
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "act", () => $72b03fdf46effee2$export$3ba232387fd5d6dd, (v) => $72b03fdf46effee2$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$3ba232387fd5d6dd;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;

var $hPtJY = parcelRequire("hPtJY");
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray, $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$noop$1() {}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop$1, $72b03fdf46effee2$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $hPtJY && "function" === typeof $hPtJY.emit) {
        $hPtJY.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $72b03fdf46effee2$var$noop() {}
$72b03fdf46effee2$export$dca3b0875bd9a954 = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$3ba232387fd5d6dd = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, void 0, void 0, null, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;

var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
var $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $dca0ddb82b882518$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$0) {
                                control = x$0;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$1) {
                            control = x$1;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return fiber = $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1), fiber;
        case 11:
            return fiber = $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1), fiber;
        case 1:
            return fiber = $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0), fiber;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$2 = parentA.child; child$2;){
                if (child$2 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$2 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$2 = child$2.sibling;
            }
            if (!didFindChild) {
                for(child$2 = parentB.child; child$2;){
                    if (child$2 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$2 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$2 = child$2.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    fiber = nextRootInstance.nodeType;
    switch(fiber){
        case 9:
        case 11:
            nextRootInstance = (nextRootInstance = nextRootInstance.documentElement) ? (nextRootInstance = nextRootInstance.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance) : 0 : 0;
            break;
        default:
            if (fiber = 8 === fiber ? nextRootInstance.parentNode : nextRootInstance, nextRootInstance = fiber.tagName, fiber = fiber.namespaceURI) fiber = $dca0ddb82b882518$var$getOwnHostContext(fiber), nextRootInstance = $dca0ddb82b882518$var$getChildHostContextProd(fiber, nextRootInstance);
            else switch(nextRootInstance){
                case "svg":
                    nextRootInstance = 1;
                    break;
                case "math":
                    nextRootInstance = 2;
                    break;
                default:
                    nextRootInstance = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, nextRootInstance);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$onCommitRoot(root) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, root, void 0, 128 === (root.current.flags & 128));
    } catch (err) {}
}
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionLane = 128, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194176;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, warmLanes = root.warmLanes;
    root = 0 !== root.finishedLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = nonIdlePendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(warmLanes))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = pendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(warmLanes))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, warmLanes = wipLanes & -wipLanes, suspendedLanes >= warmLanes || 32 === suspendedLanes && 0 !== (warmLanes & 4194176)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
            return currentTime + 250;
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextTransitionLane() {
    var lane = $dca0ddb82b882518$var$nextTransitionLane;
    $dca0ddb82b882518$var$nextTransitionLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextTransitionLane & 4194176) && ($dca0ddb82b882518$var$nextTransitionLane = 128);
    return lane;
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194218;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node) {
    var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    node._valueTracker || (node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node));
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$283;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_418 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_418) {
            var $dca0ddb82b882518$var$element$jscomp$inline_419 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_419.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_418 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_419.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$283 = $dca0ddb82b882518$var$isSupported$jscomp$inline_418;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$283 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$283 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
function $dca0ddb82b882518$var$restoreSelection(priorSelectionInformation, containerInfo) {
    var curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(containerInfo);
    containerInfo = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== containerInfo && containerInfo && containerInfo.ownerDocument && $dca0ddb82b882518$var$containsNode(containerInfo.ownerDocument.documentElement, containerInfo)) {
        if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(containerInfo)) {
            if (priorSelectionInformation = priorSelectionRange.start, curFocusedElem = priorSelectionRange.end, void 0 === curFocusedElem && (curFocusedElem = priorSelectionInformation), "selectionStart" in containerInfo) containerInfo.selectionStart = priorSelectionInformation, containerInfo.selectionEnd = Math.min(curFocusedElem, containerInfo.value.length);
            else if (curFocusedElem = (priorSelectionInformation = containerInfo.ownerDocument || document) && priorSelectionInformation.defaultView || window, curFocusedElem.getSelection) {
                curFocusedElem = curFocusedElem.getSelection();
                var length = containerInfo.textContent.length, start = Math.min(priorSelectionRange.start, length);
                priorSelectionRange = void 0 === priorSelectionRange.end ? start : Math.min(priorSelectionRange.end, length);
                !curFocusedElem.extend && start > priorSelectionRange && (length = priorSelectionRange, priorSelectionRange = start, start = length);
                length = $dca0ddb82b882518$var$getNodeForCharacterOffset(containerInfo, start);
                var endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(containerInfo, priorSelectionRange);
                length && endMarker && (1 !== curFocusedElem.rangeCount || curFocusedElem.anchorNode !== length.node || curFocusedElem.anchorOffset !== length.offset || curFocusedElem.focusNode !== endMarker.node || curFocusedElem.focusOffset !== endMarker.offset) && (priorSelectionInformation = priorSelectionInformation.createRange(), priorSelectionInformation.setStart(length.node, length.offset), curFocusedElem.removeAllRanges(), start > priorSelectionRange ? (curFocusedElem.addRange(priorSelectionInformation), curFocusedElem.extend(endMarker.node, endMarker.offset)) : (priorSelectionInformation.setEnd(endMarker.node, endMarker.offset), curFocusedElem.addRange(priorSelectionInformation)));
            }
        }
        priorSelectionInformation = [];
        for(curFocusedElem = containerInfo; curFocusedElem = curFocusedElem.parentNode;)1 === curFocusedElem.nodeType && priorSelectionInformation.push({
            element: curFocusedElem,
            left: curFocusedElem.scrollLeft,
            top: curFocusedElem.scrollTop
        });
        "function" === typeof containerInfo.focus && containerInfo.focus();
        for(containerInfo = 0; containerInfo < priorSelectionInformation.length; containerInfo++)curFocusedElem = priorSelectionInformation[containerInfo], curFocusedElem.element.scrollLeft = curFocusedElem.left, curFocusedElem.element.scrollTop = curFocusedElem.top;
    }
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll scrollEnd toggle touchMove waiting wheel".split(" ");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    isHidden && null !== update && 3 === sourceFiber.tag && (parent = sourceFiber.stateNode, isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), parent = parent.hiddenUpdates, sourceFiber = parent[isHidden], null === sourceFiber ? parent[isHidden] = [
        update
    ] : sourceFiber.push(update), update.lane = lane | 536870912);
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {}, $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $dca0ddb82b882518$var$track(instance);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children), $dca0ddb82b882518$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 3:
        case 27:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        case 5:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var shouldClear = !1, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== fiber.tag && 27 !== fiber.tag) {
        if (JSCompiler_temp = 5 === fiber.tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && (shouldClear = !0);
    shouldClear && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === fiber.tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(shouldClear = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === shouldClear) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        shouldClear--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || shouldClear++;
                }
                fiber = fiber.nextSibling;
            }
            $dca0ddb82b882518$var$nextHydratableInstance = null;
        }
    } else $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$noop$3() {}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$3, $dca0ddb82b882518$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            if (thenableState === $dca0ddb82b882518$var$SuspenseException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$3, $dca0ddb82b882518$var$noop$3);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    thenableState = thenable.reason;
                    if (thenableState === $dca0ddb82b882518$var$SuspenseException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
                    throw thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 33554434, lastPlacedIndex) : newIndex;
        newFiber.flags |= 33554434;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 33554434);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = fiber);
        }
    } else $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || "$!" === state.data)) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber$1.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber$1.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber$1.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber$1.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber$1.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber$1.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
var $dca0ddb82b882518$var$createFunctionComponentUpdateQueue;
$dca0ddb82b882518$var$createFunctionComponentUpdateQueue = function() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
};
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber$1;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber$1.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber$1.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber$1.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$54 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber$1.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber$1.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$54 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber$1, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushEffect(9, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 60) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber$1.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber$1.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$60) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$60);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber$1;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    currentStateHook = "object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then ? $dca0ddb82b882518$var$useThenable(currentStateHook) : currentStateHook;
    var actionQueueHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), actionQueue = actionQueueHook.queue, dispatch = actionQueue.dispatch;
    action !== actionQueueHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber$1.flags |= 2048, $dca0ddb82b882518$var$pushEffect(9, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), {
        destroy: void 0
    }, null));
    return [
        currentStateHook,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushEffect(tag, create, inst, deps) {
    tag = {
        tag: tag,
        create: create,
        inst: inst,
        deps: deps,
        next: null
    };
    create = $dca0ddb82b882518$var$currentlyRenderingFiber$1.updateQueue;
    null === create && (create = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber$1.updateQueue = create);
    inst = create.lastEffect;
    null === inst ? create.lastEffect = tag.next = tag : (deps = inst.next, inst.next = tag, tag.next = deps, create.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber$1.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushEffect(1 | hookFlags, create, {
        destroy: void 0
    }, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushEffect(hookFlags, create, inst, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber$1.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushEffect(1 | hookFlags, create, inst, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber$1.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber$1.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop$2() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop$2 : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$63 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$63 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$63, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$63, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber$1 || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber$1;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194176)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError
};
$dca0ddb82b882518$var$ContextOnlyDispatcher.useCacheRefresh = $dca0ddb82b882518$var$throwInvalidHookError;
$dca0ddb82b882518$var$ContextOnlyDispatcher.useMemoCache = $dca0ddb82b882518$var$throwInvalidHookError;
$dca0ddb82b882518$var$ContextOnlyDispatcher.useHostTransitionStatus = $dca0ddb82b882518$var$throwInvalidHookError;
$dca0ddb82b882518$var$ContextOnlyDispatcher.useFormState = $dca0ddb82b882518$var$throwInvalidHookError;
$dca0ddb82b882518$var$ContextOnlyDispatcher.useActionState = $dca0ddb82b882518$var$throwInvalidHookError;
$dca0ddb82b882518$var$ContextOnlyDispatcher.useOptimistic = $dca0ddb82b882518$var$throwInvalidHookError;
var $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber$1, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 60) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushEffect(9, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = ":" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += ":";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = ":" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + ":";
        return hook.memoizedState = identifierPrefix;
    },
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1);
    }
};
$dca0ddb82b882518$var$HooksDispatcherOnMount.useMemoCache = $dca0ddb82b882518$var$useMemoCache;
$dca0ddb82b882518$var$HooksDispatcherOnMount.useHostTransitionStatus = $dca0ddb82b882518$var$useHostTransitionStatus;
$dca0ddb82b882518$var$HooksDispatcherOnMount.useFormState = $dca0ddb82b882518$var$mountActionState;
$dca0ddb82b882518$var$HooksDispatcherOnMount.useActionState = $dca0ddb82b882518$var$mountActionState;
$dca0ddb82b882518$var$HooksDispatcherOnMount.useOptimistic = function(passthrough) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    hook.memoizedState = hook.baseState = passthrough;
    var queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
    };
    hook.queue = queue;
    hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, !0, queue);
    queue.dispatch = hook;
    return [
        passthrough,
        hook
    ];
};
var $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId
};
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useCacheRefresh = $dca0ddb82b882518$var$updateRefresh;
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useMemoCache = $dca0ddb82b882518$var$useMemoCache;
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useHostTransitionStatus = $dca0ddb82b882518$var$useHostTransitionStatus;
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useFormState = $dca0ddb82b882518$var$updateActionState;
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useActionState = $dca0ddb82b882518$var$updateActionState;
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useOptimistic = function(passthrough, reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
};
var $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId
};
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useCacheRefresh = $dca0ddb82b882518$var$updateRefresh;
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useMemoCache = $dca0ddb82b882518$var$useMemoCache;
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useHostTransitionStatus = $dca0ddb82b882518$var$useHostTransitionStatus;
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useFormState = $dca0ddb82b882518$var$rerenderActionState;
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useActionState = $dca0ddb82b882518$var$rerenderActionState;
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useOptimistic = function(passthrough, reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    hook.baseState = passthrough;
    return [
        passthrough,
        hook.queue.dispatch
    ];
};
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    isMounted: function(component) {
        return (component = component._reactInternals) ? $dca0ddb82b882518$var$getNearestMountedFiber(component) === component : !1;
    },
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$67 in Component)void 0 === newProps[propName$67] && (newProps[propName$67] = Component[propName$67]);
    }
    return newProps;
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $hPtJY && "function" === typeof $hPtJY.emit) {
        $hPtJY.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$68) {
        setTimeout(function() {
            throw e$68;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$69) {
        setTimeout(function() {
            throw e$69;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, nextIsDetached = 0 !== (workInProgress.stateNode._pendingVisibility & 2), prevState = null !== current ? current.memoizedState : null;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    if ("hidden" === nextProps.mode || nextIsDetached) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(nextIsDetached = 0; null !== nextChildren;)nextIsDetached = nextIsDetached | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = nextIsDetached & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 2097664);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 2097664;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($dca0ddb82b882518$var$isHydrating) {
                var nextInstance = $dca0ddb82b882518$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                            id: $dca0ddb82b882518$var$treeContextId,
                            overflow: $dca0ddb82b882518$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912
                    }, JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return "$!" === nextInstance.data ? workInProgress.lanes = 16 : workInProgress.lanes = 536870912, null;
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, nextProps;
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), "$!" === nextInstance.data) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp) {
                nextProps = renderLanes & -renderLanes;
                if (0 !== (nextProps & 42)) nextProps = 1;
                else switch(nextProps){
                    case 2:
                        nextProps = 1;
                        break;
                    case 8:
                        nextProps = 4;
                        break;
                    case 32:
                        nextProps = 16;
                        break;
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                        nextProps = 64;
                        break;
                    case 268435456:
                        nextProps = 134217728;
                        break;
                    default:
                        nextProps = 0;
                }
                nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps;
                if (0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            }
            "$?" === nextInstance.data || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 128, workInProgress.child = current.child, workInProgress = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, current), nextInstance._reactRetry = workInProgress, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextInstance.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && ($dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId, $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow, $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider, $dca0ddb82b882518$var$treeContextId = current.id, $dca0ddb82b882518$var$treeContextOverflow = current.overflow, $dca0ddb82b882518$var$treeContextProvider = workInProgress), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 31457280, null !== digest ? showFallback = $dca0ddb82b882518$var$createWorkInProgress(digest, showFallback) : (showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $dca0ddb82b882518$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, nextProps;
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    return $dca0ddb82b882518$var$createFiberFromOffscreen(offscreenProps, mode, 0, null);
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $dca0ddb82b882518$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $dca0ddb82b882518$var$shouldConstruct(lazyComponent) ? (current = $dca0ddb82b882518$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $dca0ddb82b882518$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                var nextProps = workInProgress.pendingProps;
                init = workInProgress.memoizedState;
                lazyComponent = init.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                nextProps = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, nextProps);
                nextProps !== init.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                nextProps = nextState.element;
                if (init.isDehydrated) {
                    if (init = {
                        element: nextProps,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = init, workInProgress.memoizedState = init, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else if (nextProps !== lazyComponent) {
                        lazyComponent = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError(lazyComponent);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else for($dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(workInProgress.stateNode.containerInfo.firstChild), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !0, renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextProps, renderLanes), workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (nextProps === lazyComponent) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, lazyComponent[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(lazyComponent, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (lazyComponent = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(lazyComponent.firstChild)), lazyComponent = workInProgress.pendingProps.children, null !== current || $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes) : workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (init = lazyComponent = $dca0ddb82b882518$var$nextHydratableInstance) lazyComponent = $dca0ddb82b882518$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(lazyComponent.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            nextProps = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = nextProps.children;
            $dca0ddb82b882518$var$shouldSetTextContent(init, nextProps) ? lazyComponent = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = init);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), init = $dca0ddb82b882518$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), lazyComponent = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? (init = $dca0ddb82b882518$var$peekCacheFromPool(), null === init && (init = $dca0ddb82b882518$var$workInProgressRoot, nextProps = $dca0ddb82b882518$var$createCache(), init.pooledCache = nextProps, nextProps.refCount++, null !== nextProps && (init.pooledCacheLanes |= renderLanes), init = nextProps), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, nextProps = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, lazyComponent)) : (lazyComponent = nextProps.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194176))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0;
                        try {
                            destroy();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            var instance = current.stateNode;
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = instance;
                    break;
                default:
                    instanceToUse = instance;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$112) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$112);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 27 !== fiber.tag && 18 !== fiber.tag;){
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? 8 === parent.nodeType ? parent.parentNode.insertBefore(node, before) : parent.insertBefore(node, before) : (8 === parent.nodeType ? (before = parent.parentNode, before.insertBefore(node, parent)) : (before = parent, before.appendChild(node)), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null, $dca0ddb82b882518$var$shouldFireAfterActiveInstanceBlur = !1;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
    resolvedPrevProps = $dca0ddb82b882518$var$shouldFireAfterActiveInstanceBlur;
    $dca0ddb82b882518$var$shouldFireAfterActiveInstanceBlur = !1;
    return resolvedPrevProps;
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$111) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$111);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (flags = finishedWork.updateQueue, null !== flags)) {
                finishedRoot = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        finishedRoot = finishedWork.child.stateNode;
                        break;
                    case 1:
                        finishedRoot = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(flags, finishedRoot);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 26:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 22:
            prevProps = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!prevProps) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                var prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            flags & 512 && ("manual" === finishedWork.memoizedProps.mode ? $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return) : $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber = deletedFiber.stateNode;
            for(nearestMountedAncestor = deletedFiber.attributes; nearestMountedAncestor.length;)deletedFiber.removeAttributeNode(nearestMountedAncestor[0]);
            $dca0ddb82b882518$var$detachDeletedInstance(deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParent;
            var prevHostParentIsContainer$119 = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParentIsContainer;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer$119;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    finishedRoot = $dca0ddb82b882518$var$hostParent, prevHostParent = deletedFiber.stateNode, 8 === finishedRoot.nodeType ? finishedRoot.parentNode.removeChild(prevHostParent) : finishedRoot.removeChild(prevHostParent);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (nearestMountedAncestor = $dca0ddb82b882518$var$hostParent, deletedFiber = deletedFiber.stateNode, 8 === nearestMountedAncestor.nodeType ? $dca0ddb82b882518$var$clearSuspenseBoundary(nearestMountedAncestor.parentNode, deletedFiber) : 1 === nearestMountedAncestor.nodeType && $dca0ddb82b882518$var$clearSuspenseBoundary(nearestMountedAncestor, deletedFiber), $dca0ddb82b882518$var$retryIfBlockedOn(nearestMountedAncestor)) : $dca0ddb82b882518$var$clearSuspenseBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            if (flags & 4 && null === finishedWork.alternate) {
                hoistableRoot = finishedWork.stateNode;
                currentResource = finishedWork.memoizedProps;
                try {
                    for(var node = hoistableRoot.firstChild; node;){
                        var nextNode = node.nextSibling, nodeName = node.nodeName;
                        node[$dca0ddb82b882518$var$internalHoistableMarker] || "HEAD" === nodeName || "BODY" === nodeName || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node.rel.toLowerCase() || hoistableRoot.removeChild(node);
                        node = nextNode;
                    }
                    for(var type = finishedWork.type, attributes = hoistableRoot.attributes; attributes.length;)hoistableRoot.removeAttributeNode(attributes[0]);
                    $dca0ddb82b882518$var$setInitialProperties(hoistableRoot, type, currentResource);
                    hoistableRoot[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                    hoistableRoot[$dca0ddb82b882518$var$internalPropsKey] = currentResource;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            node = null !== finishedWork.memoizedState;
            nextNode = null !== current && null !== current.memoizedState;
            nodeName = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            type = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = nodeName || node;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = type || nextNode;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = type;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = nodeName;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            root = finishedWork.stateNode;
            root._current = finishedWork;
            root._visibility &= -3;
            root._visibility |= root._pendingVisibility & 2;
            if (flags & 8192 && (root._visibility = node ? root._visibility & -2 : root._visibility | 1, node && (root = $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden, null === current || nextNode || root || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), null === finishedWork.memoizedProps || "manual" !== finishedWork.memoizedProps.mode)) a: for(current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag || 27 === root.tag) {
                    if (null === current) {
                        nextNode = current = root;
                        try {
                            if (hoistableRoot = nextNode.stateNode, node) currentResource = hoistableRoot.style, "function" === typeof currentResource.setProperty ? currentResource.setProperty("display", "none", "important") : currentResource.display = "none";
                            else {
                                maybeNodes = nextNode.stateNode;
                                i = nextNode.memoizedProps.style;
                                var display = void 0 !== i && null !== i && i.hasOwnProperty("display") ? i.display : null;
                                maybeNodes.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        nextNode = root;
                        try {
                            nextNode.stateNode.nodeValue = node ? "" : nextNode.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            if (27 !== finishedWork.tag) {
                a: {
                    for(var parent = finishedWork.return; null !== parent;){
                        if ($dca0ddb82b882518$var$isHostParent(parent)) {
                            var JSCompiler_inline_result = parent;
                            break a;
                        }
                        parent = parent.return;
                    }
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
                }
                switch(JSCompiler_inline_result.tag){
                    case 27:
                        var parent$jscomp$0 = JSCompiler_inline_result.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                        $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0);
                        break;
                    case 5:
                        var parent$113 = JSCompiler_inline_result.stateNode;
                        JSCompiler_inline_result.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$113, ""), JSCompiler_inline_result.flags &= -33);
                        var before$114 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                        $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$114, parent$113);
                        break;
                    case 3:
                    case 4:
                        var parent$115 = JSCompiler_inline_result.stateNode.containerInfo, before$116 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                        $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$116, parent$115);
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
                }
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 26:
            case 27:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 26:
            case 27:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 4 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 4 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 4, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 4 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 4, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource($dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 4 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -5, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 4 && (i._visibility &= -5, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 31457280;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 31457282;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_OFFSCREEN_TYPE:
            return $dca0ddb82b882518$var$createFiberFromOffscreen(pendingProps, mode, lanes, key);
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_PROVIDER_TYPE:
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromOffscreen(pendingProps, mode, lanes, key) {
    pendingProps = $dca0ddb82b882518$var$createFiberImplClass(22, pendingProps, key, mode);
    pendingProps.elementType = $dca0ddb82b882518$var$REACT_OFFSCREEN_TYPE;
    pendingProps.lanes = lanes;
    var primaryChildInstance = {
        _visibility: 1,
        _pendingVisibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null,
        _current: null,
        detach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(456));
            if (0 === (primaryChildInstance._pendingVisibility & 2)) {
                var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility |= 2, $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        },
        attach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(456));
            if (0 !== (primaryChildInstance._pendingVisibility & 2)) {
                var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility &= -3, $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        }
    };
    pendingProps.stateNode = primaryChildInstance;
    return pendingProps;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        resource = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194176) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null !== $dca0ddb82b882518$var$shellBoundary : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || resource !== $dca0ddb82b882518$var$shellBoundary)) throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$131 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$131 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$131 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$131.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags & 31457280, subtreeFlags |= child$132.flags & 31457280, child$132.return = completedWork, child$132 = child$132.sibling;
    else for(child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags, subtreeFlags |= child$132.flags, child$132.return = completedWork, child$132 = child$132.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, null !== $dca0ddb82b882518$var$hydrationErrors && ($dca0ddb82b882518$var$queueRecoverableErrors($dca0ddb82b882518$var$hydrationErrors), $dca0ddb82b882518$var$hydrationErrors = null));
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== renderLanes ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script></script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else null !== $dca0ddb82b882518$var$hydrationErrors && ($dca0ddb82b882518$var$queueRecoverableErrors($dca0ddb82b882518$var$hydrationErrors), $dca0ddb82b882518$var$hydrationErrors = null), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$144 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$144 = newProps.memoizedState.cachePool.pool);
                cache$144 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$144 = type.rendering;
            if (null === cache$144) {
                if (newProps) $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$144 = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== cache$144) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1);
                            current = cache$144.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(cache$144), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$144.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - type.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$144.sibling = workInProgress.child, workInProgress.child = cache$144) : (current = type.last, null !== current ? current.sibling = cache$144 : workInProgress.child = cache$144, type.last = cache$144);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $dca0ddb82b882518$var$now(), workInProgress.sibling = null, current = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$rootDoesHavePassiveEffects = !1, $dca0ddb82b882518$var$rootWithPendingPassiveEffects = null, $dca0ddb82b882518$var$pendingPassiveEffectsLanes = 0, $dca0ddb82b882518$var$pendingPassiveEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes) return $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes;
    if (null !== $dca0ddb82b882518$var$ReactSharedInternals.T) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $dca0ddb82b882518$var$requestTransitionLane();
    }
    return $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    0 === $dca0ddb82b882518$var$workInProgressDeferredLane && ($dca0ddb82b882518$var$workInProgressDeferredLane = 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && 2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 60) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else if (6 === exitStatus) $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
        else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && $dca0ddb82b882518$var$queueRecoverableErrors(renderWasConcurrent);
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                switch(exitStatus){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194176) === lanes) {
                            $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                            break a;
                        }
                        break;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                shouldTimeSlice.finishedWork = forceSync;
                shouldTimeSlice.finishedLanes = lanes;
                if ((lanes & 62914560) === lanes && (renderWasConcurrent = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < renderWasConcurrent)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0)) break a;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, 2, -0, 0), renderWasConcurrent);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$queueRecoverableErrors(errors) {
    null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = errors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, errors);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var subtreeFlags = finishedWork.subtreeFlags;
    if (subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if ($dca0ddb82b882518$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $dca0ddb82b882518$var$noop
        }, $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork), finishedWork = $dca0ddb82b882518$var$waitForCommitToBeReady(), null !== finishedWork) {
            root.cancelPendingCommit = finishedWork($dca0ddb82b882518$var$commitRoot.bind(null, root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, 1, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    root.finishedWork = null;
    root.finishedLanes = 0;
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194176) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$164) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$164);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 === $dca0ddb82b882518$var$workInProgressSuspendedReason && $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : 1) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrent();
        break;
    } catch (thrownValue$166) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$166);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrent() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousUpdateLanePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$ReactSharedInternals.T = null, $dca0ddb82b882518$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, previousUpdateLanePriority, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
    } finally{
        $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousUpdateLanePriority;
    }
}
function $dca0ddb82b882518$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, renderPriorityLevel, spawnedLane, updatedLanes, suspendedRetryLanes) {
    do $dca0ddb82b882518$var$flushPassiveEffects();
    while (null !== $dca0ddb82b882518$var$rootWithPendingPassiveEffects);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var finishedWork = root.finishedWork;
    didIncludeRenderPhaseUpdate = root.finishedLanes;
    if (null === finishedWork) return null;
    root.finishedWork = null;
    root.finishedLanes = 0;
    if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
    root.callbackNode = null;
    root.callbackPriority = 0;
    root.cancelPendingCommit = null;
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    remainingLanes |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
    $dca0ddb82b882518$var$markRootFinished(root, didIncludeRenderPhaseUpdate, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
    0 === (finishedWork.subtreeFlags & 10256) && 0 === (finishedWork.flags & 10256) || $dca0ddb82b882518$var$rootDoesHavePassiveEffects || ($dca0ddb82b882518$var$rootDoesHavePassiveEffects = !0, $dca0ddb82b882518$var$pendingPassiveEffectsRemainingLanes = remainingLanes, $dca0ddb82b882518$var$pendingPassiveTransitions = transitions, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
        $dca0ddb82b882518$var$flushPassiveEffects(!0);
        return null;
    }));
    transitions = 0 !== (finishedWork.flags & 15990);
    0 !== (finishedWork.subtreeFlags & 15990) || transitions ? (transitions = $dca0ddb82b882518$var$ReactSharedInternals.T, $dca0ddb82b882518$var$ReactSharedInternals.T = null, spawnedLane = $dca0ddb82b882518$var$ReactDOMSharedInternals.p, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, updatedLanes = $dca0ddb82b882518$var$executionContext, $dca0ddb82b882518$var$executionContext |= 4, $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root), $dca0ddb82b882518$var$restoreSelection($dca0ddb82b882518$var$selectionInformation, root.containerInfo), $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled, $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null, root.current = finishedWork, $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork), $dca0ddb82b882518$var$requestPaint(), $dca0ddb82b882518$var$executionContext = updatedLanes, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = spawnedLane, $dca0ddb82b882518$var$ReactSharedInternals.T = transitions) : root.current = finishedWork;
    $dca0ddb82b882518$var$rootDoesHavePassiveEffects ? ($dca0ddb82b882518$var$rootDoesHavePassiveEffects = !1, $dca0ddb82b882518$var$rootWithPendingPassiveEffects = root, $dca0ddb82b882518$var$pendingPassiveEffectsLanes = didIncludeRenderPhaseUpdate) : $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    remainingLanes = root.pendingLanes;
    0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
    $dca0ddb82b882518$var$onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
    if (null !== recoverableErrors) for(renderPriorityLevel = root.onRecoverableError, finishedWork = 0; finishedWork < recoverableErrors.length; finishedWork++)remainingLanes = recoverableErrors[finishedWork], renderPriorityLevel(remainingLanes.value, {
        componentStack: remainingLanes.stack
    });
    0 !== ($dca0ddb82b882518$var$pendingPassiveEffectsLanes & 3) && $dca0ddb82b882518$var$flushPassiveEffects();
    remainingLanes = root.pendingLanes;
    0 !== (didIncludeRenderPhaseUpdate & 4194218) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
    $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    return null;
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (null !== $dca0ddb82b882518$var$rootWithPendingPassiveEffects) {
        var root$170 = $dca0ddb82b882518$var$rootWithPendingPassiveEffects, remainingLanes = $dca0ddb82b882518$var$pendingPassiveEffectsRemainingLanes;
        $dca0ddb82b882518$var$pendingPassiveEffectsRemainingLanes = 0;
        var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingPassiveEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
        try {
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            if (null === $dca0ddb82b882518$var$rootWithPendingPassiveEffects) var JSCompiler_inline_result = !1;
            else {
                renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
                $dca0ddb82b882518$var$pendingPassiveTransitions = null;
                var root = $dca0ddb82b882518$var$rootWithPendingPassiveEffects, lanes = $dca0ddb82b882518$var$pendingPassiveEffectsLanes;
                $dca0ddb82b882518$var$rootWithPendingPassiveEffects = null;
                $dca0ddb82b882518$var$pendingPassiveEffectsLanes = 0;
                if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
                var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
                $dca0ddb82b882518$var$executionContext |= 4;
                $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root.current);
                $dca0ddb82b882518$var$commitPassiveMountOnFiber(root, root.current, lanes, renderPriority);
                $dca0ddb82b882518$var$executionContext = prevExecutionContext;
                $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
                if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
                    $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root);
                } catch (err) {}
                JSCompiler_inline_result = !0;
            }
            return JSCompiler_inline_result;
        } finally{
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root$170, remainingLanes);
        }
    }
    return !1;
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateTask($dca0ddb82b882518$var$processRootScheduleInMicrotask));
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$172 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$172;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$172.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$172.suspendedLanes, pingedLanes = root$172.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326677 ? JSCompiler_inline_result & 201326677 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$172, root$172 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$172, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                }
                root$172 = root$172.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane), $dca0ddb82b882518$var$currentEventTransitionLane = 0);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && 2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPassiveEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPassiveEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateTask(cb) {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, cb) : cb();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    0 === $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = $dca0ddb82b882518$var$claimNextTransitionLane());
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1439 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1439 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1439++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1440 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1439], $dca0ddb82b882518$var$domEventName$jscomp$inline_1441 = $dca0ddb82b882518$var$eventName$jscomp$inline_1440.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1442 = $dca0ddb82b882518$var$eventName$jscomp$inline_1440[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1440.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1441, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1442);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer || 8 === container.nodeType && container.parentNode === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if (3 === grandTag || 4 === grandTag) {
                    if (grandTag = nodeTag.stateNode.containerInfo, grandTag === targetContainer || 8 === grandTag.nodeType && grandTag.parentNode === targetContainer) return;
                }
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $dca0ddb82b882518$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $dca0ddb82b882518$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $dca0ddb82b882518$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $dca0ddb82b882518$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $dca0ddb82b882518$var$getParent(inCapturePhase);
                                reactEventName = $dca0ddb82b882518$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        targetFiber = targetFiber.return;
    }
    return listeners;
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$noop$1() {}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$186 = props[hasSrc];
                if (null != propValue$186) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$186;
                        break;
                    case "type":
                        propValue = propValue$186;
                        break;
                    case "checked":
                        checked = propValue$186;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$186;
                        break;
                    case "value":
                        propKey = propValue$186;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$186;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$186) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$186, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $dca0ddb82b882518$var$track(domElement);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $dca0ddb82b882518$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$186 in props)props.hasOwnProperty(propValue$186) && (hasSrc = props[propValue$186], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$186, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$203 in nextProps){
                var propKey = nextProps[propKey$203];
                lastProp = lastProps[propKey$203];
                if (nextProps.hasOwnProperty(propKey$203) && (null != propKey || null != lastProp)) switch(propKey$203){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$203, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$203 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$203 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$203 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$203, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$203 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$203 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$203, propKey);
            return;
        case "option":
            for(var propKey$219 in lastProps)if (propKey$203 = lastProps[propKey$219], lastProps.hasOwnProperty(propKey$219) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$219)) switch(propKey$219){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$219, null, nextProps, propKey$203);
            }
            for(lastDefaultValue in nextProps)if (propKey$203 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$203 && "function" !== typeof propKey$203 && "symbol" !== typeof propKey$203;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$203, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$224 in lastProps)propKey$203 = lastProps[propKey$224], lastProps.hasOwnProperty(propKey$224) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$224) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$224, null, nextProps, propKey$203);
            for(checked in nextProps)if (propKey$203 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$203) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$203, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$229 in lastProps)propKey$203 = lastProps[propKey$229], lastProps.hasOwnProperty(propKey$229) && void 0 !== propKey$203 && !nextProps.hasOwnProperty(propKey$229) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$229, void 0, nextProps, propKey$203);
                for(defaultChecked in nextProps)propKey$203 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$203 === propKey || void 0 === propKey$203 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$203, nextProps, propKey);
                return;
            }
    }
    for(var propKey$234 in lastProps)propKey$203 = lastProps[propKey$234], lastProps.hasOwnProperty(propKey$234) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$234) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$234, null, nextProps, propKey$203);
    for(lastProp in nextProps)propKey$203 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$203 === propKey || null == propKey$203 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$203, nextProps, propKey);
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" !== node && "$?" !== node && "$!" !== node || depth++;
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(suspenseInstance);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
function $dca0ddb82b882518$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$242 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$243 = styles$242.get(type);
                resource$243 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$243 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$242.set(type, resource$243), (styles$242 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$242._p && (resource$243.instance = styles$242, resource$243.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$242 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$243.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$243;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$248 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$248) return resource.state.loading |= 4, resource.instance = instance$248, $dca0ddb82b882518$var$markNodeAsHoistable(instance$248), instance$248;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$248 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$248);
            var linkInstance = instance$248;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$248, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$248, props.precedence, hoistableRoot);
            return resource.instance = instance$248;
        case "script":
            instance$248 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$248))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$248)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $dca0ddb82b882518$var$suspendedState = null;
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $dca0ddb82b882518$var$suspendedState) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(475));
    var state = $dca0ddb82b882518$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $dca0ddb82b882518$var$waitForCommitToBeReady() {
    if (null === $dca0ddb82b882518$var$suspendedState) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(475));
    var state = $dca0ddb82b882518$var$suspendedState;
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.finishedLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $dca0ddb82b882518$var$requestUpdateLane(), root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        0 === root.tag && $dca0ddb82b882518$var$flushPassiveEffects();
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1686 = $acw62.version;
if ("19.0.0" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1686) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1686, "19.0.0"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2165 = {
    bundleType: 0,
    version: "19.0.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    findFiberByHostInstance: $dca0ddb82b882518$var$getClosestInstanceFromNode,
    reconcilerVersion: "19.0.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2166 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2166.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2166.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2166.inject($dca0ddb82b882518$var$internals$jscomp$inline_2165), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2166;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(8 === container.nodeType ? container.parentNode : container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    initialChildren.current.lanes = isStrictMode;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, isStrictMode);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $11c56e2ffb2d6006$export$8352ce38b91d0c62, (v) => $11c56e2ffb2d6006$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $11c56e2ffb2d6006$export$839f9183b0465a69, (v) => $11c56e2ffb2d6006$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $11c56e2ffb2d6006$export$4b844e58a3e414b4, (v) => $11c56e2ffb2d6006$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$8352ce38b91d0c62;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$839f9183b0465a69;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$4b844e58a3e414b4;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$requestHostCallback();
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostCallback() {
    $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
}
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$8352ce38b91d0c62 = function() {
    $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$requestHostCallback());
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$839f9183b0465a69 = function() {
    return $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$4b844e58a3e414b4 = function() {};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$requestHostCallback()));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("9Qu0I"));

});

parcelRegister("1u0KT", function(module, exports) {
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.0.0";

});



parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $6b3372b60d35b33f$export$2b8d127b894957b9, (v) => $6b3372b60d35b33f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $6b3372b60d35b33f$export$cea3a54a6425200c, (v) => $6b3372b60d35b33f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$2b8d127b894957b9;
var $6b3372b60d35b33f$export$cea3a54a6425200c;
var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
"use strict";
var $6b3372b60d35b33f$var$b = "function" === typeof Symbol && Symbol.for, $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$b ? Symbol.for("react.element") : 60103, $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$b ? Symbol.for("react.portal") : 60106, $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$b ? Symbol.for("react.fragment") : 60107, $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$b ? Symbol.for("react.strict_mode") : 60108, $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$b ? Symbol.for("react.profiler") : 60114, $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$b ? Symbol.for("react.provider") : 60109, $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$b ? Symbol.for("react.context") : 60110, $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$b ? Symbol.for("react.async_mode") : 60111, $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$b ? Symbol.for("react.forward_ref") : 60112, $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense") : 60113, $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense_list") : 60120, $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$b ? Symbol.for("react.memo") : 60115, $6b3372b60d35b33f$var$t = $6b3372b60d35b33f$var$b ? Symbol.for("react.lazy") : 60116, $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$b ? Symbol.for("react.block") : 60121, $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$b ? Symbol.for("react.fundamental") : 60117, $6b3372b60d35b33f$var$x = $6b3372b60d35b33f$var$b ? Symbol.for("react.responder") : 60118, $6b3372b60d35b33f$var$y = $6b3372b60d35b33f$var$b ? Symbol.for("react.scope") : 60119;
function $6b3372b60d35b33f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6b3372b60d35b33f$var$c:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$g:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$t:
                            case $6b3372b60d35b33f$var$r:
                            case $6b3372b60d35b33f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6b3372b60d35b33f$var$d:
                return u;
        }
    }
}
function $6b3372b60d35b33f$var$A(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$m;
}
$6b3372b60d35b33f$export$2b8d127b894957b9 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$cea3a54a6425200c = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$k;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$t;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$r;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$92387174baf9b227 = function(a) {
    return $6b3372b60d35b33f$var$A(a) || $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$t;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$r;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$g || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$p || a === $6b3372b60d35b33f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$t || a.$$typeof === $6b3372b60d35b33f$var$r || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$w || a.$$typeof === $6b3372b60d35b33f$var$x || a.$$typeof === $6b3372b60d35b33f$var$y || a.$$typeof === $6b3372b60d35b33f$var$v);
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$z;

});


var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};
"use strict";
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));


var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));



var $acw62 = parcelRequire("acw62");
var $e19976245606d3d7$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e19976245606d3d7$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e19976245606d3d7$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $e19976245606d3d7$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e19976245606d3d7$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e19976245606d3d7$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e19976245606d3d7$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


/**
 * @param {number}
 * @return {number}
 */ var $5e4f012072913cb4$export$2335f513bbd82c6d = Math.abs;
var $5e4f012072913cb4$export$6788812c4e6611e6 = String.fromCharCode;
var $5e4f012072913cb4$export$e6e34fd1f2686227 = Object.assign;
function $5e4f012072913cb4$export$d6af199866bfb566(value, length) {
    return $5e4f012072913cb4$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 0)) << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 1)) << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 2)) << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 3) : 0;
}
function $5e4f012072913cb4$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $5e4f012072913cb4$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $5e4f012072913cb4$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $5e4f012072913cb4$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $5e4f012072913cb4$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $5e4f012072913cb4$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $5e4f012072913cb4$export$36776f635604f274(value) {
    return value.length;
}
function $5e4f012072913cb4$export$f9084667e487ed46(value) {
    return value.length;
}
function $5e4f012072913cb4$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $5e4f012072913cb4$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join("");
}


var $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c = 1;
var $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1;
var $f4f4fca9115ed8bd$export$f24224f1c91d8156 = 0;
var $f4f4fca9115ed8bd$export$5880b8b5730aff45 = 0;
var $f4f4fca9115ed8bd$export$c0306caf338ac095 = 0;
var $f4f4fca9115ed8bd$export$30a86d91af8ff6e6 = "";
function $f4f4fca9115ed8bd$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c,
        column: $f4f4fca9115ed8bd$export$4e0c71f277ca26b3,
        length: length,
        return: ""
    };
}
function $f4f4fca9115ed8bd$export$784d13d8ee351f07(root, props) {
    return (0, $5e4f012072913cb4$export$e6e34fd1f2686227)($f4f4fca9115ed8bd$export$35059013cd4a06db("", null, null, "", null, null, 0), root, {
        length: -root.length
    }, props);
}
function $f4f4fca9115ed8bd$export$eba6f6f03b0a92e7() {
    return $f4f4fca9115ed8bd$export$c0306caf338ac095;
}
function $f4f4fca9115ed8bd$export$232faf9add678146() {
    $f4f4fca9115ed8bd$export$c0306caf338ac095 = $f4f4fca9115ed8bd$export$5880b8b5730aff45 > 0 ? (0, $5e4f012072913cb4$export$a9db5e087081082d)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, --$f4f4fca9115ed8bd$export$5880b8b5730aff45) : 0;
    if ($f4f4fca9115ed8bd$export$4e0c71f277ca26b3--, $f4f4fca9115ed8bd$export$c0306caf338ac095 === 10) $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1, $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c--;
    return $f4f4fca9115ed8bd$export$c0306caf338ac095;
}
function $f4f4fca9115ed8bd$export$48cfd1e771a65c4f() {
    $f4f4fca9115ed8bd$export$c0306caf338ac095 = $f4f4fca9115ed8bd$export$5880b8b5730aff45 < $f4f4fca9115ed8bd$export$f24224f1c91d8156 ? (0, $5e4f012072913cb4$export$a9db5e087081082d)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, $f4f4fca9115ed8bd$export$5880b8b5730aff45++) : 0;
    if ($f4f4fca9115ed8bd$export$4e0c71f277ca26b3++, $f4f4fca9115ed8bd$export$c0306caf338ac095 === 10) $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1, $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c++;
    return $f4f4fca9115ed8bd$export$c0306caf338ac095;
}
function $f4f4fca9115ed8bd$export$4d3fb11e950abb9e() {
    return (0, $5e4f012072913cb4$export$a9db5e087081082d)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, $f4f4fca9115ed8bd$export$5880b8b5730aff45);
}
function $f4f4fca9115ed8bd$export$e88cb2efb12ae807() {
    return $f4f4fca9115ed8bd$export$5880b8b5730aff45;
}
function $f4f4fca9115ed8bd$export$58adb3bec8346d0f(begin, end) {
    return (0, $5e4f012072913cb4$export$2f35ab04d2335697)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, begin, end);
}
function $f4f4fca9115ed8bd$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $f4f4fca9115ed8bd$export$2de70f21292aac9e(value) {
    return $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c = $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1, $f4f4fca9115ed8bd$export$f24224f1c91d8156 = (0, $5e4f012072913cb4$export$36776f635604f274)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6 = value), $f4f4fca9115ed8bd$export$5880b8b5730aff45 = 0, [];
}
function $f4f4fca9115ed8bd$export$45918ac1574455b1(value) {
    return $f4f4fca9115ed8bd$export$30a86d91af8ff6e6 = "", value;
}
function $f4f4fca9115ed8bd$export$410ac95b9ec204b8(type) {
    return (0, $5e4f012072913cb4$export$87c2784dc9fc4ab)($f4f4fca9115ed8bd$export$58adb3bec8346d0f($f4f4fca9115ed8bd$export$5880b8b5730aff45 - 1, $f4f4fca9115ed8bd$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $f4f4fca9115ed8bd$export$660b2ee2d4fb4eff(value) {
    return $f4f4fca9115ed8bd$export$45918ac1574455b1($f4f4fca9115ed8bd$export$5f8c09e3ae6f64e1($f4f4fca9115ed8bd$export$2de70f21292aac9e(value)));
}
function $f4f4fca9115ed8bd$export$7af1228ff777d175(type) {
    while($f4f4fca9115ed8bd$export$c0306caf338ac095 = $f4f4fca9115ed8bd$export$4d3fb11e950abb9e())if ($f4f4fca9115ed8bd$export$c0306caf338ac095 < 33) $f4f4fca9115ed8bd$export$48cfd1e771a65c4f();
    else break;
    return $f4f4fca9115ed8bd$export$9e1725a4cfeada27(type) > 2 || $f4f4fca9115ed8bd$export$9e1725a4cfeada27($f4f4fca9115ed8bd$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $f4f4fca9115ed8bd$export$5f8c09e3ae6f64e1(children) {
    while($f4f4fca9115ed8bd$export$48cfd1e771a65c4f())switch($f4f4fca9115ed8bd$export$9e1725a4cfeada27($f4f4fca9115ed8bd$export$c0306caf338ac095)){
        case 0:
            (0, $5e4f012072913cb4$export$10d8903dec122b9d)($f4f4fca9115ed8bd$export$c2ab62c7bf24634($f4f4fca9115ed8bd$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $5e4f012072913cb4$export$10d8903dec122b9d)($f4f4fca9115ed8bd$export$410ac95b9ec204b8($f4f4fca9115ed8bd$export$c0306caf338ac095), children);
            break;
        default:
            (0, $5e4f012072913cb4$export$10d8903dec122b9d)((0, $5e4f012072913cb4$export$6788812c4e6611e6)($f4f4fca9115ed8bd$export$c0306caf338ac095), children);
    }
    return children;
}
function $f4f4fca9115ed8bd$export$955ba06d119e085e(index, count) {
    while(--count && $f4f4fca9115ed8bd$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($f4f4fca9115ed8bd$export$c0306caf338ac095 < 48 || $f4f4fca9115ed8bd$export$c0306caf338ac095 > 102 || $f4f4fca9115ed8bd$export$c0306caf338ac095 > 57 && $f4f4fca9115ed8bd$export$c0306caf338ac095 < 65 || $f4f4fca9115ed8bd$export$c0306caf338ac095 > 70 && $f4f4fca9115ed8bd$export$c0306caf338ac095 < 97) break;
    return $f4f4fca9115ed8bd$export$58adb3bec8346d0f(index, $f4f4fca9115ed8bd$export$e88cb2efb12ae807() + (count < 6 && $f4f4fca9115ed8bd$export$4d3fb11e950abb9e() == 32 && $f4f4fca9115ed8bd$export$48cfd1e771a65c4f() == 32));
}
function $f4f4fca9115ed8bd$export$c889f2fcc19dbf12(type) {
    while($f4f4fca9115ed8bd$export$48cfd1e771a65c4f())switch($f4f4fca9115ed8bd$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $f4f4fca9115ed8bd$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $f4f4fca9115ed8bd$export$c889f2fcc19dbf12($f4f4fca9115ed8bd$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $f4f4fca9115ed8bd$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $f4f4fca9115ed8bd$export$48cfd1e771a65c4f();
            break;
    }
    return $f4f4fca9115ed8bd$export$5880b8b5730aff45;
}
function $f4f4fca9115ed8bd$export$4254d4e2b3745c4c(type, index) {
    while($f4f4fca9115ed8bd$export$48cfd1e771a65c4f())// //
    if (type + $f4f4fca9115ed8bd$export$c0306caf338ac095 === 57) break;
    else if (type + $f4f4fca9115ed8bd$export$c0306caf338ac095 === 84 && $f4f4fca9115ed8bd$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $f4f4fca9115ed8bd$export$58adb3bec8346d0f(index, $f4f4fca9115ed8bd$export$5880b8b5730aff45 - 1) + "*" + (0, $5e4f012072913cb4$export$6788812c4e6611e6)(type === 47 ? type : $f4f4fca9115ed8bd$export$48cfd1e771a65c4f());
}
function $f4f4fca9115ed8bd$export$c2ab62c7bf24634(index) {
    while(!$f4f4fca9115ed8bd$export$9e1725a4cfeada27($f4f4fca9115ed8bd$export$4d3fb11e950abb9e()))$f4f4fca9115ed8bd$export$48cfd1e771a65c4f();
    return $f4f4fca9115ed8bd$export$58adb3bec8346d0f(index, $f4f4fca9115ed8bd$export$5880b8b5730aff45);
}

var $e853ac0080e24cb4$export$71ad59f2e432cfe8 = "-ms-";
var $e853ac0080e24cb4$export$2c0f367103c8d01c = "-moz-";
var $e853ac0080e24cb4$export$39dfd62a25e0fe93 = "-webkit-";
var $e853ac0080e24cb4$export$a29989082612d0d9 = "comm";
var $e853ac0080e24cb4$export$aa3a2e812ca8570d = "rule";
var $e853ac0080e24cb4$export$527d108ccf083c2b = "decl";
var $e853ac0080e24cb4$export$d3d35020fa5b54f0 = "@page";
var $e853ac0080e24cb4$export$500415a86c544f73 = "@media";
var $e853ac0080e24cb4$export$a763edbf796b780a = "@import";
var $e853ac0080e24cb4$export$2790aeb8b4e5c826 = "@charset";
var $e853ac0080e24cb4$export$1cc683e23b84b133 = "@viewport";
var $e853ac0080e24cb4$export$9447a5efea57e862 = "@supports";
var $e853ac0080e24cb4$export$ef011b4e114b1fba = "@document";
var $e853ac0080e24cb4$export$6aad947bda0f3f46 = "@namespace";
var $e853ac0080e24cb4$export$b44a8529a35fcb60 = "@keyframes";
var $e853ac0080e24cb4$export$2c16de31893252e6 = "@font-face";
var $e853ac0080e24cb4$export$3d846dd52e150c6f = "@counter-style";
var $e853ac0080e24cb4$export$22314bfbb57653fe = "@font-feature-values";
var $e853ac0080e24cb4$export$d773506282b3cfe6 = "@layer";




function $36ea00327b41abe1$export$ef7acd7185315e22(value) {
    return (0, $f4f4fca9115ed8bd$export$45918ac1574455b1)($36ea00327b41abe1$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], value = (0, $f4f4fca9115ed8bd$export$2de70f21292aac9e)(value), 0, [
        0
    ], value));
}
function $36ea00327b41abe1$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = "";
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)()){
        // (
        case 40:
            if (previous != 108 && (0, $5e4f012072913cb4$export$a9db5e087081082d)(characters, length - 1) == 58) {
                if ((0, $5e4f012072913cb4$export$f8e21b1e77979a08)(characters += (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $f4f4fca9115ed8bd$export$410ac95b9ec204b8)(character), "&", "&\f"), "&\f") != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $f4f4fca9115ed8bd$export$410ac95b9ec204b8)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $f4f4fca9115ed8bd$export$7af1228ff777d175)(previous);
            break;
        // \
        case 92:
            characters += (0, $f4f4fca9115ed8bd$export$955ba06d119e085e)((0, $f4f4fca9115ed8bd$export$e88cb2efb12ae807)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)()){
                case 42:
                case 47:
                    (0, $5e4f012072913cb4$export$10d8903dec122b9d)($36ea00327b41abe1$export$4a34f930e789283c((0, $f4f4fca9115ed8bd$export$4254d4e2b3745c4c)((0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)(), (0, $f4f4fca9115ed8bd$export$e88cb2efb12ae807)()), root, parent), declarations);
                    break;
                default:
                    characters += "/";
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $5e4f012072913cb4$export$36776f635604f274)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(characters, /\f/g, "");
                    if (property > 0 && (0, $5e4f012072913cb4$export$36776f635604f274)(characters) - length) (0, $5e4f012072913cb4$export$10d8903dec122b9d)(property > 32 ? $36ea00327b41abe1$export$f8483753829ec8f3(characters + ";", rule, parent, length - 1) : $36ea00327b41abe1$export$f8483753829ec8f3((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(characters, " ", "") + ";", rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ";";
                // { rule/at-rule
                default:
                    (0, $5e4f012072913cb4$export$10d8903dec122b9d)(reference = $36ea00327b41abe1$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $36ea00327b41abe1$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $5e4f012072913cb4$export$a9db5e087081082d)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $36ea00327b41abe1$export$98e6a39c04603d36(value, reference, reference, rule && (0, $5e4f012072913cb4$export$10d8903dec122b9d)($36ea00327b41abe1$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $36ea00327b41abe1$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ""
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = "", length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $5e4f012072913cb4$export$36776f635604f274)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $f4f4fca9115ed8bd$export$232faf9add678146)() == 125) continue;
            }
            switch(characters += (0, $5e4f012072913cb4$export$6788812c4e6611e6)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += "\f", -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $5e4f012072913cb4$export$36776f635604f274)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)() === 45) characters += (0, $f4f4fca9115ed8bd$export$410ac95b9ec204b8)((0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)());
                    atrule = (0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)(), offset = length = (0, $5e4f012072913cb4$export$36776f635604f274)(type = characters += (0, $f4f4fca9115ed8bd$export$c2ab62c7bf24634)((0, $f4f4fca9115ed8bd$export$e88cb2efb12ae807)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $5e4f012072913cb4$export$36776f635604f274)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $36ea00327b41abe1$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ""
    ];
    var size = (0, $5e4f012072913cb4$export$f9084667e487ed46)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, post + 1, post = (0, $5e4f012072913cb4$export$2335f513bbd82c6d)(j = points[i])), z = value; x < size; ++x)if (z = (0, $5e4f012072913cb4$export$87c2784dc9fc4ab)(j > 0 ? rule[x] + " " + y : (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $f4f4fca9115ed8bd$export$35059013cd4a06db)(value, root, parent, offset === 0 ? (0, $e853ac0080e24cb4$export$aa3a2e812ca8570d) : type, props, children, length);
}
function $36ea00327b41abe1$export$4a34f930e789283c(value, root, parent) {
    return (0, $f4f4fca9115ed8bd$export$35059013cd4a06db)(value, root, parent, (0, $e853ac0080e24cb4$export$a29989082612d0d9), (0, $5e4f012072913cb4$export$6788812c4e6611e6)((0, $f4f4fca9115ed8bd$export$eba6f6f03b0a92e7)()), (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, 2, -2), 0);
}
function $36ea00327b41abe1$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $f4f4fca9115ed8bd$export$35059013cd4a06db)(value, root, parent, (0, $e853ac0080e24cb4$export$527d108ccf083c2b), (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, 0, length), (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, length + 1, -1), length);
}






function $8f2522f8594faa86$export$dfdc1655ccc5b9cb(children, callback) {
    var output = "";
    var length = (0, $5e4f012072913cb4$export$f9084667e487ed46)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || "";
    return output;
}
function $8f2522f8594faa86$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $e853ac0080e24cb4$export$d773506282b3cfe6:
            if (element.children.length) break;
        case 0, $e853ac0080e24cb4$export$a763edbf796b780a:
        case 0, $e853ac0080e24cb4$export$527d108ccf083c2b:
            return element.return = element.return || element.value;
        case 0, $e853ac0080e24cb4$export$a29989082612d0d9:
            return "";
        case 0, $e853ac0080e24cb4$export$b44a8529a35fcb60:
            return element.return = element.value + "{" + $8f2522f8594faa86$export$dfdc1655ccc5b9cb(element.children, callback) + "}";
        case 0, $e853ac0080e24cb4$export$aa3a2e812ca8570d:
            element.value = element.props.join(",");
    }
    return (0, $5e4f012072913cb4$export$36776f635604f274)(children = $8f2522f8594faa86$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + "{" + children + "}" : "";
}




function $be3fa667258f7944$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $5e4f012072913cb4$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + value;
        // tab-size
        case 4789:
            return (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + value + value;
        // writing-mode
        case 5936:
            switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "box-$1$2" + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "flex-item-" + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, "") + (!(0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /flex-|baseline/) ? (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "grid-row-" + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, "") : "") + value;
        // align-content
        case 4675:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "flex-line-pack" + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/g, "") + value;
        // flex-shrink
        case 5548:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "box-" + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, "-grow", "") + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, "$1" + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "$2") + value;
        // cursor
        case 6187:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "$1"), /(image-set)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "box-pack:$3" + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + value;
        // justify-self
        case 4200:
            if (!(0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /flex-|baseline/)) return (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "grid-column-align" + (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, "template-", "") + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $5e4f012072913cb4$export$4659b591c19bdf3d)(element.props, /grid-\w+-end/);
            })) return ~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(value + (children = children[length].value), "span") ? value : (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, "-start", "") + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "grid-row-span:" + (~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(children, "span") ? (0, $5e4f012072913cb4$export$4659b591c19bdf3d)(children, /\d+/) : +(0, $5e4f012072913cb4$export$4659b591c19bdf3d)(children, /\d+/) - +(0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /\d+/)) + ";";
            return (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, "-start", "") + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $5e4f012072913cb4$export$4659b591c19bdf3d)(element.props, /grid-\w+-start/);
            }) ? value : (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, "-end", "-span"), "span ", "") + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $5e4f012072913cb4$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "$2-$3" + "$1" + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(value, "stretch") ? $be3fa667258f7944$export$82e9f45cca5ba907((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, "stretch", "fill-available"), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + a + ":" + b + f + (c ? (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + a + "-span:" + (d ? e : +e - +b) + f : "") + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 6) === 121) return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, ":", ":" + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, (0, $5e4f012072913cb4$export$a9db5e087081082d)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "$2$3" + "$1" + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "$2box$3") + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, ":", ":" + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, "scroll-", "scroll-snap-") + value;
    }
    return value;
}


function $b9a8452e0aabfcf6$export$5a7767152ae0305f(collection) {
    var length = (0, $5e4f012072913cb4$export$f9084667e487ed46)(collection);
    return function(element, index, children, callback) {
        var output = "";
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || "";
        return output;
    };
}
function $b9a8452e0aabfcf6$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $b9a8452e0aabfcf6$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $e853ac0080e24cb4$export$527d108ccf083c2b:
                element.return = (0, $be3fa667258f7944$export$82e9f45cca5ba907)(element.value, element.length, children);
                return;
            case 0, $e853ac0080e24cb4$export$b44a8529a35fcb60:
                return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                    (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                        value: (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(element.value, "@", "@" + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $e853ac0080e24cb4$export$aa3a2e812ca8570d:
                if (element.length) return (0, $5e4f012072913cb4$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ":" + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "input-$1")
                                    ]
                                }),
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + "$1")
                                    ]
                                }),
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
}
function $b9a8452e0aabfcf6$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $e853ac0080e24cb4$export$aa3a2e812ca8570d:
            element.props = element.props.map(function(value) {
                return (0, $5e4f012072913cb4$export$1be1fc439b849fdf)((0, $f4f4fca9115ed8bd$export$660b2ee2d4fb4eff)(value), function(value, index, children) {
                    switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, 0)){
                        // \f
                        case 12:
                            return (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, 1, (0, $5e4f012072913cb4$export$36776f635604f274)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === "global") children[index] = "", children[++index] = "\f" + (0, $5e4f012072913cb4$export$2f35ab04d2335697)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? "" : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $5e4f012072913cb4$export$f9084667e487ed46)(children) > 1 ? "" : value;
                                case index = (0, $5e4f012072913cb4$export$f9084667e487ed46)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}


var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $fc182b1f84212d3f$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $f4f4fca9115ed8bd$export$9e1725a4cfeada27)(character)) break;
        (0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)();
    }
    return (0, $f4f4fca9115ed8bd$export$58adb3bec8346d0f)(begin, (0, $f4f4fca9115ed8bd$export$5880b8b5730aff45));
};
var $fc182b1f84212d3f$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $f4f4fca9115ed8bd$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $fc182b1f84212d3f$var$identifierWithPointTracking((0, $f4f4fca9115ed8bd$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $f4f4fca9115ed8bd$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $5e4f012072913cb4$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)());
    return parsed;
};
var $fc182b1f84212d3f$var$getRules = function getRules(value, points) {
    return (0, $f4f4fca9115ed8bd$export$45918ac1574455b1)($fc182b1f84212d3f$var$toRules((0, $f4f4fca9115ed8bd$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $fc182b1f84212d3f$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $fc182b1f84212d3f$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$fc182b1f84212d3f$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $fc182b1f84212d3f$var$fixedElements.set(element, true);
    var points = [];
    var rules = $fc182b1f84212d3f$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $fc182b1f84212d3f$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
/* eslint-disable no-fallthrough */ function $fc182b1f84212d3f$var$prefix(value, length) {
    switch((0, $5e4f012072913cb4$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "box-$1$2" + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "flex-item-" + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "flex-line-pack" + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "box-" + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, "-grow", "") + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, "$1" + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "$2") + value;
        // cursor
        case 6187:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "$1"), /(image-set)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "box-pack:$3" + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $5e4f012072913cb4$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "$2-$3" + "$1" + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(value, "stretch") ? $fc182b1f84212d3f$var$prefix((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, (0, $5e4f012072913cb4$export$36776f635604f274)(value) - 3 - (~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, ":", ":" + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "$2$3" + "$1" + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $fc182b1f84212d3f$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $e853ac0080e24cb4$export$527d108ccf083c2b:
                element["return"] = $fc182b1f84212d3f$var$prefix(element.value, element.length);
                break;
            case 0, $e853ac0080e24cb4$export$b44a8529a35fcb60:
                return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                    (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                        value: (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(element.value, "@", "@" + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $e853ac0080e24cb4$export$aa3a2e812ca8570d:
                if (element.length) return (0, $5e4f012072913cb4$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ":" + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "input-$1")
                                    ]
                                }),
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + "$1")
                                    ]
                                }),
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $fc182b1f84212d3f$var$defaultStylisPlugins = [
    $fc182b1f84212d3f$var$prefixer
];
var $fc182b1f84212d3f$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $fc182b1f84212d3f$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" ");
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $fc182b1f84212d3f$var$compat,
        $fc182b1f84212d3f$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $8f2522f8594faa86$export$fac44ee5b035f737),
        (0, $b9a8452e0aabfcf6$export$38bcb760f1d4871c)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $b9a8452e0aabfcf6$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)((0, $36ea00327b41abe1$export$ef7acd7185315e22)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $e19976245606d3d7$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};


function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}



var $72623ab6bcb0a33b$exports = {};
"use strict";
var $3251146683c5d714$exports = {};
"use strict";

$3251146683c5d714$exports = (parcelRequire("9cCWX"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($3251146683c5d714$exports.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component["$$typeof"]] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$72623ab6bcb0a33b$exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $f1be2661c8fac766$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($72623ab6bcb0a33b$exports)))(targetComponent, sourceComponent);
};


var $1f6791d0a193b918$var$isBrowser = true;
function $1f6791d0a193b918$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $1f6791d0a193b918$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $1f6791d0a193b918$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $1f6791d0a193b918$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $1f6791d0a193b918$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $62578605b07c8dad$var$isDevelopment = false;
var $62578605b07c8dad$var$hyphenateRegex = /[A-Z]|^ms/g;
var $62578605b07c8dad$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $62578605b07c8dad$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $62578605b07c8dad$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $62578605b07c8dad$var$processStyleName = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(styleName) {
    return $62578605b07c8dad$var$isCustomProperty(styleName) ? styleName : styleName.replace($62578605b07c8dad$var$hyphenateRegex, "-$&").toLowerCase();
});
var $62578605b07c8dad$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($62578605b07c8dad$var$animationRegex, function(match, p1, p2) {
                $62578605b07c8dad$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $62578605b07c8dad$var$cursor
                };
                return p1;
            });
    }
    if ((0, $936be3b045ab836e$export$2e2bcd8739ae039)[key] !== 1 && !$62578605b07c8dad$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $62578605b07c8dad$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $62578605b07c8dad$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $62578605b07c8dad$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $62578605b07c8dad$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $62578605b07c8dad$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $62578605b07c8dad$var$cursor;
                var result = interpolation(mergedProps);
                $62578605b07c8dad$var$cursor = previousCursor;
                return $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== "object") {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($62578605b07c8dad$var$isProcessableValue(asString)) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === "NO_COMPONENT_SELECTOR" && $62578605b07c8dad$var$isDevelopment) throw new Error($62578605b07c8dad$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($62578605b07c8dad$var$isProcessableValue(value[_i])) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case "animation":
                    case "animationName":
                        string += $62578605b07c8dad$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $62578605b07c8dad$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $62578605b07c8dad$var$cursor;
function $62578605b07c8dad$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $62578605b07c8dad$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $62578605b07c8dad$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $62578605b07c8dad$var$labelPattern.exec(styles)) !== null)identifierName += "-" + match[1];
    var name = (0, $3629985b3ecf741f$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $62578605b07c8dad$var$cursor
    };
}



var $acw62 = parcelRequire("acw62");
var $19b532704a3a90e7$var$syncFallback = function syncFallback(create) {
    return create();
};
var $19b532704a3a90e7$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $19b532704a3a90e7$export$db21c7ffa21794e7 = $19b532704a3a90e7$var$useInsertionEffect || $19b532704a3a90e7$var$syncFallback;
var $19b532704a3a90e7$export$811a713a7276cb9d = $19b532704a3a90e7$var$useInsertionEffect || $acw62.useLayoutEffect;


var $4eee05ec22b53782$export$23f2a1d2818174ef = false;
var $4eee05ec22b53782$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $fc182b1f84212d3f$export$2e2bcd8739ae039)({
    key: "css"
}) : null);
var $4eee05ec22b53782$export$e7094788287c5e9b = $4eee05ec22b53782$var$EmotionCacheContext.Provider;
var $4eee05ec22b53782$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($4eee05ec22b53782$var$EmotionCacheContext);
};
var $4eee05ec22b53782$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($4eee05ec22b53782$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $4eee05ec22b53782$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $4eee05ec22b53782$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($4eee05ec22b53782$export$971d5caa766a69d7);
};
var $4eee05ec22b53782$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $4eee05ec22b53782$var$createCacheWithTheme = /* #__PURE__ */ (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function(theme) {
        return $4eee05ec22b53782$var$getTheme(outerTheme, theme);
    });
});
var $4eee05ec22b53782$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $acw62.useContext($4eee05ec22b53782$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $4eee05ec22b53782$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($4eee05ec22b53782$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $4eee05ec22b53782$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(function render(props, ref) {
        var theme = $acw62.useContext($4eee05ec22b53782$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $f1be2661c8fac766$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $4eee05ec22b53782$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $4eee05ec22b53782$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $4eee05ec22b53782$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($4eee05ec22b53782$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$4eee05ec22b53782$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $4eee05ec22b53782$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $1f6791d0a193b918$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $19b532704a3a90e7$export$db21c7ffa21794e7)(function() {
        return (0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $4eee05ec22b53782$var$Emotion = /* #__PURE__ */ $4eee05ec22b53782$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$4eee05ec22b53782$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $1f6791d0a193b918$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)(registeredStyles, undefined, $acw62.useContext($4eee05ec22b53782$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($4eee05ec22b53782$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== "css" && _key2 !== $4eee05ec22b53782$var$typePropName && !$4eee05ec22b53782$export$23f2a1d2818174ef) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($4eee05ec22b53782$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $4eee05ec22b53782$export$a9c23c6ac3fc3eca = $4eee05ec22b53782$var$Emotion;



var $acw62 = parcelRequire("acw62");








var $63d46a01db878c10$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $4eee05ec22b53782$export$dda1d9f60106f0e9).call(props, "css")) return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $4eee05ec22b53782$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $4eee05ec22b53782$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $acw62.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($63d46a01db878c10$export$c8a8987d4410bf2d || ($63d46a01db878c10$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $63d46a01db878c10$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $4eee05ec22b53782$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)([
        styles
    ], undefined, $acw62.useContext((0, $4eee05ec22b53782$export$971d5caa766a69d7)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $19b532704a3a90e7$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $19b532704a3a90e7$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $63d46a01db878c10$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $62578605b07c8dad$export$6321afa313b251b5)(args);
}
function $63d46a01db878c10$export$d25ddfdf17c3ad3e() {
    var insertable = $63d46a01db878c10$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $63d46a01db878c10$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $63d46a01db878c10$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $1f6791d0a193b918$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $63d46a01db878c10$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $19b532704a3a90e7$export$db21c7ffa21794e7)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
    });
    return null;
};
var $63d46a01db878c10$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $4eee05ec22b53782$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $4eee05ec22b53782$export$23f2a1d2818174ef)) throw new Error("css can only be used during render");
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $1f6791d0a193b918$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $4eee05ec22b53782$export$23f2a1d2818174ef)) throw new Error("cx can only be used during render");
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $63d46a01db878c10$var$merge(cache.registered, css, $63d46a01db878c10$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $4eee05ec22b53782$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($63d46a01db878c10$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});



var $acw62 = parcelRequire("acw62");
"use strict";
"use client";
function $77be94f3d6ae12e4$var$getErrorMessage(hook, provider) {
    return `${hook} returned \`undefined\`. Seems you forgot to wrap component within ${provider}`;
}
function $77be94f3d6ae12e4$export$fd42f52fd3ae1109(options = {}) {
    const { name: name, strict: strict = true, hookName: hookName = "useContext", providerName: providerName = "Provider", errorMessage: errorMessage, defaultValue: defaultValue } = options;
    const Context = (0, $acw62.createContext)(defaultValue);
    Context.displayName = name;
    function useContext$1() {
        const context = (0, $acw62.useContext)(Context);
        if (!context && strict) {
            const error = new Error(errorMessage ?? $77be94f3d6ae12e4$var$getErrorMessage(hookName, providerName));
            error.name = "ContextError";
            Error.captureStackTrace?.(error, useContext$1);
            throw error;
        }
        return context;
    }
    return [
        Context.Provider,
        useContext$1,
        Context
    ];
}


"use strict";
"use client";
const [$67ef757553aa7733$var$ChakraContextProvider, $67ef757553aa7733$export$e4f18fbc74d20572] = (0, $77be94f3d6ae12e4$export$fd42f52fd3ae1109)({
    name: "ChakraContext",
    strict: true,
    providerName: "<ChakraProvider />"
});
function $67ef757553aa7733$export$80dbe0482bcbd25a(props) {
    const { value: sys, children: children } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)($67ef757553aa7733$var$ChakraContextProvider, {
        value: sys,
        children: [
            !sys._config.disableLayers && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $63d46a01db878c10$export$98f03c5d19621d70), {
                styles: sys.layers.atRule
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $63d46a01db878c10$export$98f03c5d19621d70), {
                styles: sys._global
            }),
            children
        ]
    });
}



var $acw62 = parcelRequire("acw62");


// eslint-disable-next-line no-undef
var $bcd4e42ca4163639$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bcd4e42ca4163639$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(prop) {
    return $bcd4e42ca4163639$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});







var $acw62 = parcelRequire("acw62");
"use strict";
function $5dfe17a654a6f2ff$export$9dd9a52f2dd5b9ce(...fns) {
    return function mergedFn(...args) {
        fns.forEach((fn)=>fn?.(...args));
    };
}


"use strict";
const $c22e670e330c23ab$var$clsx = (...args)=>args.map((str)=>str?.trim?.()).filter(Boolean).join(" ");
const $c22e670e330c23ab$var$eventRegex = /^on[A-Z]/;
function $c22e670e330c23ab$export$9d1611c77c2fe928(...args) {
    let result = {};
    for (let props of args){
        for(let key in result){
            if ($c22e670e330c23ab$var$eventRegex.test(key) && typeof result[key] === "function" && typeof props[key] === "function") {
                result[key] = (0, $5dfe17a654a6f2ff$export$9dd9a52f2dd5b9ce)(result[key], props[key]);
                continue;
            }
            if (key === "className" || key === "class") {
                result[key] = $c22e670e330c23ab$var$clsx(result[key], props[key]);
                continue;
            }
            if (key === "style") {
                result[key] = Object.assign({}, result[key] ?? {}, props[key] ?? {});
                continue;
            }
            result[key] = props[key] !== void 0 ? props[key] : result[key];
        }
        for(let key in props)if (result[key] === void 0) result[key] = props[key];
    }
    return result;
}


"use strict";
function $7964df37844d1d8e$export$d734136a7b018efe(ref, value) {
    if (ref == null) return;
    if (typeof ref === "function") {
        ref(value);
        return;
    }
    try {
        ref.current = value;
    } catch (error) {
        throw new Error(`Cannot assign value '${value}' to ref '${ref}'`);
    }
}
function $7964df37844d1d8e$export$c9058316764c140e(...refs) {
    return (node)=>{
        refs.forEach((ref)=>{
            $7964df37844d1d8e$export$d734136a7b018efe(ref, node);
        });
    };
}


"use strict";
function $d2e329dcce85bd14$export$8e16b83750b44988(object) {
    const clone = Object.assign({}, object);
    for(let key in clone)if (clone[key] === void 0) delete clone[key];
    return clone;
}


"use strict";
const $7b2d6a34cc679515$export$a274e22fb40f762e = (...classNames)=>classNames.filter(Boolean).map((r)=>r.trim()).join(" ");


"use strict";
function $0d9b9055f4794093$export$c77b7fefca3cef07(mod) {
    return mod.default || mod;
}



var $acw62 = parcelRequire("acw62");
"use strict";
const $b3f328a5401a2298$export$a6cdc56e425d0d0a = (v)=>v != null && typeof v === "object" && !Array.isArray(v);
const $b3f328a5401a2298$export$30a9abfd5fb9f5f6 = (v)=>/^var\(--.+\)$/.test(v);
const $b3f328a5401a2298$export$844ec244b1367d54 = (v)=>typeof v === "string";
const $b3f328a5401a2298$export$f6e2535fb5126e54 = (v)=>typeof v === "function";


"use strict";
function $96f7255b1177d968$export$9a1094f4b3924ae7(el) {
    const version = $acw62.version;
    if (!(0, $b3f328a5401a2298$export$844ec244b1367d54)(version)) return el?.ref;
    if (version.startsWith("18.")) return el?.ref;
    return el?.props?.ref;
}




var $acw62 = parcelRequire("acw62");

"use strict";
const $8be83bf2b7a4ecef$var$splitPropFn = (props, predicate)=>{
    const rest = {};
    const result = {};
    const allKeys = Object.keys(props);
    for (const key of allKeys)if (predicate(key)) result[key] = props[key];
    else rest[key] = props[key];
    return [
        result,
        rest
    ];
};
const $8be83bf2b7a4ecef$export$45029c61b0073d87 = (props, keys)=>{
    const predicate = (0, $b3f328a5401a2298$export$f6e2535fb5126e54)(keys) ? keys : (key)=>keys.includes(key);
    return $8be83bf2b7a4ecef$var$splitPropFn(props, predicate);
};
const $8be83bf2b7a4ecef$export$3ea53b214fbc1986 = (keys)=>{
    return function split(props) {
        return $8be83bf2b7a4ecef$export$45029c61b0073d87(props, keys);
    };
};



"use strict";
const $9ca3d2f82ec96e82$var$htmlProps = /* @__PURE__ */ new Set([
    "htmlWidth",
    "htmlHeight",
    "htmlSize",
    "htmlTranslate"
]);
function $9ca3d2f82ec96e82$export$4790f84f88141745(prop) {
    return typeof prop === "string" && $9ca3d2f82ec96e82$var$htmlProps.has(prop);
}
function $9ca3d2f82ec96e82$export$6c54c1eadfbe24b8(inProps, cvaRecipe, shouldForwardProps) {
    const { css: css, isValidProperty: isValidProperty } = (0, $67ef757553aa7733$export$e4f18fbc74d20572)();
    const { children: children, ...props } = inProps;
    const result = (0, $acw62.useMemo)(()=>{
        const [forwardedProps, restProps_B] = (0, $8be83bf2b7a4ecef$export$45029c61b0073d87)(props, (key)=>shouldForwardProps(key, cvaRecipe.variantKeys));
        const [variantProps, restProps_C] = (0, $8be83bf2b7a4ecef$export$45029c61b0073d87)(restProps_B, cvaRecipe.variantKeys);
        const [styleProps, elementProps] = (0, $8be83bf2b7a4ecef$export$45029c61b0073d87)(restProps_C, isValidProperty);
        return {
            forwardedProps: forwardedProps,
            variantProps: variantProps,
            styleProps: styleProps,
            elementProps: elementProps
        };
    }, [
        cvaRecipe.variantKeys,
        shouldForwardProps,
        props,
        isValidProperty
    ]);
    const { css: cssStyles, ...propStyles } = result.styleProps;
    const cvaStyles = (0, $acw62.useMemo)(()=>{
        const variantProps = {
            ...result.variantProps
        };
        if (!cvaRecipe.variantKeys.includes("colorPalette")) variantProps.colorPalette = props.colorPalette;
        if (!cvaRecipe.variantKeys.includes("orientation")) variantProps.orientation = props.orientation;
        return cvaRecipe(variantProps);
    }, [
        cvaRecipe,
        result.variantProps,
        props.colorPalette,
        props.orientation
    ]);
    const styles = (0, $acw62.useMemo)(()=>{
        return css(cvaStyles, ...$9ca3d2f82ec96e82$var$toArray(cssStyles), propStyles);
    }, [
        css,
        cvaStyles,
        cssStyles,
        propStyles
    ]);
    return {
        styles: styles,
        props: {
            ...result.forwardedProps,
            ...result.elementProps,
            children: children
        }
    };
}
const $9ca3d2f82ec96e82$var$toArray = (val)=>{
    const res = Array.isArray(val) ? val : [
        val
    ];
    return res.filter(Boolean).flat();
};


"use strict";
"use client";
const $ce363bdb8a43b242$var$isPropValid = (0, $0d9b9055f4794093$export$c77b7fefca3cef07)((0, $bcd4e42ca4163639$export$2e2bcd8739ae039));
const $ce363bdb8a43b242$var$testOmitPropsOnStringTag = $ce363bdb8a43b242$var$isPropValid;
const $ce363bdb8a43b242$var$testOmitPropsOnComponent = (key)=>key !== "theme";
const $ce363bdb8a43b242$var$composeShouldForwardProps = (tag, options, isReal)=>{
    let shouldForwardProp;
    if (options) {
        const optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? (propName)=>tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName) : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
let $ce363bdb8a43b242$var$isBrowser = typeof document !== "undefined";
const $ce363bdb8a43b242$var$Insertion = ({ cache: cache2, serialized: serialized, isStringTag: isStringTag })=>{
    (0, $1f6791d0a193b918$export$580009a5da2a8b4b)(cache2, serialized, isStringTag);
    const rules = (0, $19b532704a3a90e7$export$db21c7ffa21794e7)(()=>(0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache2, serialized, isStringTag));
    if (!$ce363bdb8a43b242$var$isBrowser && rules !== void 0) {
        let serializedNames = serialized.name;
        let next = serialized.next;
        while(next !== void 0){
            serializedNames = (0, $7b2d6a34cc679515$export$a274e22fb40f762e)(serializedNames, next.name);
            next = next.next;
        }
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("style", {
            [`data-emotion`]: (0, $7b2d6a34cc679515$export$a274e22fb40f762e)(cache2.key, serializedNames),
            dangerouslySetInnerHTML: {
                __html: rules
            },
            nonce: cache2.sheet.nonce
        });
    }
    return null;
};
const $ce363bdb8a43b242$var$createStyled = (tag, configOrCva = {}, options = {})=>{
    const isReal = tag.__emotion_real === tag;
    const baseTag = isReal && tag.__emotion_base || tag;
    let identifierName;
    let targetClassName;
    if (options !== void 0) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    let styles = [];
    const Styled = (0, $4eee05ec22b53782$export$efccba1c4a2ef57b)((inProps, cache2, ref)=>{
        const { cva: cva, isValidProperty: isValidProperty } = (0, $67ef757553aa7733$export$e4f18fbc74d20572)();
        const cvaFn = configOrCva.__cva__ ? configOrCva : cva(configOrCva);
        const cvaRecipe = $ce363bdb8a43b242$var$mergeCva(tag.__emotion_cva, cvaFn);
        const createShouldForwardProps = (props2)=>{
            return (prop, variantKeys)=>{
                if (props2.includes(prop)) return true;
                return !variantKeys?.includes(prop) && !isValidProperty(prop);
            };
        };
        if (!options.shouldForwardProp && options.forwardProps) options.shouldForwardProp = createShouldForwardProps(options.forwardProps);
        const fallbackShouldForwardProp = (prop, variantKeys)=>{
            const emotionSfp = typeof tag === "string" && tag.charCodeAt(0) > 96 ? $ce363bdb8a43b242$var$testOmitPropsOnStringTag : $ce363bdb8a43b242$var$testOmitPropsOnComponent;
            const chakraSfp = !variantKeys?.includes(prop) && !isValidProperty(prop);
            return emotionSfp(prop) && chakraSfp;
        };
        const shouldForwardProp = $ce363bdb8a43b242$var$composeShouldForwardProps(tag, options, isReal) || fallbackShouldForwardProp;
        const propsWithDefault = $acw62.useMemo(()=>Object.assign({}, options.defaultProps, (0, $d2e329dcce85bd14$export$8e16b83750b44988)(inProps)), [
            inProps
        ]);
        const { props: props, styles: styleProps } = (0, $9ca3d2f82ec96e82$export$6c54c1eadfbe24b8)(propsWithDefault, cvaRecipe, shouldForwardProp);
        let className = "";
        let classInterpolations = [
            styleProps
        ];
        let mergedProps = props;
        if (props.theme == null) {
            mergedProps = {};
            for(let key in props)mergedProps[key] = props[key];
            mergedProps.theme = $acw62.useContext((0, $4eee05ec22b53782$export$971d5caa766a69d7));
        }
        if (typeof props.className === "string") className = (0, $1f6791d0a193b918$export$95d99596f328fd52)(cache2.registered, classInterpolations, props.className);
        else if (props.className != null) className = (0, $7b2d6a34cc679515$export$a274e22fb40f762e)(className, props.className);
        const serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)(styles.concat(classInterpolations), cache2.registered, mergedProps);
        className = (0, $7b2d6a34cc679515$export$a274e22fb40f762e)(className, `${cache2.key}-${serialized.name}`);
        if (targetClassName !== void 0) className = (0, $7b2d6a34cc679515$export$a274e22fb40f762e)(className, targetClassName);
        const shouldUseAs = !shouldForwardProp("as");
        let FinalTag = shouldUseAs && props.as || baseTag;
        let finalProps = {};
        for(let prop in props){
            if (shouldUseAs && prop === "as") continue;
            if ((0, $9ca3d2f82ec96e82$export$4790f84f88141745)(prop)) {
                const nativeProp = prop.replace("html", "").toLowerCase();
                finalProps[nativeProp] = props[prop];
                continue;
            }
            if (shouldForwardProp(prop)) finalProps[prop] = props[prop];
        }
        finalProps.className = className.trim();
        finalProps.ref = ref;
        const forwardAsChild = options.forwardAsChild || options.forwardProps?.includes("asChild");
        if (props.asChild && !forwardAsChild) {
            const child = $acw62.Children.only(props.children);
            FinalTag = child.type;
            finalProps.children = null;
            Reflect.deleteProperty(finalProps, "asChild");
            finalProps = (0, $c22e670e330c23ab$export$9d1611c77c2fe928)(finalProps, child.props);
            finalProps.ref = (0, $7964df37844d1d8e$export$c9058316764c140e)(ref, (0, $96f7255b1177d968$export$9a1094f4b3924ae7)(child));
        }
        if (finalProps.as && forwardAsChild) {
            finalProps.as = void 0;
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                children: [
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($ce363bdb8a43b242$var$Insertion, {
                        cache: cache2,
                        serialized: serialized,
                        isStringTag: typeof FinalTag === "string"
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(FinalTag, {
                        asChild: true,
                        ...finalProps,
                        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(props.as, {
                            children: finalProps.children
                        })
                    })
                ]
            });
        }
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
            children: [
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($ce363bdb8a43b242$var$Insertion, {
                    cache: cache2,
                    serialized: serialized,
                    isStringTag: typeof FinalTag === "string"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(FinalTag, {
                    ...finalProps
                })
            ]
        });
    });
    Styled.displayName = identifierName !== void 0 ? identifierName : `chakra(${typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component"})`;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_forwardProp = options.shouldForwardProp;
    Styled.__emotion_cva = configOrCva;
    Object.defineProperty(Styled, "toString", {
        value () {
            return `.${targetClassName}`;
        }
    });
    return Styled;
};
const $ce363bdb8a43b242$var$styledFn = $ce363bdb8a43b242$var$createStyled.bind();
const $ce363bdb8a43b242$var$cache = /* @__PURE__ */ new Map();
const $ce363bdb8a43b242$var$chakraImpl = new Proxy($ce363bdb8a43b242$var$styledFn, {
    apply (_, __, args) {
        return $ce363bdb8a43b242$var$styledFn(...args);
    },
    get (_, el) {
        if (!$ce363bdb8a43b242$var$cache.has(el)) $ce363bdb8a43b242$var$cache.set(el, $ce363bdb8a43b242$var$styledFn(el));
        return $ce363bdb8a43b242$var$cache.get(el);
    }
});
const $ce363bdb8a43b242$export$7cd122d781af9fa4 = $ce363bdb8a43b242$var$chakraImpl;
const $ce363bdb8a43b242$var$mergeCva = (cvaA, cvaB)=>{
    if (cvaA && !cvaB) return cvaA;
    if (!cvaA && cvaB) return cvaB;
    return cvaA.merge(cvaB);
};


"use strict";
"use client";
const $e44bdf01ce5be678$export$e71c4d32a2263218 = (0, $ce363bdb8a43b242$export$7cd122d781af9fa4)("div");
$e44bdf01ce5be678$export$e71c4d32a2263218.displayName = "Box";



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");



"use strict";
const $0e1476c7d7475328$export$e37f626c01cb373a = Object.freeze({});
const $0e1476c7d7475328$export$d3d148c3a490a1e4 = Object.freeze({});




var $acw62 = parcelRequire("acw62");

"use strict";
"use client";
function $fd8c30bdd9f39a41$export$cf0e09a7086104ff(options) {
    const { key: key, recipe: recipeProp } = options;
    const sys = (0, $67ef757553aa7733$export$e4f18fbc74d20572)();
    return (0, $acw62.useMemo)(()=>{
        const recipe = recipeProp || (key != null ? sys.getRecipe(key) : {});
        return sys.cva(structuredClone(recipe));
    }, [
        key,
        recipeProp,
        sys
    ]);
}


"use strict";
"use client";
const $4917af36de141b89$var$upperFirst = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
function $4917af36de141b89$export$e99ac154c18649c5(options) {
    const { key: recipeKey, recipe: recipeConfig } = options;
    const contextName = $4917af36de141b89$var$upperFirst(recipeKey || recipeConfig.className || "Component");
    const [PropsProvider, usePropsContext] = (0, $77be94f3d6ae12e4$export$fd42f52fd3ae1109)({
        strict: false,
        name: `${contextName}PropsContext`,
        providerName: `${contextName}PropsContext`
    });
    function useRecipeResult(props) {
        const { unstyled: unstyled, ...restProps } = props;
        const recipe = (0, $fd8c30bdd9f39a41$export$cf0e09a7086104ff)({
            key: recipeKey,
            recipe: restProps.recipe || recipeConfig
        });
        const [variantProps, otherProps] = (0, $acw62.useMemo)(()=>recipe.splitVariantProps(restProps), [
            recipe,
            restProps
        ]);
        const styles = unstyled ? (0, $0e1476c7d7475328$export$e37f626c01cb373a) : recipe(variantProps);
        return {
            styles: styles,
            className: recipe.className,
            props: otherProps
        };
    }
    const withContext = (Component, options2)=>{
        const SuperComponent = (0, $ce363bdb8a43b242$export$7cd122d781af9fa4)(Component, {}, options2);
        const StyledComponent = (0, $acw62.forwardRef)((inProps, ref)=>{
            const propsContext = usePropsContext();
            const props = (0, $acw62.useMemo)(()=>(0, $c22e670e330c23ab$export$9d1611c77c2fe928)(propsContext, inProps), [
                inProps,
                propsContext
            ]);
            const { styles: styles, className: className, props: localProps } = useRecipeResult(props);
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(SuperComponent, {
                ...localProps,
                ref: ref,
                css: [
                    styles,
                    props.css
                ],
                className: (0, $7b2d6a34cc679515$export$a274e22fb40f762e)(className, props.className)
            });
        });
        StyledComponent.displayName = Component.displayName || Component.name;
        return StyledComponent;
    };
    function withPropsProvider() {
        return PropsProvider;
    }
    return {
        withContext: withContext,
        PropsProvider: PropsProvider,
        withPropsProvider: withPropsProvider,
        usePropsContext: usePropsContext,
        useRecipeResult: useRecipeResult
    };
}





var $acw62 = parcelRequire("acw62");

"use strict";
"use client";
const $0c29309d5d88a7ae$export$5f1714a13ed34c01 = (0, $ce363bdb8a43b242$export$7cd122d781af9fa4)("span");



"use strict";
"use client";
const $09da3206be65a1a5$export$335dd19f2cdf1a5c = (0, $ce363bdb8a43b242$export$7cd122d781af9fa4)("div", {
    base: {
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    variants: {
        axis: {
            horizontal: {
                insetStart: "50%",
                translate: "-50%",
                _rtl: {
                    translate: "50%"
                }
            },
            vertical: {
                top: "50%",
                translate: "0 -50%"
            },
            both: {
                insetStart: "50%",
                top: "50%",
                translate: "-50% -50%",
                _rtl: {
                    translate: "50% -50%"
                }
            }
        }
    },
    defaultVariants: {
        axis: "both"
    }
});
$09da3206be65a1a5$export$335dd19f2cdf1a5c.displayName = "AbsoluteCenter";



"use strict";
"use client";
const { withContext: $3d4eb862e9f7344f$var$withContext, PropsProvider: $3d4eb862e9f7344f$var$PropsProvider } = (0, $4917af36de141b89$export$e99ac154c18649c5)({
    key: "spinner"
});
const $3d4eb862e9f7344f$export$7f7cbe89f1eacd2 = $3d4eb862e9f7344f$var$withContext("span");
const $3d4eb862e9f7344f$export$ac4069e6bc5c57c5 = $3d4eb862e9f7344f$var$PropsProvider;


"use strict";
const $852768e4665e44f2$export$3b0d6d7590275603 = $acw62.forwardRef(function Loader2(props, ref) {
    const { spinner: spinner = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3d4eb862e9f7344f$export$7f7cbe89f1eacd2), {
        size: "inherit",
        borderWidth: "0.125em",
        color: "inherit"
    }), spinnerPlacement: spinnerPlacement = "start", children: children, text: text, visible: visible = true, ...rest } = props;
    if (!visible) return children;
    if (text) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $0c29309d5d88a7ae$export$5f1714a13ed34c01), {
        ref: ref,
        display: "contents",
        ...rest,
        children: [
            spinnerPlacement === "start" && spinner,
            text,
            spinnerPlacement === "end" && spinner
        ]
    });
    if (spinner) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $0c29309d5d88a7ae$export$5f1714a13ed34c01), {
        ref: ref,
        display: "contents",
        ...rest,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $09da3206be65a1a5$export$335dd19f2cdf1a5c), {
                display: "inline-flex",
                children: spinner
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0c29309d5d88a7ae$export$5f1714a13ed34c01), {
                opacity: 0,
                children: children
            })
        ]
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0c29309d5d88a7ae$export$5f1714a13ed34c01), {
        ref: ref,
        display: "contents",
        ...rest,
        children: children
    });
});


"use strict";
"use client";
const { useRecipeResult: $dcc08b6ba0830e03$var$useRecipeResult, PropsProvider: $dcc08b6ba0830e03$var$PropsProvider, usePropsContext: $dcc08b6ba0830e03$var$usePropsContext } = (0, $4917af36de141b89$export$e99ac154c18649c5)({
    key: "button"
});
const $dcc08b6ba0830e03$export$353f5b6fc5456de1 = (0, $acw62.forwardRef)(function Button2(inProps, ref) {
    const propsContext = $dcc08b6ba0830e03$var$usePropsContext();
    const props = (0, $acw62.useMemo)(()=>(0, $c22e670e330c23ab$export$9d1611c77c2fe928)(propsContext, inProps), [
        propsContext,
        inProps
    ]);
    const result = $dcc08b6ba0830e03$var$useRecipeResult(props);
    const { loading: loading, loadingText: loadingText, children: children, spinner: spinner, spinnerPlacement: spinnerPlacement, ...rest } = result.props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $ce363bdb8a43b242$export$7cd122d781af9fa4).button, {
        type: "button",
        ref: ref,
        ...rest,
        disabled: loading || rest.disabled,
        className: (0, $7b2d6a34cc679515$export$a274e22fb40f762e)(result.className, props.className),
        css: [
            result.styles,
            props.css
        ],
        children: !props.asChild && loading ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $852768e4665e44f2$export$3b0d6d7590275603), {
            spinner: spinner,
            text: loadingText,
            spinnerPlacement: spinnerPlacement,
            children: children
        }) : children
    });
});
const $dcc08b6ba0830e03$export$1e26e075ed062b9a = $dcc08b6ba0830e03$var$PropsProvider;


"use strict";
"use client";
const { withContext: $7b9aee1d6c050693$var$withContext, PropsProvider: $7b9aee1d6c050693$var$PropsProvider } = (0, $4917af36de141b89$export$e99ac154c18649c5)({
    key: "container"
});
const $7b9aee1d6c050693$export$42a852a2b6b56249 = $7b9aee1d6c050693$var$withContext("div");
const $7b9aee1d6c050693$export$65f1f05d2478f85b = $7b9aee1d6c050693$var$PropsProvider;


"use strict";
"use client";
const { withContext: $86ee73686dbc0e1a$var$withContext, PropsProvider: $86ee73686dbc0e1a$var$PropsProvider } = (0, $4917af36de141b89$export$e99ac154c18649c5)({
    key: "heading"
});
const $86ee73686dbc0e1a$export$a8a3e93435678ff9 = $86ee73686dbc0e1a$var$withContext("h2");
const $86ee73686dbc0e1a$export$75dc054942fe7313 = $86ee73686dbc0e1a$var$PropsProvider;


"use strict";
"use client";
const { withContext: $6a8ad047b05e4916$var$withContext, PropsProvider: $6a8ad047b05e4916$var$PropsProvider } = (0, $4917af36de141b89$export$e99ac154c18649c5)({
    key: "link"
});
const $6a8ad047b05e4916$export$a6c7ac8248d6e38a = $6a8ad047b05e4916$var$withContext("a");
const $6a8ad047b05e4916$export$5d1a7d87cf890a12 = $6a8ad047b05e4916$var$PropsProvider;

var $96e9fa4e455ee4bb$exports = {};

$parcel$export($96e9fa4e455ee4bb$exports, "Indicator", () => $e659fff345b40d8b$export$d375f1eed74d6a0e);
$parcel$export($96e9fa4e455ee4bb$exports, "Item", () => $e659fff345b40d8b$export$a7b06bfba60a8a78);
$parcel$export($96e9fa4e455ee4bb$exports, "Root", () => $e659fff345b40d8b$export$3fd2536aa7317f19);
$parcel$export($96e9fa4e455ee4bb$exports, "RootPropsProvider", () => $e659fff345b40d8b$export$189b7c86fd2ac639);


var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");

"use strict";
"use client";
function $0a4f91ba8bf684ef$export$51a14f30f34875a5(options) {
    const { key: key, recipe: recipeProp } = options;
    const sys = (0, $67ef757553aa7733$export$e4f18fbc74d20572)();
    return (0, $acw62.useMemo)(()=>{
        const recipe = recipeProp || (key != null ? sys.getSlotRecipe(key) : {});
        return sys.sva(structuredClone(recipe));
    }, [
        key,
        recipeProp,
        sys
    ]);
}


"use strict";
"use client";
const $975f34631e6d460a$var$upperFirst = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $975f34631e6d460a$export$ac7f79c9443925b8 = (options)=>{
    const { key: recipeKey, recipe: recipeConfig } = options;
    const contextName = $975f34631e6d460a$var$upperFirst(recipeKey || recipeConfig.className || "Component");
    const [StylesProvider, useStyles] = (0, $77be94f3d6ae12e4$export$fd42f52fd3ae1109)({
        name: `${contextName}StylesContext`,
        errorMessage: `use${contextName}Styles returned is 'undefined'. Seems you forgot to wrap the components in "<${contextName}.Root />" `
    });
    const [ClassNamesProvider, useClassNames] = (0, $77be94f3d6ae12e4$export$fd42f52fd3ae1109)({
        name: `${contextName}ClassNameContext`,
        errorMessage: `use${contextName}ClassNames returned is 'undefined'. Seems you forgot to wrap the components in "<${contextName}.Root />" `,
        strict: false
    });
    const [PropsProvider, usePropsContext] = (0, $77be94f3d6ae12e4$export$fd42f52fd3ae1109)({
        strict: false,
        name: `${contextName}PropsContext`,
        providerName: `${contextName}PropsContext`,
        defaultValue: {}
    });
    function useRecipeResult(props) {
        const { unstyled: unstyled, ...restProps } = props;
        const slotRecipe = (0, $0a4f91ba8bf684ef$export$51a14f30f34875a5)({
            key: recipeKey,
            recipe: restProps.recipe || recipeConfig
        });
        const [variantProps, otherProps] = (0, $acw62.useMemo)(()=>slotRecipe.splitVariantProps(restProps), [
            restProps,
            slotRecipe
        ]);
        const styles = (0, $acw62.useMemo)(()=>unstyled ? (0, $0e1476c7d7475328$export$d3d148c3a490a1e4) : slotRecipe(variantProps), [
            unstyled,
            variantProps,
            slotRecipe
        ]);
        return {
            styles: styles,
            classNames: slotRecipe.classNameMap,
            props: otherProps
        };
    }
    function withRootProvider(Component, options2 = {}) {
        const { defaultProps: defaultProps } = options2;
        const StyledComponent = (inProps)=>{
            const propsContext = usePropsContext();
            const props = (0, $acw62.useMemo)(()=>(0, $c22e670e330c23ab$export$9d1611c77c2fe928)(defaultProps, propsContext, inProps), [
                propsContext,
                inProps
            ]);
            const { styles: styles, classNames: classNames, props: rootProps } = useRecipeResult(props);
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(StylesProvider, {
                value: styles,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(ClassNamesProvider, {
                    value: classNames,
                    children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                        ...rootProps
                    })
                })
            });
        };
        StyledComponent.displayName = Component.displayName || Component.name;
        return StyledComponent;
    }
    const withProvider = (Component, slot, options2)=>{
        const { defaultProps: defaultProps, ...restOptions } = options2 ?? {};
        const SuperComponent = (0, $ce363bdb8a43b242$export$7cd122d781af9fa4)(Component, {}, restOptions);
        const StyledComponent = (0, $acw62.forwardRef)((inProps, ref)=>{
            const propsContext = usePropsContext();
            const props = (0, $acw62.useMemo)(()=>(0, $c22e670e330c23ab$export$9d1611c77c2fe928)(defaultProps ?? {}, propsContext, inProps), [
                propsContext,
                inProps
            ]);
            const { styles: styles, props: rootProps, classNames: classNames } = useRecipeResult(props);
            const className = classNames[slot];
            const element = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(StylesProvider, {
                value: styles,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(ClassNamesProvider, {
                    value: classNames,
                    children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(SuperComponent, {
                        ref: ref,
                        ...rootProps,
                        css: [
                            styles[slot],
                            props.css
                        ],
                        className: (0, $7b2d6a34cc679515$export$a274e22fb40f762e)(props.className, className)
                    })
                })
            });
            return options2?.wrapElement?.(element, props) ?? element;
        });
        StyledComponent.displayName = Component.displayName || Component.name;
        return StyledComponent;
    };
    const withContext = (Component, slot, options2)=>{
        const SuperComponent = (0, $ce363bdb8a43b242$export$7cd122d781af9fa4)(Component, {}, options2);
        const StyledComponent = (0, $acw62.forwardRef)((props, ref)=>{
            const styles = useStyles();
            const classNames = useClassNames();
            const className = classNames?.[slot];
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(SuperComponent, {
                ...props,
                css: [
                    slot ? styles[slot] : void 0,
                    props.css
                ],
                ref: ref,
                className: (0, $7b2d6a34cc679515$export$a274e22fb40f762e)(props.className, className)
            });
        });
        StyledComponent.displayName = Component.displayName || Component.name;
        return StyledComponent;
    };
    return {
        StylesProvider: StylesProvider,
        ClassNamesProvider: ClassNamesProvider,
        PropsProvider: PropsProvider,
        usePropsContext: usePropsContext,
        useRecipeResult: useRecipeResult,
        withProvider: withProvider,
        withContext: withContext,
        withRootProvider: withRootProvider,
        useStyles: useStyles,
        useClassNames: useClassNames
    };
};


"use strict";
"use client";
const { withProvider: $e659fff345b40d8b$var$withProvider, withContext: $e659fff345b40d8b$var$withContext, useStyles: $e659fff345b40d8b$export$cc8f1462c0be9565, PropsProvider: $e659fff345b40d8b$var$PropsProvider } = (0, $975f34631e6d460a$export$ac7f79c9443925b8)({
    key: "list"
});
const $e659fff345b40d8b$export$3fd2536aa7317f19 = $e659fff345b40d8b$var$withProvider("ul", "root", {
    defaultProps: {
        role: "list"
    }
});
const $e659fff345b40d8b$export$189b7c86fd2ac639 = $e659fff345b40d8b$var$PropsProvider;
const $e659fff345b40d8b$export$a7b06bfba60a8a78 = $e659fff345b40d8b$var$withContext("li", "item");
const $e659fff345b40d8b$export$d375f1eed74d6a0e = $e659fff345b40d8b$var$withContext("span", "indicator");


"use strict";


"use strict";
"use client";
const { withContext: $a78d01f419bf79df$var$withContext, PropsProvider: $a78d01f419bf79df$var$PropsProvider } = (0, $4917af36de141b89$export$e99ac154c18649c5)({
    key: "text"
});
const $a78d01f419bf79df$export$5f1af8db9871e1d6 = $a78d01f419bf79df$var$withContext("p");
const $a78d01f419bf79df$export$36a604bba6f5a410 = $a78d01f419bf79df$var$PropsProvider;


"use strict";
"use client";
const $2dea3e0803adfea1$export$8fecac46448b5689 = {
    border: "0",
    clip: "rect(0, 0, 0, 0)",
    height: "1px",
    width: "1px",
    margin: "-1px",
    padding: "0",
    overflow: "hidden",
    whiteSpace: "nowrap",
    position: "absolute"
};
const $2dea3e0803adfea1$export$439d29a4e110a164 = (0, $ce363bdb8a43b242$export$7cd122d781af9fa4)("span", {
    base: $2dea3e0803adfea1$export$8fecac46448b5689
});
$2dea3e0803adfea1$export$439d29a4e110a164.displayName = "VisuallyHidden";


var $40f75bffb1354217$exports = {};
/*!
 * clipboard.js v2.0.11
 * https://clipboardjs.com/
 *
 * Licensed MIT © Zeno Rocha
 */ (function webpackUniversalModuleDefinition(root, factory) {
    $40f75bffb1354217$exports = factory();
})($40f75bffb1354217$exports, function() {
    return /******/ function() {
        /******/ var __webpack_modules__ = {
            /***/ 686: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    "default": function() {
                        return /* binding */ clipboard;
                    }
                });
                // EXTERNAL MODULE: ./node_modules/tiny-emitter/index.js
                var tiny_emitter = __webpack_require__(279);
                var tiny_emitter_default = /*#__PURE__*/ __webpack_require__.n(tiny_emitter);
                // EXTERNAL MODULE: ./node_modules/good-listener/src/listen.js
                var listen = __webpack_require__(370);
                var listen_default = /*#__PURE__*/ __webpack_require__.n(listen);
                // EXTERNAL MODULE: ./node_modules/select/src/select.js
                var src_select = __webpack_require__(817);
                var select_default = /*#__PURE__*/ __webpack_require__.n(src_select);
                /**
 * Executes a given operation type.
 * @param {String} type
 * @return {Boolean}
 */ function command(type) {
                    try {
                        return document.execCommand(type);
                    } catch (err) {
                        return false;
                    }
                }
                /**
 * Cut action wrapper.
 * @param {String|HTMLElement} target
 * @return {String}
 */ var ClipboardActionCut = function ClipboardActionCut(target) {
                    var selectedText = select_default()(target);
                    command("cut");
                    return selectedText;
                };
                /* harmony default export */ var actions_cut = ClipboardActionCut;
                /**
 * Creates a fake textarea element with a value.
 * @param {String} value
 * @return {HTMLElement}
 */ function createFakeElement(value) {
                    var isRTL = document.documentElement.getAttribute("dir") === "rtl";
                    var fakeElement = document.createElement("textarea"); // Prevent zooming on iOS
                    fakeElement.style.fontSize = "12pt"; // Reset box model
                    fakeElement.style.border = "0";
                    fakeElement.style.padding = "0";
                    fakeElement.style.margin = "0"; // Move element out of screen horizontally
                    fakeElement.style.position = "absolute";
                    fakeElement.style[isRTL ? "right" : "left"] = "-9999px"; // Move element to the same position vertically
                    var yPosition = window.pageYOffset || document.documentElement.scrollTop;
                    fakeElement.style.top = "".concat(yPosition, "px");
                    fakeElement.setAttribute("readonly", "");
                    fakeElement.value = value;
                    return fakeElement;
                }
                /**
 * Create fake copy action wrapper using a fake element.
 * @param {String} target
 * @param {Object} options
 * @return {String}
 */ var fakeCopyAction = function fakeCopyAction(value, options) {
                    var fakeElement = createFakeElement(value);
                    options.container.appendChild(fakeElement);
                    var selectedText = select_default()(fakeElement);
                    command("copy");
                    fakeElement.remove();
                    return selectedText;
                };
                /**
 * Copy action wrapper.
 * @param {String|HTMLElement} target
 * @param {Object} options
 * @return {String}
 */ var ClipboardActionCopy = function ClipboardActionCopy(target) {
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                        container: document.body
                    };
                    var selectedText = "";
                    if (typeof target === "string") selectedText = fakeCopyAction(target, options);
                    else if (target instanceof HTMLInputElement && ![
                        "text",
                        "search",
                        "url",
                        "tel",
                        "password"
                    ].includes(target === null || target === void 0 ? void 0 : target.type)) // If input type doesn't support `setSelectionRange`. Simulate it. https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange
                    selectedText = fakeCopyAction(target.value, options);
                    else {
                        selectedText = select_default()(target);
                        command("copy");
                    }
                    return selectedText;
                };
                /* harmony default export */ var actions_copy = ClipboardActionCopy;
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                /**
 * Inner function which performs selection from either `text` or `target`
 * properties and then executes copy or cut operations.
 * @param {Object} options
 */ var ClipboardActionDefault = function ClipboardActionDefault() {
                    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    // Defines base properties passed from constructor.
                    var _options$action = options.action, action = _options$action === void 0 ? "copy" : _options$action, container = options.container, target = options.target, text = options.text; // Sets the `action` to be performed which can be either 'copy' or 'cut'.
                    if (action !== "copy" && action !== "cut") throw new Error('Invalid "action" value, use either "copy" or "cut"');
                     // Sets the `target` property using an element that will be have its content copied.
                    if (target !== undefined) {
                        if (target && _typeof(target) === "object" && target.nodeType === 1) {
                            if (action === "copy" && target.hasAttribute("disabled")) throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                            if (action === "cut" && (target.hasAttribute("readonly") || target.hasAttribute("disabled"))) throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                        } else throw new Error('Invalid "target" value, use a valid Element');
                    } // Define selection strategy based on `text` property.
                    if (text) return actions_copy(text, {
                        container: container
                    });
                     // Defines which selection strategy based on `target` property.
                    if (target) return action === "cut" ? actions_cut(target) : actions_copy(target, {
                        container: container
                    });
                };
                /* harmony default export */ var actions_default = ClipboardActionDefault;
                function clipboard_typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") clipboard_typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else clipboard_typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return clipboard_typeof(obj);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self, call) {
                    if (call && (clipboard_typeof(call) === "object" || typeof call === "function")) return call;
                    return _assertThisInitialized(self);
                }
                function _assertThisInitialized(self) {
                    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                /**
 * Helper function to retrieve attribute value.
 * @param {String} suffix
 * @param {Element} element
 */ function getAttributeValue(suffix, element) {
                    var attribute = "data-clipboard-".concat(suffix);
                    if (!element.hasAttribute(attribute)) return;
                    return element.getAttribute(attribute);
                }
                /**
 * Base class which takes one or more elements, adds event listeners to them,
 * and instantiates a new `ClipboardAction` on each click.
 */ var Clipboard = /*#__PURE__*/ function(_Emitter) {
                    _inherits(Clipboard, _Emitter);
                    var _super = _createSuper(Clipboard);
                    /**
   * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
   * @param {Object} options
   */ function Clipboard(trigger, options) {
                        var _this;
                        _classCallCheck(this, Clipboard);
                        _this = _super.call(this);
                        _this.resolveOptions(options);
                        _this.listenClick(trigger);
                        return _this;
                    }
                    /**
   * Defines if attributes would be resolved using internal setter functions
   * or custom functions that were passed in the constructor.
   * @param {Object} options
   */ _createClass(Clipboard, [
                        {
                            key: "resolveOptions",
                            value: function resolveOptions() {
                                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                                this.action = typeof options.action === "function" ? options.action : this.defaultAction;
                                this.target = typeof options.target === "function" ? options.target : this.defaultTarget;
                                this.text = typeof options.text === "function" ? options.text : this.defaultText;
                                this.container = clipboard_typeof(options.container) === "object" ? options.container : document.body;
                            }
                        },
                        {
                            key: "listenClick",
                            value: function listenClick(trigger) {
                                var _this2 = this;
                                this.listener = listen_default()(trigger, "click", function(e) {
                                    return _this2.onClick(e);
                                });
                            }
                        },
                        {
                            key: "onClick",
                            value: function onClick(e) {
                                var trigger = e.delegateTarget || e.currentTarget;
                                var action = this.action(trigger) || "copy";
                                var text = actions_default({
                                    action: action,
                                    container: this.container,
                                    target: this.target(trigger),
                                    text: this.text(trigger)
                                }); // Fires an event based on the copy operation result.
                                this.emit(text ? "success" : "error", {
                                    action: action,
                                    text: text,
                                    trigger: trigger,
                                    clearSelection: function clearSelection() {
                                        if (trigger) trigger.focus();
                                        window.getSelection().removeAllRanges();
                                    }
                                });
                            }
                        },
                        {
                            key: "defaultAction",
                            value: function defaultAction(trigger) {
                                return getAttributeValue("action", trigger);
                            }
                        },
                        {
                            key: "defaultTarget",
                            value: function defaultTarget(trigger) {
                                var selector = getAttributeValue("target", trigger);
                                if (selector) return document.querySelector(selector);
                            }
                        },
                        {
                            key: "defaultText",
                            /**
     * Default `text` lookup function.
     * @param {Element} trigger
     */ value: function defaultText(trigger) {
                                return getAttributeValue("text", trigger);
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.listener.destroy();
                            }
                        }
                    ], [
                        {
                            key: "copy",
                            value: function copy(target) {
                                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                                    container: document.body
                                };
                                return actions_copy(target, options);
                            }
                        },
                        {
                            key: "cut",
                            value: function cut(target) {
                                return actions_cut(target);
                            }
                        },
                        {
                            key: "isSupported",
                            value: function isSupported() {
                                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
                                    "copy",
                                    "cut"
                                ];
                                var actions = typeof action === "string" ? [
                                    action
                                ] : action;
                                var support = !!document.queryCommandSupported;
                                actions.forEach(function(action) {
                                    support = support && !!document.queryCommandSupported(action);
                                });
                                return support;
                            }
                        }
                    ]);
                    return Clipboard;
                }(tiny_emitter_default());
                /* harmony default export */ var clipboard = Clipboard;
            /***/ },
            /***/ 828: /***/ function(module1) {
                var DOCUMENT_NODE_TYPE = 9;
                /**
 * A polyfill for Element.matches()
 */ if (typeof Element !== "undefined" && !Element.prototype.matches) {
                    var proto = Element.prototype;
                    proto.matches = proto.matchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector || proto.webkitMatchesSelector;
                }
                /**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */ function closest(element, selector) {
                    while(element && element.nodeType !== DOCUMENT_NODE_TYPE){
                        if (typeof element.matches === "function" && element.matches(selector)) return element;
                        element = element.parentNode;
                    }
                }
                module1.exports = closest;
            /***/ },
            /***/ 438: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var closest = __webpack_require__(828);
                /**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */ function _delegate(element, selector, type, callback, useCapture) {
                    var listenerFn = listener.apply(this, arguments);
                    element.addEventListener(type, listenerFn, useCapture);
                    return {
                        destroy: function() {
                            element.removeEventListener(type, listenerFn, useCapture);
                        }
                    };
                }
                /**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */ function delegate(elements, selector, type, callback, useCapture) {
                    // Handle the regular Element usage
                    if (typeof elements.addEventListener === "function") return _delegate.apply(null, arguments);
                    // Handle Element-less usage, it defaults to global delegation
                    if (typeof type === "function") // Use `document` as the first parameter, then apply arguments
                    // This is a short way to .unshift `arguments` without running into deoptimizations
                    return _delegate.bind(null, document).apply(null, arguments);
                    // Handle Selector-based usage
                    if (typeof elements === "string") elements = document.querySelectorAll(elements);
                    // Handle Array-like based usage
                    return Array.prototype.map.call(elements, function(element) {
                        return _delegate(element, selector, type, callback, useCapture);
                    });
                }
                /**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */ function listener(element, selector, type, callback) {
                    return function(e) {
                        e.delegateTarget = closest(e.target, selector);
                        if (e.delegateTarget) callback.call(element, e);
                    };
                }
                module1.exports = delegate;
            /***/ },
            /***/ 879: /***/ function(__unused_webpack_module, exports) {
                /**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.node = function(value) {
                    return value !== undefined && value instanceof HTMLElement && value.nodeType === 1;
                };
                /**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.nodeList = function(value) {
                    var type = Object.prototype.toString.call(value);
                    return value !== undefined && (type === "[object NodeList]" || type === "[object HTMLCollection]") && "length" in value && (value.length === 0 || exports.node(value[0]));
                };
                /**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.string = function(value) {
                    return typeof value === "string" || value instanceof String;
                };
                /**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.fn = function(value) {
                    var type = Object.prototype.toString.call(value);
                    return type === "[object Function]";
                };
            /***/ },
            /***/ 370: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var is = __webpack_require__(879);
                var delegate = __webpack_require__(438);
                /**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listen(target, type, callback) {
                    if (!target && !type && !callback) throw new Error("Missing required arguments");
                    if (!is.string(type)) throw new TypeError("Second argument must be a String");
                    if (!is.fn(callback)) throw new TypeError("Third argument must be a Function");
                    if (is.node(target)) return listenNode(target, type, callback);
                    else if (is.nodeList(target)) return listenNodeList(target, type, callback);
                    else if (is.string(target)) return listenSelector(target, type, callback);
                    else throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList");
                }
                /**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenNode(node, type, callback) {
                    node.addEventListener(type, callback);
                    return {
                        destroy: function() {
                            node.removeEventListener(type, callback);
                        }
                    };
                }
                /**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenNodeList(nodeList, type, callback) {
                    Array.prototype.forEach.call(nodeList, function(node) {
                        node.addEventListener(type, callback);
                    });
                    return {
                        destroy: function() {
                            Array.prototype.forEach.call(nodeList, function(node) {
                                node.removeEventListener(type, callback);
                            });
                        }
                    };
                }
                /**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenSelector(selector, type, callback) {
                    return delegate(document.body, selector, type, callback);
                }
                module1.exports = listen;
            /***/ },
            /***/ 817: /***/ function(module1) {
                function select(element) {
                    var selectedText;
                    if (element.nodeName === "SELECT") {
                        element.focus();
                        selectedText = element.value;
                    } else if (element.nodeName === "INPUT" || element.nodeName === "TEXTAREA") {
                        var isReadOnly = element.hasAttribute("readonly");
                        if (!isReadOnly) element.setAttribute("readonly", "");
                        element.select();
                        element.setSelectionRange(0, element.value.length);
                        if (!isReadOnly) element.removeAttribute("readonly");
                        selectedText = element.value;
                    } else {
                        if (element.hasAttribute("contenteditable")) element.focus();
                        var selection = window.getSelection();
                        var range = document.createRange();
                        range.selectNodeContents(element);
                        selection.removeAllRanges();
                        selection.addRange(range);
                        selectedText = selection.toString();
                    }
                    return selectedText;
                }
                module1.exports = select;
            /***/ },
            /***/ 279: /***/ function(module1) {
                function E() {
                // Keep this empty so it's easier to inherit from
                // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
                }
                E.prototype = {
                    on: function(name, callback, ctx) {
                        var e = this.e || (this.e = {});
                        (e[name] || (e[name] = [])).push({
                            fn: callback,
                            ctx: ctx
                        });
                        return this;
                    },
                    once: function(name, callback, ctx) {
                        var self = this;
                        function listener() {
                            self.off(name, listener);
                            callback.apply(ctx, arguments);
                        }
                        listener._ = callback;
                        return this.on(name, listener, ctx);
                    },
                    emit: function(name) {
                        var data = [].slice.call(arguments, 1);
                        var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
                        var i = 0;
                        var len = evtArr.length;
                        for(i; i < len; i++)evtArr[i].fn.apply(evtArr[i].ctx, data);
                        return this;
                    },
                    off: function(name, callback) {
                        var e = this.e || (this.e = {});
                        var evts = e[name];
                        var liveEvents = [];
                        if (evts && callback) {
                            for(var i = 0, len = evts.length; i < len; i++)if (evts[i].fn !== callback && evts[i].fn._ !== callback) liveEvents.push(evts[i]);
                        }
                        // Remove event from queue to prevent memory leak
                        // Suggested by https://github.com/lazd
                        // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
                        liveEvents.length ? e[name] = liveEvents : delete e[name];
                        return this;
                    }
                };
                module1.exports = E;
                module1.exports.TinyEmitter = E;
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ if (__webpack_module_cache__[moduleId]) /******/ return __webpack_module_cache__[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/compat get default export */ /******/ !function() {
            /******/ // getDefaultExport function for compatibility with non-harmony modules
            /******/ __webpack_require__.n = function(module1) {
                /******/ var getter = module1 && module1.__esModule ? /******/ function() {
                    return module1["default"];
                } : /******/ function() {
                    return module1;
                };
                /******/ __webpack_require__.d(getter, {
                    a: getter
                });
                /******/ return getter;
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/define property getters */ /******/ !function() {
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = function(exports, definition) {
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ !function() {
            /******/ __webpack_require__.o = function(obj, prop) {
                return Object.prototype.hasOwnProperty.call(obj, prop);
            };
        /******/ }();
        /******/ /************************************************************************/ /******/ // module exports must be returned from runtime so entry inlining is disabled
        /******/ // startup
        /******/ // Load entry module and return exports
        /******/ return __webpack_require__(686);
    /******/ }().default;
});


var $85b88a992de89b18$exports = {};

$parcel$export($85b88a992de89b18$exports, "createCollecticon", () => $85b88a992de89b18$export$7209ba2b0568490);
$parcel$export($85b88a992de89b18$exports, "CollecticonArea", () => $85b88a992de89b18$export$fb146e0ebe1880c9);
$parcel$export($85b88a992de89b18$exports, "CollecticonArrowDownLeft", () => $85b88a992de89b18$export$4d7881fd068b9554);
$parcel$export($85b88a992de89b18$exports, "CollecticonArrowDownRight", () => $85b88a992de89b18$export$ff31736f1164b93d);
$parcel$export($85b88a992de89b18$exports, "CollecticonArrowDown", () => $85b88a992de89b18$export$bab927fca1b80a3);
$parcel$export($85b88a992de89b18$exports, "CollecticonArrowLeft", () => $85b88a992de89b18$export$7c84e7446b64c8ba);
$parcel$export($85b88a992de89b18$exports, "CollecticonArrowLoop", () => $85b88a992de89b18$export$669f6b165f77f8e7);
$parcel$export($85b88a992de89b18$exports, "CollecticonArrowMove", () => $85b88a992de89b18$export$d4555cec95ec110c);
$parcel$export($85b88a992de89b18$exports, "CollecticonArrowReply", () => $85b88a992de89b18$export$4337670c5d4a46ab);
$parcel$export($85b88a992de89b18$exports, "CollecticonArrowReturn", () => $85b88a992de89b18$export$404215554288eeeb);
$parcel$export($85b88a992de89b18$exports, "CollecticonArrowRevert", () => $85b88a992de89b18$export$45ced6d791f6eabf);
$parcel$export($85b88a992de89b18$exports, "CollecticonArrowRight", () => $85b88a992de89b18$export$d30f3c1f95f9e187);
$parcel$export($85b88a992de89b18$exports, "CollecticonArrowSemiSpinCcw", () => $85b88a992de89b18$export$d33a98b6c97f9bcf);
$parcel$export($85b88a992de89b18$exports, "CollecticonArrowSemiSpinCw", () => $85b88a992de89b18$export$65b63483548348e7);
$parcel$export($85b88a992de89b18$exports, "CollecticonArrowSpinCcw", () => $85b88a992de89b18$export$1e31cff672fc44e7);
$parcel$export($85b88a992de89b18$exports, "CollecticonArrowSpinCw", () => $85b88a992de89b18$export$8b2c6a502c5588cb);
$parcel$export($85b88a992de89b18$exports, "CollecticonArrowUpLeft", () => $85b88a992de89b18$export$e18c7fe3ad046317);
$parcel$export($85b88a992de89b18$exports, "CollecticonArrowUpRight", () => $85b88a992de89b18$export$c59521707fa9adf4);
$parcel$export($85b88a992de89b18$exports, "CollecticonArrowUp", () => $85b88a992de89b18$export$44382674197c7e20);
$parcel$export($85b88a992de89b18$exports, "CollecticonBell", () => $85b88a992de89b18$export$6d44efda105760b1);
$parcel$export($85b88a992de89b18$exports, "CollecticonBlow", () => $85b88a992de89b18$export$67ac5bddd7c814c4);
$parcel$export($85b88a992de89b18$exports, "CollecticonBold", () => $85b88a992de89b18$export$bd738f28ecacfb4c);
$parcel$export($85b88a992de89b18$exports, "CollecticonBookBookmark", () => $85b88a992de89b18$export$32797ac8ba9dbc26);
$parcel$export($85b88a992de89b18$exports, "CollecticonBook", () => $85b88a992de89b18$export$f27e10809e8ad7c);
$parcel$export($85b88a992de89b18$exports, "CollecticonBrandBluesky", () => $85b88a992de89b18$export$8619dc02de403f24);
$parcel$export($85b88a992de89b18$exports, "CollecticonBrandCollecticons", () => $85b88a992de89b18$export$a7cf23fc039bccca);
$parcel$export($85b88a992de89b18$exports, "CollecticonBrandDevelopmentSeed2", () => $85b88a992de89b18$export$3fd46276f478a1b0);
$parcel$export($85b88a992de89b18$exports, "CollecticonBrandDevelopmentSeed", () => $85b88a992de89b18$export$dd983756265c5ba0);
$parcel$export($85b88a992de89b18$exports, "CollecticonBrandDropbox", () => $85b88a992de89b18$export$c9ea3985d0020928);
$parcel$export($85b88a992de89b18$exports, "CollecticonBrandFacebook", () => $85b88a992de89b18$export$834c92baa9723134);
$parcel$export($85b88a992de89b18$exports, "CollecticonBrandFlickr", () => $85b88a992de89b18$export$d8149c9a6ffff702);
$parcel$export($85b88a992de89b18$exports, "CollecticonBrandGithub", () => $85b88a992de89b18$export$68cfb6157bb0630);
$parcel$export($85b88a992de89b18$exports, "CollecticonBrandGooglePlus", () => $85b88a992de89b18$export$41b74980cc97582d);
$parcel$export($85b88a992de89b18$exports, "CollecticonBrandHumanRights", () => $85b88a992de89b18$export$eabd4486e49012ba);
$parcel$export($85b88a992de89b18$exports, "CollecticonBrandId", () => $85b88a992de89b18$export$b32786cce09df9e0);
$parcel$export($85b88a992de89b18$exports, "CollecticonBrandInstagram", () => $85b88a992de89b18$export$c85efb9e6a50791b);
$parcel$export($85b88a992de89b18$exports, "CollecticonBrandLastfm", () => $85b88a992de89b18$export$4238e97612e0856e);
$parcel$export($85b88a992de89b18$exports, "CollecticonBrandLinkedin", () => $85b88a992de89b18$export$a2e102bc44d355e3);
$parcel$export($85b88a992de89b18$exports, "CollecticonBrandMedium", () => $85b88a992de89b18$export$435e172f1afd8f3);
$parcel$export($85b88a992de89b18$exports, "CollecticonBrandSatsummit", () => $85b88a992de89b18$export$b3ee3fb5dcd7cd96);
$parcel$export($85b88a992de89b18$exports, "CollecticonBrandSkype", () => $85b88a992de89b18$export$f01132691dc82ba2);
$parcel$export($85b88a992de89b18$exports, "CollecticonBrandSlack", () => $85b88a992de89b18$export$8b71514e84056695);
$parcel$export($85b88a992de89b18$exports, "CollecticonBrandSoundcloud", () => $85b88a992de89b18$export$4eeeb34c908b13d0);
$parcel$export($85b88a992de89b18$exports, "CollecticonBrandStackoverflow", () => $85b88a992de89b18$export$cb0b56e133ef23a1);
$parcel$export($85b88a992de89b18$exports, "CollecticonBrandTumblr", () => $85b88a992de89b18$export$e582f877f685c307);
$parcel$export($85b88a992de89b18$exports, "CollecticonBrandTwitter", () => $85b88a992de89b18$export$f26b4f060f08f8f9);
$parcel$export($85b88a992de89b18$exports, "CollecticonBrandX", () => $85b88a992de89b18$export$c07c7d541b672534);
$parcel$export($85b88a992de89b18$exports, "CollecticonBrandYoutube", () => $85b88a992de89b18$export$5e55219a763bfc51);
$parcel$export($85b88a992de89b18$exports, "CollecticonBriefcase", () => $85b88a992de89b18$export$3f241c3fc4d9dd7a);
$parcel$export($85b88a992de89b18$exports, "CollecticonCalendarMinus", () => $85b88a992de89b18$export$7e0d7941fbd8a620);
$parcel$export($85b88a992de89b18$exports, "CollecticonCalendarPlus", () => $85b88a992de89b18$export$8266db1827cb2822);
$parcel$export($85b88a992de89b18$exports, "CollecticonCalendarRange", () => $85b88a992de89b18$export$16c0cbaf2c55e7b6);
$parcel$export($85b88a992de89b18$exports, "CollecticonCalendarSlot", () => $85b88a992de89b18$export$edaa4810f882e615);
$parcel$export($85b88a992de89b18$exports, "CollecticonCalendar", () => $85b88a992de89b18$export$af3433002e85528f);
$parcel$export($85b88a992de89b18$exports, "CollecticonCamera", () => $85b88a992de89b18$export$ebaef9cfe20e1737);
$parcel$export($85b88a992de89b18$exports, "CollecticonChartBars", () => $85b88a992de89b18$export$e71f7b946c7cc127);
$parcel$export($85b88a992de89b18$exports, "CollecticonChartLine", () => $85b88a992de89b18$export$51e1bcc8c9b70cf);
$parcel$export($85b88a992de89b18$exports, "CollecticonChartPie", () => $85b88a992de89b18$export$acdc8ffe67b5cfdc);
$parcel$export($85b88a992de89b18$exports, "CollecticonChevronDownSmall", () => $85b88a992de89b18$export$c99fa69b6fe4cbfa);
$parcel$export($85b88a992de89b18$exports, "CollecticonChevronDownTrailSmall", () => $85b88a992de89b18$export$d24fe4633d517542);
$parcel$export($85b88a992de89b18$exports, "CollecticonChevronDown", () => $85b88a992de89b18$export$6be9a9d30ce9b0ed);
$parcel$export($85b88a992de89b18$exports, "CollecticonChevronLeftSmall", () => $85b88a992de89b18$export$5257c06aa807f52c);
$parcel$export($85b88a992de89b18$exports, "CollecticonChevronLeftTrailSmall", () => $85b88a992de89b18$export$bd98fc092ca567ad);
$parcel$export($85b88a992de89b18$exports, "CollecticonChevronLeft", () => $85b88a992de89b18$export$87375f63e1783ecd);
$parcel$export($85b88a992de89b18$exports, "CollecticonChevronRightSmall", () => $85b88a992de89b18$export$1871f85e3a28ae2d);
$parcel$export($85b88a992de89b18$exports, "CollecticonChevronRightTrailSmall", () => $85b88a992de89b18$export$5bb5160993ff67f0);
$parcel$export($85b88a992de89b18$exports, "CollecticonChevronRight", () => $85b88a992de89b18$export$f98cf460e7941c2b);
$parcel$export($85b88a992de89b18$exports, "CollecticonChevronStepBackward", () => $85b88a992de89b18$export$61133413a12a7ef4);
$parcel$export($85b88a992de89b18$exports, "CollecticonChevronStepForward", () => $85b88a992de89b18$export$e4779f93e989d6cc);
$parcel$export($85b88a992de89b18$exports, "CollecticonChevronUpSmall", () => $85b88a992de89b18$export$66e62118032befb3);
$parcel$export($85b88a992de89b18$exports, "CollecticonChevronUpTrailSmall", () => $85b88a992de89b18$export$ef1b2d050d1d9596);
$parcel$export($85b88a992de89b18$exports, "CollecticonChevronUp", () => $85b88a992de89b18$export$cd6ea45e6c6fa795);
$parcel$export($85b88a992de89b18$exports, "CollecticonCircleExclamation", () => $85b88a992de89b18$export$f72e08a2ef494448);
$parcel$export($85b88a992de89b18$exports, "CollecticonCircleForbidden", () => $85b88a992de89b18$export$543083732c6741d9);
$parcel$export($85b88a992de89b18$exports, "CollecticonCircleInformation", () => $85b88a992de89b18$export$5ec4aa1366cd882);
$parcel$export($85b88a992de89b18$exports, "CollecticonCirclePause", () => $85b88a992de89b18$export$e356a46c6dfa0cd);
$parcel$export($85b88a992de89b18$exports, "CollecticonCirclePlayNext", () => $85b88a992de89b18$export$f251922d9c0b7d86);
$parcel$export($85b88a992de89b18$exports, "CollecticonCirclePlay", () => $85b88a992de89b18$export$b8c4b2c7e344e0c3);
$parcel$export($85b88a992de89b18$exports, "CollecticonCircleQuestion", () => $85b88a992de89b18$export$94c33b488623435e);
$parcel$export($85b88a992de89b18$exports, "CollecticonCircleRecord", () => $85b88a992de89b18$export$1d64b5b770b4b3ed);
$parcel$export($85b88a992de89b18$exports, "CollecticonCircleStop", () => $85b88a992de89b18$export$5836eb8e2e3e864d);
$parcel$export($85b88a992de89b18$exports, "CollecticonCircleTick", () => $85b88a992de89b18$export$c65898577f07616b);
$parcel$export($85b88a992de89b18$exports, "CollecticonCircleXmark", () => $85b88a992de89b18$export$6fb1bca6e16c2c94);
$parcel$export($85b88a992de89b18$exports, "CollecticonClipboardTick", () => $85b88a992de89b18$export$5a17af862a7576da);
$parcel$export($85b88a992de89b18$exports, "CollecticonClipboard", () => $85b88a992de89b18$export$b21a11de10d6bf76);
$parcel$export($85b88a992de89b18$exports, "CollecticonClockBack", () => $85b88a992de89b18$export$17345b07225e0aa);
$parcel$export($85b88a992de89b18$exports, "CollecticonClock", () => $85b88a992de89b18$export$bbbb9b7c1aff7988);
$parcel$export($85b88a992de89b18$exports, "CollecticonCode", () => $85b88a992de89b18$export$1610bcb056ae58bb);
$parcel$export($85b88a992de89b18$exports, "CollecticonCog", () => $85b88a992de89b18$export$4073c4c5b5a233d4);
$parcel$export($85b88a992de89b18$exports, "CollecticonCompass2", () => $85b88a992de89b18$export$fa207a04e28a42cb);
$parcel$export($85b88a992de89b18$exports, "CollecticonCompass", () => $85b88a992de89b18$export$6df11ed8ec8f8d62);
$parcel$export($85b88a992de89b18$exports, "CollecticonCrosshair2", () => $85b88a992de89b18$export$ec3499dc3f62d571);
$parcel$export($85b88a992de89b18$exports, "CollecticonCrosshair", () => $85b88a992de89b18$export$daacca6cce9e30d3);
$parcel$export($85b88a992de89b18$exports, "CollecticonDiscDollar", () => $85b88a992de89b18$export$23ce67b3071ee16e);
$parcel$export($85b88a992de89b18$exports, "CollecticonDiscXmark", () => $85b88a992de89b18$export$65f71275cd169acd);
$parcel$export($85b88a992de89b18$exports, "CollecticonDownload2", () => $85b88a992de89b18$export$cb9a136b7e677418);
$parcel$export($85b88a992de89b18$exports, "CollecticonDownload3", () => $85b88a992de89b18$export$2982342031c9fea6);
$parcel$export($85b88a992de89b18$exports, "CollecticonDownload", () => $85b88a992de89b18$export$70f26903e40c814d);
$parcel$export($85b88a992de89b18$exports, "CollecticonDrop", () => $85b88a992de89b18$export$d5822d1e3e781a7c);
$parcel$export($85b88a992de89b18$exports, "CollecticonEllipsisHorizontal", () => $85b88a992de89b18$export$74e5b01e82a6f5df);
$parcel$export($85b88a992de89b18$exports, "CollecticonEllipsisVertical", () => $85b88a992de89b18$export$b307b75901e71920);
$parcel$export($85b88a992de89b18$exports, "CollecticonEnvelope", () => $85b88a992de89b18$export$8f179830d10593db);
$parcel$export($85b88a992de89b18$exports, "CollecticonEqualSmall", () => $85b88a992de89b18$export$5af68724e0a1bf3d);
$parcel$export($85b88a992de89b18$exports, "CollecticonEqual", () => $85b88a992de89b18$export$35a394b139d2779b);
$parcel$export($85b88a992de89b18$exports, "CollecticonExclamationSmall", () => $85b88a992de89b18$export$d37d6805b1edaaab);
$parcel$export($85b88a992de89b18$exports, "CollecticonExpandCollapse", () => $85b88a992de89b18$export$5edd362dbec83f16);
$parcel$export($85b88a992de89b18$exports, "CollecticonExpandDownLeft", () => $85b88a992de89b18$export$2a5f2ff1590ba9f0);
$parcel$export($85b88a992de89b18$exports, "CollecticonExpandDownRight", () => $85b88a992de89b18$export$e4d1c1f093ddfc94);
$parcel$export($85b88a992de89b18$exports, "CollecticonExpandFromLeft", () => $85b88a992de89b18$export$b96e2b4e5f7775c1);
$parcel$export($85b88a992de89b18$exports, "CollecticonExpandFromRight", () => $85b88a992de89b18$export$bfc74f0b8ad1f2ce);
$parcel$export($85b88a992de89b18$exports, "CollecticonExpandTopLeft", () => $85b88a992de89b18$export$c5cb8522150f3be8);
$parcel$export($85b88a992de89b18$exports, "CollecticonExpandTopRight", () => $85b88a992de89b18$export$10a0ddbd1861a097);
$parcel$export($85b88a992de89b18$exports, "CollecticonEyeDisabled", () => $85b88a992de89b18$export$c52792559dd5fde);
$parcel$export($85b88a992de89b18$exports, "CollecticonEye", () => $85b88a992de89b18$export$5b296b74fc93300b);
$parcel$export($85b88a992de89b18$exports, "CollecticonFaceHappy", () => $85b88a992de89b18$export$baa7a52704f72315);
$parcel$export($85b88a992de89b18$exports, "CollecticonFaceSad", () => $85b88a992de89b18$export$3ca36d1b1b6880d8);
$parcel$export($85b88a992de89b18$exports, "CollecticonFactory", () => $85b88a992de89b18$export$d05ae46b0b12cd6f);
$parcel$export($85b88a992de89b18$exports, "CollecticonFence", () => $85b88a992de89b18$export$ccb23f910e5c3193);
$parcel$export($85b88a992de89b18$exports, "CollecticonFilter", () => $85b88a992de89b18$export$f153bd1599ddd890);
$parcel$export($85b88a992de89b18$exports, "CollecticonFlagPole", () => $85b88a992de89b18$export$9fcd2875a6bf0e38);
$parcel$export($85b88a992de89b18$exports, "CollecticonFlame", () => $85b88a992de89b18$export$964c15ec9e30ae83);
$parcel$export($85b88a992de89b18$exports, "CollecticonFlask", () => $85b88a992de89b18$export$5c5e312ef0488786);
$parcel$export($85b88a992de89b18$exports, "CollecticonFolder", () => $85b88a992de89b18$export$22e733acfe1431e6);
$parcel$export($85b88a992de89b18$exports, "CollecticonForm", () => $85b88a992de89b18$export$cc646d2f0b9a8ed7);
$parcel$export($85b88a992de89b18$exports, "CollecticonGauge", () => $85b88a992de89b18$export$6c64be5e42deae66);
$parcel$export($85b88a992de89b18$exports, "CollecticonGitFork", () => $85b88a992de89b18$export$476bfa1ddc2dfe7a);
$parcel$export($85b88a992de89b18$exports, "CollecticonGlobe", () => $85b88a992de89b18$export$922c85641f9f6751);
$parcel$export($85b88a992de89b18$exports, "CollecticonGovBuilding", () => $85b88a992de89b18$export$4a42f583c9418002);
$parcel$export($85b88a992de89b18$exports, "CollecticonGripHorizontal", () => $85b88a992de89b18$export$384500bdee9cfb28);
$parcel$export($85b88a992de89b18$exports, "CollecticonGripVertical", () => $85b88a992de89b18$export$686e909ad6dbb500);
$parcel$export($85b88a992de89b18$exports, "CollecticonHamburgerMenu", () => $85b88a992de89b18$export$77134c21538c4a4c);
$parcel$export($85b88a992de89b18$exports, "CollecticonHandPan", () => $85b88a992de89b18$export$89331070f6fc9967);
$parcel$export($85b88a992de89b18$exports, "CollecticonHandSwipeHorizontal", () => $85b88a992de89b18$export$90416b71b616b91);
$parcel$export($85b88a992de89b18$exports, "CollecticonHandThumbsDown", () => $85b88a992de89b18$export$84d82bc35f21d6b6);
$parcel$export($85b88a992de89b18$exports, "CollecticonHandThumbsUp", () => $85b88a992de89b18$export$ffd6616d7f2ec8c7);
$parcel$export($85b88a992de89b18$exports, "CollecticonHeading", () => $85b88a992de89b18$export$9551e39be92a9bc5);
$parcel$export($85b88a992de89b18$exports, "CollecticonHeart", () => $85b88a992de89b18$export$3094a1b9f32c68d5);
$parcel$export($85b88a992de89b18$exports, "CollecticonHouse", () => $85b88a992de89b18$export$62a58013efdd2c1a);
$parcel$export($85b88a992de89b18$exports, "CollecticonHouses", () => $85b88a992de89b18$export$72fd52d03f766e5d);
$parcel$export($85b88a992de89b18$exports, "CollecticonIsoStack", () => $85b88a992de89b18$export$b7a766f44e29e48c);
$parcel$export($85b88a992de89b18$exports, "CollecticonItalic", () => $85b88a992de89b18$export$f6547b3d6e6e28f2);
$parcel$export($85b88a992de89b18$exports, "CollecticonKeyboard", () => $85b88a992de89b18$export$bf1e1a02918ee573);
$parcel$export($85b88a992de89b18$exports, "CollecticonLayoutColumn2X", () => $85b88a992de89b18$export$4c6f701ae5fe9073);
$parcel$export($85b88a992de89b18$exports, "CollecticonLayoutGrid2X2", () => $85b88a992de89b18$export$af3a5aeff000074d);
$parcel$export($85b88a992de89b18$exports, "CollecticonLayoutGrid3X3", () => $85b88a992de89b18$export$3b51a6b9653487d2);
$parcel$export($85b88a992de89b18$exports, "CollecticonLayoutRow2X", () => $85b88a992de89b18$export$ae59d452b696795b);
$parcel$export($85b88a992de89b18$exports, "CollecticonLeaf", () => $85b88a992de89b18$export$b64d86384c92f1e0);
$parcel$export($85b88a992de89b18$exports, "CollecticonLink", () => $85b88a992de89b18$export$c1c6fe15475bbb7e);
$parcel$export($85b88a992de89b18$exports, "CollecticonListNumbered", () => $85b88a992de89b18$export$8eec6b150ddf7426);
$parcel$export($85b88a992de89b18$exports, "CollecticonList", () => $85b88a992de89b18$export$8e6bd23949fc26d0);
$parcel$export($85b88a992de89b18$exports, "CollecticonLock2Open", () => $85b88a992de89b18$export$70cca5edf1a67180);
$parcel$export($85b88a992de89b18$exports, "CollecticonLock2", () => $85b88a992de89b18$export$d5b6665210f0a539);
$parcel$export($85b88a992de89b18$exports, "CollecticonLockOpen", () => $85b88a992de89b18$export$247536f07b7c3b83);
$parcel$export($85b88a992de89b18$exports, "CollecticonLock", () => $85b88a992de89b18$export$5c8bd75215c9ed1f);
$parcel$export($85b88a992de89b18$exports, "CollecticonLogin", () => $85b88a992de89b18$export$1692611780ac32d);
$parcel$export($85b88a992de89b18$exports, "CollecticonLogout", () => $85b88a992de89b18$export$2d4c748bd12d78e0);
$parcel$export($85b88a992de89b18$exports, "CollecticonMagnifierLeft", () => $85b88a992de89b18$export$b2a4ca5137e627ff);
$parcel$export($85b88a992de89b18$exports, "CollecticonMagnifierMinus", () => $85b88a992de89b18$export$2b187ab490e92c13);
$parcel$export($85b88a992de89b18$exports, "CollecticonMagnifierPlus", () => $85b88a992de89b18$export$aef499440d07757c);
$parcel$export($85b88a992de89b18$exports, "CollecticonMagnifierRight", () => $85b88a992de89b18$export$89ad07d969809ef0);
$parcel$export($85b88a992de89b18$exports, "CollecticonMap", () => $85b88a992de89b18$export$a85a53f46ea5d4e1);
$parcel$export($85b88a992de89b18$exports, "CollecticonMarker", () => $85b88a992de89b18$export$ddb0bcf29e4fc4bb);
$parcel$export($85b88a992de89b18$exports, "CollecticonMedal", () => $85b88a992de89b18$export$41cf3a9d8250975e);
$parcel$export($85b88a992de89b18$exports, "CollecticonMinusSmall", () => $85b88a992de89b18$export$448b293f3d913b8a);
$parcel$export($85b88a992de89b18$exports, "CollecticonMinus", () => $85b88a992de89b18$export$8b95d566fbd56482);
$parcel$export($85b88a992de89b18$exports, "CollecticonMobilePhone", () => $85b88a992de89b18$export$40baeeb0bb7c9f71);
$parcel$export($85b88a992de89b18$exports, "CollecticonOptionsTick", () => $85b88a992de89b18$export$d7458318da00be20);
$parcel$export($85b88a992de89b18$exports, "CollecticonPageCog", () => $85b88a992de89b18$export$c5e5312dcf5a204f);
$parcel$export($85b88a992de89b18$exports, "CollecticonPageLabel", () => $85b88a992de89b18$export$4de7d3a780aa7d4b);
$parcel$export($85b88a992de89b18$exports, "CollecticonPageLockOpen", () => $85b88a992de89b18$export$37ce21e1ba043044);
$parcel$export($85b88a992de89b18$exports, "CollecticonPagePlus", () => $85b88a992de89b18$export$505d1154312c1f4d);
$parcel$export($85b88a992de89b18$exports, "CollecticonPageTick", () => $85b88a992de89b18$export$4a8a225852a3176);
$parcel$export($85b88a992de89b18$exports, "CollecticonPageUp", () => $85b88a992de89b18$export$63c83462b6ec5fb6);
$parcel$export($85b88a992de89b18$exports, "CollecticonPage", () => $85b88a992de89b18$export$c04e66d9f370f139);
$parcel$export($85b88a992de89b18$exports, "CollecticonPages", () => $85b88a992de89b18$export$509fad11b885abb0);
$parcel$export($85b88a992de89b18$exports, "CollecticonPencil", () => $85b88a992de89b18$export$b8f31e9a5cf17074);
$parcel$export($85b88a992de89b18$exports, "CollecticonPi", () => $85b88a992de89b18$export$20df3a4d38f4449c);
$parcel$export($85b88a992de89b18$exports, "CollecticonPicture", () => $85b88a992de89b18$export$c273953023f3b0d9);
$parcel$export($85b88a992de89b18$exports, "CollecticonPilcrow", () => $85b88a992de89b18$export$1f35cd9a970948ef);
$parcel$export($85b88a992de89b18$exports, "CollecticonPlusSmall", () => $85b88a992de89b18$export$3a9f56a1d1f9a714);
$parcel$export($85b88a992de89b18$exports, "CollecticonPlus", () => $85b88a992de89b18$export$889d6f1a30ea74d6);
$parcel$export($85b88a992de89b18$exports, "CollecticonPopDown", () => $85b88a992de89b18$export$37ff0821c075ffdb);
$parcel$export($85b88a992de89b18$exports, "CollecticonPopUp", () => $85b88a992de89b18$export$f4bc043c492a6c31);
$parcel$export($85b88a992de89b18$exports, "CollecticonPrinter", () => $85b88a992de89b18$export$cabb19bc45ece1c2);
$parcel$export($85b88a992de89b18$exports, "CollecticonProgressTickHigh", () => $85b88a992de89b18$export$1a26968bd5e528c1);
$parcel$export($85b88a992de89b18$exports, "CollecticonProgressTickLow", () => $85b88a992de89b18$export$bf479e9952d124c2);
$parcel$export($85b88a992de89b18$exports, "CollecticonProgressTickMedium", () => $85b88a992de89b18$export$e936722be7af186a);
$parcel$export($85b88a992de89b18$exports, "CollecticonQuoteLeft", () => $85b88a992de89b18$export$cc12b47c9c533761);
$parcel$export($85b88a992de89b18$exports, "CollecticonQuoteRight", () => $85b88a992de89b18$export$31a206cffc6bcef8);
$parcel$export($85b88a992de89b18$exports, "CollecticonResizeCenterHorizontal", () => $85b88a992de89b18$export$8aa06688994ea65a);
$parcel$export($85b88a992de89b18$exports, "CollecticonResizeCenterVertical", () => $85b88a992de89b18$export$ce07c1505fc240fa);
$parcel$export($85b88a992de89b18$exports, "CollecticonResizeIn", () => $85b88a992de89b18$export$4ec862b3067b2249);
$parcel$export($85b88a992de89b18$exports, "CollecticonResizeOut", () => $85b88a992de89b18$export$3c2cb1e70bb7ddf8);
$parcel$export($85b88a992de89b18$exports, "CollecticonRoad", () => $85b88a992de89b18$export$62497cdf6d0d1934);
$parcel$export($85b88a992de89b18$exports, "CollecticonRock", () => $85b88a992de89b18$export$a7789793f3c2c8cc);
$parcel$export($85b88a992de89b18$exports, "CollecticonRssFeed", () => $85b88a992de89b18$export$67a54af4fd4d9a2e);
$parcel$export($85b88a992de89b18$exports, "CollecticonShare2", () => $85b88a992de89b18$export$611ca684c7a93fe1);
$parcel$export($85b88a992de89b18$exports, "CollecticonShare", () => $85b88a992de89b18$export$7cffb2c8835f2a25);
$parcel$export($85b88a992de89b18$exports, "CollecticonShrinkToLeft", () => $85b88a992de89b18$export$72c7f3691d5e45db);
$parcel$export($85b88a992de89b18$exports, "CollecticonShrinkToRight", () => $85b88a992de89b18$export$d11c632cbde2be34);
$parcel$export($85b88a992de89b18$exports, "CollecticonSignDanger", () => $85b88a992de89b18$export$3b59d4afb984fe49);
$parcel$export($85b88a992de89b18$exports, "CollecticonSlidersHorizontal", () => $85b88a992de89b18$export$1ff70e20de9defba);
$parcel$export($85b88a992de89b18$exports, "CollecticonSlidersVertical", () => $85b88a992de89b18$export$5363c08acc839f14);
$parcel$export($85b88a992de89b18$exports, "CollecticonSortAsc", () => $85b88a992de89b18$export$7306271c30123976);
$parcel$export($85b88a992de89b18$exports, "CollecticonSortDesc", () => $85b88a992de89b18$export$d51a5d41a86d4b55);
$parcel$export($85b88a992de89b18$exports, "CollecticonSortNone", () => $85b88a992de89b18$export$24bdafc250bc28ef);
$parcel$export($85b88a992de89b18$exports, "CollecticonSort", () => $85b88a992de89b18$export$ee66e65f9bacd0b7);
$parcel$export($85b88a992de89b18$exports, "CollecticonSpark", () => $85b88a992de89b18$export$f0833711cb9f68ce);
$parcel$export($85b88a992de89b18$exports, "CollecticonSpeechBalloon", () => $85b88a992de89b18$export$154cb3948df3efa1);
$parcel$export($85b88a992de89b18$exports, "CollecticonSquareSmall", () => $85b88a992de89b18$export$b347ffcee0e953cc);
$parcel$export($85b88a992de89b18$exports, "CollecticonSquare", () => $85b88a992de89b18$export$ade582b79af72d78);
$parcel$export($85b88a992de89b18$exports, "CollecticonStar", () => $85b88a992de89b18$export$75f6b5de4cbd2386);
$parcel$export($85b88a992de89b18$exports, "CollecticonSteam", () => $85b88a992de89b18$export$2bdb2cf27f0a265);
$parcel$export($85b88a992de89b18$exports, "CollecticonStream", () => $85b88a992de89b18$export$18836a3de4fad05d);
$parcel$export($85b88a992de89b18$exports, "CollecticonSubscript2", () => $85b88a992de89b18$export$2eb1b0b2d752ea4b);
$parcel$export($85b88a992de89b18$exports, "CollecticonSubscript", () => $85b88a992de89b18$export$b147170bf0ac6406);
$parcel$export($85b88a992de89b18$exports, "CollecticonSuperscript2", () => $85b88a992de89b18$export$831d605561b8cca5);
$parcel$export($85b88a992de89b18$exports, "CollecticonSuperscript", () => $85b88a992de89b18$export$3a4c80bfe15d601a);
$parcel$export($85b88a992de89b18$exports, "CollecticonSwapHorizontal", () => $85b88a992de89b18$export$8702548ed1d7ac29);
$parcel$export($85b88a992de89b18$exports, "CollecticonSwapVertical", () => $85b88a992de89b18$export$4a3cdaf8654d6ecf);
$parcel$export($85b88a992de89b18$exports, "CollecticonTableAddColumn", () => $85b88a992de89b18$export$7f7b28202d8c7331);
$parcel$export($85b88a992de89b18$exports, "CollecticonTableAddRow", () => $85b88a992de89b18$export$ca16e8c9b654c9e9);
$parcel$export($85b88a992de89b18$exports, "CollecticonTableSubtractColumn", () => $85b88a992de89b18$export$5784f2a304a439e3);
$parcel$export($85b88a992de89b18$exports, "CollecticonTableSubtractRow", () => $85b88a992de89b18$export$51fa6d51058f66a4);
$parcel$export($85b88a992de89b18$exports, "CollecticonTable", () => $85b88a992de89b18$export$c69ace2e6416b89c);
$parcel$export($85b88a992de89b18$exports, "CollecticonTag", () => $85b88a992de89b18$export$7b73804de18dac8e);
$parcel$export($85b88a992de89b18$exports, "CollecticonTarget", () => $85b88a992de89b18$export$40d1ddcefe169242);
$parcel$export($85b88a992de89b18$exports, "CollecticonTextBlock", () => $85b88a992de89b18$export$3b8ef319a6c5f131);
$parcel$export($85b88a992de89b18$exports, "CollecticonTickSmall", () => $85b88a992de89b18$export$7679025d661a5f99);
$parcel$export($85b88a992de89b18$exports, "CollecticonTick", () => $85b88a992de89b18$export$6a564a3c64a0c770);
$parcel$export($85b88a992de89b18$exports, "CollecticonTrashBin", () => $85b88a992de89b18$export$5918e8962b6636e9);
$parcel$export($85b88a992de89b18$exports, "CollecticonTriangleDownSmall", () => $85b88a992de89b18$export$f7790cfaf03c8a87);
$parcel$export($85b88a992de89b18$exports, "CollecticonTriangleDown", () => $85b88a992de89b18$export$d0e1eaac53e25db1);
$parcel$export($85b88a992de89b18$exports, "CollecticonTriangleLeftSmall", () => $85b88a992de89b18$export$668e2789cbc708d7);
$parcel$export($85b88a992de89b18$exports, "CollecticonTriangleLeft", () => $85b88a992de89b18$export$1974c1a52230d9bf);
$parcel$export($85b88a992de89b18$exports, "CollecticonTriangleRightSmall", () => $85b88a992de89b18$export$501ada128b32fc9e);
$parcel$export($85b88a992de89b18$exports, "CollecticonTriangleRight", () => $85b88a992de89b18$export$79a26f2c80e33f90);
$parcel$export($85b88a992de89b18$exports, "CollecticonTriangleUpSmall", () => $85b88a992de89b18$export$18dba1b5898bbfb1);
$parcel$export($85b88a992de89b18$exports, "CollecticonTriangleUp", () => $85b88a992de89b18$export$9bef3663bbeb4db3);
$parcel$export($85b88a992de89b18$exports, "CollecticonTumblrReblog", () => $85b88a992de89b18$export$3c99c824037eed46);
$parcel$export($85b88a992de89b18$exports, "CollecticonUfo", () => $85b88a992de89b18$export$bf9bd1a6e1a39cb5);
$parcel$export($85b88a992de89b18$exports, "CollecticonUnderline", () => $85b88a992de89b18$export$193ca764ca13a0c5);
$parcel$export($85b88a992de89b18$exports, "CollecticonUpload2", () => $85b88a992de89b18$export$6ec63552fd597a0c);
$parcel$export($85b88a992de89b18$exports, "CollecticonUpload3", () => $85b88a992de89b18$export$1a820bf437484746);
$parcel$export($85b88a992de89b18$exports, "CollecticonUpload", () => $85b88a992de89b18$export$65f5fd8d1a192873);
$parcel$export($85b88a992de89b18$exports, "CollecticonUserGroup", () => $85b88a992de89b18$export$de7094d8f3d0eff8);
$parcel$export($85b88a992de89b18$exports, "CollecticonUser", () => $85b88a992de89b18$export$24f630ce129477b6);
$parcel$export($85b88a992de89b18$exports, "CollecticonUsers", () => $85b88a992de89b18$export$7c42224f1c8d83b0);
$parcel$export($85b88a992de89b18$exports, "CollecticonWay", () => $85b88a992de89b18$export$25372d620e7a1b0b);
$parcel$export($85b88a992de89b18$exports, "CollecticonWrench", () => $85b88a992de89b18$export$db99d8e121938012);
$parcel$export($85b88a992de89b18$exports, "CollecticonXmarkSmall", () => $85b88a992de89b18$export$4cca98ab4f54f41d);
$parcel$export($85b88a992de89b18$exports, "CollecticonXmark", () => $85b88a992de89b18$export$eeb267586df04918);
$parcel$export($85b88a992de89b18$exports, "version", () => $85b88a992de89b18$export$83d89fbfd8236492);

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



"use strict";
"use client";
const { useRecipeResult: $6b00e4b576c923cf$var$useRecipeResult, PropsProvider: $6b00e4b576c923cf$var$PropsProvider } = (0, $4917af36de141b89$export$e99ac154c18649c5)({
    key: "icon"
});
const $6b00e4b576c923cf$export$f04a61298a47a40f = $acw62.forwardRef(function Icon2(props, ref) {
    const { styles: styles, className: className, props: otherProps } = $6b00e4b576c923cf$var$useRecipeResult({
        asChild: !props.as,
        ...props
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $ce363bdb8a43b242$export$7cd122d781af9fa4).svg, {
        ref: ref,
        focusable: false,
        "aria-hidden": "true",
        ...otherProps,
        css: [
            styles,
            props.css
        ],
        className: (0, $7b2d6a34cc679515$export$a274e22fb40f762e)(className, props.className)
    });
});
const $6b00e4b576c923cf$export$36c42a57bca547a8 = $6b00e4b576c923cf$var$PropsProvider;


/**
 * Creates a collecticons component.
 *
 * @param {function} creatorFn Function to create the collecticon.
 */ function $85b88a992de89b18$export$7209ba2b0568490(creatorFn, iconSvgProps = {}) {
    const CollecticonChakra = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
        const { title: title, fontSize: fontSize, meaningful: meaningful, ...rest } = props;
        const s = typeof fontSize !== "undefined" ? fontSize : "1rem";
        const iconProps = {
            title: title,
            width: s,
            height: s,
            fill: "currentColor",
            role: "img",
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg",
            // By default icons are rendered decoratively (aria hidden true) Using
            // "meaningful" prop (together with a descriptive title) will enable the
            // icon to be understood by assistive technologies.
            "aria-hidden": !meaningful,
            ...iconSvgProps,
            ...rest
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6b00e4b576c923cf$export$f04a61298a47a40f), {
            ...iconProps,
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", null, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), creatorFn(iconProps)));
    });
    CollecticonChakra.displayName = "CollecticonChakra";
    return CollecticonChakra;
}
const $85b88a992de89b18$export$fb146e0ebe1880c9 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M4 12v1h8v-1h1V4h-1V3H4v1H3v8zm3-5h2v2H7zm9 5v4h-4v-1H4v1H0v-4h1V4H0V0h4v1h8V0h4v4h-1v8z"
    })));
const $85b88a992de89b18$export$4d7881fd068b9554 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M12 12H5.414l9.607-9.607L13.607.979 4 10.586V4H2v10h10z"
    })));
const $85b88a992de89b18$export$ff31736f1164b93d = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M12 4v6.586L2.393.979.979 2.393 10.586 12H4v2h10V4z"
    })));
const $85b88a992de89b18$export$bab927fca1b80a3 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M13.586 7.586 9 12.172V0H7v12.172L2.414 7.586 1 9l7 7 7-7z"
    })));
const $85b88a992de89b18$export$7c84e7446b64c8ba = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8.414 13.586 3.828 9H16V7H3.828l4.586-4.586L7 1 0 8l7 7z"
    })));
const $85b88a992de89b18$export$669f6b165f77f8e7 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M6 4H3.528q.112-.121.228-.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756A5.97 5.97 0 0 1 14 8h2a8 8 0 0 0-8-8 7.98 7.98 0 0 0-6 2.709V0H0v6h6zm4 8h2.472q-.112.122-.228.244C11.109 13.375 9.603 14 8 14s-3.109-.625-4.244-1.756A5.97 5.97 0 0 1 2 8H0a8 8 0 0 0 8 8 7.98 7.98 0 0 0 6-2.709V16h2v-6h-6z"
    })));
const $85b88a992de89b18$export$d4555cec95ec110c = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M7.5 1.924 5.773 3.651l-.712-.712L8 0l2.939 2.939-.712.712L8.5 1.924V7.5h5.576l-1.727-1.727.712-.712L16 8l-2.939 2.939-.712-.712L14.076 8.5H8.5v5.576l1.727-1.727.712.712L8 16l-2.939-2.939.712-.712L7.5 14.076V8.5H1.924l1.727 1.727-.712.712L0 8l2.939-2.939.712.712L1.924 7.5H7.5z"
    })));
const $85b88a992de89b18$export$4337670c5d4a46ab = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M16 11a4 4 0 0 0-4-4H3.828l2.586-2.586L5 3 0 8l5 5 1.414-1.414L3.828 9H12a2 2 0 0 1 2 2v3h2z"
    })));
const $85b88a992de89b18$export$404215554288eeeb = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M14.238 5.762A5.96 5.96 0 0 0 10 4H3.828l2.586-2.586L5 0 0 5l5 5 1.414-1.414L3.828 6H10c1.063 0 2.066.418 2.824 1.176S14 8.937 14 10s-.418 2.066-1.176 2.824A3.97 3.97 0 0 1 10 14H6v2h4c1.597 0 3.102-.626 4.238-1.762S16 11.597 16 10s-.626-3.102-1.762-4.238"
    })));
const $85b88a992de89b18$export$45ced6d791f6eabf = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M0 0h2v2.709A7.98 7.98 0 0 1 8 0a8 8 0 0 1 8 8 8 8 0 0 1-8 8 8 8 0 0 1-8-8h2c0 1.603.624 3.11 1.756 4.244A5.96 5.96 0 0 0 8 14a5.97 5.97 0 0 0 4.244-1.756A5.97 5.97 0 0 0 14 8a5.97 5.97 0 0 0-1.756-4.244A5.97 5.97 0 0 0 8 2a5.97 5.97 0 0 0-4.472 2H6v2H0zm10.784 4.916 1.485 1.337L7.1 12 3.856 8.794l1.406-1.422 1.754 1.731z"
    })));
const $85b88a992de89b18$export$d30f3c1f95f9e187 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M7.586 2.414 12.172 7H0v2h12.172l-4.586 4.586L9 15l7-7-7-7z"
    })));
const $85b88a992de89b18$export$d33a98b6c97f9bcf = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M0 0v6h6V4H3.528q.11-.127.228-.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756C13.375 4.891 14 6.397 14 8s-.625 3.109-1.756 4.244A5.97 5.97 0 0 1 8 14v2c4.419 0 8-3.581 8-8s-3.581-8-8-8a7.98 7.98 0 0 0-6 2.709V0z"
    })));
const $85b88a992de89b18$export$65b63483548348e7 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M14 0v2.709A7.98 7.98 0 0 0 8 0C3.581 0 0 3.581 0 8s3.581 8 8 8v-2a5.97 5.97 0 0 1-4.244-1.756C2.625 11.109 2 9.603 2 8s.625-3.109 1.756-4.244C4.891 2.625 6.397 2 8 2a5.97 5.97 0 0 1 4.472 2H10v2h6V0z"
    })));
const $85b88a992de89b18$export$1e31cff672fc44e7 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M0 0v6h6V4H3.528q.11-.127.228-.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756C13.375 4.891 14 6.397 14 8s-.625 3.109-1.756 4.244C11.109 13.375 9.603 14 8 14s-3.112-.622-4.244-1.756S2 9.603 2 8H0c0 4.419 3.581 8 8 8s8-3.581 8-8-3.581-8-8-8a7.98 7.98 0 0 0-6 2.709V0z"
    })));
const $85b88a992de89b18$export$8b2c6a502c5588cb = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M14 0v2.709A7.98 7.98 0 0 0 8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8h-2c0 1.603-.625 3.109-1.756 4.244S9.603 14 8 14s-3.109-.625-4.244-1.756C2.625 11.109 2 9.603 2 8s.625-3.109 1.756-4.244C4.891 2.625 6.397 2 8 2a5.97 5.97 0 0 1 4.472 2H10v2h6V0z"
    })));
const $85b88a992de89b18$export$e18c7fe3ad046317 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M4 12V5.414l9.607 9.607 1.414-1.414L5.414 4H12V2H2v10z"
    })));
const $85b88a992de89b18$export$c59521707fa9adf4 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M4 4h6.586L.979 13.607l1.414 1.414L12 5.414V12h2V2H4z"
    })));
const $85b88a992de89b18$export$44382674197c7e20 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M2.414 8.414 7 3.828V16h2V3.828l4.586 4.586L15 7 8 0 1 7z"
    })));
const $85b88a992de89b18$export$6d44efda105760b1 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M13 9V6.5c0-2.306-1.759-4.222-4-4.472V1.5a1 1 0 1 0-2 0v.528c-2.241.25-4 2.166-4 4.472V9c0 1.103-.897 2-2 2v2h14v-2c-1.103 0-2-.897-2-2m-5 6.5c.931 0 1.716-.638 1.938-1.5H6.062A2 2 0 0 0 8 15.5"
    })));
const $85b88a992de89b18$export$67ac5bddd7c814c4 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8 3a3.001 3.001 0 0 0-6 0h2c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1H0v2h5c1.656 0 3-1.344 3-3m4-2a4 4 0 0 0-4 4v1h2V5c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2H1v2h11.5v-.031A4.001 4.001 0 0 0 12 1m-3 9H2v2h7c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1H6a3.001 3.001 0 0 0 6 0c0-1.656-1.344-3-3-3"
    })));
const $85b88a992de89b18$export$bd738f28ecacfb4c = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M9 1H3v14h6a4.001 4.001 0 0 0 2.645-7A4.001 4.001 0 0 0 9 1M8 9a2 2 0 0 1 0 4H6V9zm0-6a2 2 0 0 1 0 4H6V3z"
    })));
const $85b88a992de89b18$export$32797ac8ba9dbc26 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M5 12h9V0H9v6L7 4 5 6V0H4C2.9 0 2 .9 2 2v12c0 1.1.9 2 2 2h10v-2H5c-.6 0-1-.4-1-1s.4-1 1-1"
    })));
const $85b88a992de89b18$export$f27e10809e8ad7c = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M5 12h9V0H4C2.9 0 2 .9 2 2v12c0 1.1.9 2 2 2h10v-2H5c-.6 0-1-.4-1-1s.4-1 1-1M5 2h7v2H5z"
    })));
const $85b88a992de89b18$export$8619dc02de403f24 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M5.304 15.028c-.996.112-1.699-.432-2.397-1.038-.999-.867-1.615-2.159-.782-3.171.807-.98 2.412-1.22 2.412-1.22s-1.957.258-3.175-.826C.74 8.22.392 7.497.305 6.66.194 5.584.013 3.383 0 2.57c-.014-.918.335-1.533.941-1.6C2.394.808 4.1 2.175 5.757 4.195 7.369 6.159 8 7.548 8 7.548s.631-1.389 2.243-3.353C11.9 2.175 13.606.808 15.058.97c.607.067.956.682.942 1.6-.013.813-.194 3.014-.305 4.09-.087.837-.435 1.56-1.056 2.113-1.219 1.084-3.176.826-3.176.826s1.605.24 2.412 1.22c.833 1.012.217 2.304-.782 3.171-.698.606-1.401 1.15-2.397 1.038C8.883 14.825 8 11.448 8 11.448s-.883 3.377-2.696 3.58"
    })));
const $85b88a992de89b18$export$a7cf23fc039bccca = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M12.042 0h-8v2h8zM10.87 11.828C10.114 12.584 9.111 13 8.042 13s-2.072-.416-2.828-1.172S4.042 10.069 4.042 9s.416-2.072 1.172-2.828S6.973 5 8.042 5s2.072.416 2.828 1.172A4 4 0 0 1 11.917 8h2.041a6 6 0 1 0 0 2h-2.041a4 4 0 0 1-1.047 1.828"
    })));
const $85b88a992de89b18$export$3fd46276f478a1b0 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M9.053 13.581c-.003-.322.084-.6.219-.891-.288.253-.403.541-.506.931.028-.456.25-3.45.25-3.6.766-2.188.425-8.722 1.4-9.534C9.291.691 8.913 1.841 8.55 2.753 8.194 1.681 8.475 1 7.294.625c.944.8.756 1.491.95 2.594-.566-.734-.391-1.65-1.041-2.4-.184-.191-.797-.657-.797-.657 0 .028.491 1.009.581 1.528.091.519.306 1.556.275 1.938.079 2.119.613 4.172.979 6.25.059.353.244 1.391.244 1.391l.04.431c-.066-.284-.125-.541-.163-.65-.106-.312-.366-1.103-.428-1.431-.89-1.832-2.518-5.419-4.693-5.95C4.475 4.763 5.803 6.206 6.1 7.6c-.663-.931-3.269-2.919-4.328-3.644 1.997 2.072 3.6 4.219 5.337 6.522.503.653 1.131 1.978 1.178 2.278.034.222.075 1.05.1 1.559-.972-2.344-1.506-3.534-3.297-4.587-.306-.162-1.256-.491-1.256-.491.431.475.959.5 1.353 1.166-.815-.534-1.662-.628-2.593-.659 2.991 1.547 4.606 1.978 5.616 4.95.081.487-.041.856-.032 1.306h.669c-.003-.316.003-.616 0-.678.031-.206.041-.831.131-1.022.312-.794.819-1.169 1.525-1.631-.641.206-.962.128-1.45.912m2.944-7.003c-.247.234-.978 1.162-.978 1.162.044-1.312.372-2.719 1.209-3.7-1.163.762-1.822 2.644-2.125 3.794-.119.463-1.497 3.144-.856 4.584.125-.525.422-1.038.75-1.487.153-.203.794-1.228 1.438-2.688.566-1.469 1.491-2.328 2.8-3.056-.985.151-1.548.719-2.238 1.391"
    })));
const $85b88a992de89b18$export$dd983756265c5ba0 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M15 0H1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h7.178c-.009-.45.113-.819.031-1.306-1.009-2.972-2.625-3.403-5.616-4.95.931.031 1.778.125 2.594.659-.393-.665-.921-.69-1.353-1.165 0 0 .95.328 1.256.491 1.791 1.053 2.325 2.244 3.297 4.587-.025-.509-.066-1.337-.1-1.559-.047-.3-.675-1.625-1.178-2.278-1.737-2.303-3.341-4.45-5.338-6.522C2.831 4.681 5.438 6.669 6.1 7.6c-.297-1.394-1.625-2.837-2.859-3.931 2.175.531 3.803 4.119 4.693 5.95.062.328.322 1.119.428 1.431.038.109.097.366.163.65l-.041-.431S8.3 10.231 8.24 9.878c-.366-2.078-.9-4.131-.978-6.25.031-.381-.184-1.419-.275-1.938S6.406.19 6.406.162c0 0 .613.466.797.656.65.75.475 1.666 1.041 2.4-.194-1.102-.006-1.793-.95-2.593 1.181.375.9 1.056 1.256 2.128.363-.913.741-2.062 1.866-2.266-.975.812-.634 7.347-1.4 9.534 0 .15-.222 3.144-.25 3.6.103-.391.219-.678.506-.931-.134.291-.222.569-.219.891.488-.784.809-.706 1.45-.913-.706.462-1.212.837-1.525 1.631-.091.191-.1.816-.131 1.022.003.062-.003.359 0 .675H15a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1m-3.566 8.244c-.644 1.459-1.284 2.484-1.438 2.688-.328.45-.625.962-.75 1.488-.641-1.441.738-4.122.856-4.584.303-1.15.962-3.031 2.125-3.794-.837.981-1.166 2.387-1.209 3.7 0 0 .731-.928.978-1.162.691-.672 1.253-1.241 2.238-1.391-1.309.727-2.234 1.586-2.8 3.055"
    })));
const $85b88a992de89b18$export$c9ea3985d0020928 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8.011 3.76 4.005 6.317 8.01 8.874 4.005 11.43 0 8.852l4.005-2.557L0 3.76l4.005-2.557zm-4.027 8.48 4.005-2.557 4.005 2.557-4.005 2.557zm4.027-3.388 4.005-2.557L8.011 3.76l3.984-2.557L16 3.76l-4.005 2.557L16 8.874l-4.005 2.557z"
    })));
const $85b88a992de89b18$export$834c92baa9723134 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M15.117 0H.883A.883.883 0 0 0 0 .883v14.234c0 .488.395.883.883.883h7.664V9.812H6.469V7.391h2.078V5.608c0-2.067 1.262-3.192 3.106-3.192.883 0 1.642.066 1.863.095v2.16l-1.271.001c-1.003 0-1.197.477-1.197 1.176v1.543h2.398l-.312 2.422h-2.086V16h4.07a.88.88 0 0 0 .882-.883V.883A.883.883 0 0 0 15.117 0"
    })));
const $85b88a992de89b18$export$d8149c9a6ffff702 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M0 8a3.5 3.5 0 1 0 7 0 3.5 3.5 0 0 0-7 0m9 0a3.5 3.5 0 1 0 7 0 3.5 3.5 0 0 0-7 0"
    })));
const $85b88a992de89b18$export$68cfb6157bb0630 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M7.999 0a8 8 0 0 0-2.528 15.591c.4.073.546-.174.546-.386 0-.19-.007-.693-.011-1.361-2.225.483-2.695-1.072-2.695-1.072-.364-.924-.888-1.17-.888-1.17-.726-.496.055-.486.055-.486.803.057 1.225.824 1.225.824.714 1.223 1.872.87 2.328.665.073-.517.279-.87.508-1.069-1.776-.202-3.644-.888-3.644-3.954 0-.873.312-1.587.823-2.147-.081-.202-.356-1.016.08-2.117 0 0 .672-.215 2.2.82A7.7 7.7 0 0 1 8 3.869a7.7 7.7 0 0 1 2.003.269c1.527-1.035 2.198-.82 2.198-.82.436 1.101.162 1.915.08 2.117.513.559.822 1.273.822 2.147 0 3.073-1.87 3.75-3.653 3.948.287.247.543.735.543 1.481 0 1.069-.01 1.932-.01 2.195 0 .214.144.463.55.385A8 8 0 0 0 7.999 0",
        clipRule: "evenodd"
    })));
const $85b88a992de89b18$export$41b74980cc97582d = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M14.544 7.272V5.816h-1.456v1.456h-1.453v1.453h1.456v1.456h1.459V8.725H16V7.272zm-9.453 0v1.747h2.891c-.116.75-.872 2.197-2.887 2.197-1.737 0-3.156-1.441-3.156-3.216s1.416-3.216 3.153-3.216c.991 0 1.653.422 2.031.784L8.504 4.24c-.888-.831-2.038-1.331-3.41-1.331a5.09 5.09 0 1 0-.003 10.182c2.941 0 4.887-2.066 4.887-4.975a4.7 4.7 0 0 0-.081-.844z"
    })));
const $85b88a992de89b18$export$eabd4486e49012ba = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M7.734 0c.334.184 1.469.938 1.469 2.297 0 1.203-1.941 4.791-1.188 5.722l4.812-6s1.197 1.456.478 2.688c-.747 1.281-2.588 2.781-3.325 3.897-.456.69-.234 1.059-.234 1.059l5.834-3.194s.469 1.391-.641 2.391c-1.172 1.056-3.931 1.475-3.931 2.575h4.006s-.409 1.216-1.184 1.384c-.684.15-2.144-.247-2.831.372C10.271 13.847 9.456 16 7.015 16c-1.641 0-2.912-1.184-3.703-2.738-.913-1.797-1.938-2.663-2.991-2.881 0 0 .575-1.359 2.088-1.359 2.081 0 2.972 3.409 4.544 3.409.453 0 .934-.234.934-.903 0-.725-1.044-1.325-1.334-1.525-.691-.481-1.244-1.247-.888-2.531z"
    })));
const $85b88a992de89b18$export$b32786cce09df9e0 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M0 14.462h2.518V4.963H0zM0 3.83h2.518V1.538H0zm15.756 1.769a5.7 5.7 0 0 0-.916-2.074 4.24 4.24 0 0 0-2.189-1.629q-.794-.261-1.988-.279H5.124v12.845h5.538q2.913 0 4.308-2.396Q16 10.288 16 7.725q0-1.01-.244-2.126m-2.894 4.758q-.75 1.874-2.653 1.874H7.73V3.847h2.479q1.833 0 2.448 1.05t.615 3.011q0 1.422-.41 2.449"
    })));
const $85b88a992de89b18$export$c85efb9e6a50791b = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8m0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2m3-10H5C2.237 0 0 2.237 0 5v6c0 2.762 2.237 5 5 5h6a5 5 0 0 0 5-5V5c0-2.763-2.238-5-5-5m3 11c0 1.653-1.347 3-3 3H5c-1.653 0-3-1.347-3-3V5c0-1.653 1.347-3 3-3h6c1.653 0 3 1.347 3 3zm-2-8a1 1 0 1 0 0 2 1 1 0 1 0 0-2"
    })));
const $85b88a992de89b18$export$4238e97612e0856e = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M3.997 12.445c2.072 0 3.059-.972 3.059-.972L6.469 9.88s-.953 1.062-2.381 1.062c-1.266 0-2.162-1.1-2.162-2.859 0-2.253 1.138-3.059 2.253-3.059 1.613 0 2.125 1.044 2.566 2.381l.588 1.831c.588 1.778 1.688 3.206 4.856 3.206 2.272 0 3.812-.697 3.812-2.528 0-1.484-.844-2.253-2.419-2.622l-1.172-.256c-.806-.184-1.044-.512-1.044-1.062 0-.622.494-.991 1.3-.991.878 0 1.356.331 1.428 1.119l1.831-.219c-.147-1.65-1.284-2.328-3.153-2.328-1.65 0-3.262.622-3.262 2.622 0 1.247.606 2.034 2.125 2.4l1.247.294c.934.219 1.247.606 1.247 1.137 0 .678-.659.953-1.906.953-1.85 0-2.622-.972-3.059-2.309L8.556 6.82c-.765-2.384-1.994-3.262-4.431-3.262C1.428 3.558 0 5.261 0 8.158c0 2.784 1.428 4.287 3.997 4.287"
    })));
const $85b88a992de89b18$export$a2e102bc44d355e3 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M14.815 0H1.18C.53 0 0 .517 0 1.153v13.694C0 15.485.53 16 1.18 16h13.636c.651 0 1.184-.515 1.184-1.153V1.153C16 .517 15.467 0 14.815 0M4.746 13.634H2.371V5.999h2.376zM3.559 4.955a1.376 1.376 0 1 1-.001-2.753 1.376 1.376 0 0 1 .001 2.753m10.074 8.679h-2.371V9.922c0-.886-.017-2.025-1.233-2.025-1.235 0-1.423.964-1.423 1.96v3.778H6.235V5.999h2.274v1.043h.033c.317-.6 1.091-1.233 2.245-1.233 2.401 0 2.845 1.581 2.845 3.638z"
    })));
const $85b88a992de89b18$export$435e172f1afd8f3 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M0 0v16h16V0zm13.292 3.791-.858.823a.25.25 0 0 0-.095.241V10.9a.25.25 0 0 0 .095.241l.838.823v.181H9.057v-.181l.868-.843c.085-.085.085-.11.085-.241V5.993l-2.414 6.13h-.325l-2.81-6.13v4.109a.57.57 0 0 0 .156.472l1.129 1.37v.181H2.544v-.181l1.129-1.37a.55.55 0 0 0 .146-.472V5.351A.42.42 0 0 0 3.683 5L2.679 3.791V3.61h3.116l2.409 5.283 2.118-5.283h2.971v.181z"
    })));
const $85b88a992de89b18$export$b3ee3fb5dcd7cd96 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M11 5 9 7V4L8 3 7 4v3L5 5H0v6h5l2-2v4h2V9l2 2h5V5zm-9 5H1V6h1zm2 0H3V6h1zm9 0h-1V6h1zm2 0h-1V6h1z"
    })));
const $85b88a992de89b18$export$f01132691dc82ba2 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M15.239 9.03q.068-.487.069-.992c0-4.036-3.29-7.309-7.347-7.309a7.3 7.3 0 0 0-1.183.096A4.384 4.384 0 0 0 .706 6.886a7 7 0 0 0-.091 1.152c0 4.037 3.288 7.309 7.346 7.309.458 0 .904-.045 1.337-.123a4.384 4.384 0 0 0 6.701-3.724 4.36 4.36 0 0 0-.76-2.47m-6.591 4.395c-2.335.122-3.427-.395-4.428-1.334-1.118-1.049-.669-2.245.242-2.306.91-.061 1.456 1.032 1.942 1.335.485.303 2.331.993 3.306-.122 1.062-1.213-.706-1.841-2.002-2.031-1.85-.274-4.186-1.275-4.004-3.247S5.379 2.738 6.95 2.595c2.002-.182 3.306.303 4.337 1.183 1.192 1.017.547 2.153-.212 2.244-.757.092-1.607-1.671-3.275-1.698-1.72-.027-2.882 1.79-.759 2.306s4.398.728 5.218 2.669c.819 1.942-1.274 4.004-3.611 4.126"
    })));
const $85b88a992de89b18$export$8b71514e84056695 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M0 10.111c0 .925.756 1.681 1.681 1.681s1.681-.756 1.681-1.681V8.43H1.681C.756 8.43 0 9.186 0 10.111m16-4.222c0-.925-.756-1.681-1.681-1.681s-1.681.756-1.681 1.681V7.57h1.681c.925 0 1.681-.756 1.681-1.681M10.111 7.57c.925 0 1.681-.756 1.681-1.681V1.681C11.792.756 11.036 0 10.111 0S8.43.756 8.43 1.681v4.208c0 .925.756 1.681 1.681 1.681m-4.222.86c-.925 0-1.681.756-1.681 1.681v4.208c0 .925.756 1.681 1.681 1.681s1.681-.756 1.681-1.681v-4.208c0-.925-.756-1.681-1.681-1.681m0-4.222H1.681C.756 4.208 0 4.964 0 5.889S.756 7.57 1.681 7.57h4.208c.925 0 1.681-.756 1.681-1.681s-.756-1.681-1.681-1.681m0-4.208c-.925 0-1.681.756-1.681 1.681s.756 1.681 1.681 1.681H7.57V1.681C7.57.756 6.814 0 5.889 0m8.43 8.43h-4.208c-.925 0-1.681.756-1.681 1.681s.756 1.681 1.681 1.681h4.208c.925 0 1.681-.756 1.681-1.681s-.756-1.681-1.681-1.681m-4.208 4.208H8.43v1.681c0 .925.756 1.681 1.681 1.681s1.681-.756 1.681-1.681-.756-1.681-1.681-1.681"
    })));
const $85b88a992de89b18$export$4eeeb34c908b13d0 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M2.035 7.791a.097.097 0 0 0-.094.094L1.8 9.638l.141 1.694a.094.094 0 0 0 .094.091c.05 0 .091-.041.094-.091l.159-1.694-.159-1.754c-.004-.056-.044-.093-.094-.093m.641.112a.11.11 0 0 0-.107.106l-.134 1.626.134 1.71a.11.11 0 0 0 .106.106.11.11 0 0 0 .106-.106l.15-1.71-.149-1.626a.11.11 0 0 0-.106-.106m.643-1.031a.123.123 0 0 0-.122.119l-.125 2.644.125 1.71a.123.123 0 0 0 .122.119.123.123 0 0 0 .122-.119l.141-1.71-.141-2.645a.125.125 0 0 0-.122-.118M1.4 7.85c-.044 0-.075.034-.081.078l-.15 1.707.15 1.644a.08.08 0 0 0 .081.078c.041 0 .075-.034.081-.078l.169-1.644-.168-1.707c-.007-.047-.038-.078-.082-.078m-1.219.831c-.034 0-.059.025-.066.063L0 9.635l.116.875a.065.065 0 0 0 .066.063c.031 0 .059-.025.063-.063l.138-.875-.139-.888c-.003-.041-.031-.066-.063-.066m.591-.55c-.034 0-.063.028-.066.066L.55 9.635l.156 1.407c.003.038.031.066.066.066.034 0 .063-.025.066-.066l.178-1.407-.178-1.438c-.003-.038-.032-.066-.066-.066m3.185-1.869a.137.137 0 0 0-.134.134l-.116 3.248.116 1.697a.137.137 0 0 0 .134.134.137.137 0 0 0 .134-.134l.131-1.697-.131-3.247a.135.135 0 0 0-.134-.135m3.448-.859q-.05-.034-.113-.035c-.063-.001-.078.013-.109.034a.2.2 0 0 0-.094.169v.038l-.075 4.026.078 1.635v.006a.2.2 0 0 0 .047.122.2.2 0 0 0 .156.075.2.2 0 0 0 .141-.059.22.22 0 0 0 .063-.144l.009-.163.078-1.469-.085-4.067a.24.24 0 0 0-.096-.168m6.629 2.134c-.269 0-.528.053-.763.153a3.473 3.473 0 0 0-3.46-3.166c-.444 0-.878.088-1.26.234-.149.057-.187.116-.19.232v6.248a.23.23 0 0 0 .213.225h5.457a1.964 1.964 0 1 0 .003-3.926M6.617 6.031a.193.193 0 0 0-.191.188l-.084 3.416.084 1.644a.191.191 0 0 0 .382 0l.094-1.644-.094-3.417a.19.19 0 0 0-.191-.187m1.456-1.013a.2.2 0 0 0-.109-.031q-.08.002-.138.05a.24.24 0 0 0-.081.166v.022l-.087 4.413.044.816.044.794c0 .119.1.216.216.216a.216.216 0 0 0 .216-.216v.003l.097-1.61-.098-4.435a.21.21 0 0 0-.104-.188m-2.125.897a.175.175 0 0 0-.175.175l-.094 3.545.094 1.653c.003.097.078.175.175.175s.172-.078.175-.175l.103-1.653-.103-3.548a.176.176 0 0 0-.175-.172m-.666-.081a.166.166 0 0 0-.163.163l-.1 3.638.1 1.669c.003.091.075.159.163.159s.159-.072.163-.159l.113-1.669-.113-3.639a.165.165 0 0 0-.163-.162m-.659.134a.15.15 0 0 0-.15.147l-.11 3.52.109 1.682c.003.081.069.147.15.147s.144-.066.15-.147l.122-1.682-.121-3.52a.154.154 0 0 0-.15-.147"
    })));
const $85b88a992de89b18$export$cb0b56e133ef23a1 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M11.212 11.359 4.23 9.891l.294-1.396 6.981 1.468zm.409-1.799L5.154 6.548l.602-1.293 6.468 3.012zm.806-1.619L6.944 3.375l.913-1.096 5.483 4.565zM9.338.852 10.483 0l4.258 5.725-1.145.852zm1.872 12.305H4.102v-1.422h7.108zm2.843-2.843h-1.421v4.264H2.681v-4.264H1.259V16h12.794z"
    })));
const $85b88a992de89b18$export$e582f877f685c307 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M9.707 15.997c-3.396 0-4.687-2.503-4.687-4.274V6.496H3.412V4.43C5.83 3.555 6.421 1.368 6.552.118A.13.13 0 0 1 6.667 0H9.01v4.074h3.199v2.421H8.995v4.98c.009.669.25 1.581 1.472 1.581h.059c.422-.012.99-.137 1.29-.278l.772 2.284c-.291.425-1.6.915-2.771.937h-.119c0-.002.009-.002.009-.002"
    })));
const $85b88a992de89b18$export$f26b4f060f08f8f9 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M16 3.038a6.6 6.6 0 0 1-1.885.517 3.3 3.3 0 0 0 1.443-1.816 6.6 6.6 0 0 1-2.085.797 3.283 3.283 0 0 0-5.594 2.993 9.32 9.32 0 0 1-6.766-3.43A3.3 3.3 0 0 0 .669 3.75c0 1.139.579 2.144 1.46 2.732a3.3 3.3 0 0 1-1.486-.411v.041a3.286 3.286 0 0 0 2.633 3.219 3.3 3.3 0 0 1-1.483.057 3.29 3.29 0 0 0 3.066 2.28 6.6 6.6 0 0 1-4.86 1.359 9.3 9.3 0 0 0 5.032 1.475c6.038 0 9.34-5.002 9.34-9.34a9 9 0 0 0-.01-.425A6.7 6.7 0 0 0 16 3.038"
    })));
const $85b88a992de89b18$export$c07c7d541b672534 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M2.096 1.031h2.188l9.658 12.914h-2.187zM.039 0l6.177 8.26L0 14.975h1.399l5.443-5.879 4.397 5.879H16L9.475 6.251 15.261 0h-1.399L8.85 5.415 4.8 0z"
    })));
const $85b88a992de89b18$export$5e55219a763bfc51 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M6.364 10.379V5.621L10.545 8zm9.302-6.255A2.01 2.01 0 0 0 14.251 2.7C13.003 2.364 8 2.364 8 2.364s-5.003 0-6.251.336A2.01 2.01 0 0 0 .334 4.124C0 5.38 0 8 0 8s0 2.62.334 3.876A2.01 2.01 0 0 0 1.749 13.3c1.248.336 6.251.336 6.251.336s5.003 0 6.251-.336a2.01 2.01 0 0 0 1.415-1.424C16 10.62 16 8 16 8s0-2.62-.334-3.876"
    })));
const $85b88a992de89b18$export$3f241c3fc4d9dd7a = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M6 2h4v1h2V2c0-1.1-.9-2-2-2H6C4.9 0 4 .9 4 2v1h2zM0 14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V8H0zm7-5h2v1a1 1 0 1 1-2 0zm8-5H1c-.55 0-1 .45-1 1v2h16V5c0-.55-.45-1-1-1"
    })));
const $85b88a992de89b18$export$7e0d7941fbd8a620 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M11.5 0H10v3H9V1H5V0H3.5v3h-1V1H1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h4.341A6 6 0 0 1 5 11H2V5h10c1 0 1.393.368 2 .72V2a1 1 0 0 0-1-1h-1.5z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M16 11a5 5 0 1 1-10.001-.001A5 5 0 0 1 16 11m-7.5.625h5v-1.25h-5z"
    })));
const $85b88a992de89b18$export$8266db1827cb2822 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M11.5 0H10v3H9V1H5V0H3.5v3h-1V1H1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h4.341A6 6 0 0 1 5 11H2V5h10c1 0 1.393.368 2 .72V2a1 1 0 0 0-1-1h-1.5z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M16 11a5 5 0 1 1-10 0 5 5 0 0 1 10 0m-5.625-2.5v1.875H8.5v1.25h1.875V13.5h1.25v-1.875H13.5v-1.25h-1.875V8.5z"
    })));
const $85b88a992de89b18$export$16c0cbaf2c55e7b6 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M15 15H1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h1v2h3V2h6v2h3V2h1a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1m-1-9H2v7h12zm-5 6H7v-2h2zm-3 0H4v-2h2zm6-3h-2V7h2zM9 9H7V7h2zM4 3H3V.494C3 .222 3.222 0 3.497 0h.009C3.778 0 4 .222 4 .494zm9 0h-1V.494c0-.272.222-.494.497-.494h.009c.272 0 .494.222.494.494z"
    })));
const $85b88a992de89b18$export$edaa4810f882e615 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M6 7H4v2h2zm9-5h-1v2h-3V2H5v2H2V2H1a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m-1 11H2V6h12zM4 .494A.495.495 0 0 0 3.506 0h-.009A.496.496 0 0 0 3 .494V3h1zm9 0A.495.495 0 0 0 12.506 0h-.009A.496.496 0 0 0 12 .494V3h1z",
        style: {
            fillRule: "nonzero"
        }
    })));
const $85b88a992de89b18$export$af3433002e85528f = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M6 7H4v2h2zm0 3H4v2h2zm3-3H7v2h2zm0 3H7v2h2zm3-3h-2v2h2zm0 3h-2v2h2zm3-8h-1v2h-3V2H5v2H2V2H1a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m-1 11H2V6h12zM4 .494A.495.495 0 0 0 3.506 0h-.009A.496.496 0 0 0 3 .494V3h1zm9 0A.495.495 0 0 0 12.506 0h-.009A.496.496 0 0 0 12 .494V3h1z"
    })));
const $85b88a992de89b18$export$ebaef9cfe20e1737 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M6 8.5c0 1.103.897 2 2 2s2-.897 2-2-.897-2-2-2-2 .897-2 2M15 3h-3.5c-.25-1-.5-2-1.5-2H6C5 1 4.75 2 4.5 3H1c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1m-7 9.5a4 4 0 1 1 0-8 4 4 0 0 1 0 8"
    })));
const $85b88a992de89b18$export$e71f7b946c7cc127 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M16 14v2H0v-2zm-5-9v8H9V5zm4-4v12h-2V1zM3 9v4H1V9zm4-6v10H5V3z"
    })));
const $85b88a992de89b18$export$51e1bcc8c9b70cf = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M16 14v2H0v-2zm-2.708-9.61A1.499 1.499 0 0 1 14.5 2a1.5 1.5 0 0 1 0 3l-.052-.001-3.74 5.611A1.499 1.499 0 0 1 9.5 13a1.5 1.5 0 0 1-1.249-2.33L5.626 6.995a2 2 0 0 1-.252 0L2.749 10.67a1.5 1.5 0 1 1-1.123-.665L4.251 6.33a1.5 1.5 0 1 1 2.498 0l2.625 3.675a2 2 0 0 1 .178-.004z"
    })));
const $85b88a992de89b18$export$acdc8ffe67b5cfdc = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M7 9h7c-.05 3.913-3.167 7-7 7-3.863 0-7-3.137-7-7s3.137-7 7-7zm9-2H9V0l1.41.142C13.576.793 15.962 3.577 16 7"
    })));
const $85b88a992de89b18$export$c99fa69b6fe4cbfa = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M12.586 4.586 8 9.172 3.414 4.586 2 6l6 6 6-6z"
    })));
const $85b88a992de89b18$export$d24fe4633d517542 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M12.586 6.586 8 11.172 3.414 6.586 2 8l6 6 6-6zM8.172 8.828h-.344l-.25-.25h.844zm.5-.5H7.328l-.25-.25h1.844zm.5-.5H6.828l-.25-.25h2.844zm.5-.5H6.328l-.25-.25h3.844zm.5-.5H5.828l-.25-.25h4.844zm.5-.5H5.328l-.25-.25h2.828L8 6.172l.094-.094h2.828zm-3.016-.5H4.828l-.25-.25h2.828zm3.516 0H8.344l.25-.25h2.828zm-4.016-.5H4.328l-.25-.25h2.828zm4.516 0H8.844l.25-.25h2.828zm-5.016-.5H3.828l-.25-.25h2.828zm5.516 0H9.344l.25-.25h2.828zm-6.016-.5H3.328l-.25-.25h2.828zm6.516 0H9.844l.25-.25h2.828zm-7.016-.5H2.828l-.25-.25h2.828zm7.516 0h-2.828l.25-.25h2.828zm-8.016-.5H2.328l-.25-.25h2.828zm8.516 0h-2.828l.25-.25h2.828zm-9.016-.5H2.172l.25-.25h1.984zm9.172 0h-2.484l.25-.25h1.984zm-9.672-.5H2.672l.242-.242h1zm9.172 0h-1.484l.242-.242h1zm-9.664-.492h-.5l.25-.25zm9.172 0h-.5l.25-.25z"
    })));
const $85b88a992de89b18$export$6be9a9d30ce9b0ed = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M14.586 3.586 8 10.172 1.414 3.586 0 5l8 8 8-8z"
    })));
const $85b88a992de89b18$export$5257c06aa807f52c = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M11.414 12.586 6.828 8l4.586-4.586L10 2 4 8l6 6z"
    })));
const $85b88a992de89b18$export$bd98fc092ca567ad = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M9.414 12.586 4.828 8l4.586-4.586L8 2 2 8l6 6zM7.172 8.172v-.344l.25-.25v.844zm.5.5V7.328l.25-.25v1.844zm.5.5V6.828l.25-.25v2.844zm.5.5V6.328l.25-.25v3.844zm.5.5V5.828l.25-.25v4.844zm.5.5V5.328l.25-.25v2.828L9.828 8l.094.094v2.828zm.5-3.016V4.828l.25-.25v2.828zm0 3.516V8.344l.25.25v2.828zm.5-4.016V4.328l.25-.25v2.828zm0 4.516V8.844l.25.25v2.828zm.5-5.016V3.828l.25-.25v2.828zm0 5.516V9.344l.25.25v2.828zm.5-6.016V3.328l.25-.25v2.828zm0 6.516V9.844l.25.25v2.828zm.5-7.016V2.828l.25-.25v2.828zm0 7.516v-2.828l.25.25v2.828zm.5-8.016V2.328l.25-.25v2.828zm0 8.516v-2.828l.25.25v2.828zm.5-9.016V2.172l.25.25v1.984zm0 9.172v-2.484l.25.25v1.984zm.5-9.672V2.672l.242.242v1zm0 9.172v-1.484l.242.242v1zm.492-9.664v-.5l.25.25zm0 9.172v-.5l.25.25z"
    })));
const $85b88a992de89b18$export$87375f63e1783ecd = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M12.414 14.586 5.828 8l6.586-6.586L11 0 3 8l8 8z"
    })));
const $85b88a992de89b18$export$1871f85e3a28ae2d = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M4.586 3.414 9.172 8l-4.586 4.586L6 14l6-6-6-6z"
    })));
const $85b88a992de89b18$export$5bb5160993ff67f0 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M6.586 3.414 11.172 8l-4.586 4.586L8 14l6-6-6-6zm2.242 4.414v.344l-.25.25v-.844zm-.5-.5v1.344l-.25.25V7.078zm-.5-.5v2.344l-.25.25V6.578zm-.5-.5v3.344l-.25.25V6.078zm-.5-.5v4.344l-.25.25V5.578zm-.5-.5v5.344l-.25.25V8.094L6.172 8l-.094-.094V5.078zm-.5 3.016v2.828l-.25.25V8.594zm0-3.516v2.828l-.25-.25V4.578zm-.5 4.016v2.828l-.25.25V9.094zm0-4.516v2.828l-.25-.25V4.078zm-.5 5.016v2.828l-.25.25V9.594zm0-5.516v2.828l-.25-.25V3.578zm-.5 6.016v2.828l-.25.25v-2.828zm0-6.516v2.828l-.25-.25V3.078zm-.5 7.016v2.828l-.25.25v-2.828zm0-7.516v2.828l-.25-.25V2.578zm-.5 8.016v2.828l-.25.25v-2.828zm0-8.516v2.828l-.25-.25V2.078zm-.5 9.016v2.484l-.25-.25v-1.984zm0-9.172v2.484l-.25-.25V2.422zm-.5 9.672v1.484l-.242-.242v-1zm0-9.172v1.484l-.242-.242v-1zm-.492 9.664v.5l-.25-.25zm0-9.172v.5l-.25-.25z"
    })));
const $85b88a992de89b18$export$f98cf460e7941c2b = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M3.586 1.414 10.172 8l-6.586 6.586L5 16l8-8-8-8z"
    })));
const $85b88a992de89b18$export$61133413a12a7ef4 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M2 15h2V1H2zM14.4 2.4 13 1 6 8l7 7 1.4-1.4L8.8 8z"
    })));
const $85b88a992de89b18$export$e4779f93e989d6cc = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M14 1h-2v14h2zM7.2 8l-5.6 5.6L3 15l7-7-7-7-1.4 1.4z"
    })));
const $85b88a992de89b18$export$66e62118032befb3 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M3.414 11.414 8 6.828l4.586 4.586L14 10 8 4l-6 6z"
    })));
const $85b88a992de89b18$export$ef1b2d050d1d9596 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M3.414 9.414 8 4.828l4.586 4.586L14 8 8 2 2 8zm4.414-2.242h.344l.25.25h-.844zm-.5.5h1.344l.25.25H7.078zm-.5.5h2.344l.25.25H6.578zm-.5.5h3.344l.25.25H6.078zm-.5.5h4.344l.25.25H5.578zm-.5.5h5.344l.25.25H8.094L8 9.828l-.094.094H5.078zm3.016.5h2.828l.25.25H8.594zm-3.516 0h2.828l-.25.25H4.578zm4.016.5h2.828l.25.25H9.094zm-4.516 0h2.828l-.25.25H4.078zm5.016.5h2.828l.25.25H9.594zm-5.516 0h2.828l-.25.25H3.578zm6.016.5h2.828l.25.25h-2.828zm-6.516 0h2.828l-.25.25H3.078zm7.016.5h2.828l.25.25h-2.828zm-7.516 0h2.828l-.25.25H2.578zm8.016.5h2.828l.25.25h-2.828zm-8.516 0h2.828l-.25.25H2.078zm9.016.5h2.484l-.25.25h-1.984zm-9.172 0h2.484l-.25.25H2.422zm9.672.5h1.484l-.242.242h-1zm-9.172 0h1.484l-.242.242h-1zm9.664.492h.5l-.25.25zm-9.172 0h.5l-.25.25z"
    })));
const $85b88a992de89b18$export$cd6ea45e6c6fa795 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M1.414 12.414 8 5.828l6.586 6.586L16 11 8 3l-8 8z"
    })));
const $85b88a992de89b18$export$f72e08a2ef494448 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M7 9h2V4H7zm2 2a1 1 0 1 0-2 0 1 1 0 1 0 2 0m7-3c0-4.419-3.581-8-8-8S0 3.581 0 8s3.581 8 8 8 8-3.581 8-8m-2 0a5.97 5.97 0 0 1-1.756 4.244C11.109 13.375 9.603 14 8 14s-3.109-.625-4.244-1.756C2.625 11.109 2 9.603 2 8s.625-3.109 1.756-4.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756A5.97 5.97 0 0 1 14 8"
    })));
const $85b88a992de89b18$export$543083732c6741d9 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M0 8c0 4.419 3.581 8 8 8s8-3.581 8-8-3.581-8-8-8-8 3.581-8 8m12.891 3.478L4.522 3.109A5.97 5.97 0 0 1 8 2c1.603 0 3.109.625 4.244 1.756A5.97 5.97 0 0 1 14 8a5.97 5.97 0 0 1-1.109 3.478M2 8c0-1.266.391-2.469 1.109-3.478l8.369 8.369A5.97 5.97 0 0 1 8 14a5.97 5.97 0 0 1-4.244-1.756A5.97 5.97 0 0 1 2 8"
    })));
const $85b88a992de89b18$export$5ec4aa1366cd882 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M7 12h2V7H7zm1-8a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0-4a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.243 12.243C11.109 13.376 9.603 14 8 14s-3.109-.624-4.243-1.757C2.624 11.109 2 9.603 2 8s.624-3.109 1.757-4.243C4.891 2.624 6.397 2 8 2s3.109.624 4.243 1.757A5.96 5.96 0 0 1 14 8a5.96 5.96 0 0 1-1.757 4.243"
    })));
const $85b88a992de89b18$export$e356a46c6dfa0cd = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m4.244 12.244C11.109 13.375 9.603 14 8 14s-3.109-.625-4.244-1.756A5.97 5.97 0 0 1 2 8c0-1.603.625-3.109 1.756-4.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756A5.97 5.97 0 0 1 14 8a5.97 5.97 0 0 1-1.756 4.244M5 11h2V5H5zm4 0h2V5H9z"
    })));
const $85b88a992de89b18$export$f251922d9c0b7d86 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "m5 11 4-3-4-3zM8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m4.244 12.244C11.109 13.375 9.603 14 8 14s-3.109-.625-4.244-1.756A5.97 5.97 0 0 1 2 8c0-1.603.625-3.109 1.756-4.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756A5.97 5.97 0 0 1 14 8a5.97 5.97 0 0 1-1.756 4.244M9 8v3h2V5H9z"
    })));
const $85b88a992de89b18$export$b8c4b2c7e344e0c3 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "m6 12 6-4-6-4zM8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m4.244 12.244C11.109 13.375 9.603 14 8 14s-3.109-.625-4.244-1.756C2.625 11.109 2 9.603 2 8s.625-3.109 1.756-4.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756C13.375 4.891 14 6.397 14 8s-.625 3.109-1.756 4.244"
    })));
const $85b88a992de89b18$export$94c33b488623435e = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8 10.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.243 12.243C11.109 13.376 9.603 14 8 14s-3.109-.624-4.243-1.757C2.624 11.109 2 9.603 2 8s.624-3.109 1.757-4.243C4.891 2.624 6.397 2 8 2s3.109.624 4.243 1.757A5.96 5.96 0 0 1 14 8a5.96 5.96 0 0 1-1.757 4.243M7.927 3.755c-2.248 0-2.76 1.695-2.802 2.906h1.571c.028-.256.101-1.418 1.221-1.418.672 0 1.206.406 1.206 1.175 0 .695-.724 1.155-1.303 1.711s-.652 1.196-.652 1.695V10h1.615v-.176c0-1.256 1.967-1.594 1.967-3.541 0-1.224-.876-2.528-2.823-2.528"
    })));
const $85b88a992de89b18$export$1d64b5b770b4b3ed = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8 .035a7.986 7.986 0 0 1 7.983 7.982A7.987 7.987 0 0 1 8 16 7.987 7.987 0 0 1 .017 8.017 7.986 7.986 0 0 1 8 .035m0 2a5.986 5.986 0 0 0-5.983 5.982A5.986 5.986 0 0 0 8 14a5.986 5.986 0 0 0 5.983-5.983A5.986 5.986 0 0 0 8 2.035m-.011 2.982a2.984 2.984 0 0 1 0 5.966 2.984 2.984 0 0 1 0-5.966"
    })));
const $85b88a992de89b18$export$5836eb8e2e3e864d = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M5 11h6V5H5zM8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m4.244 12.244C11.109 13.375 9.603 14 8 14s-3.109-.625-4.244-1.756C2.625 11.109 2 9.603 2 8s.625-3.109 1.756-4.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756C13.375 4.891 14 6.397 14 8s-.625 3.109-1.756 4.244"
    })));
const $85b88a992de89b18$export$c65898577f07616b = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m4.244 12.244C11.109 13.375 9.603 14 8 14s-3.109-.625-4.244-1.756C2.625 11.109 2 9.603 2 8s.625-3.109 1.756-4.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756C13.375 4.891 14 6.397 14 8s-.625 3.109-1.756 4.244m-1.46-7.328L7.016 9.103 5.262 7.372 3.856 8.794 7.1 12l5.169-5.747z"
    })));
const $85b88a992de89b18$export$6fb1bca6e16c2c94 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M10.294 4.294 8 6.584 5.706 4.291 4.291 5.706 6.584 8 4.29 10.294l1.416 1.416L8 9.416l2.294 2.294 1.416-1.416L9.416 8l2.294-2.294zM8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m4.244 12.244C11.109 13.375 9.603 14 8 14s-3.109-.625-4.244-1.756C2.625 11.109 2 9.603 2 8s.625-3.109 1.756-4.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756C13.375 4.891 14 6.397 14 8s-.625 3.109-1.756 4.244"
    })));
const $85b88a992de89b18$export$5a17af862a7576da = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M11 2c0-.6-.4-1-1-1h-.6C9.2.4 8.7 0 8 0S6.8.4 6.6 1H6c-.6 0-1 .4-1 1v2h6zm2 0h-1v2h1v10H3V4h1V2H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2M7 9.7 5.2 8 3.8 9.4 7 12.6l5.2-5.7-1.5-1.3z"
    })));
const $85b88a992de89b18$export$b21a11de10d6bf76 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M11 6H5v2h6zm0-4c0-.6-.4-1-1-1h-.6C9.2.4 8.7 0 8 0S6.8.4 6.6 1H6c-.6 0-1 .4-1 1v2h6zm0 8H5v2h6zm2-8h-1v2h1v10H3V4h1V2H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2"
    })));
const $85b88a992de89b18$export$17345b07225e0aa = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8 0a7.97 7.97 0 0 0-6 2.709V0H0v6h6V4H3.528c.072-.084.153-.162.228-.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756C13.375 4.891 14 6.397 14 8s-.625 3.109-1.756 4.244C11.109 13.375 9.603 14 8 14s-3.113-.619-4.244-1.756S2 9.603 2 8H0c0 4.419 3.581 8 8 8s8-3.581 8-8-3.581-8-8-8M7 4v4.416l3.291 3.291 1.416-1.416L9 7.584V4z"
    })));
const $85b88a992de89b18$export$bbbb9b7c1aff7988 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M9 4H7v4.416l3.294 3.291 1.413-1.416L9 7.584zM8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m0 14c-3.312 0-6-2.688-6-6s2.688-6 6-6 6 2.688 6 6-2.688 6-6 6"
    })));
const $85b88a992de89b18$export$1610bcb056ae58bb = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M12.294 3.294 10.878 4.71 13.5 8l-2.622 3.294 1.416 1.416L16 8zM5.122 4.706 3.706 3.291 0 8l3.706 4.706 1.416-1.416L2.5 8zM6 13h2l2-10H8z"
    })));
const $85b88a992de89b18$export$4073c4c5b5a233d4 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M16 9V7l-2.259-.753a6 6 0 0 0-.441-1.066l1.066-2.131-1.416-1.416L10.819 2.7a6.3 6.3 0 0 0-1.066-.441L9 0H7l-.753 2.259a6 6 0 0 0-1.066.441L3.05 1.638 1.638 3.05l1.066 2.131a6 6 0 0 0-.445 1.066L0 7v2l2.259.753c.112.372.263.728.441 1.066L1.634 12.95l1.416 1.416L5.181 13.3c.338.178.694.328 1.066.441L7 16h2l.753-2.259a6 6 0 0 0 1.066-.441l2.131 1.066 1.416-1.416-1.066-2.131c.178-.337.328-.694.441-1.066zm-8 2a3.001 3.001 0 0 1 0-6 3.001 3.001 0 0 1 0 6"
    })));
const $85b88a992de89b18$export$fa207a04e28a42cb = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M15 1 1 6l7 2 2 7z"
    })));
const $85b88a992de89b18$export$6df11ed8ec8f8d62 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m0 14c-3.312 0-6-2.688-6-6s2.688-6 6-6 6 2.688 6 6-2.688 6-6 6M6.5 6.5 4 11v1h1l4.5-2.5L12 5V4h-1zM8 9a1 1 0 1 1 0-2 1 1 0 1 1 0 2"
    })));
const $85b88a992de89b18$export$ec3499dc3f62d571 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m4.244 12.244A5.95 5.95 0 0 1 9 13.919V11H7v2.919a5.96 5.96 0 0 1-3.244-1.675A5.98 5.98 0 0 1 2.081 9H5V7H2.081c.203-1.222.781-2.35 1.675-3.244S5.775 2.284 7 2.081V5h2V2.081a5.96 5.96 0 0 1 3.244 1.675A5.95 5.95 0 0 1 13.919 7H11v2h2.919a6 6 0 0 1-1.675 3.244"
    })));
const $85b88a992de89b18$export$daacca6cce9e30d3 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M13.916 7A6.005 6.005 0 0 0 9 2.084V0H7v2.084A6.005 6.005 0 0 0 2.084 7H0v2h2.084A6.005 6.005 0 0 0 7 13.916V16h2v-2.084A6 6 0 0 0 13.916 9H16V7zm-3.088 3.828C10.072 11.584 9.069 12 8 12s-2.072-.416-2.828-1.172S4 9.069 4 8s.416-2.072 1.172-2.828S6.931 4 8 4s2.072.416 2.828 1.172S12 6.931 12 8s-.416 2.072-1.172 2.828M8 6c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2"
    })));
const $85b88a992de89b18$export$23ce67b3071ee16e = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m4 6H6.181a.494.494 0 0 0-.493.494v.009c0 .272.222.494.494.494H10c1.103 0 2 .897 2 2v1c0 1.103-.897 2-2 2H9v1H7v-1H4v-2h5.506A.495.495 0 0 0 10 9.503v-.009A.495.495 0 0 0 9.506 9H5.981A1.98 1.98 0 0 1 4 7.019V6c0-1.103.897-2 2-2h1V3h2v1h3z"
    })));
const $85b88a992de89b18$export$65f71275cd169acd = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.707 11.293-1.414 1.414L8 9.414l-3.293 3.293-1.414-1.414L6.586 8 3.293 4.707l1.414-1.414L8 6.586l3.293-3.293 1.414 1.414L9.414 8z"
    })));
const $85b88a992de89b18$export$cb9a136b7e677418 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M12.706 8.294 11.29 6.878 9 9.172V0H7v9.172L4.706 6.878 3.291 8.294 8 13zM16 14H0v2h16z"
    })));
const $85b88a992de89b18$export$2982342031c9fea6 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M4.71 5.878 3.294 7.294 8 12l4.71-4.706-1.416-1.416L9 8.172V0H7v8.172zM2 14v-2H0v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2h-2v2z"
    })));
const $85b88a992de89b18$export$70f26903e40c814d = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M12.706 8.294 11.29 6.878 9 9.172V0H7v9.172L4.706 6.878 3.291 8.294 8 13zM14 4v10H2V4H0v12h16V4z"
    })));
const $85b88a992de89b18$export$d5822d1e3e781a7c = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8 13c2 0 4.497-1.5 4-4-1 0-6 4-4 4M8 0S1 5 1 10c0 4 3.688 6 7 6s7-2 7-6C15 5 8 0 8 0m4.606 11.687c-.244.456-.6.866-1.062 1.209a5.4 5.4 0 0 1-1.641.816C9.294 13.9 8.637 14 8 14s-1.294-.1-1.903-.288a5.3 5.3 0 0 1-1.641-.816 3.7 3.7 0 0 1-1.062-1.209C3.131 11.194 3 10.625 3 10c0-.788.278-1.684.825-2.669.494-.891 1.2-1.831 2.094-2.794A25 25 0 0 1 8 2.553a24 24 0 0 1 2.084 1.984c.894.966 1.6 1.906 2.094 2.794.544.985.822 1.881.822 2.669 0 .625-.134 1.194-.394 1.687"
    })));
const $85b88a992de89b18$export$74e5b01e82a6f5df = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M4 8c0-1.103-.897-2-2-2s-2 .897-2 2 .897 2 2 2 2-.897 2-2m2 0c0 1.103.897 2 2 2s2-.897 2-2-.897-2-2-2-2 .897-2 2m6 0c0 1.103.897 2 2 2s2-.897 2-2-.897-2-2-2-2 .897-2 2"
    })));
const $85b88a992de89b18$export$b307b75901e71920 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8 4c1.103 0 2-.897 2-2s-.897-2-2-2-2 .897-2 2 .897 2 2 2m0 2c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2m0 6c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2"
    })));
const $85b88a992de89b18$export$8f179830d10593db = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M0 6v8h16V6l-8 5zm0-4v2l8 5 8-5V2z"
    })));
const $85b88a992de89b18$export$5af68724e0a1bf3d = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M2 11h12V9H2zm0-6v2h12V5z"
    })));
const $85b88a992de89b18$export$35a394b139d2779b = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M1 11h14V9H1zm0-6v2h14V5z"
    })));
const $85b88a992de89b18$export$d37d6805b1edaaab = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M9 11a1 1 0 1 0-2 0 1 1 0 1 0 2 0m0-7v5H7V4z"
    })));
const $85b88a992de89b18$export$5edd362dbec83f16 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M4.414 15.414 8 11.828l3.586 3.586L13 14 8 9l-5 5zM11.586.586 8 4.172 4.414.586 3 2l5 5 5-5z",
        style: {
            fillRule: "nonzero"
        }
    })));
const $85b88a992de89b18$export$2a5f2ff1590ba9f0 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M13 11H9v2h6V1H3v6h2V3h8zM0 8v8h8v-2H3.412l6.294-6.294-1.412-1.412L2 12.587V8z"
    })));
const $85b88a992de89b18$export$e4d1c1f093ddfc94 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M3 3h8v4h2V1H1v12h6v-2H3zm11 5v4.587L7.706 6.294 6.294 7.706 12.587 14H8v2h8V8z"
    })));
const $85b88a992de89b18$export$b96e2b4e5f7775c1 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M16 16H0V0h16zM4 2v12h10V2zm1.586 3.414L8.172 8l-2.586 2.586L7 12l4-4-4-4z"
    })));
const $85b88a992de89b18$export$bfc74f0b8ad1f2ce = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M0 0h16v16H0zm12 14V2H2v12zm-1.586-3.414L7.828 8l2.586-2.586L9 4 5 8l4 4z"
    })));
const $85b88a992de89b18$export$c5cb8522150f3be8 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M13 13H5V9H3v6h12V3H9v2h4zM2 8V3.413l6.294 6.294 1.413-1.413L3.412 2H8V0H0v8z"
    })));
const $85b88a992de89b18$export$10a0ddbd1861a097 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M3 5h4V3H1v12h12V9h-2v4H3zm13 3V0H8v2h4.587L6.294 8.294l1.413 1.413L14 3.413V8z"
    })));
const $85b88a992de89b18$export$c52792559dd5fde = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M11.685 2.886zl2.9-2.9L16 1.4l-2.655 2.655C15.264 5.792 16 8 16 8s-2 6-8 6c-1.463 0-2.688-.357-3.704-.896L1.4 16l-1.414-1.414 2.654-2.654 1.415-1.416L5.472 9.1zm-5.879 8.708A5.9 5.9 0 0 0 8 12c3.479 0 5.214-2.733 5.832-4-.313-.644-.915-1.662-1.883-2.51.021.168.051.335.051.51a4 4 0 0 1-4.561 3.961zm-4.137-.692C.478 9.435 0 8 0 8s2-6 8-6a8 8 0 0 1 2.26.311L4.549 8.023A4 4 0 0 1 4 6c0-.174.03-.34.051-.509C3.082 6.34 2.481 7.358 2.168 8c.193.396.493.932.92 1.484z"
    })));
const $85b88a992de89b18$export$5b296b74fc93300b = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8 2C2 2 0 8 0 8s2 6 8 6 8-6 8-6-2-6-8-6m0 10c-3.481 0-5.213-2.728-5.832-4 .313-.642.914-1.66 1.883-2.509C4.03 5.66 4 5.826 4 6a4 4 0 0 0 8 0c0-.175-.03-.342-.051-.51.968.848 1.57 1.866 1.883 2.51-.618 1.267-2.353 4-5.832 4"
    })));
const $85b88a992de89b18$export$baa7a52704f72315 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M5 7a1 1 0 1 0 0-2 1 1 0 1 0 0 2m3 3a2 2 0 0 1-1.731-1H4.125a4.001 4.001 0 0 0 7.75 0H9.731c-.347.597-.993 1-1.731 1M8 0a8 8 0 0 0-8 8 8 8 0 0 0 8 8 8 8 0 0 0 8-8 8 8 0 0 0-8-8m4.244 12.244A5.97 5.97 0 0 1 8 14a5.97 5.97 0 0 1-4.244-1.756A5.97 5.97 0 0 1 2 8c0-1.603.625-3.109 1.756-4.244A5.97 5.97 0 0 1 8 2c1.603 0 3.109.625 4.244 1.756A5.97 5.97 0 0 1 14 8a5.97 5.97 0 0 1-1.756 4.244M11 5a1 1 0 1 0 0 2 1 1 0 1 0 0-2"
    })));
const $85b88a992de89b18$export$3ca36d1b1b6880d8 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8 8a4 4 0 0 0-3.875 3h2.144c.347-.597.994-1 1.731-1s1.384.403 1.731 1h2.144A4.004 4.004 0 0 0 8 8M5 7a1 1 0 1 0 0-2 1 1 0 1 0 0 2m3-7a8 8 0 0 0-8 8 8 8 0 0 0 8 8 8 8 0 0 0 8-8 8 8 0 0 0-8-8m4.244 12.244A5.97 5.97 0 0 1 8 14a5.97 5.97 0 0 1-4.244-1.756A5.97 5.97 0 0 1 2 8c0-1.603.625-3.109 1.756-4.244A5.97 5.97 0 0 1 8 2c1.603 0 3.109.625 4.244 1.756A5.97 5.97 0 0 1 14 8a5.97 5.97 0 0 1-1.756 4.244M11 5a1 1 0 1 0 0 2 1 1 0 1 0 0-2"
    })));
const $85b88a992de89b18$export$d05ae46b0b12cd6f = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M0 16h3V0H0zm10-8V4L4 8v8h6v-4h2v4h4V4z"
    })));
const $85b88a992de89b18$export$ccb23f910e5c3193 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "m14 0-2 2v2h-2V2L8 0 6 2v2H4V2L2 0 0 2v14h4v-2h2v2h4v-2h2v2h4V2zM4 12V6h2v6zm6 0V6h2v6z"
    })));
const $85b88a992de89b18$export$f153bd1599ddd890 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M7 16v-6L0 2V0h16v2l-7 8v4z"
    })));
const $85b88a992de89b18$export$9fcd2875a6bf0e38 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M2.009 0h-.018A.99.99 0 0 0 1 .991V16h2V.991A.99.99 0 0 0 2.009 0M16 1H4v8h12l-4-4z"
    })));
const $85b88a992de89b18$export$964c15ec9e30ae83 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "m9.65 4.05.45.45c.9.95 1.6 1.9 2.1 2.8.55 1 .85 1.9.85 2.65 0 .6-.15 1.2-.4 1.7q-.375.675-1.05 1.2c-.45.35-1 .6-1.65.8-.65.25-1.3.35-1.95.35s-1.3-.1-1.9-.3-1.15-.45-1.65-.8q-.675-.525-1.05-1.2c-.25-.5-.4-1.05-.4-1.7 0-.6.2-1.3.65-2.1.1-.2.2-.4.35-.6.8.65 1.55.8 2.05.8.85 0 1.65-.4 2.3-1.1.4-.5.75-1.1 1-1.85.1-.35.2-.7.3-1.1M8 0c0 3.9-.85 6.1-1.95 6.1C5.45 6.1 4.7 5.45 4 4c-1.65 1.85-3 4-3 6 0 4 3.7 6 7 6s7-2 7-6C15 5 8 0 8 0"
    })));
const $85b88a992de89b18$export$5c5e312ef0488786 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M5 2v4L.817 12.971A2.001 2.001 0 0 0 2.532 16h10.936a2 2 0 0 0 1.715-3.029L11 6V2h1V0H4v2zm6.068 8H4.932L7 6.554V2h2v4.554z"
    })));
const $85b88a992de89b18$export$22e733acfe1431e6 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "m7 1 2 2h7v11H0V1z"
    })));
const $85b88a992de89b18$export$cc646d2f0b9a8ed7 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8 14v2H0v-2zM1 7h14a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1m1 2v2h12V9zM1 0h14a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1m1 2v2h12V2z"
    })));
const $85b88a992de89b18$export$6c64be5e42deae66 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m0 14c-3.312 0-6-2.688-6-6s2.688-6 6-6 6 2.688 6 6-2.688 6-6 6m.225-5.984L6.172 5.387l.575 3.287a1.5 1.5 0 1 0 1.478-.658M8 3a5 5 0 0 0-4.9 4h1.141A3.84 3.84 0 0 1 5.25 5.25C5.984 4.516 6.963 4.113 8 4.113s2.016.403 2.75 1.137A3.85 3.85 0 0 1 11.759 7H12.9A5 5 0 0 0 8 3"
    })));
const $85b88a992de89b18$export$476bfa1ddc2dfe7a = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M13 9v2h-2.488a.5.5 0 0 1-.169-.069L7.416 8l2.931-2.931A.5.5 0 0 1 10.516 5H13v2l3-3-3-3v2h-2.5c-.538 0-1.181.266-1.559.647L6.584 6H0v4h6.584l2.353 2.353c.382.381 1.022.647 1.56.647h2.5v2l3-3z"
    })));
const $85b88a992de89b18$export$922c85641f9f6751 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8M3.756 12.244A5.97 5.97 0 0 1 2 8q0-.855.231-1.653l.506 1.334 2.819 2.225.469.106-.691 1.106 1.022 2.653a6 6 0 0 1-2.6-1.527m9.066-.669a6 6 0 0 1-.578.669 5.96 5.96 0 0 1-4.041 1.753l1.678-1.325.216-1.131-4.241-1.972-.262-.457-.344-.237-.178-.784-.581.237.194-.762.694-.091.619.688.202-1.188.759-1.05.809-.287.082-.547-.175-.188.766-.125.087-.6-.694-.716-.593.079-.735-.366-.4 1.253-.884-.537 1.284-1.344-1.644.334a5.96 5.96 0 0 1 2.759-.869L9.484 3.65l.684.184.144-.528.703-.491c.441.256.85.572 1.219.941q.276.278.516.584l-.544.941-.534.106.656 4.137.731.766zm.037-5.384.247-.331.281.34z"
    })));
const $85b88a992de89b18$export$4a42f583c9418002 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M2 5h12v1h-1v8h2v1h1v1H0v-1h1v-1h2V6H2zm5 1H5v8h2zm2 0h2v8H9zM8.112.056a.25.25 0 0 0-.224 0l-6.94 3.47C.71 3.644.794 4 1.058 4h13.882c.264 0 .348-.356.112-.474zM8 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
        clipRule: "evenodd"
    })));
const $85b88a992de89b18$export$384500bdee9cfb28 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M3 7V5H1v2zm0 4V9H1v2zm4-4V5H5v2zm0 4V9H5v2zm4-4V5H9v2zm0 4V9H9v2zm4-4V5h-2v2zm0 4V9h-2v2z"
    })));
const $85b88a992de89b18$export$686e909ad6dbb500 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M7 13H5v2h2zm4 0H9v2h2zM7 9H5v2h2zm4 0H9v2h2zM7 5H5v2h2zm4 0H9v2h2zM7 1H5v2h2zm4 0H9v2h2z"
    })));
const $85b88a992de89b18$export$77134c21538c4a4c = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M1 9h14V7H1zm0 5h14v-2H1zM1 2v2h14V2z"
    })));
const $85b88a992de89b18$export$89331070f6fc9967 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8 8V1a1 1 0 0 1 2 0v7h1V2a1 1 0 0 1 2 0v6h1V5a1 1 0 0 1 2 0v9a2 2 0 0 1-2 2H7c-.63 0-1.222-.296-1.6-.8L0 8a1.63 1.63 0 0 1 2.131-.152L5 10V3a1 1 0 0 1 2 0v5z"
    })));
const $85b88a992de89b18$export$90416b71b616b91 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M5 11V4.5a1.5 1.5 0 0 1 3 0V8h1.528c.31 0 .617.072.894.211l2.472 1.236A2 2 0 0 1 14 11.236V14a2 2 0 0 1-2 2H6.702c-.455 0-.895-.155-1.25-.438L1 12a1 1 0 0 1 1-1zM2 4.5C2 2.016 4.016 0 6.5 0S11 2.016 11 4.5H9a2.5 2.5 0 0 0-5 0z"
    })));
const $85b88a992de89b18$export$84d82bc35f21d6b6 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M3 10V1H0v9zm12 1a.997.997 0 0 0 1-1V6.277a1 1 0 0 0-.143-.515l-2.274-3.791A2 2 0 0 0 11.868 1H6a2 2 0 0 0-2 2v7.298c0 .455.155.895.438 1.25L8 16a1 1 0 0 0 1-1v-4z"
    })));
const $85b88a992de89b18$export$ffd6616d7f2ec8c7 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M3 6v9H0V6zm12-1a.997.997 0 0 1 1 1v3.723a1 1 0 0 1-.143.515l-2.274 3.791a2 2 0 0 1-1.715.971H6a2 2 0 0 1-2-2V5.702c0-.455.155-.895.438-1.25L8 0a1 1 0 0 1 1 1v4z"
    })));
const $85b88a992de89b18$export$9551e39be92a9bc5 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M11 8H5V1H3v14h2v-5h6v5h2V1h-2z"
    })));
const $85b88a992de89b18$export$3094a1b9f32c68d5 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M11.75 1A4.25 4.25 0 0 0 8 3.249 4.25 4.25 0 0 0 0 5.25C0 11 8 15 8 15s8-4 8-9.75A4.25 4.25 0 0 0 11.75 1"
    })));
const $85b88a992de89b18$export$62a58013efdd2c1a = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M0 6v10h6v-6h4v6h6V6L8 0z"
    })));
const $85b88a992de89b18$export$72fd52d03f766e5d = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M0 8v7h3v-4h3v4h6V8L6 3zm10-7L7.6 3 13 7.5V13h3V6z"
    })));
const $85b88a992de89b18$export$b7a766f44e29e48c = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8 9 0 5l8-4 8 4zm6.397-1.8L16 8l-8 4-8-4 1.603-.8L8 10.397zm0 3L16 11l-8 4-8-4 1.603-.8L8 13.397z"
    })));
const $85b88a992de89b18$export$f6547b3d6e6e28f2 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "m9.439 3-5 10H1v2h9v-2H6.561l5-10H15V1H6v2z"
    })));
const $85b88a992de89b18$export$bf1e1a02918ee573 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M16 4a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zm-4 6v2H4v-2zM4 7v2H2V7zm3 0v2H5V7zm3 0v2H8V7zm4 0v2h-3V7zM4 4v2H2V4zm3 0v2H5V4zm3 0v2H8V4zm4 0v2h-3V4z"
    })));
const $85b88a992de89b18$export$4c6f701ae5fe9073 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M0 16h7V0H0zm15 0V0H8v16z"
    })));
const $85b88a992de89b18$export$af3a5aeff000074d = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M7 9v7H0V9zm8 0v7H8V9zM7 1v7H0V1zm8 0v7H8V1z"
    })));
const $85b88a992de89b18$export$3b51a6b9653487d2 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M1 1h4v4H1zm5 0h4v4H6zm5 0h4v4h-4zM1 6h4v4H1zm5 0h4v4H6zm5 0h4v4h-4zM1 11h4v4H1zm5 0h4v4H6zm5 0h4v4h-4z"
    })));
const $85b88a992de89b18$export$ae59d452b696795b = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M0 0v7h16V0zm0 15h16V8H0z"
    })));
const $85b88a992de89b18$export$b64d86384c92f1e0 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8 0a7 7 0 0 0-7 7v9h2v-4a7 7 0 0 1 7-7h2a7 7 0 0 0-7 7v2h3a7 7 0 0 0 7-7V0z"
    })));
const $85b88a992de89b18$export$c1c6fe15475bbb7e = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M6.794 12.794c-.478.475-1.113.737-1.794.737s-1.316-.262-1.794-.738a2.54 2.54 0 0 1 0-3.584L5.5 6.916 4.084 5.5 1.791 7.794a4.54 4.54 0 0 0 .003 6.413c.853.855 1.99 1.324 3.206 1.324s2.353-.469 3.206-1.325l2.294-2.294L9.084 10.5zm7.412-11C13.353.938 12.216.469 11 .469S8.647.938 7.794 1.794L5.5 4.084 6.916 5.5 9.21 3.206c.474-.475 1.109-.737 1.79-.737s1.316.263 1.794.737a2.537 2.537 0 0 1 0 3.584L10.5 9.084l1.416 1.416 2.294-2.294a4.54 4.54 0 0 0-.004-6.412m-2.5 3.912L10.29 4.29l-6 6 1.416 1.416z"
    })));
const $85b88a992de89b18$export$8eec6b150ddf7426 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M0 10V9h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-.75a.25.25 0 0 0-.25.25v.5a.25.25 0 0 0 .25.25H3v1H1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h.75a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25zm4 1h12v2H4zm0-4h12v2H4zM1 3.25A.25.25 0 0 0 .75 3H0V2h1a1 1 0 0 1 1 1v4H1zM4 3h12v2H4z"
    })));
const $85b88a992de89b18$export$8e6bd23949fc26d0 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M4 3v2h12V3zM0 5h2V3H0zm4 4h12V7H4zM0 9h2V7H0zm4 4h12v-2H4zm-4 0h2v-2H0z"
    })));
const $85b88a992de89b18$export$70cca5edf1a67180 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M12.25 7H12V4c0-1.653-1.347-3-3-3H7C5.347 1 4 2.347 4 4v1h2V4c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v3H3.75a.753.753 0 0 0-.75.75v6.5c0 .412.338.75.75.75h8.5c.412 0 .75-.338.75-.75v-6.5a.753.753 0 0 0-.75-.75"
    })));
const $85b88a992de89b18$export$d5b6665210f0a539 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M12.25 7H12V4c0-1.653-1.347-3-3-3H7C5.347 1 4 2.347 4 4v3h-.25a.753.753 0 0 0-.75.75v6.5c0 .413.338.75.75.75h8.5c.413 0 .75-.337.75-.75v-6.5a.75.75 0 0 0-.75-.75M6 4c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v3H6z"
    })));
const $85b88a992de89b18$export$247536f07b7c3b83 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M14 7h-1V4c0-2.206-1.794-4-4-4H7C4.794 0 3 1.794 3 4h2c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v3H2c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1m-5 5.731v.769c0 .55-.45 1-1 1s-1-.45-1-1v-.769a2 2 0 1 1 2 0"
    })));
const $85b88a992de89b18$export$5c8bd75215c9ed1f = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M14 7h-1V4c0-2.206-1.794-4-4-4H7C4.794 0 3 1.794 3 4v3H2c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1m-5 5.731v.769c0 .55-.45 1-1 1s-1-.45-1-1v-.769a2 2 0 1 1 2 0M5 7V4c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v3z"
    })));
const $85b88a992de89b18$export$1692611780ac32d = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M14 14V2H8V0h8v16H8v-2zm-6.998-.998L12 8 7 3 5.584 4.416 8.172 7H0v2h8.172l-2.586 2.586z"
    })));
const $85b88a992de89b18$export$2d4c748bd12d78e0 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M14 14V2H8V0h8v16H8v-2zm-9.002-.998L0 8l5-5 1.416 1.416L3.828 7H12v2H3.828l2.586 2.586z"
    })));
const $85b88a992de89b18$export$b2a4ca5137e627ff = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "m15.708 13.587-3.675-3.675a6.5 6.5 0 1 0-2.121 2.121l3.675 3.675a1.003 1.003 0 0 0 1.414 0l.707-.707a1.003 1.003 0 0 0 0-1.414M3.318 9.682C2.468 8.832 2 7.702 2 6.5s.468-2.332 1.318-3.182S5.298 2 6.5 2s2.332.468 3.182 1.318S11 5.298 11 6.5s-.468 2.332-1.318 3.182S7.702 11 6.5 11s-2.332-.468-3.182-1.318"
    })));
const $85b88a992de89b18$export$2b187ab490e92c13 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M3.5 5.5h6v2h-6z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "m12.033 9.912 3.675 3.675a1.003 1.003 0 0 1 0 1.414l-.707.707a1.003 1.003 0 0 1-1.414 0l-3.675-3.675a6.5 6.5 0 1 1 2.121-2.121m-8.715-.23A4.47 4.47 0 0 0 6.5 11a4.47 4.47 0 0 0 3.182-1.318A4.47 4.47 0 0 0 11 6.5a4.47 4.47 0 0 0-1.318-3.182A4.47 4.47 0 0 0 6.5 2a4.47 4.47 0 0 0-3.182 1.318A4.47 4.47 0 0 0 2 6.5a4.47 4.47 0 0 0 1.318 3.182"
    })));
const $85b88a992de89b18$export$aef499440d07757c = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M7.5 7.5h2v-2h-2v-2h-2v2h-2v2h2v2h2z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M15.708 13.587a1.003 1.003 0 0 1 0 1.414l-.707.707a1.003 1.003 0 0 1-1.414 0l-3.675-3.675a6.5 6.5 0 1 1 2.121-2.121zM2 6.5a4.47 4.47 0 0 0 1.318 3.182A4.47 4.47 0 0 0 6.5 11a4.47 4.47 0 0 0 3.182-1.318A4.47 4.47 0 0 0 11 6.5a4.47 4.47 0 0 0-1.318-3.182A4.47 4.47 0 0 0 6.5 2a4.47 4.47 0 0 0-3.182 1.318A4.47 4.47 0 0 0 2 6.5"
    })));
const $85b88a992de89b18$export$89ad07d969809ef0 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "m.292 15.001.707.707a1.003 1.003 0 0 0 1.414 0l3.675-3.675a6.5 6.5 0 1 0-2.121-2.121L.292 13.587a1.003 1.003 0 0 0 0 1.414M9.5 11a4.47 4.47 0 0 1-3.182-1.318C5.468 8.832 5 7.702 5 6.5s.468-2.332 1.318-3.182S8.298 2 9.5 2s2.332.468 3.182 1.318S14 5.298 14 6.5s-.468 2.332-1.318 3.182A4.47 4.47 0 0 1 9.5 11"
    })));
const $85b88a992de89b18$export$a85a53f46ea5d4e1 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "m0 3 5-2v12l-5 2zm11 0v12l-5-1.667v-12zm5-2v12l-4 1.6v-12z"
    })));
const $85b88a992de89b18$export$ddb0bcf29e4fc4bb = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8 0C4.688 0 2 2.688 2 6c0 6 6 10 6 10s6-4 6-10c0-3.312-2.688-6-6-6m0 8a3.001 3.001 0 0 1 0-6 3.001 3.001 0 0 1 0 6"
    })));
const $85b88a992de89b18$export$41cf3a9d8250975e = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M4 10.471V16l4-2 4 2v-5.529A5.99 5.99 0 0 0 14 6c0-3.311-2.689-6-6-6S2 2.689 2 6c0 1.775.773 3.372 2 4.471M8 3a3.001 3.001 0 0 1 0 6 3.001 3.001 0 0 1 0-6"
    })));
const $85b88a992de89b18$export$448b293f3d913b8a = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M14 7H2v2h12z"
    })));
const $85b88a992de89b18$export$8b95d566fbd56482 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M15 7H1v2h14z"
    })));
const $85b88a992de89b18$export$40baeeb0bb7c9f71 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M11.5 0h-7C3.675 0 3 .675 3 1.5v13c0 .825.675 1.5 1.5 1.5h7c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5M8 15a1 1 0 1 1 0-2 1 1 0 1 1 0 2m4-3H4V2h8z"
    })));
const $85b88a992de89b18$export$d7458318da00be20 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M16 5H4.988v9H16v1.988H3V3.012h13zM0 .012h14V2H1.988v12H0V.012m8.2 8.36L6.794 9.794 10.037 13l5.169-5.747-1.484-1.338-3.769 4.187z"
    })));
const $85b88a992de89b18$export$c5e5312dcf5a204f = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M14.706 4.206 10.794.294A1 1 0 0 0 10.088 0H1v7h2V2h7v3h3v9H9v2h6V4.916c0-.266-.106-.522-.294-.71m-7.114 8.179L9 12.15v-1.288l-1.408-.231a3 3 0 0 0-.288-.697l.833-1.164-.91-.91-1.161.832a3.2 3.2 0 0 0-.689-.285L5.146 7H3.857l-.231 1.407a3.1 3.1 0 0 0-.692.285L1.771 7.86l-.911.91.832 1.163a3.2 3.2 0 0 0-.285.691L0 10.856v1.288l1.408.231c.066.244.166.475.285.691L.86 14.23l.91.91 1.164-.832c.219.119.447.219.691.285L3.857 16h1.289l.231-1.407c.244-.066.476-.166.688-.285l1.164.832.91-.91-.829-1.154c.116-.219.217-.447.282-.691m-3.1.403c-.71 0-1.289-.579-1.289-1.288s.579-1.288 1.289-1.288a1.289 1.289 0 1 1 0 2.576"
    })));
const $85b88a992de89b18$export$4de7d3a780aa7d4b = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M14.706 4.206 10.794.294A1 1 0 0 0 10.088 0H1v8H0v4h10V8H3V2h7v3h3v9H3v-1H1v3h14V4.916c0-.266-.106-.522-.294-.71"
    })));
const $85b88a992de89b18$export$37ce21e1ba043044 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M14.706 4.206 10.793.293A1 1 0 0 0 10.087 0H1v9h2V2h7v3h3v9H9v2h6V4.916c0-.266-.106-.522-.294-.71M9 10h2V9c0-1.653-1.347-3-3-3S5 7.347 5 9v1H.991a.995.995 0 0 0-.991.991v4.019c0 .543.447.99.991.99H7.01c.543 0 .99-.447.99-.991V10.99a.995.995 0 0 0-.991-.99H7V9c0-.55.45-1 1-1s1 .45 1 1zm-5 4a1 1 0 1 1 0-2 1 1 0 1 1 0 2"
    })));
const $85b88a992de89b18$export$505d1154312c1f4d = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M14.706 4.206c.188.188.294.444.294.71V16H1V0h9.087c.266 0 .519.106.706.293zM13 14V5h-3V2H3v12zm-1-6H9V5H7v3H4v2h3v3h2v-3h3z"
    })));
const $85b88a992de89b18$export$4a8a225852a3176 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M14.706 4.206 10.793.293A1 1 0 0 0 10.087 0H1v16h14V4.916c0-.266-.106-.522-.294-.71M13 14H3V2h7v3h3zM5.2 8.372 3.794 9.794 7.037 13l5.169-5.747-1.484-1.338-3.769 4.187z"
    })));
const $85b88a992de89b18$export$63c83462b6ec5fb6 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M14.706 4.206c.188.188.294.444.294.71V16H1V0h9.087c.266 0 .519.106.706.293zM13 14V5h-3V2H3v12zm-7.586-3.586L4 9l4-4 4 4-1.414 1.414L9 8.828V13H7V8.828z"
    })));
const $85b88a992de89b18$export$c04e66d9f370f139 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M14.706 4.206 10.793.293A1 1 0 0 0 10.087 0H1v16h14V4.916c0-.266-.106-.522-.294-.71M13 14H3V2h7v3h3z"
    })));
const $85b88a992de89b18$export$509fad11b885abb0 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M3 3H1v13h11v-2H3zm9-3H4v13h11V3zm1 11H6V2h5v2h2z"
    })));
const $85b88a992de89b18$export$b8f31e9a5cf17074 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M1 11v4h4l7-7-4-4zM11 1 9 3l4 4 2-2z"
    })));
const $85b88a992de89b18$export$20df3a4d38f4449c = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M4 4h2v10H4zm10 10h-2a2 2 0 0 1-2-2V4h2v7.5c0 .133.053.26.146.354A.5.5 0 0 0 12.5 12H14zM2 2h12v2H2z"
    })));
const $85b88a992de89b18$export$c273953023f3b0d9 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M11.5 7a1.5 1.5 0 1 0-.001-3.001A1.5 1.5 0 0 0 11.5 7M13 8l-4 2-3-5-3 6v1h10zM0 1v14h16V1zm14 12H2V3h12z"
    })));
const $85b88a992de89b18$export$1f35cd9a970948ef = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8 14H6v-4c-2.208 0-4-1.792-4-4 0-2.177 1.742-3.949 4-4h8v2h-2v10h-2V4H8z"
    })));
const $85b88a992de89b18$export$3a9f56a1d1f9a714 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M14 7H9V2H7v5H2v2h5v5h2V9h5z"
    })));
const $85b88a992de89b18$export$889d6f1a30ea74d6 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M15 7H9V1H7v6H1v2h6v6h2V9h6z"
    })));
const $85b88a992de89b18$export$37ff0821c075ffdb = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M2 14h10V5H2zm2-7h6v5H4zm1-5v2h8v7h2V2z"
    })));
const $85b88a992de89b18$export$f4bc043c492a6c31 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M4 2v9h10V2zm8 7H6V4h6zM3 5H1v9h10v-2H3z"
    })));
const $85b88a992de89b18$export$cabb19bc45ece1c2 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M13 1H3v2h10zm2 3H1c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1h2v4h10v-4h2c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1m-4 9H5V9h6zm3-6a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
    })));
const $85b88a992de89b18$export$1a26968bd5e528c1 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M15.938 9h-2.02a6 6 0 0 1-1.674 3.244A5.97 5.97 0 0 1 8 14a5.97 5.97 0 0 1-4.244-1.756A5.97 5.97 0 0 1 2 8a5.97 5.97 0 0 1 2-4.472V6h2V0H0v2h2.709A7.98 7.98 0 0 0 0 8a8 8 0 0 0 8 8 8 8 0 0 0 7.938-7m-5.154-4.084 1.485 1.337L7.1 12 3.856 8.794l1.406-1.422 1.754 1.731zm3.536-1.822-1.427 1.427A5.9 5.9 0 0 1 13.918 7h2.02a7.96 7.96 0 0 0-1.618-3.906m-2.842.014 1.428-1.428A7.97 7.97 0 0 0 8 0v2a5.96 5.96 0 0 1 3.478 1.108"
    })));
const $85b88a992de89b18$export$bf479e9952d124c2 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M4.522 12.892 3.094 14.32A7.96 7.96 0 0 0 7 15.938v-2.02a5.95 5.95 0 0 1-2.478-1.026m6.956 0A5.95 5.95 0 0 1 9 13.918v2.02a7.96 7.96 0 0 0 3.906-1.618zM13.918 9a5.95 5.95 0 0 1-1.026 2.478l1.428 1.428A7.96 7.96 0 0 0 15.938 9zM2.082 9H.062a7.96 7.96 0 0 0 1.618 3.906l1.428-1.428A5.95 5.95 0 0 1 2.082 9m8.702-4.084 1.485 1.337L7.1 12 3.856 8.794l1.406-1.422 1.754 1.731zm3.536-1.822-1.427 1.427A5.9 5.9 0 0 1 13.918 7h2.02a7.96 7.96 0 0 0-1.618-3.906M.062 7h2.02A5.98 5.98 0 0 1 4 3.528V6h2V0H0v2h2.709A7.98 7.98 0 0 0 .062 7m11.416-3.892 1.428-1.428A7.97 7.97 0 0 0 8 0v2a5.96 5.96 0 0 1 3.478 1.108"
    })));
const $85b88a992de89b18$export$e936722be7af186a = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M7 15.938v-2.02a6 6 0 0 1-3.244-1.674A5.97 5.97 0 0 1 2 8a5.97 5.97 0 0 1 2-4.472V6h2V0H0v2h2.709A7.98 7.98 0 0 0 0 8a8 8 0 0 0 7 7.938m4.478-3.046A5.95 5.95 0 0 1 9 13.918v2.02a7.96 7.96 0 0 0 3.906-1.618zM15.938 9h-2.02a5.95 5.95 0 0 1-1.026 2.478l1.428 1.428A7.96 7.96 0 0 0 15.938 9m-5.154-4.084 1.485 1.337L7.1 12 3.856 8.794l1.406-1.422 1.754 1.731zm3.536-1.822-1.427 1.427A5.9 5.9 0 0 1 13.918 7h2.02a7.96 7.96 0 0 0-1.618-3.906m-2.842.014 1.428-1.428A7.97 7.97 0 0 0 8 0v2a5.96 5.96 0 0 1 3.478 1.108"
    })));
const $85b88a992de89b18$export$cc12b47c9c533761 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M16 3V1c-4.188 0-7 2.812-7 7v7h7V8h-5c0-3.084 1.916-5 5-5M0 8v7h7V8H2c0-3.084 1.916-5 5-5V1C2.812 1 0 3.812 0 8"
    })));
const $85b88a992de89b18$export$31a206cffc6bcef8 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M0 8h5c0 3.084-1.916 5-5 5v2c4.188 0 7-2.812 7-7V1H0zm9-7v7h5c0 3.084-1.916 5-5 5v2c4.188 0 7-2.812 7-7V1z"
    })));
const $85b88a992de89b18$export$8aa06688994ea65a = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M6.999 16h2.002V0H6.999zM5.414 5.414 4 4 0 8l4 4 1.414-1.414L3.828 9H6V7H3.828zM12 4l-1.414 1.414L12.172 7H10v2h2.172l-1.586 1.586L12 12l4-4z"
    })));
const $85b88a992de89b18$export$ce07c1505fc240fa = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M0 6.999v2.002h16V6.999zm7-3.171V6h2V3.828l1.586 1.586L12 4 8 0 4 4l1.414 1.414zm2 8.344V10H7v2.172l-1.586-1.586L4 12l4 4 4-4-1.414-1.414z"
    })));
const $85b88a992de89b18$export$4ec862b3067b2249 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M2 8h6v6H6v-2.6L1.4 16l-1.414-1.414L4.572 10H2zm6-6h2v2.6L14.6 0l1.414 1.414L11.428 6H14v2H8z"
    })));
const $85b88a992de89b18$export$3c2cb1e70bb7ddf8 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "m1.986 12.6 4.6-4.6L8 9.414 3.414 14h2.572v2h-6v-6h2zM12.586 2h-2.572V0h6v6h-2V3.4L9.414 8 8 6.586z"
    })));
const $85b88a992de89b18$export$62497cdf6d0d1934 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M16 16 13 0H9v1H7V0H3L0 16h7v-4h2v4zM7 3h2v2H7zm0 7V7h2v3z"
    })));
const $85b88a992de89b18$export$a7789793f3c2c8cc = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "m6.516 2.612 2.809.938.734 2.934.188.75.644.428 2.238 1.494.605 4.844H2.441l.331-1.65 1.125-.562.875-.438.191-.959zM5 0 3 10l-2 1-1 5h16l-1-8-3-2-1-4z"
    })));
const $85b88a992de89b18$export$67a54af4fd4d9a2e = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M1 5v2a7.982 7.982 0 0 1 5.656 2.343A7.98 7.98 0 0 1 9 15h2C11 9.477 6.523 5 1 5m3 5a2 2 0 1 0-.001 3.999A2 2 0 0 0 4 10M1 1v2a11.955 11.955 0 0 1 8.485 3.515 12 12 0 0 1 2.573 3.815c.625 1.478.942 3.049.942 4.67h2C15 7.268 8.732 1 1 1"
    })));
const $85b88a992de89b18$export$611ca684c7a93fe1 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M13.5 11c-.609 0-1.169.219-1.603.581l-6.9-3.45Q5.001 8.066 5 8q0-.066-.003-.131l6.9-3.45a2.5 2.5 0 1 0-.894-1.788l-6.9 3.45a2.5 2.5 0 1 0 0 3.838l6.9 3.45q-.004.065-.003.131a2.5 2.5 0 1 0 2.5-2.5"
    })));
const $85b88a992de89b18$export$7cffb2c8835f2a25 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M10 6v2h3v6H3V8h3V6H1v10h14V6zM7 3.328V11h2V3.328l1.834 1.834L12 4 8 0 4 4l1.166 1.166z"
    })));
const $85b88a992de89b18$export$72c7f3691d5e45db = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M16 16H0V0h16zM4 2v12h10V2zm6.414 8.586L7.828 8l2.586-2.586L9 4 5 8l4 4z"
    })));
const $85b88a992de89b18$export$d11c632cbde2be34 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M0 0h16v16H0zm12 14V2H2v12zM5.586 5.414 8.172 8l-2.586 2.586L7 12l4-4-4-4z"
    })));
const $85b88a992de89b18$export$3b59d4afb984fe49 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M15.006 12.262 8.994 1.737c-.547-.956-1.438-.956-1.984 0L.994 12.262C.447 13.219.9 14 2 14h12c1.1 0 1.553-.781 1.006-1.738M8 13a1.25 1.25 0 1 1-.002-2.498A1.25 1.25 0 0 1 8 13m1-3H7V5h2z"
    })));
const $85b88a992de89b18$export$1ff70e20de9defba = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M4 12H0v2h4v1h3v-4H4zm5-2h3V6H9v1H0v2h9zM3 5h3V1H3v1H0v2h3zm5 9h8v-2H8zM7 2v2h9V2zm6 7h3V7h-3z"
    })));
const $85b88a992de89b18$export$5363c08acc839f14 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M12 12v4h2v-4h1V9h-4v3zm-2-5V4H6v3h1v9h2V7zm-5 6v-3H1v3h1v3h2v-3zm9-5V0h-2v8zM2 9h2V0H2zm7-6V0H7v3z"
    })));
const $85b88a992de89b18$export$7306271c30123976 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M11.292 8.878 11.139 9h.275zm.872.872h-1.966l-.312.25h2.531zm-.5-.5h-.837l-.313.25h1.403zM8.627 11h3.181l.319-.25H8.939zm-.629 3 .319-.25h-.634zM6.73 13h2.54l.319-.25H6.411zm-.635-.5h3.809l.319-.25H5.777zm1.269 1h1.269l.319-.25H7.048zM5.458 12h5.078l.319-.25H5.142zm-.95-.75.319.25h3.172l-.312-.25zm5.059-1-.312.25h3.188l.262-.206-.044-.044zM7.998 11.5h3.175l.319-.25H8.311zM4.705 8.878 4.583 9h.275zm.468.372h-.837l-.25.25h1.403zm1.885 1.5H3.87l.319.25H7.37zm-.628-.5H3.336l-.044.044.263.206h3.188zm-.628-.5H3.836l-.25.25h2.531zM7.998 4.5l3.294 2.622 1.416-1.416L7.998 2 3.292 5.706l1.416 1.416z"
    })));
const $85b88a992de89b18$export$d51a5d41a86d4b55 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M9.27 3H6.73l-.319.25h3.175zM7.373 5H4.192l-.319.25h3.184zm1.263-2.5H7.367l-.319.25h1.903zM10.542 4H5.461l-.319.25h5.712zm-.637-.5H6.098l-.318.25h4.444zM8.002 2l-.319.25h.634zm3.49 2.75-.319-.25H8.002l.312.25zm-3.49-.25H4.827l-.319.25h3.181zM9.57 5.75h3.094l.044-.044-.263-.206H9.258zm-.628-.5h3.184L11.808 5H8.63zm2.975 1.25h-1.403l.312.25h.837zm-.775.5.153.122.122-.122zM6.433 5.75l.312-.25H3.558l-.263.206.044.044zm5.984.25H9.886l.312.25h1.966zm-6.928.5H4.086l.25.25h.838zm-.903.5.122.122L4.861 7zm1.531-1H3.586l.25.25h1.966zm1.885 5.5L4.708 8.878l-1.416 1.416L8.002 14l4.706-3.706-1.416-1.416z"
    })));
const $85b88a992de89b18$export$24bdafc250bc28ef = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M9.269 3H6.728l-.319.25h3.175zM7.372 5H4.191l-.319.25h3.184zm1.262-2.5H7.366l-.319.25H8.95zM10.541 4H5.459l-.318.25h5.712zm-.638-.5H6.097l-.319.25h4.444zM8 2l-.319.25h.634zm3.491 2.75-.319-.25H8l.312.25zM8 4.5H4.825l-.319.25h3.181zm1.569 1.25h3.094l.044-.044-.263-.206H9.256zm-.628-.5h3.184L11.806 5H8.628zm2.975 1.25h-1.403l.312.25h.837zm-.775.5.153.122.122-.122zm-4.71-1.25.313-.25H3.556l-.262.206.044.044zm4.863 3.128L11.141 9h.275zm.872.872H10.2l-.313.25h2.531zm-.5-.5h-.837l-.313.25h1.403zm.75-3.25H9.884l.312.25h1.966zm-3.788 5h3.181l.319-.25H8.941zM8 14l.319-.25h-.635zm-1.269-1h2.541l.319-.25H6.412zm-.634-.5h3.809l.319-.25H5.778zm1.269 1h1.269l.319-.25H7.05zM5.459 12h5.078l.319-.25H5.144zm-.95-.75.319.25H8l-.312-.25zm5.06-1-.313.25h3.188l.262-.206-.044-.044zM8 11.5h3.175l.319-.25H8.312zM4.706 8.878 4.584 9h.275zm.469.372h-.837l-.25.25h1.403zm.313-2.75H4.084l.25.25h.838zm-.904.5.122.122L4.859 7zm2.475 3.75H3.872l.319.25h3.181zM6.116 6H3.584l.25.25H5.8zm.315 4.25H3.338l-.044.044.262.206h3.188zm-.628-.5H3.837l-.25.25h2.531z"
    })));
const $85b88a992de89b18$export$ee66e65f9bacd0b7 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8 11.5 4.706 8.878 3.29 10.294 8 14l4.706-3.706-1.416-1.416zm0-7 3.294 2.622 1.416-1.416L8 2 3.294 5.706 4.71 7.122z"
    })));
const $85b88a992de89b18$export$f0833711cb9f68ce = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M10 1 3 9h4.5L6 15l7-8H8.5z"
    })));
const $85b88a992de89b18$export$154cb3948df3efa1 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M4 13H2a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H8l-4 3z"
    })));
const $85b88a992de89b18$export$b347ffcee0e953cc = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M4 4h8v8H4z"
    })));
const $85b88a992de89b18$export$ade582b79af72d78 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M2 2h12v12H2z"
    })));
const $85b88a992de89b18$export$75f6b5de4cbd2386 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "m16 6.204-5.528-.803L8 .392 5.528 5.401 0 6.204l4 3.899-.944 5.505L8 13.009l4.944 2.599L12 10.103z"
    })));
const $85b88a992de89b18$export$2bdb2cf27f0a265 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M7 16h2v-6H7zm5.603-12.956A5 5 0 0 0 8 0C5.238 0 3 2.237 3 5a3.001 3.001 0 0 0 0 6h.284L4 15h2L5 9H3c-.55 0-1-.45-1-1s.45-1 1-1h2V5c0-1.653 1.347-3 3-3 1.206 0 2.291.719 2.762 1.828l.438 1.028 1.103.166c.466.072.897.306 1.209.669A2.002 2.002 0 0 1 12 9h-1l-1 6h2l.725-4.066a4 4 0 0 0-.122-7.89"
    })));
const $85b88a992de89b18$export$18836a3de4fad05d = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M13.656 2.344A7.98 7.98 0 0 1 16 8a7.98 7.98 0 0 1-2.344 5.656l-1.414-1.414A5.98 5.98 0 0 0 14 8a5.98 5.98 0 0 0-1.758-4.242zm-11.312 0 1.414 1.414A5.98 5.98 0 0 0 2 8c0 1.656.672 3.156 1.758 4.242l-1.414 1.414A7.98 7.98 0 0 1 0 8c0-2.208.896-4.208 2.344-5.656m9.191 2.121A4.98 4.98 0 0 1 13 8c0 1.38-.56 2.63-1.465 3.535l-1.414-1.414A3 3 0 0 0 11 8a3 3 0 0 0-.879-2.121zm-7.07 0 1.414 1.414A3 3 0 0 0 5 8c0 .828.336 1.578.879 2.121l-1.414 1.414A4.98 4.98 0 0 1 3 8c0-1.38.56-2.63 1.465-3.535M8 6a2 2 0 1 1-.001 4.001A2 2 0 0 1 8 6"
    })));
const $85b88a992de89b18$export$2eb1b0b2d752ea4b = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M13 12v-1h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-.75a.25.25 0 0 0-.25.25v.5a.25.25 0 0 0 .25.25H16v1h-2a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h.75a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25zm-1 3h-2v-5H4v5H2V6c0-2.76 2.24-5 5-5s5 2.24 5 5zm-2-7V6a3.001 3.001 0 0 0-6 0v2z",
        style: {
            fillRule: "nonzero"
        }
    })));
const $85b88a992de89b18$export$b147170bf0ac6406 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M13 12v-1h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-.75a.25.25 0 0 0-.25.25v.5a.25.25 0 0 0 .25.25H16v1h-2a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h.75a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25zM8.414 8l4 4H9.586L7 9.414 4.414 12H1.586l4-4-4-4h2.828L7 6.586 9.586 4h2.828z"
    })));
const $85b88a992de89b18$export$831d605561b8cca5 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M12 15h-2v-5H4v5H2V6c0-2.76 2.24-5 5-5s5 2.24 5 5zm-2-7V6a3.001 3.001 0 0 0-6 0v2zm3-7V0h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-.75a.25.25 0 0 0-.25.25v.5a.25.25 0 0 0 .25.25H16v1h-2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h.75a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25z"
    })));
const $85b88a992de89b18$export$3a4c80bfe15d601a = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "m8.414 8 4 4H9.586L7 9.414 4.414 12H1.586l4-4-4-4h2.828L7 6.586 9.586 4h2.828zM13 1V0h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-.75a.25.25 0 0 0-.25.25v.5a.25.25 0 0 0 .25.25H16v1h-2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h.75a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25z"
    })));
const $85b88a992de89b18$export$8702548ed1d7ac29 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M0 11h11.2l-2.6 2.6L10 15l6-6H0zm4.8-6 2.6-2.6L6 1 0 7h16V5z"
    })));
const $85b88a992de89b18$export$4a3cdaf8654d6ecf = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M5 16V4.8L2.4 7.4 1 6l6-6v16zm6-4.8 2.6-2.6L15 10l-6 6V0h2z"
    })));
const $85b88a992de89b18$export$7f7b28202d8c7331 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M12 11v2h2v-2h2V9h-2V7h-2v2h-2v2zm2-5V1a.997.997 0 0 0-1-1H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1H9V2h3v4zM4 2h3v12H4z"
    })));
const $85b88a992de89b18$export$ca16e8c9b654c9e9 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M11 12h2v2h-2v2H9v-2H7v-2h2v-2h2zm-5 2H1a.997.997 0 0 1-1-1V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-1V9H2v3h4zM2 4v3h12V4z"
    })));
const $85b88a992de89b18$export$5784f2a304a439e3 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M11.414 13 13 11.414 14.586 13 16 11.586 14.414 10 16 8.414 14.586 7 13 8.586 11.414 7 10 8.414 11.586 10 10 11.586zM14 6V1a.997.997 0 0 0-1-1H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1H9V2h3v4zM4 2h3v12H4z"
    })));
const $85b88a992de89b18$export$51fa6d51058f66a4 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M13 11.414 11.414 13 13 14.586 11.586 16 10 14.414 8.414 16 7 14.586 8.586 13 7 11.414 8.414 10 10 11.586 11.586 10zM6 14H1a.997.997 0 0 1-1-1V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-1V9H2v3h4zM2 4v3h12V4z"
    })));
const $85b88a992de89b18$export$c69ace2e6416b89c = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M1 16a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zm1-9v7h2V7zm4 0v7h4V7zm6 0v7h2V7zM2 2v3h12V2z"
    })));
const $85b88a992de89b18$export$7b73804de18dac8e = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M14.497 0H9.988c-.826 0-1.981.478-2.565 1.063L.438 8.047a1.506 1.506 0 0 0 0 2.125l5.389 5.389a1.506 1.506 0 0 0 2.125 0l6.984-6.984C15.522 7.993 16 6.838 16 6.012V1.503C16 .676 15.324 0 14.497 0M12.5 5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 12.5 5"
    })));
const $85b88a992de89b18$export$40d1ddcefe169242 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8m0 6.5c-1.378 0-2.5-1.122-2.5-2.5S6.622 5.5 8 5.5s2.5 1.122 2.5 2.5-1.122 2.5-2.5 2.5M8 7a1 1 0 1 0 0 2 1 1 0 1 0 0-2m0-7C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m4.244 12.244C11.109 13.375 9.603 14 8 14s-3.109-.625-4.244-1.756S2 9.603 2 8s.625-3.109 1.756-4.244S6.397 2 8 2s3.109.625 4.244 1.756S14 6.397 14 8s-.625 3.109-1.756 4.244"
    })));
const $85b88a992de89b18$export$3b8ef319a6c5f131 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M0 10h16V8H0zM0 0v2h16V0zm0 14h8v-2H0zm0-8h16V4H0z"
    })));
const $85b88a992de89b18$export$7679025d661a5f99 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M2 9.014 3.414 7.6l2.59 2.589L12.593 3.6l1.414 1.414-8.004 8.003z"
    })));
const $85b88a992de89b18$export$6a564a3c64a0c770 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M0 9.014 1.414 7.6l3.59 3.589L14.593 1.6l1.414 1.414L5.003 14.017z"
    })));
const $85b88a992de89b18$export$5918e8962b6636e9 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M11 5h2v8.5c0 .825-.675 1.5-1.5 1.5h-7c-.825 0-1.5-.675-1.5-1.5V5h2v8h2V5h2v8h2zM2 2h12v2H2zm4-2h4v1H6z"
    })));
const $85b88a992de89b18$export$f7790cfaf03c8a87 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8 11 3 6h10z"
    })));
const $85b88a992de89b18$export$d0e1eaac53e25db1 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8 13 0 5h16z"
    })));
const $85b88a992de89b18$export$668e2789cbc708d7 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "m5 8 5-5v10z"
    })));
const $85b88a992de89b18$export$1974c1a52230d9bf = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "m3 8 8-8v16z"
    })));
const $85b88a992de89b18$export$501ada128b32fc9e = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "m11 8-5 5V3z"
    })));
const $85b88a992de89b18$export$79a26f2c80e33f90 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "m13 8-8 8V0z"
    })));
const $85b88a992de89b18$export$18dba1b5898bbfb1 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "m8 5 5 5H3z"
    })));
const $85b88a992de89b18$export$9bef3663bbeb4db3 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "m8 3 8 8H0z"
    })));
const $85b88a992de89b18$export$3c99c824037eed46 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M2 5h10.672l-1.837 1.834L12 8l4-4-4-4-1.166 1.166L12.672 3H0v7l2-2zm12 6H3.328l1.838-1.834L4 8l-4 4 4 4 1.166-1.166L3.328 13H16V6l-2 2z"
    })));
const $85b88a992de89b18$export$bf9bd1a6e1a39cb5 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "m6 13-3 2 .889-2.667L0 10h16l-3.889 2.333L13 15l-3-2zm10-4H0V8l3-2c0-2.76 2.24-5 5-5s5 2.24 5 5l3 2z"
    })));
const $85b88a992de89b18$export$193ca764ca13a0c5 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M3 13h10v2H3zm8-12h2v6c0 2.76-2.24 5-5 5S3 9.76 3 7V1h2v6a3.001 3.001 0 0 0 6 0z"
    })));
const $85b88a992de89b18$export$6ec63552fd597a0c = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M3.294 7.706 4.71 9.122 7 6.828V16h2V6.828l2.294 2.294 1.416-1.416L8 3zM0 2h16V0H0z"
    })));
const $85b88a992de89b18$export$1a820bf437484746 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M4.71 6.122 3.294 4.706 8 0l4.71 4.706-1.416 1.416L9 3.828V12H7V3.828zM2 14v-2H0v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2h-2v2z"
    })));
const $85b88a992de89b18$export$65f5fd8d1a192873 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M3.294 7.706 4.71 9.122 7 6.828V16h2V6.828l2.294 2.294 1.416-1.416L8 3zM2 12V2h12v10h2V0H0v12z"
    })));
const $85b88a992de89b18$export$de7094d8f3d0eff8 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M14 12.5a2.5 2.5 0 0 0-2.5-2.5h-7A2.5 2.5 0 0 0 2 12.5V15h12zM12 6h2a2 2 0 0 1 2 2v3h-1.337A3.5 3.5 0 0 0 11.5 9h-.855A4 4 0 0 0 12 6M1.337 11H0V8a2 2 0 0 1 2-2h2a4 4 0 0 0 1.355 3H4.5a3.5 3.5 0 0 0-3.163 2M8 3a3.001 3.001 0 0 1 0 6 3.001 3.001 0 0 1 0-6M4.127 4.996a2 2 0 1 1 1.825-2.432 4.01 4.01 0 0 0-1.825 2.432m5.921-2.432a2 2 0 1 1 1.825 2.432 4.01 4.01 0 0 0-1.825-2.432"
    })));
const $85b88a992de89b18$export$24f630ce129477b6 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8 8a4 4 0 1 0 0-8 4 4 0 0 0 0 8m4 2H4a4 4 0 0 0-4 4v2h16v-2a4 4 0 0 0-4-4"
    })));
const $85b88a992de89b18$export$7c42224f1c8d83b0 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M16 12.5a2.5 2.5 0 0 0-2.5-2.5h-7A2.5 2.5 0 0 0 4 12.5V15h12zM3 13H0v-2.5A2.5 2.5 0 0 1 2.5 8h4.036c.218.376.495.714.819 1H6.5A3.5 3.5 0 0 0 3 12.5zm7-10a3.001 3.001 0 0 1 0 6 3.001 3.001 0 0 1 0-6M6.126 6.997 6 7a3.001 3.001 0 0 1 0-6c1.026 0 1.932.516 2.473 1.302a4.004 4.004 0 0 0-2.347 4.695"
    })));
const $85b88a992de89b18$export$25372d620e7a1b0b = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M15 3v1.268A1.999 1.999 0 0 1 14 8a2 2 0 0 1-1-3.732V3.5a1.5 1.5 0 0 0-3 0v8.513A4 4 0 0 1 6 16c-2.208 0-4-1.792-4-4v-.171A3.001 3.001 0 1 1 6 9a3 3 0 0 1-2 2.829v.177a1.95 1.95 0 0 0 .157.772A2.001 2.001 0 0 0 8 12V3.5a3.501 3.501 0 0 1 6.964-.5zM3 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
    })));
const $85b88a992de89b18$export$db99d8e121938012 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M15.379 12.379 8.79 5.79c.123-.411.21-.839.21-1.29A4.5 4.5 0 0 0 4.5 0c-.451 0-.879.087-1.29.21l2.291 2.291a2.12 2.12 0 0 1 0 2.998l-.002.002a2.12 2.12 0 0 1-2.998 0L.21 3.21C.087 3.621 0 4.049 0 4.5A4.5 4.5 0 0 0 4.5 9c.451 0 .879-.087 1.29-.21l6.589 6.589a2.12 2.12 0 0 0 2.998 0l.002-.002a2.12 2.12 0 0 0 0-2.998M13.75 14.75a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
    })));
const $85b88a992de89b18$export$4cca98ab4f54f41d = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "m13.707 3.707-1.414-1.414L8 6.586 3.707 2.293 2.293 3.707 6.586 8l-4.293 4.293 1.414 1.414L8 9.414l4.293 4.293 1.414-1.414L9.414 8z"
    })));
const $85b88a992de89b18$export$eeb267586df04918 = $85b88a992de89b18$export$7209ba2b0568490(()=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "m14.707 2.707-1.414-1.414L8 6.586 2.707 1.293 1.293 2.707 6.586 8l-5.293 5.293 1.414 1.414L8 9.414l5.293 5.293 1.414-1.414L9.414 8z"
    })));
const $85b88a992de89b18$export$83d89fbfd8236492 = "4.0.0";


var $2b4a7ce7bd2c99e2$exports = {};
$2b4a7ce7bd2c99e2$exports = new URL("main-bg.5a3ebeca.svg", import.meta.url).toString();



var $acw62 = parcelRequire("acw62");

function $0d0f5c87991c3283$export$284abb4664c19c7c(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $86ee73686dbc0e1a$export$a8a3e93435678ff9), {
        as: "h2",
        fontSize: [
            "lg",
            "xl",
            "2xl",
            "3xl"
        ],
        lineHeight: "calc(0.5rem + 1em)",
        textAlign: "center",
        textTransform: "uppercase",
        position: "relative",
        pt: "1%",
        mb: "1.5rem",
        _before: {
            content: '""',
            position: "absolute",
            top: 0,
            left: "50%",
            transform: "translate(-50%, 0)",
            width: "8%",
            height: "8%",
            maxW: "5rem",
            background: "#fff"
        },
        ...props
    });
}



var $acw62 = parcelRequire("acw62");

// src/shared.ts
var $b06ec5ff205338e5$var$clamp = (value)=>Math.max(0, Math.min(1, value));
var $b06ec5ff205338e5$var$wrap = (v, idx)=>{
    return v.map((_, index)=>v[(Math.max(idx, 0) + index) % v.length]);
};
var $b06ec5ff205338e5$var$pipe = (...fns)=>(arg)=>fns.reduce((acc, fn)=>fn(acc), arg);
var $b06ec5ff205338e5$var$noop = ()=>void 0;
var $b06ec5ff205338e5$var$isObject = (v)=>typeof v === "object" && v !== null;
var $b06ec5ff205338e5$export$e2f9a725ee199e81 = 2147483647;
var $b06ec5ff205338e5$export$5cc3b7b83e34ade7 = (guard)=>guard ? "" : void 0;
var $b06ec5ff205338e5$export$91a6105db3d4be7b = (guard)=>guard ? "true" : void 0;
// src/node.ts
var $b06ec5ff205338e5$var$ELEMENT_NODE = 1;
var $b06ec5ff205338e5$var$DOCUMENT_NODE = 9;
var $b06ec5ff205338e5$var$DOCUMENT_FRAGMENT_NODE = 11;
var $b06ec5ff205338e5$export$1b3bfaa9684536aa = (el)=>$b06ec5ff205338e5$var$isObject(el) && el.nodeType === $b06ec5ff205338e5$var$ELEMENT_NODE && typeof el.nodeName === "string";
var $b06ec5ff205338e5$export$62858bae88b53fd0 = (el)=>$b06ec5ff205338e5$var$isObject(el) && el.nodeType === $b06ec5ff205338e5$var$DOCUMENT_NODE;
var $b06ec5ff205338e5$export$5a096129d439f843 = (el)=>$b06ec5ff205338e5$var$isObject(el) && el === el.window;
var $b06ec5ff205338e5$export$d4522fa375bab361 = (el)=>$b06ec5ff205338e5$var$isObject(el) && el.constructor.name === "VisualViewport";
var $b06ec5ff205338e5$export$651544f548703224 = (node)=>{
    if ($b06ec5ff205338e5$export$1b3bfaa9684536aa(node)) return node.localName || "";
    return "#document";
};
function $b06ec5ff205338e5$export$7b296c28e0fa3aed(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($b06ec5ff205338e5$export$651544f548703224(node));
}
var $b06ec5ff205338e5$export$8ee0fc9ee280b4ee = (el)=>$b06ec5ff205338e5$var$isObject(el) && el.nodeType !== void 0;
var $b06ec5ff205338e5$export$af51f0f06c0f328a = (el)=>$b06ec5ff205338e5$export$8ee0fc9ee280b4ee(el) && el.nodeType === $b06ec5ff205338e5$var$DOCUMENT_FRAGMENT_NODE && "host" in el;
var $b06ec5ff205338e5$export$63ed1d20cf8213cf = (el)=>$b06ec5ff205338e5$export$1b3bfaa9684536aa(el) && el.localName === "input";
var $b06ec5ff205338e5$export$1800cc20d529d764 = (el)=>!!el?.matches("a[href]");
var $b06ec5ff205338e5$export$e989c0fffaa6b27a = (el)=>{
    if (!$b06ec5ff205338e5$export$1b3bfaa9684536aa(el)) return false;
    return el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0;
};
var $b06ec5ff205338e5$var$TEXTAREA_SELECT_REGEX = /(textarea|select)/;
function $b06ec5ff205338e5$export$2780cb57de98fa3a(el) {
    if (el == null || !$b06ec5ff205338e5$export$1b3bfaa9684536aa(el)) return false;
    try {
        return $b06ec5ff205338e5$export$63ed1d20cf8213cf(el) && el.selectionStart != null || $b06ec5ff205338e5$var$TEXTAREA_SELECT_REGEX.test(el.localName) || el.isContentEditable || el.getAttribute("contenteditable") === "true" || el.getAttribute("contenteditable") === "";
    } catch  {
        return false;
    }
}
function $b06ec5ff205338e5$export$2344b14b097df817(parent, child) {
    if (!parent || !child) return false;
    if (!$b06ec5ff205338e5$export$1b3bfaa9684536aa(parent) || !$b06ec5ff205338e5$export$1b3bfaa9684536aa(child)) return false;
    const rootNode = child.getRootNode?.();
    if (parent === child) return true;
    if (parent.contains(child)) return true;
    if (rootNode && $b06ec5ff205338e5$export$af51f0f06c0f328a(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            next = next.parentNode || next.host;
        }
    }
    return false;
}
function $b06ec5ff205338e5$export$f65ca476c09acec0(el) {
    if ($b06ec5ff205338e5$export$62858bae88b53fd0(el)) return el;
    if ($b06ec5ff205338e5$export$5a096129d439f843(el)) return el.document;
    return el?.ownerDocument ?? document;
}
function $b06ec5ff205338e5$export$e495491855dc5418(el) {
    return $b06ec5ff205338e5$export$f65ca476c09acec0(el).documentElement;
}
function $b06ec5ff205338e5$export$38b2d434cce3ea22(el) {
    if ($b06ec5ff205338e5$export$af51f0f06c0f328a(el)) return $b06ec5ff205338e5$export$38b2d434cce3ea22(el.host);
    if ($b06ec5ff205338e5$export$62858bae88b53fd0(el)) return el.defaultView ?? window;
    if ($b06ec5ff205338e5$export$1b3bfaa9684536aa(el)) return el.ownerDocument?.defaultView ?? window;
    return window;
}
function $b06ec5ff205338e5$export$cd4e5573fbe2b576(rootNode) {
    let activeElement = rootNode.activeElement;
    while(activeElement?.shadowRoot){
        const el = activeElement.shadowRoot.activeElement;
        if (el === activeElement) break;
        else activeElement = el;
    }
    return activeElement;
}
function $b06ec5ff205338e5$export$4e12058fc4d51d56(node) {
    if ($b06ec5ff205338e5$export$651544f548703224(node) === "html") return node;
    const result = node.assignedSlot || node.parentNode || $b06ec5ff205338e5$export$af51f0f06c0f328a(node) && node.host || $b06ec5ff205338e5$export$e495491855dc5418(node);
    return $b06ec5ff205338e5$export$af51f0f06c0f328a(result) ? result.host : result;
}
// src/computed-style.ts
var $b06ec5ff205338e5$var$styleCache = /* @__PURE__ */ new WeakMap();
function $b06ec5ff205338e5$export$3735103072e4a80(el) {
    if (!$b06ec5ff205338e5$var$styleCache.has(el)) $b06ec5ff205338e5$var$styleCache.set(el, $b06ec5ff205338e5$export$38b2d434cce3ea22(el).getComputedStyle(el));
    return $b06ec5ff205338e5$var$styleCache.get(el);
}
// src/data-url.ts
function $b06ec5ff205338e5$export$4631f9310db9e583(svg, opts) {
    const { type: type, quality: quality = 0.92, background: background } = opts;
    if (!svg) throw new Error("[zag-js > getDataUrl]: Could not find the svg element");
    const win = $b06ec5ff205338e5$export$38b2d434cce3ea22(svg);
    const doc = win.document;
    const svgBounds = svg.getBoundingClientRect();
    const svgClone = svg.cloneNode(true);
    if (!svgClone.hasAttribute("viewBox")) svgClone.setAttribute("viewBox", `0 0 ${svgBounds.width} ${svgBounds.height}`);
    const serializer = new win.XMLSerializer();
    const source = '<?xml version="1.0" standalone="no"?>\r\n' + serializer.serializeToString(svgClone);
    const svgString = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(source);
    if (type === "image/svg+xml") return Promise.resolve(svgString).then((str)=>{
        svgClone.remove();
        return str;
    });
    const dpr = win.devicePixelRatio || 1;
    const canvas = doc.createElement("canvas");
    const image = new win.Image();
    image.src = svgString;
    canvas.width = svgBounds.width * dpr;
    canvas.height = svgBounds.height * dpr;
    const context = canvas.getContext("2d");
    if (type === "image/jpeg" || background) {
        context.fillStyle = background || "white";
        context.fillRect(0, 0, canvas.width, canvas.height);
    }
    return new Promise((resolve)=>{
        image.onload = ()=>{
            context?.drawImage(image, 0, 0, canvas.width, canvas.height);
            resolve(canvas.toDataURL(type, quality));
            svgClone.remove();
        };
    });
}
// src/platform.ts
var $b06ec5ff205338e5$export$9f57505b7bd8dae = ()=>typeof document !== "undefined";
function $b06ec5ff205338e5$export$867a782338812cb4() {
    const agent = navigator.userAgentData;
    return agent?.platform ?? navigator.platform;
}
function $b06ec5ff205338e5$export$7935961ef7719cb0() {
    const ua2 = navigator.userAgentData;
    if (ua2 && Array.isArray(ua2.brands)) return ua2.brands.map(({ brand: brand, version: version })=>`${brand}/${version}`).join(" ");
    return navigator.userAgent;
}
var $b06ec5ff205338e5$var$pt = (v)=>$b06ec5ff205338e5$export$9f57505b7bd8dae() && v.test($b06ec5ff205338e5$export$867a782338812cb4());
var $b06ec5ff205338e5$var$ua = (v)=>$b06ec5ff205338e5$export$9f57505b7bd8dae() && v.test($b06ec5ff205338e5$export$7935961ef7719cb0());
var $b06ec5ff205338e5$var$vn = (v)=>$b06ec5ff205338e5$export$9f57505b7bd8dae() && v.test(navigator.vendor);
var $b06ec5ff205338e5$export$a1d0d20ee9546562 = ()=>$b06ec5ff205338e5$export$9f57505b7bd8dae() && !!navigator.maxTouchPoints;
var $b06ec5ff205338e5$export$9ac100e40613ea10 = ()=>$b06ec5ff205338e5$var$pt(/^Mac/);
var $b06ec5ff205338e5$export$95df08bae54cb4df = ()=>$b06ec5ff205338e5$export$5231b1f790f5c149() && $b06ec5ff205338e5$var$vn(/apple/i);
var $b06ec5ff205338e5$export$b7d78993b74f766d = ()=>$b06ec5ff205338e5$var$ua(/firefox\//i);
var $b06ec5ff205338e5$export$5231b1f790f5c149 = ()=>$b06ec5ff205338e5$var$pt(/mac|iphone|ipad|ipod/i);
var $b06ec5ff205338e5$export$41a665f744414057 = ()=>$b06ec5ff205338e5$var$pt(/iP(hone|ad|od)|iOS/);
var $b06ec5ff205338e5$export$78551043582a6a98 = ()=>$b06ec5ff205338e5$var$ua(/AppleWebKit/);
var $b06ec5ff205338e5$export$a11b0059900ceec8 = ()=>{
    const re = /android/i;
    return $b06ec5ff205338e5$var$pt(re) || $b06ec5ff205338e5$var$ua(re);
};
// src/event.ts
function $b06ec5ff205338e5$export$28ed887a50e27461(event) {
    const { selectionStart: selectionStart, selectionEnd: selectionEnd, value: value } = event.currentTarget;
    return value.slice(0, selectionStart) + event.data + value.slice(selectionEnd);
}
function $b06ec5ff205338e5$var$getComposedPath(event) {
    return event.composedPath?.() ?? event.nativeEvent?.composedPath?.();
}
function $b06ec5ff205338e5$export$e58f029f0fbfdb29(event) {
    const composedPath = $b06ec5ff205338e5$var$getComposedPath(event);
    return composedPath?.[0] ?? event.target;
}
var $b06ec5ff205338e5$export$7bced8f45c53f2f = (event)=>{
    return $b06ec5ff205338e5$export$2344b14b097df817(event.currentTarget, $b06ec5ff205338e5$export$e58f029f0fbfdb29(event));
};
function $b06ec5ff205338e5$export$ca85c990e080b373(event) {
    const element = event.currentTarget;
    if (!element) return false;
    const isAppleDevice = $b06ec5ff205338e5$export$5231b1f790f5c149();
    if (isAppleDevice && !event.metaKey) return false;
    if (!isAppleDevice && !event.ctrlKey) return false;
    const localName = element.localName;
    if (localName === "a") return true;
    if (localName === "button" && element.type === "submit") return true;
    if (localName === "input" && element.type === "submit") return true;
    return false;
}
function $b06ec5ff205338e5$export$e2c2f0d64f6a549a(event) {
    const element = event.currentTarget;
    if (!element) return false;
    const localName = element.localName;
    if (!event.altKey) return false;
    if (localName === "a") return true;
    if (localName === "button" && element.type === "submit") return true;
    if (localName === "input" && element.type === "submit") return true;
    return false;
}
function $b06ec5ff205338e5$export$49e72d3db4288c1(event) {
    return $b06ec5ff205338e5$export$4abe0e945399ac1d(event).isComposing;
}
function $b06ec5ff205338e5$export$746ace428e2a5877(e) {
    return e.detail === 0 || e.clientX === 0 && e.clientY === 0;
}
function $b06ec5ff205338e5$export$b3f2c64190cf8c4(e) {
    return e.key.length === 1 && !e.ctrlKey && !e.metaKey;
}
function $b06ec5ff205338e5$export$29bf1b5f2c56cf63(e) {
    return e.width === 0 && e.height === 0 || e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse";
}
function $b06ec5ff205338e5$export$60278871457622de(e) {
    if (e.mozInputSource === 0 && e.isTrusted) return true;
    if ($b06ec5ff205338e5$export$a11b0059900ceec8() && e.pointerType) return e.type === "click" && e.buttons === 1;
    return e.detail === 0 && !e.pointerType;
}
var $b06ec5ff205338e5$export$698c4f0ff5e11e52 = (e)=>e.button === 0;
var $b06ec5ff205338e5$export$6faedb510c176c60 = (e)=>{
    return e.button === 2 || $b06ec5ff205338e5$export$9ac100e40613ea10() && e.ctrlKey && e.button === 0;
};
var $b06ec5ff205338e5$export$90788ad2c69b4f50 = (e)=>e.ctrlKey || e.altKey || e.metaKey;
var $b06ec5ff205338e5$export$c4dfce035d43d1e0 = (event)=>"touches" in event && event.touches.length > 0;
var $b06ec5ff205338e5$var$keyMap = {
    Up: "ArrowUp",
    Down: "ArrowDown",
    Esc: "Escape",
    " ": "Space",
    ",": "Comma",
    Left: "ArrowLeft",
    Right: "ArrowRight"
};
var $b06ec5ff205338e5$var$rtlKeyMap = {
    ArrowLeft: "ArrowRight",
    ArrowRight: "ArrowLeft"
};
function $b06ec5ff205338e5$export$f7a7490116b79d4d(event, options = {}) {
    const { dir: dir = "ltr", orientation: orientation = "horizontal" } = options;
    let key = event.key;
    key = $b06ec5ff205338e5$var$keyMap[key] ?? key;
    const isRtl = dir === "rtl" && orientation === "horizontal";
    if (isRtl && key in $b06ec5ff205338e5$var$rtlKeyMap) key = $b06ec5ff205338e5$var$rtlKeyMap[key];
    return key;
}
function $b06ec5ff205338e5$export$4abe0e945399ac1d(event) {
    return event.nativeEvent ?? event;
}
var $b06ec5ff205338e5$var$pageKeys = /* @__PURE__ */ new Set([
    "PageUp",
    "PageDown"
]);
var $b06ec5ff205338e5$var$arrowKeys = /* @__PURE__ */ new Set([
    "ArrowUp",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight"
]);
function $b06ec5ff205338e5$export$587b7b5379932dd6(event) {
    if (event.ctrlKey || event.metaKey) return 0.1;
    else {
        const isPageKey = $b06ec5ff205338e5$var$pageKeys.has(event.key);
        const isSkipKey = isPageKey || event.shiftKey && $b06ec5ff205338e5$var$arrowKeys.has(event.key);
        return isSkipKey ? 10 : 1;
    }
}
function $b06ec5ff205338e5$export$a8637644cbd23a7b(event, type = "client") {
    const point = $b06ec5ff205338e5$export$c4dfce035d43d1e0(event) ? event.touches[0] || event.changedTouches[0] : event;
    return {
        x: point[`${type}X`],
        y: point[`${type}Y`]
    };
}
var $b06ec5ff205338e5$export$b1d829ddf82884aa = (target, eventName, handler, options)=>{
    const node = typeof target === "function" ? target() : target;
    node?.addEventListener(eventName, handler, options);
    return ()=>{
        node?.removeEventListener(eventName, handler, options);
    };
};
// src/form.ts
function $b06ec5ff205338e5$var$getDescriptor(el, options) {
    const { type: type = "HTMLInputElement", property: property = "value" } = options;
    const proto = $b06ec5ff205338e5$export$38b2d434cce3ea22(el)[type].prototype;
    return Object.getOwnPropertyDescriptor(proto, property) ?? {};
}
function $b06ec5ff205338e5$var$getElementType(el) {
    if (el.localName === "input") return "HTMLInputElement";
    if (el.localName === "textarea") return "HTMLTextAreaElement";
    if (el.localName === "select") return "HTMLSelectElement";
}
function $b06ec5ff205338e5$export$c2c7fef809f2f8ef(el, value, property = "value") {
    const type = $b06ec5ff205338e5$var$getElementType(el);
    if (type) {
        const descriptor = $b06ec5ff205338e5$var$getDescriptor(el, {
            type: type,
            property: property
        });
        descriptor.set?.call(el, value);
    }
    el.setAttribute(property, value);
}
function $b06ec5ff205338e5$export$1b2cb9f366b7b263(el, checked) {
    const descriptor = $b06ec5ff205338e5$var$getDescriptor(el, {
        type: "HTMLInputElement",
        property: "checked"
    });
    descriptor.set?.call(el, checked);
    if (checked) el.setAttribute("checked", "");
    else el.removeAttribute("checked");
}
function $b06ec5ff205338e5$export$71608d92f9cda884(el, options) {
    const { value: value, bubbles: bubbles = true } = options;
    if (!el) return;
    const win = $b06ec5ff205338e5$export$38b2d434cce3ea22(el);
    if (!(el instanceof win.HTMLInputElement)) return;
    $b06ec5ff205338e5$export$c2c7fef809f2f8ef(el, `${value}`);
    el.dispatchEvent(new win.Event("input", {
        bubbles: bubbles
    }));
}
function $b06ec5ff205338e5$export$ebab7723673c874f(el, options) {
    const { checked: checked, bubbles: bubbles = true } = options;
    if (!el) return;
    const win = $b06ec5ff205338e5$export$38b2d434cce3ea22(el);
    if (!(el instanceof win.HTMLInputElement)) return;
    $b06ec5ff205338e5$export$1b2cb9f366b7b263(el, checked);
    el.dispatchEvent(new win.Event("click", {
        bubbles: bubbles
    }));
}
function $b06ec5ff205338e5$var$getClosestForm(el) {
    return $b06ec5ff205338e5$var$isFormElement(el) ? el.form : el.closest("form");
}
function $b06ec5ff205338e5$var$isFormElement(el) {
    return el.matches("textarea, input, select, button");
}
function $b06ec5ff205338e5$var$trackFormReset(el, callback) {
    if (!el) return;
    const form = $b06ec5ff205338e5$var$getClosestForm(el);
    const onReset = (e)=>{
        if (e.defaultPrevented) return;
        callback();
    };
    form?.addEventListener("reset", onReset, {
        passive: true
    });
    return ()=>form?.removeEventListener("reset", onReset);
}
function $b06ec5ff205338e5$var$trackFieldsetDisabled(el, callback) {
    const fieldset = el?.closest("fieldset");
    if (!fieldset) return;
    callback(fieldset.disabled);
    const win = $b06ec5ff205338e5$export$38b2d434cce3ea22(fieldset);
    const obs = new win.MutationObserver(()=>callback(fieldset.disabled));
    obs.observe(fieldset, {
        attributes: true,
        attributeFilter: [
            "disabled"
        ]
    });
    return ()=>obs.disconnect();
}
function $b06ec5ff205338e5$export$a48469c7b6beba26(el, options) {
    if (!el) return;
    const { onFieldsetDisabledChange: onFieldsetDisabledChange, onFormReset: onFormReset } = options;
    const cleanups2 = [
        $b06ec5ff205338e5$var$trackFormReset(el, onFormReset),
        $b06ec5ff205338e5$var$trackFieldsetDisabled(el, onFieldsetDisabledChange)
    ];
    return ()=>cleanups2.forEach((cleanup)=>cleanup?.());
}
// src/tabbable.ts
var $b06ec5ff205338e5$var$isFrame = (el)=>$b06ec5ff205338e5$export$1b3bfaa9684536aa(el) && el.tagName === "IFRAME";
var $b06ec5ff205338e5$var$hasTabIndex = (el)=>!Number.isNaN(parseInt(el.getAttribute("tabindex") || "0", 10));
var $b06ec5ff205338e5$var$hasNegativeTabIndex = (el)=>parseInt(el.getAttribute("tabindex") || "0", 10) < 0;
var $b06ec5ff205338e5$var$focusableSelector = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false']), details > summary:first-of-type";
var $b06ec5ff205338e5$export$f6768025e418420e = (container, includeContainer = false)=>{
    if (!container) return [];
    const elements = Array.from(container.querySelectorAll($b06ec5ff205338e5$var$focusableSelector));
    const include = includeContainer == true || includeContainer == "if-empty" && elements.length === 0;
    if (include && $b06ec5ff205338e5$export$1b3bfaa9684536aa(container) && $b06ec5ff205338e5$export$4c063cf1350e6fed(container)) elements.unshift(container);
    const focusableElements = elements.filter($b06ec5ff205338e5$export$4c063cf1350e6fed);
    focusableElements.forEach((element, i)=>{
        if ($b06ec5ff205338e5$var$isFrame(element) && element.contentDocument) {
            const frameBody = element.contentDocument.body;
            focusableElements.splice(i, 1, ...$b06ec5ff205338e5$export$f6768025e418420e(frameBody));
        }
    });
    return focusableElements;
};
function $b06ec5ff205338e5$export$4c063cf1350e6fed(element) {
    if (!element || element.closest("[inert]")) return false;
    return element.matches($b06ec5ff205338e5$var$focusableSelector) && $b06ec5ff205338e5$export$e989c0fffaa6b27a(element);
}
function $b06ec5ff205338e5$export$748138f04a69bf21(container, includeContainer) {
    const [first] = $b06ec5ff205338e5$export$f6768025e418420e(container, includeContainer);
    return first || null;
}
function $b06ec5ff205338e5$export$5f161a4b62f9e29a(container, includeContainer) {
    if (!container) return [];
    const elements = Array.from(container.querySelectorAll($b06ec5ff205338e5$var$focusableSelector));
    const tabbableElements = elements.filter($b06ec5ff205338e5$export$bebd5a1431fec25d);
    if (includeContainer && $b06ec5ff205338e5$export$bebd5a1431fec25d(container)) tabbableElements.unshift(container);
    tabbableElements.forEach((element, i)=>{
        if ($b06ec5ff205338e5$var$isFrame(element) && element.contentDocument) {
            const frameBody = element.contentDocument.body;
            const allFrameTabbable = $b06ec5ff205338e5$export$5f161a4b62f9e29a(frameBody);
            tabbableElements.splice(i, 1, ...allFrameTabbable);
        }
    });
    if (!tabbableElements.length && includeContainer) return elements;
    return tabbableElements;
}
function $b06ec5ff205338e5$export$bebd5a1431fec25d(el) {
    if (el != null && el.tabIndex > 0) return true;
    return $b06ec5ff205338e5$export$4c063cf1350e6fed(el) && !$b06ec5ff205338e5$var$hasNegativeTabIndex(el);
}
function $b06ec5ff205338e5$export$9beaf9bf6ff178ae(container, includeContainer) {
    const [first] = $b06ec5ff205338e5$export$5f161a4b62f9e29a(container, includeContainer);
    return first || null;
}
function $b06ec5ff205338e5$export$73cc6e682b257cff(container, includeContainer) {
    const elements = $b06ec5ff205338e5$export$5f161a4b62f9e29a(container, includeContainer);
    return elements[elements.length - 1] || null;
}
function $b06ec5ff205338e5$export$1b7701f2d138464c(container, includeContainer) {
    const elements = $b06ec5ff205338e5$export$5f161a4b62f9e29a(container, includeContainer);
    const first = elements[0] || null;
    const last = elements[elements.length - 1] || null;
    return [
        first,
        last
    ];
}
function $b06ec5ff205338e5$export$28f33206776129a7(container, current) {
    const tabbables = $b06ec5ff205338e5$export$5f161a4b62f9e29a(container);
    const doc = container?.ownerDocument || document;
    const currentElement = current ?? doc.activeElement;
    if (!currentElement) return null;
    const index = tabbables.indexOf(currentElement);
    return tabbables[index + 1] || null;
}
function $b06ec5ff205338e5$export$a4672efddb4181b8(node) {
    if (node.tabIndex < 0) {
        if ((/^(audio|video|details)$/.test(node.localName) || $b06ec5ff205338e5$export$2780cb57de98fa3a(node)) && !$b06ec5ff205338e5$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
}
// src/initial-focus.ts
function $b06ec5ff205338e5$export$af1ff6d51ec218ea(options) {
    const { root: root, getInitialEl: getInitialEl, filter: filter, enabled: enabled = true } = options;
    if (!enabled) return;
    let node = null;
    node || (node = typeof getInitialEl === "function" ? getInitialEl() : getInitialEl);
    node || (node = root?.querySelector("[data-autofocus],[autofocus]"));
    if (!node) {
        const tabbables = $b06ec5ff205338e5$export$5f161a4b62f9e29a(root);
        node = filter ? tabbables.filter(filter)[0] : tabbables[0];
    }
    return node || root || void 0;
}
function $b06ec5ff205338e5$export$605ed6bb305230a3(event) {
    const container = event.currentTarget;
    if (!container) return false;
    const [firstTabbable, lastTabbable] = $b06ec5ff205338e5$export$1b7701f2d138464c(container);
    const doc = container.ownerDocument || document;
    if (doc.activeElement === firstTabbable && event.shiftKey) return false;
    if (doc.activeElement === lastTabbable && !event.shiftKey) return false;
    if (!firstTabbable && !lastTabbable) return false;
    return true;
}
// src/raf.ts
function $b06ec5ff205338e5$export$bdd553fddd433dcb(fn) {
    const set2 = /* @__PURE__ */ new Set();
    function raf2(fn2) {
        const id = globalThis.requestAnimationFrame(fn2);
        set2.add(()=>globalThis.cancelAnimationFrame(id));
    }
    raf2(()=>raf2(fn));
    return function cleanup() {
        set2.forEach((fn2)=>fn2());
    };
}
function $b06ec5ff205338e5$export$27f233d61a9e2fa4(fn) {
    const id = globalThis.requestAnimationFrame(fn);
    return ()=>{
        globalThis.cancelAnimationFrame(id);
    };
}
function $b06ec5ff205338e5$export$77d693d38001d697(el, type, cb) {
    const cancelTimer = $b06ec5ff205338e5$export$27f233d61a9e2fa4(()=>{
        el.removeEventListener(type, exec, true);
        cb();
    });
    const exec = ()=>{
        cancelTimer();
        cb();
    };
    el.addEventListener(type, exec, {
        once: true,
        capture: true
    });
    return cancelTimer;
}
// src/mutation-observer.ts
function $b06ec5ff205338e5$var$observeAttributesImpl(node, options) {
    if (!node) return;
    const { attributes: attributes, callback: fn } = options;
    const win = node.ownerDocument.defaultView || window;
    const obs = new win.MutationObserver((changes)=>{
        for (const change of changes)if (change.type === "attributes" && change.attributeName && attributes.includes(change.attributeName)) fn(change);
    });
    obs.observe(node, {
        attributes: true,
        attributeFilter: attributes
    });
    return ()=>obs.disconnect();
}
function $b06ec5ff205338e5$export$343af0d656c88488(nodeOrFn, options) {
    const { defer: defer } = options;
    const func = defer ? $b06ec5ff205338e5$export$27f233d61a9e2fa4 : (v)=>v();
    const cleanups2 = [];
    cleanups2.push(func(()=>{
        const node = typeof nodeOrFn === "function" ? nodeOrFn() : nodeOrFn;
        cleanups2.push($b06ec5ff205338e5$var$observeAttributesImpl(node, options));
    }));
    return ()=>{
        cleanups2.forEach((fn)=>fn?.());
    };
}
function $b06ec5ff205338e5$var$observeChildrenImpl(node, options) {
    const { callback: fn } = options;
    if (!node) return;
    const win = node.ownerDocument.defaultView || window;
    const obs = new win.MutationObserver(fn);
    obs.observe(node, {
        childList: true,
        subtree: true
    });
    return ()=>obs.disconnect();
}
function $b06ec5ff205338e5$export$c7ed990b38b19ee7(nodeOrFn, options) {
    const { defer: defer } = options;
    const func = defer ? $b06ec5ff205338e5$export$27f233d61a9e2fa4 : (v)=>v();
    const cleanups2 = [];
    cleanups2.push(func(()=>{
        const node = typeof nodeOrFn === "function" ? nodeOrFn() : nodeOrFn;
        cleanups2.push($b06ec5ff205338e5$var$observeChildrenImpl(node, options));
    }));
    return ()=>{
        cleanups2.forEach((fn)=>fn?.());
    };
}
// src/navigate.ts
function $b06ec5ff205338e5$export$e91dc30618113dbe(el) {
    const click = ()=>el.click();
    if ($b06ec5ff205338e5$export$b7d78993b74f766d()) $b06ec5ff205338e5$export$77d693d38001d697(el, "keyup", click);
    else queueMicrotask(click);
}
// src/overflow.ts
function $b06ec5ff205338e5$export$7cd01a57c8ca906c(el) {
    const parentNode = $b06ec5ff205338e5$export$4e12058fc4d51d56(el);
    if ($b06ec5ff205338e5$export$7b296c28e0fa3aed(parentNode)) return $b06ec5ff205338e5$export$f65ca476c09acec0(parentNode).body;
    if ($b06ec5ff205338e5$export$1b3bfaa9684536aa(parentNode) && $b06ec5ff205338e5$export$989e911fa9af580a(parentNode)) return parentNode;
    return $b06ec5ff205338e5$export$7cd01a57c8ca906c(parentNode);
}
function $b06ec5ff205338e5$export$3b57c1601291186b(el, list = []) {
    const scrollableAncestor = $b06ec5ff205338e5$export$7cd01a57c8ca906c(el);
    const isBody = scrollableAncestor === el.ownerDocument.body;
    const win = $b06ec5ff205338e5$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $b06ec5ff205338e5$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : []);
    return list.concat(scrollableAncestor, $b06ec5ff205338e5$export$3b57c1601291186b(scrollableAncestor, []));
}
var $b06ec5ff205338e5$var$getElementRect = (el)=>{
    if ($b06ec5ff205338e5$export$1b3bfaa9684536aa(el)) return el.getBoundingClientRect();
    if ($b06ec5ff205338e5$export$d4522fa375bab361(el)) return {
        top: 0,
        left: 0,
        bottom: el.height,
        right: el.width
    };
    return {
        top: 0,
        left: 0,
        bottom: el.innerHeight,
        right: el.innerWidth
    };
};
function $b06ec5ff205338e5$export$62976f5619263b39(el, ancestor) {
    if (!$b06ec5ff205338e5$export$1b3bfaa9684536aa(el)) return true;
    const ancestorRect = $b06ec5ff205338e5$var$getElementRect(ancestor);
    const elRect = el.getBoundingClientRect();
    return elRect.top >= ancestorRect.top && elRect.left >= ancestorRect.left && elRect.bottom <= ancestorRect.bottom && elRect.right <= ancestorRect.right;
}
var $b06ec5ff205338e5$var$OVERFLOW_RE = /auto|scroll|overlay|hidden|clip/;
function $b06ec5ff205338e5$export$989e911fa9af580a(el) {
    const win = $b06ec5ff205338e5$export$38b2d434cce3ea22(el);
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = win.getComputedStyle(el);
    return $b06ec5ff205338e5$var$OVERFLOW_RE.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $b06ec5ff205338e5$var$isScrollable(el) {
    return el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth;
}
function $b06ec5ff205338e5$export$53a0910f038337bd(el, options) {
    const { rootEl: rootEl, ...scrollOptions } = options || {};
    if (!el || !rootEl) return;
    if (!$b06ec5ff205338e5$export$989e911fa9af580a(rootEl) || !$b06ec5ff205338e5$var$isScrollable(rootEl)) return;
    el.scrollIntoView(scrollOptions);
}
function $b06ec5ff205338e5$export$3abe133d5501edeb(element) {
    if ($b06ec5ff205338e5$export$1b3bfaa9684536aa(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
// src/point.ts
function $b06ec5ff205338e5$export$b5a2724f2c73e602(point, element) {
    const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
    const offset = {
        x: point.x - left,
        y: point.y - top
    };
    const percent = {
        x: $b06ec5ff205338e5$var$clamp(offset.x / width),
        y: $b06ec5ff205338e5$var$clamp(offset.y / height)
    };
    function getPercentValue(options = {}) {
        const { dir: dir = "ltr", orientation: orientation = "horizontal", inverted: inverted } = options;
        const invertX = typeof inverted === "object" ? inverted.x : inverted;
        const invertY = typeof inverted === "object" ? inverted.y : inverted;
        if (orientation === "horizontal") return dir === "rtl" || invertX ? 1 - percent.x : percent.x;
        return invertY ? 1 - percent.y : percent.y;
    }
    return {
        offset: offset,
        percent: percent,
        getPercentValue: getPercentValue
    };
}
// src/pointer-lock.ts
function $b06ec5ff205338e5$export$1f5d6fe16dcd7702(doc, fn) {
    const body = doc.body;
    const supported = "pointerLockElement" in doc || "mozPointerLockElement" in doc;
    const isLocked = ()=>!!doc.pointerLockElement;
    function onPointerChange() {
        fn?.(isLocked());
    }
    function onPointerError(event) {
        if (isLocked()) fn?.(false);
        console.error("PointerLock error occurred:", event);
        doc.exitPointerLock();
    }
    if (!supported) return;
    try {
        body.requestPointerLock();
    } catch  {}
    const cleanup = [
        $b06ec5ff205338e5$export$b1d829ddf82884aa(doc, "pointerlockchange", onPointerChange, false),
        $b06ec5ff205338e5$export$b1d829ddf82884aa(doc, "pointerlockerror", onPointerError, false)
    ];
    return ()=>{
        cleanup.forEach((cleanup2)=>cleanup2());
        doc.exitPointerLock();
    };
}
// src/text-selection.ts
var $b06ec5ff205338e5$var$state = "default";
var $b06ec5ff205338e5$var$userSelect = "";
var $b06ec5ff205338e5$var$elementMap = /* @__PURE__ */ new WeakMap();
function $b06ec5ff205338e5$var$disableTextSelectionImpl(options = {}) {
    const { target: target, doc: doc } = options;
    const docNode = doc ?? document;
    const rootEl = docNode.documentElement;
    if ($b06ec5ff205338e5$export$41a665f744414057()) {
        if ($b06ec5ff205338e5$var$state === "default") {
            $b06ec5ff205338e5$var$userSelect = rootEl.style.webkitUserSelect;
            rootEl.style.webkitUserSelect = "none";
        }
        $b06ec5ff205338e5$var$state = "disabled";
    } else if (target) {
        $b06ec5ff205338e5$var$elementMap.set(target, target.style.userSelect);
        target.style.userSelect = "none";
    }
    return ()=>$b06ec5ff205338e5$export$b0d6fa1ab32e3295({
            target: target,
            doc: docNode
        });
}
function $b06ec5ff205338e5$export$b0d6fa1ab32e3295(options = {}) {
    const { target: target, doc: doc } = options;
    const docNode = doc ?? document;
    const rootEl = docNode.documentElement;
    if ($b06ec5ff205338e5$export$41a665f744414057()) {
        if ($b06ec5ff205338e5$var$state !== "disabled") return;
        $b06ec5ff205338e5$var$state = "restoring";
        setTimeout(()=>{
            $b06ec5ff205338e5$export$bdd553fddd433dcb(()=>{
                if ($b06ec5ff205338e5$var$state === "restoring") {
                    if (rootEl.style.webkitUserSelect === "none") rootEl.style.webkitUserSelect = $b06ec5ff205338e5$var$userSelect || "";
                    $b06ec5ff205338e5$var$userSelect = "";
                    $b06ec5ff205338e5$var$state = "default";
                }
            });
        }, 300);
    } else if (target && $b06ec5ff205338e5$var$elementMap.has(target)) {
        const prevUserSelect = $b06ec5ff205338e5$var$elementMap.get(target);
        if (target.style.userSelect === "none") target.style.userSelect = prevUserSelect ?? "";
        if (target.getAttribute("style") === "") target.removeAttribute("style");
        $b06ec5ff205338e5$var$elementMap.delete(target);
    }
}
function $b06ec5ff205338e5$export$16a4697467175487(options = {}) {
    const { defer: defer, target: target, ...restOptions } = options;
    const func = defer ? $b06ec5ff205338e5$export$27f233d61a9e2fa4 : (v)=>v();
    const cleanups2 = [];
    cleanups2.push(func(()=>{
        const node = typeof target === "function" ? target() : target;
        cleanups2.push($b06ec5ff205338e5$var$disableTextSelectionImpl({
            ...restOptions,
            target: node
        }));
    }));
    return ()=>{
        cleanups2.forEach((fn)=>fn?.());
    };
}
// src/pointer-move.ts
function $b06ec5ff205338e5$export$71f75065f080cb5b(doc, handlers) {
    const { onPointerMove: onPointerMove, onPointerUp: onPointerUp } = handlers;
    const handleMove = (event)=>{
        const point = $b06ec5ff205338e5$export$a8637644cbd23a7b(event);
        const distance = Math.sqrt(point.x ** 2 + point.y ** 2);
        const moveBuffer = event.pointerType === "touch" ? 10 : 5;
        if (distance < moveBuffer) return;
        if (event.pointerType === "mouse" && event.button === 0) {
            onPointerUp();
            return;
        }
        onPointerMove({
            point: point,
            event: event
        });
    };
    const cleanups2 = [
        $b06ec5ff205338e5$export$b1d829ddf82884aa(doc, "pointermove", handleMove, false),
        $b06ec5ff205338e5$export$b1d829ddf82884aa(doc, "pointerup", onPointerUp, false),
        $b06ec5ff205338e5$export$b1d829ddf82884aa(doc, "pointercancel", onPointerUp, false),
        $b06ec5ff205338e5$export$b1d829ddf82884aa(doc, "contextmenu", onPointerUp, false),
        $b06ec5ff205338e5$export$16a4697467175487({
            doc: doc
        })
    ];
    return ()=>{
        cleanups2.forEach((cleanup)=>cleanup());
    };
}
// src/press.ts
function $b06ec5ff205338e5$export$9a7215eeb3481da(options) {
    const { pointerNode: pointerNode, keyboardNode: keyboardNode = pointerNode, onPress: onPress, onPressStart: onPressStart, onPressEnd: onPressEnd, isValidKey: isValidKey = (e)=>e.key === "Enter" } = options;
    if (!pointerNode) return $b06ec5ff205338e5$var$noop;
    const win = $b06ec5ff205338e5$export$38b2d434cce3ea22(pointerNode);
    const doc = $b06ec5ff205338e5$export$f65ca476c09acec0(pointerNode);
    let removeStartListeners = $b06ec5ff205338e5$var$noop;
    let removeEndListeners = $b06ec5ff205338e5$var$noop;
    let removeAccessibleListeners = $b06ec5ff205338e5$var$noop;
    const getInfo = (event)=>({
            point: $b06ec5ff205338e5$export$a8637644cbd23a7b(event),
            event: event
        });
    function startPress(event) {
        onPressStart?.(getInfo(event));
    }
    function cancelPress(event) {
        onPressEnd?.(getInfo(event));
    }
    const startPointerPress = (startEvent)=>{
        removeEndListeners();
        const endPointerPress = (endEvent)=>{
            const target = $b06ec5ff205338e5$export$e58f029f0fbfdb29(endEvent);
            if ($b06ec5ff205338e5$export$2344b14b097df817(pointerNode, target)) onPress?.(getInfo(endEvent));
            else onPressEnd?.(getInfo(endEvent));
        };
        const removePointerUpListener = $b06ec5ff205338e5$export$b1d829ddf82884aa(win, "pointerup", endPointerPress, {
            passive: !onPress
        });
        const removePointerCancelListener = $b06ec5ff205338e5$export$b1d829ddf82884aa(win, "pointercancel", cancelPress, {
            passive: !onPressEnd
        });
        removeEndListeners = $b06ec5ff205338e5$var$pipe(removePointerUpListener, removePointerCancelListener);
        if (doc.activeElement === keyboardNode && startEvent.pointerType === "mouse") startEvent.preventDefault();
        startPress(startEvent);
    };
    const removePointerListener = $b06ec5ff205338e5$export$b1d829ddf82884aa(pointerNode, "pointerdown", startPointerPress, {
        passive: !onPressStart
    });
    const removeFocusListener = $b06ec5ff205338e5$export$b1d829ddf82884aa(keyboardNode, "focus", startAccessiblePress);
    removeStartListeners = $b06ec5ff205338e5$var$pipe(removePointerListener, removeFocusListener);
    function startAccessiblePress() {
        const handleKeydown = (keydownEvent)=>{
            if (!isValidKey(keydownEvent)) return;
            const handleKeyup = (keyupEvent)=>{
                if (!isValidKey(keyupEvent)) return;
                const evt2 = new win.PointerEvent("pointerup");
                const info = getInfo(evt2);
                onPress?.(info);
                onPressEnd?.(info);
            };
            removeEndListeners();
            removeEndListeners = $b06ec5ff205338e5$export$b1d829ddf82884aa(keyboardNode, "keyup", handleKeyup);
            const evt = new win.PointerEvent("pointerdown");
            startPress(evt);
        };
        const handleBlur = ()=>{
            const evt = new win.PointerEvent("pointercancel");
            cancelPress(evt);
        };
        const removeKeydownListener = $b06ec5ff205338e5$export$b1d829ddf82884aa(keyboardNode, "keydown", handleKeydown);
        const removeBlurListener = $b06ec5ff205338e5$export$b1d829ddf82884aa(keyboardNode, "blur", handleBlur);
        removeAccessibleListeners = $b06ec5ff205338e5$var$pipe(removeKeydownListener, removeBlurListener);
    }
    return ()=>{
        removeStartListeners();
        removeEndListeners();
        removeAccessibleListeners();
    };
}
// src/proxy-tab-focus.ts
function $b06ec5ff205338e5$var$proxyTabFocusImpl(container, options = {}) {
    const { triggerElement: triggerElement, onFocus: onFocus } = options;
    const doc = container?.ownerDocument || document;
    const body = doc.body;
    function onKeyDown(event) {
        if (event.key !== "Tab") return;
        let elementToFocus = null;
        const [firstTabbable, lastTabbable] = $b06ec5ff205338e5$export$1b7701f2d138464c(container, true);
        const noTabbableElements = !firstTabbable && !lastTabbable;
        if (event.shiftKey && (doc.activeElement === firstTabbable || noTabbableElements)) elementToFocus = triggerElement;
        else if (!event.shiftKey && doc.activeElement === triggerElement) elementToFocus = firstTabbable;
        else if (!event.shiftKey && (doc.activeElement === lastTabbable || noTabbableElements)) elementToFocus = $b06ec5ff205338e5$export$28f33206776129a7(body, triggerElement);
        if (!elementToFocus) return;
        event.preventDefault();
        if (typeof onFocus === "function") onFocus(elementToFocus);
        else elementToFocus.focus();
    }
    return $b06ec5ff205338e5$export$b1d829ddf82884aa(doc, "keydown", onKeyDown, true);
}
function $b06ec5ff205338e5$export$c90f8060ab168f84(container, options) {
    const { defer: defer, triggerElement: triggerElement, ...restOptions } = options;
    const func = defer ? $b06ec5ff205338e5$export$27f233d61a9e2fa4 : (v)=>v();
    const cleanups2 = [];
    cleanups2.push(func(()=>{
        const node = typeof container === "function" ? container() : container;
        const trigger = typeof triggerElement === "function" ? triggerElement() : triggerElement;
        cleanups2.push($b06ec5ff205338e5$var$proxyTabFocusImpl(node, {
            triggerElement: trigger,
            ...restOptions
        }));
    }));
    return ()=>{
        cleanups2.forEach((fn)=>fn?.());
    };
}
// src/query.ts
function $b06ec5ff205338e5$export$dcd0d083aa86c355(root, selector) {
    return Array.from(root?.querySelectorAll(selector) ?? []);
}
function $b06ec5ff205338e5$export$2fa187e846a241c4(root, selector) {
    return root?.querySelector(selector) ?? null;
}
var $b06ec5ff205338e5$export$b1c92eba80c58b85 = (v)=>v.id;
function $b06ec5ff205338e5$export$9c576e34c0103ac9(v, id, itemToId = $b06ec5ff205338e5$export$b1c92eba80c58b85) {
    return v.find((item)=>itemToId(item) === id);
}
function $b06ec5ff205338e5$export$b3919dc3604f191c(v, id, itemToId = $b06ec5ff205338e5$export$b1c92eba80c58b85) {
    const item = $b06ec5ff205338e5$export$9c576e34c0103ac9(v, id, itemToId);
    return item ? v.indexOf(item) : -1;
}
function $b06ec5ff205338e5$export$f3d559454b8c0d00(v, id, loop = true) {
    let idx = $b06ec5ff205338e5$export$b3919dc3604f191c(v, id);
    idx = loop ? (idx + 1) % v.length : Math.min(idx + 1, v.length - 1);
    return v[idx];
}
function $b06ec5ff205338e5$export$326274ae311c62fd(v, id, loop = true) {
    let idx = $b06ec5ff205338e5$export$b3919dc3604f191c(v, id);
    if (idx === -1) return loop ? v[v.length - 1] : null;
    idx = loop ? (idx - 1 + v.length) % v.length : Math.max(0, idx - 1);
    return v[idx];
}
// src/scope.ts
function $b06ec5ff205338e5$export$41a9651decfe2bde(methods) {
    const dom = {
        getRootNode: (ctx)=>ctx.getRootNode?.() ?? document,
        getDoc: (ctx)=>$b06ec5ff205338e5$export$f65ca476c09acec0(dom.getRootNode(ctx)),
        getWin: (ctx)=>dom.getDoc(ctx).defaultView ?? window,
        getActiveElement: (ctx)=>$b06ec5ff205338e5$export$cd4e5573fbe2b576(dom.getRootNode(ctx)),
        isActiveElement: (ctx, elem)=>elem === dom.getActiveElement(ctx),
        getById: (ctx, id)=>dom.getRootNode(ctx).getElementById(id),
        setValue: (elem, value)=>{
            if (elem == null || value == null) return;
            $b06ec5ff205338e5$export$c2c7fef809f2f8ef(elem, value.toString());
        }
    };
    return {
        ...dom,
        ...methods
    };
}
// src/searchable.ts
var $b06ec5ff205338e5$var$sanitize = (str)=>str.split("").map((char)=>{
        const code = char.charCodeAt(0);
        if (code > 0 && code < 128) return char;
        if (code >= 128 && code <= 255) return `/x${code.toString(16)}`.replace("/", "\\");
        return "";
    }).join("").trim();
var $b06ec5ff205338e5$var$getValueText = (el)=>{
    return $b06ec5ff205338e5$var$sanitize(el.dataset?.valuetext ?? el.textContent ?? "");
};
var $b06ec5ff205338e5$var$match = (valueText, query2)=>{
    return valueText.trim().toLowerCase().startsWith(query2.toLowerCase());
};
function $b06ec5ff205338e5$export$cade8123d3662a60(v, text, currentId, itemToId = $b06ec5ff205338e5$export$b1c92eba80c58b85) {
    const index = currentId ? $b06ec5ff205338e5$export$b3919dc3604f191c(v, currentId, itemToId) : -1;
    let items = currentId ? $b06ec5ff205338e5$var$wrap(v, index) : v;
    const isSingleKey = text.length === 1;
    if (isSingleKey) items = items.filter((item)=>itemToId(item) !== currentId);
    return items.find((item)=>$b06ec5ff205338e5$var$match($b06ec5ff205338e5$var$getValueText(item), text));
}
// src/set.ts
var $b06ec5ff205338e5$var$cleanups = /* @__PURE__ */ new WeakMap();
function $b06ec5ff205338e5$var$set(element, key, setup) {
    if (!$b06ec5ff205338e5$var$cleanups.has(element)) $b06ec5ff205338e5$var$cleanups.set(element, /* @__PURE__ */ new Map());
    const elementCleanups = $b06ec5ff205338e5$var$cleanups.get(element);
    const prevCleanup = elementCleanups.get(key);
    if (!prevCleanup) {
        elementCleanups.set(key, setup());
        return ()=>{
            elementCleanups.get(key)?.();
            elementCleanups.delete(key);
        };
    }
    const cleanup = setup();
    const nextCleanup = ()=>{
        cleanup();
        prevCleanup();
        elementCleanups.delete(key);
    };
    elementCleanups.set(key, nextCleanup);
    return ()=>{
        const isCurrent = elementCleanups.get(key) === nextCleanup;
        if (!isCurrent) return;
        cleanup();
        elementCleanups.set(key, prevCleanup);
    };
}
function $b06ec5ff205338e5$export$9fec4d97f1922e0b(element, attr, value) {
    const setup = ()=>{
        const previousValue = element.getAttribute(attr);
        element.setAttribute(attr, value);
        return ()=>{
            if (previousValue == null) element.removeAttribute(attr);
            else element.setAttribute(attr, previousValue);
        };
    };
    return $b06ec5ff205338e5$var$set(element, attr, setup);
}
function $b06ec5ff205338e5$export$a41c68a4eb5ff164(element, property, value) {
    const setup = ()=>{
        const exists = property in element;
        const previousValue = element[property];
        element[property] = value;
        return ()=>{
            if (!exists) delete element[property];
            else element[property] = previousValue;
        };
    };
    return $b06ec5ff205338e5$var$set(element, property, setup);
}
function $b06ec5ff205338e5$export$37a5fde709c1db82(element, style) {
    if (!element) return ()=>{};
    const setup = ()=>{
        const prevStyle = element.style.cssText;
        Object.assign(element.style, style);
        return ()=>{
            element.style.cssText = prevStyle;
        };
    };
    return $b06ec5ff205338e5$var$set(element, "style", setup);
}
// src/typeahead.ts
function $b06ec5ff205338e5$var$getByTypeaheadImpl(baseItems, options) {
    const { state: state2, activeId: activeId, key: key, timeout: timeout = 350, itemToId: itemToId } = options;
    const search = state2.keysSoFar + key;
    const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]);
    const query2 = isRepeated ? search[0] : search;
    let items = baseItems.slice();
    const next = $b06ec5ff205338e5$export$cade8123d3662a60(items, query2, activeId, itemToId);
    function cleanup() {
        clearTimeout(state2.timer);
        state2.timer = -1;
    }
    function update(value) {
        state2.keysSoFar = value;
        cleanup();
        if (value !== "") state2.timer = +setTimeout(()=>{
            update("");
            cleanup();
        }, timeout);
    }
    update(search);
    return next;
}
var $b06ec5ff205338e5$export$ec2dfd1ac255c804 = /* @__PURE__ */ Object.assign($b06ec5ff205338e5$var$getByTypeaheadImpl, {
    defaultOptions: {
        keysSoFar: "",
        timer: -1
    },
    isValidEvent: $b06ec5ff205338e5$var$isValidTypeaheadEvent
});
function $b06ec5ff205338e5$var$isValidTypeaheadEvent(event) {
    return event.key.length === 1 && !event.ctrlKey && !event.metaKey;
}
// src/visual-viewport.ts
function $b06ec5ff205338e5$export$a75724614b3b2d4b(doc, fn) {
    const win = doc?.defaultView || window;
    const onResize = ()=>{
        fn?.($b06ec5ff205338e5$var$getViewportSize(win));
    };
    onResize();
    return $b06ec5ff205338e5$export$b1d829ddf82884aa(win.visualViewport ?? win, "resize", onResize);
}
function $b06ec5ff205338e5$var$getViewportSize(win) {
    return {
        width: win.visualViewport?.width || win.innerWidth,
        height: win.visualViewport?.height || win.innerHeight
    };
}
// src/visually-hidden.ts
var $b06ec5ff205338e5$export$8fecac46448b5689 = {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px",
    whiteSpace: "nowrap",
    wordWrap: "normal"
};
function $b06ec5ff205338e5$export$ca1f3b6b815c75ae(el) {
    Object.assign(el.style, $b06ec5ff205338e5$export$8fecac46448b5689);
}
// src/wait-for.ts
var $b06ec5ff205338e5$var$fps = 1e3 / 60;
function $b06ec5ff205338e5$export$1a1c301579a08d1e(query2, cb) {
    const el = query2();
    if ($b06ec5ff205338e5$export$1b3bfaa9684536aa(el) && el.isConnected) {
        cb(el);
        return ()=>void 0;
    } else {
        const timerId = setInterval(()=>{
            const el2 = query2();
            if ($b06ec5ff205338e5$export$1b3bfaa9684536aa(el2) && el2.isConnected) {
                cb(el2);
                clearInterval(timerId);
            }
        }, $b06ec5ff205338e5$var$fps);
        return ()=>clearInterval(timerId);
    }
}
function $b06ec5ff205338e5$export$dfc394f7db44feeb(queries, cb) {
    const cleanups2 = [];
    queries?.forEach((query2)=>{
        const clean = $b06ec5ff205338e5$export$1a1c301579a08d1e(query2, cb);
        cleanups2.push(clean);
    });
    return ()=>{
        cleanups2.forEach((fn)=>fn());
    };
}



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $acw62 = parcelRequire("acw62");
"use client";
function $c09f1c0fc6a95cc7$var$getErrorMessage(hook, provider) {
    return `${hook} returned \`undefined\`. Seems you forgot to wrap component within ${provider}`;
}
function $c09f1c0fc6a95cc7$export$fd42f52fd3ae1109(options = {}) {
    const { name: name, strict: strict = true, hookName: hookName = "useContext", providerName: providerName = "Provider", errorMessage: errorMessage, defaultValue: defaultValue } = options;
    const Context = (0, $acw62.createContext)(defaultValue);
    Context.displayName = name;
    function useContext$1() {
        const context = (0, $acw62.useContext)(Context);
        if (!context && strict) {
            const error = new Error(errorMessage ?? $c09f1c0fc6a95cc7$var$getErrorMessage(hookName, providerName));
            error.name = "ContextError";
            Error.captureStackTrace?.(error, useContext$1);
            throw error;
        }
        return context;
    }
    return [
        Context.Provider,
        useContext$1,
        Context
    ];
}


"use client";
const [$059158563f8f31ee$export$f25ed4a90a0c3c0c, $059158563f8f31ee$export$899b1e582a0b3c80] = (0, $c09f1c0fc6a95cc7$export$fd42f52fd3ae1109)({
    name: "EnvironmentContext",
    hookName: "useEnvironmentContext",
    providerName: "<EnvironmentProvider />",
    strict: false,
    defaultValue: {
        getRootNode: ()=>document,
        getDocument: ()=>document,
        getWindow: ()=>window
    }
});


"use client";
const $0aa5f269574efb3e$export$602eac185826482c = (props)=>{
    const { children: children, disabled: disabled } = props;
    const [container, setContainer] = (0, $acw62.useState)(props.container?.current);
    const isServer = (0, $acw62.useSyncExternalStore)($0aa5f269574efb3e$var$subscribe, ()=>false, ()=>true);
    const { getRootNode: getRootNode } = (0, $059158563f8f31ee$export$899b1e582a0b3c80)();
    (0, $acw62.useEffect)(()=>{
        setContainer(()=>props.container?.current);
    }, [
        props.container
    ]);
    if (isServer || disabled) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    });
    const mountNode = container ?? $0aa5f269574efb3e$var$getPortalNode(getRootNode);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: (0, $acw62.Children).map(children, (child)=>(0, $1u0KT.createPortal)(child, mountNode))
    });
};
const $0aa5f269574efb3e$var$getPortalNode = (cb)=>{
    const node = cb?.();
    const rootNode = node.getRootNode();
    if ((0, $b06ec5ff205338e5$export$af51f0f06c0f328a)(rootNode)) return rootNode;
    return (0, $b06ec5ff205338e5$export$f65ca476c09acec0)(node).body;
};
const $0aa5f269574efb3e$var$subscribe = ()=>()=>{};

var $54141a59eba486c0$exports = {};

$parcel$export($54141a59eba486c0$exports, "Arrow", () => $8d803391fcba4002$export$c27ee0ad710f7559);
$parcel$export($54141a59eba486c0$exports, "ArrowTip", () => $8d803391fcba4002$export$c3ab883c081fd14b);
$parcel$export($54141a59eba486c0$exports, "Content", () => $8d803391fcba4002$export$e9003e2be37ec060);
$parcel$export($54141a59eba486c0$exports, "Context", () => $8d803391fcba4002$export$39ae08fa83328b12);
$parcel$export($54141a59eba486c0$exports, "Positioner", () => $8d803391fcba4002$export$84b0dae449d0e8f7);
$parcel$export($54141a59eba486c0$exports, "PropsProvider", () => $8d803391fcba4002$export$f5fb98130cf3ead9);
$parcel$export($54141a59eba486c0$exports, "Root", () => $8d803391fcba4002$export$c21697e1ea9173ed);
$parcel$export($54141a59eba486c0$exports, "RootProvider", () => $8d803391fcba4002$export$946771a20dbdbfa1);
$parcel$export($54141a59eba486c0$exports, "Trigger", () => $8d803391fcba4002$export$8c610744efcf8a1d);
var $ef898291ec002f82$exports = {};

$parcel$export($ef898291ec002f82$exports, "Arrow", () => $2425566c512fd661$export$c27ee0ad710f7559);
$parcel$export($ef898291ec002f82$exports, "ArrowTip", () => $c6a7754970035450$export$c3ab883c081fd14b);
$parcel$export($ef898291ec002f82$exports, "Content", () => $ad73072fbd419abf$export$e9003e2be37ec060);
$parcel$export($ef898291ec002f82$exports, "Context", () => $22105b3d7679a48f$export$39ae08fa83328b12);
$parcel$export($ef898291ec002f82$exports, "Positioner", () => $560c721fd21d66e5$export$84b0dae449d0e8f7);
$parcel$export($ef898291ec002f82$exports, "Root", () => $242f66612319711c$export$c21697e1ea9173ed);
$parcel$export($ef898291ec002f82$exports, "RootProvider", () => $cf6599fdc73c5e78$export$946771a20dbdbfa1);
$parcel$export($ef898291ec002f82$exports, "Trigger", () => $f26e0653a2ead678$export$8c610744efcf8a1d);

/* eslint @typescript-eslint/no-explicit-any: off */ // symbols
const $2364deb6cb3c9389$var$TRACK_MEMO_SYMBOL = Symbol();
const $2364deb6cb3c9389$var$GET_ORIGINAL_SYMBOL = Symbol();
// properties
const $2364deb6cb3c9389$var$AFFECTED_PROPERTY = "a";
const $2364deb6cb3c9389$var$IS_TARGET_COPIED_PROPERTY = "f";
const $2364deb6cb3c9389$var$PROXY_PROPERTY = "p";
const $2364deb6cb3c9389$var$PROXY_CACHE_PROPERTY = "c";
const $2364deb6cb3c9389$var$TARGET_CACHE_PROPERTY = "t";
const $2364deb6cb3c9389$var$HAS_KEY_PROPERTY = "h";
const $2364deb6cb3c9389$var$ALL_OWN_KEYS_PROPERTY = "w";
const $2364deb6cb3c9389$var$HAS_OWN_KEY_PROPERTY = "o";
const $2364deb6cb3c9389$var$KEYS_PROPERTY = "k";
// function to create a new bare proxy
let $2364deb6cb3c9389$var$newProxy = (target, handler)=>new Proxy(target, handler);
// get object prototype
const $2364deb6cb3c9389$var$getProto = Object.getPrototypeOf;
const $2364deb6cb3c9389$var$objectsToTrack = new WeakMap();
// check if obj is a plain object or an array
const $2364deb6cb3c9389$var$isObjectToTrack = (obj)=>obj && ($2364deb6cb3c9389$var$objectsToTrack.has(obj) ? $2364deb6cb3c9389$var$objectsToTrack.get(obj) : $2364deb6cb3c9389$var$getProto(obj) === Object.prototype || $2364deb6cb3c9389$var$getProto(obj) === Array.prototype);
// check if it is object
const $2364deb6cb3c9389$var$isObject = (x)=>typeof x === "object" && x !== null;
// Properties that are both non-configurable and non-writable will break
// the proxy get trap when we try to return a recursive/child compare proxy
// from them. We can avoid this by making a copy of the target object with
// all descriptors marked as configurable, see `copyTargetObject`.
// See: https://github.com/dai-shi/proxy-compare/pull/8
const $2364deb6cb3c9389$var$needsToCopyTargetObject = (obj)=>Object.values(Object.getOwnPropertyDescriptors(obj)).some((descriptor)=>!descriptor.configurable && !descriptor.writable);
// Make a copy with all descriptors marked as configurable.
const $2364deb6cb3c9389$var$copyTargetObject = (obj)=>{
    if (Array.isArray(obj)) // Arrays need a special way to copy
    return Array.from(obj);
    // For non-array objects, we create a new object keeping the prototype
    // with changing all configurable options (otherwise, proxies will complain)
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    Object.values(descriptors).forEach((desc)=>{
        desc.configurable = true;
    });
    return Object.create($2364deb6cb3c9389$var$getProto(obj), descriptors);
};
const $2364deb6cb3c9389$var$createProxyHandler = (origObj, isTargetCopied)=>{
    const state = {
        [$2364deb6cb3c9389$var$IS_TARGET_COPIED_PROPERTY]: isTargetCopied
    };
    let trackObject = false; // for trackMemo
    const recordUsage = (type, key)=>{
        if (!trackObject) {
            let used = state[$2364deb6cb3c9389$var$AFFECTED_PROPERTY].get(origObj);
            if (!used) {
                used = {};
                state[$2364deb6cb3c9389$var$AFFECTED_PROPERTY].set(origObj, used);
            }
            if (type === $2364deb6cb3c9389$var$ALL_OWN_KEYS_PROPERTY) used[$2364deb6cb3c9389$var$ALL_OWN_KEYS_PROPERTY] = true;
            else {
                let set = used[type];
                if (!set) {
                    set = new Set();
                    used[type] = set;
                }
                set.add(key);
            }
        }
    };
    const recordObjectAsUsed = ()=>{
        trackObject = true;
        state[$2364deb6cb3c9389$var$AFFECTED_PROPERTY].delete(origObj);
    };
    const handler = {
        get (target, key) {
            if (key === $2364deb6cb3c9389$var$GET_ORIGINAL_SYMBOL) return origObj;
            recordUsage($2364deb6cb3c9389$var$KEYS_PROPERTY, key);
            return $2364deb6cb3c9389$export$7865d0c7f908de6b(Reflect.get(target, key), state[$2364deb6cb3c9389$var$AFFECTED_PROPERTY], state[$2364deb6cb3c9389$var$PROXY_CACHE_PROPERTY], state[$2364deb6cb3c9389$var$TARGET_CACHE_PROPERTY]);
        },
        has (target, key) {
            if (key === $2364deb6cb3c9389$var$TRACK_MEMO_SYMBOL) {
                recordObjectAsUsed();
                return true;
            }
            recordUsage($2364deb6cb3c9389$var$HAS_KEY_PROPERTY, key);
            return Reflect.has(target, key);
        },
        getOwnPropertyDescriptor (target, key) {
            recordUsage($2364deb6cb3c9389$var$HAS_OWN_KEY_PROPERTY, key);
            return Reflect.getOwnPropertyDescriptor(target, key);
        },
        ownKeys (target) {
            recordUsage($2364deb6cb3c9389$var$ALL_OWN_KEYS_PROPERTY);
            return Reflect.ownKeys(target);
        }
    };
    if (isTargetCopied) handler.set = handler.deleteProperty = ()=>false;
    return [
        handler,
        state
    ];
};
const $2364deb6cb3c9389$var$getOriginalObject = (obj)=>// unwrap proxy
    obj[$2364deb6cb3c9389$var$GET_ORIGINAL_SYMBOL] || // otherwise
    obj;
const $2364deb6cb3c9389$export$7865d0c7f908de6b = (obj, affected, proxyCache, targetCache)=>{
    if (!$2364deb6cb3c9389$var$isObjectToTrack(obj)) return obj;
    let targetAndCopied = targetCache && targetCache.get(obj);
    if (!targetAndCopied) {
        const target = $2364deb6cb3c9389$var$getOriginalObject(obj);
        if ($2364deb6cb3c9389$var$needsToCopyTargetObject(target)) targetAndCopied = [
            target,
            $2364deb6cb3c9389$var$copyTargetObject(target)
        ];
        else targetAndCopied = [
            target
        ];
        targetCache === null || targetCache === void 0 || targetCache.set(obj, targetAndCopied);
    }
    const [target, copiedTarget] = targetAndCopied;
    let handlerAndState = proxyCache && proxyCache.get(target);
    if (!handlerAndState || handlerAndState[1][$2364deb6cb3c9389$var$IS_TARGET_COPIED_PROPERTY] !== !!copiedTarget) {
        handlerAndState = $2364deb6cb3c9389$var$createProxyHandler(target, !!copiedTarget);
        handlerAndState[1][$2364deb6cb3c9389$var$PROXY_PROPERTY] = $2364deb6cb3c9389$var$newProxy(copiedTarget || target, handlerAndState[0]);
        if (proxyCache) proxyCache.set(target, handlerAndState);
    }
    handlerAndState[1][$2364deb6cb3c9389$var$AFFECTED_PROPERTY] = affected;
    handlerAndState[1][$2364deb6cb3c9389$var$PROXY_CACHE_PROPERTY] = proxyCache;
    handlerAndState[1][$2364deb6cb3c9389$var$TARGET_CACHE_PROPERTY] = targetCache;
    return handlerAndState[1][$2364deb6cb3c9389$var$PROXY_PROPERTY];
};
const $2364deb6cb3c9389$var$isAllOwnKeysChanged = (prevObj, nextObj)=>{
    const prevKeys = Reflect.ownKeys(prevObj);
    const nextKeys = Reflect.ownKeys(nextObj);
    return prevKeys.length !== nextKeys.length || prevKeys.some((k, i)=>k !== nextKeys[i]);
};
const $2364deb6cb3c9389$export$3a85b3f4caf02b6f = (prevObj, nextObj, affected, cache, isEqual = Object.is)=>{
    if (isEqual(prevObj, nextObj)) return false;
    if (!$2364deb6cb3c9389$var$isObject(prevObj) || !$2364deb6cb3c9389$var$isObject(nextObj)) return true;
    const used = affected.get($2364deb6cb3c9389$var$getOriginalObject(prevObj));
    if (!used) return true;
    if (cache) {
        const hit = cache.get(prevObj);
        if (hit === nextObj) return false;
        // for object with cycles
        cache.set(prevObj, nextObj);
    }
    let changed = null;
    for (const key of used[$2364deb6cb3c9389$var$HAS_KEY_PROPERTY] || []){
        changed = Reflect.has(prevObj, key) !== Reflect.has(nextObj, key);
        if (changed) return changed;
    }
    if (used[$2364deb6cb3c9389$var$ALL_OWN_KEYS_PROPERTY] === true) {
        changed = $2364deb6cb3c9389$var$isAllOwnKeysChanged(prevObj, nextObj);
        if (changed) return changed;
    } else for (const key of used[$2364deb6cb3c9389$var$HAS_OWN_KEY_PROPERTY] || []){
        const hasPrev = !!Reflect.getOwnPropertyDescriptor(prevObj, key);
        const hasNext = !!Reflect.getOwnPropertyDescriptor(nextObj, key);
        changed = hasPrev !== hasNext;
        if (changed) return changed;
    }
    for (const key of used[$2364deb6cb3c9389$var$KEYS_PROPERTY] || []){
        changed = $2364deb6cb3c9389$export$3a85b3f4caf02b6f(prevObj[key], nextObj[key], affected, cache, isEqual);
        if (changed) return changed;
    }
    if (changed === null) throw new Error("invalid used");
    return changed;
};
const $2364deb6cb3c9389$export$badc26589cf7bb38 = (obj)=>{
    if ($2364deb6cb3c9389$var$isObjectToTrack(obj)) return $2364deb6cb3c9389$var$TRACK_MEMO_SYMBOL in obj;
    return false;
};
const $2364deb6cb3c9389$export$80d2cee7ee556e99 = (obj)=>{
    if ($2364deb6cb3c9389$var$isObjectToTrack(obj)) return obj[$2364deb6cb3c9389$var$GET_ORIGINAL_SYMBOL] || null;
    return null;
};
const $2364deb6cb3c9389$export$2c8383c890e26a1c = (obj, mark = true)=>{
    $2364deb6cb3c9389$var$objectsToTrack.set(obj, mark);
};
const $2364deb6cb3c9389$export$10e85fc10e680a16 = (obj, affected, onlyWithValues)=>{
    const list = [];
    const seen = new WeakSet();
    const walk = (x, path)=>{
        var _a, _b, _c;
        if (seen.has(x)) // for object with cycles
        return;
        if ($2364deb6cb3c9389$var$isObject(x)) seen.add(x);
        const used = $2364deb6cb3c9389$var$isObject(x) && affected.get($2364deb6cb3c9389$var$getOriginalObject(x));
        if (used) {
            (_a = used[$2364deb6cb3c9389$var$HAS_KEY_PROPERTY]) === null || _a === void 0 || _a.forEach((key)=>{
                const segment = `:has(${String(key)})`;
                list.push(path ? [
                    ...path,
                    segment
                ] : [
                    segment
                ]);
            });
            if (used[$2364deb6cb3c9389$var$ALL_OWN_KEYS_PROPERTY] === true) {
                const segment = ":ownKeys";
                list.push(path ? [
                    ...path,
                    segment
                ] : [
                    segment
                ]);
            } else (_b = used[$2364deb6cb3c9389$var$HAS_OWN_KEY_PROPERTY]) === null || _b === void 0 || _b.forEach((key)=>{
                const segment = `:hasOwn(${String(key)})`;
                list.push(path ? [
                    ...path,
                    segment
                ] : [
                    segment
                ]);
            });
            (_c = used[$2364deb6cb3c9389$var$KEYS_PROPERTY]) === null || _c === void 0 || _c.forEach((key)=>{
                if (!onlyWithValues || "value" in (Object.getOwnPropertyDescriptor(x, key) || {})) walk(x[key], path ? [
                    ...path,
                    key
                ] : [
                    key
                ]);
            });
        } else if (path) list.push(path);
    };
    walk(obj);
    return list;
};
const $2364deb6cb3c9389$export$9b4d5450dbd8e67e = (fn)=>{
    $2364deb6cb3c9389$var$newProxy = fn;
};


// src/global.ts
function $7bf56e9c8ff12ab3$var$glob() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
}
function $7bf56e9c8ff12ab3$export$69db39dc95d7166e(key, value) {
    const g = $7bf56e9c8ff12ab3$var$glob();
    if (!g) return value();
    g[key] || (g[key] = value());
    return g[key];
}
var $7bf56e9c8ff12ab3$var$refSet = $7bf56e9c8ff12ab3$export$69db39dc95d7166e("__zag__refSet", ()=>/* @__PURE__ */ new WeakSet());
// src/utils.ts
var $7bf56e9c8ff12ab3$var$isReactElement = (x)=>typeof x === "object" && x !== null && "$$typeof" in x && "props" in x;
var $7bf56e9c8ff12ab3$var$isVueElement = (x)=>typeof x === "object" && x !== null && "__v_isVNode" in x;
var $7bf56e9c8ff12ab3$var$isDOMElement = (x)=>typeof x === "object" && x !== null && "nodeType" in x && typeof x.nodeName === "string";
var $7bf56e9c8ff12ab3$var$isElement = (x)=>$7bf56e9c8ff12ab3$var$isReactElement(x) || $7bf56e9c8ff12ab3$var$isVueElement(x) || $7bf56e9c8ff12ab3$var$isDOMElement(x);
var $7bf56e9c8ff12ab3$var$isObject = (x)=>x !== null && typeof x === "object";
var $7bf56e9c8ff12ab3$var$canProxy = (x)=>$7bf56e9c8ff12ab3$var$isObject(x) && !$7bf56e9c8ff12ab3$var$refSet.has(x) && (Array.isArray(x) || !(Symbol.iterator in x)) && !$7bf56e9c8ff12ab3$var$isElement(x) && !(x instanceof WeakMap) && !(x instanceof WeakSet) && !(x instanceof Error) && !(x instanceof Number) && !(x instanceof Date) && !(x instanceof String) && !(x instanceof RegExp) && !(x instanceof ArrayBuffer) && !(x instanceof Promise);
var $7bf56e9c8ff12ab3$var$isDev = ()=>false;
// src/clone.ts
function $7bf56e9c8ff12ab3$var$set(obj, key, val) {
    if (typeof val.value === "object" && !$7bf56e9c8ff12ab3$var$canProxy(val.value)) val.value = $7bf56e9c8ff12ab3$export$9cd59f9826255e47(val.value);
    if (!val.enumerable || val.get || val.set || !val.configurable || !val.writable || key === "__proto__") Object.defineProperty(obj, key, val);
    else obj[key] = val.value;
}
function $7bf56e9c8ff12ab3$export$9cd59f9826255e47(x) {
    if (typeof x !== "object") return x;
    var i = 0, k, list, tmp, str = Object.prototype.toString.call(x);
    if (str === "[object Object]") tmp = Object.create(Object.getPrototypeOf(x) || null);
    else if (str === "[object Array]") tmp = Array(x.length);
    else if (str === "[object Set]") {
        tmp = /* @__PURE__ */ new Set();
        x.forEach(function(val) {
            tmp.add($7bf56e9c8ff12ab3$export$9cd59f9826255e47(val));
        });
    } else if (str === "[object Map]") {
        tmp = /* @__PURE__ */ new Map();
        x.forEach(function(val, key) {
            tmp.set($7bf56e9c8ff12ab3$export$9cd59f9826255e47(key), $7bf56e9c8ff12ab3$export$9cd59f9826255e47(val));
        });
    } else if (str === "[object Date]") tmp = /* @__PURE__ */ new Date(+x);
    else if (str === "[object RegExp]") tmp = new RegExp(x.source, x.flags);
    else if (str === "[object DataView]") tmp = new x.constructor($7bf56e9c8ff12ab3$export$9cd59f9826255e47(x.buffer));
    else if (str === "[object ArrayBuffer]") tmp = x.slice(0);
    else if (str === "[object Blob]") tmp = x.slice();
    else if (str.slice(-6) === "Array]") tmp = new x.constructor(x);
    if (tmp) {
        for(list = Object.getOwnPropertySymbols(x); i < list.length; i++)$7bf56e9c8ff12ab3$var$set(tmp, list[i], Object.getOwnPropertyDescriptor(x, list[i]));
        for(i = 0, list = Object.getOwnPropertyNames(x); i < list.length; i++){
            if (Object.hasOwnProperty.call(tmp, k = list[i]) && tmp[k] === x[k]) continue;
            $7bf56e9c8ff12ab3$var$set(tmp, k, Object.getOwnPropertyDescriptor(x, k));
        }
    }
    return tmp || x;
}
var $7bf56e9c8ff12ab3$var$proxyStateMap = $7bf56e9c8ff12ab3$export$69db39dc95d7166e("__zag__proxyStateMap", ()=>/* @__PURE__ */ new WeakMap());
var $7bf56e9c8ff12ab3$var$buildProxyFunction = (objectIs = Object.is, newProxy = (target, handler)=>new Proxy(target, handler), snapCache = /* @__PURE__ */ new WeakMap(), createSnapshot = (target, version)=>{
    const cache = snapCache.get(target);
    if (cache?.[0] === version) return cache[1];
    const snap = Array.isArray(target) ? [] : Object.create(Object.getPrototypeOf(target));
    (0, $2364deb6cb3c9389$export$2c8383c890e26a1c)(snap, true);
    snapCache.set(target, [
        version,
        snap
    ]);
    Reflect.ownKeys(target).forEach((key)=>{
        const value = Reflect.get(target, key);
        if ($7bf56e9c8ff12ab3$var$refSet.has(value)) {
            (0, $2364deb6cb3c9389$export$2c8383c890e26a1c)(value, false);
            snap[key] = value;
        } else if ($7bf56e9c8ff12ab3$var$proxyStateMap.has(value)) snap[key] = $7bf56e9c8ff12ab3$export$b8801ea43165ed7d(value);
        else snap[key] = value;
    });
    return Object.freeze(snap);
}, proxyCache = /* @__PURE__ */ new WeakMap(), versionHolder = [
    1,
    1
], proxyFunction2 = (initialObject)=>{
    if (!$7bf56e9c8ff12ab3$var$isObject(initialObject)) throw new Error("object required");
    const found = proxyCache.get(initialObject);
    if (found) return found;
    let version = versionHolder[0];
    const listeners = /* @__PURE__ */ new Set();
    const notifyUpdate = (op, nextVersion = ++versionHolder[0])=>{
        if (version !== nextVersion) {
            version = nextVersion;
            listeners.forEach((listener)=>listener(op, nextVersion));
        }
    };
    let checkVersion = versionHolder[1];
    const ensureVersion = (nextCheckVersion = ++versionHolder[1])=>{
        if (checkVersion !== nextCheckVersion && !listeners.size) {
            checkVersion = nextCheckVersion;
            propProxyStates.forEach(([propProxyState])=>{
                const propVersion = propProxyState[1](nextCheckVersion);
                if (propVersion > version) version = propVersion;
            });
        }
        return version;
    };
    const createPropListener = (prop)=>(op, nextVersion)=>{
            const newOp = [
                ...op
            ];
            newOp[1] = [
                prop,
                ...newOp[1]
            ];
            notifyUpdate(newOp, nextVersion);
        };
    const propProxyStates = /* @__PURE__ */ new Map();
    const addPropListener = (prop, propProxyState)=>{
        if ($7bf56e9c8ff12ab3$var$isDev() && propProxyStates.has(prop)) throw new Error("prop listener already exists");
        if (listeners.size) {
            const remove = propProxyState[3](createPropListener(prop));
            propProxyStates.set(prop, [
                propProxyState,
                remove
            ]);
        } else propProxyStates.set(prop, [
            propProxyState
        ]);
    };
    const removePropListener = (prop)=>{
        const entry = propProxyStates.get(prop);
        if (entry) {
            propProxyStates.delete(prop);
            entry[1]?.();
        }
    };
    const addListener = (listener)=>{
        listeners.add(listener);
        if (listeners.size === 1) propProxyStates.forEach(([propProxyState, prevRemove], prop)=>{
            if ($7bf56e9c8ff12ab3$var$isDev() && prevRemove) throw new Error("remove already exists");
            const remove = propProxyState[3](createPropListener(prop));
            propProxyStates.set(prop, [
                propProxyState,
                remove
            ]);
        });
        const removeListener = ()=>{
            listeners.delete(listener);
            if (listeners.size === 0) propProxyStates.forEach(([propProxyState, remove], prop)=>{
                if (remove) {
                    remove();
                    propProxyStates.set(prop, [
                        propProxyState
                    ]);
                }
            });
        };
        return removeListener;
    };
    const baseObject = Array.isArray(initialObject) ? [] : Object.create(Object.getPrototypeOf(initialObject));
    const handler = {
        deleteProperty (target, prop) {
            const prevValue = Reflect.get(target, prop);
            removePropListener(prop);
            const deleted = Reflect.deleteProperty(target, prop);
            if (deleted) notifyUpdate([
                "delete",
                [
                    prop
                ],
                prevValue
            ]);
            return deleted;
        },
        set (target, prop, value, receiver) {
            const hasPrevValue = Reflect.has(target, prop);
            const prevValue = Reflect.get(target, prop, receiver);
            if (hasPrevValue && (objectIs(prevValue, value) || proxyCache.has(value) && objectIs(prevValue, proxyCache.get(value)))) return true;
            removePropListener(prop);
            if ($7bf56e9c8ff12ab3$var$isObject(value)) value = (0, $2364deb6cb3c9389$export$80d2cee7ee556e99)(value) || value;
            let nextValue = value;
            if (Object.getOwnPropertyDescriptor(target, prop)?.set) ;
            else {
                if (!$7bf56e9c8ff12ab3$var$proxyStateMap.has(value) && $7bf56e9c8ff12ab3$var$canProxy(value)) nextValue = $7bf56e9c8ff12ab3$export$923f96dd5afa9ce6(value);
                const childProxyState = !$7bf56e9c8ff12ab3$var$refSet.has(nextValue) && $7bf56e9c8ff12ab3$var$proxyStateMap.get(nextValue);
                if (childProxyState) addPropListener(prop, childProxyState);
            }
            Reflect.set(target, prop, nextValue, receiver);
            notifyUpdate([
                "set",
                [
                    prop
                ],
                value,
                prevValue
            ]);
            return true;
        }
    };
    const proxyObject = newProxy(baseObject, handler);
    proxyCache.set(initialObject, proxyObject);
    const proxyState = [
        baseObject,
        ensureVersion,
        createSnapshot,
        addListener
    ];
    $7bf56e9c8ff12ab3$var$proxyStateMap.set(proxyObject, proxyState);
    Reflect.ownKeys(initialObject).forEach((key)=>{
        const desc = Object.getOwnPropertyDescriptor(initialObject, key);
        if (desc.get || desc.set) Object.defineProperty(baseObject, key, desc);
        else proxyObject[key] = initialObject[key];
    });
    return proxyObject;
})=>[
        // public functions
        proxyFunction2,
        // shared state
        $7bf56e9c8ff12ab3$var$proxyStateMap,
        $7bf56e9c8ff12ab3$var$refSet,
        // internal things
        objectIs,
        newProxy,
        $7bf56e9c8ff12ab3$var$canProxy,
        snapCache,
        createSnapshot,
        proxyCache,
        versionHolder
    ];
var [$7bf56e9c8ff12ab3$var$proxyFunction] = $7bf56e9c8ff12ab3$var$buildProxyFunction();
function $7bf56e9c8ff12ab3$export$923f96dd5afa9ce6(initialObject = {}) {
    return $7bf56e9c8ff12ab3$var$proxyFunction(initialObject);
}
function $7bf56e9c8ff12ab3$export$ec068583843480e7(proxyObject, callback, notifyInSync) {
    const proxyState = $7bf56e9c8ff12ab3$var$proxyStateMap.get(proxyObject);
    if ($7bf56e9c8ff12ab3$var$isDev() && !proxyState) console.warn("Please use proxy object");
    let promise;
    const ops = [];
    const addListener = proxyState[3];
    let isListenerActive = false;
    const listener = (op)=>{
        ops.push(op);
        if (notifyInSync) {
            callback(ops.splice(0));
            return;
        }
        if (!promise) promise = Promise.resolve().then(()=>{
            promise = void 0;
            if (isListenerActive) callback(ops.splice(0));
        });
    };
    const removeListener = addListener(listener);
    isListenerActive = true;
    return ()=>{
        isListenerActive = false;
        removeListener();
    };
}
function $7bf56e9c8ff12ab3$export$b8801ea43165ed7d(proxyObject) {
    const proxyState = $7bf56e9c8ff12ab3$var$proxyStateMap.get(proxyObject);
    if ($7bf56e9c8ff12ab3$var$isDev() && !proxyState) console.warn("Please use proxy object");
    const [target, ensureVersion, createSnapshot] = proxyState;
    return createSnapshot(target, ensureVersion());
}
function $7bf56e9c8ff12ab3$export$eff4d24c3ff7876e(obj) {
    $7bf56e9c8ff12ab3$var$refSet.add(obj);
    return obj;
}
// src/proxy-computed.ts
function $7bf56e9c8ff12ab3$export$64a33e9109220e08(initialObject, computedFns) {
    const keys = Object.keys(computedFns);
    keys.forEach((key)=>{
        if (Object.getOwnPropertyDescriptor(initialObject, key)) throw new Error("object property already defined");
        const computedFn = computedFns[key];
        const { get: get, set: set2 } = typeof computedFn === "function" ? {
            get: computedFn
        } : computedFn;
        const desc = {};
        desc.get = ()=>get($7bf56e9c8ff12ab3$export$b8801ea43165ed7d(proxyObject));
        if (set2) desc.set = (newValue)=>set2(proxyObject, newValue);
        Object.defineProperty(initialObject, key, desc);
    });
    const proxyObject = $7bf56e9c8ff12ab3$export$923f96dd5afa9ce6(initialObject);
    return proxyObject;
}


// src/array.ts
function $89352e0ddd72597a$export$45b10814cc054894(v) {
    if (!v) return [];
    return Array.isArray(v) ? v : [
        v
    ];
}
var $89352e0ddd72597a$export$126fef020408babd = (length)=>Array.from(Array(length).keys());
var $89352e0ddd72597a$export$43128fadae87b74a = (v)=>v[0];
var $89352e0ddd72597a$export$4c7897fafd92b108 = (v)=>v[v.length - 1];
var $89352e0ddd72597a$export$dd1bc94b04021eeb = (v)=>v.length === 0;
var $89352e0ddd72597a$export$a4f4bb6b1453fff5 = (v, t)=>v.indexOf(t) !== -1;
var $89352e0ddd72597a$export$e16d8520af44a096 = (v, ...items)=>v.concat(items);
var $89352e0ddd72597a$export$cd7f480d6b8286c3 = (v, ...items)=>v.filter((t)=>!items.includes(t));
var $89352e0ddd72597a$export$aa72b1a59562dee2 = (v, i)=>v.filter((_, idx)=>idx !== i);
var $89352e0ddd72597a$export$9f200c4466975173 = (v, i, ...items)=>[
        ...v.slice(0, i),
        ...items,
        ...v.slice(i)
    ];
var $89352e0ddd72597a$export$f70730c3d1fc524e = (v)=>Array.from(new Set(v));
var $89352e0ddd72597a$export$daf1e94085156e29 = (v, item)=>{
    if ($89352e0ddd72597a$export$a4f4bb6b1453fff5(v, item)) return $89352e0ddd72597a$export$cd7f480d6b8286c3(v, item);
    return $89352e0ddd72597a$export$e16d8520af44a096(v, item);
};
function $89352e0ddd72597a$export$42ffd38884aecdac(v) {
    while(v.length > 0)v.pop();
    return v;
}
function $89352e0ddd72597a$export$7db462fe6be63e0(v, idx, opts = {}) {
    const { step: step = 1, loop: loop = true } = opts;
    const next2 = idx + step;
    const len = v.length;
    const last2 = len - 1;
    if (idx === -1) return step > 0 ? 0 : last2;
    if (next2 < 0) return loop ? last2 : 0;
    if (next2 >= len) return loop ? 0 : idx > len ? len : idx;
    return next2;
}
function $89352e0ddd72597a$export$48cfd1e771a65c4f(v, idx, opts = {}) {
    return v[$89352e0ddd72597a$export$7db462fe6be63e0(v, idx, opts)];
}
function $89352e0ddd72597a$export$9041fedbf960fcef(v, idx, opts = {}) {
    const { step: step = 1, loop: loop = true } = opts;
    return $89352e0ddd72597a$export$7db462fe6be63e0(v, idx, {
        step: -step,
        loop: loop
    });
}
function $89352e0ddd72597a$export$232faf9add678146(v, index, opts = {}) {
    return v[$89352e0ddd72597a$export$9041fedbf960fcef(v, index, opts)];
}
var $89352e0ddd72597a$export$5f7ec48d69707ddd = (v, size)=>{
    const res = [];
    return v.reduce((rows, value, index)=>{
        if (index % size === 0) rows.push([
            value
        ]);
        else $89352e0ddd72597a$export$4c7897fafd92b108(rows)?.push(value);
        return rows;
    }, res);
};
// src/equal.ts
var $89352e0ddd72597a$var$isArrayLike = (value)=>value?.constructor.name === "Array";
var $89352e0ddd72597a$var$isArrayEqual = (a, b)=>{
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (!$89352e0ddd72597a$export$248d38f6296296c5(a[i], b[i])) return false;
    }
    return true;
};
var $89352e0ddd72597a$export$248d38f6296296c5 = (a, b)=>{
    if (Object.is(a, b)) return true;
    if (a == null && b != null || a != null && b == null) return false;
    if (typeof a?.isEqual === "function" && typeof b?.isEqual === "function") return a.isEqual(b);
    if (typeof a === "function" && typeof b === "function") return a.toString() === b.toString();
    if ($89352e0ddd72597a$var$isArrayLike(a) && $89352e0ddd72597a$var$isArrayLike(b)) return $89352e0ddd72597a$var$isArrayEqual(Array.from(a), Array.from(b));
    if (!(typeof a === "object") || !(typeof b === "object")) return false;
    const keys = Object.keys(b ?? /* @__PURE__ */ Object.create(null));
    const length = keys.length;
    for(let i = 0; i < length; i++){
        const hasKey = Reflect.has(a, keys[i]);
        if (!hasKey) return false;
    }
    for(let i = 0; i < length; i++){
        const key = keys[i];
        if (!$89352e0ddd72597a$export$248d38f6296296c5(a[key], b[key])) return false;
    }
    return true;
};
// src/functions.ts
var $89352e0ddd72597a$export$624e501d81f5ffce = (v, ...a)=>{
    const res = typeof v === "function" ? v(...a) : v;
    return res ?? void 0;
};
var $89352e0ddd72597a$export$f2db7d5238e1d23f = (v)=>v;
var $89352e0ddd72597a$export$8793edee2d425525 = ()=>{};
var $89352e0ddd72597a$export$9dd9a52f2dd5b9ce = (...fns)=>(...a)=>{
        fns.forEach(function(fn) {
            fn?.(...a);
        });
    };
var $89352e0ddd72597a$export$31b40729666a4ae0 = /* @__PURE__ */ (()=>{
    let id = 0;
    return ()=>{
        id++;
        return id.toString(36);
    };
})();
function $89352e0ddd72597a$export$4659b591c19bdf3d(key, record, ...args) {
    if (key in record) {
        const fn = record[key];
        return typeof fn === "function" ? fn(...args) : fn;
    }
    const error = new Error(`No matching key: ${JSON.stringify(key)} in ${JSON.stringify(Object.keys(record))}`);
    Error.captureStackTrace?.(error, $89352e0ddd72597a$export$4659b591c19bdf3d);
    throw error;
}
var $89352e0ddd72597a$export$d234c058d1d4e435 = (fn, fallback)=>{
    try {
        return fn();
    } catch (error) {
        if (error instanceof Error) Error.captureStackTrace?.(error, $89352e0ddd72597a$export$d234c058d1d4e435);
        return fallback?.();
    }
};
// src/guard.ts
var $89352e0ddd72597a$export$40edfb7eeb78c4e8 = ()=>false;
var $89352e0ddd72597a$export$43bee75e5e14138e = (v)=>Array.isArray(v);
var $89352e0ddd72597a$export$f9ce7b637dfbe238 = (v)=>v === true || v === false;
var $89352e0ddd72597a$export$c10d0b04eaa80a43 = (v)=>v != null && typeof v === "object";
var $89352e0ddd72597a$export$a6cdc56e425d0d0a = (v)=>$89352e0ddd72597a$export$c10d0b04eaa80a43(v) && !$89352e0ddd72597a$export$43bee75e5e14138e(v);
var $89352e0ddd72597a$export$7e4aa119212bc614 = (v)=>typeof v === "number" && !Number.isNaN(v);
var $89352e0ddd72597a$export$844ec244b1367d54 = (v)=>typeof v === "string";
var $89352e0ddd72597a$export$f6e2535fb5126e54 = (v)=>typeof v === "function";
var $89352e0ddd72597a$export$630801d484da15df = (v)=>v == null;
var $89352e0ddd72597a$export$dd642ef726dcde21 = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
var $89352e0ddd72597a$var$baseGetTag = (v)=>Object.prototype.toString.call(v);
var $89352e0ddd72597a$var$fnToString = Function.prototype.toString;
var $89352e0ddd72597a$var$objectCtorString = $89352e0ddd72597a$var$fnToString.call(Object);
var $89352e0ddd72597a$export$53b83ca8eaab0383 = (v)=>{
    if (!$89352e0ddd72597a$export$c10d0b04eaa80a43(v) || $89352e0ddd72597a$var$baseGetTag(v) != "[object Object]") return false;
    const proto = Object.getPrototypeOf(v);
    if (proto === null) return true;
    const Ctor = $89352e0ddd72597a$export$dd642ef726dcde21(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $89352e0ddd72597a$var$fnToString.call(Ctor) == $89352e0ddd72597a$var$objectCtorString;
};
// src/number.ts
var { floor: $89352e0ddd72597a$var$floor, abs: $89352e0ddd72597a$var$abs, round: $89352e0ddd72597a$var$round, min: $89352e0ddd72597a$var$min, max: $89352e0ddd72597a$var$max, pow: $89352e0ddd72597a$var$pow, sign: $89352e0ddd72597a$var$sign } = Math;
var $89352e0ddd72597a$export$c9f5652083b8129d = (v)=>Number.isNaN(v);
var $89352e0ddd72597a$export$9e06de0973666692 = (v)=>$89352e0ddd72597a$export$c9f5652083b8129d(v) ? 0 : v;
var $89352e0ddd72597a$export$842a2cf37af977e1 = (v, m)=>(v % m + m) % m;
var $89352e0ddd72597a$export$4997ffc0176396a6 = (v, vmax)=>(v % vmax + vmax) % vmax;
var $89352e0ddd72597a$export$9015d8af42444785 = (i, v, vmin)=>i === 0 ? vmin : v[i - 1];
var $89352e0ddd72597a$export$b2cceded85b4d6b0 = (i, v, vmax)=>i === v.length - 1 ? vmax : v[i + 1];
var $89352e0ddd72597a$export$e280c4b0ba1fba46 = (v, vmax)=>$89352e0ddd72597a$export$9e06de0973666692(v) >= vmax;
var $89352e0ddd72597a$export$f34fe80559da9f6e = (v, vmin)=>$89352e0ddd72597a$export$9e06de0973666692(v) <= vmin;
var $89352e0ddd72597a$export$7c4e06fee2f75722 = (v, vmin, vmax)=>$89352e0ddd72597a$export$9e06de0973666692(v) >= vmin && $89352e0ddd72597a$export$9e06de0973666692(v) <= vmax;
var $89352e0ddd72597a$export$6dc2969fe47f79f = (v, vmin, step)=>$89352e0ddd72597a$var$round(($89352e0ddd72597a$export$9e06de0973666692(v) - vmin) / step) * step + vmin;
var $89352e0ddd72597a$export$31ee16100cde6ce2 = (v, vmin, vmax)=>$89352e0ddd72597a$var$min($89352e0ddd72597a$var$max($89352e0ddd72597a$export$9e06de0973666692(v), vmin), vmax);
var $89352e0ddd72597a$export$864513891389ca82 = (v)=>$89352e0ddd72597a$export$31ee16100cde6ce2(v, 0, 1);
var $89352e0ddd72597a$export$22574034cd380c24 = (v, vmin, vmax)=>($89352e0ddd72597a$export$9e06de0973666692(v) - vmin) / (vmax - vmin);
var $89352e0ddd72597a$export$476354dbf49bdff6 = (p, vmin, vmax, step)=>$89352e0ddd72597a$export$31ee16100cde6ce2($89352e0ddd72597a$export$6dc2969fe47f79f(p * (vmax - vmin) + vmin, vmin, step), vmin, vmax);
var $89352e0ddd72597a$export$e1a7b8e69ef6c52f = (v, step)=>{
    let rv = v;
    let ss = step.toString();
    let pi = ss.indexOf(".");
    let p = pi >= 0 ? ss.length - pi : 0;
    if (p > 0) {
        let pw = $89352e0ddd72597a$var$pow(10, p);
        rv = $89352e0ddd72597a$var$round(rv * pw) / pw;
    }
    return rv;
};
var $89352e0ddd72597a$export$db558e705f7d32d7 = (v, dpr)=>typeof dpr === "number" ? $89352e0ddd72597a$var$floor(v * dpr + 0.5) / dpr : $89352e0ddd72597a$var$round(v);
var $89352e0ddd72597a$export$cb6e0bb50bc19463 = (v, vmin, vmax, step)=>{
    vmin = Number(vmin);
    vmax = Number(vmax);
    let remainder = (v - ($89352e0ddd72597a$export$c9f5652083b8129d(vmin) ? 0 : vmin)) % step;
    let sv = $89352e0ddd72597a$export$e1a7b8e69ef6c52f($89352e0ddd72597a$var$abs(remainder) * 2 >= step ? v + $89352e0ddd72597a$var$sign(remainder) * (step - $89352e0ddd72597a$var$abs(remainder)) : v - remainder, step);
    if (!$89352e0ddd72597a$export$c9f5652083b8129d(vmin)) {
        if (sv < vmin) sv = vmin;
        else if (!$89352e0ddd72597a$export$c9f5652083b8129d(vmax) && sv > vmax) sv = vmin + $89352e0ddd72597a$var$floor($89352e0ddd72597a$export$e1a7b8e69ef6c52f((vmax - vmin) / step, step)) * step;
    } else if (!$89352e0ddd72597a$export$c9f5652083b8129d(vmax) && sv > vmax) sv = vmin + $89352e0ddd72597a$var$floor($89352e0ddd72597a$export$e1a7b8e69ef6c52f((vmax - vmin) / step, step)) * step;
    return $89352e0ddd72597a$export$e1a7b8e69ef6c52f(sv, step);
};
var $89352e0ddd72597a$export$1119f90a8bbc6509 = (vs, i, v)=>{
    if (vs[i] === v) return vs;
    return [
        ...vs.slice(0, i),
        v,
        ...vs.slice(i + 1)
    ];
};
function $89352e0ddd72597a$export$d59398ffb0009913(index, ctx) {
    const minValueAtIndex = $89352e0ddd72597a$export$9015d8af42444785(index, ctx.values, ctx.min);
    const maxValueAtIndex = $89352e0ddd72597a$export$b2cceded85b4d6b0(index, ctx.values, ctx.max);
    let nextValues = ctx.values.slice();
    return function setValue(value) {
        let nextValue = $89352e0ddd72597a$export$cb6e0bb50bc19463(value, minValueAtIndex, maxValueAtIndex, ctx.step);
        nextValues = $89352e0ddd72597a$export$1119f90a8bbc6509(nextValues, index, value);
        nextValues[index] = nextValue;
        return nextValues;
    };
}
function $89352e0ddd72597a$export$883adeea0e999db3(index, ctx) {
    const nextValue = ctx.values[index] + ctx.step;
    return $89352e0ddd72597a$export$d59398ffb0009913(index, ctx)(nextValue);
}
function $89352e0ddd72597a$export$afee86354f7f91ab(index, ctx) {
    const nextValue = ctx.values[index] - ctx.step;
    return $89352e0ddd72597a$export$d59398ffb0009913(index, ctx)(nextValue);
}
var $89352e0ddd72597a$export$70ddabd6efec4c0a = (vs, t)=>{
    let i = vs.findIndex((v)=>t - v < 0);
    if (i === 0) return i;
    if (i === -1) return vs.length - 1;
    let vLeft = vs[i - 1];
    let vRight = vs[i];
    if ($89352e0ddd72597a$var$abs(vLeft - t) < $89352e0ddd72597a$var$abs(vRight - t)) return i - 1;
    return i;
};
var $89352e0ddd72597a$export$4b9ea961bfd9be6e = (vs, t)=>vs[$89352e0ddd72597a$export$70ddabd6efec4c0a(vs, t)];
var $89352e0ddd72597a$export$bf5bf18fe4d721e6 = (vs, vmin, vmax, gap)=>vs.map((v, i)=>({
            min: i === 0 ? vmin : vs[i - 1] + gap,
            max: i === vs.length - 1 ? vmax : vs[i + 1] - gap,
            value: v
        }));
var $89352e0ddd72597a$export$42961567a0fc6d1e = (va, vb)=>{
    const [a, b] = va;
    const [c, d] = vb;
    return (v)=>a === b || c === d ? c : c + (d - c) / (b - a) * (v - a);
};
var $89352e0ddd72597a$export$b6268554fba451f = (v, d = 0, b = 10)=>{
    const pow2 = Math.pow(b, d);
    return $89352e0ddd72597a$var$round(v * pow2) / pow2;
};
var $89352e0ddd72597a$var$countDecimals = (value)=>{
    if (!Number.isFinite(value)) return 0;
    let e = 1, p = 0;
    while(Math.round(value * e) / e !== value){
        e *= 10;
        p += 1;
    }
    return p;
};
var $89352e0ddd72597a$var$decimalOp = (a, op, b)=>{
    let result = op === "+" ? a + b : a - b;
    if (a % 1 !== 0 || b % 1 !== 0) {
        const multiplier = 10 ** Math.max($89352e0ddd72597a$var$countDecimals(a), $89352e0ddd72597a$var$countDecimals(b));
        a = Math.round(a * multiplier);
        b = Math.round(b * multiplier);
        result = op === "+" ? a + b : a - b;
        result /= multiplier;
    }
    return result;
};
var $89352e0ddd72597a$export$d3f405d8a429a91 = (v, s)=>$89352e0ddd72597a$var$decimalOp($89352e0ddd72597a$export$9e06de0973666692(v), "+", s);
var $89352e0ddd72597a$export$5b2c46821c67093d = (v, s)=>$89352e0ddd72597a$var$decimalOp($89352e0ddd72597a$export$9e06de0973666692(v), "-", s);
// src/object.ts
function $89352e0ddd72597a$export$8e16b83750b44988(obj) {
    if (!$89352e0ddd72597a$var$isPlainObject2(obj) || obj === void 0) return obj;
    const keys = Reflect.ownKeys(obj).filter((key)=>typeof key === "string");
    const filtered = {};
    for (const key of keys){
        const value = obj[key];
        if (value !== void 0) filtered[key] = $89352e0ddd72597a$export$8e16b83750b44988(value);
    }
    return filtered;
}
var $89352e0ddd72597a$export$7b419323e6ed4f31 = (v)=>JSON.parse(JSON.stringify(v));
var $89352e0ddd72597a$var$isPlainObject2 = (v)=>{
    return v && typeof v === "object" && v.constructor === Object;
};
function $89352e0ddd72597a$export$357523c63a2253b9(obj, keys) {
    const filtered = {};
    for (const key of keys){
        const value = obj[key];
        if (value !== void 0) filtered[key] = value;
    }
    return filtered;
}
function $89352e0ddd72597a$export$45029c61b0073d87(props, keys) {
    const rest = {};
    const result = {};
    const keySet = new Set(keys);
    for(const key in props)if (keySet.has(key)) result[key] = props[key];
    else rest[key] = props[key];
    return [
        result,
        rest
    ];
}
var $89352e0ddd72597a$export$3ea53b214fbc1986 = (keys)=>{
    return function split(props) {
        return $89352e0ddd72597a$export$45029c61b0073d87(props, keys);
    };
};
function $89352e0ddd72597a$export$30a06c8d3562193f(obj, keys) {
    return $89352e0ddd72597a$export$3ea53b214fbc1986(keys)(obj)[1];
}
// src/warning.ts
function $89352e0ddd72597a$export$c106dd0671a0fc2d(...a) {
    const m = a.length === 1 ? a[0] : a[1];
    const c = a.length === 2 ? a[0] : true;
}
function $89352e0ddd72597a$export$f5708dca728d7177(...a) {
    const m = a.length === 1 ? a[0] : a[1];
    const c = a.length === 2 ? a[0] : true;
}


var $5c0da97e9c7aa95f$var$__defProp = Object.defineProperty;
var $5c0da97e9c7aa95f$var$__defNormalProp = (obj, key, value)=>key in obj ? $5c0da97e9c7aa95f$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5c0da97e9c7aa95f$var$__publicField = (obj, key, value)=>$5c0da97e9c7aa95f$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
function $5c0da97e9c7aa95f$export$6969335ea1e4e77c(source, ...objects) {
    for (const obj of objects){
        const target = (0, $89352e0ddd72597a$export$8e16b83750b44988)(obj);
        for(const key in target)if ((0, $89352e0ddd72597a$export$53b83ca8eaab0383)(obj[key])) {
            if (!source[key]) source[key] = {};
            $5c0da97e9c7aa95f$export$6969335ea1e4e77c(source[key], obj[key]);
        } else source[key] = obj[key];
    }
    return source;
}
function $5c0da97e9c7aa95f$var$toEvent(event) {
    const obj = (0, $89352e0ddd72597a$export$844ec244b1367d54)(event) ? {
        type: event
    } : event;
    return obj;
}
function $5c0da97e9c7aa95f$var$toArray(value) {
    if (!value) return [];
    return (0, $89352e0ddd72597a$export$43bee75e5e14138e)(value) ? value.slice() : [
        value
    ];
}
function $5c0da97e9c7aa95f$var$isGuardHelper(value) {
    return (0, $89352e0ddd72597a$export$a6cdc56e425d0d0a)(value) && value.predicate != null;
}
// src/guard-utils.ts
var $5c0da97e9c7aa95f$var$Truthy = ()=>true;
function $5c0da97e9c7aa95f$var$exec(guardMap, ctx, event, meta) {
    return (guard)=>{
        if ((0, $89352e0ddd72597a$export$844ec244b1367d54)(guard)) return !!guardMap[guard]?.(ctx, event, meta);
        if ((0, $89352e0ddd72597a$export$f6e2535fb5126e54)(guard)) return guard(ctx, event, meta);
        return guard.predicate(guardMap)(ctx, event, meta);
    };
}
function $5c0da97e9c7aa95f$var$or(...conditions) {
    return {
        predicate: (guardMap)=>(ctx, event, meta)=>conditions.map($5c0da97e9c7aa95f$var$exec(guardMap, ctx, event, meta)).some(Boolean)
    };
}
function $5c0da97e9c7aa95f$var$and(...conditions) {
    return {
        predicate: (guardMap)=>(ctx, event, meta)=>conditions.map($5c0da97e9c7aa95f$var$exec(guardMap, ctx, event, meta)).every(Boolean)
    };
}
function $5c0da97e9c7aa95f$var$not(condition) {
    return {
        predicate: (guardMap)=>(ctx, event, meta)=>{
                return !$5c0da97e9c7aa95f$var$exec(guardMap, ctx, event, meta)(condition);
            }
    };
}
function $5c0da97e9c7aa95f$var$stateIn(...values) {
    return (_ctx, _evt, meta)=>meta.state.matches(...values);
}
var $5c0da97e9c7aa95f$export$f3249297f3edf7e9 = {
    or: $5c0da97e9c7aa95f$var$or,
    and: $5c0da97e9c7aa95f$var$and,
    not: $5c0da97e9c7aa95f$var$not,
    stateIn: $5c0da97e9c7aa95f$var$stateIn
};
function $5c0da97e9c7aa95f$export$7877a478dd30fd3d(actions) {
    return {
        predicate: (guardMap)=>(ctx, event, meta)=>actions.find((def)=>{
                    const guard = def.guard ?? $5c0da97e9c7aa95f$var$Truthy;
                    return $5c0da97e9c7aa95f$var$exec(guardMap, ctx, event, meta)(guard);
                })?.actions
    };
}
function $5c0da97e9c7aa95f$var$determineGuardFn(guard, guardMap) {
    guard = guard ?? $5c0da97e9c7aa95f$var$Truthy;
    return (context, event, meta)=>{
        if ((0, $89352e0ddd72597a$export$844ec244b1367d54)(guard)) {
            const value = guardMap[guard];
            return (0, $89352e0ddd72597a$export$f6e2535fb5126e54)(value) ? value(context, event, meta) : value;
        }
        if ($5c0da97e9c7aa95f$var$isGuardHelper(guard)) return guard.predicate(guardMap)(context, event, meta);
        return guard?.(context, event, meta);
    };
}
function $5c0da97e9c7aa95f$var$determineActionsFn(values, guardMap) {
    return (context, event, meta)=>{
        if ($5c0da97e9c7aa95f$var$isGuardHelper(values)) return values.predicate(guardMap)(context, event, meta);
        return values;
    };
}
function $5c0da97e9c7aa95f$var$createProxy(config) {
    const computedContext = config.computed ?? (0, $89352e0ddd72597a$export$f2db7d5238e1d23f)({});
    const initialContext = config.context ?? (0, $89352e0ddd72597a$export$f2db7d5238e1d23f)({});
    const initialTags = config.initial ? config.states?.[config.initial]?.tags : [];
    const state = (0, $7bf56e9c8ff12ab3$export$923f96dd5afa9ce6)({
        value: config.initial ?? "",
        previousValue: "",
        event: (0, $89352e0ddd72597a$export$f2db7d5238e1d23f)({}),
        previousEvent: (0, $89352e0ddd72597a$export$f2db7d5238e1d23f)({}),
        context: (0, $7bf56e9c8ff12ab3$export$64a33e9109220e08)(initialContext, computedContext),
        done: false,
        tags: initialTags ?? [],
        hasTag (tag) {
            return this.tags.includes(tag);
        },
        matches (...value) {
            return value.includes(this.value);
        },
        can (event) {
            return (0, $89352e0ddd72597a$export$f2db7d5238e1d23f)(this).nextEvents.includes(event);
        },
        get nextEvents () {
            const stateEvents = config.states?.[this.value]?.["on"] ?? {};
            const globalEvents = config?.on ?? {};
            return Object.keys({
                ...stateEvents,
                ...globalEvents
            });
        },
        get changed () {
            if (this.event.value === "machine.init" /* Init */  || !this.previousValue) return false;
            return this.value !== this.previousValue;
        }
    });
    return (0, $89352e0ddd72597a$export$f2db7d5238e1d23f)(state);
}
function $5c0da97e9c7aa95f$var$determineDelayFn(delay, delaysMap) {
    return (context, event)=>{
        if ((0, $89352e0ddd72597a$export$7e4aa119212bc614)(delay)) return delay;
        if ((0, $89352e0ddd72597a$export$f6e2535fb5126e54)(delay)) return delay(context, event);
        if ((0, $89352e0ddd72597a$export$844ec244b1367d54)(delay)) {
            const value = Number.parseFloat(delay);
            if (!Number.isNaN(value)) return value;
            if (delaysMap) {
                const valueOrFn = delaysMap?.[delay];
                (0, $89352e0ddd72597a$export$f5708dca728d7177)(valueOrFn == null, `[@zag-js/core > determine-delay] Cannot determine delay for \`${delay}\`. It doesn't exist in \`options.delays\``);
                return (0, $89352e0ddd72597a$export$f6e2535fb5126e54)(valueOrFn) ? valueOrFn(context, event) : valueOrFn;
            }
        }
    };
}
function $5c0da97e9c7aa95f$var$toTarget(target) {
    return (0, $89352e0ddd72597a$export$844ec244b1367d54)(target) ? {
        target: target
    } : target;
}
function $5c0da97e9c7aa95f$var$determineTransitionFn(transitions, guardMap) {
    return (context, event, meta)=>{
        return $5c0da97e9c7aa95f$var$toArray(transitions).map($5c0da97e9c7aa95f$var$toTarget).find((transition)=>{
            const determineGuard = $5c0da97e9c7aa95f$var$determineGuardFn(transition.guard, guardMap);
            const guard = determineGuard(context, event, meta);
            return guard ?? transition.target ?? transition.actions;
        });
    };
}
// src/machine.ts
var $5c0da97e9c7aa95f$export$f391db14ff2d9279 = class {
    // Let's get started!
    constructor(config, options){
        $5c0da97e9c7aa95f$var$__publicField(this, "status", "Not Started" /* NotStarted */ );
        $5c0da97e9c7aa95f$var$__publicField(this, "state");
        $5c0da97e9c7aa95f$var$__publicField(this, "initialState");
        $5c0da97e9c7aa95f$var$__publicField(this, "initialContext");
        $5c0da97e9c7aa95f$var$__publicField(this, "id");
        $5c0da97e9c7aa95f$var$__publicField(this, "type", "machine" /* Machine */ );
        // Cleanup function map (per state)
        $5c0da97e9c7aa95f$var$__publicField(this, "activityEvents", /* @__PURE__ */ new Map());
        $5c0da97e9c7aa95f$var$__publicField(this, "delayedEvents", /* @__PURE__ */ new Map());
        // state update listeners the user can opt-in for
        $5c0da97e9c7aa95f$var$__publicField(this, "stateListeners", /* @__PURE__ */ new Set());
        $5c0da97e9c7aa95f$var$__publicField(this, "doneListeners", /* @__PURE__ */ new Set());
        $5c0da97e9c7aa95f$var$__publicField(this, "contextWatchers", /* @__PURE__ */ new Set());
        // Cleanup functions (for `subscribe`)
        $5c0da97e9c7aa95f$var$__publicField(this, "removeStateListener", (0, $89352e0ddd72597a$export$8793edee2d425525));
        // For Parent <==> Spawned Actor relationship
        $5c0da97e9c7aa95f$var$__publicField(this, "parent");
        $5c0da97e9c7aa95f$var$__publicField(this, "children", /* @__PURE__ */ new Map());
        // A map of guard, action, delay implementations
        $5c0da97e9c7aa95f$var$__publicField(this, "guardMap");
        $5c0da97e9c7aa95f$var$__publicField(this, "actionMap");
        $5c0da97e9c7aa95f$var$__publicField(this, "delayMap");
        $5c0da97e9c7aa95f$var$__publicField(this, "activityMap");
        $5c0da97e9c7aa95f$var$__publicField(this, "sync");
        $5c0da97e9c7aa95f$var$__publicField(this, "options");
        $5c0da97e9c7aa95f$var$__publicField(this, "config");
        // created actions
        $5c0da97e9c7aa95f$var$__publicField(this, "_created", ()=>{
            if (!this.config.created) return;
            const event = $5c0da97e9c7aa95f$var$toEvent("machine.created" /* Created */ );
            this.executeActions(this.config.created, event);
        });
        // Starts the interpreted machine.
        $5c0da97e9c7aa95f$var$__publicField(this, "start", (init)=>{
            this.state.value = "";
            this.state.tags = [];
            if (this.status === "Running" /* Running */ ) return this;
            this.status = "Running" /* Running */ ;
            this.removeStateListener = (0, $7bf56e9c8ff12ab3$export$ec068583843480e7)(this.state, ()=>{
                this.stateListeners.forEach((listener)=>{
                    listener(this.stateSnapshot);
                });
            }, this.sync);
            this.setupContextWatchers();
            this.executeActivities($5c0da97e9c7aa95f$var$toEvent("machine.start" /* Start */ ), $5c0da97e9c7aa95f$var$toArray(this.config.activities), "machine.start" /* Start */ );
            this.executeActions(this.config.entry, $5c0da97e9c7aa95f$var$toEvent("machine.start" /* Start */ ));
            const event = $5c0da97e9c7aa95f$var$toEvent("machine.init" /* Init */ );
            const target = (0, $89352e0ddd72597a$export$a6cdc56e425d0d0a)(init) ? init.value : init;
            const context = (0, $89352e0ddd72597a$export$a6cdc56e425d0d0a)(init) ? init.context : void 0;
            if (context) this.setContext(context);
            const transition = {
                target: target ?? this.config.initial
            };
            const next = this.getNextStateInfo(transition, event);
            this.initialState = next;
            this.performStateChangeEffects(this.state.value, next, event);
            return this;
        });
        $5c0da97e9c7aa95f$var$__publicField(this, "setupContextWatchers", ()=>{
            const { watch: watch } = this.config;
            if (!watch) return;
            let prev = (0, $7bf56e9c8ff12ab3$export$b8801ea43165ed7d)(this.state.context);
            const cleanup = (0, $7bf56e9c8ff12ab3$export$ec068583843480e7)(this.state.context, ()=>{
                const next = (0, $7bf56e9c8ff12ab3$export$b8801ea43165ed7d)(this.state.context);
                for (const [key, fn] of Object.entries(watch)){
                    const isEqual = this.options.compareFns?.[key] ?? Object.is;
                    if (isEqual(prev[key], next[key])) continue;
                    this.executeActions(fn, this.state.event);
                }
                prev = next;
            });
            this.contextWatchers.add(cleanup);
        });
        // Stops the interpreted machine
        $5c0da97e9c7aa95f$var$__publicField(this, "stop", ()=>{
            if (this.status === "Stopped" /* Stopped */ ) return;
            this.performExitEffects(this.state.value, $5c0da97e9c7aa95f$var$toEvent("machine.stop" /* Stop */ ));
            this.executeActions(this.config.exit, $5c0da97e9c7aa95f$var$toEvent("machine.stop" /* Stop */ ));
            this.setState("");
            this.setEvent("machine.stop" /* Stop */ );
            this.stopStateListeners();
            this.stopChildren();
            this.stopActivities();
            this.stopDelayedEvents();
            this.stopContextWatchers();
            this.status = "Stopped" /* Stopped */ ;
            return this;
        });
        $5c0da97e9c7aa95f$var$__publicField(this, "stopStateListeners", ()=>{
            this.removeStateListener();
            this.stateListeners.clear();
        });
        $5c0da97e9c7aa95f$var$__publicField(this, "stopContextWatchers", ()=>{
            this.contextWatchers.forEach((fn)=>fn());
            this.contextWatchers.clear();
        });
        $5c0da97e9c7aa95f$var$__publicField(this, "stopDelayedEvents", ()=>{
            this.delayedEvents.forEach((state)=>{
                state.forEach((stop)=>stop());
            });
            this.delayedEvents.clear();
        });
        // Cleanup running activities (e.g `setInterval`, invoked callbacks, promises)
        $5c0da97e9c7aa95f$var$__publicField(this, "stopActivities", (state)=>{
            if (state) {
                this.activityEvents.get(state)?.forEach((stop)=>stop());
                this.activityEvents.get(state)?.clear();
                this.activityEvents.delete(state);
            } else {
                this.activityEvents.forEach((state2)=>{
                    state2.forEach((stop)=>stop());
                    state2.clear();
                });
                this.activityEvents.clear();
            }
        });
        /**
     * Function to send event to spawned child machine or actor
     */ $5c0da97e9c7aa95f$var$__publicField(this, "sendChild", (evt, to)=>{
            const event = $5c0da97e9c7aa95f$var$toEvent(evt);
            const id = (0, $89352e0ddd72597a$export$624e501d81f5ffce)(to, this.contextSnapshot);
            const child = this.children.get(id);
            if (!child) (0, $89352e0ddd72597a$export$f5708dca728d7177)(`[@zag-js/core] Cannot send '${event.type}' event to unknown child`);
            child.send(event);
        });
        /**
     * Function to stop a running child machine or actor
     */ $5c0da97e9c7aa95f$var$__publicField(this, "stopChild", (id)=>{
            if (!this.children.has(id)) (0, $89352e0ddd72597a$export$f5708dca728d7177)(`[@zag-js/core > stop-child] Cannot stop unknown child ${id}`);
            this.children.get(id).stop();
            this.children.delete(id);
        });
        $5c0da97e9c7aa95f$var$__publicField(this, "removeChild", (id)=>{
            this.children.delete(id);
        });
        // Stop and delete spawned actors
        $5c0da97e9c7aa95f$var$__publicField(this, "stopChildren", ()=>{
            this.children.forEach((child)=>child.stop());
            this.children.clear();
        });
        $5c0da97e9c7aa95f$var$__publicField(this, "setParent", (parent)=>{
            this.parent = parent;
        });
        $5c0da97e9c7aa95f$var$__publicField(this, "spawn", (src, id)=>{
            const actor = (0, $89352e0ddd72597a$export$624e501d81f5ffce)(src);
            if (id) actor.id = id;
            actor.type = "machine.actor" /* Actor */ ;
            actor.setParent(this);
            this.children.set(actor.id, (0, $89352e0ddd72597a$export$f2db7d5238e1d23f)(actor));
            actor.onDone(()=>{
                this.removeChild(actor.id);
            }).start();
            return (0, $89352e0ddd72597a$export$f2db7d5238e1d23f)((0, $7bf56e9c8ff12ab3$export$eff4d24c3ff7876e)(actor));
        });
        $5c0da97e9c7aa95f$var$__publicField(this, "stopActivity", (key)=>{
            if (!this.state.value) return;
            const cleanups = this.activityEvents.get(this.state.value);
            cleanups?.get(key)?.();
            cleanups?.delete(key);
        });
        $5c0da97e9c7aa95f$var$__publicField(this, "addActivityCleanup", (state, key, cleanup)=>{
            if (!state) return;
            if (!this.activityEvents.has(state)) this.activityEvents.set(state, /* @__PURE__ */ new Map([
                [
                    key,
                    cleanup
                ]
            ]));
            else this.activityEvents.get(state)?.set(key, cleanup);
        });
        $5c0da97e9c7aa95f$var$__publicField(this, "setState", (target)=>{
            this.state.previousValue = this.state.value;
            this.state.value = target;
            const stateNode = this.getStateNode(target);
            if (target == null) (0, $89352e0ddd72597a$export$42ffd38884aecdac)(this.state.tags);
            else this.state.tags = $5c0da97e9c7aa95f$var$toArray(stateNode?.tags);
        });
        /**
     * To used within side effects for React or Vue to update context
     */ $5c0da97e9c7aa95f$var$__publicField(this, "setContext", (context)=>{
            if (!context) return;
            $5c0da97e9c7aa95f$export$6969335ea1e4e77c(this.state.context, (0, $89352e0ddd72597a$export$8e16b83750b44988)(context));
        });
        $5c0da97e9c7aa95f$var$__publicField(this, "setOptions", (options)=>{
            const opts = (0, $89352e0ddd72597a$export$8e16b83750b44988)(options);
            this.actionMap = {
                ...this.actionMap,
                ...opts.actions
            };
            this.delayMap = {
                ...this.delayMap,
                ...opts.delays
            };
            this.activityMap = {
                ...this.activityMap,
                ...opts.activities
            };
            this.guardMap = {
                ...this.guardMap,
                ...opts.guards
            };
        });
        $5c0da97e9c7aa95f$var$__publicField(this, "getStateNode", (state)=>{
            if (!state) return;
            return this.config.states?.[state];
        });
        $5c0da97e9c7aa95f$var$__publicField(this, "getNextStateInfo", (transitions, event)=>{
            const transition = this.determineTransition(transitions, event);
            const isTargetless = !transition?.target;
            const target = transition?.target ?? this.state.value;
            const changed = this.state.value !== target;
            const stateNode = this.getStateNode(target);
            const reenter = !isTargetless && !changed && !transition?.internal;
            const info = {
                reenter: reenter,
                transition: transition,
                stateNode: stateNode,
                target: target,
                changed: changed
            };
            this.log("NextState:", `[${event.type}]`, this.state.value, "---->", info.target);
            return info;
        });
        $5c0da97e9c7aa95f$var$__publicField(this, "getAfterActions", (transition, delay)=>{
            let id;
            const current = this.state.value;
            return {
                entry: ()=>{
                    id = globalThis.setTimeout(()=>{
                        const next = this.getNextStateInfo(transition, this.state.event);
                        this.performStateChangeEffects(current, next, this.state.event);
                    }, delay);
                },
                exit: ()=>{
                    globalThis.clearTimeout(id);
                }
            };
        });
        /**
     * All `after` events leverage `setTimeout` and `clearTimeout`,
     * we invoke the `clearTimeout` on exit and `setTimeout` on entry.
     *
     * To achieve this, we split the `after` definition into `entry` and `exit`
     *  functions and append them to the state's `entry` and `exit` actions
     */ $5c0da97e9c7aa95f$var$__publicField(this, "getDelayedEventActions", (state)=>{
            const stateNode = this.getStateNode(state);
            const event = this.state.event;
            if (!stateNode || !stateNode.after) return;
            const entries = [];
            const exits = [];
            if ((0, $89352e0ddd72597a$export$43bee75e5e14138e)(stateNode.after)) {
                const transition = this.determineTransition(stateNode.after, event);
                if (!transition) return;
                if (!(0, $89352e0ddd72597a$export$dd642ef726dcde21)(transition, "delay")) throw new Error(`[@zag-js/core > after] Delay is required for after transition: ${JSON.stringify(transition)}`);
                const determineDelay = $5c0da97e9c7aa95f$var$determineDelayFn(transition.delay, this.delayMap);
                const __delay = determineDelay(this.contextSnapshot, event);
                const actions = this.getAfterActions(transition, __delay);
                entries.push(actions.entry);
                exits.push(actions.exit);
                return {
                    entries: entries,
                    exits: exits
                };
            }
            if ((0, $89352e0ddd72597a$export$a6cdc56e425d0d0a)(stateNode.after)) for(const delay in stateNode.after){
                const transition = stateNode.after[delay];
                const determineDelay = $5c0da97e9c7aa95f$var$determineDelayFn(delay, this.delayMap);
                const __delay = determineDelay(this.contextSnapshot, event);
                const actions = this.getAfterActions(transition, __delay);
                entries.push(actions.entry);
                exits.push(actions.exit);
            }
            return {
                entries: entries,
                exits: exits
            };
        });
        /**
     * Function to executes defined actions. It can accept actions as string
     * (referencing `options.actions`) or actual functions.
     */ $5c0da97e9c7aa95f$var$__publicField(this, "executeActions", (actions, event)=>{
            const pickedActions = $5c0da97e9c7aa95f$var$determineActionsFn(actions, this.guardMap)(this.contextSnapshot, event, this.guardMeta);
            for (const action of $5c0da97e9c7aa95f$var$toArray(pickedActions)){
                const fn = (0, $89352e0ddd72597a$export$844ec244b1367d54)(action) ? this.actionMap?.[action] : action;
                (0, $89352e0ddd72597a$export$c106dd0671a0fc2d)((0, $89352e0ddd72597a$export$844ec244b1367d54)(action) && !fn, `[@zag-js/core > execute-actions] No implementation found for action: \`${action}\``);
                fn?.(this.state.context, event, this.meta);
            }
        });
        /**
     * Function to execute running activities and registers
     * their cleanup function internally (to be called later on when we exit the state)
     */ $5c0da97e9c7aa95f$var$__publicField(this, "executeActivities", (event, activities, state)=>{
            for (const activity of activities){
                const fn = (0, $89352e0ddd72597a$export$844ec244b1367d54)(activity) ? this.activityMap?.[activity] : activity;
                if (!fn) {
                    (0, $89352e0ddd72597a$export$c106dd0671a0fc2d)(`[@zag-js/core > execute-activity] No implementation found for activity: \`${activity}\``);
                    continue;
                }
                const cleanup = fn(this.state.context, event, this.meta);
                if (cleanup) {
                    const key = (0, $89352e0ddd72597a$export$844ec244b1367d54)(activity) ? activity : activity.name || (0, $89352e0ddd72597a$export$31b40729666a4ae0)();
                    this.addActivityCleanup(state ?? this.state.value, key, cleanup);
                }
            }
        });
        /**
     * Normalizes the `every` definition to transition. `every` can be:
     * - An array of possible actions to run (we need to pick the first match based on guard)
     * - An object of intervals and actions
     */ $5c0da97e9c7aa95f$var$__publicField(this, "createEveryActivities", (every, callbackfn)=>{
            if (!every) return;
            if ((0, $89352e0ddd72597a$export$43bee75e5e14138e)(every)) {
                const picked = $5c0da97e9c7aa95f$var$toArray(every).find((transition)=>{
                    const delayOrFn = transition.delay;
                    const determineDelay2 = $5c0da97e9c7aa95f$var$determineDelayFn(delayOrFn, this.delayMap);
                    const delay2 = determineDelay2(this.contextSnapshot, this.state.event);
                    const determineGuard = $5c0da97e9c7aa95f$var$determineGuardFn(transition.guard, this.guardMap);
                    const guard = determineGuard(this.contextSnapshot, this.state.event, this.guardMeta);
                    return guard ?? delay2 != null;
                });
                if (!picked) return;
                const determineDelay = $5c0da97e9c7aa95f$var$determineDelayFn(picked.delay, this.delayMap);
                const delay = determineDelay(this.contextSnapshot, this.state.event);
                const activity = ()=>{
                    const id = globalThis.setInterval(()=>{
                        this.executeActions(picked.actions, this.state.event);
                    }, delay);
                    return ()=>{
                        globalThis.clearInterval(id);
                    };
                };
                callbackfn(activity);
            } else for(const interval in every){
                const actions = every?.[interval];
                const determineDelay = $5c0da97e9c7aa95f$var$determineDelayFn(interval, this.delayMap);
                const delay = determineDelay(this.contextSnapshot, this.state.event);
                const activity = ()=>{
                    const id = globalThis.setInterval(()=>{
                        this.executeActions(actions, this.state.event);
                    }, delay);
                    return ()=>{
                        globalThis.clearInterval(id);
                    };
                };
                callbackfn(activity);
            }
        });
        $5c0da97e9c7aa95f$var$__publicField(this, "setEvent", (event)=>{
            this.state.previousEvent = this.state.event;
            this.state.event = (0, $7bf56e9c8ff12ab3$export$eff4d24c3ff7876e)($5c0da97e9c7aa95f$var$toEvent(event));
        });
        $5c0da97e9c7aa95f$var$__publicField(this, "performExitEffects", (current, event)=>{
            const currentState = this.state.value;
            if (currentState === "") return;
            const stateNode = current ? this.getStateNode(current) : void 0;
            this.stopActivities(currentState);
            const _exit = $5c0da97e9c7aa95f$var$determineActionsFn(stateNode?.exit, this.guardMap)(this.contextSnapshot, event, this.guardMeta);
            const exitActions = $5c0da97e9c7aa95f$var$toArray(_exit);
            const afterExitActions = this.delayedEvents.get(currentState);
            if (afterExitActions) exitActions.push(...afterExitActions);
            this.executeActions(exitActions, event);
            this.delayedEvents.delete(currentState);
        });
        $5c0da97e9c7aa95f$var$__publicField(this, "performEntryEffects", (next, event)=>{
            const stateNode = this.getStateNode(next);
            const activities = $5c0da97e9c7aa95f$var$toArray(stateNode?.activities);
            this.createEveryActivities(stateNode?.every, (activity)=>{
                activities.unshift(activity);
            });
            if (activities.length > 0) this.executeActivities(event, activities);
            const pickedActions = $5c0da97e9c7aa95f$var$determineActionsFn(stateNode?.entry, this.guardMap)(this.contextSnapshot, event, this.guardMeta);
            const entryActions = $5c0da97e9c7aa95f$var$toArray(pickedActions);
            const afterActions = this.getDelayedEventActions(next);
            if (stateNode?.after && afterActions) {
                this.delayedEvents.set(next, afterActions?.exits);
                entryActions.push(...afterActions.entries);
            }
            this.executeActions(entryActions, event);
            if (stateNode?.type === "final") {
                this.state.done = true;
                this.doneListeners.forEach((listener)=>{
                    listener(this.stateSnapshot);
                });
                this.stop();
            }
        });
        $5c0da97e9c7aa95f$var$__publicField(this, "performTransitionEffects", (transitions, event)=>{
            const transition = this.determineTransition(transitions, event);
            this.executeActions(transition?.actions, event);
        });
        /**
     * Performs all the requires side-effects or reactions when
     * we move from state A => state B.
     *
     * The Effect order:
     * Exit actions (current state) => Transition actions  => Go to state => Entry actions (next state)
     */ $5c0da97e9c7aa95f$var$__publicField(this, "performStateChangeEffects", (current, next, event)=>{
            this.setEvent(event);
            const changed = next.changed || next.reenter;
            if (changed) this.performExitEffects(current, event);
            this.performTransitionEffects(next.transition, event);
            this.setState(next.target);
            if (changed) this.performEntryEffects(next.target, event);
        });
        $5c0da97e9c7aa95f$var$__publicField(this, "determineTransition", (transition, event)=>{
            const fn = $5c0da97e9c7aa95f$var$determineTransitionFn(transition, this.guardMap);
            return fn?.(this.contextSnapshot, event, this.guardMeta);
        });
        /**
     * Function to send event to parent machine from spawned child
     */ $5c0da97e9c7aa95f$var$__publicField(this, "sendParent", (evt)=>{
            if (!this.parent) (0, $89352e0ddd72597a$export$f5708dca728d7177)("[@zag-js/core > send-parent] Cannot send event to an unknown parent");
            const event = $5c0da97e9c7aa95f$var$toEvent(evt);
            this.parent?.send(event);
        });
        $5c0da97e9c7aa95f$var$__publicField(this, "log", (...args)=>{
            if ((0, $89352e0ddd72597a$export$40edfb7eeb78c4e8)() && this.options.debug) console.log(...args);
        });
        /**
     * Function to send an event to current machine
     */ $5c0da97e9c7aa95f$var$__publicField(this, "send", (evt)=>{
            const event = $5c0da97e9c7aa95f$var$toEvent(evt);
            this.transition(this.state.value, event);
        });
        $5c0da97e9c7aa95f$var$__publicField(this, "transition", (state, evt)=>{
            const stateNode = (0, $89352e0ddd72597a$export$844ec244b1367d54)(state) ? this.getStateNode(state) : state?.stateNode;
            const event = $5c0da97e9c7aa95f$var$toEvent(evt);
            if (!stateNode && !this.config.on) {
                const msg = this.status === "Stopped" /* Stopped */  ? "[@zag-js/core > transition] Cannot transition a stopped machine" : `[@zag-js/core > transition] State does not have a definition for \`state\`: ${state}, \`event\`: ${event.type}`;
                (0, $89352e0ddd72597a$export$c106dd0671a0fc2d)(msg);
                return;
            }
            const transitions = // @ts-expect-error - Fix this
            stateNode?.on?.[event.type] ?? this.config.on?.[event.type];
            const next = this.getNextStateInfo(transitions, event);
            this.performStateChangeEffects(this.state.value, next, event);
            return next.stateNode;
        });
        $5c0da97e9c7aa95f$var$__publicField(this, "subscribe", (listener)=>{
            this.stateListeners.add(listener);
            if (this.status === "Running" /* Running */ ) listener(this.stateSnapshot);
            return ()=>{
                this.stateListeners.delete(listener);
            };
        });
        $5c0da97e9c7aa95f$var$__publicField(this, "onDone", (listener)=>{
            this.doneListeners.add(listener);
            return this;
        });
        $5c0da97e9c7aa95f$var$__publicField(this, "onTransition", (listener)=>{
            this.stateListeners.add(listener);
            if (this.status === "Running" /* Running */ ) listener(this.stateSnapshot);
            return this;
        });
        this.config = (0, $7bf56e9c8ff12ab3$export$9cd59f9826255e47)(config);
        this.options = (0, $7bf56e9c8ff12ab3$export$9cd59f9826255e47)(options ?? {});
        this.id = this.config.id ?? `machine-${(0, $89352e0ddd72597a$export$31b40729666a4ae0)()}`;
        this.guardMap = this.options?.guards ?? {};
        this.actionMap = this.options?.actions ?? {};
        this.delayMap = this.options?.delays ?? {};
        this.activityMap = this.options?.activities ?? {};
        this.sync = this.options?.sync ?? false;
        this.state = $5c0da97e9c7aa95f$var$createProxy(this.config);
        this.initialContext = (0, $7bf56e9c8ff12ab3$export$b8801ea43165ed7d)(this.state.context);
    }
    // immutable state value
    get stateSnapshot() {
        return (0, $89352e0ddd72597a$export$f2db7d5238e1d23f)((0, $7bf56e9c8ff12ab3$export$b8801ea43165ed7d)(this.state));
    }
    getState() {
        return this.stateSnapshot;
    }
    // immutable context value
    get contextSnapshot() {
        return this.stateSnapshot.context;
    }
    /**
   * A reference to the instance methods of the machine.
   * Useful when spawning child machines and managing the communication between them.
   */ get self() {
        const self = this;
        return {
            id: this.id,
            send: this.send.bind(this),
            sendParent: this.sendParent.bind(this),
            sendChild: this.sendChild.bind(this),
            stop: this.stop.bind(this),
            stopChild: this.stopChild.bind(this),
            spawn: this.spawn.bind(this),
            stopActivity: this.stopActivity.bind(this),
            get state () {
                return self.stateSnapshot;
            },
            get initialContext () {
                return self.initialContext;
            },
            get initialState () {
                return self.initialState?.target ?? "";
            }
        };
    }
    get meta() {
        return {
            state: this.stateSnapshot,
            guards: this.guardMap,
            send: this.send.bind(this),
            self: this.self,
            initialContext: this.initialContext,
            initialState: this.initialState?.target ?? "",
            getState: ()=>this.stateSnapshot,
            getAction: (key)=>this.actionMap[key],
            getGuard: (key)=>this.guardMap[key]
        };
    }
    get guardMeta() {
        return {
            state: this.stateSnapshot
        };
    }
    get [Symbol.toStringTag]() {
        return "Machine";
    }
    getHydrationState() {
        const state = this.getState();
        return {
            value: state.value,
            tags: state.tags
        };
    }
};
var $5c0da97e9c7aa95f$export$aaa7fa18f8e9b2e8 = (config, options)=>new $5c0da97e9c7aa95f$export$f391db14ff2d9279(config, options);
var $5c0da97e9c7aa95f$export$2163e7903738b5df = (value)=>{
    return value instanceof $5c0da97e9c7aa95f$export$f391db14ff2d9279 || value?.type === "machine" /* Machine */ ;
};
var $5c0da97e9c7aa95f$var$clsx = (...args)=>args.map((str)=>str?.trim?.()).filter(Boolean).join(" ");
var $5c0da97e9c7aa95f$var$CSS_REGEX = /((?:--)?(?:\w+-?)+)\s*:\s*([^;]*)/g;
var $5c0da97e9c7aa95f$var$serialize = (style)=>{
    const res = {};
    let match;
    while(match = $5c0da97e9c7aa95f$var$CSS_REGEX.exec(style))res[match[1]] = match[2];
    return res;
};
var $5c0da97e9c7aa95f$var$css = (a, b)=>{
    if ((0, $89352e0ddd72597a$export$844ec244b1367d54)(a)) {
        if ((0, $89352e0ddd72597a$export$844ec244b1367d54)(b)) return `${a};${b}`;
        a = $5c0da97e9c7aa95f$var$serialize(a);
    } else if ((0, $89352e0ddd72597a$export$844ec244b1367d54)(b)) b = $5c0da97e9c7aa95f$var$serialize(b);
    return Object.assign({}, a ?? {}, b ?? {});
};
function $5c0da97e9c7aa95f$export$9d1611c77c2fe928(...args) {
    let result = {};
    for (let props of args){
        for(let key in result){
            if (key.startsWith("on") && typeof result[key] === "function" && typeof props[key] === "function") {
                result[key] = (0, $89352e0ddd72597a$export$9dd9a52f2dd5b9ce)(props[key], result[key]);
                continue;
            }
            if (key === "className" || key === "class") {
                result[key] = $5c0da97e9c7aa95f$var$clsx(result[key], props[key]);
                continue;
            }
            if (key === "style") {
                result[key] = $5c0da97e9c7aa95f$var$css(result[key], props[key]);
                continue;
            }
            result[key] = props[key] !== void 0 ? props[key] : result[key];
        }
        for(let key in props)if (result[key] === void 0) result[key] = props[key];
    }
    return result;
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $7e78ca1f48c8c7e9$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $7e78ca1f48c8c7e9$export$43e446d32b3d21af(...refs) {
    return (node)=>{
        for (const ref of refs)$7e78ca1f48c8c7e9$var$setRef(ref, node);
    };
}


function $13136dc5aae14dd9$var$getRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
const $13136dc5aae14dd9$var$withAsChild = (Component)=>{
    const Comp = (0, $acw62.memo)((0, $acw62.forwardRef)((props, ref)=>{
        const { asChild: asChild, children: children, ...restProps } = props;
        if (!asChild) return (0, $acw62.createElement)(Component, {
            ...restProps,
            ref: ref
        }, children);
        const onlyChild = (0, $acw62.Children).only(children);
        if (!(0, $acw62.isValidElement)(onlyChild)) return null;
        const childRef = $13136dc5aae14dd9$var$getRef(onlyChild);
        return (0, $acw62.cloneElement)(onlyChild, {
            ...(0, $5c0da97e9c7aa95f$export$9d1611c77c2fe928)(restProps, onlyChild.props),
            ref: ref ? (0, $7e78ca1f48c8c7e9$export$43e446d32b3d21af)(ref, childRef) : childRef
        });
    }));
    Comp.displayName = Component.displayName || Component.name;
    return Comp;
};
const $13136dc5aae14dd9$export$6953726f95ce7a26 = ()=>{
    const cache = /* @__PURE__ */ new Map();
    return new Proxy($13136dc5aae14dd9$var$withAsChild, {
        apply (_target, _thisArg, argArray) {
            return $13136dc5aae14dd9$var$withAsChild(argArray[0]);
        },
        get (_, element) {
            const asElement = element;
            if (!cache.has(asElement)) cache.set(asElement, $13136dc5aae14dd9$var$withAsChild(asElement));
            return cache.get(asElement);
        }
    });
};
const $13136dc5aae14dd9$export$d4dd0c6fc02249a9 = $13136dc5aae14dd9$export$6953726f95ce7a26();



"use client";
const [$56aa2b6daf4b4126$export$f78649fb9ca566b8, $56aa2b6daf4b4126$export$7c25e524becad277] = (0, $c09f1c0fc6a95cc7$export$fd42f52fd3ae1109)({
    name: "TooltipContext",
    hookName: "useTooltipContext",
    providerName: "<TooltipProvider />"
});


"use client";
const $2425566c512fd661$export$c27ee0ad710f7559 = (0, $acw62.forwardRef)((props, ref)=>{
    const tooltip = (0, $56aa2b6daf4b4126$export$7c25e524becad277)();
    const mergedProps = (0, $5c0da97e9c7aa95f$export$9d1611c77c2fe928)(tooltip.getArrowProps(), props);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $13136dc5aae14dd9$export$d4dd0c6fc02249a9).div, {
        ...mergedProps,
        ref: ref
    });
});
$2425566c512fd661$export$c27ee0ad710f7559.displayName = "TooltipArrow";





var $acw62 = parcelRequire("acw62");


"use client";
const $c6a7754970035450$export$c3ab883c081fd14b = (0, $acw62.forwardRef)((props, ref)=>{
    const tooltip = (0, $56aa2b6daf4b4126$export$7c25e524becad277)();
    const mergedProps = (0, $5c0da97e9c7aa95f$export$9d1611c77c2fe928)(tooltip.getArrowTipProps(), props);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $13136dc5aae14dd9$export$d4dd0c6fc02249a9).div, {
        ...mergedProps,
        ref: ref
    });
});
$c6a7754970035450$export$c3ab883c081fd14b.displayName = "TooltipArrowTip";





var $acw62 = parcelRequire("acw62");



"use client";
const [$db3c4143ce5ffba4$export$446d8ecac66007a1, $db3c4143ce5ffba4$export$de7b90475d798ca5] = (0, $c09f1c0fc6a95cc7$export$fd42f52fd3ae1109)({
    name: "PresenceContext",
    hookName: "usePresenceContext",
    providerName: "<PresenceProvider />"
});



"use client";
const $ad73072fbd419abf$export$e9003e2be37ec060 = (0, $acw62.forwardRef)((props, ref)=>{
    const tooltip = (0, $56aa2b6daf4b4126$export$7c25e524becad277)();
    const presence = (0, $db3c4143ce5ffba4$export$de7b90475d798ca5)();
    const mergedProps = (0, $5c0da97e9c7aa95f$export$9d1611c77c2fe928)(tooltip.getContentProps(), presence.getPresenceProps(), props);
    if (presence.unmounted) return null;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $13136dc5aae14dd9$export$d4dd0c6fc02249a9).div, {
        ...mergedProps,
        ref: (0, $7e78ca1f48c8c7e9$export$43e446d32b3d21af)(presence.ref, ref)
    });
});
$ad73072fbd419abf$export$e9003e2be37ec060.displayName = "TooltipContent";



"use client";
const $22105b3d7679a48f$export$39ae08fa83328b12 = (props)=>props.children((0, $56aa2b6daf4b4126$export$7c25e524becad277)());





var $acw62 = parcelRequire("acw62");



"use client";
const $560c721fd21d66e5$export$84b0dae449d0e8f7 = (0, $acw62.forwardRef)((props, ref)=>{
    const tooltip = (0, $56aa2b6daf4b4126$export$7c25e524becad277)();
    const mergedProps = (0, $5c0da97e9c7aa95f$export$9d1611c77c2fe928)(tooltip.getPositionerProps(), props);
    const presence = (0, $db3c4143ce5ffba4$export$de7b90475d798ca5)();
    if (presence.unmounted) return null;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $13136dc5aae14dd9$export$d4dd0c6fc02249a9).div, {
        ...mergedProps,
        ref: ref
    });
});
$560c721fd21d66e5$export$84b0dae449d0e8f7.displayName = "TooltipPositioner";




"use client";
const $2f63cfe652e827af$export$3ea53b214fbc1986 = ()=>(props, keys)=>keys.reduce((previousValue, currentValue)=>{
            const [target, source] = previousValue;
            const key = currentValue;
            if (source[key] !== void 0) target[key] = source[key];
            delete source[key];
            return [
                target,
                source
            ];
        }, [
            {},
            {
                ...props
            }
        ]);


"use client";
const $c32316e2d692216e$export$785dc0c15a64f8f7 = (props)=>(0, $2f63cfe652e827af$export$3ea53b214fbc1986)()(props, [
        "immediate",
        "lazyMount",
        "onExitComplete",
        "present",
        "unmountOnExit"
    ]);



// src/prop-types.ts
function $5b359805fda5a40e$export$adbadfb4429588ef(fn) {
    return new Proxy({}, {
        get () {
            return fn;
        }
    });
}
// src/create-props.ts
var $5b359805fda5a40e$export$c94ea207b45fef3a = ()=>(props)=>Array.from(new Set(props));


// src/presence.connect.ts
function $eae5258c38b068da$export$64605811ab45167f(state, send, _normalize) {
    const present = state.matches("mounted", "unmountSuspended");
    return {
        skip: !state.context.initial && present,
        present: present,
        setNode (node) {
            if (!node) return;
            send({
                type: "NODE.SET",
                node: node
            });
        },
        unmount () {
            send({
                type: "UNMOUNT"
            });
        }
    };
}
function $eae5258c38b068da$export$ea56d40cd27c3480(ctx) {
    return (0, $5c0da97e9c7aa95f$export$aaa7fa18f8e9b2e8)({
        initial: ctx.present ? "mounted" : "unmounted",
        context: {
            node: null,
            styles: null,
            unmountAnimationName: null,
            prevAnimationName: null,
            present: false,
            initial: false,
            ...ctx
        },
        exit: [
            "clearInitial",
            "cleanupNode"
        ],
        watch: {
            present: [
                "setInitial",
                "syncPresence"
            ]
        },
        on: {
            "NODE.SET": {
                actions: [
                    "setNode",
                    "setStyles"
                ]
            }
        },
        states: {
            mounted: {
                on: {
                    UNMOUNT: {
                        target: "unmounted",
                        actions: [
                            "invokeOnExitComplete"
                        ]
                    },
                    "UNMOUNT.SUSPEND": "unmountSuspended"
                }
            },
            unmountSuspended: {
                activities: [
                    "trackAnimationEvents"
                ],
                after: {
                    // Fallback to timeout to ensure we exit this state even if the `animationend` event
                    // did not get trigger
                    ANIMATION_DURATION: {
                        target: "unmounted",
                        actions: [
                            "invokeOnExitComplete"
                        ]
                    }
                },
                on: {
                    MOUNT: {
                        target: "mounted",
                        actions: [
                            "setPrevAnimationName"
                        ]
                    },
                    UNMOUNT: {
                        target: "unmounted",
                        actions: [
                            "invokeOnExitComplete"
                        ]
                    }
                }
            },
            unmounted: {
                entry: [
                    "clearPrevAnimationName"
                ],
                on: {
                    MOUNT: {
                        target: "mounted",
                        actions: [
                            "setPrevAnimationName"
                        ]
                    }
                }
            }
        }
    }, {
        delays: {
            ANIMATION_DURATION (ctx2) {
                return $eae5258c38b068da$var$parseMs(ctx2.styles?.animationDuration) + $eae5258c38b068da$var$parseMs(ctx2.styles?.animationDelay) + $eae5258c38b068da$var$ANIMATION_TIMEOUT_MARGIN;
            }
        },
        actions: {
            setInitial (ctx2) {
                ctx2.initial = true;
            },
            clearInitial (ctx2) {
                ctx2.initial = false;
            },
            cleanupNode (ctx2) {
                ctx2.node = null;
                ctx2.styles = null;
            },
            invokeOnExitComplete (ctx2) {
                ctx2.onExitComplete?.();
            },
            setNode (ctx2, evt) {
                ctx2.node = (0, $7bf56e9c8ff12ab3$export$eff4d24c3ff7876e)(evt.node);
            },
            setStyles (ctx2, evt) {
                const win = evt.node.ownerDocument.defaultView || window;
                ctx2.styles = (0, $7bf56e9c8ff12ab3$export$eff4d24c3ff7876e)(win.getComputedStyle(evt.node));
            },
            syncPresence (ctx2, _evt, { send: send }) {
                if (ctx2.present) {
                    send({
                        type: "MOUNT",
                        src: "presence.changed"
                    });
                    return;
                }
                if (!ctx2.present && ctx2.node?.ownerDocument.visibilityState === "hidden") {
                    send({
                        type: "UNMOUNT",
                        src: "visibilitychange"
                    });
                    return;
                }
                const animationName = $eae5258c38b068da$var$getAnimationName(ctx2.styles);
                const exec = ctx2.immediate ? queueMicrotask : requestAnimationFrame;
                exec(()=>{
                    ctx2.unmountAnimationName = animationName;
                    if (animationName === "none" || animationName === ctx2.prevAnimationName || ctx2.styles?.display === "none" || ctx2.styles?.animationDuration === "0s") send({
                        type: "UNMOUNT",
                        src: "presence.changed"
                    });
                    else send({
                        type: "UNMOUNT.SUSPEND"
                    });
                });
            },
            setPrevAnimationName (ctx2) {
                const exec = ctx2.immediate ? queueMicrotask : requestAnimationFrame;
                exec(()=>{
                    ctx2.prevAnimationName = $eae5258c38b068da$var$getAnimationName(ctx2.styles);
                });
            },
            clearPrevAnimationName (ctx2) {
                ctx2.prevAnimationName = null;
            }
        },
        activities: {
            trackAnimationEvents (ctx2, _evt, { send: send }) {
                const node = ctx2.node;
                if (!node) return;
                const onStart = (event)=>{
                    const target = event.composedPath?.()?.[0] ?? event.target;
                    if (target === node) ctx2.prevAnimationName = $eae5258c38b068da$var$getAnimationName(ctx2.styles);
                };
                const onEnd = (event)=>{
                    const animationName = $eae5258c38b068da$var$getAnimationName(ctx2.styles);
                    const target = event.composedPath?.()?.[0] ?? event.target;
                    if (target === node && animationName === ctx2.unmountAnimationName) send({
                        type: "UNMOUNT",
                        src: "animationend"
                    });
                };
                node.addEventListener("animationstart", onStart);
                node.addEventListener("animationcancel", onEnd);
                node.addEventListener("animationend", onEnd);
                return ()=>{
                    node.removeEventListener("animationstart", onStart);
                    node.removeEventListener("animationcancel", onEnd);
                    node.removeEventListener("animationend", onEnd);
                };
            }
        }
    });
}
function $eae5258c38b068da$var$getAnimationName(styles) {
    return styles?.animationName || "none";
}
function $eae5258c38b068da$var$parseMs(value) {
    return parseFloat(value || "0") * 1e3;
}
var $eae5258c38b068da$var$ANIMATION_TIMEOUT_MARGIN = 16.667;
var $eae5258c38b068da$export$8128bb6492cf3de7 = (0, $5b359805fda5a40e$export$c94ea207b45fef3a)()([
    "onExitComplete",
    "present",
    "immediate"
]);





var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");



var $1f415bf7923d35c7$export$601abcd8103db5e4 = (0, $5b359805fda5a40e$export$adbadfb4429588ef)((v)=>v);
var $1f415bf7923d35c7$export$602eac185826482c = (props)=>{
    const { children: children, container: container, disabled: disabled, getRootNode: getRootNode } = props;
    const isServer = typeof window === "undefined";
    if (isServer || disabled) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    });
    const doc = getRootNode?.().ownerDocument ?? document;
    const mountNode = container?.current ?? doc.body;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: (0, $acw62.Children).map(children, (child)=>(0, $1u0KT.createPortal)(child, mountNode))
    });
};
// ../../utilities/core/src/equal.ts
var $1f415bf7923d35c7$var$isArrayLike = (value)=>value?.constructor.name === "Array";
var $1f415bf7923d35c7$var$isArrayEqual = (a, b)=>{
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (!$1f415bf7923d35c7$var$isEqual(a[i], b[i])) return false;
    }
    return true;
};
var $1f415bf7923d35c7$var$isEqual = (a, b)=>{
    if (Object.is(a, b)) return true;
    if (a == null && b != null || a != null && b == null) return false;
    if (typeof a?.isEqual === "function" && typeof b?.isEqual === "function") return a.isEqual(b);
    if (typeof a === "function" && typeof b === "function") return a.toString() === b.toString();
    if ($1f415bf7923d35c7$var$isArrayLike(a) && $1f415bf7923d35c7$var$isArrayLike(b)) return $1f415bf7923d35c7$var$isArrayEqual(Array.from(a), Array.from(b));
    if (!(typeof a === "object") || !(typeof b === "object")) return false;
    const keys = Object.keys(b ?? /* @__PURE__ */ Object.create(null));
    const length = keys.length;
    for(let i = 0; i < length; i++){
        const hasKey = Reflect.has(a, keys[i]);
        if (!hasKey) return false;
    }
    for(let i = 0; i < length; i++){
        const key = keys[i];
        if (!$1f415bf7923d35c7$var$isEqual(a[key], b[key])) return false;
    }
    return true;
};
// ../../utilities/core/src/guard.ts
var $1f415bf7923d35c7$var$isDev = ()=>false;
var $1f415bf7923d35c7$var$fnToString = Function.prototype.toString;
$1f415bf7923d35c7$var$fnToString.call(Object);
// ../../utilities/core/src/object.ts
function $1f415bf7923d35c7$var$compact(obj) {
    if (!$1f415bf7923d35c7$var$isPlainObject(obj) || obj === void 0) return obj;
    const keys = Reflect.ownKeys(obj).filter((key)=>typeof key === "string");
    const filtered = {};
    for (const key of keys){
        const value = obj[key];
        if (value !== void 0) filtered[key] = $1f415bf7923d35c7$var$compact(value);
    }
    return filtered;
}
var $1f415bf7923d35c7$var$isPlainObject = (v)=>{
    return v && typeof v === "object" && v.constructor === Object;
};
function $1f415bf7923d35c7$var$useUpdateEffect(callback, deps) {
    const render = (0, $acw62.useRef)(false);
    const effect = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        const mounted = render.current;
        const run = mounted && effect.current;
        if (run) return callback();
        effect.current = true;
    }, deps);
    (0, $acw62.useEffect)(()=>{
        render.current = true;
        return ()=>{
            render.current = false;
        };
    }, []);
}
// src/use-snapshot.ts
var $1f415bf7923d35c7$var$targetCache = (0, $7bf56e9c8ff12ab3$export$69db39dc95d7166e)("__zag__targetCache", ()=>/* @__PURE__ */ new WeakMap());
function $1f415bf7923d35c7$var$useSnapshot(service, options) {
    const { actions: actions, context: context, sync: notifyInSync } = options ?? {};
    const lastSnapshot = (0, $acw62.useRef)(void 0);
    const lastAffected = (0, $acw62.useRef)(void 0);
    const currSnapshot = (0, $acw62.useSyncExternalStore)((0, $acw62.useCallback)((callback)=>(0, $7bf56e9c8ff12ab3$export$ec068583843480e7)(service.state, callback, notifyInSync), [
        notifyInSync
    ]), ()=>{
        const nextSnapshot = (0, $7bf56e9c8ff12ab3$export$b8801ea43165ed7d)(service.state);
        try {
            if (lastSnapshot.current && lastAffected.current && !(0, $2364deb6cb3c9389$export$3a85b3f4caf02b6f)(lastSnapshot.current, nextSnapshot, lastAffected.current, /* @__PURE__ */ new WeakMap())) return lastSnapshot.current;
        } catch  {}
        return nextSnapshot;
    }, ()=>(0, $7bf56e9c8ff12ab3$export$b8801ea43165ed7d)(service.state));
    service.setOptions({
        actions: actions
    });
    const ctx = (0, $acw62.useMemo)(()=>$1f415bf7923d35c7$var$compact(context ?? {}), [
        context
    ]);
    $1f415bf7923d35c7$var$useUpdateEffect(()=>{
        const entries = Object.entries(ctx);
        const previousCtx = service.contextSnapshot ?? {};
        const equality = entries.map(([key, value])=>({
                key: key,
                curr: value,
                prev: previousCtx[key],
                equal: $1f415bf7923d35c7$var$isEqual(previousCtx[key], value)
            }));
        const allEqual = equality.every(({ equal: equal })=>equal);
        if (!allEqual) service.setContext(ctx);
    }, [
        ctx
    ]);
    const currAffected = /* @__PURE__ */ new WeakMap();
    (0, $acw62.useEffect)(()=>{
        lastSnapshot.current = currSnapshot;
        lastAffected.current = currAffected;
    });
    const proxyCache = (0, $acw62.useMemo)(()=>/* @__PURE__ */ new WeakMap(), []);
    return (0, $2364deb6cb3c9389$export$7865d0c7f908de6b)(currSnapshot, currAffected, proxyCache, $1f415bf7923d35c7$var$targetCache);
}
// src/use-actor.ts
function $1f415bf7923d35c7$export$25c4ab29592aabd9(service) {
    const state = $1f415bf7923d35c7$var$useSnapshot(service);
    return [
        state,
        service.send
    ];
}
function $1f415bf7923d35c7$var$useConstant(fn) {
    const ref = (0, $acw62.useRef)(void 0);
    if (!ref.current) ref.current = {
        v: fn()
    };
    return ref.current.v;
}
var $1f415bf7923d35c7$var$useSafeLayoutEffect = typeof document !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
// src/use-service.ts
function $1f415bf7923d35c7$var$useService(machine, options) {
    const { state: hydratedState, context: context } = options ?? {};
    const service = $1f415bf7923d35c7$var$useConstant(()=>{
        const instance = typeof machine === "function" ? machine() : machine;
        if (context) instance.setContext(context);
        instance._created();
        return instance;
    });
    const snapshotRef = (0, $acw62.useRef)(void 0);
    $1f415bf7923d35c7$var$useSafeLayoutEffect(()=>{
        const stateInit = hydratedState ?? snapshotRef.current;
        service.start(stateInit);
        return ()=>{
            if ($1f415bf7923d35c7$var$isDev()) snapshotRef.current = service.getHydrationState();
            service.stop();
        };
    }, []);
    return service;
}
// src/use-machine.ts
function $1f415bf7923d35c7$export$e0338c4153421160(machine, options) {
    const service = $1f415bf7923d35c7$var$useService(machine, options);
    const state = $1f415bf7923d35c7$var$useSnapshot(service, options);
    return [
        state,
        service.send,
        service
    ];
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
function $3171cf4ad48bd85a$export$90fc3a17d93f704c(callback, opts = {}) {
    const { sync: sync = false } = opts;
    const callbackRef = $3171cf4ad48bd85a$var$useLatestRef(callback);
    return (0, $acw62.useCallback)(// biome-ignore lint/suspicious/noExplicitAny: <explanation>
    (...args)=>{
        if (sync) return queueMicrotask(()=>callbackRef.current?.(...args));
        return callbackRef.current?.(...args);
    }, [
        sync,
        callbackRef
    ]);
}
function $3171cf4ad48bd85a$var$useLatestRef(value) {
    const ref = (0, $acw62.useRef)(value);
    ref.current = value;
    return ref;
}


"use client";
const $ca3f71bdf43088cc$export$2a8c16d82a0a0e26 = (props)=>{
    const { lazyMount: lazyMount, unmountOnExit: unmountOnExit, present: present, ...rest } = props;
    const wasEverPresent = (0, $acw62.useRef)(false);
    const context = {
        ...rest,
        present: present,
        onExitComplete: (0, $3171cf4ad48bd85a$export$90fc3a17d93f704c)(props.onExitComplete)
    };
    const [state, send] = (0, $1f415bf7923d35c7$export$e0338c4153421160)($eae5258c38b068da$export$ea56d40cd27c3480(context), {
        context: context
    });
    const api = $eae5258c38b068da$export$64605811ab45167f(state, send, (0, $1f415bf7923d35c7$export$601abcd8103db5e4));
    if (api.present) wasEverPresent.current = true;
    const unmounted = !api.present && !wasEverPresent.current && lazyMount || unmountOnExit && !api.present && wasEverPresent.current;
    const getPresenceProps = ()=>({
            "data-state": present ? "open" : "closed",
            hidden: !api.present
        });
    return {
        ref: api.setNode,
        getPresenceProps: getPresenceProps,
        present: api.present,
        unmounted: unmounted
    };
};




// src/create-anatomy.ts
var $26df824f906b3a5c$export$197e6e8d4b33fd6c = (name, parts = [])=>({
        parts: (...values)=>{
            if ($26df824f906b3a5c$var$isEmpty(parts)) return $26df824f906b3a5c$export$197e6e8d4b33fd6c(name, values);
            throw new Error("createAnatomy().parts(...) should only be called once. Did you mean to use .extendWith(...) ?");
        },
        extendWith: (...values)=>$26df824f906b3a5c$export$197e6e8d4b33fd6c(name, [
                ...parts,
                ...values
            ]),
        rename: (newName)=>$26df824f906b3a5c$export$197e6e8d4b33fd6c(newName, parts),
        keys: ()=>parts,
        build: ()=>[
                ...new Set(parts)
            ].reduce((prev, part)=>Object.assign(prev, {
                    [part]: {
                        selector: [
                            `&[data-scope="${$26df824f906b3a5c$var$toKebabCase(name)}"][data-part="${$26df824f906b3a5c$var$toKebabCase(part)}"]`,
                            `& [data-scope="${$26df824f906b3a5c$var$toKebabCase(name)}"][data-part="${$26df824f906b3a5c$var$toKebabCase(part)}"]`
                        ].join(", "),
                        attrs: {
                            "data-scope": $26df824f906b3a5c$var$toKebabCase(name),
                            "data-part": $26df824f906b3a5c$var$toKebabCase(part)
                        }
                    }
                }), {})
    });
var $26df824f906b3a5c$var$toKebabCase = (value)=>value.replace(/([A-Z])([A-Z])/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase();
var $26df824f906b3a5c$var$isEmpty = (v)=>v.length === 0;




// src/index.ts
function $10f5b85675c7b32e$var$isVirtualClick(event) {
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    return event.detail === 0 && !event.pointerType;
}
function $10f5b85675c7b32e$var$isValidKey(e) {
    return !(e.metaKey || !(0, $b06ec5ff205338e5$export$9ac100e40613ea10)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
var $10f5b85675c7b32e$var$nonTextInputTypes = /* @__PURE__ */ new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
function $10f5b85675c7b32e$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    const target = e ? (0, $b06ec5ff205338e5$export$e58f029f0fbfdb29)(e) : null;
    const win = (0, $b06ec5ff205338e5$export$38b2d434cce3ea22)(target);
    isTextInput = isTextInput || target instanceof win.HTMLInputElement && !$10f5b85675c7b32e$var$nonTextInputTypes.has(target?.type) || target instanceof win.HTMLTextAreaElement || target instanceof win.HTMLElement && target.isContentEditable;
    return !(isTextInput && modality === "keyboard" && e instanceof win.KeyboardEvent && !Reflect.has($10f5b85675c7b32e$var$FOCUS_VISIBLE_INPUT_KEYS, e.key));
}
var $10f5b85675c7b32e$var$currentModality = null;
var $10f5b85675c7b32e$var$changeHandlers = /* @__PURE__ */ new Set();
var $10f5b85675c7b32e$export$b9f54f824a756af3 = /* @__PURE__ */ new Map();
var $10f5b85675c7b32e$var$hasEventBeforeFocus = false;
var $10f5b85675c7b32e$var$hasBlurredWindowRecently = false;
var $10f5b85675c7b32e$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $10f5b85675c7b32e$var$triggerChangeHandlers(modality, e) {
    for (let handler of $10f5b85675c7b32e$var$changeHandlers)handler(modality, e);
}
function $10f5b85675c7b32e$var$handleKeyboardEvent(e) {
    $10f5b85675c7b32e$var$hasEventBeforeFocus = true;
    if ($10f5b85675c7b32e$var$isValidKey(e)) {
        $10f5b85675c7b32e$var$currentModality = "keyboard";
        $10f5b85675c7b32e$var$triggerChangeHandlers("keyboard", e);
    }
}
function $10f5b85675c7b32e$var$handlePointerEvent(e) {
    $10f5b85675c7b32e$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $10f5b85675c7b32e$var$hasEventBeforeFocus = true;
        $10f5b85675c7b32e$var$triggerChangeHandlers("pointer", e);
    }
}
function $10f5b85675c7b32e$var$handleClickEvent(e) {
    if ($10f5b85675c7b32e$var$isVirtualClick(e)) {
        $10f5b85675c7b32e$var$hasEventBeforeFocus = true;
        $10f5b85675c7b32e$var$currentModality = "virtual";
    }
}
function $10f5b85675c7b32e$var$handleFocusEvent(e) {
    const target = (0, $b06ec5ff205338e5$export$e58f029f0fbfdb29)(e);
    if (target === (0, $b06ec5ff205338e5$export$38b2d434cce3ea22)(target) || target === (0, $b06ec5ff205338e5$export$f65ca476c09acec0)(target)) return;
    if (!$10f5b85675c7b32e$var$hasEventBeforeFocus && !$10f5b85675c7b32e$var$hasBlurredWindowRecently) {
        $10f5b85675c7b32e$var$currentModality = "virtual";
        $10f5b85675c7b32e$var$triggerChangeHandlers("virtual", e);
    }
    $10f5b85675c7b32e$var$hasEventBeforeFocus = false;
    $10f5b85675c7b32e$var$hasBlurredWindowRecently = false;
}
function $10f5b85675c7b32e$var$handleWindowBlur() {
    $10f5b85675c7b32e$var$hasEventBeforeFocus = false;
    $10f5b85675c7b32e$var$hasBlurredWindowRecently = true;
}
function $10f5b85675c7b32e$var$setupGlobalFocusEvents(root) {
    if (typeof window === "undefined" || $10f5b85675c7b32e$export$b9f54f824a756af3.get((0, $b06ec5ff205338e5$export$38b2d434cce3ea22)(root))) return;
    const win = (0, $b06ec5ff205338e5$export$38b2d434cce3ea22)(root);
    const doc = (0, $b06ec5ff205338e5$export$f65ca476c09acec0)(root);
    let focus = win.HTMLElement.prototype.focus;
    win.HTMLElement.prototype.focus = function() {
        $10f5b85675c7b32e$var$currentModality = "virtual";
        $10f5b85675c7b32e$var$triggerChangeHandlers("virtual", null);
        $10f5b85675c7b32e$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    doc.addEventListener("keydown", $10f5b85675c7b32e$var$handleKeyboardEvent, true);
    doc.addEventListener("keyup", $10f5b85675c7b32e$var$handleKeyboardEvent, true);
    doc.addEventListener("click", $10f5b85675c7b32e$var$handleClickEvent, true);
    win.addEventListener("focus", $10f5b85675c7b32e$var$handleFocusEvent, true);
    win.addEventListener("blur", $10f5b85675c7b32e$var$handleWindowBlur, false);
    if (typeof win.PointerEvent !== "undefined") {
        doc.addEventListener("pointerdown", $10f5b85675c7b32e$var$handlePointerEvent, true);
        doc.addEventListener("pointermove", $10f5b85675c7b32e$var$handlePointerEvent, true);
        doc.addEventListener("pointerup", $10f5b85675c7b32e$var$handlePointerEvent, true);
    } else {
        doc.addEventListener("mousedown", $10f5b85675c7b32e$var$handlePointerEvent, true);
        doc.addEventListener("mousemove", $10f5b85675c7b32e$var$handlePointerEvent, true);
        doc.addEventListener("mouseup", $10f5b85675c7b32e$var$handlePointerEvent, true);
    }
    win.addEventListener("beforeunload", ()=>{
        $10f5b85675c7b32e$var$tearDownWindowFocusTracking(root);
    }, {
        once: true
    });
    $10f5b85675c7b32e$export$b9f54f824a756af3.set(win, {
        focus: focus
    });
}
var $10f5b85675c7b32e$var$tearDownWindowFocusTracking = (root, loadListener)=>{
    const win = (0, $b06ec5ff205338e5$export$38b2d434cce3ea22)(root);
    const doc = (0, $b06ec5ff205338e5$export$f65ca476c09acec0)(root);
    if (!$10f5b85675c7b32e$export$b9f54f824a756af3.has(win)) return;
    win.HTMLElement.prototype.focus = $10f5b85675c7b32e$export$b9f54f824a756af3.get(win).focus;
    doc.removeEventListener("keydown", $10f5b85675c7b32e$var$handleKeyboardEvent, true);
    doc.removeEventListener("keyup", $10f5b85675c7b32e$var$handleKeyboardEvent, true);
    doc.removeEventListener("click", $10f5b85675c7b32e$var$handleClickEvent, true);
    win.removeEventListener("focus", $10f5b85675c7b32e$var$handleFocusEvent, true);
    win.removeEventListener("blur", $10f5b85675c7b32e$var$handleWindowBlur, false);
    if (typeof win.PointerEvent !== "undefined") {
        doc.removeEventListener("pointerdown", $10f5b85675c7b32e$var$handlePointerEvent, true);
        doc.removeEventListener("pointermove", $10f5b85675c7b32e$var$handlePointerEvent, true);
        doc.removeEventListener("pointerup", $10f5b85675c7b32e$var$handlePointerEvent, true);
    } else {
        doc.removeEventListener("mousedown", $10f5b85675c7b32e$var$handlePointerEvent, true);
        doc.removeEventListener("mousemove", $10f5b85675c7b32e$var$handlePointerEvent, true);
        doc.removeEventListener("mouseup", $10f5b85675c7b32e$var$handlePointerEvent, true);
    }
    $10f5b85675c7b32e$export$b9f54f824a756af3.delete(win);
};
function $10f5b85675c7b32e$export$630ff653c5ada6a9() {
    return $10f5b85675c7b32e$var$currentModality;
}
function $10f5b85675c7b32e$export$8397ddfc504fdb9a(modality) {
    $10f5b85675c7b32e$var$currentModality = modality;
    $10f5b85675c7b32e$var$triggerChangeHandlers(modality, null);
}
function $10f5b85675c7b32e$export$1238a82db5699f92(props) {
    const { onChange: onChange, root: root } = props;
    $10f5b85675c7b32e$var$setupGlobalFocusEvents(root);
    onChange({
        modality: $10f5b85675c7b32e$var$currentModality
    });
    const handler = ()=>onChange({
            modality: $10f5b85675c7b32e$var$currentModality
        });
    $10f5b85675c7b32e$var$changeHandlers.add(handler);
    return ()=>{
        $10f5b85675c7b32e$var$changeHandlers.delete(handler);
    };
}
function $10f5b85675c7b32e$export$b9b3dfddab17db27() {
    return $10f5b85675c7b32e$var$currentModality === "keyboard";
}
function $10f5b85675c7b32e$export$920b4983565c6f4d(props = {}) {
    const { isTextInput: isTextInput, autoFocus: autoFocus, onChange: onChange, root: root } = props;
    $10f5b85675c7b32e$var$setupGlobalFocusEvents(root);
    onChange?.({
        isFocusVisible: autoFocus || $10f5b85675c7b32e$export$b9b3dfddab17db27(),
        modality: $10f5b85675c7b32e$var$currentModality
    });
    const handler = (modality, e)=>{
        if (!$10f5b85675c7b32e$var$isKeyboardFocusEvent(!!isTextInput, modality, e)) return;
        onChange?.({
            isFocusVisible: $10f5b85675c7b32e$export$b9b3dfddab17db27(),
            modality: modality
        });
    };
    $10f5b85675c7b32e$var$changeHandlers.add(handler);
    return ()=>{
        $10f5b85675c7b32e$var$changeHandlers.delete(handler);
    };
}


/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $204931a4986f463b$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $204931a4986f463b$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $204931a4986f463b$export$803cd8101b6c182b = /*#__PURE__*/ $204931a4986f463b$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $204931a4986f463b$export$27b07d8a310ed8b5[0], side + "-" + $204931a4986f463b$export$27b07d8a310ed8b5[1]), []);
const $204931a4986f463b$export$96ec731ed4dcb222 = Math.min;
const $204931a4986f463b$export$8960430cfd85939f = Math.max;
const $204931a4986f463b$export$2077e0241d6afd3c = Math.round;
const $204931a4986f463b$export$a3fe094919f356fd = Math.floor;
const $204931a4986f463b$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $204931a4986f463b$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $204931a4986f463b$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $204931a4986f463b$export$7d15b64cf5a3a4c4(start, value, end) {
    return $204931a4986f463b$export$8960430cfd85939f(start, $204931a4986f463b$export$96ec731ed4dcb222(value, end));
}
function $204931a4986f463b$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $204931a4986f463b$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $204931a4986f463b$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $204931a4986f463b$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $204931a4986f463b$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $204931a4986f463b$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($204931a4986f463b$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $204931a4986f463b$export$2b57e0052a6d6d4c(placement) {
    return $204931a4986f463b$export$8a000a963141ac32($204931a4986f463b$export$f28e8f882010718a(placement));
}
function $204931a4986f463b$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $204931a4986f463b$export$f0989780f32bfcda(placement);
    const alignmentAxis = $204931a4986f463b$export$2b57e0052a6d6d4c(placement);
    const length = $204931a4986f463b$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $204931a4986f463b$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $204931a4986f463b$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $204931a4986f463b$export$496432a3699e50b1(placement) {
    const oppositePlacement = $204931a4986f463b$export$9c5e28bad23365fa(placement);
    return [
        $204931a4986f463b$export$2b182c584985588b(placement),
        oppositePlacement,
        $204931a4986f463b$export$2b182c584985588b(oppositePlacement)
    ];
}
function $204931a4986f463b$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$204931a4986f463b$var$oppositeAlignmentMap[alignment]);
}
function $204931a4986f463b$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $204931a4986f463b$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $204931a4986f463b$export$f0989780f32bfcda(placement);
    let list = $204931a4986f463b$var$getSideList($204931a4986f463b$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($204931a4986f463b$export$2b182c584985588b));
    }
    return list;
}
function $204931a4986f463b$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$204931a4986f463b$var$oppositeSideMap[side]);
}
function $204931a4986f463b$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $204931a4986f463b$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $204931a4986f463b$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $204931a4986f463b$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $9dccb9a8753b0e86$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $204931a4986f463b$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $204931a4986f463b$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $204931a4986f463b$export$f0989780f32bfcda)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $9dccb9a8753b0e86$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $9dccb9a8753b0e86$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $9dccb9a8753b0e86$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $204931a4986f463b$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $204931a4986f463b$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $204931a4986f463b$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $9dccb9a8753b0e86$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $204931a4986f463b$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $204931a4986f463b$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $204931a4986f463b$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $204931a4986f463b$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $204931a4986f463b$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $204931a4986f463b$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $204931a4986f463b$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $9dccb9a8753b0e86$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $204931a4986f463b$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $204931a4986f463b$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $204931a4986f463b$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $204931a4986f463b$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $204931a4986f463b$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $9dccb9a8753b0e86$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $204931a4986f463b$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $204931a4986f463b$export$803cd8101b6c182b) ? $9dccb9a8753b0e86$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $204931a4986f463b$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $204931a4986f463b$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $204931a4986f463b$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $204931a4986f463b$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $9dccb9a8753b0e86$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $204931a4986f463b$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $204931a4986f463b$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $204931a4986f463b$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $204931a4986f463b$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $204931a4986f463b$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === "y";
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $9dccb9a8753b0e86$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $9dccb9a8753b0e86$var$isAnySideFullyClipped(overflow) {
    return (0, $204931a4986f463b$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $9dccb9a8753b0e86$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $9dccb9a8753b0e86$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $9dccb9a8753b0e86$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $9dccb9a8753b0e86$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $9dccb9a8753b0e86$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $9dccb9a8753b0e86$var$getBoundingRect(rects) {
    const minX = (0, $204931a4986f463b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $204931a4986f463b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $204931a4986f463b$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $204931a4986f463b$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $9dccb9a8753b0e86$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $204931a4986f463b$export$ee05aea0aeecbad4)($9dccb9a8753b0e86$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $9dccb9a8753b0e86$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $9dccb9a8753b0e86$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $204931a4986f463b$export$ee05aea0aeecbad4)($9dccb9a8753b0e86$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $204931a4986f463b$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $204931a4986f463b$export$f28e8f882010718a)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement) === "left";
                    const maxRight = (0, $204931a4986f463b$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $204931a4986f463b$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $9dccb9a8753b0e86$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $204931a4986f463b$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $204931a4986f463b$export$f28e8f882010718a)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $9dccb9a8753b0e86$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $9dccb9a8753b0e86$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $9dccb9a8753b0e86$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $204931a4986f463b$export$f28e8f882010718a)((0, $204931a4986f463b$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $204931a4986f463b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $204931a4986f463b$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $204931a4986f463b$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $9dccb9a8753b0e86$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $204931a4986f463b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $204931a4986f463b$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $204931a4986f463b$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $9dccb9a8753b0e86$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const overflow = await $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $204931a4986f463b$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $204931a4986f463b$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $204931a4986f463b$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $c51400d9a81fca36$var$hasWindow() {
    return typeof window !== "undefined";
}
function $c51400d9a81fca36$export$651544f548703224(node) {
    if ($c51400d9a81fca36$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $c51400d9a81fca36$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $c51400d9a81fca36$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($c51400d9a81fca36$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $c51400d9a81fca36$export$8ee0fc9ee280b4ee(value) {
    if (!$c51400d9a81fca36$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).Node;
}
function $c51400d9a81fca36$export$45a5e7f76e0caa8d(value) {
    if (!$c51400d9a81fca36$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).Element;
}
function $c51400d9a81fca36$export$1b3bfaa9684536aa(value) {
    if (!$c51400d9a81fca36$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).HTMLElement;
}
function $c51400d9a81fca36$export$af51f0f06c0f328a(value) {
    if (!$c51400d9a81fca36$var$hasWindow() || typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $c51400d9a81fca36$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $c51400d9a81fca36$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $c51400d9a81fca36$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($c51400d9a81fca36$export$651544f548703224(element));
}
function $c51400d9a81fca36$export$89e651af02346cd4(element) {
    return [
        ":popover-open",
        ":modal"
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $c51400d9a81fca36$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $c51400d9a81fca36$export$78551043582a6a98();
    const css = $c51400d9a81fca36$export$45a5e7f76e0caa8d(elementOrCss) ? $c51400d9a81fca36$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return [
        "transform",
        "translate",
        "scale",
        "rotate",
        "perspective"
    ].some((value)=>css[value] ? css[value] !== "none" : false) || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "translate",
        "scale",
        "rotate",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $c51400d9a81fca36$export$940d8225183e1404(element) {
    let currentNode = $c51400d9a81fca36$export$4e12058fc4d51d56(element);
    while($c51400d9a81fca36$export$1b3bfaa9684536aa(currentNode) && !$c51400d9a81fca36$export$d1162fb0b6d4cd51(currentNode)){
        if ($c51400d9a81fca36$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($c51400d9a81fca36$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $c51400d9a81fca36$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $c51400d9a81fca36$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $c51400d9a81fca36$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($c51400d9a81fca36$export$651544f548703224(node));
}
function $c51400d9a81fca36$export$3735103072e4a80(element) {
    return $c51400d9a81fca36$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $c51400d9a81fca36$export$dc8fc79fa2800137(element) {
    if ($c51400d9a81fca36$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $c51400d9a81fca36$export$4e12058fc4d51d56(node) {
    if ($c51400d9a81fca36$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $c51400d9a81fca36$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $c51400d9a81fca36$export$e495491855dc5418(node);
    return $c51400d9a81fca36$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $c51400d9a81fca36$export$7cd01a57c8ca906c(node) {
    const parentNode = $c51400d9a81fca36$export$4e12058fc4d51d56(node);
    if ($c51400d9a81fca36$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($c51400d9a81fca36$export$1b3bfaa9684536aa(parentNode) && $c51400d9a81fca36$export$989e911fa9af580a(parentNode)) return parentNode;
    return $c51400d9a81fca36$export$7cd01a57c8ca906c(parentNode);
}
function $c51400d9a81fca36$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $c51400d9a81fca36$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $c51400d9a81fca36$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $c51400d9a81fca36$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $c51400d9a81fca36$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $c51400d9a81fca36$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $c51400d9a81fca36$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $c51400d9a81fca36$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $bede215d88ec3aee$var$getCssDimensions(element) {
    const css = (0, $c51400d9a81fca36$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $204931a4986f463b$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $204931a4986f463b$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $bede215d88ec3aee$var$unwrapElement(element) {
    return !(0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $bede215d88ec3aee$var$getScale(element) {
    const domElement = $bede215d88ec3aee$var$unwrapElement(element);
    if (!(0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(domElement)) return (0, $204931a4986f463b$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $bede215d88ec3aee$var$getCssDimensions(domElement);
    let x = ($ ? (0, $204931a4986f463b$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $204931a4986f463b$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $bede215d88ec3aee$var$noOffsets = /*#__PURE__*/ (0, $204931a4986f463b$export$a397704b5e280835)(0);
function $bede215d88ec3aee$var$getVisualOffsets(element) {
    const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element);
    if (!(0, $c51400d9a81fca36$export$78551043582a6a98)() || !win.visualViewport) return $bede215d88ec3aee$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $bede215d88ec3aee$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $bede215d88ec3aee$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $bede215d88ec3aee$var$unwrapElement(element);
    let scale = (0, $204931a4986f463b$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(offsetParent)) scale = $bede215d88ec3aee$var$getScale(offsetParent);
        } else scale = $bede215d88ec3aee$var$getScale(element);
    }
    const visualOffsets = $bede215d88ec3aee$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $bede215d88ec3aee$var$getVisualOffsets(domElement) : (0, $204931a4986f463b$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $c51400d9a81fca36$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $bede215d88ec3aee$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $c51400d9a81fca36$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $c51400d9a81fca36$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $204931a4986f463b$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $bede215d88ec3aee$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $bede215d88ec3aee$var$getBoundingClientRect((0, $c51400d9a81fca36$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $bede215d88ec3aee$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $bede215d88ec3aee$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $bede215d88ec3aee$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, $c51400d9a81fca36$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $c51400d9a81fca36$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $204931a4986f463b$export$a397704b5e280835)(1);
    const offsets = (0, $204931a4986f463b$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $c51400d9a81fca36$export$651544f548703224)(offsetParent) !== "body" || (0, $c51400d9a81fca36$export$989e911fa9af580a)(documentElement)) scroll = (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $bede215d88ec3aee$var$getBoundingClientRect(offsetParent);
            scale = $bede215d88ec3aee$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bede215d88ec3aee$var$getHTMLOffset(documentElement, scroll, true) : (0, $204931a4986f463b$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $bede215d88ec3aee$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $bede215d88ec3aee$var$getDocumentRect(element) {
    const html = (0, $c51400d9a81fca36$export$e495491855dc5418)(element);
    const scroll = (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $204931a4986f463b$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $204931a4986f463b$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $bede215d88ec3aee$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $c51400d9a81fca36$export$3735103072e4a80)(body).direction === "rtl") x += (0, $204931a4986f463b$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $bede215d88ec3aee$var$getViewportRect(element, strategy) {
    const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element);
    const html = (0, $c51400d9a81fca36$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $c51400d9a81fca36$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $bede215d88ec3aee$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $bede215d88ec3aee$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element) ? $bede215d88ec3aee$var$getScale(element) : (0, $204931a4986f463b$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $bede215d88ec3aee$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $bede215d88ec3aee$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $bede215d88ec3aee$var$getDocumentRect((0, $c51400d9a81fca36$export$e495491855dc5418)(element));
    else if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $bede215d88ec3aee$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $bede215d88ec3aee$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $204931a4986f463b$export$ee05aea0aeecbad4)(rect);
}
function $bede215d88ec3aee$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(parentNode) || (0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $c51400d9a81fca36$export$3735103072e4a80)(parentNode).position === "fixed" || $bede215d88ec3aee$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $bede215d88ec3aee$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $c51400d9a81fca36$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(el) && (0, $c51400d9a81fca36$export$651544f548703224)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $c51400d9a81fca36$export$3735103072e4a80)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(currentNode) && !(0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $c51400d9a81fca36$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $c51400d9a81fca36$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $c51400d9a81fca36$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $bede215d88ec3aee$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $bede215d88ec3aee$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? (0, $c51400d9a81fca36$export$89e651af02346cd4)(element) ? [] : $bede215d88ec3aee$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $bede215d88ec3aee$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $204931a4986f463b$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $204931a4986f463b$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $204931a4986f463b$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $204931a4986f463b$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $bede215d88ec3aee$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $bede215d88ec3aee$var$getDimensions(element) {
    const { width: width, height: height } = $bede215d88ec3aee$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $bede215d88ec3aee$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $c51400d9a81fca36$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $bede215d88ec3aee$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $204931a4986f463b$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $c51400d9a81fca36$export$651544f548703224)(offsetParent) !== "body" || (0, $c51400d9a81fca36$export$989e911fa9af580a)(documentElement)) scroll = (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $bede215d88ec3aee$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $bede215d88ec3aee$var$getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bede215d88ec3aee$var$getHTMLOffset(documentElement, scroll) : (0, $204931a4986f463b$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $bede215d88ec3aee$var$isStaticPositioned(element) {
    return (0, $c51400d9a81fca36$export$3735103072e4a80)(element).position === "static";
}
function $bede215d88ec3aee$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element) || (0, $c51400d9a81fca36$export$3735103072e4a80)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $c51400d9a81fca36$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $bede215d88ec3aee$var$getOffsetParent(element, polyfill) {
    const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element);
    if ((0, $c51400d9a81fca36$export$89e651af02346cd4)(element)) return win;
    if (!(0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$bede215d88ec3aee$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $bede215d88ec3aee$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $c51400d9a81fca36$export$71535ffaa902797f)(offsetParent) && $bede215d88ec3aee$var$isStaticPositioned(offsetParent))offsetParent = $bede215d88ec3aee$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(offsetParent) && $bede215d88ec3aee$var$isStaticPositioned(offsetParent) && !(0, $c51400d9a81fca36$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $c51400d9a81fca36$export$940d8225183e1404)(element) || win;
}
const $bede215d88ec3aee$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $bede215d88ec3aee$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $bede215d88ec3aee$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $bede215d88ec3aee$var$isRTL(element) {
    return (0, $c51400d9a81fca36$export$3735103072e4a80)(element).direction === "rtl";
}
const $bede215d88ec3aee$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $bede215d88ec3aee$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $c51400d9a81fca36$export$e495491855dc5418,
    getClippingRect: $bede215d88ec3aee$var$getClippingRect,
    getOffsetParent: $bede215d88ec3aee$var$getOffsetParent,
    getElementRects: $bede215d88ec3aee$var$getElementRects,
    getClientRects: $bede215d88ec3aee$var$getClientRects,
    getDimensions: $bede215d88ec3aee$var$getDimensions,
    getScale: $bede215d88ec3aee$var$getScale,
    isElement: $c51400d9a81fca36$export$45a5e7f76e0caa8d,
    isRTL: $bede215d88ec3aee$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $bede215d88ec3aee$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $c51400d9a81fca36$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $204931a4986f463b$export$a3fe094919f356fd)(top);
        const insetRight = (0, $204931a4986f463b$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $204931a4986f463b$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $204931a4986f463b$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $204931a4986f463b$export$8960430cfd85939f)(0, (0, $204931a4986f463b$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $bede215d88ec3aee$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $bede215d88ec3aee$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $c51400d9a81fca36$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $c51400d9a81fca36$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $bede215d88ec3aee$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $bede215d88ec3aee$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $bede215d88ec3aee$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $bede215d88ec3aee$export$37b6bde19b108ecc = (0, $9dccb9a8753b0e86$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $bede215d88ec3aee$export$cc800923e997bb8 = (0, $9dccb9a8753b0e86$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $bede215d88ec3aee$export$91fb6ecbd551914 = (0, $9dccb9a8753b0e86$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $bede215d88ec3aee$export$fba63a578e423eb = (0, $9dccb9a8753b0e86$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $bede215d88ec3aee$export$8a83211c878a3f1f = (0, $9dccb9a8753b0e86$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $bede215d88ec3aee$export$346677f925de839c = (0, $9dccb9a8753b0e86$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $bede215d88ec3aee$export$fe8985bb6374093c = (0, $9dccb9a8753b0e86$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $bede215d88ec3aee$export$f2120bbfa5450bd2 = (0, $9dccb9a8753b0e86$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $bede215d88ec3aee$export$18c8ad048e32c7d5 = (0, $9dccb9a8753b0e86$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $bede215d88ec3aee$export$7bf07e38f3dc4b69 = (0, $9dccb9a8753b0e86$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $bede215d88ec3aee$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $bede215d88ec3aee$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $9dccb9a8753b0e86$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};




// src/get-placement.ts
function $9e811243c3728edf$var$createDOMRect(x = 0, y = 0, width = 0, height = 0) {
    if (typeof DOMRect === "function") return new DOMRect(x, y, width, height);
    const rect = {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x
    };
    return {
        ...rect,
        toJSON: ()=>rect
    };
}
function $9e811243c3728edf$var$getDOMRect(anchorRect) {
    if (!anchorRect) return $9e811243c3728edf$var$createDOMRect();
    const { x: x, y: y, width: width, height: height } = anchorRect;
    return $9e811243c3728edf$var$createDOMRect(x, y, width, height);
}
function $9e811243c3728edf$var$getAnchorElement(anchorElement, getAnchorRect) {
    return {
        contextElement: (0, $b06ec5ff205338e5$export$1b3bfaa9684536aa)(anchorElement) ? anchorElement : void 0,
        getBoundingClientRect: ()=>{
            const anchor = anchorElement;
            const anchorRect = getAnchorRect?.(anchor);
            if (anchorRect || !anchor) return $9e811243c3728edf$var$getDOMRect(anchorRect);
            return anchor.getBoundingClientRect();
        }
    };
}
// src/middleware.ts
var $9e811243c3728edf$var$toVar = (value)=>({
        variable: value,
        reference: `var(${value})`
    });
var $9e811243c3728edf$var$cssVars = {
    arrowSize: $9e811243c3728edf$var$toVar("--arrow-size"),
    arrowSizeHalf: $9e811243c3728edf$var$toVar("--arrow-size-half"),
    arrowBg: $9e811243c3728edf$var$toVar("--arrow-background"),
    transformOrigin: $9e811243c3728edf$var$toVar("--transform-origin"),
    arrowOffset: $9e811243c3728edf$var$toVar("--arrow-offset")
};
var $9e811243c3728edf$var$getTransformOrigin = (arrow2)=>({
        top: "bottom center",
        "top-start": arrow2 ? `${arrow2.x}px bottom` : "left bottom",
        "top-end": arrow2 ? `${arrow2.x}px bottom` : "right bottom",
        bottom: "top center",
        "bottom-start": arrow2 ? `${arrow2.x}px top` : "top left",
        "bottom-end": arrow2 ? `${arrow2.x}px top` : "top right",
        left: "right center",
        "left-start": arrow2 ? `right ${arrow2.y}px` : "right top",
        "left-end": arrow2 ? `right ${arrow2.y}px` : "right bottom",
        right: "left center",
        "right-start": arrow2 ? `left ${arrow2.y}px` : "left top",
        "right-end": arrow2 ? `left ${arrow2.y}px` : "left bottom"
    });
var $9e811243c3728edf$var$transformOriginMiddleware = {
    name: "transformOrigin",
    fn ({ placement: placement, elements: elements, middlewareData: middlewareData }) {
        const { arrow: arrow2 } = middlewareData;
        const transformOrigin = $9e811243c3728edf$var$getTransformOrigin(arrow2)[placement];
        const { floating: floating } = elements;
        floating.style.setProperty($9e811243c3728edf$var$cssVars.transformOrigin.variable, transformOrigin);
        return {
            data: {
                transformOrigin: transformOrigin
            }
        };
    }
};
var $9e811243c3728edf$var$rectMiddleware = {
    name: "rects",
    fn ({ rects: rects }) {
        return {
            data: rects
        };
    }
};
var $9e811243c3728edf$var$shiftArrowMiddleware = (arrowEl)=>{
    if (!arrowEl) return;
    return {
        name: "shiftArrow",
        fn ({ placement: placement, middlewareData: middlewareData }) {
            if (!middlewareData.arrow) return {};
            const { x: x, y: y } = middlewareData.arrow;
            const dir = placement.split("-")[0];
            Object.assign(arrowEl.style, {
                left: x != null ? `${x}px` : "",
                top: y != null ? `${y}px` : "",
                [dir]: `calc(100% + ${$9e811243c3728edf$var$cssVars.arrowOffset.reference})`
            });
            return {};
        }
    };
};
// src/placement.ts
function $9e811243c3728edf$export$8cf10a75ab4aab46(v) {
    return /^(?:top|bottom|left|right)(?:-(?:start|end))?$/.test(v);
}
function $9e811243c3728edf$var$getPlacementDetails(placement) {
    const [side, align] = placement.split("-");
    return {
        side: side,
        align: align,
        hasAlign: align != null
    };
}
function $9e811243c3728edf$export$2f5876c005418271(placement) {
    return placement.split("-")[0];
}
// src/get-placement.ts
var $9e811243c3728edf$var$defaultOptions = {
    strategy: "absolute",
    placement: "bottom",
    listeners: true,
    gutter: 8,
    flip: true,
    slide: true,
    overlap: false,
    sameWidth: false,
    fitViewport: false,
    overflowPadding: 8,
    arrowPadding: 4
};
function $9e811243c3728edf$var$roundByDpr(win, value) {
    const dpr = win.devicePixelRatio || 1;
    return Math.round(value * dpr) / dpr;
}
function $9e811243c3728edf$var$getBoundaryMiddleware(opts) {
    return (0, $89352e0ddd72597a$export$624e501d81f5ffce)(opts.boundary);
}
function $9e811243c3728edf$var$getArrowMiddleware(arrowElement, opts) {
    if (!arrowElement) return;
    return (0, $bede215d88ec3aee$export$f2120bbfa5450bd2)({
        element: arrowElement,
        padding: opts.arrowPadding
    });
}
function $9e811243c3728edf$var$getOffsetMiddleware(arrowElement, opts) {
    if ((0, $89352e0ddd72597a$export$630801d484da15df)(opts.offset ?? opts.gutter)) return;
    return (0, $bede215d88ec3aee$export$cc800923e997bb8)(({ placement: placement })=>{
        const arrowOffset = (arrowElement?.clientHeight || 0) / 2;
        const gutter = opts.offset?.mainAxis ?? opts.gutter;
        const mainAxis = typeof gutter === "number" ? gutter + arrowOffset : gutter ?? arrowOffset;
        const { hasAlign: hasAlign } = $9e811243c3728edf$var$getPlacementDetails(placement);
        const shift2 = !hasAlign ? opts.shift : void 0;
        const crossAxis = opts.offset?.crossAxis ?? shift2;
        return (0, $89352e0ddd72597a$export$8e16b83750b44988)({
            crossAxis: crossAxis,
            mainAxis: mainAxis,
            alignmentAxis: opts.shift
        });
    });
}
function $9e811243c3728edf$var$getFlipMiddleware(opts) {
    if (!opts.flip) return;
    return (0, $bede215d88ec3aee$export$8a83211c878a3f1f)({
        boundary: $9e811243c3728edf$var$getBoundaryMiddleware(opts),
        padding: opts.overflowPadding,
        fallbackPlacements: opts.flip === true ? void 0 : opts.flip
    });
}
function $9e811243c3728edf$var$getShiftMiddleware(opts) {
    if (!opts.slide && !opts.overlap) return;
    return (0, $bede215d88ec3aee$export$fba63a578e423eb)({
        boundary: $9e811243c3728edf$var$getBoundaryMiddleware(opts),
        mainAxis: opts.slide,
        crossAxis: opts.overlap,
        padding: opts.overflowPadding,
        limiter: (0, $bede215d88ec3aee$export$7bf07e38f3dc4b69)()
    });
}
function $9e811243c3728edf$var$getSizeMiddleware(opts) {
    return (0, $bede215d88ec3aee$export$346677f925de839c)({
        padding: opts.overflowPadding,
        apply ({ elements: elements, rects: rects, availableHeight: availableHeight, availableWidth: availableWidth }) {
            const floating = elements.floating;
            const referenceWidth = Math.round(rects.reference.width);
            availableWidth = Math.floor(availableWidth);
            availableHeight = Math.floor(availableHeight);
            floating.style.setProperty("--reference-width", `${referenceWidth}px`);
            floating.style.setProperty("--available-width", `${availableWidth}px`);
            floating.style.setProperty("--available-height", `${availableHeight}px`);
        }
    });
}
function $9e811243c3728edf$var$hideWhenDetachedMiddleware(opts) {
    if (!opts.hideWhenDetached) return;
    return (0, $bede215d88ec3aee$export$fe8985bb6374093c)({
        strategy: "referenceHidden",
        boundary: opts.boundary?.() ?? "clippingAncestors"
    });
}
function $9e811243c3728edf$var$getAutoUpdateOptions(opts) {
    if (!opts) return {};
    if (opts === true) return {
        ancestorResize: true,
        ancestorScroll: true,
        elementResize: true,
        layoutShift: true
    };
    return opts;
}
function $9e811243c3728edf$var$getPlacementImpl(referenceOrVirtual, floating, opts = {}) {
    const reference = $9e811243c3728edf$var$getAnchorElement(referenceOrVirtual, opts.getAnchorRect);
    if (!floating || !reference) return;
    const options = Object.assign({}, $9e811243c3728edf$var$defaultOptions, opts);
    const arrowEl = floating.querySelector("[data-part=arrow]");
    const middleware = [
        $9e811243c3728edf$var$getOffsetMiddleware(arrowEl, options),
        $9e811243c3728edf$var$getFlipMiddleware(options),
        $9e811243c3728edf$var$getShiftMiddleware(options),
        $9e811243c3728edf$var$getArrowMiddleware(arrowEl, options),
        $9e811243c3728edf$var$shiftArrowMiddleware(arrowEl),
        $9e811243c3728edf$var$transformOriginMiddleware,
        $9e811243c3728edf$var$getSizeMiddleware(options),
        $9e811243c3728edf$var$hideWhenDetachedMiddleware(options),
        $9e811243c3728edf$var$rectMiddleware
    ];
    const { placement: placement, strategy: strategy, onComplete: onComplete, onPositioned: onPositioned } = options;
    const updatePosition = async ()=>{
        if (!reference || !floating) return;
        const pos = await (0, $bede215d88ec3aee$export$48a53dcb22e581d0)(reference, floating, {
            placement: placement,
            middleware: middleware,
            strategy: strategy
        });
        onComplete?.(pos);
        onPositioned?.({
            placed: true
        });
        const win = (0, $b06ec5ff205338e5$export$38b2d434cce3ea22)(floating);
        const x = $9e811243c3728edf$var$roundByDpr(win, pos.x);
        const y = $9e811243c3728edf$var$roundByDpr(win, pos.y);
        floating.style.setProperty("--x", `${x}px`);
        floating.style.setProperty("--y", `${y}px`);
        if (options.hideWhenDetached) {
            const isHidden = pos.middlewareData.hide?.referenceHidden;
            if (isHidden) {
                floating.style.setProperty("visibility", "hidden");
                floating.style.setProperty("pointer-events", "none");
            } else {
                floating.style.removeProperty("visibility");
                floating.style.removeProperty("pointer-events");
            }
        }
        const contentEl = floating.firstElementChild;
        if (contentEl) {
            const styles = (0, $b06ec5ff205338e5$export$3735103072e4a80)(contentEl);
            floating.style.setProperty("--z-index", styles.zIndex);
        }
    };
    const update = async ()=>{
        if (opts.updatePosition) {
            await opts.updatePosition({
                updatePosition: updatePosition
            });
            onPositioned?.({
                placed: true
            });
        } else await updatePosition();
    };
    const autoUpdateOptions = $9e811243c3728edf$var$getAutoUpdateOptions(options.listeners);
    const cancelAutoUpdate = options.listeners ? (0, $bede215d88ec3aee$export$deee3a793edee05f)(reference, floating, update, autoUpdateOptions) : (0, $89352e0ddd72597a$export$8793edee2d425525);
    update();
    return ()=>{
        cancelAutoUpdate?.();
        onPositioned?.({
            placed: false
        });
    };
}
function $9e811243c3728edf$export$a9fe23cfa43a7b55(referenceOrFn, floatingOrFn, opts = {}) {
    const { defer: defer, ...options } = opts;
    const func = defer ? (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4) : (v)=>v();
    const cleanups = [];
    cleanups.push(func(()=>{
        const reference = typeof referenceOrFn === "function" ? referenceOrFn() : referenceOrFn;
        const floating = typeof floatingOrFn === "function" ? floatingOrFn() : floatingOrFn;
        cleanups.push($9e811243c3728edf$var$getPlacementImpl(reference, floating, options));
    }));
    return ()=>{
        cleanups.forEach((fn)=>fn?.());
    };
}
// src/get-styles.ts
var $9e811243c3728edf$var$ARROW_FLOATING_STYLE = {
    bottom: "rotate(45deg)",
    left: "rotate(135deg)",
    top: "rotate(225deg)",
    right: "rotate(315deg)"
};
function $9e811243c3728edf$export$736498a3bfbba398(options = {}) {
    const { placement: placement, sameWidth: sameWidth, fitViewport: fitViewport, strategy: strategy = "absolute" } = options;
    return {
        arrow: {
            position: "absolute",
            width: $9e811243c3728edf$var$cssVars.arrowSize.reference,
            height: $9e811243c3728edf$var$cssVars.arrowSize.reference,
            [$9e811243c3728edf$var$cssVars.arrowSizeHalf.variable]: `calc(${$9e811243c3728edf$var$cssVars.arrowSize.reference} / 2)`,
            [$9e811243c3728edf$var$cssVars.arrowOffset.variable]: `calc(${$9e811243c3728edf$var$cssVars.arrowSizeHalf.reference} * -1)`
        },
        arrowTip: {
            // @ts-expect-error - Fix this
            transform: placement ? $9e811243c3728edf$var$ARROW_FLOATING_STYLE[placement.split("-")[0]] : void 0,
            background: $9e811243c3728edf$var$cssVars.arrowBg.reference,
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
            position: "absolute",
            zIndex: "inherit"
        },
        floating: {
            position: strategy,
            isolation: "isolate",
            minWidth: sameWidth ? void 0 : "max-content",
            width: sameWidth ? "var(--reference-width)" : void 0,
            maxWidth: fitViewport ? "var(--available-width)" : void 0,
            maxHeight: fitViewport ? "var(--available-height)" : void 0,
            top: "0px",
            left: "0px",
            // move off-screen if placement is not defined
            transform: placement ? "translate3d(var(--x), var(--y), 0)" : "translate3d(0, -100vh, 0)",
            zIndex: "var(--z-index)"
        }
    };
}





// src/tooltip.anatomy.ts
var $aa59da5a8c9775bf$export$477202748c7242bf = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("tooltip").parts("trigger", "arrow", "arrowTip", "positioner", "content");
var $aa59da5a8c9775bf$var$parts = $aa59da5a8c9775bf$export$477202748c7242bf.build();
var $aa59da5a8c9775bf$var$dom = (0, $b06ec5ff205338e5$export$41a9651decfe2bde)({
    getTriggerId: (ctx)=>ctx.ids?.trigger ?? `tooltip:${ctx.id}:trigger`,
    getContentId: (ctx)=>ctx.ids?.content ?? `tooltip:${ctx.id}:content`,
    getArrowId: (ctx)=>ctx.ids?.arrow ?? `tooltip:${ctx.id}:arrow`,
    getPositionerId: (ctx)=>ctx.ids?.positioner ?? `tooltip:${ctx.id}:popper`,
    getTriggerEl: (ctx)=>$aa59da5a8c9775bf$var$dom.getById(ctx, $aa59da5a8c9775bf$var$dom.getTriggerId(ctx)),
    getContentEl: (ctx)=>$aa59da5a8c9775bf$var$dom.getById(ctx, $aa59da5a8c9775bf$var$dom.getContentId(ctx)),
    getPositionerEl: (ctx)=>$aa59da5a8c9775bf$var$dom.getById(ctx, $aa59da5a8c9775bf$var$dom.getPositionerId(ctx)),
    getArrowEl: (ctx)=>$aa59da5a8c9775bf$var$dom.getById(ctx, $aa59da5a8c9775bf$var$dom.getArrowId(ctx))
});
var $aa59da5a8c9775bf$var$store = (0, $7bf56e9c8ff12ab3$export$923f96dd5afa9ce6)({
    id: null,
    prevId: null,
    setId (val) {
        this.prevId = this.id;
        this.id = val;
    }
});
// src/tooltip.connect.ts
function $aa59da5a8c9775bf$export$64605811ab45167f(state, send, normalize) {
    const id = state.context.id;
    const hasAriaLabel = state.context.hasAriaLabel;
    const open = state.hasTag("open");
    const triggerId = $aa59da5a8c9775bf$var$dom.getTriggerId(state.context);
    const contentId = $aa59da5a8c9775bf$var$dom.getContentId(state.context);
    const disabled = state.context.disabled;
    const popperStyles = (0, $9e811243c3728edf$export$736498a3bfbba398)({
        ...state.context.positioning,
        placement: state.context.currentPlacement
    });
    return {
        open: open,
        setOpen (nextOpen) {
            if (nextOpen === open) return;
            send(nextOpen ? "OPEN" : "CLOSE");
        },
        reposition (options = {}) {
            send({
                type: "POSITIONING.SET",
                options: options
            });
        },
        getTriggerProps () {
            return normalize.button({
                ...$aa59da5a8c9775bf$var$parts.trigger.attrs,
                id: triggerId,
                dir: state.context.dir,
                "data-expanded": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(open),
                "data-state": open ? "open" : "closed",
                "aria-describedby": open ? contentId : void 0,
                onClick (event) {
                    if (event.defaultPrevented) return;
                    if (disabled) return;
                    if (!state.context.closeOnClick) return;
                    send({
                        type: "CLOSE",
                        src: "trigger.click"
                    });
                },
                onFocus (event) {
                    if (event.defaultPrevented) return;
                    if (disabled) return;
                    if (state.event.src === "trigger.pointerdown") return;
                    if (!(0, $10f5b85675c7b32e$export$b9b3dfddab17db27)()) return;
                    send({
                        type: "OPEN",
                        src: "trigger.focus"
                    });
                },
                onBlur (event) {
                    if (event.defaultPrevented) return;
                    if (disabled) return;
                    if (id === $aa59da5a8c9775bf$var$store.id) send({
                        type: "CLOSE",
                        src: "trigger.blur"
                    });
                },
                onPointerDown (event) {
                    if (event.defaultPrevented) return;
                    if (disabled) return;
                    if (!state.context.closeOnPointerDown) return;
                    if (id === $aa59da5a8c9775bf$var$store.id) send({
                        type: "CLOSE",
                        src: "trigger.pointerdown"
                    });
                },
                onPointerMove (event) {
                    if (event.defaultPrevented) return;
                    if (disabled) return;
                    if (event.pointerType === "touch") return;
                    send("POINTER_MOVE");
                },
                onPointerLeave () {
                    if (disabled) return;
                    send("POINTER_LEAVE");
                },
                onPointerCancel () {
                    if (disabled) return;
                    send("POINTER_LEAVE");
                }
            });
        },
        getArrowProps () {
            return normalize.element({
                id: $aa59da5a8c9775bf$var$dom.getArrowId(state.context),
                ...$aa59da5a8c9775bf$var$parts.arrow.attrs,
                dir: state.context.dir,
                style: popperStyles.arrow
            });
        },
        getArrowTipProps () {
            return normalize.element({
                ...$aa59da5a8c9775bf$var$parts.arrowTip.attrs,
                dir: state.context.dir,
                style: popperStyles.arrowTip
            });
        },
        getPositionerProps () {
            return normalize.element({
                id: $aa59da5a8c9775bf$var$dom.getPositionerId(state.context),
                ...$aa59da5a8c9775bf$var$parts.positioner.attrs,
                dir: state.context.dir,
                style: popperStyles.floating
            });
        },
        getContentProps () {
            return normalize.element({
                ...$aa59da5a8c9775bf$var$parts.content.attrs,
                dir: state.context.dir,
                hidden: !open,
                "data-state": open ? "open" : "closed",
                role: hasAriaLabel ? void 0 : "tooltip",
                id: hasAriaLabel ? void 0 : contentId,
                "data-placement": state.context.currentPlacement,
                onPointerEnter () {
                    send("CONTENT.POINTER_MOVE");
                },
                onPointerLeave () {
                    send("CONTENT.POINTER_LEAVE");
                },
                style: {
                    pointerEvents: state.context.interactive ? "auto" : "none"
                }
            });
        }
    };
}
var { and: $aa59da5a8c9775bf$var$and, not: $aa59da5a8c9775bf$var$not } = (0, $5c0da97e9c7aa95f$export$f3249297f3edf7e9);
function $aa59da5a8c9775bf$export$ea56d40cd27c3480(userContext) {
    const ctx = (0, $89352e0ddd72597a$export$8e16b83750b44988)(userContext);
    return (0, $5c0da97e9c7aa95f$export$aaa7fa18f8e9b2e8)({
        id: "tooltip",
        initial: ctx.open ? "open" : "closed",
        activities: [
            "trackFocusVisible"
        ],
        context: {
            openDelay: 1e3,
            closeDelay: 500,
            closeOnPointerDown: true,
            closeOnEscape: true,
            interactive: false,
            closeOnScroll: true,
            closeOnClick: true,
            disabled: false,
            ...ctx,
            currentPlacement: void 0,
            hasPointerMoveOpened: false,
            positioning: {
                placement: "bottom",
                ...ctx.positioning
            }
        },
        computed: {
            hasAriaLabel: (ctx2)=>!!ctx2["aria-label"]
        },
        watch: {
            disabled: [
                "closeIfDisabled"
            ],
            open: [
                "toggleVisibility"
            ]
        },
        states: {
            closed: {
                tags: [
                    "closed"
                ],
                entry: [
                    "clearGlobalId"
                ],
                on: {
                    "CONTROLLED.OPEN": "open",
                    OPEN: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnOpen"
                            ]
                        },
                        {
                            target: "open",
                            actions: [
                                "invokeOnOpen"
                            ]
                        }
                    ],
                    POINTER_LEAVE: {
                        actions: [
                            "clearPointerMoveOpened"
                        ]
                    },
                    POINTER_MOVE: [
                        {
                            guard: $aa59da5a8c9775bf$var$and("noVisibleTooltip", $aa59da5a8c9775bf$var$not("hasPointerMoveOpened")),
                            target: "opening"
                        },
                        {
                            guard: $aa59da5a8c9775bf$var$not("hasPointerMoveOpened"),
                            target: "open",
                            actions: [
                                "setPointerMoveOpened",
                                "invokeOnOpen"
                            ]
                        }
                    ]
                }
            },
            opening: {
                tags: [
                    "closed"
                ],
                activities: [
                    "trackScroll",
                    "trackPointerlockChange"
                ],
                after: {
                    OPEN_DELAY: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "setPointerMoveOpened",
                                "invokeOnOpen"
                            ]
                        },
                        {
                            target: "open",
                            actions: [
                                "setPointerMoveOpened",
                                "invokeOnOpen"
                            ]
                        }
                    ]
                },
                on: {
                    "CONTROLLED.OPEN": "open",
                    "CONTROLLED.CLOSE": "closed",
                    OPEN: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnOpen"
                            ]
                        },
                        {
                            target: "open",
                            actions: [
                                "invokeOnOpen"
                            ]
                        }
                    ],
                    POINTER_LEAVE: [
                        {
                            guard: "isOpenControlled",
                            // We trigger toggleVisibility manually since the `ctx.open` has not changed yet (at this point)
                            actions: [
                                "clearPointerMoveOpened",
                                "invokeOnClose",
                                "toggleVisibility"
                            ]
                        },
                        {
                            target: "closed",
                            actions: [
                                "clearPointerMoveOpened",
                                "invokeOnClose"
                            ]
                        }
                    ],
                    CLOSE: [
                        {
                            guard: "isOpenControlled",
                            // We trigger toggleVisibility manually since the `ctx.open` has not changed yet (at this point)
                            actions: [
                                "invokeOnClose",
                                "toggleVisibility"
                            ]
                        },
                        {
                            target: "closed",
                            actions: [
                                "invokeOnClose"
                            ]
                        }
                    ]
                }
            },
            open: {
                tags: [
                    "open"
                ],
                activities: [
                    "trackEscapeKey",
                    "trackScroll",
                    "trackPointerlockChange",
                    "trackPositioning"
                ],
                entry: [
                    "setGlobalId"
                ],
                on: {
                    "CONTROLLED.CLOSE": "closed",
                    CLOSE: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnClose"
                            ]
                        },
                        {
                            target: "closed",
                            actions: [
                                "invokeOnClose"
                            ]
                        }
                    ],
                    POINTER_LEAVE: [
                        {
                            guard: "isVisible",
                            target: "closing",
                            actions: [
                                "clearPointerMoveOpened"
                            ]
                        },
                        // == group ==
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "clearPointerMoveOpened",
                                "invokeOnClose"
                            ]
                        },
                        {
                            target: "closed",
                            actions: [
                                "clearPointerMoveOpened",
                                "invokeOnClose"
                            ]
                        }
                    ],
                    "CONTENT.POINTER_LEAVE": {
                        guard: "isInteractive",
                        target: "closing"
                    },
                    "POSITIONING.SET": {
                        actions: "reposition"
                    }
                }
            },
            closing: {
                tags: [
                    "open"
                ],
                activities: [
                    "trackStore",
                    "trackPositioning"
                ],
                after: {
                    CLOSE_DELAY: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnClose"
                            ]
                        },
                        {
                            target: "closed",
                            actions: [
                                "invokeOnClose"
                            ]
                        }
                    ]
                },
                on: {
                    "CONTROLLED.CLOSE": "closed",
                    "CONTROLLED.OPEN": "open",
                    CLOSE: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnClose"
                            ]
                        },
                        {
                            target: "closed",
                            actions: [
                                "invokeOnClose"
                            ]
                        }
                    ],
                    POINTER_MOVE: [
                        {
                            guard: "isOpenControlled",
                            // We trigger toggleVisibility manually since the `ctx.open` has not changed yet (at this point)
                            actions: [
                                "setPointerMoveOpened",
                                "invokeOnOpen",
                                "toggleVisibility"
                            ]
                        },
                        {
                            target: "open",
                            actions: [
                                "setPointerMoveOpened",
                                "invokeOnOpen"
                            ]
                        }
                    ],
                    "CONTENT.POINTER_MOVE": {
                        guard: "isInteractive",
                        target: "open"
                    },
                    "POSITIONING.SET": {
                        actions: "reposition"
                    }
                }
            }
        }
    }, {
        activities: {
            trackFocusVisible (ctx2) {
                return (0, $10f5b85675c7b32e$export$920b4983565c6f4d)({
                    root: $aa59da5a8c9775bf$var$dom.getRootNode(ctx2)
                });
            },
            trackPositioning (ctx2) {
                ctx2.currentPlacement || (ctx2.currentPlacement = ctx2.positioning.placement);
                const getPositionerEl = ()=>$aa59da5a8c9775bf$var$dom.getPositionerEl(ctx2);
                return (0, $9e811243c3728edf$export$a9fe23cfa43a7b55)($aa59da5a8c9775bf$var$dom.getTriggerEl(ctx2), getPositionerEl, {
                    ...ctx2.positioning,
                    defer: true,
                    onComplete (data) {
                        ctx2.currentPlacement = data.placement;
                    }
                });
            },
            trackPointerlockChange (ctx2, _evt, { send: send }) {
                const onChange = ()=>send({
                        type: "CLOSE",
                        src: "pointerlock:change"
                    });
                return (0, $b06ec5ff205338e5$export$b1d829ddf82884aa)($aa59da5a8c9775bf$var$dom.getDoc(ctx2), "pointerlockchange", onChange, false);
            },
            trackScroll (ctx2, _evt, { send: send }) {
                if (!ctx2.closeOnScroll) return;
                const triggerEl = $aa59da5a8c9775bf$var$dom.getTriggerEl(ctx2);
                if (!triggerEl) return;
                const overflowParents = (0, $b06ec5ff205338e5$export$3b57c1601291186b)(triggerEl);
                const cleanups = overflowParents.map((overflowParent)=>{
                    const onScroll = ()=>{
                        send({
                            type: "CLOSE",
                            src: "scroll"
                        });
                    };
                    return (0, $b06ec5ff205338e5$export$b1d829ddf82884aa)(overflowParent, "scroll", onScroll, {
                        passive: true,
                        capture: true
                    });
                });
                return ()=>{
                    cleanups.forEach((fn)=>fn?.());
                };
            },
            trackStore (ctx2, _evt, { send: send }) {
                return (0, $7bf56e9c8ff12ab3$export$ec068583843480e7)($aa59da5a8c9775bf$var$store, ()=>{
                    if ($aa59da5a8c9775bf$var$store.id !== ctx2.id) send({
                        type: "CLOSE",
                        src: "id.change"
                    });
                });
            },
            trackEscapeKey (ctx2, _evt, { send: send }) {
                if (!ctx2.closeOnEscape) return;
                const onKeyDown = (event)=>{
                    if ((0, $b06ec5ff205338e5$export$49e72d3db4288c1)(event)) return;
                    if (event.key !== "Escape") return;
                    event.stopPropagation();
                    send({
                        type: "CLOSE",
                        src: "keydown.escape"
                    });
                };
                return (0, $b06ec5ff205338e5$export$b1d829ddf82884aa)($aa59da5a8c9775bf$var$dom.getDoc(ctx2), "keydown", onKeyDown, true);
            }
        },
        actions: {
            setGlobalId (ctx2) {
                $aa59da5a8c9775bf$var$store.setId(ctx2.id);
            },
            clearGlobalId (ctx2) {
                if (ctx2.id === $aa59da5a8c9775bf$var$store.id) $aa59da5a8c9775bf$var$store.setId(null);
            },
            invokeOnOpen (ctx2) {
                ctx2.onOpenChange?.({
                    open: true
                });
            },
            invokeOnClose (ctx2) {
                ctx2.onOpenChange?.({
                    open: false
                });
            },
            closeIfDisabled (ctx2, _evt, { send: send }) {
                if (!ctx2.disabled) return;
                send({
                    type: "CLOSE",
                    src: "disabled.change"
                });
            },
            reposition (ctx2, evt) {
                const getPositionerEl = ()=>$aa59da5a8c9775bf$var$dom.getPositionerEl(ctx2);
                (0, $9e811243c3728edf$export$a9fe23cfa43a7b55)($aa59da5a8c9775bf$var$dom.getTriggerEl(ctx2), getPositionerEl, {
                    ...ctx2.positioning,
                    ...evt.options,
                    defer: true,
                    listeners: false,
                    onComplete (data) {
                        ctx2.currentPlacement = data.placement;
                    }
                });
            },
            toggleVisibility (ctx2, evt, { send: send }) {
                queueMicrotask(()=>{
                    send({
                        type: ctx2.open ? "CONTROLLED.OPEN" : "CONTROLLED.CLOSE",
                        previousEvent: evt
                    });
                });
            },
            setPointerMoveOpened (ctx2) {
                ctx2.hasPointerMoveOpened = true;
            },
            clearPointerMoveOpened (ctx2) {
                ctx2.hasPointerMoveOpened = false;
            }
        },
        guards: {
            noVisibleTooltip: ()=>$aa59da5a8c9775bf$var$store.id === null,
            isVisible: (ctx2)=>ctx2.id === $aa59da5a8c9775bf$var$store.id,
            isInteractive: (ctx2)=>ctx2.interactive,
            hasPointerMoveOpened: (ctx2)=>!!ctx2.hasPointerMoveOpened,
            isOpenControlled: (ctx2)=>!!ctx2["open.controlled"]
        },
        delays: {
            OPEN_DELAY: (ctx2)=>ctx2.openDelay,
            CLOSE_DELAY: (ctx2)=>ctx2.closeDelay
        }
    });
}
var $aa59da5a8c9775bf$export$8128bb6492cf3de7 = (0, $5b359805fda5a40e$export$c94ea207b45fef3a)()([
    "aria-label",
    "closeDelay",
    "closeOnEscape",
    "closeOnPointerDown",
    "closeOnScroll",
    "closeOnClick",
    "dir",
    "disabled",
    "getRootNode",
    "id",
    "ids",
    "interactive",
    "onOpenChange",
    "open.controlled",
    "open",
    "openDelay",
    "positioning"
]);
var $aa59da5a8c9775bf$export$45029c61b0073d87 = (0, $89352e0ddd72597a$export$3ea53b214fbc1986)($aa59da5a8c9775bf$export$8128bb6492cf3de7);



var $acw62 = parcelRequire("acw62");


"use client";
const [$5e64ddcd24167d93$export$ff34e5addbd1eccb, $5e64ddcd24167d93$export$2a7b1d9f665d6730] = (0, $c09f1c0fc6a95cc7$export$fd42f52fd3ae1109)({
    name: "LocaleContext",
    hookName: "useLocaleContext",
    providerName: "<LocaleProvider />",
    strict: false,
    defaultValue: {
        dir: "ltr",
        locale: "en-US"
    }
});



"use client";
const $1d3e5ce17a2b5ec5$export$1c4b08e0eca38426 = (props = {})=>{
    const { getRootNode: getRootNode } = (0, $059158563f8f31ee$export$899b1e582a0b3c80)();
    const { dir: dir } = (0, $5e64ddcd24167d93$export$2a7b1d9f665d6730)();
    const initialContext = {
        id: (0, $acw62.useId)(),
        dir: dir,
        getRootNode: getRootNode,
        open: props.defaultOpen,
        "open.controlled": props.open !== void 0,
        ...props
    };
    const context = {
        ...initialContext,
        onOpenChange: (0, $3171cf4ad48bd85a$export$90fc3a17d93f704c)(props.onOpenChange, {
            sync: true
        })
    };
    const [state, send] = (0, $1f415bf7923d35c7$export$e0338c4153421160)($aa59da5a8c9775bf$export$ea56d40cd27c3480(initialContext), {
        context: context
    });
    return $aa59da5a8c9775bf$export$64605811ab45167f(state, send, (0, $1f415bf7923d35c7$export$601abcd8103db5e4));
};



"use client";
const $242f66612319711c$export$c21697e1ea9173ed = (props)=>{
    const [presenceProps, { children: children, ...localProps }] = (0, $c32316e2d692216e$export$785dc0c15a64f8f7)(props);
    const tooltip = (0, $1d3e5ce17a2b5ec5$export$1c4b08e0eca38426)(localProps);
    const presence = (0, $ca3f71bdf43088cc$export$2a8c16d82a0a0e26)((0, $5c0da97e9c7aa95f$export$9d1611c77c2fe928)({
        present: tooltip.open
    }, presenceProps));
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $56aa2b6daf4b4126$export$f78649fb9ca566b8), {
        value: tooltip,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $db3c4143ce5ffba4$export$446d8ecac66007a1), {
            value: presence,
            children: children
        })
    });
};








"use client";
const $cf6599fdc73c5e78$export$946771a20dbdbfa1 = (props)=>{
    const [presenceProps, { value: tooltip, children: children }] = (0, $c32316e2d692216e$export$785dc0c15a64f8f7)(props);
    const presence = (0, $ca3f71bdf43088cc$export$2a8c16d82a0a0e26)((0, $5c0da97e9c7aa95f$export$9d1611c77c2fe928)({
        present: tooltip.open
    }, presenceProps));
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $56aa2b6daf4b4126$export$f78649fb9ca566b8), {
        value: tooltip,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $db3c4143ce5ffba4$export$446d8ecac66007a1), {
            value: presence,
            children: children
        })
    });
};





var $acw62 = parcelRequire("acw62");


"use client";
const $f26e0653a2ead678$export$8c610744efcf8a1d = (0, $acw62.forwardRef)((props, ref)=>{
    const tooltip = (0, $56aa2b6daf4b4126$export$7c25e524becad277)();
    const mergedProps = (0, $5c0da97e9c7aa95f$export$9d1611c77c2fe928)(tooltip.getTriggerProps(), props);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $13136dc5aae14dd9$export$d4dd0c6fc02249a9).button, {
        ...mergedProps,
        ref: ref
    });
});
$f26e0653a2ead678$export$8c610744efcf8a1d.displayName = "TooltipTrigger";





"use strict";
"use client";
const { withRootProvider: $8d803391fcba4002$var$withRootProvider, withContext: $8d803391fcba4002$var$withContext, useStyles: $8d803391fcba4002$export$805718aab2624980, PropsProvider: $8d803391fcba4002$var$PropsProvider } = (0, $975f34631e6d460a$export$ac7f79c9443925b8)({
    key: "tooltip"
});
const $8d803391fcba4002$export$946771a20dbdbfa1 = $8d803391fcba4002$var$withRootProvider((0, $ef898291ec002f82$exports).RootProvider);
const $8d803391fcba4002$export$c21697e1ea9173ed = $8d803391fcba4002$var$withRootProvider((0, $ef898291ec002f82$exports).Root, {
    defaultProps: {
        lazyMount: true,
        unmountOnExit: true
    }
});
const $8d803391fcba4002$export$f5fb98130cf3ead9 = $8d803391fcba4002$var$PropsProvider;
const $8d803391fcba4002$export$8c610744efcf8a1d = $8d803391fcba4002$var$withContext((0, $ef898291ec002f82$exports).Trigger, "trigger", {
    forwardAsChild: true
});
const $8d803391fcba4002$export$84b0dae449d0e8f7 = $8d803391fcba4002$var$withContext((0, $ef898291ec002f82$exports).Positioner, "positioner", {
    forwardAsChild: true
});
const $8d803391fcba4002$export$e9003e2be37ec060 = $8d803391fcba4002$var$withContext((0, $ef898291ec002f82$exports).Content, "content", {
    forwardAsChild: true
});
const $8d803391fcba4002$export$c27ee0ad710f7559 = $8d803391fcba4002$var$withContext((0, $ef898291ec002f82$exports).Arrow, "arrow", {
    forwardAsChild: true
});
const $8d803391fcba4002$export$c3ab883c081fd14b = $8d803391fcba4002$var$withContext((0, $ef898291ec002f82$exports).ArrowTip, "arrowTip", {
    forwardAsChild: true
});
const $8d803391fcba4002$export$39ae08fa83328b12 = (0, $ef898291ec002f82$exports).Context;


"use strict";


const $75039f93b4d4aeb6$export$28c660c63b792dea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function Tooltip(props, ref) {
    const { showArrow: showArrow, children: children, disabled: disabled, portalled: portalled = true, content: content, contentProps: contentProps, portalRef: portalRef, ...rest } = props;
    if (disabled) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $54141a59eba486c0$exports).Root, {
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $54141a59eba486c0$exports).Trigger, {
        asChild: true
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0aa5f269574efb3e$export$602eac185826482c), {
        disabled: !portalled,
        container: portalRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $54141a59eba486c0$exports).Positioner, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $54141a59eba486c0$exports).Content, {
        ref: ref,
        ...contentProps
    }, showArrow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $54141a59eba486c0$exports).Arrow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $54141a59eba486c0$exports).ArrowTip, null)), content))));
});


const $385655437d631473$var$iconNames = Object.keys($85b88a992de89b18$exports).filter((k)=>k.startsWith("Collecticon"));
const $385655437d631473$var$HighlightBox = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e44bdf01ce5be678$export$e71c4d32a2263218), {
        p: {
            base: "1rem",
            md: "2rem"
        },
        bg: "rgba(255,255,255,0.16)",
        overflowX: "auto",
        ...props
    });
const $385655437d631473$var$TextLink = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6a8ad047b05e4916$export$a6c7ac8248d6e38a), {
        textDecoration: "underline",
        _hover: {
            opacity: 0.64
        },
        ...props
    });
function $385655437d631473$export$86fbec116b87613f() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e44bdf01ce5be678$export$e71c4d32a2263218), {
        minH: "100vh",
        bgColor: "primary",
        bgImage: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($2b4a7ce7bd2c99e2$exports)))})`,
        bgRepeat: "no-repeat",
        bgSize: "cover",
        bgPos: [
            "-48vw center",
            "-48vw top",
            "-80vw center"
        ],
        color: "base",
        animation: {
            md: "mainBg"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7b9aee1d6c050693$export$42a852a2b6b56249), {
        maxW: "container.xl",
        color: "white",
        display: "flex",
        flexFlow: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e44bdf01ce5be678$export$e71c4d32a2263218), {
        as: "header",
        role: "banner",
        animation: "fade-in",
        animationDuration: "1s",
        textAlign: "center",
        padding: {
            base: "2rem",
            sm: "3rem",
            md: "4rem"
        },
        textTransform: "uppercase",
        fontWeight: "700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $86ee73686dbc0e1a$export$a8a3e93435678ff9), {
        fontSize: {
            base: "2rem",
            sm: "3rem",
            md: "4rem",
            lg: "5rem",
            xl: "6rem"
        },
        position: "relative",
        lineHeight: "1",
        pt: "3.2%",
        margin: "0",
        _before: {
            content: '""',
            position: "absolute",
            top: 0,
            left: "50%",
            transform: "translate(-50%, 0)",
            width: "12%",
            height: "10%",
            maxW: "10rem",
            background: "#fff"
        }
    }, "Collecticons"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a78d01f419bf79df$export$5f1af8db9871e1d6), {
        fontSize: {
            base: "1rem",
            sm: "1.25rem",
            md: "1.5rem"
        },
        mt: "4"
    }, "An evergrowing collection of crisp icons."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a78d01f419bf79df$export$5f1af8db9871e1d6), {
        mt: "8"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dcc08b6ba0830e03$export$353f5b6fc5456de1), {
        asChild: true,
        title: "Get the icons!",
        borderRadius: "0",
        bg: "white/16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        href: "collecticons.zip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, "Download"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a78d01f419bf79df$export$5f1af8db9871e1d6), {
        as: "small",
        display: "block",
        fontSize: "1rem",
        lineHeight: "1.5",
        mt: "0.5rem",
        opacity: "0.64"
    }, "V", $85b88a992de89b18$exports.version, " / ", $385655437d631473$var$iconNames.length, " icons"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e44bdf01ce5be678$export$e71c4d32a2263218), {
        as: "main",
        role: "main"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e44bdf01ce5be678$export$e71c4d32a2263218), {
        as: "section",
        mb: {
            base: "3rem",
            md: "4rem"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2dea3e0803adfea1$export$439d29a4e110a164), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0d0f5c87991c3283$export$284abb4664c19c7c), null, "Showcase")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $96e9fa4e455ee4bb$exports).Root, {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        gap: "4",
        flexWrap: "wrap",
        variant: "plain"
    }, $385655437d631473$var$iconNames.map((iconName)=>{
        const Cmp = $85b88a992de89b18$exports[iconName];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $96e9fa4e455ee4bb$exports).Item, {
            key: iconName,
            display: "flex",
            background: "rgba(255,255,255,0.16)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($385655437d631473$var$CollecticonItem, {
            Component: Cmp,
            name: iconName
        }));
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e44bdf01ce5be678$export$e71c4d32a2263218), {
        as: "section",
        mb: {
            base: "3rem",
            md: "4rem"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0d0f5c87991c3283$export$284abb4664c19c7c), null, "Usage"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7b9aee1d6c050693$export$42a852a2b6b56249), {
        maxW: "container.md",
        fontSize: {
            md: "1.25rem"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $86ee73686dbc0e1a$export$a8a3e93435678ff9), {
        as: "h3",
        fontSize: [
            "lg",
            "xl",
            "2xl",
            "3xl"
        ],
        mb: 4
    }, "Downloading the SVG's"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $96e9fa4e455ee4bb$exports).Root, {
        as: "ol",
        pl: 4,
        mb: 8
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $96e9fa4e455ee4bb$exports).Item, {
        mb: 4
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($385655437d631473$var$TextLink, {
        href: "/collecticons.zip",
        title: "Get the icons!"
    }, "Download collecticons"), "."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $96e9fa4e455ee4bb$exports).Item, {
        mb: 4
    }, "Done! \u2728")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $86ee73686dbc0e1a$export$a8a3e93435678ff9), {
        as: "h3",
        fontSize: [
            "lg",
            "xl",
            "2xl",
            "3xl"
        ],
        mb: 4
    }, "Collecticons for React"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a78d01f419bf79df$export$5f1af8db9871e1d6), {
        mb: 4
    }, "You can also use collecticons with", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($385655437d631473$var$TextLink, {
        href: "https://www.npmjs.com/",
        title: "View NPM website"
    }, "NPM"), "."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $96e9fa4e455ee4bb$exports).Root, {
        as: "ol",
        pl: 4,
        mb: 8
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $96e9fa4e455ee4bb$exports).Item, {
        mb: 4
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Install collecticons."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($385655437d631473$var$HighlightBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("pre", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("code", null, "yarn add @devseed-ui/collecticons-react")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $96e9fa4e455ee4bb$exports).Item, {
        mb: 4
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Simply use an icon in your app."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($385655437d631473$var$HighlightBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("pre", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("code", null, "<CollecticonBrandDevelopmentSeed />"))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $86ee73686dbc0e1a$export$a8a3e93435678ff9), {
        as: "h3",
        fontSize: [
            "lg",
            "xl",
            "2xl",
            "3xl"
        ],
        mb: 4
    }, "Collecticons (Chakra UI specific)"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a78d01f419bf79df$export$5f1af8db9871e1d6), {
        mb: 4
    }, "Collecticons is also available specifically for", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($385655437d631473$var$TextLink, {
        href: "https://chakra-ui.com/"
    }, "Chakra UI"), " ", "making it possible to use with the Chakra styled system."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $96e9fa4e455ee4bb$exports).Root, {
        as: "ol",
        pl: 4,
        mb: 8
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $96e9fa4e455ee4bb$exports).Item, {
        mb: 4
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Install collecticons."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($385655437d631473$var$HighlightBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("pre", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("code", null, "yarn add @devseed-ui/collecticons-chakra")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $96e9fa4e455ee4bb$exports).Item, {
        mb: 4
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Simply use an icon in your app."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($385655437d631473$var$HighlightBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("pre", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("code", null, `<CollecticonBrandDevelopmentSeed fontSize={{ base: '4', lg: '8' }} />`))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e44bdf01ce5be678$export$e71c4d32a2263218), {
        as: "section",
        mb: {
            base: "3rem",
            md: "4rem"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0d0f5c87991c3283$export$284abb4664c19c7c), null, "About"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7b9aee1d6c050693$export$42a852a2b6b56249), {
        maxW: "container.md",
        fontSize: {
            md: "1.25rem"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a78d01f419bf79df$export$5f1af8db9871e1d6), {
        mb: 4
    }, "We at", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($385655437d631473$var$TextLink, {
        href: "https://developmentseed.org",
        title: "Visit Development Seed website"
    }, "Development Seed"), " ", "use iconography in a lot of projects. Some of the icons were designed/built on top of libraries like", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($385655437d631473$var$TextLink, {
        href: "https://github.com/Keyamoon/IcoMoon-Free",
        title: "View icoMoon webfont"
    }, "icoMoon by Keyamoon"), " ", "and others were made in house. This evergrowing collection is a set of the icons we've been using so far and are now available for free under the", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($385655437d631473$var$TextLink, {
        href: "https://github.com/developmentseed/collecticons/blob/master/LICENSE",
        title: "View license"
    }, "The MIT License"), " ", "and the", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($385655437d631473$var$TextLink, {
        href: "https://creativecommons.org/licenses/by/4.0/"
    }, "Creative Commons Attribution License 4.0"), "."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a78d01f419bf79df$export$5f1af8db9871e1d6), {
        mb: 4
    }, "If you feel like contributing to this library checkout our", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($385655437d631473$var$TextLink, {
        href: "https://github.com/developmentseed/collecticons",
        title: "View collecticons icon library"
    }, "collecticons library"), " ", "repo and submit a pull request."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e44bdf01ce5be678$export$e71c4d32a2263218), {
        as: "footer",
        role: "contentinfo",
        py: "2rem",
        textTransform: "uppercase",
        fontSize: "0.875rem",
        lineHeight: "1.25rem",
        opacity: "0.64",
        animation: "fade-in",
        animationDuration: "1s"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a78d01f419bf79df$export$5f1af8db9871e1d6), {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1
    }, "Made with ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($85b88a992de89b18$exports.CollecticonHeart, null), " by", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6a8ad047b05e4916$export$a6c7ac8248d6e38a), {
        href: "https://developmentseed.org",
        title: "Visit Development Seed website"
    }, "Development Seed"), "."))));
}
function $385655437d631473$var$CollecticonItem({ Component: Component, name: name }) {
    const [showCopiedMsg, setShowCopiedMsg] = (0, $acw62.useState)(false);
    const triggerElement = (0, $acw62.useRef)(null);
    const copyValue = (0, $acw62.useRef)(name);
    copyValue.current = name;
    const [isHover, setIsHover] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!triggerElement.current) throw new Error("ref for trigger element is not set");
        let copiedMsgTimeout;
        const clipboard = new (0, (/*@__PURE__*/$parcel$interopDefault($40f75bffb1354217$exports)))(triggerElement.current, {
            text: ()=>copyValue.current
        });
        clipboard.on("success", ()=>{
            setShowCopiedMsg(true);
            copiedMsgTimeout = setTimeout(()=>{
                setShowCopiedMsg(false);
            }, 2000);
        });
        return ()=>{
            clipboard.destroy();
            if (copiedMsgTimeout) clearTimeout(copiedMsgTimeout);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $75039f93b4d4aeb6$export$28c660c63b792dea), {
        showArrow: true,
        positioning: {
            placement: "top"
        },
        content: showCopiedMsg ? "Copied!" : name,
        openDelay: 0,
        open: isHover
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6a8ad047b05e4916$export$a6c7ac8248d6e38a), {
        href: "#",
        p: "4",
        onClick: (e)=>e.preventDefault(),
        ref: triggerElement,
        color: "white",
        onMouseEnter: ()=>setIsHover(true),
        onMouseLeave: ()=>setIsHover(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, {
        fontSize: {
            base: "4",
            lg: "8"
        }
    })));
}


// src/index.ts
var $34089d82611f238e$var$userGeneratedStr = "";
var $34089d82611f238e$var$userGenerated = $34089d82611f238e$var$userGeneratedStr.split(",");
var $34089d82611f238e$var$cssPropertiesStr = "WebkitAppearance,WebkitBorderBefore,WebkitBorderBeforeColor,WebkitBorderBeforeStyle,WebkitBorderBeforeWidth,WebkitBoxReflect,WebkitLineClamp,WebkitMask,WebkitMaskAttachment,WebkitMaskClip,WebkitMaskComposite,WebkitMaskImage,WebkitMaskOrigin,WebkitMaskPosition,WebkitMaskPositionX,WebkitMaskPositionY,WebkitMaskRepeat,WebkitMaskRepeatX,WebkitMaskRepeatY,WebkitMaskSize,WebkitOverflowScrolling,WebkitTapHighlightColor,WebkitTextFillColor,WebkitTextStroke,WebkitTextStrokeColor,WebkitTextStrokeWidth,WebkitTouchCallout,WebkitUserModify,accentColor,alignContent,alignItems,alignSelf,alignTracks,all,animation,animationComposition,animationDelay,animationDirection,animationDuration,animationFillMode,animationIterationCount,animationName,animationPlayState,animationRange,animationRangeEnd,animationRangeStart,animationTimingFunction,animationTimeline,appearance,aspectRatio,azimuth,backdropFilter,backfaceVisibility,background,backgroundAttachment,backgroundBlendMode,backgroundClip,backgroundColor,backgroundImage,backgroundOrigin,backgroundPosition,backgroundPositionX,backgroundPositionY,backgroundRepeat,backgroundSize,blockSize,border,borderBlock,borderBlockColor,borderBlockStyle,borderBlockWidth,borderBlockEnd,borderBlockEndColor,borderBlockEndStyle,borderBlockEndWidth,borderBlockStart,borderBlockStartColor,borderBlockStartStyle,borderBlockStartWidth,borderBottom,borderBottomColor,borderBottomLeftRadius,borderBottomRightRadius,borderBottomStyle,borderBottomWidth,borderCollapse,borderColor,borderEndEndRadius,borderEndStartRadius,borderImage,borderImageOutset,borderImageRepeat,borderImageSlice,borderImageSource,borderImageWidth,borderInline,borderInlineEnd,borderInlineColor,borderInlineStyle,borderInlineWidth,borderInlineEndColor,borderInlineEndStyle,borderInlineEndWidth,borderInlineStart,borderInlineStartColor,borderInlineStartStyle,borderInlineStartWidth,borderLeft,borderLeftColor,borderLeftStyle,borderLeftWidth,borderRadius,borderRight,borderRightColor,borderRightStyle,borderRightWidth,borderSpacing,borderStartEndRadius,borderStartStartRadius,borderStyle,borderTop,borderTopColor,borderTopLeftRadius,borderTopRightRadius,borderTopStyle,borderTopWidth,borderWidth,bottom,boxAlign,boxDecorationBreak,boxDirection,boxFlex,boxFlexGroup,boxLines,boxOrdinalGroup,boxOrient,boxPack,boxShadow,boxSizing,breakAfter,breakBefore,breakInside,captionSide,caret,caretColor,caretShape,clear,clip,clipPath,color,colorScheme,columnCount,columnFill,columnGap,columnRule,columnRuleColor,columnRuleStyle,columnRuleWidth,columnSpan,columnWidth,columns,contain,containIntrinsicSize,containIntrinsicBlockSize,containIntrinsicHeight,containIntrinsicInlineSize,containIntrinsicWidth,container,containerName,containerType,content,contentVisibility,counterIncrement,counterReset,counterSet,cursor,direction,display,emptyCells,filter,flex,flexBasis,flexDirection,flexFlow,flexGrow,flexShrink,flexWrap,float,font,fontFamily,fontFeatureSettings,fontKerning,fontLanguageOverride,fontOpticalSizing,fontPalette,fontVariationSettings,fontSize,fontSizeAdjust,fontSmooth,fontStretch,fontStyle,fontSynthesis,fontSynthesisPosition,fontSynthesisSmallCaps,fontSynthesisStyle,fontSynthesisWeight,fontVariant,fontVariantAlternates,fontVariantCaps,fontVariantEastAsian,fontVariantEmoji,fontVariantLigatures,fontVariantNumeric,fontVariantPosition,fontWeight,forcedColorAdjust,gap,grid,gridArea,gridAutoColumns,gridAutoFlow,gridAutoRows,gridColumn,gridColumnEnd,gridColumnGap,gridColumnStart,gridGap,gridRow,gridRowEnd,gridRowGap,gridRowStart,gridTemplate,gridTemplateAreas,gridTemplateColumns,gridTemplateRows,hangingPunctuation,height,hyphenateCharacter,hyphenateLimitChars,hyphens,imageOrientation,imageRendering,imageResolution,imeMode,initialLetter,initialLetterAlign,inlineSize,inputSecurity,inset,insetBlock,insetBlockEnd,insetBlockStart,insetInline,insetInlineEnd,insetInlineStart,isolation,justifyContent,justifyItems,justifySelf,justifyTracks,left,letterSpacing,lineBreak,lineClamp,lineHeight,lineHeightStep,listStyle,listStyleImage,listStylePosition,listStyleType,margin,marginBlock,marginBlockEnd,marginBlockStart,marginBottom,marginInline,marginInlineEnd,marginInlineStart,marginLeft,marginRight,marginTop,marginTrim,mask,maskBorder,maskBorderMode,maskBorderOutset,maskBorderRepeat,maskBorderSlice,maskBorderSource,maskBorderWidth,maskClip,maskComposite,maskImage,maskMode,maskOrigin,maskPosition,maskRepeat,maskSize,maskType,masonryAutoFlow,mathDepth,mathShift,mathStyle,maxBlockSize,maxHeight,maxInlineSize,maxLines,maxWidth,minBlockSize,minHeight,minInlineSize,minWidth,mixBlendMode,objectFit,objectPosition,offset,offsetAnchor,offsetDistance,offsetPath,offsetPosition,offsetRotate,opacity,order,orphans,outline,outlineColor,outlineOffset,outlineStyle,outlineWidth,overflow,overflowAnchor,overflowBlock,overflowClipBox,overflowClipMargin,overflowInline,overflowWrap,overflowX,overflowY,overlay,overscrollBehavior,overscrollBehaviorBlock,overscrollBehaviorInline,overscrollBehaviorX,overscrollBehaviorY,padding,paddingBlock,paddingBlockEnd,paddingBlockStart,paddingBottom,paddingInline,paddingInlineEnd,paddingInlineStart,paddingLeft,paddingRight,paddingTop,page,pageBreakAfter,pageBreakBefore,pageBreakInside,paintOrder,perspective,perspectiveOrigin,placeContent,placeItems,placeSelf,pointerEvents,position,printColorAdjust,quotes,resize,right,rotate,rowGap,rubyAlign,rubyMerge,rubyPosition,scale,scrollbarColor,scrollbarGutter,scrollbarWidth,scrollBehavior,scrollMargin,scrollMarginBlock,scrollMarginBlockStart,scrollMarginBlockEnd,scrollMarginBottom,scrollMarginInline,scrollMarginInlineStart,scrollMarginInlineEnd,scrollMarginLeft,scrollMarginRight,scrollMarginTop,scrollPadding,scrollPaddingBlock,scrollPaddingBlockStart,scrollPaddingBlockEnd,scrollPaddingBottom,scrollPaddingInline,scrollPaddingInlineStart,scrollPaddingInlineEnd,scrollPaddingLeft,scrollPaddingRight,scrollPaddingTop,scrollSnapAlign,scrollSnapCoordinate,scrollSnapDestination,scrollSnapPointsX,scrollSnapPointsY,scrollSnapStop,scrollSnapType,scrollSnapTypeX,scrollSnapTypeY,scrollTimeline,scrollTimelineAxis,scrollTimelineName,shapeImageThreshold,shapeMargin,shapeOutside,tabSize,tableLayout,textAlign,textAlignLast,textCombineUpright,textDecoration,textDecorationColor,textDecorationLine,textDecorationSkip,textDecorationSkipInk,textDecorationStyle,textDecorationThickness,textEmphasis,textEmphasisColor,textEmphasisPosition,textEmphasisStyle,textIndent,textJustify,textOrientation,textOverflow,textRendering,textShadow,textSizeAdjust,textTransform,textUnderlineOffset,textUnderlinePosition,textWrap,timelineScope,top,touchAction,transform,transformBox,transformOrigin,transformStyle,transition,transitionBehavior,transitionDelay,transitionDuration,transitionProperty,transitionTimingFunction,translate,unicodeBidi,userSelect,verticalAlign,viewTimeline,viewTimelineAxis,viewTimelineInset,viewTimelineName,viewTransitionName,visibility,whiteSpace,whiteSpaceCollapse,widows,width,willChange,wordBreak,wordSpacing,wordWrap,writingMode,zIndex,zoom,alignmentBaseline,baselineShift,clipRule,colorInterpolation,colorRendering,dominantBaseline,fill,fillOpacity,fillRule,floodColor,floodOpacity,glyphOrientationVertical,lightingColor,marker,markerEnd,markerMid,markerStart,shapeRendering,stopColor,stopOpacity,stroke,strokeDasharray,strokeDashoffset,strokeLinecap,strokeLinejoin,strokeMiterlimit,strokeOpacity,strokeWidth,textAnchor,vectorEffect";
var $34089d82611f238e$export$e22b134a0d53ed0a = $34089d82611f238e$var$cssPropertiesStr.split(",").concat($34089d82611f238e$var$userGenerated);
var $34089d82611f238e$var$properties = new Map($34089d82611f238e$export$e22b134a0d53ed0a.map((prop)=>[
        prop,
        true
    ]));
function $34089d82611f238e$var$memo(fn) {
    const cache = /* @__PURE__ */ Object.create(null);
    return (arg)=>{
        if (cache[arg] === void 0) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $34089d82611f238e$var$cssPropertySelectorRegex = /&|@/;
var $34089d82611f238e$export$74465ce51e034ce6 = /* @__PURE__ */ $34089d82611f238e$var$memo((prop)=>{
    return $34089d82611f238e$var$properties.has(prop) || prop.startsWith("--") || $34089d82611f238e$var$cssPropertySelectorRegex.test(prop);
});




"use strict";
const $d37e33c22423b9ba$var$isNotNullish = (element)=>element != null;
function $d37e33c22423b9ba$export$915658b6215945a4(target, predicate, options = {}) {
    const { stop: stop, getKey: getKey } = options;
    function inner(value, path = []) {
        if ((0, $b3f328a5401a2298$export$a6cdc56e425d0d0a)(value) || Array.isArray(value)) {
            const result = {};
            for (const [prop, child] of Object.entries(value)){
                const key = getKey?.(prop, child) ?? prop;
                const childPath = [
                    ...path,
                    key
                ];
                if (stop?.(value, childPath)) return predicate(value, path);
                const next = inner(child, childPath);
                if ($d37e33c22423b9ba$var$isNotNullish(next)) result[key] = next;
            }
            return result;
        }
        return predicate(value, path);
    }
    return inner(target);
}
function $d37e33c22423b9ba$export$d6051a0f7a227332(obj, fn) {
    if (Array.isArray(obj)) return obj.map((value)=>fn(value));
    if (!(0, $b3f328a5401a2298$export$a6cdc56e425d0d0a)(obj)) {
        if (obj !== null && obj !== void 0) return fn(obj);
        else return obj;
    }
    return $d37e33c22423b9ba$export$915658b6215945a4(obj, (value)=>fn(value));
}


"use strict";
function $0b8ad33560552d98$export$bffa455ba8c619a6(values, stop) {
    const result = {};
    (0, $d37e33c22423b9ba$export$915658b6215945a4)(values, (token, paths)=>{
        if (token) result[paths.join(".")] = token.value;
    }, {
        stop: stop
    });
    return result;
}



var $c924af90aa582a4d$exports = {};
$c924af90aa582a4d$exports = $c924af90aa582a4d$var$stringify;
$c924af90aa582a4d$var$stringify.default = $c924af90aa582a4d$var$stringify;
$c924af90aa582a4d$var$stringify.stable = $c924af90aa582a4d$var$deterministicStringify;
$c924af90aa582a4d$var$stringify.stableStringify = $c924af90aa582a4d$var$deterministicStringify;
var $c924af90aa582a4d$var$LIMIT_REPLACE_NODE = "[...]";
var $c924af90aa582a4d$var$CIRCULAR_REPLACE_NODE = "[Circular]";
var $c924af90aa582a4d$var$arr = [];
var $c924af90aa582a4d$var$replacerStack = [];
function $c924af90aa582a4d$var$defaultOptions() {
    return {
        depthLimit: Number.MAX_SAFE_INTEGER,
        edgesLimit: Number.MAX_SAFE_INTEGER
    };
}
// Regular stringify
function $c924af90aa582a4d$var$stringify(obj, replacer, spacer, options) {
    if (typeof options === "undefined") options = $c924af90aa582a4d$var$defaultOptions();
    $c924af90aa582a4d$var$decirc(obj, "", 0, [], undefined, 0, options);
    var res;
    try {
        if ($c924af90aa582a4d$var$replacerStack.length === 0) res = JSON.stringify(obj, replacer, spacer);
        else res = JSON.stringify(obj, $c924af90aa582a4d$var$replaceGetterValues(replacer), spacer);
    } catch (_) {
        return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
    } finally{
        while($c924af90aa582a4d$var$arr.length !== 0){
            var part = $c924af90aa582a4d$var$arr.pop();
            if (part.length === 4) Object.defineProperty(part[0], part[1], part[3]);
            else part[0][part[1]] = part[2];
        }
    }
    return res;
}
function $c924af90aa582a4d$var$setReplace(replace, val, k, parent) {
    var propertyDescriptor = Object.getOwnPropertyDescriptor(parent, k);
    if (propertyDescriptor.get !== undefined) {
        if (propertyDescriptor.configurable) {
            Object.defineProperty(parent, k, {
                value: replace
            });
            $c924af90aa582a4d$var$arr.push([
                parent,
                k,
                val,
                propertyDescriptor
            ]);
        } else $c924af90aa582a4d$var$replacerStack.push([
            val,
            k,
            replace
        ]);
    } else {
        parent[k] = replace;
        $c924af90aa582a4d$var$arr.push([
            parent,
            k,
            val
        ]);
    }
}
function $c924af90aa582a4d$var$decirc(val, k, edgeIndex, stack, parent, depth, options) {
    depth += 1;
    var i;
    if (typeof val === "object" && val !== null) {
        for(i = 0; i < stack.length; i++)if (stack[i] === val) {
            $c924af90aa582a4d$var$setReplace($c924af90aa582a4d$var$CIRCULAR_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.depthLimit !== "undefined" && depth > options.depthLimit) {
            $c924af90aa582a4d$var$setReplace($c924af90aa582a4d$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.edgesLimit !== "undefined" && edgeIndex + 1 > options.edgesLimit) {
            $c924af90aa582a4d$var$setReplace($c924af90aa582a4d$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        stack.push(val);
        // Optimize for Arrays. Big arrays could kill the performance otherwise!
        if (Array.isArray(val)) for(i = 0; i < val.length; i++)$c924af90aa582a4d$var$decirc(val[i], i, i, stack, val, depth, options);
        else {
            var keys = Object.keys(val);
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                $c924af90aa582a4d$var$decirc(val[key], key, i, stack, val, depth, options);
            }
        }
        stack.pop();
    }
}
// Stable-stringify
function $c924af90aa582a4d$var$compareFunction(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}
function $c924af90aa582a4d$var$deterministicStringify(obj, replacer, spacer, options) {
    if (typeof options === "undefined") options = $c924af90aa582a4d$var$defaultOptions();
    var tmp = $c924af90aa582a4d$var$deterministicDecirc(obj, "", 0, [], undefined, 0, options) || obj;
    var res;
    try {
        if ($c924af90aa582a4d$var$replacerStack.length === 0) res = JSON.stringify(tmp, replacer, spacer);
        else res = JSON.stringify(tmp, $c924af90aa582a4d$var$replaceGetterValues(replacer), spacer);
    } catch (_) {
        return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
    } finally{
        // Ensure that we restore the object as it was.
        while($c924af90aa582a4d$var$arr.length !== 0){
            var part = $c924af90aa582a4d$var$arr.pop();
            if (part.length === 4) Object.defineProperty(part[0], part[1], part[3]);
            else part[0][part[1]] = part[2];
        }
    }
    return res;
}
function $c924af90aa582a4d$var$deterministicDecirc(val, k, edgeIndex, stack, parent, depth, options) {
    depth += 1;
    var i;
    if (typeof val === "object" && val !== null) {
        for(i = 0; i < stack.length; i++)if (stack[i] === val) {
            $c924af90aa582a4d$var$setReplace($c924af90aa582a4d$var$CIRCULAR_REPLACE_NODE, val, k, parent);
            return;
        }
        try {
            if (typeof val.toJSON === "function") return;
        } catch (_) {
            return;
        }
        if (typeof options.depthLimit !== "undefined" && depth > options.depthLimit) {
            $c924af90aa582a4d$var$setReplace($c924af90aa582a4d$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.edgesLimit !== "undefined" && edgeIndex + 1 > options.edgesLimit) {
            $c924af90aa582a4d$var$setReplace($c924af90aa582a4d$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        stack.push(val);
        // Optimize for Arrays. Big arrays could kill the performance otherwise!
        if (Array.isArray(val)) for(i = 0; i < val.length; i++)$c924af90aa582a4d$var$deterministicDecirc(val[i], i, i, stack, val, depth, options);
        else {
            // Create a temporary object in the required way
            var tmp = {};
            var keys = Object.keys(val).sort($c924af90aa582a4d$var$compareFunction);
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                $c924af90aa582a4d$var$deterministicDecirc(val[key], key, i, stack, val, depth, options);
                tmp[key] = val[key];
            }
            if (typeof parent !== "undefined") {
                $c924af90aa582a4d$var$arr.push([
                    parent,
                    k,
                    val
                ]);
                parent[k] = tmp;
            } else return tmp;
        }
        stack.pop();
    }
}
// wraps replacer function to handle values we couldn't replace
// and mark them as replaced value
function $c924af90aa582a4d$var$replaceGetterValues(replacer) {
    replacer = typeof replacer !== "undefined" ? replacer : function(k, v) {
        return v;
    };
    return function(key, val) {
        if ($c924af90aa582a4d$var$replacerStack.length > 0) for(var i = 0; i < $c924af90aa582a4d$var$replacerStack.length; i++){
            var part = $c924af90aa582a4d$var$replacerStack[i];
            if (part[1] === key && part[0] === val) {
                val = part[2];
                $c924af90aa582a4d$var$replacerStack.splice(i, 1);
                break;
            }
        }
        return replacer.call(this, key, val);
    };
}


"use strict";
const $d4123a658452050c$export$7c73462e0d25e514 = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    function get(...args) {
        const key = args.map((v)=>(0, (/*@__PURE__*/$parcel$interopDefault($c924af90aa582a4d$exports)))(v)).join("|");
        if (cache[key] === void 0) cache[key] = fn(...args);
        return cache[key];
    }
    return get;
};



"use strict";
function $132364fc06bc5aac$var$merge(target, source) {
    if (source == null) return target;
    for (const key of Object.keys(source)){
        if (source[key] === void 0 || key === "__proto__") continue;
        if (!(0, $b3f328a5401a2298$export$a6cdc56e425d0d0a)(target[key]) && (0, $b3f328a5401a2298$export$a6cdc56e425d0d0a)(source[key])) Object.assign(target, {
            [key]: source[key]
        });
        else if (target[key] && (0, $b3f328a5401a2298$export$a6cdc56e425d0d0a)(source[key])) $132364fc06bc5aac$var$merge(target[key], source[key]);
        else if (Array.isArray(source[key]) && Array.isArray(target[key])) {
            let i = 0;
            for(; i < source[key].length; i++)if ((0, $b3f328a5401a2298$export$a6cdc56e425d0d0a)(target[key][i]) && (0, $b3f328a5401a2298$export$a6cdc56e425d0d0a)(source[key][i])) $132364fc06bc5aac$var$merge(target[key][i], source[key][i]);
            else target[key][i] = source[key][i];
        } else Object.assign(target, {
            [key]: source[key]
        });
    }
    return target;
}
function $132364fc06bc5aac$export$2ee76fde9ffe109d(target, ...sources) {
    for (const source of sources)$132364fc06bc5aac$var$merge(target, source);
    return target;
}



"use strict";
const $dc95ad86baa706b3$var$BASE_FONT_SIZE = 16;
const $dc95ad86baa706b3$var$UNIT_PX = "px";
const $dc95ad86baa706b3$var$UNIT_EM = "em";
const $dc95ad86baa706b3$var$UNIT_REM = "rem";
function $dc95ad86baa706b3$export$65f2564e9a9b9222(value = "") {
    const DIGIT_REGEX = new RegExp(String.raw`-?\d+(?:\.\d+|\d*)`);
    const UNIT_REGEX = new RegExp(`${$dc95ad86baa706b3$var$UNIT_PX}|${$dc95ad86baa706b3$var$UNIT_EM}|${$dc95ad86baa706b3$var$UNIT_REM}`);
    const unit = value.match(new RegExp(`${DIGIT_REGEX.source}(${UNIT_REGEX.source})`));
    return unit?.[1];
}
function $dc95ad86baa706b3$export$6562491d7413c9c9(value = "") {
    if (typeof value === "number") return `${value}px`;
    const unit = $dc95ad86baa706b3$export$65f2564e9a9b9222(value);
    if (!unit) return value;
    if (unit === $dc95ad86baa706b3$var$UNIT_PX) return value;
    if (unit === $dc95ad86baa706b3$var$UNIT_EM || unit === $dc95ad86baa706b3$var$UNIT_REM) return `${parseFloat(value) * $dc95ad86baa706b3$var$BASE_FONT_SIZE}${$dc95ad86baa706b3$var$UNIT_PX}`;
}
function $dc95ad86baa706b3$export$6a029509daffbde8(value = "", fontSize = $dc95ad86baa706b3$var$BASE_FONT_SIZE) {
    const unit = $dc95ad86baa706b3$export$65f2564e9a9b9222(value);
    if (!unit) return value;
    if (unit === $dc95ad86baa706b3$var$UNIT_EM) return value;
    if (unit === $dc95ad86baa706b3$var$UNIT_PX) return `${parseFloat(value) / fontSize}${$dc95ad86baa706b3$var$UNIT_EM}`;
    if (unit === $dc95ad86baa706b3$var$UNIT_REM) return `${parseFloat(value) * $dc95ad86baa706b3$var$BASE_FONT_SIZE / fontSize}${$dc95ad86baa706b3$var$UNIT_EM}`;
}
function $dc95ad86baa706b3$export$9aee8eecd1073da1(value = "") {
    const unit = $dc95ad86baa706b3$export$65f2564e9a9b9222(value);
    if (!unit) return value;
    if (unit === $dc95ad86baa706b3$var$UNIT_REM) return value;
    if (unit === $dc95ad86baa706b3$var$UNIT_EM) return `${parseFloat(value)}${$dc95ad86baa706b3$var$UNIT_REM}`;
    if (unit === $dc95ad86baa706b3$var$UNIT_PX) return `${parseFloat(value) / $dc95ad86baa706b3$var$BASE_FONT_SIZE}${$dc95ad86baa706b3$var$UNIT_REM}`;
}


"use strict";
const $8b497d63b5509176$var$capitalize = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
function $8b497d63b5509176$export$79e1df82cbbff4e9(breakpoints) {
    const sorted = $8b497d63b5509176$var$sort(breakpoints);
    const values = Object.fromEntries(sorted);
    function get(name) {
        return values[name];
    }
    function only(name) {
        return $8b497d63b5509176$var$build(get(name));
    }
    function getRanges() {
        const breakpoints2 = Object.keys(values);
        const permuations = $8b497d63b5509176$var$getPermutations(breakpoints2);
        const results = breakpoints2.flatMap((name)=>{
            const value = get(name);
            const down2 = [
                `${name}Down`,
                $8b497d63b5509176$var$build({
                    max: $8b497d63b5509176$var$adjust(value.min)
                })
            ];
            const up2 = [
                name,
                $8b497d63b5509176$var$build({
                    min: value.min
                })
            ];
            const _only = [
                `${name}Only`,
                only(name)
            ];
            return [
                up2,
                _only,
                down2
            ];
        }).filter(([, value])=>value !== "").concat(permuations.map(([min, max])=>{
            const minValue = get(min);
            const maxValue = get(max);
            return [
                `${min}To${$8b497d63b5509176$var$capitalize(max)}`,
                $8b497d63b5509176$var$build({
                    min: minValue.min,
                    max: $8b497d63b5509176$var$adjust(maxValue.min)
                })
            ];
        }));
        return Object.fromEntries(results);
    }
    function toConditions() {
        const ranges = getRanges();
        return Object.fromEntries(Object.entries(ranges));
    }
    const conditions = toConditions();
    const getCondition = (key)=>{
        return conditions[key];
    };
    function keys() {
        return [
            "base",
            ...Object.keys(values)
        ];
    }
    function up(name) {
        return $8b497d63b5509176$var$build({
            min: get(name).min
        });
    }
    function down(name) {
        return $8b497d63b5509176$var$build({
            max: $8b497d63b5509176$var$adjust(get(name).min)
        });
    }
    return {
        values: Object.values(values),
        only: only,
        keys: keys,
        conditions: conditions,
        getCondition: getCondition,
        up: up,
        down: down
    };
}
function $8b497d63b5509176$var$adjust(value) {
    const computedMax = parseFloat((0, $dc95ad86baa706b3$export$6562491d7413c9c9)(value) ?? "") - 0.04;
    return (0, $dc95ad86baa706b3$export$9aee8eecd1073da1)(`${computedMax}px`);
}
function $8b497d63b5509176$var$sort(breakpoints) {
    const entries = Object.entries(breakpoints).sort(([, minA], [, minB])=>{
        return parseInt(minA, 10) < parseInt(minB, 10) ? -1 : 1;
    });
    return entries.map(([name, min], index, entries2)=>{
        let max = null;
        if (index <= entries2.length - 1) max = entries2[index + 1]?.[1];
        if (max != null) max = $8b497d63b5509176$var$adjust(max);
        return [
            name,
            {
                name: name,
                min: (0, $dc95ad86baa706b3$export$9aee8eecd1073da1)(min),
                max: max
            }
        ];
    });
}
function $8b497d63b5509176$var$getPermutations(values) {
    const result = [];
    values.forEach((current, index)=>{
        let idx = index;
        idx++;
        let next = values[idx];
        while(next){
            result.push([
                current,
                next
            ]);
            idx++;
            next = values[idx];
        }
    });
    return result;
}
function $8b497d63b5509176$var$build({ min: min, max: max }) {
    if (min == null && max == null) return "";
    return [
        "@media screen",
        min && `(min-width: ${min})`,
        max && `(max-width: ${max})`
    ].filter(Boolean).join(" and ");
}


"use strict";
const $3fffe12fb4188fab$var$mapEntries = (obj, fn)=>{
    return Object.fromEntries(Object.entries(obj).map(([key, value])=>fn(key, value)));
};
const $3fffe12fb4188fab$export$4841b94afe59a0cf = (options)=>{
    const { breakpoints: breakpoints, conditions: conds = {} } = options;
    const conditions = $3fffe12fb4188fab$var$mapEntries(conds, (key, value)=>[
            `_${key}`,
            value
        ]);
    const values = Object.assign({}, conditions, breakpoints.conditions);
    function keys() {
        return Object.keys(values);
    }
    function has(key) {
        return keys().includes(key) || /^@|&|&$/.test(key) || key.startsWith("_");
    }
    function sort(paths) {
        return paths.filter((v)=>v !== "base").sort((a, b)=>{
            const aa = has(a);
            const bb = has(b);
            if (aa && !bb) return 1;
            if (!aa && bb) return -1;
            return 0;
        });
    }
    function expandAtRule(key) {
        if (!key.startsWith("@breakpoint")) return key;
        return breakpoints.getCondition(key.replace("@breakpoint ", ""));
    }
    function resolve(key) {
        return Reflect.get(values, key) || key;
    }
    return {
        keys: keys,
        sort: sort,
        has: has,
        resolve: resolve,
        breakpoints: breakpoints.keys(),
        expandAtRule: expandAtRule
    };
};


"use strict";
function $dd67db2b933220bc$export$9cd59f9826255e47(obj) {
    if (obj === null || typeof obj !== "object") return obj;
    if (Array.isArray(obj)) return obj.map((prop)=>$dd67db2b933220bc$export$9cd59f9826255e47(prop));
    const _clone = Object.create(Object.getPrototypeOf(obj));
    for (const key of Object.keys(obj))_clone[key] = $dd67db2b933220bc$export$9cd59f9826255e47(obj[key]);
    return _clone;
}



"use strict";
const $ee2de6f250f65b79$export$d0de36da8d019bea = (v)=>v;
const $ee2de6f250f65b79$export$9ab6f981e4119117 = (v)=>v;
const $ee2de6f250f65b79$export$c28efc68fea5b4d6 = (v)=>v;
const $ee2de6f250f65b79$export$900dac1a2cda17d7 = (v)=>v;
const $ee2de6f250f65b79$export$22794656cac17ba4 = (v)=>v;
const $ee2de6f250f65b79$export$9a6b93c1c4f92839 = (v)=>v;
const $ee2de6f250f65b79$export$4e5d103345f1ef38 = (v)=>v;
const $ee2de6f250f65b79$export$cd834db0363565be = (v)=>v;
const $ee2de6f250f65b79$export$479138f860542d07 = (v)=>v;
function $ee2de6f250f65b79$var$createProxy() {
    const identity = (v)=>v;
    return new Proxy(identity, {
        get () {
            return identity;
        }
    });
}
const $ee2de6f250f65b79$export$8e135e7aaa7aabf6 = /* @__PURE__ */ $ee2de6f250f65b79$var$createProxy();
const $ee2de6f250f65b79$export$97e094f42fbe07cb = /* @__PURE__ */ $ee2de6f250f65b79$var$createProxy();
const $ee2de6f250f65b79$export$9e20b617fd74b180 = (v)=>v;
const $ee2de6f250f65b79$export$5d86b86a654a7039 = (...configs)=>{
    return (0, $132364fc06bc5aac$export$2ee76fde9ffe109d)({}, ...configs.map((0, $dd67db2b933220bc$export$9cd59f9826255e47)));
};









"use strict";
const $074735f81906b0d5$var$createMediaQueryRegex = (dimension)=>({
        minMax: new RegExp(`(!?\\(\\s*min(-device-)?-${dimension})(.|
)+\\(\\s*max(-device)?-${dimension}`, "i"),
        min: new RegExp(`\\(\\s*min(-device)?-${dimension}`, "i"),
        maxMin: new RegExp(`(!?\\(\\s*max(-device)?-${dimension})(.|
)+\\(\\s*min(-device)?-${dimension}`, "i"),
        max: new RegExp(`\\(\\s*max(-device)?-${dimension}`, "i")
    });
const $074735f81906b0d5$var$widthRegex = $074735f81906b0d5$var$createMediaQueryRegex("width");
const $074735f81906b0d5$var$heightRegex = $074735f81906b0d5$var$createMediaQueryRegex("height");
const $074735f81906b0d5$var$createQueryTester = (regexSet)=>({
        isMin: $074735f81906b0d5$var$_testQuery(regexSet.minMax, regexSet.maxMin, regexSet.min),
        isMax: $074735f81906b0d5$var$_testQuery(regexSet.maxMin, regexSet.minMax, regexSet.max)
    });
const { isMin: $074735f81906b0d5$var$isMinWidth, isMax: $074735f81906b0d5$var$isMaxWidth } = $074735f81906b0d5$var$createQueryTester($074735f81906b0d5$var$widthRegex);
const { isMin: $074735f81906b0d5$var$isMinHeight, isMax: $074735f81906b0d5$var$isMaxHeight } = $074735f81906b0d5$var$createQueryTester($074735f81906b0d5$var$heightRegex);
const $074735f81906b0d5$var$isPrint = /print/i;
const $074735f81906b0d5$var$isPrintOnly = /^print$/i;
const $074735f81906b0d5$var$isLength = /(-?\d*\.?\d+)(ch|em|ex|px|rem)/;
const $074735f81906b0d5$var$lengthExec = /(\d)/;
const $074735f81906b0d5$var$maxValue = Number.MAX_VALUE;
const $074735f81906b0d5$var$multipliers = {
    ch: 8.8984375,
    em: 16,
    rem: 16,
    ex: 8.296875,
    px: 1
};
function $074735f81906b0d5$var$getQueryLength(query) {
    const length = $074735f81906b0d5$var$isLength.exec(query) || ($074735f81906b0d5$var$isMinWidth(query) || $074735f81906b0d5$var$isMinHeight(query) ? $074735f81906b0d5$var$lengthExec.exec(query) : null);
    if (!length) return $074735f81906b0d5$var$maxValue;
    if (length[0] === "0") return 0;
    const number = parseFloat(length[1]);
    const unit = length[2];
    return number * ($074735f81906b0d5$var$multipliers[unit] || 1);
}
function $074735f81906b0d5$var$_testQuery(doubleTestTrue, doubleTestFalse, singleTest) {
    return (query)=>doubleTestTrue.test(query) || !doubleTestFalse.test(query) && singleTest.test(query);
}
function $074735f81906b0d5$var$_testIsPrint(a, b) {
    const isPrintA = $074735f81906b0d5$var$isPrint.test(a), isPrintOnlyA = $074735f81906b0d5$var$isPrintOnly.test(a);
    const isPrintB = $074735f81906b0d5$var$isPrint.test(b), isPrintOnlyB = $074735f81906b0d5$var$isPrintOnly.test(b);
    if (isPrintA && isPrintB) {
        if (!isPrintOnlyA && isPrintOnlyB) return 1;
        if (isPrintOnlyA && !isPrintOnlyB) return -1;
        return a.localeCompare(b);
    }
    return isPrintA ? 1 : isPrintB ? -1 : null;
}
const $074735f81906b0d5$export$6096a7de4975ce6d = (0, $d4123a658452050c$export$7c73462e0d25e514)((a, b)=>{
    const testIsPrint = $074735f81906b0d5$var$_testIsPrint(a, b);
    if (testIsPrint !== null) return testIsPrint;
    const minA = $074735f81906b0d5$var$isMinWidth(a) || $074735f81906b0d5$var$isMinHeight(a), maxA = $074735f81906b0d5$var$isMaxWidth(a) || $074735f81906b0d5$var$isMaxHeight(a);
    const minB = $074735f81906b0d5$var$isMinWidth(b) || $074735f81906b0d5$var$isMinHeight(b), maxB = $074735f81906b0d5$var$isMaxWidth(b) || $074735f81906b0d5$var$isMaxHeight(b);
    if (minA && maxB) return -1;
    if (maxA && minB) return 1;
    const lengthA = $074735f81906b0d5$var$getQueryLength(a), lengthB = $074735f81906b0d5$var$getQueryLength(b);
    if (lengthA === $074735f81906b0d5$var$maxValue && lengthB === $074735f81906b0d5$var$maxValue) return a.localeCompare(b);
    if (lengthA === $074735f81906b0d5$var$maxValue) return 1;
    if (lengthB === $074735f81906b0d5$var$maxValue) return -1;
    if (lengthA !== lengthB) return lengthA > lengthB ? maxA ? -1 : 1 : maxA ? 1 : -1;
    return a.localeCompare(b);
});


"use strict";
function $a546b69a1a0916f9$var$sortQueries(queries) {
    return queries.sort(([a], [b])=>(0, $074735f81906b0d5$export$6096a7de4975ce6d)(a, b));
}
function $a546b69a1a0916f9$export$48f0d927df046b15(obj) {
    const mediaQueries = [];
    const containerQueries = [];
    const rest = {};
    for (const [key, value] of Object.entries(obj)){
        if (key.startsWith("@media")) mediaQueries.push([
            key,
            value
        ]);
        else if (key.startsWith("@container")) containerQueries.push([
            key,
            value
        ]);
        else if ((0, $b3f328a5401a2298$export$a6cdc56e425d0d0a)(value)) rest[key] = $a546b69a1a0916f9$export$48f0d927df046b15(value);
        else rest[key] = value;
    }
    const sortedMediaQueries = $a546b69a1a0916f9$var$sortQueries(mediaQueries);
    const sortedContainerQueries = $a546b69a1a0916f9$var$sortQueries(containerQueries);
    return {
        ...rest,
        ...Object.fromEntries(sortedMediaQueries),
        ...Object.fromEntries(sortedContainerQueries)
    };
}


"use strict";
const $7bc594fcbeb14d16$var$importantRegex = /\s*!(important)?/i;
const $7bc594fcbeb14d16$var$isImportant = (v)=>(0, $b3f328a5401a2298$export$844ec244b1367d54)(v) ? $7bc594fcbeb14d16$var$importantRegex.test(v) : false;
const $7bc594fcbeb14d16$var$withoutImportant = (v)=>(0, $b3f328a5401a2298$export$844ec244b1367d54)(v) ? v.replace($7bc594fcbeb14d16$var$importantRegex, "").trim() : v;
function $7bc594fcbeb14d16$export$7f714a6e05babb56(context) {
    const { transform: transform, conditions: conditions, normalize: normalize } = context;
    const mergeFn = $7bc594fcbeb14d16$var$mergeCss(context);
    return (0, $d4123a658452050c$export$7c73462e0d25e514)(function cssFn(...styleArgs) {
        const styles = mergeFn(...styleArgs);
        const normalized = normalize(styles);
        const result = /* @__PURE__ */ Object.create(null);
        (0, $d37e33c22423b9ba$export$915658b6215945a4)(normalized, (value, paths)=>{
            const important = $7bc594fcbeb14d16$var$isImportant(value);
            if (value == null) return;
            const [prop, ...selectors] = conditions.sort(paths).map(conditions.resolve);
            if (important) value = $7bc594fcbeb14d16$var$withoutImportant(value);
            let transformed = transform(prop, value) ?? /* @__PURE__ */ Object.create(null);
            transformed = (0, $d37e33c22423b9ba$export$915658b6215945a4)(transformed, (v)=>(0, $b3f328a5401a2298$export$844ec244b1367d54)(v) && important ? `${v} !important` : v, {
                getKey: (prop2)=>conditions.expandAtRule(prop2)
            });
            $7bc594fcbeb14d16$var$mergeByPath(result, selectors.flat(), transformed);
        });
        return (0, $a546b69a1a0916f9$export$48f0d927df046b15)(result);
    });
}
function $7bc594fcbeb14d16$var$mergeByPath(target, paths, value) {
    let acc = target;
    for (const path of paths){
        if (!path) continue;
        if (!acc[path]) acc[path] = /* @__PURE__ */ Object.create(null);
        acc = acc[path];
    }
    (0, $132364fc06bc5aac$export$2ee76fde9ffe109d)(acc, value);
}
function $7bc594fcbeb14d16$var$compactFn(...styles) {
    return styles.filter((style)=>(0, $b3f328a5401a2298$export$a6cdc56e425d0d0a)(style) && Object.keys((0, $d2e329dcce85bd14$export$8e16b83750b44988)(style)).length > 0);
}
function $7bc594fcbeb14d16$var$mergeCss(ctx) {
    function resolve(styles) {
        const comp = $7bc594fcbeb14d16$var$compactFn(...styles);
        if (comp.length === 1) return comp;
        return comp.map((style)=>ctx.normalize(style));
    }
    return (0, $d4123a658452050c$export$7c73462e0d25e514)(function mergeFn(...styles) {
        return (0, $132364fc06bc5aac$export$2ee76fde9ffe109d)({}, ...resolve(styles));
    });
}





"use strict";
function $8d06bc2a680f4388$export$30a06c8d3562193f(object, keysToOmit = []) {
    const clone = Object.assign({}, object);
    for (const key of keysToOmit)if (key in clone) delete clone[key];
    return clone;
}



"use strict";
const $9569b64a81009ac5$export$f70730c3d1fc524e = (...items)=>{
    const _items = items.filter(Boolean);
    return Array.from(new Set(_items));
};



"use strict";
const $4b08c8ac77ec20b1$var$defaults = (conf)=>({
        base: {},
        variants: {},
        defaultVariants: {},
        compoundVariants: [],
        ...conf
    });
function $4b08c8ac77ec20b1$export$439f157863edac93(options) {
    const { css: css, conditions: conditions, normalize: normalize, layers: layers } = options;
    function cva(config = {}) {
        const { base: base, variants: variants, defaultVariants: defaultVariants, compoundVariants: compoundVariants } = $4b08c8ac77ec20b1$var$defaults(config);
        const getVariantCss = (0, $7bc594fcbeb14d16$export$7f714a6e05babb56)({
            conditions: conditions,
            normalize: normalize,
            transform (prop, value) {
                return variants[prop]?.[value];
            }
        });
        const resolve = (props = {})=>{
            const variantSelections = normalize({
                ...defaultVariants,
                ...(0, $d2e329dcce85bd14$export$8e16b83750b44988)(props)
            });
            let variantCss = {
                ...base
            };
            (0, $132364fc06bc5aac$export$2ee76fde9ffe109d)(variantCss, getVariantCss(variantSelections));
            const compoundVariantCss = getCompoundVariantCss(compoundVariants, variantSelections);
            return layers.wrap("recipes", css(variantCss, compoundVariantCss));
        };
        const variantKeys = Object.keys(variants);
        const splitVariantProps = (props)=>{
            const restProps = (0, $8d06bc2a680f4388$export$30a06c8d3562193f)(props, [
                "recipe"
            ]);
            const [recipeProps, localProps] = (0, $8be83bf2b7a4ecef$export$45029c61b0073d87)(restProps, variantKeys);
            if (!variantKeys.includes("colorPalette")) recipeProps.colorPalette = props.colorPalette || defaultVariants.colorPalette;
            if (variantKeys.includes("orientation")) localProps.orientation = props.orientation;
            return [
                recipeProps,
                localProps
            ];
        };
        const variantMap = Object.fromEntries(Object.entries(variants).map(([key, value])=>[
                key,
                Object.keys(value)
            ]));
        const cvaFn = (props)=>css(resolve(props));
        return Object.assign(cvaFn, {
            className: config.className,
            __cva__: true,
            variantMap: variantMap,
            variantKeys: variantKeys,
            raw: resolve,
            config: config,
            splitVariantProps: splitVariantProps,
            merge (other) {
                return cva($4b08c8ac77ec20b1$var$mergeCva(options)(this, other));
            }
        });
    }
    function getCompoundVariantCss(cvs, vm) {
        let result = {};
        cvs.forEach((cv)=>{
            const isMatching = Object.entries(cv).every(([key, value])=>{
                if (key === "css") return true;
                const values = Array.isArray(value) ? value : [
                    value
                ];
                return values.some((value2)=>vm[key] === value2);
            });
            if (isMatching) result = css(result, cv.css);
        });
        return result;
    }
    return cva;
}
function $4b08c8ac77ec20b1$var$mergeCva(opts) {
    const { css: css } = opts;
    return function mergeCva2(cvaA, cvaB) {
        const override = $4b08c8ac77ec20b1$var$defaults(cvaB.config);
        const variantKeys = (0, $9569b64a81009ac5$export$f70730c3d1fc524e)(cvaA.variantKeys, Object.keys(cvaB.variants));
        const base = css(cvaA.base, override.base);
        const variants = Object.fromEntries(variantKeys.map((key)=>[
                key,
                css(cvaA.config.variants[key], override.variants[key])
            ]));
        const defaultVariants = (0, $132364fc06bc5aac$export$2ee76fde9ffe109d)(cvaA.config.defaultVariants, override.defaultVariants);
        const compoundVariants = [
            ...cvaA.compoundVariants,
            ...override.compoundVariants
        ];
        const className = (0, $7b2d6a34cc679515$export$a274e22fb40f762e)(cvaA.className, cvaB.className);
        return {
            className: className,
            base: base,
            variants: variants,
            defaultVariants: defaultVariants,
            compoundVariants: compoundVariants
        };
    };
}


"use strict";
const $b9a7cd9f5520e35f$var$defaultLayers = {
    reset: "reset",
    base: "base",
    tokens: "tokens",
    recipes: "recipes"
};
const $b9a7cd9f5520e35f$var$layerOrder = {
    reset: 0,
    base: 1,
    tokens: 2,
    recipes: 3
};
function $b9a7cd9f5520e35f$export$ddf51b1b91379574(config) {
    const layers = config.layers ?? $b9a7cd9f5520e35f$var$defaultLayers;
    const values = Object.values(layers);
    const names = values.sort((a, b)=>$b9a7cd9f5520e35f$var$layerOrder[a] - $b9a7cd9f5520e35f$var$layerOrder[b]);
    return {
        names: names,
        atRule: `@layer ${names.join(", ")};`,
        wrap (layer, styles) {
            if (config.disableLayers) return styles;
            const params = layers[layer];
            return {
                [`@layer ${params}`]: styles
            };
        }
    };
}



"use strict";
function $44dce68f810fd8e4$export$358f081847bfe3e3(context) {
    const { utility: utility, normalize: normalize } = context;
    const { hasShorthand: hasShorthand, resolveShorthand: resolveShorthand } = utility;
    return function(styles) {
        return (0, $d37e33c22423b9ba$export$915658b6215945a4)(styles, normalize, {
            stop: (value)=>Array.isArray(value),
            getKey: hasShorthand ? resolveShorthand : void 0
        });
    };
}



"use strict";
function $8f95a203f04b4df2$export$33276ec412a73052(options) {
    const { preflight: preflight } = options;
    if (!preflight) return {};
    const { scope: scope = "", level: level = "parent" } = (0, $b3f328a5401a2298$export$a6cdc56e425d0d0a)(preflight) ? preflight : {};
    let selector = "";
    if (scope && level === "parent") selector = `${scope} `;
    else if (scope && level === "element") selector = `&${scope}`;
    const scoped = {
        "*": {
            margin: "0px",
            padding: "0px",
            font: "inherit",
            wordWrap: "break-word",
            WebkitTapHighlightColor: "transparent"
        },
        "*, *::before, *::after, *::backdrop": {
            boxSizing: "border-box",
            borderWidth: "0px",
            borderStyle: "solid",
            borderColor: "var(--global-color-border, currentColor)"
        },
        hr: {
            height: "0px",
            color: "inherit",
            borderTopWidth: "1px"
        },
        body: {
            minHeight: "100dvh",
            position: "relative"
        },
        img: {
            borderStyle: "none"
        },
        "img, svg, video, canvas, audio, iframe, embed, object": {
            display: "block",
            verticalAlign: "middle"
        },
        iframe: {
            border: "none"
        },
        "img, video": {
            maxWidth: "100%",
            height: "auto"
        },
        "p, h1, h2, h3, h4, h5, h6": {
            overflowWrap: "break-word"
        },
        "ol, ul": {
            listStyle: "none"
        },
        "code, kbd, pre, samp": {
            fontSize: "1em"
        },
        "button, [type='button'], [type='reset'], [type='submit']": {
            WebkitAppearance: "button",
            backgroundColor: "transparent",
            backgroundImage: "none"
        },
        "button, input, optgroup, select, textarea": {
            color: "inherit"
        },
        "button, select": {
            textTransform: "none"
        },
        table: {
            textIndent: "0px",
            borderColor: "inherit",
            borderCollapse: "collapse"
        },
        "*::placeholder": {
            opacity: "unset",
            color: "#9ca3af",
            userSelect: "none"
        },
        textarea: {
            resize: "vertical"
        },
        summary: {
            display: "list-item"
        },
        small: {
            fontSize: "80%"
        },
        "sub, sup": {
            fontSize: "75%",
            lineHeight: 0,
            position: "relative",
            verticalAlign: "baseline"
        },
        sub: {
            bottom: "-0.25em"
        },
        sup: {
            top: "-0.5em"
        },
        dialog: {
            padding: "0px"
        },
        a: {
            color: "inherit",
            textDecoration: "inherit"
        },
        "abbr:where([title])": {
            textDecoration: "underline dotted"
        },
        "b, strong": {
            fontWeight: "bolder"
        },
        "code, kbd, samp, pre": {
            fontSize: "1em",
            "--font-mono-fallback": "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New'",
            fontFamily: "var(--global-font-mono, var(--font-mono-fallback))"
        },
        'input[type="text"], input[type="email"], input[type="search"], input[type="password"]': {
            WebkitAppearance: "none",
            MozAppearance: "none"
        },
        "input[type='search']": {
            WebkitAppearance: "textfield",
            outlineOffset: "-2px"
        },
        "::-webkit-search-decoration, ::-webkit-search-cancel-button": {
            WebkitAppearance: "none"
        },
        "::-webkit-file-upload-button": {
            WebkitAppearance: "button",
            font: "inherit"
        },
        'input[type="number"]::-webkit-inner-spin-button, input[type="number"]::-webkit-outer-spin-button': {
            height: "auto"
        },
        "input[type='number']": {
            MozAppearance: "textfield"
        },
        ":-moz-ui-invalid": {
            boxShadow: "none"
        },
        ":-moz-focusring": {
            outline: "auto"
        },
        "[hidden]:where(:not([hidden='until-found']))": {
            display: "none !important"
        }
    };
    const preflightCss = {
        [scope || "html"]: {
            lineHeight: 1.5,
            "--font-fallback": "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
            WebkitTextSizeAdjust: "100%",
            WebkitFontSmoothing: "antialiased",
            MozOsxFontSmoothing: "grayscale",
            textRendering: "optimizeLegibility",
            touchAction: "manipulation",
            MozTabSize: "4",
            tabSize: "4",
            fontFamily: "var(--global-font-body, var(--font-fallback))"
        }
    };
    if (level === "element") {
        const modified = Object.entries(scoped).reduce((acc, [k, v])=>{
            acc[k] = {
                [selector]: v
            };
            return acc;
        }, {});
        Object.assign(preflightCss, modified);
    } else if (selector) preflightCss[selector] = scoped;
    else Object.assign(preflightCss, scoped);
    return preflightCss;
}




"use strict";
function $d899c5ee07c3fb7c$export$173558e7ef6da591(options) {
    const { conditions: conditions, isValidProperty: isValidProperty } = options;
    return function serialize(styles) {
        return (0, $d37e33c22423b9ba$export$915658b6215945a4)(styles, (value)=>value, {
            getKey: (prop, value)=>{
                if (!(0, $b3f328a5401a2298$export$a6cdc56e425d0d0a)(value)) return prop;
                if (!conditions.has(prop) && !isValidProperty(prop)) return $d899c5ee07c3fb7c$var$parseSelectors(prop).map((s)=>"&" + s).join(", ");
                return prop;
            }
        });
    };
}
function $d899c5ee07c3fb7c$var$parseSelectors(selector) {
    const result = [];
    let parenCount = 0;
    let currentSelector = "";
    let inEscape = false;
    for(let i = 0; i < selector.length; i++){
        const char = selector[i];
        if (char === "\\" && !inEscape) {
            inEscape = true;
            currentSelector += char;
            continue;
        }
        if (inEscape) {
            inEscape = false;
            currentSelector += char;
            continue;
        }
        if (char === "(") parenCount++;
        else if (char === ")") parenCount--;
        if (char === "," && parenCount === 0) {
            result.push(currentSelector.trim());
            currentSelector = "";
        } else currentSelector += char;
    }
    if (currentSelector) result.push(currentSelector.trim());
    return result;
}




"use strict";
const $fa805d9058e81f24$var$getSlotRecipes = (config = {})=>{
    const init = (slot)=>({
            base: config.base?.[slot] ?? {},
            variants: {},
            defaultVariants: config.defaultVariants ?? {},
            compoundVariants: config.compoundVariants ? $fa805d9058e81f24$export$ec9417c0c2e3abea(config.compoundVariants, slot) : []
        });
    const slots = config.slots ?? [];
    const entries = slots.map((slot)=>[
            slot,
            init(slot)
        ]);
    for (const [variantsKey, variantsSpec] of Object.entries(config.variants ?? {}))for (const [variantKey, variantSpec] of Object.entries(variantsSpec))entries.forEach(([slot, slotRecipe])=>{
        var _a;
        (_a = slotRecipe.variants)[variantsKey] ?? (_a[variantsKey] = {});
        slotRecipe.variants[variantsKey][variantKey] = variantSpec[slot] ?? {};
    });
    return Object.fromEntries(entries);
};
const $fa805d9058e81f24$export$ec9417c0c2e3abea = (compoundVariants, slotName)=>compoundVariants.filter((compoundVariant)=>compoundVariant.css[slotName]).map((compoundVariant)=>({
            ...compoundVariant,
            css: compoundVariant.css[slotName]
        }));
function $fa805d9058e81f24$export$6882452d1db83150(options) {
    const { cva: cva } = options;
    return function sva(config = {}) {
        const slots = Object.entries($fa805d9058e81f24$var$getSlotRecipes(config)).map(([slot, slotCva])=>[
                slot,
                cva(slotCva)
            ]);
        function svaFn(props) {
            const result = slots.map(([slot, cvaFn])=>[
                    slot,
                    cvaFn(props)
                ]);
            return Object.fromEntries(result);
        }
        const variants = config.variants ?? {};
        const variantKeys = Object.keys(variants);
        function splitVariantProps(props) {
            const restProps = (0, $8d06bc2a680f4388$export$30a06c8d3562193f)(props, [
                "recipe"
            ]);
            const [recipeProps, localProps] = (0, $8be83bf2b7a4ecef$export$45029c61b0073d87)(restProps, variantKeys);
            if (!variantKeys.includes("colorPalette")) recipeProps.colorPalette = props.colorPalette || config.defaultVariants?.colorPalette;
            if (variantKeys.includes("orientation")) localProps.orientation = props.orientation;
            return [
                recipeProps,
                localProps
            ];
        }
        const variantMap = Object.fromEntries(Object.entries(variants).map(([key, value])=>[
                key,
                Object.keys(value)
            ]));
        let classNameMap = {};
        if (config.className) classNameMap = Object.fromEntries(config.slots.map((slot)=>[
                slot,
                `${config.className}__${slot}`
            ]));
        return Object.assign(svaFn, {
            variantMap: variantMap,
            variantKeys: variantKeys,
            splitVariantProps: splitVariantProps,
            classNameMap: classNameMap
        });
    };
}



"use strict";
const $492c05c13da69026$export$c94ea207b45fef3a = ()=>(props)=>Array.from(new Set(props));





"use strict";
const $fce16da9dfa1c130$var$escRegex = /[^a-zA-Z0-9_\u0081-\uffff-]/g;
function $fce16da9dfa1c130$var$esc(string) {
    return `${string}`.replace($fce16da9dfa1c130$var$escRegex, (s)=>`\\${s}`);
}
const $fce16da9dfa1c130$var$dashCaseRegex = /[A-Z]/g;
function $fce16da9dfa1c130$var$dashCase(string) {
    return string.replace($fce16da9dfa1c130$var$dashCaseRegex, (match)=>`-${match.toLowerCase()}`);
}
function $fce16da9dfa1c130$export$8b4981022bd80a4e(name, options = {}) {
    const { fallback: fallback = "", prefix: prefix = "" } = options;
    const variable = $fce16da9dfa1c130$var$dashCase([
        "-",
        prefix,
        $fce16da9dfa1c130$var$esc(name)
    ].filter(Boolean).join("-"));
    return {
        var: variable,
        ref: `var(${variable}${fallback ? `, ${fallback}` : ""})`
    };
}


"use strict";
const $f10862bae7c0a8e1$var$rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|^-|[^\x80-\uFFFF\w-]/g;
const $f10862bae7c0a8e1$var$fcssescape = function(ch, asCodePoint) {
    if (!asCodePoint) return "\\" + ch;
    if (ch === "\0") return "\uFFFD";
    if (ch === "-" && ch.length === 1) return "\\-";
    return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16);
};
const $f10862bae7c0a8e1$export$a1a11b095f88289a = (sel)=>{
    return (sel + "").replace($f10862bae7c0a8e1$var$rcssescape, $f10862bae7c0a8e1$var$fcssescape);
};



"use strict";
const $01d01ec4e77f1ad1$export$ae1eeb9bcad7a91d = (str, resolve)=>{
    let expanded = "";
    let index = 0;
    let state = "char";
    let tokenPath = "";
    let fallback = "";
    const currentStates = [];
    while(index < str.length){
        const char = str[index];
        if (char === "{") {
            const endIndex = str.indexOf("}", index);
            if (endIndex === -1) break;
            const path = str.slice(index + 1, endIndex);
            const resolved = resolve(path);
            expanded += resolved ?? path;
            index = endIndex + 1;
            continue;
        }
        if (state === "token") {
            if (char === ",") {
                if (str[index] === "") index++;
                state = "fallback";
                currentStates.push(state);
                const resolved = resolve(tokenPath);
                if (resolved?.endsWith(")")) expanded += resolved.slice(0, -1);
                tokenPath = "";
                fallback = "";
                continue;
            }
        }
        if (state === "fallback") {
            const nextFallback = fallback + char;
            if (nextFallback === ", var(") {
                const innerEndIndex = $01d01ec4e77f1ad1$var$cssVarParser(str.slice(index + 1));
                const endIndex = innerEndIndex + index + 1;
                const cssVar = str.slice(index + 1, endIndex);
                if (endIndex === -1) break;
                expanded += ", var(" + cssVar + ")";
                index = endIndex + 1;
                state = currentStates.pop() ?? state;
                fallback = "";
                continue;
            }
        }
        if (state === "token" || state === "fallback") {
            index++;
            if (char === ")") {
                state = currentStates.pop() ?? state ?? "char";
                fallback += char;
                const resolved = tokenPath ? resolve(tokenPath) ?? (0, $f10862bae7c0a8e1$export$a1a11b095f88289a)(tokenPath) : tokenPath;
                if (fallback) {
                    fallback = fallback.slice(1).trim();
                    if (!fallback.startsWith("token(") && fallback.endsWith(")")) fallback = fallback.slice(0, -1);
                    if (fallback.includes("token(")) {
                        const parsed = $01d01ec4e77f1ad1$export$ae1eeb9bcad7a91d(fallback, resolve);
                        if (parsed) fallback = parsed.slice(0, -1);
                    } else if (fallback) {
                        const resolvedFallback = resolve(fallback);
                        if (resolvedFallback) fallback = resolvedFallback;
                    }
                }
                const lastChar = expanded.at(-1);
                if (fallback) {
                    if (lastChar?.trim()) expanded += resolved.slice(0, -1) + (", " + fallback + ")");
                    else expanded += fallback;
                } else expanded += resolved || ")";
                tokenPath = "";
                fallback = "";
                state = "char";
                continue;
            }
            if (state === "token") tokenPath += char;
            if (state === "fallback") fallback += char;
            continue;
        }
        const tokenIndex = str.indexOf("token(", index);
        if (tokenIndex !== -1) {
            const innerTokenIndex = tokenIndex + 6;
            expanded += str.slice(index, tokenIndex);
            index = innerTokenIndex;
            state = "token";
            currentStates.push(state);
            continue;
        }
        expanded += char;
        index++;
    }
    return expanded;
};
const $01d01ec4e77f1ad1$var$cssVarParser = (str)=>{
    let index = 0;
    const openedParenthesises = [
        "("
    ];
    while(index < str.length){
        const char = str[index];
        if (char === "(") openedParenthesises.push(char);
        else if (char === ")") {
            openedParenthesises.pop();
            if (openedParenthesises.length === 0) return index;
        }
        index++;
    }
    return index;
};


"use strict";
function $76f0f8bfacb1c512$export$18dc39132a3e8c51(map) {
    const obj = {};
    map.forEach((value, key)=>{
        if (value instanceof Map) obj[key] = Object.fromEntries(value);
        else obj[key] = value;
    });
    return obj;
}



"use strict";
const $a7ba83f784547ca3$var$REFERENCE_REGEX = /({([^}]*)})/g;
const $a7ba83f784547ca3$var$CURLY_REGEX = /[{}]/g;
const $a7ba83f784547ca3$export$98aea2f7791dffee = /\w+\.\w+/;
const $a7ba83f784547ca3$export$7a8750ced918912e = (value)=>{
    if (!(0, $b3f328a5401a2298$export$844ec244b1367d54)(value)) return [];
    const matches = value.match($a7ba83f784547ca3$var$REFERENCE_REGEX);
    if (!matches) return [];
    return matches.map((match)=>match.replace($a7ba83f784547ca3$var$CURLY_REGEX, "")).map((value2)=>value2.trim());
};
const $a7ba83f784547ca3$export$9d46be67a6e05ef0 = (value)=>$a7ba83f784547ca3$var$REFERENCE_REGEX.test(value);
function $a7ba83f784547ca3$export$6c976907770ec615(token) {
    if (!token.extensions?.references) return token.extensions?.cssVar?.ref ?? token.value;
    const references = token.extensions.references ?? {};
    token.value = Object.keys(references).reduce((valueStr, key)=>{
        const referenceToken = references[key];
        if (referenceToken.extensions.conditions) return valueStr;
        const value = $a7ba83f784547ca3$export$6c976907770ec615(referenceToken);
        return valueStr.replace(`{${key}}`, value);
    }, token.value);
    delete token.extensions.references;
    return token.value;
}




"use strict";
function $9e7070bbc9deb695$var$resolveReference(operand) {
    if ((0, $b3f328a5401a2298$export$a6cdc56e425d0d0a)(operand) && operand.reference) return operand.reference;
    return String(operand);
}
const $9e7070bbc9deb695$var$toExpression = (operator, ...operands)=>operands.map($9e7070bbc9deb695$var$resolveReference).join(` ${operator} `).replace(/calc/g, "");
const $9e7070bbc9deb695$var$add = (...operands)=>`calc(${$9e7070bbc9deb695$var$toExpression("+", ...operands)})`;
const $9e7070bbc9deb695$var$subtract = (...operands)=>`calc(${$9e7070bbc9deb695$var$toExpression("-", ...operands)})`;
const $9e7070bbc9deb695$var$multiply = (...operands)=>`calc(${$9e7070bbc9deb695$var$toExpression("*", ...operands)})`;
const $9e7070bbc9deb695$var$divide = (...operands)=>`calc(${$9e7070bbc9deb695$var$toExpression("/", ...operands)})`;
const $9e7070bbc9deb695$var$negate = (x)=>{
    const value = $9e7070bbc9deb695$var$resolveReference(x);
    if (value != null && !Number.isNaN(parseFloat(value))) return String(value).startsWith("-") ? String(value).slice(1) : `-${value}`;
    return $9e7070bbc9deb695$var$multiply(value, -1);
};
const $9e7070bbc9deb695$export$42bfa9b2d4dad91a = Object.assign((x)=>({
        add: (...operands)=>$9e7070bbc9deb695$export$42bfa9b2d4dad91a($9e7070bbc9deb695$var$add(x, ...operands)),
        subtract: (...operands)=>$9e7070bbc9deb695$export$42bfa9b2d4dad91a($9e7070bbc9deb695$var$subtract(x, ...operands)),
        multiply: (...operands)=>$9e7070bbc9deb695$export$42bfa9b2d4dad91a($9e7070bbc9deb695$var$multiply(x, ...operands)),
        divide: (...operands)=>$9e7070bbc9deb695$export$42bfa9b2d4dad91a($9e7070bbc9deb695$var$divide(x, ...operands)),
        negate: ()=>$9e7070bbc9deb695$export$42bfa9b2d4dad91a($9e7070bbc9deb695$var$negate(x)),
        toString: ()=>x.toString()
    }), {
    add: $9e7070bbc9deb695$var$add,
    subtract: $9e7070bbc9deb695$var$subtract,
    multiply: $9e7070bbc9deb695$var$multiply,
    divide: $9e7070bbc9deb695$var$divide,
    negate: $9e7070bbc9deb695$var$negate
});



"use strict";
const $b68ebd9b2c05acc5$export$441a6ff10bae0bb3 = {
    enforce: "pre",
    transform (dictionary) {
        const { prefix: prefix, allTokens: allTokens, formatCssVar: formatCssVar, formatTokenName: formatTokenName, registerToken: registerToken } = dictionary;
        const tokens = allTokens.filter(({ extensions: extensions })=>extensions.category === "spacing");
        tokens.forEach((token)=>{
            const originalPath = token.path.slice();
            const originalVar = formatCssVar(originalPath, prefix);
            if ((0, $b3f328a5401a2298$export$844ec244b1367d54)(token.value) && token.value === "0rem") return;
            const nextToken = structuredClone(token);
            Object.assign(nextToken.extensions, {
                negative: true,
                prop: `-${token.extensions.prop}`,
                originalPath: originalPath
            });
            nextToken.value = (0, $9e7070bbc9deb695$export$42bfa9b2d4dad91a).negate(originalVar.ref);
            const lastPath = nextToken.path[nextToken.path.length - 1];
            if (lastPath != null) nextToken.path[nextToken.path.length - 1] = `-${lastPath}`;
            if (nextToken.path) nextToken.name = formatTokenName(nextToken.path);
            registerToken(nextToken);
        });
    }
};
const $b68ebd9b2c05acc5$var$units = /* @__PURE__ */ new Set([
    "spacing",
    "sizes",
    "borderWidths",
    "fontSizes",
    "radii"
]);
const $b68ebd9b2c05acc5$export$d69f1b5705d59b6c = {
    enforce: "post",
    transform (dictionary) {
        const tokens = dictionary.allTokens.filter((token)=>{
            return $b68ebd9b2c05acc5$var$units.has(token.extensions.category) && !token.extensions.negative;
        });
        tokens.forEach((token)=>{
            Object.assign(token.extensions, {
                pixelValue: (0, $dc95ad86baa706b3$export$6562491d7413c9c9)(token.value)
            });
        });
    }
};
const $b68ebd9b2c05acc5$export$b525739f8f649fe4 = {
    enforce: "post",
    transform (dictionary) {
        const { allTokens: allTokens, registerToken: registerToken, formatTokenName: formatTokenName } = dictionary;
        const tokens = allTokens.filter(({ extensions: extensions })=>extensions.category === "colors");
        const keys = /* @__PURE__ */ new Map();
        const colorPalettes = /* @__PURE__ */ new Map();
        tokens.forEach((token)=>{
            const { colorPalette: colorPalette } = token.extensions;
            if (!colorPalette) return;
            colorPalette.keys.forEach((keyPath)=>{
                keys.set(formatTokenName(keyPath), keyPath);
            });
            colorPalette.roots.forEach((colorPaletteRoot)=>{
                const name = formatTokenName(colorPaletteRoot);
                const colorPaletteList = colorPalettes.get(name) || [];
                colorPaletteList.push(token);
                colorPalettes.set(name, colorPaletteList);
                if (token.extensions.default && colorPaletteRoot.length === 1) {
                    const keyPath = colorPalette.keys[0]?.filter(Boolean);
                    if (!keyPath.length) return;
                    const path = colorPaletteRoot.concat(keyPath);
                    keys.set(formatTokenName(path), []);
                }
            });
        });
        keys.forEach((segments)=>{
            const path = [
                "colors",
                "colorPalette",
                ...segments
            ].filter(Boolean);
            const name = formatTokenName(path);
            const prop = formatTokenName(path.slice(1));
            const token = {
                name: name,
                value: name,
                originalValue: name,
                path: path,
                extensions: {
                    condition: "base",
                    originalPath: path,
                    category: "colors",
                    prop: prop,
                    virtual: true
                }
            };
            registerToken(token, "pre");
        });
    }
};
const $b68ebd9b2c05acc5$export$52eea65c8f3bb51f = {
    enforce: "post",
    transform (dictionary) {
        dictionary.allTokens = dictionary.allTokens.filter((token)=>token.value !== "");
    }
};
const $b68ebd9b2c05acc5$export$52d04681fd073e3c = [
    $b68ebd9b2c05acc5$export$441a6ff10bae0bb3,
    $b68ebd9b2c05acc5$export$b525739f8f649fe4,
    $b68ebd9b2c05acc5$export$d69f1b5705d59b6c,
    $b68ebd9b2c05acc5$export$52eea65c8f3bb51f
];



"use strict";
const $59c016065fcd41a5$export$dbf77247e2e4face = {
    type: "extensions",
    enforce: "pre",
    name: "tokens/css-var",
    transform (token, dictionary) {
        const { prefix: prefix, formatCssVar: formatCssVar } = dictionary;
        const { negative: negative, originalPath: originalPath } = token.extensions;
        const path = negative ? originalPath : token.path;
        return {
            cssVar: formatCssVar(path.filter(Boolean), prefix)
        };
    }
};
const $59c016065fcd41a5$export$f78ef862fefbe03d = {
    enforce: "post",
    type: "value",
    name: "tokens/conditionals",
    transform (token, dictionary) {
        const { prefix: prefix, formatCssVar: formatCssVar } = dictionary;
        const refs = (0, $a7ba83f784547ca3$export$7a8750ced918912e)(token.value);
        if (!refs.length) return token.value;
        refs.forEach((ref)=>{
            const variable = formatCssVar(ref.split("."), prefix);
            token.value = token.value.replace(`{${variable.ref}}`, variable);
        });
        return token.value;
    }
};
const $59c016065fcd41a5$export$f5aaa1c82e5da430 = {
    type: "extensions",
    enforce: "pre",
    name: "tokens/colors/colorPalette",
    match (token) {
        return token.extensions.category === "colors" && !token.extensions.virtual;
    },
    transform (token, dict) {
        let path = token.path.slice();
        path.pop();
        path.shift();
        if (path.length === 0) {
            const newPath = [
                ...token.path
            ];
            newPath.shift();
            path = newPath;
        }
        if (path.length === 0) return {};
        const roots = path.reduce((acc, _, i, arr)=>{
            const next = arr.slice(0, i + 1);
            acc.push(next);
            return acc;
        }, []);
        const root = path[0];
        const value = dict.formatTokenName(path);
        const keys = token.path.slice(token.path.indexOf(root) + 1).reduce((acc, _, i, arr)=>{
            acc.push(arr.slice(i));
            return acc;
        }, []);
        if (keys.length === 0) keys.push([
            ""
        ]);
        return {
            colorPalette: {
                value: value,
                roots: roots,
                keys: keys
            }
        };
    }
};
const $59c016065fcd41a5$export$12feaf11c829ef28 = [
    $59c016065fcd41a5$export$dbf77247e2e4face,
    $59c016065fcd41a5$export$f78ef862fefbe03d,
    $59c016065fcd41a5$export$f5aaa1c82e5da430
];


"use strict";
const $3fc19fb8e741bb80$var$isToken = (value)=>{
    return (0, $b3f328a5401a2298$export$a6cdc56e425d0d0a)(value) && Object.prototype.hasOwnProperty.call(value, "value");
};
function $3fc19fb8e741bb80$var$expandBreakpoints(breakpoints) {
    if (!breakpoints) return {
        breakpoints: {},
        sizes: {}
    };
    return {
        breakpoints: (0, $d37e33c22423b9ba$export$d6051a0f7a227332)(breakpoints, (value)=>({
                value: value
            })),
        sizes: Object.fromEntries(Object.entries(breakpoints).map(([key, value])=>[
                `breakpoint-${key}`,
                {
                    value: value
                }
            ]))
    };
}
function $3fc19fb8e741bb80$export$b2a6cfa443dacae(options) {
    const { prefix: prefix = "", tokens: tokens = {}, semanticTokens: semanticTokens = {}, breakpoints: breakpoints = {} } = options;
    const formatTokenName = (path)=>path.join(".");
    const formatCssVar = (path, prefix2)=>(0, $fce16da9dfa1c130$export$8b4981022bd80a4e)(path.join("-"), {
            prefix: prefix2
        });
    const allTokens = [];
    const tokenNameMap = /* @__PURE__ */ new Map();
    const conditionMap = /* @__PURE__ */ new Map();
    const cssVarMap = /* @__PURE__ */ new Map();
    const colorPaletteMap = /* @__PURE__ */ new Map();
    const flatMap = /* @__PURE__ */ new Map();
    const byCategory = /* @__PURE__ */ new Map();
    const categoryMap = /* @__PURE__ */ new Map();
    const transforms = /* @__PURE__ */ new Map();
    const middlewares = [];
    function registerToken(token, phase) {
        allTokens.push(token);
        tokenNameMap.set(token.name, token);
        if (phase) transforms.forEach((fn)=>{
            if (fn.enforce === phase) transformToken(fn, token);
        });
    }
    const breakpointTokens = $3fc19fb8e741bb80$var$expandBreakpoints(breakpoints);
    const computedTokens = (0, $d2e329dcce85bd14$export$8e16b83750b44988)({
        ...tokens,
        breakpoints: breakpointTokens.breakpoints,
        sizes: {
            ...tokens.sizes,
            ...breakpointTokens.sizes
        }
    });
    function registerTokens() {
        (0, $d37e33c22423b9ba$export$915658b6215945a4)(computedTokens, (entry, path)=>{
            const isDefault = path.includes("DEFAULT");
            path = $3fc19fb8e741bb80$var$filterDefault(path);
            const category = path[0];
            const name = formatTokenName(path);
            const t = (0, $b3f328a5401a2298$export$844ec244b1367d54)(entry) ? {
                value: entry
            } : entry;
            const token = {
                value: t.value,
                originalValue: t.value,
                name: name,
                path: path,
                extensions: {
                    condition: "base",
                    originalPath: path,
                    category: category,
                    prop: formatTokenName(path.slice(1))
                }
            };
            if (isDefault) token.extensions.default = true;
            registerToken(token);
        }, {
            stop: $3fc19fb8e741bb80$var$isToken
        });
        (0, $d37e33c22423b9ba$export$915658b6215945a4)(semanticTokens, (entry, path)=>{
            const isDefault = path.includes("DEFAULT");
            path = $3fc19fb8e741bb80$var$filterBaseCondition($3fc19fb8e741bb80$var$filterDefault(path));
            const category = path[0];
            const name = formatTokenName(path);
            const t = (0, $b3f328a5401a2298$export$844ec244b1367d54)(entry.value) ? {
                value: {
                    base: entry.value
                }
            } : entry;
            const token = {
                value: t.value.base || "",
                originalValue: t.value.base || "",
                name: name,
                path: path,
                extensions: {
                    originalPath: path,
                    category: category,
                    conditions: t.value,
                    condition: "base",
                    prop: formatTokenName(path.slice(1))
                }
            };
            if (isDefault) token.extensions.default = true;
            registerToken(token);
        }, {
            stop: $3fc19fb8e741bb80$var$isToken
        });
    }
    function getByName(name) {
        return tokenNameMap.get(name);
    }
    function buildConditionMap(token) {
        const { condition: condition } = token.extensions;
        if (!condition) return;
        if (!conditionMap.has(condition)) conditionMap.set(condition, /* @__PURE__ */ new Set());
        conditionMap.get(condition).add(token);
    }
    function buildCategoryMap(token) {
        const { category: category, prop: prop } = token.extensions;
        if (!category) return;
        if (!categoryMap.has(category)) categoryMap.set(category, /* @__PURE__ */ new Map());
        categoryMap.get(category).set(prop, token);
    }
    function buildCssVars(token) {
        const { condition: condition, negative: negative, virtual: virtual, cssVar: cssVar2 } = token.extensions;
        if (negative || virtual || !condition || !cssVar2) return;
        if (!cssVarMap.has(condition)) cssVarMap.set(condition, /* @__PURE__ */ new Map());
        cssVarMap.get(condition).set(cssVar2.var, token.value);
    }
    function buildFlatMap(token) {
        const { category: category, prop: prop, cssVar: cssVar2, negative: negative } = token.extensions;
        if (!category) return;
        if (!byCategory.has(category)) byCategory.set(category, /* @__PURE__ */ new Map());
        const value = negative ? token.extensions.conditions ? token.originalValue : token.value : cssVar2.ref;
        byCategory.get(category).set(prop, value);
        flatMap.set([
            category,
            prop
        ].join("."), value);
    }
    function buildColorPalette(token) {
        const { colorPalette: colorPalette, virtual: virtual, default: isDefault } = token.extensions;
        if (!colorPalette || virtual) return;
        colorPalette.roots.forEach((root)=>{
            const name = formatTokenName(root);
            if (!colorPaletteMap.has(name)) colorPaletteMap.set(name, /* @__PURE__ */ new Map());
            const virtualPath = $3fc19fb8e741bb80$var$replaceRootWithColorPalette([
                ...token.path
            ], [
                ...root
            ]);
            const virtualName = formatTokenName(virtualPath);
            const virtualToken = getByName(virtualName);
            if (!virtualToken || !virtualToken.extensions.cssVar) return;
            const { var: virtualVar } = virtualToken.extensions.cssVar;
            colorPaletteMap.get(name).set(virtualVar, token.extensions.cssVar.ref);
            if (isDefault && root.length === 1) {
                const colorPaletteName = formatTokenName([
                    "colors",
                    "colorPalette"
                ]);
                const colorPaletteToken = getByName(colorPaletteName);
                if (!colorPaletteToken) return;
                const name2 = formatTokenName(token.path);
                const virtualToken2 = getByName(name2);
                if (!virtualToken2) return;
                const keyPath = colorPalette.keys[0]?.filter(Boolean);
                if (!keyPath.length) return;
                const computedName = formatTokenName(root.concat(keyPath));
                if (!colorPaletteMap.has(computedName)) colorPaletteMap.set(computedName, /* @__PURE__ */ new Map());
                colorPaletteMap.get(computedName).set(colorPaletteToken.extensions.cssVar.var, virtualToken2.extensions.cssVar.ref);
            }
        });
    }
    let byCategoryJson = {};
    function setupViews() {
        allTokens.forEach((token)=>{
            buildConditionMap(token);
            buildCategoryMap(token);
            buildCssVars(token);
            buildFlatMap(token);
            buildColorPalette(token);
        });
        byCategoryJson = (0, $76f0f8bfacb1c512$export$18dc39132a3e8c51)(byCategory);
    }
    const colorMix = (value, tokenFn)=>{
        if (!value || typeof value !== "string") return {
            invalid: true,
            value: value
        };
        const [colorPath, rawOpacity] = value.split("/");
        if (!colorPath || !rawOpacity) return {
            invalid: true,
            value: colorPath
        };
        const colorToken = tokenFn(colorPath);
        const opacityToken = getByName(`opacity.${rawOpacity}`)?.value;
        if (!opacityToken && isNaN(Number(rawOpacity))) return {
            invalid: true,
            value: colorPath
        };
        const percent = opacityToken ? Number(opacityToken) * 100 + "%" : `${rawOpacity}%`;
        const color = colorToken ?? colorPath;
        return {
            invalid: false,
            color: color,
            value: `color-mix(in srgb, ${color} ${percent}, transparent)`
        };
    };
    const getVar = (0, $d4123a658452050c$export$7c73462e0d25e514)((value, fallback)=>{
        return flatMap.get(value) ?? fallback;
    });
    const getCategoryValues = (0, $d4123a658452050c$export$7c73462e0d25e514)((category)=>{
        return byCategoryJson[category] || null;
    });
    const expandReferenceInValue = (0, $d4123a658452050c$export$7c73462e0d25e514)((value)=>{
        return (0, $01d01ec4e77f1ad1$export$ae1eeb9bcad7a91d)(value, (path)=>{
            if (!path) return;
            if (path.includes("/")) {
                const mix = colorMix(path, (v)=>getVar(v));
                if (mix.invalid) throw new Error("Invalid color mix at " + path + ": " + mix.value);
                return mix.value;
            }
            const resolved = getVar(path);
            if (resolved) return resolved;
            return (0, $a7ba83f784547ca3$export$98aea2f7791dffee).test(path) ? (0, $f10862bae7c0a8e1$export$a1a11b095f88289a)(path) : path;
        });
    });
    const dictionary = {
        prefix: prefix,
        allTokens: allTokens,
        tokenMap: tokenNameMap,
        registerToken: registerToken,
        getByName: getByName,
        formatTokenName: formatTokenName,
        formatCssVar: formatCssVar,
        flatMap: flatMap,
        cssVarMap: cssVarMap,
        categoryMap: categoryMap,
        colorPaletteMap: colorPaletteMap,
        getVar: getVar,
        getCategoryValues: getCategoryValues,
        expandReferenceInValue: expandReferenceInValue
    };
    function registerTransform(...fns) {
        fns.forEach((fn)=>{
            transforms.set(fn.name, fn);
        });
    }
    function registerMiddleware(...fns) {
        middlewares.push(...fns);
    }
    function transformToken(transform, token) {
        if (token.extensions.references) return;
        if ((0, $b3f328a5401a2298$export$f6e2535fb5126e54)(transform.match) && !transform.match(token)) return;
        const fn = (v)=>transform.transform(v, dictionary);
        const transformed = fn(token);
        switch(true){
            case transform.type === "extensions":
                Object.assign(token.extensions, transformed);
                break;
            case transform.type === "value":
                token.value = transformed;
                break;
            default:
                token[transform.type] = transformed;
                break;
        }
    }
    function applyMiddlewares(enforce) {
        middlewares.forEach((middleware)=>{
            if (middleware.enforce === enforce) middleware.transform(dictionary);
        });
    }
    function applyTransforms(enforce) {
        transforms.forEach((transform)=>{
            if (transform.enforce === enforce) allTokens.forEach((token)=>{
                transformToken(transform, token);
            });
        });
    }
    function addConditionalTokens() {
        allTokens.forEach((token)=>{
            const tokens2 = $3fc19fb8e741bb80$var$getConditionalTokens(token);
            if (!tokens2 || tokens2.length === 0) return;
            tokens2.forEach((token2)=>{
                registerToken(token2);
            });
        });
    }
    function getTokenReferences(value) {
        const refs = (0, $a7ba83f784547ca3$export$7a8750ced918912e)(value);
        return refs.map((ref)=>getByName(ref)).filter(Boolean);
    }
    function addReferences() {
        allTokens.forEach((token)=>{
            if (!(0, $a7ba83f784547ca3$export$9d46be67a6e05ef0)(token.value)) return;
            const references = getTokenReferences(token.value);
            token.extensions.references = references.reduce((acc, ref)=>{
                acc[ref.name] = ref;
                return acc;
            }, {});
        });
    }
    function expandTokenReferences$1() {
        allTokens.forEach((token)=>{
            (0, $a7ba83f784547ca3$export$6c976907770ec615)(token);
        });
    }
    function build() {
        applyMiddlewares("pre");
        applyTransforms("pre");
        addConditionalTokens();
        addReferences();
        expandTokenReferences$1();
        applyMiddlewares("post");
        applyTransforms("post");
        setupViews();
    }
    registerTokens();
    registerTransform(...(0, $59c016065fcd41a5$export$12feaf11c829ef28));
    registerMiddleware(...(0, $b68ebd9b2c05acc5$export$52d04681fd073e3c));
    build();
    return dictionary;
}
function $3fc19fb8e741bb80$var$filterDefault(path) {
    if (path[0] === "DEFAULT") return path;
    return path.filter((item)=>item !== "DEFAULT");
}
function $3fc19fb8e741bb80$var$filterBaseCondition(path) {
    return path.filter((item)=>item !== "base");
}
function $3fc19fb8e741bb80$var$getConditionalTokens(token) {
    if (!token.extensions.conditions) return;
    const { conditions: conditions } = token.extensions;
    const tokens = [];
    (0, $d37e33c22423b9ba$export$915658b6215945a4)(conditions, (value, path)=>{
        const nextPath = $3fc19fb8e741bb80$var$filterBaseCondition(path);
        if (!nextPath.length) return;
        const nextToken = structuredClone(token);
        nextToken.value = value;
        nextToken.extensions.condition = nextPath.join(":");
        tokens.push(nextToken);
    });
    return tokens;
}
function $3fc19fb8e741bb80$var$replaceRootWithColorPalette(path, roots) {
    const startIndex = path.findIndex((_, index)=>roots.every((rootElement, rootIndex)=>path[index + rootIndex] === rootElement));
    if (startIndex === -1) return path;
    path.splice(startIndex, roots.length);
    path.splice(startIndex, 0, "colorPalette");
    return path;
}
const $3fc19fb8e741bb80$export$d4433a01ea838b6 = (0, $492c05c13da69026$export$c94ea207b45fef3a)()([
    "aspectRatios",
    "zIndex",
    "opacity",
    "colors",
    "fonts",
    "fontSizes",
    "fontWeights",
    "lineHeights",
    "letterSpacings",
    "sizes",
    "shadows",
    "spacing",
    "radii",
    "cursor",
    "borders",
    "borderWidths",
    "borderStyles",
    "durations",
    "easings",
    "animations",
    "blurs",
    "gradients",
    "breakpoints",
    "assets"
]);




"use strict";
const $01cafdac14948764$export$9b476054b78b89cd = (value, token)=>{
    if (!value || typeof value !== "string") return {
        invalid: true,
        value: value
    };
    const [rawColor, rawOpacity] = value.split("/");
    if (!rawColor || !rawOpacity || rawColor === "currentBg") return {
        invalid: true,
        value: rawColor
    };
    const colorToken = token(`colors.${rawColor}`);
    const opacityToken = token.raw(`opacity.${rawOpacity}`)?.value;
    if (!opacityToken && isNaN(Number(rawOpacity))) return {
        invalid: true,
        value: rawColor
    };
    const percent = opacityToken ? Number(opacityToken) * 100 + "%" : `${rawOpacity}%`;
    const color = colorToken ?? rawColor;
    return {
        invalid: false,
        color: color,
        value: `color-mix(in srgb, ${color} ${percent}, transparent)`
    };
};
const $01cafdac14948764$export$85907fd96ef7f08 = (prop)=>(value, args)=>{
        const mix = args.utils.colorMix(value);
        if (mix.invalid) return {
            [prop]: value
        };
        const cssVar = "--mix-" + prop;
        return {
            [cssVar]: mix.value,
            [prop]: `var(${cssVar}, ${mix.color})`
        };
    };



"use strict";
function $ceb0a5bb967a9390$var$normalize(config) {
    return config;
}
function $ceb0a5bb967a9390$var$normalizeConfig(config) {
    return Object.fromEntries(Object.entries(config).map(([property, propertyConfig])=>{
        return [
            property,
            $ceb0a5bb967a9390$var$normalize(propertyConfig)
        ];
    }));
}
function $ceb0a5bb967a9390$export$968c2adeac0c1baa(options) {
    const configs = $ceb0a5bb967a9390$var$normalizeConfig(options.config);
    const tokens = options.tokens;
    const shorthands = /* @__PURE__ */ new Map();
    const propValues = /* @__PURE__ */ new Map();
    function register(property, config) {
        configs[property] = $ceb0a5bb967a9390$var$normalize(config);
        assignProperty(property, config);
    }
    const assignProperty = (property, config)=>{
        const values = getPropertyValues(config);
        if (!values) return;
        propValues.set(property, values);
        assignPropertyType(property, config);
    };
    const assignProperties = ()=>{
        for (const [prop, config] of Object.entries(configs)){
            if (!config) continue;
            assignProperty(prop, config);
        }
    };
    const assignShorthands = ()=>{
        for (const [property, config] of Object.entries(configs)){
            const { shorthand: shorthand } = config ?? {};
            if (!shorthand) continue;
            const values = Array.isArray(shorthand) ? shorthand : [
                shorthand
            ];
            values.forEach((name)=>shorthands.set(name, property));
        }
    };
    const assignColorPaletteProperty = ()=>{
        const values = (0, $76f0f8bfacb1c512$export$18dc39132a3e8c51)(tokens.colorPaletteMap);
        register("colorPalette", {
            values: Object.keys(values),
            transform: (0, $d4123a658452050c$export$7c73462e0d25e514)((value)=>values[value])
        });
    };
    const propTypes = /* @__PURE__ */ new Map();
    const assignPropertyType = (property, config)=>{
        if (!config) return;
        const values = getPropertyValues(config, (key)=>`type:Tokens["${key}"]`);
        if (typeof values === "object" && values.type) {
            propTypes.set(property, /* @__PURE__ */ new Set([
                `type:${values.type}`
            ]));
            return;
        }
        if (values) {
            const keys2 = new Set(Object.keys(values));
            propTypes.set(property, keys2);
        }
        const set = propTypes.get(property) ?? /* @__PURE__ */ new Set();
        if (config.property) propTypes.set(property, set.add(`CssProperties["${config.property}"]`));
    };
    const assignPropertyTypes = ()=>{
        for (const [property, propertyConfig] of Object.entries(configs)){
            if (!propertyConfig) continue;
            assignPropertyType(property, propertyConfig);
        }
    };
    const addPropertyType = (property, type)=>{
        const set = propTypes.get(property) ?? /* @__PURE__ */ new Set();
        propTypes.set(property, /* @__PURE__ */ new Set([
            ...set,
            ...type
        ]));
    };
    const getTypes = ()=>{
        const map = /* @__PURE__ */ new Map();
        for (const [prop, values] of propTypes.entries()){
            if (values.size === 0) {
                map.set(prop, [
                    "string"
                ]);
                continue;
            }
            const typeValues = Array.from(values).map((key)=>{
                if (key.startsWith("CssProperties")) return key;
                if (key.startsWith("type:")) return key.replace("type:", "");
                return JSON.stringify(key);
            });
            map.set(prop, typeValues);
        }
        return map;
    };
    const getPropertyValues = (config, resolveFn)=>{
        const { values: values } = config;
        const fn = (key)=>{
            const value = resolveFn?.(key);
            return value ? {
                [value]: value
            } : void 0;
        };
        if ((0, $b3f328a5401a2298$export$844ec244b1367d54)(values)) return fn?.(values) ?? tokens.getCategoryValues(values) ?? {};
        if (Array.isArray(values)) return values.reduce((result, value)=>{
            result[value] = value;
            return result;
        }, {});
        if ((0, $b3f328a5401a2298$export$f6e2535fb5126e54)(values)) return values(resolveFn ? fn : tokens.getCategoryValues);
        return values;
    };
    const defaultTransform = (0, $d4123a658452050c$export$7c73462e0d25e514)((prop, value)=>{
        return {
            [prop]: prop.startsWith("--") ? tokens.getVar(value, value) : value
        };
    });
    const tokenFn = Object.assign(tokens.getVar, {
        raw: (path)=>tokens.getByName(path)
    });
    const transform = (0, $d4123a658452050c$export$7c73462e0d25e514)((prop, raw)=>{
        const key = resolveShorthand(prop);
        if ((0, $b3f328a5401a2298$export$844ec244b1367d54)(raw) && !raw.includes("_EMO_")) raw = tokens.expandReferenceInValue(raw);
        const config = configs[key];
        if (!config) return defaultTransform(key, raw);
        const value = propValues.get(key)?.[raw];
        if (!config.transform) return defaultTransform(prop, value ?? raw);
        const _colorMix = (value2)=>(0, $01cafdac14948764$export$9b476054b78b89cd)(value2, tokenFn);
        return config.transform(value ?? raw, {
            raw: raw,
            token: tokenFn,
            utils: {
                colorMix: _colorMix
            }
        });
    });
    function build() {
        assignShorthands();
        assignColorPaletteProperty();
        assignProperties();
        assignPropertyTypes();
    }
    build();
    const hasShorthand = shorthands.size > 0;
    const resolveShorthand = (0, $d4123a658452050c$export$7c73462e0d25e514)((prop)=>{
        return shorthands.get(prop) ?? prop;
    });
    const keys = ()=>{
        return [
            ...Array.from(shorthands.keys()),
            ...Object.keys(configs)
        ];
    };
    const instance = {
        keys: keys,
        hasShorthand: hasShorthand,
        transform: transform,
        shorthands: shorthands,
        resolveShorthand: resolveShorthand,
        register: register,
        getTypes: getTypes,
        addPropertyType: addPropertyType
    };
    return instance;
}


"use strict";
function $a858f572f00a56ce$export$b06ab6dfae3e7e3(...configs) {
    const config = (0, $ee2de6f250f65b79$export$5d86b86a654a7039)(...configs);
    const { theme: theme = {}, utilities: utilities = {}, globalCss: globalCss = {}, cssVarsRoot: cssVarsRoot = ":where(:root, :host)", cssVarsPrefix: cssVarsPrefix = "chakra", preflight: preflight } = config;
    const layers = (0, $b9a7cd9f5520e35f$export$ddf51b1b91379574)(config);
    const tokens = (0, $3fc19fb8e741bb80$export$b2a6cfa443dacae)({
        breakpoints: theme.breakpoints,
        tokens: theme.tokens,
        semanticTokens: theme.semanticTokens,
        prefix: cssVarsPrefix
    });
    const breakpoints = (0, $8b497d63b5509176$export$79e1df82cbbff4e9)(theme.breakpoints ?? {});
    const conditions = (0, $3fffe12fb4188fab$export$4841b94afe59a0cf)({
        conditions: config.conditions ?? {},
        breakpoints: breakpoints
    });
    const utility = (0, $ceb0a5bb967a9390$export$968c2adeac0c1baa)({
        config: utilities,
        tokens: tokens
    });
    function assignComposition() {
        const { textStyles: textStyles, layerStyles: layerStyles, animationStyles: animationStyles } = theme;
        const compositions = (0, $d2e329dcce85bd14$export$8e16b83750b44988)({
            textStyle: textStyles,
            layerStyle: layerStyles,
            animationStyle: animationStyles
        });
        for (const [key, values] of Object.entries(compositions)){
            const flatValues = (0, $0b8ad33560552d98$export$bffa455ba8c619a6)(values ?? {}, (v)=>(0, $b3f328a5401a2298$export$a6cdc56e425d0d0a)(v) && "value" in v);
            utility.register(key, {
                values: Object.keys(flatValues),
                transform (value) {
                    return css(flatValues[value]);
                }
            });
        }
    }
    assignComposition();
    utility.addPropertyType("animationName", Object.keys(theme.keyframes ?? {}));
    const properties = /* @__PURE__ */ new Set([
        "css",
        ...utility.keys(),
        ...conditions.keys()
    ]);
    const isValidProperty = (0, $d4123a658452050c$export$7c73462e0d25e514)((prop)=>properties.has(prop) || (0, $34089d82611f238e$export$74465ce51e034ce6)(prop));
    const normalizeValue = (value)=>{
        if (Array.isArray(value)) return value.reduce((acc, current, index)=>{
            const key = conditions.breakpoints[index];
            if (current != null) acc[key] = current;
            return acc;
        }, {});
        return value;
    };
    const normalizeFn = (0, $44dce68f810fd8e4$export$358f081847bfe3e3)({
        utility: utility,
        normalize: normalizeValue
    });
    const serialize = (0, $d899c5ee07c3fb7c$export$173558e7ef6da591)({
        conditions: conditions,
        isValidProperty: isValidProperty
    });
    const css = (0, $7bc594fcbeb14d16$export$7f714a6e05babb56)({
        transform: utility.transform,
        conditions: conditions,
        normalize: normalizeFn
    });
    const cva = (0, $4b08c8ac77ec20b1$export$439f157863edac93)({
        css: css,
        conditions: conditions,
        normalize: normalizeFn,
        layers: layers
    });
    const sva = (0, $fa805d9058e81f24$export$6882452d1db83150)({
        cva: cva
    });
    function getTokenCss() {
        const result = {};
        for (const [key, values] of tokens.cssVarMap.entries()){
            const varsObj = Object.fromEntries(values);
            if (Object.keys(varsObj).length === 0) continue;
            const selector = key === "base" ? cssVarsRoot : conditions.resolve(key);
            const cssObject = css(serialize({
                [selector]: varsObj
            }));
            (0, $132364fc06bc5aac$export$2ee76fde9ffe109d)(result, cssObject);
        }
        return layers.wrap("tokens", result);
    }
    function getGlobalCss() {
        const keyframes = Object.fromEntries(Object.entries(theme.keyframes ?? {}).map(([key, value])=>[
                `@keyframes ${key}`,
                value
            ]));
        const result = Object.assign({}, keyframes, css(serialize(globalCss)));
        return layers.wrap("base", result);
    }
    function splitCssProps(props) {
        return (0, $8be83bf2b7a4ecef$export$45029c61b0073d87)(props, isValidProperty);
    }
    function getPreflightCss() {
        const result = (0, $8f95a203f04b4df2$export$33276ec412a73052)({
            preflight: preflight
        });
        return layers.wrap("reset", result);
    }
    const tokenMap = $a858f572f00a56ce$var$getTokenMap(tokens);
    const tokenFn = (path, fallback)=>{
        return tokenMap.get(path)?.value || fallback;
    };
    tokenFn.var = (path, fallback)=>{
        return tokenMap.get(path)?.variable || fallback;
    };
    function getRecipe(key, fallback) {
        return theme.recipes?.[key] ?? fallback;
    }
    function getSlotRecipe(key, fallback) {
        return theme.slotRecipes?.[key] ?? fallback;
    }
    function isRecipe(key) {
        return Object.hasOwnProperty.call(theme.recipes ?? {}, key);
    }
    function isSlotRecipe(key) {
        return Object.hasOwnProperty.call(theme.slotRecipes ?? {}, key);
    }
    function hasRecipe(key) {
        return isRecipe(key) || isSlotRecipe(key);
    }
    const _global = [
        getPreflightCss(),
        getGlobalCss(),
        getTokenCss()
    ];
    return {
        $$chakra: true,
        _config: config,
        _global: _global,
        breakpoints: breakpoints,
        tokens: tokens,
        conditions: conditions,
        utility: utility,
        token: tokenFn,
        properties: properties,
        layers: layers,
        isValidProperty: isValidProperty,
        splitCssProps: splitCssProps,
        normalizeValue: normalizeValue,
        getTokenCss: getTokenCss,
        getGlobalCss: getGlobalCss,
        getPreflightCss: getPreflightCss,
        css: css,
        cva: cva,
        sva: sva,
        getRecipe: getRecipe,
        getSlotRecipe: getSlotRecipe,
        hasRecipe: hasRecipe,
        isRecipe: isRecipe,
        isSlotRecipe: isSlotRecipe
    };
}
function $a858f572f00a56ce$var$getTokenMap(tokens) {
    const map = /* @__PURE__ */ new Map();
    tokens.allTokens.forEach((token)=>{
        const { cssVar: cssVar, virtual: virtual, conditions: conditions } = token.extensions;
        const value = !!conditions || virtual ? cssVar.ref : token.value;
        map.set(token.name, {
            value: value,
            variable: cssVar.ref
        });
    });
    return map;
}
const $a858f572f00a56ce$export$50a73c89c311c4ca = (mod)=>{
    return (0, $b3f328a5401a2298$export$a6cdc56e425d0d0a)(mod) && !!Reflect.get(mod, "$$chakra");
};




"use strict";
const $0de2139040a29c93$var$isCssVar = (v)=>/^var\(--.+\)$/.test(v);
const $0de2139040a29c93$var$wrap = (str, v)=>v != null ? `${str}(${v})` : v;
const $0de2139040a29c93$var$deg = (v)=>{
    if ($0de2139040a29c93$var$isCssVar(v) || v == null) return v;
    const unitless = typeof v === "string" && !v.endsWith("deg");
    return typeof v === "number" || unitless ? `${v}deg` : v;
};
const $0de2139040a29c93$var$createFocusRing = (selector)=>{
    return {
        values: [
            "outside",
            "inside",
            "mixed",
            "none"
        ],
        transform (value, { token: token }) {
            const focusRingColor = token("colors.colorPalette.focusRing");
            const styles = {
                inside: {
                    "--focus-ring-color": focusRingColor,
                    [selector]: {
                        outlineOffset: "0px",
                        outlineWidth: "var(--focus-ring-width, 1px)",
                        outlineColor: "var(--focus-ring-color)",
                        outlineStyle: "var(--focus-ring-style, solid)",
                        borderColor: "var(--focus-ring-color)"
                    }
                },
                outside: {
                    "--focus-ring-color": focusRingColor,
                    [selector]: {
                        outlineWidth: "var(--focus-ring-width, 2px)",
                        outlineOffset: "var(--focus-ring-offset, 2px)",
                        outlineStyle: "var(--focus-ring-style, solid)",
                        outlineColor: "var(--focus-ring-color)"
                    }
                },
                mixed: {
                    "--focus-ring-color": focusRingColor,
                    [selector]: {
                        outlineWidth: "var(--focus-ring-width, 3px)",
                        outlineStyle: "var(--focus-ring-style, solid)",
                        outlineColor: "color-mix(in srgb, var(--focus-ring-color), transparent 60%)",
                        borderColor: "var(--focus-ring-color)"
                    }
                },
                none: {
                    "--focus-ring-color": focusRingColor,
                    [selector]: {
                        outline: "none"
                    }
                }
            };
            return styles[value] ?? {};
        }
    };
};
const $0de2139040a29c93$var$divideColor = (0, $01cafdac14948764$export$85907fd96ef7f08)("borderColor");
const $0de2139040a29c93$var$createTransition = (value)=>{
    return {
        transition: value,
        transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
        transitionDuration: "150ms"
    };
};
const $0de2139040a29c93$export$f5b80887c0320fb6 = (0, $ee2de6f250f65b79$export$d0de36da8d019bea)({
    hover: [
        "@media (hover: hover)",
        "&:is(:hover, [data-hover]):not(:disabled, [data-disabled])"
    ],
    active: "&:is(:active, [data-active]):not(:disabled, [data-disabled], [data-state=open])",
    focus: "&:is(:focus, [data-focus])",
    focusWithin: "&:is(:focus-within, [data-focus-within])",
    focusVisible: "&:is(:focus-visible, [data-focus-visible])",
    disabled: "&:is(:disabled, [disabled], [data-disabled], [aria-disabled=true])",
    visited: "&:visited",
    target: "&:target",
    readOnly: "&:is([data-readonly], [aria-readonly=true], [readonly])",
    readWrite: "&:read-write",
    empty: "&:is(:empty, [data-empty])",
    checked: "&:is(:checked, [data-checked], [aria-checked=true], [data-state=checked])",
    enabled: "&:enabled",
    expanded: "&:is([aria-expanded=true], [data-expanded], [data-state=expanded])",
    highlighted: "&[data-highlighted]",
    complete: "&[data-complete]",
    incomplete: "&[data-incomplete]",
    dragging: "&[data-dragging]",
    before: "&::before",
    after: "&::after",
    firstLetter: "&::first-letter",
    firstLine: "&::first-line",
    marker: "&::marker",
    selection: "&::selection",
    file: "&::file-selector-button",
    backdrop: "&::backdrop",
    first: "&:first-of-type",
    last: "&:last-of-type",
    notFirst: "&:not(:first-of-type)",
    notLast: "&:not(:last-of-type)",
    only: "&:only-child",
    even: "&:nth-of-type(even)",
    odd: "&:nth-of-type(odd)",
    peerFocus: ".peer:is(:focus, [data-focus]) ~ &",
    peerHover: ".peer:is(:hover, [data-hover]):not(:disabled, [data-disabled]) ~ &",
    peerActive: ".peer:is(:active, [data-active]):not(:disabled, [data-disabled]) ~ &",
    peerFocusWithin: ".peer:focus-within ~ &",
    peerFocusVisible: ".peer:is(:focus-visible, [data-focus-visible]) ~ &",
    peerDisabled: ".peer:is(:disabled, [disabled], [data-disabled]) ~ &",
    peerChecked: ".peer:is(:checked, [data-checked], [aria-checked=true], [data-state=checked]) ~ &",
    peerInvalid: ".peer:is(:invalid, [data-invalid], [aria-invalid=true]) ~ &",
    peerExpanded: ".peer:is([aria-expanded=true], [data-expanded], [data-state=expanded]) ~ &",
    peerPlaceholderShown: ".peer:placeholder-shown ~ &",
    groupFocus: ".group:is(:focus, [data-focus]) &",
    groupHover: ".group:is(:hover, [data-hover]):not(:disabled, [data-disabled]) &",
    groupActive: ".group:is(:active, [data-active]):not(:disabled, [data-disabled]) &",
    groupFocusWithin: ".group:focus-within &",
    groupFocusVisible: ".group:is(:focus-visible, [data-focus-visible]) &",
    groupDisabled: ".group:is(:disabled, [disabled], [data-disabled]) &",
    groupChecked: ".group:is(:checked, [data-checked], [aria-checked=true], [data-state=checked]) &",
    groupExpanded: ".group:is([aria-expanded=true], [data-expanded], [data-state=expanded]) &",
    groupInvalid: ".group:invalid &",
    indeterminate: "&:is(:indeterminate, [data-indeterminate], [aria-checked=mixed], [data-state=indeterminate])",
    required: "&:is([data-required], [aria-required=true])",
    valid: "&:is([data-valid], [data-state=valid])",
    invalid: "&:is([data-invalid], [aria-invalid=true], [data-state=invalid])",
    autofill: "&:autofill",
    inRange: "&:is(:in-range, [data-in-range])",
    outOfRange: "&:is(:out-of-range, [data-outside-range])",
    placeholder: "&::placeholder, &[data-placeholder]",
    placeholderShown: "&:is(:placeholder-shown, [data-placeholder-shown])",
    pressed: "&:is([aria-pressed=true], [data-pressed])",
    selected: "&:is([aria-selected=true], [data-selected])",
    grabbed: "&:is([aria-grabbed=true], [data-grabbed])",
    underValue: "&[data-state=under-value]",
    overValue: "&[data-state=over-value]",
    atValue: "&[data-state=at-value]",
    default: "&:default",
    optional: "&:optional",
    open: "&:is([open], [data-open], [data-state=open])",
    closed: "&:is([closed], [data-closed], [data-state=closed])",
    fullscreen: "&is(:fullscreen, [data-fullscreen])",
    loading: "&:is([data-loading], [aria-busy=true])",
    hidden: "&:is([hidden], [data-hidden])",
    current: "&[data-current]",
    currentPage: "&[aria-current=page]",
    currentStep: "&[aria-current=step]",
    today: "&[data-today]",
    unavailable: "&[data-unavailable]",
    rangeStart: "&[data-range-start]",
    rangeEnd: "&[data-range-end]",
    now: "&[data-now]",
    topmost: "&[data-topmost]",
    motionReduce: "@media (prefers-reduced-motion: reduce)",
    motionSafe: "@media (prefers-reduced-motion: no-preference)",
    print: "@media print",
    landscape: "@media (orientation: landscape)",
    portrait: "@media (orientation: portrait)",
    dark: ".dark &, .dark .chakra-theme:not(.light) &",
    light: ":root &, .light &",
    osDark: "@media (prefers-color-scheme: dark)",
    osLight: "@media (prefers-color-scheme: light)",
    highContrast: "@media (forced-colors: active)",
    lessContrast: "@media (prefers-contrast: less)",
    moreContrast: "@media (prefers-contrast: more)",
    ltr: "[dir=ltr] &",
    rtl: "[dir=rtl] &",
    scrollbar: "&::-webkit-scrollbar",
    scrollbarThumb: "&::-webkit-scrollbar-thumb",
    scrollbarTrack: "&::-webkit-scrollbar-track",
    horizontal: "&[data-orientation=horizontal]",
    vertical: "&[data-orientation=vertical]",
    icon: "& :where(svg)",
    starting: "@starting-style"
});
const $0de2139040a29c93$var$currentBgVar = (0, $fce16da9dfa1c130$export$8b4981022bd80a4e)("bg-currentcolor");
const $0de2139040a29c93$var$isCurrentBgVar = (value)=>value === $0de2139040a29c93$var$currentBgVar.ref || value === "currentBg";
const $0de2139040a29c93$var$colorValues = (theme)=>({
        ...theme("colors"),
        currentBg: $0de2139040a29c93$var$currentBgVar
    });
const $0de2139040a29c93$export$68b8fa3a393a40ba = (0, $ee2de6f250f65b79$export$9e20b617fd74b180)({
    conditions: $0de2139040a29c93$export$f5b80887c0320fb6,
    utilities: {
        // background
        background: {
            values: $0de2139040a29c93$var$colorValues,
            shorthand: [
                "bg"
            ],
            transform (value, args) {
                if ($0de2139040a29c93$var$isCurrentBgVar(args.raw)) return {
                    background: $0de2139040a29c93$var$currentBgVar.ref
                };
                const styleObj = (0, $01cafdac14948764$export$85907fd96ef7f08)("background")(value, args);
                return {
                    ...styleObj,
                    [$0de2139040a29c93$var$currentBgVar.var]: styleObj?.background
                };
            }
        },
        backgroundColor: {
            values: $0de2139040a29c93$var$colorValues,
            shorthand: [
                "bgColor"
            ],
            transform (value, args) {
                if ($0de2139040a29c93$var$isCurrentBgVar(args.raw)) return {
                    backgroundColor: $0de2139040a29c93$var$currentBgVar.ref
                };
                const styleObj = (0, $01cafdac14948764$export$85907fd96ef7f08)("backgroundColor")(value, args);
                return {
                    ...styleObj,
                    [$0de2139040a29c93$var$currentBgVar.var]: styleObj?.backgroundColor
                };
            }
        },
        backgroundSize: {
            shorthand: [
                "bgSize"
            ]
        },
        backgroundPosition: {
            shorthand: [
                "bgPos"
            ]
        },
        backgroundRepeat: {
            shorthand: [
                "bgRepeat"
            ]
        },
        backgroundAttachment: {
            shorthand: [
                "bgAttachment"
            ]
        },
        backgroundClip: {
            shorthand: [
                "bgClip"
            ],
            values: [
                "text"
            ],
            transform (value) {
                return value === "text" ? {
                    color: "transparent",
                    backgroundClip: "text"
                } : {
                    backgroundClip: value
                };
            }
        },
        backgroundGradient: {
            shorthand: [
                "bgGradient"
            ],
            values (theme) {
                return {
                    ...theme("gradients"),
                    "to-t": "linear-gradient(to top, var(--gradient))",
                    "to-tr": "linear-gradient(to top right, var(--gradient))",
                    "to-r": "linear-gradient(to right, var(--gradient))",
                    "to-br": "linear-gradient(to bottom right, var(--gradient))",
                    "to-b": "linear-gradient(to bottom, var(--gradient))",
                    "to-bl": "linear-gradient(to bottom left, var(--gradient))",
                    "to-l": "linear-gradient(to left, var(--gradient))",
                    "to-tl": "linear-gradient(to top left, var(--gradient))"
                };
            },
            transform (value) {
                return {
                    "--gradient-stops": "var(--gradient-from), var(--gradient-to)",
                    "--gradient": "var(--gradient-via-stops, var(--gradient-stops))",
                    backgroundImage: value
                };
            }
        },
        gradientFrom: {
            values: $0de2139040a29c93$var$colorValues,
            transform: (0, $01cafdac14948764$export$85907fd96ef7f08)("--gradient-from")
        },
        gradientTo: {
            values: $0de2139040a29c93$var$colorValues,
            transform: (0, $01cafdac14948764$export$85907fd96ef7f08)("--gradient-to")
        },
        gradientVia: {
            values: $0de2139040a29c93$var$colorValues,
            transform (value, args) {
                const styles = (0, $01cafdac14948764$export$85907fd96ef7f08)("--gradient-via")(value, args);
                return {
                    ...styles,
                    "--gradient-via-stops": "var(--gradient-from), var(--gradient-via), var(--gradient-to)"
                };
            }
        },
        backgroundImage: {
            values (theme) {
                return {
                    ...theme("gradients"),
                    ...theme("assets")
                };
            },
            shorthand: [
                "bgImg",
                "bgImage"
            ]
        },
        // border
        border: {
            values: "borders"
        },
        borderTop: {
            values: "borders"
        },
        borderLeft: {
            values: "borders"
        },
        borderBlockStart: {
            values: "borders"
        },
        borderRight: {
            values: "borders"
        },
        borderInlineEnd: {
            values: "borders"
        },
        borderBottom: {
            values: "borders"
        },
        borderBlockEnd: {
            values: "borders"
        },
        borderInlineStart: {
            values: "borders",
            shorthand: [
                "borderStart"
            ]
        },
        borderInline: {
            values: "borders",
            shorthand: [
                "borderX"
            ]
        },
        borderBlock: {
            values: "borders",
            shorthand: [
                "borderY"
            ]
        },
        // border colors
        borderColor: {
            values: $0de2139040a29c93$var$colorValues,
            transform: (0, $01cafdac14948764$export$85907fd96ef7f08)("borderColor")
        },
        borderTopColor: {
            values: $0de2139040a29c93$var$colorValues,
            transform: (0, $01cafdac14948764$export$85907fd96ef7f08)("borderTopColor")
        },
        borderBlockStartColor: {
            values: $0de2139040a29c93$var$colorValues,
            transform: (0, $01cafdac14948764$export$85907fd96ef7f08)("borderBlockStartColor")
        },
        borderBottomColor: {
            values: $0de2139040a29c93$var$colorValues,
            transform: (0, $01cafdac14948764$export$85907fd96ef7f08)("borderBottomColor")
        },
        borderBlockEndColor: {
            values: $0de2139040a29c93$var$colorValues,
            transform: (0, $01cafdac14948764$export$85907fd96ef7f08)("borderBlockEndColor")
        },
        borderLeftColor: {
            values: $0de2139040a29c93$var$colorValues,
            transform: (0, $01cafdac14948764$export$85907fd96ef7f08)("borderLeftColor")
        },
        borderInlineStartColor: {
            values: $0de2139040a29c93$var$colorValues,
            shorthand: [
                "borderStartColor"
            ],
            transform: (0, $01cafdac14948764$export$85907fd96ef7f08)("borderInlineStartColor")
        },
        borderRightColor: {
            values: $0de2139040a29c93$var$colorValues,
            transform: (0, $01cafdac14948764$export$85907fd96ef7f08)("borderRightColor")
        },
        borderInlineEndColor: {
            values: $0de2139040a29c93$var$colorValues,
            shorthand: [
                "borderEndColor"
            ],
            transform: (0, $01cafdac14948764$export$85907fd96ef7f08)("borderInlineEndColor")
        },
        // border styles
        borderStyle: {
            values: "borderStyles"
        },
        borderTopStyle: {
            values: "borderStyles"
        },
        borderBlockStartStyle: {
            values: "borderStyles"
        },
        borderBottomStyle: {
            values: "borderStyles"
        },
        borderBlockEndStyle: {
            values: "borderStyles"
        },
        borderInlineStartStyle: {
            values: "borderStyles",
            shorthand: [
                "borderStartStyle"
            ]
        },
        borderInlineEndStyle: {
            values: "borderStyles",
            shorthand: [
                "borderEndStyle"
            ]
        },
        borderLeftStyle: {
            values: "borderStyles"
        },
        borderRightStyle: {
            values: "borderStyles"
        },
        // border radius
        borderRadius: {
            values: "radii",
            shorthand: [
                "rounded"
            ]
        },
        borderTopLeftRadius: {
            values: "radii",
            shorthand: [
                "roundedTopLeft"
            ]
        },
        borderStartStartRadius: {
            values: "radii",
            shorthand: [
                "roundedStartStart",
                "borderTopStartRadius"
            ]
        },
        borderEndStartRadius: {
            values: "radii",
            shorthand: [
                "roundedEndStart",
                "borderBottomStartRadius"
            ]
        },
        borderTopRightRadius: {
            values: "radii",
            shorthand: [
                "roundedTopRight"
            ]
        },
        borderStartEndRadius: {
            values: "radii",
            shorthand: [
                "roundedStartEnd",
                "borderTopEndRadius"
            ]
        },
        borderEndEndRadius: {
            values: "radii",
            shorthand: [
                "roundedEndEnd",
                "borderBottomEndRadius"
            ]
        },
        borderBottomLeftRadius: {
            values: "radii",
            shorthand: [
                "roundedBottomLeft"
            ]
        },
        borderBottomRightRadius: {
            values: "radii",
            shorthand: [
                "roundedBottomRight"
            ]
        },
        borderInlineStartRadius: {
            values: "radii",
            property: "borderRadius",
            shorthand: [
                "roundedStart",
                "borderStartRadius"
            ],
            transform: (value)=>({
                    borderStartStartRadius: value,
                    borderEndStartRadius: value
                })
        },
        borderInlineEndRadius: {
            values: "radii",
            property: "borderRadius",
            shorthand: [
                "roundedEnd",
                "borderEndRadius"
            ],
            transform: (value)=>({
                    borderStartEndRadius: value,
                    borderEndEndRadius: value
                })
        },
        borderTopRadius: {
            values: "radii",
            property: "borderRadius",
            shorthand: [
                "roundedTop"
            ],
            transform: (value)=>({
                    borderTopLeftRadius: value,
                    borderTopRightRadius: value
                })
        },
        borderBottomRadius: {
            values: "radii",
            property: "borderRadius",
            shorthand: [
                "roundedBottom"
            ],
            transform: (value)=>({
                    borderBottomLeftRadius: value,
                    borderBottomRightRadius: value
                })
        },
        borderLeftRadius: {
            values: "radii",
            property: "borderRadius",
            shorthand: [
                "roundedLeft"
            ],
            transform: (value)=>({
                    borderTopLeftRadius: value,
                    borderBottomLeftRadius: value
                })
        },
        borderRightRadius: {
            values: "radii",
            property: "borderRadius",
            shorthand: [
                "roundedRight"
            ],
            transform: (value)=>({
                    borderTopRightRadius: value,
                    borderBottomRightRadius: value
                })
        },
        borderWidth: {
            values: "borderWidths"
        },
        borderBlockStartWidth: {
            values: "borderWidths"
        },
        borderTopWidth: {
            values: "borderWidths"
        },
        borderBottomWidth: {
            values: "borderWidths"
        },
        borderBlockEndWidth: {
            values: "borderWidths"
        },
        borderRightWidth: {
            values: "borderWidths"
        },
        borderInlineWidth: {
            values: "borderWidths",
            shorthand: [
                "borderXWidth"
            ]
        },
        borderInlineStartWidth: {
            values: "borderWidths",
            shorthand: [
                "borderStartWidth"
            ]
        },
        borderInlineEndWidth: {
            values: "borderWidths",
            shorthand: [
                "borderEndWidth"
            ]
        },
        borderLeftWidth: {
            values: "borderWidths"
        },
        borderBlockWidth: {
            values: "borderWidths",
            shorthand: [
                "borderYWidth"
            ]
        },
        // colors
        color: {
            values: $0de2139040a29c93$var$colorValues,
            transform: (0, $01cafdac14948764$export$85907fd96ef7f08)("color")
        },
        fill: {
            values: $0de2139040a29c93$var$colorValues,
            transform: (0, $01cafdac14948764$export$85907fd96ef7f08)("fill")
        },
        stroke: {
            values: $0de2139040a29c93$var$colorValues,
            transform: (0, $01cafdac14948764$export$85907fd96ef7f08)("stroke")
        },
        accentColor: {
            values: $0de2139040a29c93$var$colorValues,
            transform: (0, $01cafdac14948764$export$85907fd96ef7f08)("accentColor")
        },
        // divide
        divideX: {
            values: {
                type: "string"
            },
            transform (value) {
                return {
                    "& > :not(style, [hidden]) ~ :not(style, [hidden])": {
                        borderInlineStartWidth: value,
                        borderInlineEndWidth: "0px"
                    }
                };
            }
        },
        divideY: {
            values: {
                type: "string"
            },
            transform (value) {
                return {
                    "& > :not(style, [hidden]) ~ :not(style, [hidden])": {
                        borderTopWidth: value,
                        borderBottomWidth: "0px"
                    }
                };
            }
        },
        divideColor: {
            values: $0de2139040a29c93$var$colorValues,
            transform (value, args) {
                return {
                    "& > :not(style, [hidden]) ~ :not(style, [hidden])": $0de2139040a29c93$var$divideColor(value, args)
                };
            }
        },
        divideStyle: {
            property: "borderStyle",
            transform (value) {
                return {
                    "& > :not(style, [hidden]) ~ :not(style, [hidden])": {
                        borderStyle: value
                    }
                };
            }
        },
        // effects
        boxShadow: {
            values: "shadows",
            shorthand: [
                "shadow"
            ]
        },
        boxShadowColor: {
            values: $0de2139040a29c93$var$colorValues,
            transform: (0, $01cafdac14948764$export$85907fd96ef7f08)("--shadow-color"),
            shorthand: [
                "shadowColor"
            ]
        },
        mixBlendMode: {
            shorthand: [
                "blendMode"
            ]
        },
        backgroundBlendMode: {
            shorthand: [
                "bgBlendMode"
            ]
        },
        opacity: {
            values: "opacity"
        },
        // filters
        filter: {
            transform (v) {
                if (v !== "auto") return {
                    filter: v
                };
                return {
                    filter: `var(--blur) var(--brightness) var(--contrast) var(--grayscale) var(--hue-rotate) var(--invert) var(--saturate) var(--sepia) var(--drop-shadow)`
                };
            }
        },
        blur: {
            values: "blurs",
            transform: (v)=>({
                    "--blur": $0de2139040a29c93$var$wrap("blur", v)
                })
        },
        brightness: {
            transform: (v)=>({
                    "--brightness": $0de2139040a29c93$var$wrap("brightness", v)
                })
        },
        contrast: {
            transform: (v)=>({
                    "--contrast": $0de2139040a29c93$var$wrap("contrast", v)
                })
        },
        grayscale: {
            transform: (v)=>({
                    "--grayscale": $0de2139040a29c93$var$wrap("grayscale", v)
                })
        },
        hueRotate: {
            transform: (v)=>({
                    "--hue-rotate": $0de2139040a29c93$var$wrap("hue-rotate", $0de2139040a29c93$var$deg(v))
                })
        },
        invert: {
            transform: (v)=>({
                    "--invert": $0de2139040a29c93$var$wrap("invert", v)
                })
        },
        saturate: {
            transform: (v)=>({
                    "--saturate": $0de2139040a29c93$var$wrap("saturate", v)
                })
        },
        sepia: {
            transform: (v)=>({
                    "--sepia": $0de2139040a29c93$var$wrap("sepia", v)
                })
        },
        dropShadow: {
            transform: (v)=>({
                    "--drop-shadow": $0de2139040a29c93$var$wrap("drop-shadow", v)
                })
        },
        // backdrop filters
        backdropFilter: {
            transform (v) {
                if (v !== "auto") return {
                    backdropFilter: v
                };
                return {
                    backdropFilter: `var(--backdrop-blur) var(--backdrop-brightness) var(--backdrop-contrast) var(--backdrop-grayscale) var(--backdrop-hue-rotate) var(--backdrop-invert) var(--backdrop-opacity) var(--backdrop-saturate) var(--backdrop-sepia)`
                };
            }
        },
        backdropBlur: {
            values: "blurs",
            transform: (v)=>({
                    "--backdrop-blur": $0de2139040a29c93$var$wrap("blur", v)
                })
        },
        backdropBrightness: {
            transform: (v)=>({
                    "--backdrop-brightness": $0de2139040a29c93$var$wrap("brightness", v)
                })
        },
        backdropContrast: {
            transform: (v)=>({
                    "--backdrop-contrast": $0de2139040a29c93$var$wrap("contrast", v)
                })
        },
        backdropGrayscale: {
            transform: (v)=>({
                    "--backdrop-grayscale": $0de2139040a29c93$var$wrap("grayscale", v)
                })
        },
        backdropHueRotate: {
            transform: (v)=>({
                    "--backdrop-hue-rotate": $0de2139040a29c93$var$wrap("hue-rotate", $0de2139040a29c93$var$deg(v))
                })
        },
        backdropInvert: {
            transform: (v)=>({
                    "--backdrop-invert": $0de2139040a29c93$var$wrap("invert", v)
                })
        },
        backdropOpacity: {
            transform: (v)=>({
                    "--backdrop-opacity": $0de2139040a29c93$var$wrap("opacity", v)
                })
        },
        backdropSaturate: {
            transform: (v)=>({
                    "--backdrop-saturate": $0de2139040a29c93$var$wrap("saturate", v)
                })
        },
        backdropSepia: {
            transform: (v)=>({
                    "--backdrop-sepia": $0de2139040a29c93$var$wrap("sepia", v)
                })
        },
        // flexbox
        flexBasis: {
            values: "sizes"
        },
        gap: {
            values: "spacing"
        },
        rowGap: {
            values: "spacing",
            shorthand: [
                "gapY"
            ]
        },
        columnGap: {
            values: "spacing",
            shorthand: [
                "gapX"
            ]
        },
        flexDirection: {
            shorthand: [
                "flexDir"
            ]
        },
        // grid
        gridGap: {
            values: "spacing"
        },
        gridColumnGap: {
            values: "spacing"
        },
        gridRowGap: {
            values: "spacing"
        },
        // interactivity
        outlineColor: {
            values: $0de2139040a29c93$var$colorValues,
            transform: (0, $01cafdac14948764$export$85907fd96ef7f08)("outlineColor")
        },
        focusRing: $0de2139040a29c93$var$createFocusRing("&:is(:focus, [data-focus])"),
        focusVisibleRing: $0de2139040a29c93$var$createFocusRing("&:is(:focus-visible, [data-focus-visible])"),
        focusRingColor: {
            values: $0de2139040a29c93$var$colorValues,
            transform: (0, $01cafdac14948764$export$85907fd96ef7f08)("--focus-ring-color")
        },
        focusRingOffset: {
            values: "spacing",
            transform: (v)=>({
                    "--focus-ring-offset": v
                })
        },
        focusRingWidth: {
            values: "borderWidths",
            property: "outlineWidth",
            transform: (v)=>({
                    "--focus-ring-width": v
                })
        },
        focusRingStyle: {
            values: "borderStyles",
            property: "outlineStyle",
            transform: (v)=>({
                    "--focus-ring-style": v
                })
        },
        // layout
        aspectRatio: {
            values: "aspectRatios"
        },
        width: {
            values: "sizes",
            shorthand: [
                "w"
            ]
        },
        inlineSize: {
            values: "sizes"
        },
        height: {
            values: "sizes",
            shorthand: [
                "h"
            ]
        },
        blockSize: {
            values: "sizes"
        },
        boxSize: {
            values: "sizes",
            property: "width",
            transform: (v)=>({
                    width: v,
                    height: v
                })
        },
        minWidth: {
            values: "sizes",
            shorthand: [
                "minW"
            ]
        },
        minInlineSize: {
            values: "sizes"
        },
        minHeight: {
            values: "sizes",
            shorthand: [
                "minH"
            ]
        },
        minBlockSize: {
            values: "sizes"
        },
        maxWidth: {
            values: "sizes",
            shorthand: [
                "maxW"
            ]
        },
        maxInlineSize: {
            values: "sizes"
        },
        maxHeight: {
            values: "sizes",
            shorthand: [
                "maxH"
            ]
        },
        maxBlockSize: {
            values: "sizes"
        },
        hideFrom: {
            values: "breakpoints",
            //@ts-ignore
            transform: (value, { raw: raw, token: token })=>{
                const bp = token.raw(`breakpoints.${raw}`);
                const media = bp ? `@breakpoint ${raw}` : `@media screen and (min-width: ${value})`;
                return {
                    [media]: {
                        display: "none"
                    }
                };
            }
        },
        hideBelow: {
            values: "breakpoints",
            //@ts-ignore
            transform (value, { raw: raw, token: token }) {
                const bp = token.raw(`breakpoints.${raw}`);
                const media = bp ? `@breakpoint ${raw}Down` : `@media screen and (max-width: ${value})`;
                return {
                    [media]: {
                        display: "none"
                    }
                };
            }
        },
        // scroll
        overscrollBehavior: {
            shorthand: [
                "overscroll"
            ]
        },
        overscrollBehaviorX: {
            shorthand: [
                "overscrollX"
            ]
        },
        overscrollBehaviorY: {
            shorthand: [
                "overscrollY"
            ]
        },
        scrollbar: {
            values: [
                "visible",
                "hidden"
            ],
            transform (v) {
                switch(v){
                    case "visible":
                        return {
                            msOverflowStyle: "auto",
                            scrollbarWidth: "auto",
                            "&::-webkit-scrollbar": {
                                display: "block"
                            }
                        };
                    case "hidden":
                        return {
                            msOverflowStyle: "none",
                            scrollbarWidth: "none",
                            "&::-webkit-scrollbar": {
                                display: "none"
                            }
                        };
                    default:
                        return {};
                }
            }
        },
        scrollbarColor: {
            values: $0de2139040a29c93$var$colorValues,
            transform: (0, $01cafdac14948764$export$85907fd96ef7f08)("scrollbarColor")
        },
        scrollbarGutter: {
            values: "spacing"
        },
        scrollbarWidth: {
            values: "sizes"
        },
        // scroll margin
        scrollMargin: {
            values: "spacing"
        },
        scrollMarginTop: {
            values: "spacing"
        },
        scrollMarginBottom: {
            values: "spacing"
        },
        scrollMarginLeft: {
            values: "spacing"
        },
        scrollMarginRight: {
            values: "spacing"
        },
        scrollMarginX: {
            values: "spacing",
            transform: (v)=>({
                    scrollMarginLeft: v,
                    scrollMarginRight: v
                })
        },
        scrollMarginY: {
            values: "spacing",
            transform: (v)=>({
                    scrollMarginTop: v,
                    scrollMarginBottom: v
                })
        },
        // scroll padding
        scrollPadding: {
            values: "spacing"
        },
        scrollPaddingTop: {
            values: "spacing"
        },
        scrollPaddingBottom: {
            values: "spacing"
        },
        scrollPaddingLeft: {
            values: "spacing"
        },
        scrollPaddingRight: {
            values: "spacing"
        },
        scrollPaddingInline: {
            values: "spacing",
            shorthand: [
                "scrollPaddingX"
            ]
        },
        scrollPaddingBlock: {
            values: "spacing",
            shorthand: [
                "scrollPaddingY"
            ]
        },
        // scroll snap
        scrollSnapType: {
            values: {
                none: "none",
                x: "x var(--scroll-snap-strictness)",
                y: "y var(--scroll-snap-strictness)",
                both: "both var(--scroll-snap-strictness)"
            }
        },
        scrollSnapStrictness: {
            values: [
                "mandatory",
                "proximity"
            ],
            transform: (v)=>({
                    "--scroll-snap-strictness": v
                })
        },
        scrollSnapMargin: {
            values: "spacing"
        },
        scrollSnapMarginTop: {
            values: "spacing"
        },
        scrollSnapMarginBottom: {
            values: "spacing"
        },
        scrollSnapMarginLeft: {
            values: "spacing"
        },
        scrollSnapMarginRight: {
            values: "spacing"
        },
        // list
        listStylePosition: {
            shorthand: [
                "listStylePos"
            ]
        },
        listStyleImage: {
            values: "assets",
            shorthand: [
                "listStyleImg"
            ]
        },
        // position
        position: {
            shorthand: [
                "pos"
            ]
        },
        zIndex: {
            values: "zIndex"
        },
        inset: {
            values: "spacing"
        },
        insetInline: {
            values: "spacing",
            shorthand: [
                "insetX"
            ]
        },
        insetBlock: {
            values: "spacing",
            shorthand: [
                "insetY"
            ]
        },
        top: {
            values: "spacing"
        },
        insetBlockStart: {
            values: "spacing"
        },
        bottom: {
            values: "spacing"
        },
        insetBlockEnd: {
            values: "spacing"
        },
        left: {
            values: "spacing"
        },
        right: {
            values: "spacing"
        },
        insetInlineStart: {
            values: "spacing",
            shorthand: [
                "insetStart"
            ]
        },
        insetInlineEnd: {
            values: "spacing",
            shorthand: [
                "insetEnd"
            ]
        },
        // shadow / ring
        ring: {
            transform (value) {
                return {
                    "--ring-offset-shadow": `var(--ring-inset) 0 0 0 var(--ring-offset-width) var(--ring-offset-color)`,
                    "--ring-shadow": `var(--ring-inset) 0 0 0 calc(var(--ring-width) + var(--ring-offset-width)) var(--ring-color)`,
                    "--ring-width": value,
                    boxShadow: "var(--ring-offset-shadow), var(--ring-shadow), var(--shadow, 0 0 #0000)"
                };
            }
        },
        ringColor: {
            values: $0de2139040a29c93$var$colorValues,
            transform: (0, $01cafdac14948764$export$85907fd96ef7f08)("--ring-color")
        },
        ringOffset: {
            transform: (value)=>({
                    "--ring-offset-width": value
                })
        },
        ringOffsetColor: {
            values: $0de2139040a29c93$var$colorValues,
            transform: (0, $01cafdac14948764$export$85907fd96ef7f08)("--ring-offset-color")
        },
        ringInset: {
            transform: (v)=>({
                    "--ring-inset": v
                })
        },
        // margin
        margin: {
            values: "spacing",
            shorthand: [
                "m"
            ]
        },
        marginTop: {
            values: "spacing",
            shorthand: [
                "mt"
            ]
        },
        marginBlockStart: {
            values: "spacing",
            shorthand: [
                "mt"
            ]
        },
        marginRight: {
            values: "spacing",
            shorthand: [
                "mr"
            ]
        },
        marginBottom: {
            values: "spacing",
            shorthand: [
                "mb"
            ]
        },
        marginBlockEnd: {
            values: "spacing"
        },
        marginLeft: {
            values: "spacing",
            shorthand: [
                "ml"
            ]
        },
        marginInlineStart: {
            values: "spacing",
            shorthand: [
                "ms",
                "marginStart"
            ]
        },
        marginInlineEnd: {
            values: "spacing",
            shorthand: [
                "me",
                "marginEnd"
            ]
        },
        marginInline: {
            values: "spacing",
            shorthand: [
                "mx",
                "marginX"
            ]
        },
        marginBlock: {
            values: "spacing",
            shorthand: [
                "my",
                "marginY"
            ]
        },
        // padding
        padding: {
            values: "spacing",
            shorthand: [
                "p"
            ]
        },
        paddingTop: {
            values: "spacing",
            shorthand: [
                "pt"
            ]
        },
        paddingRight: {
            values: "spacing",
            shorthand: [
                "pr"
            ]
        },
        paddingBottom: {
            values: "spacing",
            shorthand: [
                "pb"
            ]
        },
        paddingBlockStart: {
            values: "spacing"
        },
        paddingBlockEnd: {
            values: "spacing"
        },
        paddingLeft: {
            values: "spacing",
            shorthand: [
                "pl"
            ]
        },
        paddingInlineStart: {
            values: "spacing",
            shorthand: [
                "ps",
                "paddingStart"
            ]
        },
        paddingInlineEnd: {
            values: "spacing",
            shorthand: [
                "pe",
                "paddingEnd"
            ]
        },
        paddingInline: {
            values: "spacing",
            shorthand: [
                "px",
                "paddingX"
            ]
        },
        paddingBlock: {
            values: "spacing",
            shorthand: [
                "py",
                "paddingY"
            ]
        },
        // text decoration
        textDecoration: {
            shorthand: [
                "textDecor"
            ]
        },
        textDecorationColor: {
            values: $0de2139040a29c93$var$colorValues,
            transform: (0, $01cafdac14948764$export$85907fd96ef7f08)("textDecorationColor")
        },
        textShadow: {
            values: "shadows"
        },
        // transform
        transform: {
            transform: (value)=>{
                let v = value;
                if (value === "auto") v = `translateX(var(--translate-x, 0)) translateY(var(--translate-y, 0)) rotate(var(--rotate, 0)) scaleX(var(--scale-x, 1)) scaleY(var(--scale-y, 1)) skewX(var(--skew-x, 0)) skewY(var(--skew-y, 0))`;
                if (value === "auto-gpu") v = `translate3d(var(--translate-x, 0), var(--translate-y, 0), 0) rotate(var(--rotate, 0)) scaleX(var(--scale-x, 1)) scaleY(var(--scale-y, 1)) skewX(var(--skew-x, 0)) skewY(var(--skew-y, 0))`;
                return {
                    transform: v
                };
            }
        },
        skewX: {
            transform: (v)=>({
                    "--skew-x": $0de2139040a29c93$var$deg(v)
                })
        },
        skewY: {
            transform: (v)=>({
                    "--skew-y": $0de2139040a29c93$var$deg(v)
                })
        },
        scaleX: {
            transform: (v)=>({
                    "--scale-x": v
                })
        },
        scaleY: {
            transform: (v)=>({
                    "--scale-y": v
                })
        },
        scale: {
            transform (value) {
                if (value !== "auto") return {
                    scale: value
                };
                return {
                    scale: `var(--scale-x, 1) var(--scale-y, 1)`
                };
            }
        },
        spaceXReverse: {
            values: {
                type: "boolean"
            },
            transform (value) {
                return {
                    "& > :not(style, [hidden]) ~ :not(style, [hidden])": {
                        "--space-x-reverse": value ? "1" : void 0
                    }
                };
            }
        },
        spaceX: {
            property: "marginInlineStart",
            values: "spacing",
            transform: (v)=>({
                    "& > :not(style, [hidden]) ~ :not(style, [hidden])": {
                        "--space-x-reverse": "0",
                        marginInlineStart: `calc(${v} * calc(1 - var(--space-x-reverse)))`,
                        marginInlineEnd: `calc(${v} * var(--space-x-reverse))`
                    }
                })
        },
        spaceYReverse: {
            values: {
                type: "boolean"
            },
            transform (value) {
                return {
                    "& > :not(style, [hidden]) ~ :not(style, [hidden])": {
                        "--space-y-reverse": value ? "1" : void 0
                    }
                };
            }
        },
        spaceY: {
            property: "marginTop",
            values: "spacing",
            transform: (v)=>({
                    "& > :not(style, [hidden]) ~ :not(style, [hidden])": {
                        "--space-y-reverse": "0",
                        marginTop: `calc(${v} * calc(1 - var(--space-y-reverse)))`,
                        marginBottom: `calc(${v} * var(--space-y-reverse))`
                    }
                })
        },
        rotate: {
            transform (value) {
                if (value !== "auto") return {
                    rotate: $0de2139040a29c93$var$deg(value)
                };
                return {
                    rotate: `var(--rotate-x, 0) var(--rotate-y, 0) var(--rotate-z, 0)`
                };
            }
        },
        rotateX: {
            transform (value) {
                return {
                    "--rotate-x": $0de2139040a29c93$var$deg(value)
                };
            }
        },
        rotateY: {
            transform (value) {
                return {
                    "--rotate-y": $0de2139040a29c93$var$deg(value)
                };
            }
        },
        // transform / translate
        translate: {
            transform (value) {
                if (value !== "auto") return {
                    translate: value
                };
                return {
                    translate: `var(--translate-x) var(--translate-y)`
                };
            }
        },
        translateX: {
            values: "spacing",
            transform: (v)=>({
                    "--translate-x": v
                })
        },
        translateY: {
            values: "spacing",
            transform: (v)=>({
                    "--translate-y": v
                })
        },
        // transition
        transition: {
            values: [
                "all",
                "common",
                "colors",
                "opacity",
                "position",
                "backgrounds",
                "size",
                "shadow",
                "transform"
            ],
            transform (value) {
                switch(value){
                    case "all":
                        return $0de2139040a29c93$var$createTransition("all");
                    case "position":
                        return $0de2139040a29c93$var$createTransition("left, right, top, bottom, inset-inline, inset-block");
                    case "colors":
                        return $0de2139040a29c93$var$createTransition("color, background-color, border-color, text-decoration-color, fill, stroke");
                    case "opacity":
                        return $0de2139040a29c93$var$createTransition("opacity");
                    case "shadow":
                        return $0de2139040a29c93$var$createTransition("box-shadow");
                    case "transform":
                        return $0de2139040a29c93$var$createTransition("transform");
                    case "size":
                        return $0de2139040a29c93$var$createTransition("width, height");
                    case "backgrounds":
                        return $0de2139040a29c93$var$createTransition("background, background-color, background-image, background-position");
                    case "common":
                        return $0de2139040a29c93$var$createTransition("color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter");
                    default:
                        return {
                            transition: value
                        };
                }
            }
        },
        transitionDuration: {
            values: "durations"
        },
        transitionProperty: {
            values: {
                common: "background-color, border-color, color, fill, stroke, opacity, box-shadow, translate, transform",
                colors: "background-color, border-color, color, fill, stroke",
                size: "width, height",
                position: "left, right, top, bottom, inset-inline, inset-block",
                background: "background, background-color, background-image, background-position"
            }
        },
        transitionTimingFunction: {
            values: "easings"
        },
        // animation
        animation: {
            values: "animations"
        },
        animationDuration: {
            values: "durations"
        },
        animationDelay: {
            values: "durations"
        },
        animationTimingFunction: {
            values: "easings"
        },
        // typography
        fontFamily: {
            values: "fonts"
        },
        fontSize: {
            values: "fontSizes"
        },
        fontWeight: {
            values: "fontWeights"
        },
        lineHeight: {
            values: "lineHeights"
        },
        letterSpacing: {
            values: "letterSpacings"
        },
        textIndent: {
            values: "spacing"
        },
        truncate: {
            values: {
                type: "boolean"
            },
            transform (value) {
                if (value === true) return {
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                };
                return {};
            }
        },
        lineClamp: {
            transform (value) {
                if (value === "none") return {
                    WebkitLineClamp: "unset"
                };
                return {
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitLineClamp: value,
                    WebkitBoxOrient: "vertical",
                    textWrap: "wrap"
                };
            }
        },
        // helpers
        srOnly: {
            values: {
                type: "boolean"
            },
            transform (value) {
                return $0de2139040a29c93$var$srMapping[value] || {};
            }
        },
        debug: {
            values: {
                type: "boolean"
            },
            transform (value) {
                if (!value) return {};
                return {
                    outline: "1px solid blue !important",
                    "& > *": {
                        outline: "1px solid red !important"
                    }
                };
            }
        },
        caretColor: {
            values: $0de2139040a29c93$var$colorValues,
            transform: (0, $01cafdac14948764$export$85907fd96ef7f08)("caretColor")
        },
        cursor: {
            values: "cursor"
        }
    }
});
const $0de2139040a29c93$var$srMapping = {
    true: {
        position: "absolute",
        width: "1px",
        height: "1px",
        padding: "0",
        margin: "-1px",
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        borderWidth: "0"
    },
    false: {
        position: "static",
        width: "auto",
        height: "auto",
        padding: "0",
        margin: "0",
        overflow: "visible",
        clip: "auto",
        whiteSpace: "normal"
    }
};





"use strict";
const $b948e4674d6fb783$export$d07517a676ce386f = {
    sm: "480px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
    "2xl": "1536px"
};



"use strict";
const $ee532e93ddb721f3$var$empty = "var(--chakra-empty,/*!*/ /*!*/)";
const $ee532e93ddb721f3$export$db53682eef82cc11 = (0, $ee2de6f250f65b79$export$22794656cac17ba4)({
    "*": {
        fontFeatureSettings: '"cv11"',
        "--ring-inset": $ee532e93ddb721f3$var$empty,
        "--ring-offset-width": "0px",
        "--ring-offset-color": "#fff",
        "--ring-color": "rgba(66, 153, 225, 0.6)",
        "--ring-offset-shadow": "0 0 #0000",
        "--ring-shadow": "0 0 #0000",
        ...Object.fromEntries([
            "brightness",
            "contrast",
            "grayscale",
            "hue-rotate",
            "invert",
            "saturate",
            "sepia",
            "drop-shadow"
        ].map((prop)=>[
                `--${prop}`,
                $ee532e93ddb721f3$var$empty
            ])),
        ...Object.fromEntries([
            "blur",
            "brightness",
            "contrast",
            "grayscale",
            "hue-rotate",
            "invert",
            "opacity",
            "saturate",
            "sepia"
        ].map((prop)=>[
                `--backdrop-${prop}`,
                $ee532e93ddb721f3$var$empty
            ])),
        "--global-font-mono": "fonts.mono",
        "--global-font-body": "fonts.body",
        "--global-color-border": "colors.border"
    },
    html: {
        color: "fg",
        bg: "bg",
        lineHeight: "1.5",
        colorPalette: "gray"
    },
    "*::placeholder": {
        color: "fg.muted/80"
    },
    "*::selection": {
        bg: "colorPalette.muted/80"
    }
});



"use strict";
const $905267d7480630f1$export$c5ce54c56ca9d603 = (0, $ee2de6f250f65b79$export$479138f860542d07)({
    // fill: some background color + color combination
    "fill.muted": {
        value: {
            background: "colorPalette.muted",
            color: "colorPalette.fg"
        }
    },
    "fill.subtle": {
        value: {
            background: "colorPalette.subtle",
            color: "colorPalette.fg"
        }
    },
    "fill.surface": {
        value: {
            background: "colorPalette.subtle",
            color: "colorPalette.fg",
            boxShadow: "0 0 0px 1px var(--shadow-color)",
            boxShadowColor: "colorPalette.muted"
        }
    },
    "fill.solid": {
        value: {
            background: "colorPalette.solid",
            color: "colorPalette.contrast"
        }
    },
    // outline: some border color + color combination
    "outline.subtle": {
        value: {
            color: "colorPalette.fg",
            boxShadow: "inset 0 0 0px 1px var(--shadow-color)",
            boxShadowColor: "colorPalette.subtle"
        }
    },
    "outline.solid": {
        value: {
            borderWidth: "1px",
            borderColor: "colorPalette.solid",
            color: "colorPalette.fg"
        }
    },
    // indicator: floating border color or left/bottom border
    "indicator.bottom": {
        value: {
            position: "relative",
            "--indicator-color-fallback": "colors.colorPalette.solid",
            _before: {
                content: `""`,
                position: "absolute",
                bottom: "var(--indicator-offset-y, 0)",
                insetInline: "var(--indicator-offset-x, 0)",
                height: "var(--indicator-thickness, 2px)",
                background: "var(--indicator-color, var(--indicator-color-fallback))"
            }
        }
    },
    "indicator.top": {
        value: {
            position: "relative",
            "--indicator-color-fallback": "colors.colorPalette.solid",
            _before: {
                content: `""`,
                position: "absolute",
                top: "var(--indicator-offset-y, 0)",
                insetInline: "var(--indicator-offset-x, 0)",
                height: "var(--indicator-thickness, 2px)",
                background: "var(--indicator-color, var(--indicator-color-fallback))"
            }
        }
    },
    "indicator.start": {
        value: {
            position: "relative",
            "--indicator-color-fallback": "colors.colorPalette.solid",
            _before: {
                content: `""`,
                position: "absolute",
                insetInlineStart: "var(--indicator-offset-x, 0)",
                insetBlock: "var(--indicator-offset-y, 0)",
                width: "var(--indicator-thickness, 2px)",
                background: "var(--indicator-color, var(--indicator-color-fallback))"
            }
        }
    },
    "indicator.end": {
        value: {
            position: "relative",
            "--indicator-color-fallback": "colors.colorPalette.solid",
            _before: {
                content: `""`,
                position: "absolute",
                insetInlineEnd: "var(--indicator-offset-x, 0)",
                insetBlock: "var(--indicator-offset-y, 0)",
                width: "var(--indicator-thickness, 2px)",
                background: "var(--indicator-color, var(--indicator-color-fallback))"
            }
        }
    },
    disabled: {
        value: {
            opacity: "0.5",
            cursor: "not-allowed"
        }
    },
    none: {
        value: {}
    }
});



"use strict";
const $8710b90ad96b7ca6$export$af3299cdb043c88c = (0, $ee2de6f250f65b79$export$cd834db0363565be)({
    "slide-fade-in": {
        value: {
            transformOrigin: "var(--transform-origin)",
            "&[data-placement^=top]": {
                animationName: "slide-from-bottom, fade-in"
            },
            "&[data-placement^=bottom]": {
                animationName: "slide-from-top, fade-in"
            },
            "&[data-placement^=left]": {
                animationName: "slide-from-right, fade-in"
            },
            "&[data-placement^=right]": {
                animationName: "slide-from-left, fade-in"
            }
        }
    },
    "slide-fade-out": {
        value: {
            transformOrigin: "var(--transform-origin)",
            "&[data-placement^=top]": {
                animationName: "slide-to-bottom, fade-out"
            },
            "&[data-placement^=bottom]": {
                animationName: "slide-to-top, fade-out"
            },
            "&[data-placement^=left]": {
                animationName: "slide-to-right, fade-out"
            },
            "&[data-placement^=right]": {
                animationName: "slide-to-left, fade-out"
            }
        }
    },
    "scale-fade-in": {
        value: {
            transformOrigin: "var(--transform-origin)",
            animationName: "scale-in, fade-in"
        }
    },
    "scale-fade-out": {
        value: {
            transformOrigin: "var(--transform-origin)",
            animationName: "scale-out, fade-out"
        }
    }
});



"use strict";
const $bbc9778f5da0d591$export$251a0a63b19d28c5 = (0, $ee2de6f250f65b79$export$9ab6f981e4119117)({
    className: "chakra-badge",
    base: {
        display: "inline-flex",
        alignItems: "center",
        borderRadius: "l2",
        gap: "1",
        fontWeight: "medium",
        fontVariantNumeric: "tabular-nums",
        whiteSpace: "nowrap",
        userSelect: "none"
    },
    variants: {
        variant: {
            solid: {
                bg: "colorPalette.solid",
                color: "colorPalette.contrast"
            },
            subtle: {
                bg: "colorPalette.subtle",
                color: "colorPalette.fg"
            },
            outline: {
                color: "colorPalette.fg",
                shadow: "inset 0 0 0px 1px var(--shadow-color)",
                shadowColor: "colorPalette.muted"
            },
            surface: {
                bg: "colorPalette.subtle",
                color: "colorPalette.fg",
                shadow: "inset 0 0 0px 1px var(--shadow-color)",
                shadowColor: "colorPalette.muted"
            },
            plain: {
                color: "colorPalette.fg"
            }
        },
        size: {
            xs: {
                textStyle: "2xs",
                px: "1",
                minH: "4"
            },
            sm: {
                textStyle: "xs",
                px: "1.5",
                minH: "5"
            },
            md: {
                textStyle: "sm",
                px: "2",
                minH: "6"
            },
            lg: {
                textStyle: "sm",
                px: "2.5",
                minH: "7"
            }
        }
    },
    defaultVariants: {
        variant: "subtle",
        size: "sm"
    }
});



"use strict";
const $31556f8aab29013b$export$8fcda06ebbc760ff = (0, $ee2de6f250f65b79$export$9ab6f981e4119117)({
    className: "chakra-button",
    base: {
        display: "inline-flex",
        appearance: "none",
        alignItems: "center",
        justifyContent: "center",
        userSelect: "none",
        position: "relative",
        borderRadius: "l2",
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        borderWidth: "1px",
        borderColor: "transparent",
        cursor: "button",
        flexShrink: "0",
        outline: "0",
        lineHeight: "1.2",
        isolation: "isolate",
        fontWeight: "medium",
        transitionProperty: "common",
        transitionDuration: "moderate",
        focusVisibleRing: "outside",
        _disabled: {
            layerStyle: "disabled"
        },
        _icon: {
            flexShrink: "0"
        }
    },
    variants: {
        size: {
            "2xs": {
                h: "6",
                minW: "6",
                textStyle: "xs",
                px: "2",
                gap: "1",
                _icon: {
                    width: "3.5",
                    height: "3.5"
                }
            },
            xs: {
                h: "8",
                minW: "8",
                textStyle: "xs",
                px: "2.5",
                gap: "1",
                _icon: {
                    width: "4",
                    height: "4"
                }
            },
            sm: {
                h: "9",
                minW: "9",
                px: "3.5",
                textStyle: "sm",
                gap: "2",
                _icon: {
                    width: "4",
                    height: "4"
                }
            },
            md: {
                h: "10",
                minW: "10",
                textStyle: "sm",
                px: "4",
                gap: "2",
                _icon: {
                    width: "5",
                    height: "5"
                }
            },
            lg: {
                h: "11",
                minW: "11",
                textStyle: "md",
                px: "5",
                gap: "3",
                _icon: {
                    width: "5",
                    height: "5"
                }
            },
            xl: {
                h: "12",
                minW: "12",
                textStyle: "md",
                px: "5",
                gap: "2.5",
                _icon: {
                    width: "5",
                    height: "5"
                }
            },
            "2xl": {
                h: "16",
                minW: "16",
                textStyle: "lg",
                px: "7",
                gap: "3",
                _icon: {
                    width: "6",
                    height: "6"
                }
            }
        },
        variant: {
            solid: {
                bg: "colorPalette.solid",
                color: "colorPalette.contrast",
                _hover: {
                    bg: "colorPalette.solid/90"
                },
                _expanded: {
                    bg: "colorPalette.solid/90"
                }
            },
            subtle: {
                bg: "colorPalette.subtle",
                color: "colorPalette.fg",
                _hover: {
                    bg: "colorPalette.muted"
                },
                _expanded: {
                    bg: "colorPalette.muted"
                }
            },
            surface: {
                bg: "colorPalette.subtle",
                color: "colorPalette.fg",
                shadow: "0 0 0px 1px var(--shadow-color)",
                shadowColor: "colorPalette.muted",
                _hover: {
                    bg: "colorPalette.muted"
                },
                _expanded: {
                    bg: "colorPalette.muted"
                }
            },
            outline: {
                borderWidth: "1px",
                borderColor: "colorPalette.muted",
                color: "colorPalette.fg",
                _hover: {
                    bg: "colorPalette.subtle"
                },
                _expanded: {
                    bg: "colorPalette.subtle"
                }
            },
            ghost: {
                color: "colorPalette.fg",
                _hover: {
                    bg: "colorPalette.subtle"
                },
                _expanded: {
                    bg: "colorPalette.subtle"
                }
            },
            plain: {
                color: "colorPalette.fg"
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "solid"
    }
});



"use strict";
const $85d8300c74ba233f$export$ecb1dc0d32e8f247 = (0, $ee2de6f250f65b79$export$9ab6f981e4119117)({
    className: "chakra-checkmark",
    base: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: "0",
        color: "white",
        borderWidth: "1px",
        borderColor: "transparent",
        borderRadius: "l1",
        focusVisibleRing: "outside",
        _icon: {
            boxSize: "full"
        },
        _invalid: {
            colorPalette: "red",
            borderColor: "border.error"
        },
        _disabled: {
            opacity: "0.5"
        }
    },
    variants: {
        size: {
            xs: {
                boxSize: "3"
            },
            sm: {
                boxSize: "4"
            },
            md: {
                boxSize: "5",
                p: "0.5"
            },
            lg: {
                boxSize: "6",
                p: "0.5"
            }
        },
        variant: {
            solid: {
                borderColor: "border",
                "&:is([data-state=checked], [data-state=indeterminate])": {
                    bg: "colorPalette.solid",
                    color: "colorPalette.contrast",
                    borderColor: "colorPalette.solid"
                }
            },
            outline: {
                borderColor: "border",
                "&:is([data-state=checked], [data-state=indeterminate])": {
                    color: "colorPalette.fg",
                    borderColor: "colorPalette.solid"
                }
            },
            subtle: {
                bg: "colorPalette.muted",
                borderColor: "colorPalette.muted",
                "&:is([data-state=checked], [data-state=indeterminate])": {
                    color: "colorPalette.fg"
                }
            },
            plain: {
                "&:is([data-state=checked], [data-state=indeterminate])": {
                    color: "colorPalette.fg"
                }
            },
            inverted: {
                borderColor: "border",
                color: "colorPalette.fg",
                "&:is([data-state=checked], [data-state=indeterminate])": {
                    borderColor: "colorPalette.solid"
                }
            }
        }
    },
    defaultVariants: {
        variant: "solid",
        size: "md"
    }
});




"use strict";
const { variants: $16252efb9ed960e9$var$variants, defaultVariants: $16252efb9ed960e9$var$defaultVariants } = (0, $bbc9778f5da0d591$export$251a0a63b19d28c5);
const $16252efb9ed960e9$export$7565e651dd12f58c = (0, $ee2de6f250f65b79$export$9ab6f981e4119117)({
    className: "chakra-code",
    base: {
        fontFamily: "mono",
        alignItems: "center",
        display: "inline-flex",
        borderRadius: "l2"
    },
    variants: $16252efb9ed960e9$var$variants,
    defaultVariants: $16252efb9ed960e9$var$defaultVariants
});



"use strict";
const $b905f70517d44150$export$9822f4e3dd6bcc87 = (0, $ee2de6f250f65b79$export$9ab6f981e4119117)({
    className: "color-swatch",
    base: {
        boxSize: "var(--swatch-size)",
        shadow: "inset 0 0 0 1px rgba(0, 0, 0, 0.1)",
        "--checker-size": "8px",
        "--checker-bg": "colors.bg",
        "--checker-fg": "colors.bg.emphasized",
        background: "linear-gradient(var(--color), var(--color)), repeating-conic-gradient(var(--checker-fg) 0%, var(--checker-fg) 25%, var(--checker-bg) 0%, var(--checker-bg) 50%) 0% 50% / var(--checker-size) var(--checker-size) !important",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: "0"
    },
    variants: {
        size: {
            "2xs": {
                "--swatch-size": "sizes.3.5"
            },
            xs: {
                "--swatch-size": "sizes.4"
            },
            sm: {
                "--swatch-size": "sizes.4.5"
            },
            md: {
                "--swatch-size": "sizes.5"
            },
            lg: {
                "--swatch-size": "sizes.6"
            },
            xl: {
                "--swatch-size": "sizes.7"
            },
            "2xl": {
                "--swatch-size": "sizes.8"
            },
            inherit: {
                "--swatch-size": "inherit"
            },
            full: {
                "--swatch-size": "100%"
            }
        },
        shape: {
            square: {
                borderRadius: "none"
            },
            circle: {
                borderRadius: "full"
            },
            rounded: {
                borderRadius: "l1"
            }
        }
    },
    defaultVariants: {
        size: "md",
        shape: "rounded"
    }
});



"use strict";
const $449f86be10b51e4e$export$313800c084e919bf = (0, $ee2de6f250f65b79$export$9ab6f981e4119117)({
    className: "chakra-container",
    base: {
        position: "relative",
        maxWidth: "8xl",
        w: "100%",
        mx: "auto",
        px: {
            base: "4",
            md: "6",
            lg: "8"
        }
    },
    variants: {
        centerContent: {
            true: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
            }
        },
        fluid: {
            true: {
                maxWidth: "full"
            }
        }
    }
});



"use strict";
const $a155353a7bb345c6$export$74fda8a22e7f4a14 = (0, $ee2de6f250f65b79$export$9ab6f981e4119117)({
    className: "chakra-heading",
    base: {
        fontFamily: "heading",
        fontWeight: "semibold"
    },
    variants: {
        size: {
            xs: {
                textStyle: "xs"
            },
            sm: {
                textStyle: "sm"
            },
            md: {
                textStyle: "md"
            },
            lg: {
                textStyle: "lg"
            },
            xl: {
                textStyle: "xl"
            },
            "2xl": {
                textStyle: "2xl"
            },
            "3xl": {
                textStyle: "3xl"
            },
            "4xl": {
                textStyle: "4xl"
            },
            "5xl": {
                textStyle: "5xl"
            },
            "6xl": {
                textStyle: "6xl"
            },
            "7xl": {
                textStyle: "7xl"
            }
        }
    },
    defaultVariants: {
        size: "xl"
    }
});



"use strict";
const $f81c961adc66881d$export$74f38ee0e7bd4336 = (0, $ee2de6f250f65b79$export$9ab6f981e4119117)({
    className: "chakra-icon",
    base: {
        display: "inline-block",
        lineHeight: "1em",
        flexShrink: "0",
        color: "currentcolor",
        verticalAlign: "middle"
    },
    variants: {
        size: {
            inherit: {},
            xs: {
                boxSize: "3"
            },
            sm: {
                boxSize: "4"
            },
            md: {
                boxSize: "5"
            },
            lg: {
                boxSize: "6"
            },
            xl: {
                boxSize: "7"
            },
            "2xl": {
                boxSize: "8"
            }
        }
    },
    defaultVariants: {
        size: "inherit"
    }
});



"use strict";
const $074665036d2ed9fc$export$a6445e005c28dca2 = (0, $ee2de6f250f65b79$export$9ab6f981e4119117)({
    className: "chakra-input",
    base: {
        width: "100%",
        minWidth: "0",
        outline: "0",
        position: "relative",
        appearance: "none",
        textAlign: "start",
        borderRadius: "l2",
        _disabled: {
            layerStyle: "disabled"
        },
        height: "var(--input-height)",
        minW: "var(--input-height)",
        "--focus-color": "colors.colorPalette.focusRing",
        "--error-color": "colors.border.error",
        _invalid: {
            focusRingColor: "var(--error-color)",
            borderColor: "var(--error-color)"
        }
    },
    variants: {
        size: {
            "2xs": {
                textStyle: "xs",
                px: "2",
                "--input-height": "sizes.7"
            },
            xs: {
                textStyle: "xs",
                px: "2",
                "--input-height": "sizes.8"
            },
            sm: {
                textStyle: "sm",
                px: "2.5",
                "--input-height": "sizes.9"
            },
            md: {
                textStyle: "sm",
                px: "3",
                "--input-height": "sizes.10"
            },
            lg: {
                textStyle: "md",
                px: "4",
                "--input-height": "sizes.11"
            },
            xl: {
                textStyle: "md",
                px: "4.5",
                "--input-height": "sizes.12"
            },
            "2xl": {
                textStyle: "lg",
                px: "5",
                "--input-height": "sizes.16"
            }
        },
        variant: {
            outline: {
                bg: "transparent",
                borderWidth: "1px",
                borderColor: "border",
                focusVisibleRing: "inside"
            },
            subtle: {
                borderWidth: "1px",
                borderColor: "transparent",
                bg: "bg.muted",
                focusVisibleRing: "inside"
            },
            flushed: {
                bg: "transparent",
                borderBottomWidth: "1px",
                borderBottomColor: "border",
                borderRadius: "0",
                px: "0",
                _focusVisible: {
                    borderColor: "var(--focus-color)",
                    boxShadow: "0px 1px 0px 0px var(--focus-color)"
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "outline"
    }
});




"use strict";
const $1983173604bc6faf$export$5d8e524bc3a2e698 = (0, $ee2de6f250f65b79$export$9ab6f981e4119117)({
    className: "chakra-input-addon",
    base: {
        flex: "0 0 auto",
        width: "auto",
        display: "flex",
        alignItems: "center",
        whiteSpace: "nowrap",
        alignSelf: "stretch",
        borderRadius: "l2"
    },
    variants: {
        size: (0, $074665036d2ed9fc$export$a6445e005c28dca2).variants.size,
        variant: {
            outline: {
                borderWidth: "1px",
                borderColor: "border",
                bg: "bg.muted"
            },
            subtle: {
                borderWidth: "1px",
                borderColor: "transparent",
                bg: "bg.emphasized"
            },
            flushed: {
                borderBottom: "1px solid",
                borderColor: "inherit",
                borderRadius: "0",
                px: "0",
                bg: "transparent"
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "outline"
    }
});



"use strict";
const $d3c1aa3a2671fcd6$export$d0e46897d672167b = (0, $ee2de6f250f65b79$export$9ab6f981e4119117)({
    className: "chakra-kbd",
    base: {
        display: "inline-flex",
        alignItems: "center",
        fontWeight: "medium",
        fontFamily: "mono",
        flexShrink: "0",
        whiteSpace: "nowrap",
        wordSpacing: "-0.5em",
        userSelect: "none",
        px: "1",
        borderRadius: "l2"
    },
    variants: {
        variant: {
            raised: {
                bg: "colorPalette.subtle",
                color: "colorPalette.fg",
                borderWidth: "1px",
                borderBottomWidth: "2px",
                borderColor: "colorPalette.muted"
            },
            outline: {
                borderWidth: "1px",
                color: "colorPalette.fg"
            },
            subtle: {
                bg: "colorPalette.muted",
                color: "colorPalette.fg"
            },
            plain: {
                color: "colorPalette.fg"
            }
        },
        size: {
            sm: {
                textStyle: "xs",
                height: "4.5"
            },
            md: {
                textStyle: "sm",
                height: "5"
            },
            lg: {
                textStyle: "md",
                height: "6"
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "raised"
    }
});



"use strict";
const $4e8ffe8b04cc67dc$export$ffc13cc0f7c8dd4f = (0, $ee2de6f250f65b79$export$9ab6f981e4119117)({
    className: "chakra-link",
    base: {
        display: "inline-flex",
        alignItems: "center",
        outline: "none",
        gap: "1.5",
        cursor: "pointer",
        borderRadius: "l1",
        focusRing: "outside"
    },
    variants: {
        variant: {
            underline: {
                color: "colorPalette.fg",
                textDecoration: "underline",
                textUnderlineOffset: "3px",
                textDecorationColor: "currentColor/20"
            },
            plain: {
                color: "colorPalette.fg",
                _hover: {
                    textDecoration: "underline",
                    textUnderlineOffset: "3px",
                    textDecorationColor: "currentColor/20"
                }
            }
        }
    },
    defaultVariants: {
        variant: "plain"
    }
});



"use strict";
const $17f1f3031fa2045f$export$348c05df4991a167 = (0, $ee2de6f250f65b79$export$9ab6f981e4119117)({
    className: "chakra-mark",
    base: {
        bg: "transparent",
        color: "inherit",
        whiteSpace: "nowrap"
    },
    variants: {
        variant: {
            subtle: {
                bg: "colorPalette.subtle",
                color: "inherit"
            },
            solid: {
                bg: "colorPalette.solid",
                color: "colorPalette.contrast"
            },
            text: {
                fontWeight: "medium"
            },
            plain: {}
        }
    }
});



"use strict";
const $4eca34b97189bf98$export$f073ddc07274fbb0 = (0, $ee2de6f250f65b79$export$9ab6f981e4119117)({
    className: "chakra-radiomark",
    base: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        verticalAlign: "top",
        color: "white",
        borderWidth: "1px",
        borderColor: "transparent",
        borderRadius: "full",
        cursor: "radio",
        _focusVisible: {
            outline: "2px solid",
            outlineColor: "colorPalette.focusRing",
            outlineOffset: "2px"
        },
        _invalid: {
            colorPalette: "red",
            borderColor: "red.500"
        },
        _disabled: {
            opacity: "0.5",
            cursor: "disabled"
        },
        "& .dot": {
            height: "100%",
            width: "100%",
            borderRadius: "full",
            bg: "currentColor",
            scale: "0.4"
        }
    },
    variants: {
        variant: {
            solid: {
                borderWidth: "1px",
                borderColor: "border",
                _checked: {
                    bg: "colorPalette.solid",
                    color: "colorPalette.contrast",
                    borderColor: "colorPalette.solid"
                }
            },
            subtle: {
                borderWidth: "1px",
                bg: "colorPalette.muted",
                borderColor: "colorPalette.muted",
                color: "transparent",
                _checked: {
                    color: "colorPalette.fg"
                }
            },
            outline: {
                borderWidth: "1px",
                borderColor: "inherit",
                _checked: {
                    color: "colorPalette.fg",
                    borderColor: "colorPalette.solid"
                },
                "& .dot": {
                    scale: "0.6"
                }
            },
            inverted: {
                bg: "bg",
                borderWidth: "1px",
                borderColor: "inherit",
                _checked: {
                    color: "colorPalette.solid",
                    borderColor: "currentcolor"
                }
            }
        },
        size: {
            xs: {
                boxSize: "3"
            },
            sm: {
                boxSize: "4"
            },
            md: {
                boxSize: "5"
            },
            lg: {
                boxSize: "6"
            }
        }
    },
    defaultVariants: {
        variant: "solid",
        size: "md"
    }
});



"use strict";
const $8ee60cd492b9e7d1$export$4e3a2e764d3c1b3c = (0, $ee2de6f250f65b79$export$9ab6f981e4119117)({
    className: "chakra-separator",
    base: {
        display: "block",
        borderColor: "border"
    },
    variants: {
        variant: {
            solid: {
                borderStyle: "solid"
            },
            dashed: {
                borderStyle: "dashed"
            },
            dotted: {
                borderStyle: "dotted"
            }
        },
        orientation: {
            vertical: {
                borderInlineStartWidth: "var(--separator-thickness)"
            },
            horizontal: {
                borderTopWidth: "var(--separator-thickness)"
            }
        },
        size: {
            xs: {
                "--separator-thickness": "0.5px"
            },
            sm: {
                "--separator-thickness": "1px"
            },
            md: {
                "--separator-thickness": "2px"
            },
            lg: {
                "--separator-thickness": "3px"
            }
        }
    },
    defaultVariants: {
        size: "sm",
        variant: "solid",
        orientation: "horizontal"
    }
});



"use strict";
const $a7345e0fd45d6bc1$export$bc76d6a8a834270c = (0, $ee2de6f250f65b79$export$9ab6f981e4119117)({
    className: "chakra-skeleton",
    base: {},
    variants: {
        loading: {
            true: {
                borderRadius: "l2",
                boxShadow: "none",
                backgroundClip: "padding-box",
                cursor: "default",
                color: "transparent",
                pointerEvents: "none",
                userSelect: "none",
                flexShrink: "0",
                "&::before, &::after, *": {
                    visibility: "hidden"
                }
            },
            false: {
                background: "unset",
                animation: "fade-in var(--fade-duration, 0.1s) ease-out !important"
            }
        },
        variant: {
            pulse: {
                background: "bg.emphasized",
                animation: "pulse",
                animationDuration: "var(--duration, 1.2s)"
            },
            shine: {
                "--animate-from": "200%",
                "--animate-to": "-200%",
                "--start-color": "colors.bg.muted",
                "--end-color": "colors.bg.emphasized",
                backgroundImage: "linear-gradient(270deg,var(--start-color),var(--end-color),var(--end-color),var(--start-color))",
                backgroundSize: "400% 100%",
                animation: "bg-position var(--duration, 5s) ease-in-out infinite"
            },
            none: {
                animation: "none"
            }
        }
    },
    defaultVariants: {
        variant: "pulse",
        loading: true
    }
});



"use strict";
const $fadf61ef3c3b48aa$export$380c51a04360915a = (0, $ee2de6f250f65b79$export$9ab6f981e4119117)({
    className: "chakra-skip-nav",
    base: {
        display: "inline-flex",
        bg: "bg.panel",
        padding: "2.5",
        borderRadius: "l2",
        fontWeight: "semibold",
        focusVisibleRing: "outside",
        textStyle: "sm",
        // visually hidden
        userSelect: "none",
        border: "0",
        height: "1px",
        width: "1px",
        margin: "-1px",
        outline: "0",
        overflow: "hidden",
        position: "absolute",
        clip: "rect(0 0 0 0)",
        _focusVisible: {
            clip: "auto",
            width: "auto",
            height: "auto",
            position: "fixed",
            top: "6",
            insetStart: "6"
        }
    }
});



"use strict";
const $bfcd54da6fd498f5$export$c8e083fecedf753b = (0, $ee2de6f250f65b79$export$9ab6f981e4119117)({
    className: "chakra-spinner",
    base: {
        display: "inline-block",
        borderColor: "currentColor",
        borderStyle: "solid",
        borderWidth: "2px",
        borderRadius: "full",
        width: "var(--spinner-size)",
        height: "var(--spinner-size)",
        animation: "spin",
        animationDuration: "slowest",
        "--spinner-track-color": "transparent",
        borderBottomColor: "var(--spinner-track-color)",
        borderInlineStartColor: "var(--spinner-track-color)"
    },
    variants: {
        size: {
            inherit: {
                "--spinner-size": "1em"
            },
            xs: {
                "--spinner-size": "sizes.3"
            },
            sm: {
                "--spinner-size": "sizes.4"
            },
            md: {
                "--spinner-size": "sizes.5"
            },
            lg: {
                "--spinner-size": "sizes.8"
            },
            xl: {
                "--spinner-size": "sizes.10"
            }
        }
    },
    defaultVariants: {
        size: "md"
    }
});



"use strict";
const $9a5f452f95977291$export$986b82e7411f2367 = (0, $ee2de6f250f65b79$export$9ab6f981e4119117)({
    className: "chakra-textarea",
    base: {
        width: "100%",
        minWidth: "0",
        outline: "0",
        position: "relative",
        appearance: "none",
        textAlign: "start",
        borderRadius: "l2",
        _disabled: {
            layerStyle: "disabled"
        },
        "--focus-color": "colors.colorPalette.focusRing",
        "--error-color": "colors.border.error",
        _invalid: {
            focusRingColor: "var(--error-color)",
            borderColor: "var(--error-color)"
        }
    },
    variants: {
        size: {
            xs: {
                textStyle: "xs",
                px: "2",
                py: "1.5",
                scrollPaddingBottom: "1.5"
            },
            sm: {
                textStyle: "sm",
                px: "2.5",
                py: "2",
                scrollPaddingBottom: "2"
            },
            md: {
                textStyle: "sm",
                px: "3",
                py: "2",
                scrollPaddingBottom: "2"
            },
            lg: {
                textStyle: "md",
                px: "4",
                py: "3",
                scrollPaddingBottom: "3"
            },
            xl: {
                textStyle: "md",
                px: "4.5",
                py: "3.5",
                scrollPaddingBottom: "3.5"
            }
        },
        variant: {
            outline: {
                bg: "transparent",
                borderWidth: "1px",
                borderColor: "border",
                focusVisibleRing: "inside"
            },
            subtle: {
                borderWidth: "1px",
                borderColor: "transparent",
                bg: "bg.muted",
                focusVisibleRing: "inside"
            },
            flushed: {
                bg: "transparent",
                borderBottomWidth: "1px",
                borderBottomColor: "border",
                borderRadius: "0",
                px: "0",
                _focusVisible: {
                    borderColor: "var(--focus-color)",
                    boxShadow: "0px 1px 0px 0px var(--focus-color)"
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "outline"
    }
});


"use strict";
const $47ee297e29ad652e$export$fa74c78a0037e9df = {
    badge: (0, $bbc9778f5da0d591$export$251a0a63b19d28c5),
    button: (0, $31556f8aab29013b$export$8fcda06ebbc760ff),
    code: (0, $16252efb9ed960e9$export$7565e651dd12f58c),
    container: (0, $449f86be10b51e4e$export$313800c084e919bf),
    heading: (0, $a155353a7bb345c6$export$74fda8a22e7f4a14),
    input: (0, $074665036d2ed9fc$export$a6445e005c28dca2),
    inputAddon: (0, $1983173604bc6faf$export$5d8e524bc3a2e698),
    kbd: (0, $d3c1aa3a2671fcd6$export$d0e46897d672167b),
    link: (0, $4e8ffe8b04cc67dc$export$ffc13cc0f7c8dd4f),
    mark: (0, $17f1f3031fa2045f$export$348c05df4991a167),
    separator: (0, $8ee60cd492b9e7d1$export$4e3a2e764d3c1b3c),
    skeleton: (0, $a7345e0fd45d6bc1$export$bc76d6a8a834270c),
    skipNavLink: (0, $fadf61ef3c3b48aa$export$380c51a04360915a),
    spinner: (0, $bfcd54da6fd498f5$export$c8e083fecedf753b),
    textarea: (0, $9a5f452f95977291$export$986b82e7411f2367),
    icon: (0, $f81c961adc66881d$export$74f38ee0e7bd4336),
    checkmark: (0, $85d8300c74ba233f$export$ecb1dc0d32e8f247),
    radiomark: (0, $4eca34b97189bf98$export$f073ddc07274fbb0),
    colorSwatch: (0, $b905f70517d44150$export$9822f4e3dd6bcc87)
};



"use strict";
const $de3e683eef03515f$export$bba894c3986a1bd6 = (0, $ee2de6f250f65b79$export$97e094f42fbe07cb).colors({
    bg: {
        DEFAULT: {
            value: {
                _light: "{colors.white}",
                _dark: "{colors.black}"
            }
        },
        subtle: {
            value: {
                _light: "{colors.gray.50}",
                _dark: "{colors.gray.950}"
            }
        },
        muted: {
            value: {
                _light: "{colors.gray.100}",
                _dark: "{colors.gray.900}"
            }
        },
        emphasized: {
            value: {
                _light: "{colors.gray.200}",
                _dark: "{colors.gray.800}"
            }
        },
        inverted: {
            value: {
                _light: "{colors.black}",
                _dark: "{colors.white}"
            }
        },
        panel: {
            value: {
                _light: "{colors.white}",
                _dark: "{colors.gray.950}"
            }
        },
        error: {
            value: {
                _light: "{colors.red.50}",
                _dark: "{colors.red.950}"
            }
        },
        warning: {
            value: {
                _light: "{colors.orange.50}",
                _dark: "{colors.orange.950}"
            }
        },
        success: {
            value: {
                _light: "{colors.green.50}",
                _dark: "{colors.green.950}"
            }
        },
        info: {
            value: {
                _light: "{colors.blue.50}",
                _dark: "{colors.blue.950}"
            }
        }
    },
    fg: {
        DEFAULT: {
            value: {
                _light: "{colors.black}",
                _dark: "{colors.gray.50}"
            }
        },
        muted: {
            value: {
                _light: "{colors.gray.600}",
                _dark: "{colors.gray.400}"
            }
        },
        subtle: {
            value: {
                _light: "{colors.gray.400}",
                _dark: "{colors.gray.500}"
            }
        },
        inverted: {
            value: {
                _light: "{colors.gray.50}",
                _dark: "{colors.black}"
            }
        },
        error: {
            value: {
                _light: "{colors.red.500}",
                _dark: "{colors.red.400}"
            }
        },
        warning: {
            value: {
                _light: "{colors.orange.600}",
                _dark: "{colors.orange.300}"
            }
        },
        success: {
            value: {
                _light: "{colors.green.600}",
                _dark: "{colors.green.300}"
            }
        },
        info: {
            value: {
                _light: "{colors.blue.600}",
                _dark: "{colors.blue.300}"
            }
        }
    },
    border: {
        DEFAULT: {
            value: {
                _light: "{colors.gray.200}",
                _dark: "{colors.gray.800}"
            }
        },
        muted: {
            value: {
                _light: "{colors.gray.100}",
                _dark: "{colors.gray.900}"
            }
        },
        subtle: {
            value: {
                _light: "{colors.gray.50}",
                _dark: "{colors.gray.950}"
            }
        },
        emphasized: {
            value: {
                _light: "{colors.gray.300}",
                _dark: "{colors.gray.700}"
            }
        },
        inverted: {
            value: {
                _light: "{colors.gray.800}",
                _dark: "{colors.gray.200}"
            }
        },
        error: {
            value: {
                _light: "{colors.red.500}",
                _dark: "{colors.red.400}"
            }
        },
        warning: {
            value: {
                _light: "{colors.orange.500}",
                _dark: "{colors.orange.400}"
            }
        },
        success: {
            value: {
                _light: "{colors.green.500}",
                _dark: "{colors.green.400}"
            }
        },
        info: {
            value: {
                _light: "{colors.blue.500}",
                _dark: "{colors.blue.400}"
            }
        }
    },
    gray: {
        contrast: {
            value: {
                _light: "{colors.white}",
                _dark: "{colors.black}"
            }
        },
        fg: {
            value: {
                _light: "{colors.gray.800}",
                _dark: "{colors.gray.200}"
            }
        },
        subtle: {
            value: {
                _light: "{colors.gray.100}",
                _dark: "{colors.gray.900}"
            }
        },
        muted: {
            value: {
                _light: "{colors.gray.200}",
                _dark: "{colors.gray.800}"
            }
        },
        emphasized: {
            value: {
                _light: "{colors.gray.300}",
                _dark: "{colors.gray.700}"
            }
        },
        solid: {
            value: {
                _light: "{colors.gray.900}",
                _dark: "{colors.white}"
            }
        },
        focusRing: {
            value: {
                _light: "{colors.gray.800}",
                _dark: "{colors.gray.200}"
            }
        }
    },
    red: {
        contrast: {
            value: {
                _light: "white",
                _dark: "white"
            }
        },
        fg: {
            value: {
                _light: "{colors.red.700}",
                _dark: "{colors.red.300}"
            }
        },
        subtle: {
            value: {
                _light: "{colors.red.100}",
                _dark: "{colors.red.900}"
            }
        },
        muted: {
            value: {
                _light: "{colors.red.200}",
                _dark: "{colors.red.800}"
            }
        },
        emphasized: {
            value: {
                _light: "{colors.red.300}",
                _dark: "{colors.red.700}"
            }
        },
        solid: {
            value: {
                _light: "{colors.red.600}",
                _dark: "{colors.red.600}"
            }
        },
        focusRing: {
            value: {
                _light: "{colors.red.600}",
                _dark: "{colors.red.600}"
            }
        }
    },
    orange: {
        contrast: {
            value: {
                _light: "white",
                _dark: "black"
            }
        },
        fg: {
            value: {
                _light: "{colors.orange.700}",
                _dark: "{colors.orange.300}"
            }
        },
        subtle: {
            value: {
                _light: "{colors.orange.100}",
                _dark: "{colors.orange.900}"
            }
        },
        muted: {
            value: {
                _light: "{colors.orange.200}",
                _dark: "{colors.orange.800}"
            }
        },
        emphasized: {
            value: {
                _light: "{colors.orange.300}",
                _dark: "{colors.orange.700}"
            }
        },
        solid: {
            value: {
                _light: "{colors.orange.600}",
                _dark: "{colors.orange.500}"
            }
        },
        focusRing: {
            value: {
                _light: "{colors.orange.600}",
                _dark: "{colors.orange.500}"
            }
        }
    },
    green: {
        contrast: {
            value: {
                _light: "white",
                _dark: "white"
            }
        },
        fg: {
            value: {
                _light: "{colors.green.700}",
                _dark: "{colors.green.300}"
            }
        },
        subtle: {
            value: {
                _light: "{colors.green.100}",
                _dark: "{colors.green.900}"
            }
        },
        muted: {
            value: {
                _light: "{colors.green.200}",
                _dark: "{colors.green.800}"
            }
        },
        emphasized: {
            value: {
                _light: "{colors.green.300}",
                _dark: "{colors.green.700}"
            }
        },
        solid: {
            value: {
                _light: "{colors.green.600}",
                _dark: "{colors.green.600}"
            }
        },
        focusRing: {
            value: {
                _light: "{colors.green.600}",
                _dark: "{colors.green.600}"
            }
        }
    },
    blue: {
        contrast: {
            value: {
                _light: "white",
                _dark: "white"
            }
        },
        fg: {
            value: {
                _light: "{colors.blue.700}",
                _dark: "{colors.blue.300}"
            }
        },
        subtle: {
            value: {
                _light: "{colors.blue.100}",
                _dark: "{colors.blue.900}"
            }
        },
        muted: {
            value: {
                _light: "{colors.blue.200}",
                _dark: "{colors.blue.800}"
            }
        },
        emphasized: {
            value: {
                _light: "{colors.blue.300}",
                _dark: "{colors.blue.700}"
            }
        },
        solid: {
            value: {
                _light: "{colors.blue.600}",
                _dark: "{colors.blue.600}"
            }
        },
        focusRing: {
            value: {
                _light: "{colors.blue.600}",
                _dark: "{colors.blue.600}"
            }
        }
    },
    yellow: {
        contrast: {
            value: {
                _light: "black",
                _dark: "black"
            }
        },
        fg: {
            value: {
                _light: "{colors.yellow.800}",
                _dark: "{colors.yellow.300}"
            }
        },
        subtle: {
            value: {
                _light: "{colors.yellow.100}",
                _dark: "{colors.yellow.900}"
            }
        },
        muted: {
            value: {
                _light: "{colors.yellow.200}",
                _dark: "{colors.yellow.800}"
            }
        },
        emphasized: {
            value: {
                _light: "{colors.yellow.300}",
                _dark: "{colors.yellow.700}"
            }
        },
        solid: {
            value: {
                _light: "{colors.yellow.300}",
                _dark: "{colors.yellow.300}"
            }
        },
        focusRing: {
            value: {
                _light: "{colors.yellow.300}",
                _dark: "{colors.yellow.300}"
            }
        }
    },
    teal: {
        contrast: {
            value: {
                _light: "white",
                _dark: "white"
            }
        },
        fg: {
            value: {
                _light: "{colors.teal.700}",
                _dark: "{colors.teal.300}"
            }
        },
        subtle: {
            value: {
                _light: "{colors.teal.100}",
                _dark: "{colors.teal.900}"
            }
        },
        muted: {
            value: {
                _light: "{colors.teal.200}",
                _dark: "{colors.teal.800}"
            }
        },
        emphasized: {
            value: {
                _light: "{colors.teal.300}",
                _dark: "{colors.teal.700}"
            }
        },
        solid: {
            value: {
                _light: "{colors.teal.600}",
                _dark: "{colors.teal.600}"
            }
        },
        focusRing: {
            value: {
                _light: "{colors.teal.600}",
                _dark: "{colors.teal.600}"
            }
        }
    },
    purple: {
        contrast: {
            value: {
                _light: "white",
                _dark: "white"
            }
        },
        fg: {
            value: {
                _light: "{colors.purple.700}",
                _dark: "{colors.purple.300}"
            }
        },
        subtle: {
            value: {
                _light: "{colors.purple.100}",
                _dark: "{colors.purple.900}"
            }
        },
        muted: {
            value: {
                _light: "{colors.purple.200}",
                _dark: "{colors.purple.800}"
            }
        },
        emphasized: {
            value: {
                _light: "{colors.purple.300}",
                _dark: "{colors.purple.700}"
            }
        },
        solid: {
            value: {
                _light: "{colors.purple.600}",
                _dark: "{colors.purple.600}"
            }
        },
        focusRing: {
            value: {
                _light: "{colors.purple.600}",
                _dark: "{colors.purple.600}"
            }
        }
    },
    pink: {
        contrast: {
            value: {
                _light: "white",
                _dark: "white"
            }
        },
        fg: {
            value: {
                _light: "{colors.pink.700}",
                _dark: "{colors.pink.300}"
            }
        },
        subtle: {
            value: {
                _light: "{colors.pink.100}",
                _dark: "{colors.pink.900}"
            }
        },
        muted: {
            value: {
                _light: "{colors.pink.200}",
                _dark: "{colors.pink.800}"
            }
        },
        emphasized: {
            value: {
                _light: "{colors.pink.300}",
                _dark: "{colors.pink.700}"
            }
        },
        solid: {
            value: {
                _light: "{colors.pink.600}",
                _dark: "{colors.pink.600}"
            }
        },
        focusRing: {
            value: {
                _light: "{colors.pink.600}",
                _dark: "{colors.pink.600}"
            }
        }
    },
    cyan: {
        contrast: {
            value: {
                _light: "white",
                _dark: "white"
            }
        },
        fg: {
            value: {
                _light: "{colors.cyan.700}",
                _dark: "{colors.cyan.300}"
            }
        },
        subtle: {
            value: {
                _light: "{colors.cyan.100}",
                _dark: "{colors.cyan.900}"
            }
        },
        muted: {
            value: {
                _light: "{colors.cyan.200}",
                _dark: "{colors.cyan.800}"
            }
        },
        emphasized: {
            value: {
                _light: "{colors.cyan.300}",
                _dark: "{colors.cyan.700}"
            }
        },
        solid: {
            value: {
                _light: "{colors.cyan.600}",
                _dark: "{colors.cyan.600}"
            }
        },
        focusRing: {
            value: {
                _light: "{colors.cyan.600}",
                _dark: "{colors.cyan.600}"
            }
        }
    }
});



"use strict";
const $43209b4391cfe2b2$export$9a35918a914a3cfd = (0, $ee2de6f250f65b79$export$97e094f42fbe07cb).radii({
    l1: {
        value: "{radii.xs}"
    },
    l2: {
        value: "{radii.sm}"
    },
    l3: {
        value: "{radii.md}"
    }
});



"use strict";
const $6a303010962bcba7$export$be8678bc2461c05b = (0, $ee2de6f250f65b79$export$97e094f42fbe07cb).shadows({
    xs: {
        value: {
            _light: "0px 1px 2px {colors.gray.900/10}, 0px 0px 1px {colors.gray.900/20}",
            _dark: "0px 1px 1px {black/64}, 0px 0px 1px inset {colors.gray.300/20}"
        }
    },
    sm: {
        value: {
            _light: "0px 2px 4px {colors.gray.900/10}, 0px 0px 1px {colors.gray.900/30}",
            _dark: "0px 2px 4px {black/64}, 0px 0px 1px inset {colors.gray.300/30}"
        }
    },
    md: {
        value: {
            _light: "0px 4px 8px {colors.gray.900/10}, 0px 0px 1px {colors.gray.900/30}",
            _dark: "0px 4px 8px {black/64}, 0px 0px 1px inset {colors.gray.300/30}"
        }
    },
    lg: {
        value: {
            _light: "0px 8px 16px {colors.gray.900/10}, 0px 0px 1px {colors.gray.900/30}",
            _dark: "0px 8px 16px {black/64}, 0px 0px 1px inset {colors.gray.300/30}"
        }
    },
    xl: {
        value: {
            _light: "0px 16px 24px {colors.gray.900/10}, 0px 0px 1px {colors.gray.900/30}",
            _dark: "0px 16px 24px {black/64}, 0px 0px 1px inset {colors.gray.300/30}"
        }
    },
    "2xl": {
        value: {
            _light: "0px 24px 40px {colors.gray.900/16}, 0px 0px 1px {colors.gray.900/30}",
            _dark: "0px 24px 40px {black/64}, 0px 0px 1px inset {colors.gray.300/30}"
        }
    },
    inner: {
        value: {
            _light: "inset 0 2px 4px 0 {black/5}",
            _dark: "inset 0 2px 4px 0 black"
        }
    },
    inset: {
        value: {
            _light: "inset 0 0 0 1px {black/5}",
            _dark: "inset 0 0 0 1px {colors.gray.300/5}"
        }
    }
});







// src/accordion.anatomy.ts
var $ee305cd0ec3a86c0$export$477202748c7242bf = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("accordion").parts("root", "item", "itemTrigger", "itemContent", "itemIndicator");
var $ee305cd0ec3a86c0$var$parts = $ee305cd0ec3a86c0$export$477202748c7242bf.build();
var $ee305cd0ec3a86c0$var$dom = (0, $b06ec5ff205338e5$export$41a9651decfe2bde)({
    getRootId: (ctx)=>ctx.ids?.root ?? `accordion:${ctx.id}`,
    getItemId: (ctx, value)=>ctx.ids?.item?.(value) ?? `accordion:${ctx.id}:item:${value}`,
    getItemContentId: (ctx, value)=>ctx.ids?.itemContent?.(value) ?? `accordion:${ctx.id}:content:${value}`,
    getItemTriggerId: (ctx, value)=>ctx.ids?.itemTrigger?.(value) ?? `accordion:${ctx.id}:trigger:${value}`,
    getRootEl: (ctx)=>$ee305cd0ec3a86c0$var$dom.getById(ctx, $ee305cd0ec3a86c0$var$dom.getRootId(ctx)),
    getTriggerEls: (ctx)=>{
        const ownerId = CSS.escape($ee305cd0ec3a86c0$var$dom.getRootId(ctx));
        const selector = `[aria-controls][data-ownedby='${ownerId}']:not([disabled])`;
        return (0, $b06ec5ff205338e5$export$dcd0d083aa86c355)($ee305cd0ec3a86c0$var$dom.getRootEl(ctx), selector);
    },
    getFirstTriggerEl: (ctx)=>(0, $89352e0ddd72597a$export$43128fadae87b74a)($ee305cd0ec3a86c0$var$dom.getTriggerEls(ctx)),
    getLastTriggerEl: (ctx)=>(0, $89352e0ddd72597a$export$4c7897fafd92b108)($ee305cd0ec3a86c0$var$dom.getTriggerEls(ctx)),
    getNextTriggerEl: (ctx, id)=>(0, $b06ec5ff205338e5$export$f3d559454b8c0d00)($ee305cd0ec3a86c0$var$dom.getTriggerEls(ctx), $ee305cd0ec3a86c0$var$dom.getItemTriggerId(ctx, id)),
    getPrevTriggerEl: (ctx, id)=>(0, $b06ec5ff205338e5$export$326274ae311c62fd)($ee305cd0ec3a86c0$var$dom.getTriggerEls(ctx), $ee305cd0ec3a86c0$var$dom.getItemTriggerId(ctx, id))
});
// src/accordion.connect.ts
function $ee305cd0ec3a86c0$export$64605811ab45167f(state, send, normalize) {
    const focusedValue = state.context.focusedValue;
    const value = state.context.value;
    const multiple = state.context.multiple;
    function setValue(value2) {
        let nextValue = value2;
        if (multiple && nextValue.length > 1) nextValue = [
            nextValue[0]
        ];
        send({
            type: "VALUE.SET",
            value: nextValue
        });
    }
    function getItemState(props2) {
        return {
            expanded: value.includes(props2.value),
            focused: focusedValue === props2.value,
            disabled: Boolean(props2.disabled ?? state.context.disabled)
        };
    }
    return {
        focusedValue: focusedValue,
        value: value,
        setValue: setValue,
        getItemState: getItemState,
        getRootProps () {
            return normalize.element({
                ...$ee305cd0ec3a86c0$var$parts.root.attrs,
                dir: state.context.dir,
                id: $ee305cd0ec3a86c0$var$dom.getRootId(state.context),
                "data-orientation": state.context.orientation
            });
        },
        getItemProps (props2) {
            const itemState = getItemState(props2);
            return normalize.element({
                ...$ee305cd0ec3a86c0$var$parts.item.attrs,
                dir: state.context.dir,
                id: $ee305cd0ec3a86c0$var$dom.getItemId(state.context, props2.value),
                "data-state": itemState.expanded ? "open" : "closed",
                "data-focus": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(itemState.focused),
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(itemState.disabled),
                "data-orientation": state.context.orientation
            });
        },
        getItemContentProps (props2) {
            const itemState = getItemState(props2);
            return normalize.element({
                ...$ee305cd0ec3a86c0$var$parts.itemContent.attrs,
                dir: state.context.dir,
                role: "region",
                id: $ee305cd0ec3a86c0$var$dom.getItemContentId(state.context, props2.value),
                "aria-labelledby": $ee305cd0ec3a86c0$var$dom.getItemTriggerId(state.context, props2.value),
                hidden: !itemState.expanded,
                "data-state": itemState.expanded ? "open" : "closed",
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(itemState.disabled),
                "data-focus": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(itemState.focused),
                "data-orientation": state.context.orientation
            });
        },
        getItemIndicatorProps (props2) {
            const itemState = getItemState(props2);
            return normalize.element({
                ...$ee305cd0ec3a86c0$var$parts.itemIndicator.attrs,
                dir: state.context.dir,
                "aria-hidden": true,
                "data-state": itemState.expanded ? "open" : "closed",
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(itemState.disabled),
                "data-focus": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(itemState.focused),
                "data-orientation": state.context.orientation
            });
        },
        getItemTriggerProps (props2) {
            const { value: value2 } = props2;
            const itemState = getItemState(props2);
            return normalize.button({
                ...$ee305cd0ec3a86c0$var$parts.itemTrigger.attrs,
                type: "button",
                dir: state.context.dir,
                id: $ee305cd0ec3a86c0$var$dom.getItemTriggerId(state.context, value2),
                "aria-controls": $ee305cd0ec3a86c0$var$dom.getItemContentId(state.context, value2),
                "aria-expanded": itemState.expanded,
                disabled: itemState.disabled,
                "data-orientation": state.context.orientation,
                "aria-disabled": itemState.disabled,
                "data-state": itemState.expanded ? "open" : "closed",
                "data-ownedby": $ee305cd0ec3a86c0$var$dom.getRootId(state.context),
                onFocus () {
                    if (itemState.disabled) return;
                    send({
                        type: "TRIGGER.FOCUS",
                        value: value2
                    });
                },
                onBlur () {
                    if (itemState.disabled) return;
                    send("TRIGGER.BLUR");
                },
                onClick (event) {
                    if (itemState.disabled) return;
                    if ((0, $b06ec5ff205338e5$export$95df08bae54cb4df)()) event.currentTarget.focus();
                    send({
                        type: "TRIGGER.CLICK",
                        value: value2
                    });
                },
                onKeyDown (event) {
                    if (event.defaultPrevented) return;
                    if (itemState.disabled) return;
                    const keyMap = {
                        ArrowDown () {
                            if (state.context.isHorizontal) return;
                            send({
                                type: "GOTO.NEXT",
                                value: value2
                            });
                        },
                        ArrowUp () {
                            if (state.context.isHorizontal) return;
                            send({
                                type: "GOTO.PREV",
                                value: value2
                            });
                        },
                        ArrowRight () {
                            if (!state.context.isHorizontal) return;
                            send({
                                type: "GOTO.NEXT",
                                value: value2
                            });
                        },
                        ArrowLeft () {
                            if (!state.context.isHorizontal) return;
                            send({
                                type: "GOTO.PREV",
                                value: value2
                            });
                        },
                        Home () {
                            send({
                                type: "GOTO.FIRST",
                                value: value2
                            });
                        },
                        End () {
                            send({
                                type: "GOTO.LAST",
                                value: value2
                            });
                        }
                    };
                    const key = (0, $b06ec5ff205338e5$export$f7a7490116b79d4d)(event, {
                        dir: state.context.dir,
                        orientation: state.context.orientation
                    });
                    const exec = keyMap[key];
                    if (exec) {
                        exec(event);
                        event.preventDefault();
                    }
                }
            });
        }
    };
}
var { and: $ee305cd0ec3a86c0$var$and, not: $ee305cd0ec3a86c0$var$not } = (0, $5c0da97e9c7aa95f$export$f3249297f3edf7e9);
function $ee305cd0ec3a86c0$export$ea56d40cd27c3480(userContext) {
    const ctx = (0, $89352e0ddd72597a$export$8e16b83750b44988)(userContext);
    return (0, $5c0da97e9c7aa95f$export$aaa7fa18f8e9b2e8)({
        id: "accordion",
        initial: "idle",
        context: {
            focusedValue: null,
            value: [],
            collapsible: false,
            multiple: false,
            orientation: "vertical",
            ...ctx
        },
        watch: {
            value: "coarseValue",
            multiple: "coarseValue"
        },
        created: "coarseValue",
        computed: {
            isHorizontal: (ctx2)=>ctx2.orientation === "horizontal"
        },
        on: {
            "VALUE.SET": {
                actions: [
                    "setValue"
                ]
            }
        },
        states: {
            idle: {
                on: {
                    "TRIGGER.FOCUS": {
                        target: "focused",
                        actions: "setFocusedValue"
                    }
                }
            },
            focused: {
                on: {
                    "GOTO.NEXT": {
                        actions: "focusNextTrigger"
                    },
                    "GOTO.PREV": {
                        actions: "focusPrevTrigger"
                    },
                    "TRIGGER.CLICK": [
                        {
                            guard: $ee305cd0ec3a86c0$var$and("isExpanded", "canToggle"),
                            actions: [
                                "collapse"
                            ]
                        },
                        {
                            guard: $ee305cd0ec3a86c0$var$not("isExpanded"),
                            actions: [
                                "expand"
                            ]
                        }
                    ],
                    "GOTO.FIRST": {
                        actions: "focusFirstTrigger"
                    },
                    "GOTO.LAST": {
                        actions: "focusLastTrigger"
                    },
                    "TRIGGER.BLUR": {
                        target: "idle",
                        actions: "clearFocusedValue"
                    }
                }
            }
        }
    }, {
        guards: {
            canToggle: (ctx2)=>!!ctx2.collapsible || !!ctx2.multiple,
            isExpanded: (ctx2, evt)=>ctx2.value.includes(evt.value)
        },
        actions: {
            collapse (ctx2, evt) {
                const next = ctx2.multiple ? (0, $89352e0ddd72597a$export$cd7f480d6b8286c3)(ctx2.value, evt.value) : [];
                $ee305cd0ec3a86c0$var$set.value(ctx2, ctx2.multiple ? next : []);
            },
            expand (ctx2, evt) {
                const next = ctx2.multiple ? (0, $89352e0ddd72597a$export$e16d8520af44a096)(ctx2.value, evt.value) : [
                    evt.value
                ];
                $ee305cd0ec3a86c0$var$set.value(ctx2, next);
            },
            focusFirstTrigger (ctx2) {
                $ee305cd0ec3a86c0$var$dom.getFirstTriggerEl(ctx2)?.focus();
            },
            focusLastTrigger (ctx2) {
                $ee305cd0ec3a86c0$var$dom.getLastTriggerEl(ctx2)?.focus();
            },
            focusNextTrigger (ctx2) {
                if (!ctx2.focusedValue) return;
                const triggerEl = $ee305cd0ec3a86c0$var$dom.getNextTriggerEl(ctx2, ctx2.focusedValue);
                triggerEl?.focus();
            },
            focusPrevTrigger (ctx2) {
                if (!ctx2.focusedValue) return;
                const triggerEl = $ee305cd0ec3a86c0$var$dom.getPrevTriggerEl(ctx2, ctx2.focusedValue);
                triggerEl?.focus();
            },
            setFocusedValue (ctx2, evt) {
                $ee305cd0ec3a86c0$var$set.focusedValue(ctx2, evt.value);
            },
            clearFocusedValue (ctx2) {
                $ee305cd0ec3a86c0$var$set.focusedValue(ctx2, null);
            },
            setValue (ctx2, evt) {
                $ee305cd0ec3a86c0$var$set.value(ctx2, evt.value);
            },
            coarseValue (ctx2) {
                if (!ctx2.multiple && ctx2.value.length > 1) {
                    (0, $89352e0ddd72597a$export$c106dd0671a0fc2d)(`The value of accordion should be a single value when multiple is false.`);
                    ctx2.value = [
                        ctx2.value[0]
                    ];
                }
            }
        }
    });
}
var $ee305cd0ec3a86c0$var$invoke = {
    change (ctx) {
        ctx.onValueChange?.({
            value: Array.from(ctx.value)
        });
    },
    focusChange (ctx) {
        ctx.onFocusChange?.({
            value: ctx.focusedValue
        });
    }
};
var $ee305cd0ec3a86c0$var$set = {
    value (ctx, value) {
        if ((0, $89352e0ddd72597a$export$248d38f6296296c5)(ctx.value, value)) return;
        ctx.value = value;
        $ee305cd0ec3a86c0$var$invoke.change(ctx);
    },
    focusedValue (ctx, value) {
        if ((0, $89352e0ddd72597a$export$248d38f6296296c5)(ctx.focusedValue, value)) return;
        ctx.focusedValue = value;
        $ee305cd0ec3a86c0$var$invoke.focusChange(ctx);
    }
};
var $ee305cd0ec3a86c0$export$8128bb6492cf3de7 = (0, $5b359805fda5a40e$export$c94ea207b45fef3a)()([
    "collapsible",
    "dir",
    "disabled",
    "getRootNode",
    "id",
    "ids",
    "multiple",
    "onFocusChange",
    "onValueChange",
    "orientation",
    "value"
]);
var $ee305cd0ec3a86c0$export$45029c61b0073d87 = (0, $89352e0ddd72597a$export$3ea53b214fbc1986)($ee305cd0ec3a86c0$export$8128bb6492cf3de7);
var $ee305cd0ec3a86c0$export$b67876e05d194bf9 = (0, $5b359805fda5a40e$export$c94ea207b45fef3a)()([
    "value",
    "disabled"
]);
var $ee305cd0ec3a86c0$export$ae9d1ad549773548 = (0, $89352e0ddd72597a$export$3ea53b214fbc1986)($ee305cd0ec3a86c0$export$b67876e05d194bf9);





// src/walk-tree-outside.ts
var $ef6836a155f3b375$var$counterMap = /* @__PURE__ */ new WeakMap();
var $ef6836a155f3b375$var$uncontrolledNodes = /* @__PURE__ */ new WeakMap();
var $ef6836a155f3b375$var$markerMap = {};
var $ef6836a155f3b375$var$lockCount = 0;
var $ef6836a155f3b375$var$unwrapHost = (node)=>node && (node.host || $ef6836a155f3b375$var$unwrapHost(node.parentNode));
var $ef6836a155f3b375$var$correctTargets = (parent, targets)=>targets.map((target)=>{
        if (parent.contains(target)) return target;
        const correctedTarget = $ef6836a155f3b375$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error("[zag-js > ariaHidden] target", target, "in not contained inside", parent, ". Doing nothing");
        return null;
    }).filter((x)=>Boolean(x));
var $ef6836a155f3b375$var$isIgnoredNode = (node)=>{
    if (node.localName === "next-route-announcer") return true;
    if (node.localName === "script") return true;
    if (node.hasAttribute("aria-live")) return true;
    return node.matches("[data-live-announcer]");
};
var $ef6836a155f3b375$var$walkTreeOutside = (originalTarget, props)=>{
    const { parentNode: parentNode, markerName: markerName, controlAttribute: controlAttribute } = props;
    const targets = $ef6836a155f3b375$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    $ef6836a155f3b375$var$markerMap[markerName] || ($ef6836a155f3b375$var$markerMap[markerName] = /* @__PURE__ */ new WeakMap());
    const markerCounter = $ef6836a155f3b375$var$markerMap[markerName];
    const hiddenNodes = [];
    const elementsToKeep = /* @__PURE__ */ new Set();
    const elementsToStop = new Set(targets);
    const keep = (el)=>{
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    const deep = (parent)=>{
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, (node)=>{
            if (elementsToKeep.has(node)) deep(node);
            else try {
                if ($ef6836a155f3b375$var$isIgnoredNode(node)) return;
                const attr = node.getAttribute(controlAttribute);
                const alreadyHidden = attr !== null && attr !== "false";
                const counterValue = ($ef6836a155f3b375$var$counterMap.get(node) || 0) + 1;
                const markerValue = (markerCounter.get(node) || 0) + 1;
                $ef6836a155f3b375$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $ef6836a155f3b375$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, "");
                if (!alreadyHidden) node.setAttribute(controlAttribute, "");
            } catch (e) {
                console.error("[zag-js > ariaHidden] cannot operate on ", node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $ef6836a155f3b375$var$lockCount++;
    return ()=>{
        hiddenNodes.forEach((node)=>{
            const counterValue = $ef6836a155f3b375$var$counterMap.get(node) - 1;
            const markerValue = markerCounter.get(node) - 1;
            $ef6836a155f3b375$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$ef6836a155f3b375$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $ef6836a155f3b375$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $ef6836a155f3b375$var$lockCount--;
        if (!$ef6836a155f3b375$var$lockCount) {
            $ef6836a155f3b375$var$counterMap = /* @__PURE__ */ new WeakMap();
            $ef6836a155f3b375$var$counterMap = /* @__PURE__ */ new WeakMap();
            $ef6836a155f3b375$var$uncontrolledNodes = /* @__PURE__ */ new WeakMap();
            $ef6836a155f3b375$var$markerMap = {};
        }
    };
};
// src/aria-hidden.ts
var $ef6836a155f3b375$var$getParentNode = (originalTarget)=>{
    const target = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return target.ownerDocument.body;
};
var $ef6836a155f3b375$var$hideOthers = (originalTarget, parentNode = $ef6836a155f3b375$var$getParentNode(originalTarget), markerName = "data-aria-hidden")=>{
    if (!parentNode) return;
    return $ef6836a155f3b375$var$walkTreeOutside(originalTarget, {
        parentNode: parentNode,
        markerName: markerName,
        controlAttribute: "aria-hidden"
    });
};
// src/index.ts
var $ef6836a155f3b375$var$raf = (fn)=>{
    const frameId = requestAnimationFrame(()=>fn());
    return ()=>cancelAnimationFrame(frameId);
};
function $ef6836a155f3b375$export$e1bd0c6150f13d96(targetsOrFn, options = {}) {
    const { defer: defer = true } = options;
    const func = defer ? $ef6836a155f3b375$var$raf : (v)=>v();
    const cleanups = [];
    cleanups.push(func(()=>{
        const targets = typeof targetsOrFn === "function" ? targetsOrFn() : targetsOrFn;
        const elements = targets.filter(Boolean);
        if (elements.length === 0) return;
        cleanups.push($ef6836a155f3b375$var$hideOthers(elements));
    }));
    return ()=>{
        cleanups.forEach((fn)=>fn?.());
    };
}






// src/index.ts
// src/frame-utils.ts
function $bd9239a4339fbad2$var$getWindowFrames(win) {
    const frames = {
        each (cb) {
            for(let i = 0; i < win.frames?.length; i += 1){
                const frame = win.frames[i];
                if (frame) cb(frame);
            }
        },
        addEventListener (event, listener, options) {
            frames.each((frame)=>{
                try {
                    frame.document.addEventListener(event, listener, options);
                } catch  {}
            });
            return ()=>{
                try {
                    frames.removeEventListener(event, listener, options);
                } catch  {}
            };
        },
        removeEventListener (event, listener, options) {
            frames.each((frame)=>{
                try {
                    frame.document.removeEventListener(event, listener, options);
                } catch  {}
            });
        }
    };
    return frames;
}
function $bd9239a4339fbad2$var$getParentWindow(win) {
    const parent = win.frameElement != null ? win.parent : null;
    return {
        addEventListener: (event, listener, options)=>{
            try {
                parent?.addEventListener(event, listener, options);
            } catch  {}
            return ()=>{
                try {
                    parent?.removeEventListener(event, listener, options);
                } catch  {}
            };
        },
        removeEventListener: (event, listener, options)=>{
            try {
                parent?.removeEventListener(event, listener, options);
            } catch  {}
        }
    };
}
// src/index.ts
var $bd9239a4339fbad2$var$POINTER_OUTSIDE_EVENT = "pointerdown.outside";
var $bd9239a4339fbad2$var$FOCUS_OUTSIDE_EVENT = "focus.outside";
function $bd9239a4339fbad2$var$isComposedPathFocusable(composedPath) {
    for (const node of composedPath){
        if ((0, $b06ec5ff205338e5$export$1b3bfaa9684536aa)(node) && (0, $b06ec5ff205338e5$export$4c063cf1350e6fed)(node)) return true;
    }
    return false;
}
var $bd9239a4339fbad2$var$isPointerEvent = (event)=>"clientY" in event;
function $bd9239a4339fbad2$var$isEventPointWithin(node, event) {
    if (!$bd9239a4339fbad2$var$isPointerEvent(event) || !node) return false;
    const rect = node.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return false;
    return rect.top <= event.clientY && event.clientY <= rect.top + rect.height && rect.left <= event.clientX && event.clientX <= rect.left + rect.width;
}
function $bd9239a4339fbad2$var$isPointInRect(rect, point) {
    return rect.y <= point.y && point.y <= rect.y + rect.height && rect.x <= point.x && point.x <= rect.x + rect.width;
}
function $bd9239a4339fbad2$var$isEventWithinScrollbar(event, ancestor) {
    if (!ancestor || !$bd9239a4339fbad2$var$isPointerEvent(event)) return false;
    const isScrollableY = ancestor.scrollHeight > ancestor.clientHeight;
    const onScrollbarY = isScrollableY && event.clientX > ancestor.offsetLeft + ancestor.clientWidth;
    const isScrollableX = ancestor.scrollWidth > ancestor.clientWidth;
    const onScrollbarX = isScrollableX && event.clientY > ancestor.offsetTop + ancestor.clientHeight;
    const rect = {
        x: ancestor.offsetLeft,
        y: ancestor.offsetTop,
        width: ancestor.clientWidth + (isScrollableY ? 16 : 0),
        height: ancestor.clientHeight + (isScrollableX ? 16 : 0)
    };
    const point = {
        x: event.clientX,
        y: event.clientY
    };
    if (!$bd9239a4339fbad2$var$isPointInRect(rect, point)) return false;
    return onScrollbarY || onScrollbarX;
}
function $bd9239a4339fbad2$var$trackInteractOutsideImpl(node, options) {
    const { exclude: exclude, onFocusOutside: onFocusOutside, onPointerDownOutside: onPointerDownOutside, onInteractOutside: onInteractOutside, defer: defer } = options;
    if (!node) return;
    const doc = (0, $b06ec5ff205338e5$export$f65ca476c09acec0)(node);
    const win = (0, $b06ec5ff205338e5$export$38b2d434cce3ea22)(node);
    const frames = $bd9239a4339fbad2$var$getWindowFrames(win);
    const parentWin = $bd9239a4339fbad2$var$getParentWindow(win);
    function isEventOutside(event) {
        const target = (0, $b06ec5ff205338e5$export$e58f029f0fbfdb29)(event);
        if (!(0, $b06ec5ff205338e5$export$1b3bfaa9684536aa)(target)) return false;
        if (!target.isConnected) return false;
        if ((0, $b06ec5ff205338e5$export$2344b14b097df817)(node, target)) return false;
        if ($bd9239a4339fbad2$var$isEventPointWithin(node, event)) return false;
        const triggerEl = doc.querySelector(`[aria-controls="${node.id}"]`);
        if (triggerEl) {
            const triggerAncestor = (0, $b06ec5ff205338e5$export$7cd01a57c8ca906c)(triggerEl);
            if ($bd9239a4339fbad2$var$isEventWithinScrollbar(event, triggerAncestor)) return false;
        }
        const nodeAncestor = (0, $b06ec5ff205338e5$export$7cd01a57c8ca906c)(node);
        if ($bd9239a4339fbad2$var$isEventWithinScrollbar(event, nodeAncestor)) return false;
        return !exclude?.(target);
    }
    const pointerdownCleanups = /* @__PURE__ */ new Set();
    function onPointerDown(event) {
        function handler() {
            const func = defer ? (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4) : (v)=>v();
            const composedPath = event.composedPath?.() ?? [
                event.target
            ];
            func(()=>{
                if (!node || !isEventOutside(event)) return;
                if (onPointerDownOutside || onInteractOutside) {
                    const handler2 = (0, $89352e0ddd72597a$export$9dd9a52f2dd5b9ce)(onPointerDownOutside, onInteractOutside);
                    node.addEventListener($bd9239a4339fbad2$var$POINTER_OUTSIDE_EVENT, handler2, {
                        once: true
                    });
                }
                $bd9239a4339fbad2$var$fireCustomEvent(node, $bd9239a4339fbad2$var$POINTER_OUTSIDE_EVENT, {
                    bubbles: false,
                    cancelable: true,
                    detail: {
                        originalEvent: event,
                        contextmenu: (0, $b06ec5ff205338e5$export$6faedb510c176c60)(event),
                        focusable: $bd9239a4339fbad2$var$isComposedPathFocusable(composedPath)
                    }
                });
            });
        }
        if (event.pointerType === "touch") {
            pointerdownCleanups.forEach((fn)=>fn());
            pointerdownCleanups.add((0, $b06ec5ff205338e5$export$b1d829ddf82884aa)(doc, "click", handler, {
                once: true
            }));
            pointerdownCleanups.add(parentWin.addEventListener("click", handler, {
                once: true
            }));
            pointerdownCleanups.add(frames.addEventListener("click", handler, {
                once: true
            }));
        } else handler();
    }
    const cleanups = /* @__PURE__ */ new Set();
    const timer = setTimeout(()=>{
        cleanups.add((0, $b06ec5ff205338e5$export$b1d829ddf82884aa)(doc, "pointerdown", onPointerDown, true));
        cleanups.add(parentWin.addEventListener("pointerdown", onPointerDown, true));
        cleanups.add(frames.addEventListener("pointerdown", onPointerDown, true));
    }, 0);
    function onFocusin(event) {
        const func = defer ? (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4) : (v)=>v();
        func(()=>{
            if (!node || !isEventOutside(event)) return;
            if (onFocusOutside || onInteractOutside) {
                const handler = (0, $89352e0ddd72597a$export$9dd9a52f2dd5b9ce)(onFocusOutside, onInteractOutside);
                node.addEventListener($bd9239a4339fbad2$var$FOCUS_OUTSIDE_EVENT, handler, {
                    once: true
                });
            }
            $bd9239a4339fbad2$var$fireCustomEvent(node, $bd9239a4339fbad2$var$FOCUS_OUTSIDE_EVENT, {
                bubbles: false,
                cancelable: true,
                detail: {
                    originalEvent: event,
                    contextmenu: false,
                    focusable: (0, $b06ec5ff205338e5$export$4c063cf1350e6fed)((0, $b06ec5ff205338e5$export$e58f029f0fbfdb29)(event))
                }
            });
        });
    }
    cleanups.add((0, $b06ec5ff205338e5$export$b1d829ddf82884aa)(doc, "focusin", onFocusin, true));
    cleanups.add(parentWin.addEventListener("focusin", onFocusin, true));
    cleanups.add(frames.addEventListener("focusin", onFocusin, true));
    return ()=>{
        clearTimeout(timer);
        pointerdownCleanups.forEach((fn)=>fn());
        cleanups.forEach((fn)=>fn());
    };
}
function $bd9239a4339fbad2$export$15e1dde088f1e162(nodeOrFn, options) {
    const { defer: defer } = options;
    const func = defer ? (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4) : (v)=>v();
    const cleanups = [];
    cleanups.push(func(()=>{
        const node = typeof nodeOrFn === "function" ? nodeOrFn() : nodeOrFn;
        cleanups.push($bd9239a4339fbad2$var$trackInteractOutsideImpl(node, options));
    }));
    return ()=>{
        cleanups.forEach((fn)=>fn?.());
    };
}
function $bd9239a4339fbad2$var$fireCustomEvent(el, type, init) {
    const win = el.ownerDocument.defaultView || window;
    const event = new win.CustomEvent(type, init);
    return el.dispatchEvent(event);
}



// src/dismissable-layer.ts
function $a0385836474f3c11$var$trackEscapeKeydown(node, fn) {
    const handleKeyDown = (event)=>{
        if (event.key !== "Escape") return;
        if (event.isComposing) return;
        fn?.(event);
    };
    return (0, $b06ec5ff205338e5$export$b1d829ddf82884aa)((0, $b06ec5ff205338e5$export$f65ca476c09acec0)(node), "keydown", handleKeyDown, {
        capture: true
    });
}
var $a0385836474f3c11$var$layerStack = {
    layers: [],
    branches: [],
    count () {
        return this.layers.length;
    },
    pointerBlockingLayers () {
        return this.layers.filter((layer)=>layer.pointerBlocking);
    },
    topMostPointerBlockingLayer () {
        return [
            ...this.pointerBlockingLayers()
        ].slice(-1)[0];
    },
    hasPointerBlockingLayer () {
        return this.pointerBlockingLayers().length > 0;
    },
    isBelowPointerBlockingLayer (node) {
        const index = this.indexOf(node);
        const highestBlockingIndex = this.topMostPointerBlockingLayer() ? this.indexOf(this.topMostPointerBlockingLayer()?.node) : -1;
        return index < highestBlockingIndex;
    },
    isTopMost (node) {
        const layer = this.layers[this.count() - 1];
        return layer?.node === node;
    },
    getNestedLayers (node) {
        return Array.from(this.layers).slice(this.indexOf(node) + 1);
    },
    isInNestedLayer (node, target) {
        return this.getNestedLayers(node).some((layer)=>(0, $b06ec5ff205338e5$export$2344b14b097df817)(layer.node, target));
    },
    isInBranch (target) {
        return Array.from(this.branches).some((branch)=>(0, $b06ec5ff205338e5$export$2344b14b097df817)(branch, target));
    },
    add (layer) {
        const num = this.layers.push(layer);
        layer.node.style.setProperty("--layer-index", `${num}`);
    },
    addBranch (node) {
        this.branches.push(node);
    },
    remove (node) {
        const index = this.indexOf(node);
        if (index < 0) return;
        if (index < this.count() - 1) {
            const _layers = this.getNestedLayers(node);
            _layers.forEach((layer)=>layer.dismiss());
        }
        this.layers.splice(index, 1);
        node.style.removeProperty("--layer-index");
    },
    removeBranch (node) {
        const index = this.branches.indexOf(node);
        if (index >= 0) this.branches.splice(index, 1);
    },
    indexOf (node) {
        return this.layers.findIndex((layer)=>layer.node === node);
    },
    dismiss (node) {
        this.layers[this.indexOf(node)]?.dismiss();
    },
    clear () {
        this.remove(this.layers[0].node);
    }
};
var $a0385836474f3c11$var$originalBodyPointerEvents;
function $a0385836474f3c11$var$assignPointerEventToLayers() {
    $a0385836474f3c11$var$layerStack.layers.forEach(({ node: node })=>{
        node.style.pointerEvents = $a0385836474f3c11$var$layerStack.isBelowPointerBlockingLayer(node) ? "none" : "auto";
    });
}
function $a0385836474f3c11$var$clearPointerEvent(node) {
    node.style.pointerEvents = "";
}
function $a0385836474f3c11$var$disablePointerEventsOutside(node, persistentElements) {
    const doc = (0, $b06ec5ff205338e5$export$f65ca476c09acec0)(node);
    const cleanups = [];
    if ($a0385836474f3c11$var$layerStack.hasPointerBlockingLayer() && !doc.body.hasAttribute("data-inert")) {
        $a0385836474f3c11$var$originalBodyPointerEvents = document.body.style.pointerEvents;
        queueMicrotask(()=>{
            doc.body.style.pointerEvents = "none";
            doc.body.setAttribute("data-inert", "");
        });
    }
    if (persistentElements) {
        const persistedCleanup = (0, $b06ec5ff205338e5$export$dfc394f7db44feeb)(persistentElements, (el)=>{
            cleanups.push((0, $b06ec5ff205338e5$export$37a5fde709c1db82)(el, {
                pointerEvents: "auto"
            }));
        });
        cleanups.push(persistedCleanup);
    }
    return ()=>{
        if ($a0385836474f3c11$var$layerStack.hasPointerBlockingLayer()) return;
        queueMicrotask(()=>{
            doc.body.style.pointerEvents = $a0385836474f3c11$var$originalBodyPointerEvents;
            doc.body.removeAttribute("data-inert");
            if (doc.body.style.length === 0) doc.body.removeAttribute("style");
        });
        cleanups.forEach((fn)=>fn());
    };
}
// src/dismissable-layer.ts
function $a0385836474f3c11$var$trackDismissableElementImpl(node, options) {
    if (!node) {
        (0, $89352e0ddd72597a$export$c106dd0671a0fc2d)("[@zag-js/dismissable] node is `null` or `undefined`");
        return;
    }
    const { onDismiss: onDismiss, pointerBlocking: pointerBlocking, exclude: excludeContainers, debug: debug } = options;
    const layer = {
        dismiss: onDismiss,
        node: node,
        pointerBlocking: pointerBlocking
    };
    $a0385836474f3c11$var$layerStack.add(layer);
    $a0385836474f3c11$var$assignPointerEventToLayers();
    function onPointerDownOutside(event) {
        const target = (0, $b06ec5ff205338e5$export$e58f029f0fbfdb29)(event.detail.originalEvent);
        if ($a0385836474f3c11$var$layerStack.isBelowPointerBlockingLayer(node) || $a0385836474f3c11$var$layerStack.isInBranch(target)) return;
        options.onPointerDownOutside?.(event);
        options.onInteractOutside?.(event);
        if (event.defaultPrevented) return;
        if (debug) console.log("onPointerDownOutside:", event.detail.originalEvent);
        onDismiss?.();
    }
    function onFocusOutside(event) {
        const target = (0, $b06ec5ff205338e5$export$e58f029f0fbfdb29)(event.detail.originalEvent);
        if ($a0385836474f3c11$var$layerStack.isInBranch(target)) return;
        options.onFocusOutside?.(event);
        options.onInteractOutside?.(event);
        if (event.defaultPrevented) return;
        if (debug) console.log("onFocusOutside:", event.detail.originalEvent);
        onDismiss?.();
    }
    function onEscapeKeyDown(event) {
        if (!$a0385836474f3c11$var$layerStack.isTopMost(node)) return;
        options.onEscapeKeyDown?.(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }
    function exclude(target) {
        if (!node) return false;
        const containers = typeof excludeContainers === "function" ? excludeContainers() : excludeContainers;
        const _containers = Array.isArray(containers) ? containers : [
            containers
        ];
        const persistentElements = options.persistentElements?.map((fn)=>fn()).filter((0, $b06ec5ff205338e5$export$1b3bfaa9684536aa));
        if (persistentElements) _containers.push(...persistentElements);
        return _containers.some((node2)=>(0, $b06ec5ff205338e5$export$2344b14b097df817)(node2, target)) || $a0385836474f3c11$var$layerStack.isInNestedLayer(node, target);
    }
    const cleanups = [
        pointerBlocking ? $a0385836474f3c11$var$disablePointerEventsOutside(node, options.persistentElements) : void 0,
        $a0385836474f3c11$var$trackEscapeKeydown(node, onEscapeKeyDown),
        (0, $bd9239a4339fbad2$export$15e1dde088f1e162)(node, {
            exclude: exclude,
            onFocusOutside: onFocusOutside,
            onPointerDownOutside: onPointerDownOutside,
            defer: options.defer
        })
    ];
    return ()=>{
        $a0385836474f3c11$var$layerStack.remove(node);
        $a0385836474f3c11$var$assignPointerEventToLayers();
        $a0385836474f3c11$var$clearPointerEvent(node);
        cleanups.forEach((fn)=>fn?.());
    };
}
function $a0385836474f3c11$export$72bda0e502b8ea31(nodeOrFn, options) {
    const { defer: defer } = options;
    const func = defer ? (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4) : (v)=>v();
    const cleanups = [];
    cleanups.push(func(()=>{
        const node = (0, $89352e0ddd72597a$export$f6e2535fb5126e54)(nodeOrFn) ? nodeOrFn() : nodeOrFn;
        cleanups.push($a0385836474f3c11$var$trackDismissableElementImpl(node, options));
    }));
    return ()=>{
        func(()=>{
            cleanups.forEach((fn)=>fn?.());
        });
    };
}
function $a0385836474f3c11$export$42019839bfd578e2(nodeOrFn, options = {}) {
    const { defer: defer } = options;
    const func = defer ? (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4) : (v)=>v();
    const cleanups = [];
    cleanups.push(func(()=>{
        const node = (0, $89352e0ddd72597a$export$f6e2535fb5126e54)(nodeOrFn) ? nodeOrFn() : nodeOrFn;
        if (!node) {
            (0, $89352e0ddd72597a$export$c106dd0671a0fc2d)("[@zag-js/dismissable] branch node is `null` or `undefined`");
            return;
        }
        $a0385836474f3c11$var$layerStack.addBranch(node);
        cleanups.push(()=>{
            $a0385836474f3c11$var$layerStack.removeBranch(node);
        });
    }));
    return ()=>{
        func(()=>{
            cleanups.forEach((fn)=>fn?.());
        });
    };
}



var $39480da6128c25d0$var$__defProp = Object.defineProperty;
var $39480da6128c25d0$var$__defNormalProp = (obj, key, value)=>key in obj ? $39480da6128c25d0$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $39480da6128c25d0$var$__publicField = (obj, key, value)=>$39480da6128c25d0$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var $39480da6128c25d0$var$activeFocusTraps = {
    activateTrap (trapStack, trap) {
        if (trapStack.length > 0) {
            const activeTrap = trapStack[trapStack.length - 1];
            if (activeTrap !== trap) activeTrap.pause();
        }
        const trapIndex = trapStack.indexOf(trap);
        if (trapIndex === -1) trapStack.push(trap);
        else {
            trapStack.splice(trapIndex, 1);
            trapStack.push(trap);
        }
    },
    deactivateTrap (trapStack, trap) {
        const trapIndex = trapStack.indexOf(trap);
        if (trapIndex !== -1) trapStack.splice(trapIndex, 1);
        if (trapStack.length > 0) trapStack[trapStack.length - 1].unpause();
    }
};
var $39480da6128c25d0$var$sharedTrapStack = [];
var $39480da6128c25d0$export$34eba2437817a67b = class {
    constructor(elements, options){
        $39480da6128c25d0$var$__publicField(this, "trapStack");
        $39480da6128c25d0$var$__publicField(this, "config");
        $39480da6128c25d0$var$__publicField(this, "doc");
        $39480da6128c25d0$var$__publicField(this, "state", {
            containers: [],
            containerGroups: [],
            tabbableGroups: [],
            nodeFocusedBeforeActivation: null,
            mostRecentlyFocusedNode: null,
            active: false,
            paused: false,
            delayInitialFocusTimer: void 0,
            recentNavEvent: void 0
        });
        $39480da6128c25d0$var$__publicField(this, "listenerCleanups", []);
        $39480da6128c25d0$var$__publicField(this, "handleFocus", (event)=>{
            const target = (0, $b06ec5ff205338e5$export$e58f029f0fbfdb29)(event);
            const targetContained = this.findContainerIndex(target, event) >= 0;
            if (targetContained || (0, $b06ec5ff205338e5$export$62858bae88b53fd0)(target)) {
                if (targetContained) this.state.mostRecentlyFocusedNode = target;
            } else {
                event.stopImmediatePropagation();
                let nextNode;
                let navAcrossContainers = true;
                if (this.state.mostRecentlyFocusedNode) {
                    if ((0, $b06ec5ff205338e5$export$a4672efddb4181b8)(this.state.mostRecentlyFocusedNode) > 0) {
                        const mruContainerIdx = this.findContainerIndex(this.state.mostRecentlyFocusedNode);
                        const { tabbableNodes: tabbableNodes } = this.state.containerGroups[mruContainerIdx];
                        if (tabbableNodes.length > 0) {
                            const mruTabIdx = tabbableNodes.findIndex((node)=>node === this.state.mostRecentlyFocusedNode);
                            if (mruTabIdx >= 0) {
                                if (this.config.isKeyForward(this.state.recentNavEvent)) {
                                    if (mruTabIdx + 1 < tabbableNodes.length) {
                                        nextNode = tabbableNodes[mruTabIdx + 1];
                                        navAcrossContainers = false;
                                    }
                                } else if (mruTabIdx - 1 >= 0) {
                                    nextNode = tabbableNodes[mruTabIdx - 1];
                                    navAcrossContainers = false;
                                }
                            }
                        }
                    } else if (!this.state.containerGroups.some((g)=>g.tabbableNodes.some((n)=>(0, $b06ec5ff205338e5$export$a4672efddb4181b8)(n) > 0))) navAcrossContainers = false;
                } else navAcrossContainers = false;
                if (navAcrossContainers) nextNode = this.findNextNavNode({
                    // move FROM the MRU node, not event-related node (which will be the node that is
                    //  outside the trap causing the focus escape we're trying to fix)
                    target: this.state.mostRecentlyFocusedNode,
                    isBackward: this.config.isKeyBackward(this.state.recentNavEvent)
                });
                if (nextNode) this.tryFocus(nextNode);
                else this.tryFocus(this.state.mostRecentlyFocusedNode || this.getInitialFocusNode());
            }
            this.state.recentNavEvent = void 0;
        });
        $39480da6128c25d0$var$__publicField(this, "handlePointerDown", (event)=>{
            const target = (0, $b06ec5ff205338e5$export$e58f029f0fbfdb29)(event);
            if (this.findContainerIndex(target, event) >= 0) return;
            if ($39480da6128c25d0$var$valueOrHandler(this.config.clickOutsideDeactivates, event)) {
                this.deactivate({
                    returnFocus: this.config.returnFocusOnDeactivate
                });
                return;
            }
            if ($39480da6128c25d0$var$valueOrHandler(this.config.allowOutsideClick, event)) return;
            event.preventDefault();
        });
        $39480da6128c25d0$var$__publicField(this, "handleClick", (event)=>{
            const target = (0, $b06ec5ff205338e5$export$e58f029f0fbfdb29)(event);
            if (this.findContainerIndex(target, event) >= 0) return;
            if ($39480da6128c25d0$var$valueOrHandler(this.config.clickOutsideDeactivates, event)) return;
            if ($39480da6128c25d0$var$valueOrHandler(this.config.allowOutsideClick, event)) return;
            event.preventDefault();
            event.stopImmediatePropagation();
        });
        $39480da6128c25d0$var$__publicField(this, "handleTabKey", (event)=>{
            if (this.config.isKeyForward(event) || this.config.isKeyBackward(event)) {
                this.state.recentNavEvent = event;
                const isBackward = this.config.isKeyBackward(event);
                const destinationNode = this.findNextNavNode({
                    event: event,
                    isBackward: isBackward
                });
                if (!destinationNode) return;
                if ($39480da6128c25d0$var$isTabEvent(event)) event.preventDefault();
                this.tryFocus(destinationNode);
            }
        });
        $39480da6128c25d0$var$__publicField(this, "handleEscapeKey", (event)=>{
            if ($39480da6128c25d0$var$isEscapeEvent(event) && $39480da6128c25d0$var$valueOrHandler(this.config.escapeDeactivates, event) !== false) {
                event.preventDefault();
                this.deactivate();
            }
        });
        $39480da6128c25d0$var$__publicField(this, "_mutationObserver");
        $39480da6128c25d0$var$__publicField(this, "setupMutationObserver", ()=>{
            const win = this.doc.defaultView || window;
            this._mutationObserver = new win.MutationObserver((mutations)=>{
                const isFocusedNodeRemoved = mutations.some((mutation)=>{
                    const removedNodes = Array.from(mutation.removedNodes);
                    return removedNodes.some((node)=>node === this.state.mostRecentlyFocusedNode);
                });
                if (isFocusedNodeRemoved) this.tryFocus(this.getInitialFocusNode());
            });
        });
        $39480da6128c25d0$var$__publicField(this, "updateObservedNodes", ()=>{
            this._mutationObserver?.disconnect();
            if (this.state.active && !this.state.paused) this.state.containers.map((container)=>{
                this._mutationObserver?.observe(container, {
                    subtree: true,
                    childList: true
                });
            });
        });
        $39480da6128c25d0$var$__publicField(this, "getInitialFocusNode", ()=>{
            let node = this.getNodeForOption("initialFocus", {
                hasFallback: true
            });
            if (node === false) return false;
            if (node === void 0 || node && !(0, $b06ec5ff205338e5$export$4c063cf1350e6fed)(node)) {
                if (this.findContainerIndex(this.doc.activeElement) >= 0) node = this.doc.activeElement;
                else {
                    const firstTabbableGroup = this.state.tabbableGroups[0];
                    const firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
                    node = firstTabbableNode || this.getNodeForOption("fallbackFocus");
                }
            } else if (node === null) node = this.getNodeForOption("fallbackFocus");
            if (!node) throw new Error("Your focus-trap needs to have at least one focusable element");
            if (!node.isConnected) node = this.getNodeForOption("fallbackFocus");
            return node;
        });
        $39480da6128c25d0$var$__publicField(this, "tryFocus", (node)=>{
            if (node === false) return;
            if (node === (0, $b06ec5ff205338e5$export$cd4e5573fbe2b576)(this.doc)) return;
            if (!node || !node.focus) {
                this.tryFocus(this.getInitialFocusNode());
                return;
            }
            node.focus({
                preventScroll: !!this.config.preventScroll
            });
            this.state.mostRecentlyFocusedNode = node;
            if ($39480da6128c25d0$var$isSelectableInput(node)) node.select();
        });
        $39480da6128c25d0$var$__publicField(this, "deactivate", (deactivateOptions)=>{
            if (!this.state.active) return this;
            const options = {
                onDeactivate: this.config.onDeactivate,
                onPostDeactivate: this.config.onPostDeactivate,
                checkCanReturnFocus: this.config.checkCanReturnFocus,
                ...deactivateOptions
            };
            clearTimeout(this.state.delayInitialFocusTimer);
            this.state.delayInitialFocusTimer = void 0;
            this.removeListeners();
            this.state.active = false;
            this.state.paused = false;
            this.updateObservedNodes();
            $39480da6128c25d0$var$activeFocusTraps.deactivateTrap(this.trapStack, this);
            const onDeactivate = this.getOption(options, "onDeactivate");
            const onPostDeactivate = this.getOption(options, "onPostDeactivate");
            const checkCanReturnFocus = this.getOption(options, "checkCanReturnFocus");
            const returnFocus = this.getOption(options, "returnFocus", "returnFocusOnDeactivate");
            onDeactivate?.();
            const finishDeactivation = ()=>{
                $39480da6128c25d0$var$delay(()=>{
                    if (returnFocus) {
                        const returnFocusNode = this.getReturnFocusNode(this.state.nodeFocusedBeforeActivation);
                        this.tryFocus(returnFocusNode);
                    }
                    onPostDeactivate?.();
                });
            };
            if (returnFocus && checkCanReturnFocus) {
                const returnFocusNode = this.getReturnFocusNode(this.state.nodeFocusedBeforeActivation);
                checkCanReturnFocus(returnFocusNode).then(finishDeactivation, finishDeactivation);
                return this;
            }
            finishDeactivation();
            return this;
        });
        $39480da6128c25d0$var$__publicField(this, "pause", (pauseOptions)=>{
            if (this.state.paused || !this.state.active) return this;
            const onPause = this.getOption(pauseOptions, "onPause");
            const onPostPause = this.getOption(pauseOptions, "onPostPause");
            this.state.paused = true;
            onPause?.();
            this.removeListeners();
            this.updateObservedNodes();
            onPostPause?.();
            return this;
        });
        $39480da6128c25d0$var$__publicField(this, "unpause", (unpauseOptions)=>{
            if (!this.state.paused || !this.state.active) return this;
            const onUnpause = this.getOption(unpauseOptions, "onUnpause");
            const onPostUnpause = this.getOption(unpauseOptions, "onPostUnpause");
            this.state.paused = false;
            onUnpause?.();
            this.updateTabbableNodes();
            this.addListeners();
            this.updateObservedNodes();
            onPostUnpause?.();
            return this;
        });
        $39480da6128c25d0$var$__publicField(this, "updateContainerElements", (containerElements)=>{
            this.state.containers = Array.isArray(containerElements) ? containerElements.filter(Boolean) : [
                containerElements
            ].filter(Boolean);
            if (this.state.active) this.updateTabbableNodes();
            this.updateObservedNodes();
            return this;
        });
        $39480da6128c25d0$var$__publicField(this, "getReturnFocusNode", (previousActiveElement)=>{
            const node = this.getNodeForOption("setReturnFocus", {
                params: [
                    previousActiveElement
                ]
            });
            return node ? node : node === false ? false : previousActiveElement;
        });
        $39480da6128c25d0$var$__publicField(this, "getOption", (configOverrideOptions, optionName, configOptionName)=>{
            return configOverrideOptions && configOverrideOptions[optionName] !== void 0 ? configOverrideOptions[optionName] : // @ts-expect-error
            this.config[configOptionName || optionName];
        });
        $39480da6128c25d0$var$__publicField(this, "getNodeForOption", (optionName, { hasFallback: hasFallback = false, params: params = [] } = {})=>{
            let optionValue = this.config[optionName];
            if (typeof optionValue === "function") optionValue = optionValue(...params);
            if (optionValue === true) optionValue = void 0;
            if (!optionValue) {
                if (optionValue === void 0 || optionValue === false) return optionValue;
                throw new Error(`\`${optionName}\` was specified but was not a node, or did not return a node`);
            }
            let node = optionValue;
            if (typeof optionValue === "string") {
                try {
                    node = this.doc.querySelector(optionValue);
                } catch (err) {
                    throw new Error(`\`${optionName}\` appears to be an invalid selector; error="${err.message}"`);
                }
                if (!node) {
                    if (!hasFallback) throw new Error(`\`${optionName}\` as selector refers to no known node`);
                }
            }
            return node;
        });
        $39480da6128c25d0$var$__publicField(this, "findNextNavNode", (opts)=>{
            const { event: event, isBackward: isBackward = false } = opts;
            const target = opts.target || (0, $b06ec5ff205338e5$export$e58f029f0fbfdb29)(event);
            this.updateTabbableNodes();
            let destinationNode = null;
            if (this.state.tabbableGroups.length > 0) {
                const containerIndex = this.findContainerIndex(target, event);
                const containerGroup = containerIndex >= 0 ? this.state.containerGroups[containerIndex] : void 0;
                if (containerIndex < 0) {
                    if (isBackward) destinationNode = this.state.tabbableGroups[this.state.tabbableGroups.length - 1].lastTabbableNode;
                    else destinationNode = this.state.tabbableGroups[0].firstTabbableNode;
                } else if (isBackward) {
                    let startOfGroupIndex = this.state.tabbableGroups.findIndex(({ firstTabbableNode: firstTabbableNode })=>target === firstTabbableNode);
                    if (startOfGroupIndex < 0 && (containerGroup?.container === target || (0, $b06ec5ff205338e5$export$4c063cf1350e6fed)(target) && !(0, $b06ec5ff205338e5$export$bebd5a1431fec25d)(target) && !containerGroup?.nextTabbableNode(target, false))) startOfGroupIndex = containerIndex;
                    if (startOfGroupIndex >= 0) {
                        const destinationGroupIndex = startOfGroupIndex === 0 ? this.state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
                        const destinationGroup = this.state.tabbableGroups[destinationGroupIndex];
                        destinationNode = (0, $b06ec5ff205338e5$export$a4672efddb4181b8)(target) >= 0 ? destinationGroup.lastTabbableNode : destinationGroup.lastDomTabbableNode;
                    } else if (!$39480da6128c25d0$var$isTabEvent(event)) destinationNode = containerGroup?.nextTabbableNode(target, false);
                } else {
                    let lastOfGroupIndex = this.state.tabbableGroups.findIndex(({ lastTabbableNode: lastTabbableNode })=>target === lastTabbableNode);
                    if (lastOfGroupIndex < 0 && (containerGroup?.container === target || (0, $b06ec5ff205338e5$export$4c063cf1350e6fed)(target) && !(0, $b06ec5ff205338e5$export$bebd5a1431fec25d)(target) && !containerGroup?.nextTabbableNode(target))) lastOfGroupIndex = containerIndex;
                    if (lastOfGroupIndex >= 0) {
                        const destinationGroupIndex = lastOfGroupIndex === this.state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
                        const destinationGroup = this.state.tabbableGroups[destinationGroupIndex];
                        destinationNode = (0, $b06ec5ff205338e5$export$a4672efddb4181b8)(target) >= 0 ? destinationGroup.firstTabbableNode : destinationGroup.firstDomTabbableNode;
                    } else if (!$39480da6128c25d0$var$isTabEvent(event)) destinationNode = containerGroup?.nextTabbableNode(target);
                }
            } else destinationNode = this.getNodeForOption("fallbackFocus");
            return destinationNode;
        });
        this.trapStack = options.trapStack || $39480da6128c25d0$var$sharedTrapStack;
        const config = {
            returnFocusOnDeactivate: true,
            escapeDeactivates: true,
            delayInitialFocus: true,
            isKeyForward (e) {
                return $39480da6128c25d0$var$isTabEvent(e) && !e.shiftKey;
            },
            isKeyBackward (e) {
                return $39480da6128c25d0$var$isTabEvent(e) && e.shiftKey;
            },
            ...options
        };
        this.doc = config.document || (0, $b06ec5ff205338e5$export$f65ca476c09acec0)(Array.isArray(elements) ? elements[0] : elements);
        this.config = config;
        this.updateContainerElements(elements);
        this.setupMutationObserver();
    }
    get active() {
        return this.state.active;
    }
    get paused() {
        return this.state.paused;
    }
    findContainerIndex(element, event) {
        const composedPath = typeof event?.composedPath === "function" ? event.composedPath() : void 0;
        return this.state.containerGroups.findIndex(({ container: container, tabbableNodes: tabbableNodes })=>container.contains(element) || composedPath?.includes(container) || tabbableNodes.find((node)=>node === element));
    }
    updateTabbableNodes() {
        this.state.containerGroups = this.state.containers.map((container)=>{
            const tabbableNodes = (0, $b06ec5ff205338e5$export$5f161a4b62f9e29a)(container);
            const focusableNodes = (0, $b06ec5ff205338e5$export$f6768025e418420e)(container);
            const firstTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[0] : void 0;
            const lastTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : void 0;
            const firstDomTabbableNode = focusableNodes.find((node)=>(0, $b06ec5ff205338e5$export$bebd5a1431fec25d)(node));
            const lastDomTabbableNode = focusableNodes.slice().reverse().find((node)=>(0, $b06ec5ff205338e5$export$bebd5a1431fec25d)(node));
            const posTabIndexesFound = !!tabbableNodes.find((node)=>(0, $b06ec5ff205338e5$export$a4672efddb4181b8)(node) > 0);
            function nextTabbableNode(node, forward = true) {
                const nodeIdx = tabbableNodes.indexOf(node);
                if (nodeIdx < 0) {
                    if (forward) return focusableNodes.slice(focusableNodes.indexOf(node) + 1).find((el)=>(0, $b06ec5ff205338e5$export$bebd5a1431fec25d)(el));
                    return focusableNodes.slice(0, focusableNodes.indexOf(node)).reverse().find((el)=>(0, $b06ec5ff205338e5$export$bebd5a1431fec25d)(el));
                }
                return tabbableNodes[nodeIdx + (forward ? 1 : -1)];
            }
            return {
                container: container,
                tabbableNodes: tabbableNodes,
                focusableNodes: focusableNodes,
                posTabIndexesFound: posTabIndexesFound,
                firstTabbableNode: firstTabbableNode,
                lastTabbableNode: lastTabbableNode,
                firstDomTabbableNode: firstDomTabbableNode,
                lastDomTabbableNode: lastDomTabbableNode,
                nextTabbableNode: nextTabbableNode
            };
        });
        this.state.tabbableGroups = this.state.containerGroups.filter((group)=>group.tabbableNodes.length > 0);
        if (this.state.tabbableGroups.length <= 0 && !this.getNodeForOption("fallbackFocus")) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
        if (this.state.containerGroups.find((g)=>g.posTabIndexesFound) && this.state.containerGroups.length > 1) throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
    }
    addListeners() {
        if (!this.state.active) return;
        $39480da6128c25d0$var$activeFocusTraps.activateTrap(this.trapStack, this);
        this.state.delayInitialFocusTimer = this.config.delayInitialFocus ? $39480da6128c25d0$var$delay(()=>{
            this.tryFocus(this.getInitialFocusNode());
        }) : this.tryFocus(this.getInitialFocusNode());
        this.listenerCleanups.push((0, $b06ec5ff205338e5$export$b1d829ddf82884aa)(this.doc, "focusin", this.handleFocus, true), (0, $b06ec5ff205338e5$export$b1d829ddf82884aa)(this.doc, "mousedown", this.handlePointerDown, {
            capture: true,
            passive: false
        }), (0, $b06ec5ff205338e5$export$b1d829ddf82884aa)(this.doc, "touchstart", this.handlePointerDown, {
            capture: true,
            passive: false
        }), (0, $b06ec5ff205338e5$export$b1d829ddf82884aa)(this.doc, "click", this.handleClick, {
            capture: true,
            passive: false
        }), (0, $b06ec5ff205338e5$export$b1d829ddf82884aa)(this.doc, "keydown", this.handleTabKey, {
            capture: true,
            passive: false
        }), (0, $b06ec5ff205338e5$export$b1d829ddf82884aa)(this.doc, "keydown", this.handleEscapeKey));
        return this;
    }
    removeListeners() {
        if (!this.state.active) return;
        this.listenerCleanups.forEach((cleanup)=>cleanup());
        this.listenerCleanups = [];
        return this;
    }
    activate(activateOptions) {
        if (this.state.active) return this;
        const onActivate = this.getOption(activateOptions, "onActivate");
        const onPostActivate = this.getOption(activateOptions, "onPostActivate");
        const checkCanFocusTrap = this.getOption(activateOptions, "checkCanFocusTrap");
        if (!checkCanFocusTrap) this.updateTabbableNodes();
        this.state.active = true;
        this.state.paused = false;
        this.state.nodeFocusedBeforeActivation = this.doc.activeElement || null;
        onActivate?.();
        const finishActivation = ()=>{
            if (checkCanFocusTrap) this.updateTabbableNodes();
            this.addListeners();
            this.updateObservedNodes();
            onPostActivate?.();
        };
        if (checkCanFocusTrap) {
            checkCanFocusTrap(this.state.containers.concat()).then(finishActivation, finishActivation);
            return this;
        }
        finishActivation();
        return this;
    }
};
var $39480da6128c25d0$var$isTabEvent = (event)=>event.key === "Tab";
var $39480da6128c25d0$var$valueOrHandler = (value, ...params)=>typeof value === "function" ? value(...params) : value;
var $39480da6128c25d0$var$isEscapeEvent = (event)=>!event.isComposing && event.key === "Escape";
var $39480da6128c25d0$var$delay = (fn)=>setTimeout(fn, 0);
var $39480da6128c25d0$var$isSelectableInput = (node)=>node.localName === "input" && "select" in node && typeof node.select === "function";
// src/index.ts
function $39480da6128c25d0$export$bec45a54c2e66c22(el, options = {}) {
    let trap;
    const cleanup = (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>{
        const contentEl = typeof el === "function" ? el() : el;
        if (!contentEl) return;
        trap = new $39480da6128c25d0$export$34eba2437817a67b(contentEl, {
            escapeDeactivates: false,
            allowOutsideClick: true,
            preventScroll: true,
            returnFocusOnDeactivate: true,
            delayInitialFocus: false,
            fallbackFocus: contentEl,
            ...options,
            document: (0, $b06ec5ff205338e5$export$f65ca476c09acec0)(contentEl)
        });
        try {
            trap.activate();
        } catch  {}
    });
    return function destroy() {
        trap?.deactivate();
        cleanup();
    };
}



// src/index.ts
var $c5b78d1d10851f7e$var$LOCK_CLASSNAME = "data-scroll-lock";
function $c5b78d1d10851f7e$var$assignStyle(el, style) {
    if (!el) return;
    const previousStyle = Object.keys(style).reduce((acc, key)=>{
        acc[key] = el.style.getPropertyValue(key);
        return acc;
    }, {});
    Object.assign(el.style, style);
    return ()=>{
        Object.assign(el.style, previousStyle);
    };
}
function $c5b78d1d10851f7e$var$setCSSProperty(el, property, value) {
    if (!el) return;
    const previousValue = el.style.getPropertyValue(property);
    el.style.setProperty(property, value);
    return ()=>{
        if (previousValue) el.style.setProperty(property, previousValue);
        else el.style.removeProperty(property);
    };
}
function $c5b78d1d10851f7e$var$getPaddingProperty(documentElement) {
    const documentLeft = documentElement.getBoundingClientRect().left;
    const scrollbarX = Math.round(documentLeft) + documentElement.scrollLeft;
    return scrollbarX ? "paddingLeft" : "paddingRight";
}
function $c5b78d1d10851f7e$export$253461bf837fc8c7(_document) {
    const doc = _document ?? document;
    const win = doc.defaultView ?? window;
    const { documentElement: documentElement, body: body } = doc;
    const locked = body.hasAttribute($c5b78d1d10851f7e$var$LOCK_CLASSNAME);
    if (locked) return;
    body.setAttribute($c5b78d1d10851f7e$var$LOCK_CLASSNAME, "");
    const scrollbarWidth = win.innerWidth - documentElement.clientWidth;
    const setScrollbarWidthProperty = ()=>$c5b78d1d10851f7e$var$setCSSProperty(documentElement, "--scrollbar-width", `${scrollbarWidth}px`);
    const paddingProperty = $c5b78d1d10851f7e$var$getPaddingProperty(documentElement);
    const setStyle = ()=>$c5b78d1d10851f7e$var$assignStyle(body, {
            overflow: "hidden",
            [paddingProperty]: `${scrollbarWidth}px`
        });
    const setIOSStyle = ()=>{
        const { scrollX: scrollX, scrollY: scrollY, visualViewport: visualViewport } = win;
        const offsetLeft = visualViewport?.offsetLeft ?? 0;
        const offsetTop = visualViewport?.offsetTop ?? 0;
        const restoreStyle = $c5b78d1d10851f7e$var$assignStyle(body, {
            position: "fixed",
            overflow: "hidden",
            top: `${-(scrollY - Math.floor(offsetTop))}px`,
            left: `${-(scrollX - Math.floor(offsetLeft))}px`,
            right: "0",
            [paddingProperty]: `${scrollbarWidth}px`
        });
        return ()=>{
            restoreStyle?.();
            win.scrollTo({
                left: scrollX,
                top: scrollY,
                behavior: "instant"
            });
        };
    };
    const cleanups = [
        setScrollbarWidthProperty(),
        (0, $b06ec5ff205338e5$export$41a665f744414057)() ? setIOSStyle() : setStyle()
    ];
    return ()=>{
        cleanups.forEach((fn)=>fn?.());
        body.removeAttribute($c5b78d1d10851f7e$var$LOCK_CLASSNAME);
    };
}




// src/dialog.anatomy.ts
var $836c8b81cf0cf8be$export$477202748c7242bf = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("dialog").parts("trigger", "backdrop", "positioner", "content", "title", "description", "closeTrigger");
var $836c8b81cf0cf8be$var$parts = $836c8b81cf0cf8be$export$477202748c7242bf.build();
var $836c8b81cf0cf8be$var$dom = (0, $b06ec5ff205338e5$export$41a9651decfe2bde)({
    getPositionerId: (ctx)=>ctx.ids?.positioner ?? `dialog:${ctx.id}:positioner`,
    getBackdropId: (ctx)=>ctx.ids?.backdrop ?? `dialog:${ctx.id}:backdrop`,
    getContentId: (ctx)=>ctx.ids?.content ?? `dialog:${ctx.id}:content`,
    getTriggerId: (ctx)=>ctx.ids?.trigger ?? `dialog:${ctx.id}:trigger`,
    getTitleId: (ctx)=>ctx.ids?.title ?? `dialog:${ctx.id}:title`,
    getDescriptionId: (ctx)=>ctx.ids?.description ?? `dialog:${ctx.id}:description`,
    getCloseTriggerId: (ctx)=>ctx.ids?.closeTrigger ?? `dialog:${ctx.id}:close`,
    getContentEl: (ctx)=>$836c8b81cf0cf8be$var$dom.getById(ctx, $836c8b81cf0cf8be$var$dom.getContentId(ctx)),
    getPositionerEl: (ctx)=>$836c8b81cf0cf8be$var$dom.getById(ctx, $836c8b81cf0cf8be$var$dom.getPositionerId(ctx)),
    getBackdropEl: (ctx)=>$836c8b81cf0cf8be$var$dom.getById(ctx, $836c8b81cf0cf8be$var$dom.getBackdropId(ctx)),
    getTriggerEl: (ctx)=>$836c8b81cf0cf8be$var$dom.getById(ctx, $836c8b81cf0cf8be$var$dom.getTriggerId(ctx)),
    getTitleEl: (ctx)=>$836c8b81cf0cf8be$var$dom.getById(ctx, $836c8b81cf0cf8be$var$dom.getTitleId(ctx)),
    getDescriptionEl: (ctx)=>$836c8b81cf0cf8be$var$dom.getById(ctx, $836c8b81cf0cf8be$var$dom.getDescriptionId(ctx)),
    getCloseTriggerEl: (ctx)=>$836c8b81cf0cf8be$var$dom.getById(ctx, $836c8b81cf0cf8be$var$dom.getCloseTriggerId(ctx))
});
// src/dialog.connect.ts
function $836c8b81cf0cf8be$export$64605811ab45167f(state, send, normalize) {
    const ariaLabel = state.context["aria-label"];
    const open = state.matches("open");
    const rendered = state.context.renderedElements;
    return {
        open: open,
        setOpen (nextOpen) {
            if (nextOpen === open) return;
            send(nextOpen ? "OPEN" : "CLOSE");
        },
        getTriggerProps () {
            return normalize.button({
                ...$836c8b81cf0cf8be$var$parts.trigger.attrs,
                dir: state.context.dir,
                id: $836c8b81cf0cf8be$var$dom.getTriggerId(state.context),
                "aria-haspopup": "dialog",
                type: "button",
                "aria-expanded": open,
                "data-state": open ? "open" : "closed",
                "aria-controls": $836c8b81cf0cf8be$var$dom.getContentId(state.context),
                onClick (event) {
                    if (event.defaultPrevented) return;
                    send("TOGGLE");
                }
            });
        },
        getBackdropProps () {
            return normalize.element({
                ...$836c8b81cf0cf8be$var$parts.backdrop.attrs,
                dir: state.context.dir,
                hidden: !open,
                id: $836c8b81cf0cf8be$var$dom.getBackdropId(state.context),
                "data-state": open ? "open" : "closed"
            });
        },
        getPositionerProps () {
            return normalize.element({
                ...$836c8b81cf0cf8be$var$parts.positioner.attrs,
                dir: state.context.dir,
                id: $836c8b81cf0cf8be$var$dom.getPositionerId(state.context),
                style: {
                    pointerEvents: open ? void 0 : "none"
                }
            });
        },
        getContentProps () {
            return normalize.element({
                ...$836c8b81cf0cf8be$var$parts.content.attrs,
                dir: state.context.dir,
                role: state.context.role,
                hidden: !open,
                id: $836c8b81cf0cf8be$var$dom.getContentId(state.context),
                tabIndex: -1,
                "data-state": open ? "open" : "closed",
                "aria-modal": true,
                "aria-label": ariaLabel || void 0,
                "aria-labelledby": ariaLabel || !rendered.title ? void 0 : $836c8b81cf0cf8be$var$dom.getTitleId(state.context),
                "aria-describedby": rendered.description ? $836c8b81cf0cf8be$var$dom.getDescriptionId(state.context) : void 0
            });
        },
        getTitleProps () {
            return normalize.element({
                ...$836c8b81cf0cf8be$var$parts.title.attrs,
                dir: state.context.dir,
                id: $836c8b81cf0cf8be$var$dom.getTitleId(state.context)
            });
        },
        getDescriptionProps () {
            return normalize.element({
                ...$836c8b81cf0cf8be$var$parts.description.attrs,
                dir: state.context.dir,
                id: $836c8b81cf0cf8be$var$dom.getDescriptionId(state.context)
            });
        },
        getCloseTriggerProps () {
            return normalize.button({
                ...$836c8b81cf0cf8be$var$parts.closeTrigger.attrs,
                dir: state.context.dir,
                id: $836c8b81cf0cf8be$var$dom.getCloseTriggerId(state.context),
                type: "button",
                onClick (event) {
                    if (event.defaultPrevented) return;
                    event.stopPropagation();
                    send("CLOSE");
                }
            });
        }
    };
}
function $836c8b81cf0cf8be$export$ea56d40cd27c3480(userContext) {
    const ctx = (0, $89352e0ddd72597a$export$8e16b83750b44988)(userContext);
    return (0, $5c0da97e9c7aa95f$export$aaa7fa18f8e9b2e8)({
        id: "dialog",
        initial: ctx.open ? "open" : "closed",
        context: {
            role: "dialog",
            renderedElements: {
                title: true,
                description: true
            },
            modal: true,
            trapFocus: true,
            preventScroll: true,
            closeOnInteractOutside: true,
            closeOnEscape: true,
            restoreFocus: true,
            ...ctx
        },
        created: [
            "setAlertDialogProps"
        ],
        watch: {
            open: [
                "toggleVisibility"
            ]
        },
        states: {
            open: {
                entry: [
                    "checkRenderedElements",
                    "syncZIndex"
                ],
                activities: [
                    "trackDismissableElement",
                    "trapFocus",
                    "preventScroll",
                    "hideContentBelow"
                ],
                on: {
                    "CONTROLLED.CLOSE": {
                        target: "closed"
                    },
                    CLOSE: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnClose"
                            ]
                        },
                        {
                            target: "closed",
                            actions: [
                                "invokeOnClose"
                            ]
                        }
                    ],
                    TOGGLE: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnClose"
                            ]
                        },
                        {
                            target: "closed",
                            actions: [
                                "invokeOnClose"
                            ]
                        }
                    ]
                }
            },
            closed: {
                on: {
                    "CONTROLLED.OPEN": {
                        target: "open"
                    },
                    OPEN: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnOpen"
                            ]
                        },
                        {
                            target: "open",
                            actions: [
                                "invokeOnOpen"
                            ]
                        }
                    ],
                    TOGGLE: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnOpen"
                            ]
                        },
                        {
                            target: "open",
                            actions: [
                                "invokeOnOpen"
                            ]
                        }
                    ]
                }
            }
        }
    }, {
        guards: {
            isOpenControlled: (ctx2)=>!!ctx2["open.controlled"]
        },
        activities: {
            trackDismissableElement (ctx2, _evt, { send: send }) {
                const getContentEl = ()=>$836c8b81cf0cf8be$var$dom.getContentEl(ctx2);
                return (0, $a0385836474f3c11$export$72bda0e502b8ea31)(getContentEl, {
                    defer: true,
                    pointerBlocking: ctx2.modal,
                    exclude: [
                        $836c8b81cf0cf8be$var$dom.getTriggerEl(ctx2)
                    ],
                    onInteractOutside (event) {
                        ctx2.onInteractOutside?.(event);
                        if (!ctx2.closeOnInteractOutside) event.preventDefault();
                    },
                    persistentElements: ctx2.persistentElements,
                    onFocusOutside: ctx2.onFocusOutside,
                    onPointerDownOutside: ctx2.onPointerDownOutside,
                    onEscapeKeyDown (event) {
                        ctx2.onEscapeKeyDown?.(event);
                        if (!ctx2.closeOnEscape) event.preventDefault();
                    },
                    onDismiss () {
                        send({
                            type: "CLOSE",
                            src: "interact-outside"
                        });
                    }
                });
            },
            preventScroll (ctx2) {
                if (!ctx2.preventScroll) return;
                return (0, $c5b78d1d10851f7e$export$253461bf837fc8c7)($836c8b81cf0cf8be$var$dom.getDoc(ctx2));
            },
            trapFocus (ctx2) {
                if (!ctx2.trapFocus || !ctx2.modal) return;
                const contentEl = ()=>$836c8b81cf0cf8be$var$dom.getContentEl(ctx2);
                return (0, $39480da6128c25d0$export$bec45a54c2e66c22)(contentEl, {
                    preventScroll: true,
                    returnFocusOnDeactivate: !!ctx2.restoreFocus,
                    initialFocus: ctx2.initialFocusEl,
                    setReturnFocus: (el)=>ctx2.finalFocusEl?.() ?? el
                });
            },
            hideContentBelow (ctx2) {
                if (!ctx2.modal) return;
                const getElements = ()=>[
                        $836c8b81cf0cf8be$var$dom.getContentEl(ctx2)
                    ];
                return (0, $ef6836a155f3b375$export$e1bd0c6150f13d96)(getElements, {
                    defer: true
                });
            }
        },
        actions: {
            setAlertDialogProps (ctx2) {
                if (ctx2.role !== "alertdialog") return;
                ctx2.initialFocusEl || (ctx2.initialFocusEl = ()=>$836c8b81cf0cf8be$var$dom.getCloseTriggerEl(ctx2));
                ctx2.closeOnInteractOutside = false;
            },
            checkRenderedElements (ctx2) {
                (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>{
                    ctx2.renderedElements.title = !!$836c8b81cf0cf8be$var$dom.getTitleEl(ctx2);
                    ctx2.renderedElements.description = !!$836c8b81cf0cf8be$var$dom.getDescriptionEl(ctx2);
                });
            },
            syncZIndex (ctx2) {
                (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>{
                    const contentEl = $836c8b81cf0cf8be$var$dom.getContentEl(ctx2);
                    if (!contentEl) return;
                    const styles = (0, $b06ec5ff205338e5$export$3735103072e4a80)(contentEl);
                    const elems = [
                        $836c8b81cf0cf8be$var$dom.getPositionerEl(ctx2),
                        $836c8b81cf0cf8be$var$dom.getBackdropEl(ctx2)
                    ];
                    elems.forEach((node)=>{
                        node?.style.setProperty("--z-index", styles.zIndex);
                    });
                });
            },
            invokeOnClose (ctx2) {
                ctx2.onOpenChange?.({
                    open: false
                });
            },
            invokeOnOpen (ctx2) {
                ctx2.onOpenChange?.({
                    open: true
                });
            },
            toggleVisibility (ctx2, evt, { send: send }) {
                send({
                    type: ctx2.open ? "CONTROLLED.OPEN" : "CONTROLLED.CLOSE",
                    previousEvent: evt
                });
            }
        }
    });
}
var $836c8b81cf0cf8be$export$8128bb6492cf3de7 = (0, $5b359805fda5a40e$export$c94ea207b45fef3a)()([
    "aria-label",
    "closeOnEscape",
    "closeOnInteractOutside",
    "dir",
    "finalFocusEl",
    "getRootNode",
    "getRootNode",
    "id",
    "id",
    "ids",
    "initialFocusEl",
    "modal",
    "onEscapeKeyDown",
    "onFocusOutside",
    "onInteractOutside",
    "onOpenChange",
    "onPointerDownOutside",
    "open.controlled",
    "open",
    "persistentElements",
    "preventScroll",
    "restoreFocus",
    "role",
    "trapFocus"
]);
var $836c8b81cf0cf8be$export$45029c61b0073d87 = (0, $89352e0ddd72597a$export$3ea53b214fbc1986)($836c8b81cf0cf8be$export$8128bb6492cf3de7);








// src/editable.anatomy.ts
var $9cfeac3ec88442fd$export$477202748c7242bf = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("editable").parts("root", "area", "label", "preview", "input", "editTrigger", "submitTrigger", "cancelTrigger", "control");
var $9cfeac3ec88442fd$var$parts = $9cfeac3ec88442fd$export$477202748c7242bf.build();
var $9cfeac3ec88442fd$var$dom = (0, $b06ec5ff205338e5$export$41a9651decfe2bde)({
    getRootId: (ctx)=>ctx.ids?.root ?? `editable:${ctx.id}`,
    getAreaId: (ctx)=>ctx.ids?.area ?? `editable:${ctx.id}:area`,
    getLabelId: (ctx)=>ctx.ids?.label ?? `editable:${ctx.id}:label`,
    getPreviewId: (ctx)=>ctx.ids?.preview ?? `editable:${ctx.id}:preview`,
    getInputId: (ctx)=>ctx.ids?.input ?? `editable:${ctx.id}:input`,
    getControlId: (ctx)=>ctx.ids?.control ?? `editable:${ctx.id}:control`,
    getSubmitTriggerId: (ctx)=>ctx.ids?.submitTrigger ?? `editable:${ctx.id}:submit`,
    getCancelTriggerId: (ctx)=>ctx.ids?.cancelTrigger ?? `editable:${ctx.id}:cancel`,
    getEditTriggerId: (ctx)=>ctx.ids?.editTrigger ?? `editable:${ctx.id}:edit`,
    getInputEl: (ctx)=>$9cfeac3ec88442fd$var$dom.getById(ctx, $9cfeac3ec88442fd$var$dom.getInputId(ctx)),
    getPreviewEl: (ctx)=>$9cfeac3ec88442fd$var$dom.getById(ctx, $9cfeac3ec88442fd$var$dom.getPreviewId(ctx)),
    getSubmitTriggerEl: (ctx)=>$9cfeac3ec88442fd$var$dom.getById(ctx, $9cfeac3ec88442fd$var$dom.getSubmitTriggerId(ctx)),
    getCancelTriggerEl: (ctx)=>$9cfeac3ec88442fd$var$dom.getById(ctx, $9cfeac3ec88442fd$var$dom.getCancelTriggerId(ctx)),
    getEditTriggerEl: (ctx)=>$9cfeac3ec88442fd$var$dom.getById(ctx, $9cfeac3ec88442fd$var$dom.getEditTriggerId(ctx))
});
// src/editable.connect.ts
function $9cfeac3ec88442fd$export$64605811ab45167f(state, send, normalize) {
    const disabled = state.context.disabled;
    const interactive = state.context.isInteractive;
    const readOnly = state.context.readOnly;
    const invalid = state.context.invalid;
    const autoResize = state.context.autoResize;
    const translations = state.context.translations;
    const editing = state.matches("edit");
    const placeholderProp = state.context.placeholder;
    const placeholder = typeof placeholderProp === "string" ? {
        edit: placeholderProp,
        preview: placeholderProp
    } : placeholderProp;
    const value = state.context.value;
    const empty = value.trim() === "";
    const valueText = empty ? placeholder?.preview ?? "" : value;
    return {
        editing: editing,
        empty: empty,
        value: value,
        valueText: valueText,
        setValue (value2) {
            send({
                type: "VALUE.SET",
                value: value2,
                src: "setValue"
            });
        },
        clearValue () {
            send({
                type: "VALUE.SET",
                value: "",
                src: "clearValue"
            });
        },
        edit () {
            if (!interactive) return;
            send("EDIT");
        },
        cancel () {
            if (!interactive) return;
            send("CANCEL");
        },
        submit () {
            if (!interactive) return;
            send("SUBMIT");
        },
        getRootProps () {
            return normalize.element({
                ...$9cfeac3ec88442fd$var$parts.root.attrs,
                id: $9cfeac3ec88442fd$var$dom.getRootId(state.context),
                dir: state.context.dir
            });
        },
        getAreaProps () {
            return normalize.element({
                ...$9cfeac3ec88442fd$var$parts.area.attrs,
                id: $9cfeac3ec88442fd$var$dom.getAreaId(state.context),
                dir: state.context.dir,
                style: autoResize ? {
                    display: "inline-grid"
                } : void 0,
                "data-focus": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(editing),
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-placeholder-shown": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(empty)
            });
        },
        getLabelProps () {
            return normalize.label({
                ...$9cfeac3ec88442fd$var$parts.label.attrs,
                id: $9cfeac3ec88442fd$var$dom.getLabelId(state.context),
                dir: state.context.dir,
                htmlFor: $9cfeac3ec88442fd$var$dom.getInputId(state.context),
                "data-focus": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(editing),
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(invalid),
                onClick () {
                    if (editing) return;
                    const previewEl = $9cfeac3ec88442fd$var$dom.getPreviewEl(state.context);
                    previewEl?.focus({
                        preventScroll: true
                    });
                }
            });
        },
        getInputProps () {
            return normalize.input({
                ...$9cfeac3ec88442fd$var$parts.input.attrs,
                dir: state.context.dir,
                "aria-label": translations.input,
                name: state.context.name,
                form: state.context.form,
                id: $9cfeac3ec88442fd$var$dom.getInputId(state.context),
                hidden: autoResize ? void 0 : !editing,
                placeholder: placeholder?.edit,
                maxLength: state.context.maxLength,
                required: state.context.required,
                disabled: disabled,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                readOnly: readOnly,
                "data-readonly": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(readOnly),
                "aria-invalid": (0, $b06ec5ff205338e5$export$91a6105db3d4be7b)(invalid),
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(invalid),
                "data-autoresize": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(autoResize),
                defaultValue: value,
                size: autoResize ? 1 : void 0,
                onChange (event) {
                    send({
                        type: "VALUE.SET",
                        src: "input.change",
                        value: event.currentTarget.value
                    });
                },
                onKeyDown (event) {
                    if (event.defaultPrevented) return;
                    if ((0, $b06ec5ff205338e5$export$49e72d3db4288c1)(event)) return;
                    const keyMap = {
                        Escape () {
                            send("CANCEL");
                            event.preventDefault();
                        },
                        Enter (event2) {
                            if (!state.context.submitOnEnter) return;
                            const { localName: localName } = event2.currentTarget;
                            if (localName === "textarea") {
                                const submitMod = (0, $b06ec5ff205338e5$export$5231b1f790f5c149)() ? event2.metaKey : event2.ctrlKey;
                                if (!submitMod) return;
                                send({
                                    type: "SUBMIT",
                                    src: "keydown.enter"
                                });
                                return;
                            }
                            if (localName === "input" && !event2.shiftKey && !event2.metaKey) {
                                send({
                                    type: "SUBMIT",
                                    src: "keydown.enter"
                                });
                                event2.preventDefault();
                            }
                        }
                    };
                    const exec = keyMap[event.key];
                    if (exec) exec(event);
                },
                style: autoResize ? {
                    gridArea: "1 / 1 / auto / auto",
                    visibility: !editing ? "hidden" : void 0
                } : void 0
            });
        },
        getPreviewProps () {
            return normalize.element({
                id: $9cfeac3ec88442fd$var$dom.getPreviewId(state.context),
                ...$9cfeac3ec88442fd$var$parts.preview.attrs,
                dir: state.context.dir,
                "data-placeholder-shown": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(empty),
                "aria-readonly": (0, $b06ec5ff205338e5$export$91a6105db3d4be7b)(readOnly),
                "data-readonly": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "aria-disabled": (0, $b06ec5ff205338e5$export$91a6105db3d4be7b)(disabled),
                "aria-invalid": (0, $b06ec5ff205338e5$export$91a6105db3d4be7b)(invalid),
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(invalid),
                "aria-label": translations.edit,
                "data-autoresize": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(autoResize),
                children: valueText,
                hidden: autoResize ? void 0 : editing,
                tabIndex: interactive ? 0 : void 0,
                onClick () {
                    if (!interactive) return;
                    if (state.context.activationMode !== "click") return;
                    send({
                        type: "EDIT",
                        src: "click"
                    });
                },
                onFocus () {
                    if (!interactive) return;
                    if (state.context.activationMode !== "focus") return;
                    send({
                        type: "EDIT",
                        src: "focus"
                    });
                },
                onDoubleClick (event) {
                    if (event.defaultPrevented) return;
                    if (!interactive) return;
                    if (state.context.activationMode !== "dblclick") return;
                    send({
                        type: "EDIT",
                        src: "dblclick"
                    });
                },
                style: autoResize ? {
                    whiteSpace: "pre",
                    userSelect: "none",
                    gridArea: "1 / 1 / auto / auto",
                    visibility: editing ? "hidden" : void 0,
                    // in event the preview overflow's the parent element
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                } : void 0
            });
        },
        getEditTriggerProps () {
            return normalize.button({
                ...$9cfeac3ec88442fd$var$parts.editTrigger.attrs,
                id: $9cfeac3ec88442fd$var$dom.getEditTriggerId(state.context),
                dir: state.context.dir,
                "aria-label": translations.edit,
                hidden: editing,
                type: "button",
                disabled: disabled,
                onClick (event) {
                    if (event.defaultPrevented) return;
                    if (!interactive) return;
                    send({
                        type: "EDIT",
                        src: "edit.click"
                    });
                }
            });
        },
        getControlProps () {
            return normalize.element({
                id: $9cfeac3ec88442fd$var$dom.getControlId(state.context),
                ...$9cfeac3ec88442fd$var$parts.control.attrs,
                dir: state.context.dir
            });
        },
        getSubmitTriggerProps () {
            return normalize.button({
                ...$9cfeac3ec88442fd$var$parts.submitTrigger.attrs,
                dir: state.context.dir,
                id: $9cfeac3ec88442fd$var$dom.getSubmitTriggerId(state.context),
                "aria-label": translations.submit,
                hidden: !editing,
                disabled: disabled,
                type: "button",
                onClick (event) {
                    if (event.defaultPrevented) return;
                    if (!interactive) return;
                    send({
                        type: "SUBMIT",
                        src: "submit.click"
                    });
                }
            });
        },
        getCancelTriggerProps () {
            return normalize.button({
                ...$9cfeac3ec88442fd$var$parts.cancelTrigger.attrs,
                dir: state.context.dir,
                "aria-label": translations.cancel,
                id: $9cfeac3ec88442fd$var$dom.getCancelTriggerId(state.context),
                hidden: !editing,
                type: "button",
                disabled: disabled,
                onClick (event) {
                    if (event.defaultPrevented) return;
                    if (!interactive) return;
                    send({
                        type: "CANCEL",
                        src: "cancel.click"
                    });
                }
            });
        }
    };
}
var $9cfeac3ec88442fd$var$submitOnEnter = (ctx)=>[
        "both",
        "enter"
    ].includes(ctx.submitMode);
var $9cfeac3ec88442fd$var$submitOnBlur = (ctx)=>[
        "both",
        "blur"
    ].includes(ctx.submitMode);
function $9cfeac3ec88442fd$export$ea56d40cd27c3480(userContext) {
    const ctx = (0, $89352e0ddd72597a$export$8e16b83750b44988)(userContext);
    return (0, $5c0da97e9c7aa95f$export$aaa7fa18f8e9b2e8)({
        id: "editable",
        initial: ctx.edit ? "edit" : "preview",
        entry: ctx.edit ? [
            "focusInput"
        ] : void 0,
        context: {
            activationMode: "focus",
            submitMode: "both",
            value: "",
            previousValue: "",
            selectOnFocus: true,
            disabled: false,
            readOnly: false,
            ...ctx,
            translations: {
                input: "editable input",
                edit: "edit",
                submit: "submit",
                cancel: "cancel",
                ...ctx.translations
            }
        },
        watch: {
            value: [
                "syncInputValue"
            ],
            edit: [
                "toggleEditing"
            ]
        },
        computed: {
            submitOnEnter: $9cfeac3ec88442fd$var$submitOnEnter,
            submitOnBlur: $9cfeac3ec88442fd$var$submitOnBlur,
            isInteractive: (ctx2)=>!(ctx2.disabled || ctx2.readOnly)
        },
        on: {
            "VALUE.SET": {
                actions: "setValue"
            }
        },
        states: {
            preview: {
                // https://bugzilla.mozilla.org/show_bug.cgi?id=559561
                entry: [
                    "blurInputIfNeeded"
                ],
                on: {
                    "CONTROLLED.EDIT": {
                        target: "edit",
                        actions: [
                            "setPreviousValue",
                            "focusInput"
                        ]
                    },
                    EDIT: [
                        {
                            guard: "isEditControlled",
                            actions: [
                                "invokeOnEdit"
                            ]
                        },
                        {
                            target: "edit",
                            actions: [
                                "setPreviousValue",
                                "focusInput",
                                "invokeOnEdit"
                            ]
                        }
                    ]
                }
            },
            edit: {
                activities: [
                    "trackInteractOutside"
                ],
                on: {
                    "CONTROLLED.PREVIEW": [
                        {
                            guard: "isSubmitEvent",
                            target: "preview",
                            actions: [
                                "setPreviousValue",
                                "restoreFocus",
                                "invokeOnSubmit"
                            ]
                        },
                        {
                            target: "preview",
                            actions: [
                                "revertValue",
                                "restoreFocus",
                                "invokeOnCancel"
                            ]
                        }
                    ],
                    CANCEL: [
                        {
                            guard: "isEditControlled",
                            actions: [
                                "invokeOnPreview"
                            ]
                        },
                        {
                            target: "preview",
                            actions: [
                                "revertValue",
                                "restoreFocus",
                                "invokeOnCancel",
                                "invokeOnPreview"
                            ]
                        }
                    ],
                    SUBMIT: [
                        {
                            guard: "isEditControlled",
                            actions: [
                                "invokeOnPreview"
                            ]
                        },
                        {
                            target: "preview",
                            actions: [
                                "setPreviousValue",
                                "restoreFocus",
                                "invokeOnSubmit",
                                "invokeOnPreview"
                            ]
                        }
                    ]
                }
            }
        }
    }, {
        guards: {
            isEditControlled: (ctx2)=>!!ctx2["edit.controlled"],
            isSubmitEvent: (_ctx, evt)=>evt.previousEvent?.type === "SUBMIT"
        },
        activities: {
            trackInteractOutside (ctx2, _evt, { send: send }) {
                return (0, $bd9239a4339fbad2$export$15e1dde088f1e162)($9cfeac3ec88442fd$var$dom.getInputEl(ctx2), {
                    exclude (target) {
                        const ignore = [
                            $9cfeac3ec88442fd$var$dom.getCancelTriggerEl(ctx2),
                            $9cfeac3ec88442fd$var$dom.getSubmitTriggerEl(ctx2)
                        ];
                        return ignore.some((el)=>(0, $b06ec5ff205338e5$export$2344b14b097df817)(el, target));
                    },
                    onFocusOutside: ctx2.onFocusOutside,
                    onPointerDownOutside: ctx2.onPointerDownOutside,
                    onInteractOutside (event) {
                        ctx2.onInteractOutside?.(event);
                        if (event.defaultPrevented) return;
                        const { focusable: focusable } = event.detail;
                        send({
                            type: $9cfeac3ec88442fd$var$submitOnBlur(ctx2) ? "SUBMIT" : "CANCEL",
                            src: "interact-outside",
                            focusable: focusable
                        });
                    }
                });
            }
        },
        actions: {
            restoreFocus (ctx2, evt) {
                if (evt.focusable) return;
                (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>{
                    const finalEl = ctx2.finalFocusEl?.() ?? $9cfeac3ec88442fd$var$dom.getEditTriggerEl(ctx2);
                    finalEl?.focus({
                        preventScroll: true
                    });
                });
            },
            focusInput (ctx2) {
                (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>{
                    const inputEl = $9cfeac3ec88442fd$var$dom.getInputEl(ctx2);
                    if (!inputEl) return;
                    if (ctx2.selectOnFocus) inputEl.select();
                    else inputEl.focus({
                        preventScroll: true
                    });
                });
            },
            invokeOnCancel (ctx2) {
                ctx2.onValueRevert?.({
                    value: ctx2.previousValue
                });
            },
            invokeOnSubmit (ctx2) {
                ctx2.onValueCommit?.({
                    value: ctx2.value
                });
            },
            invokeOnEdit (ctx2) {
                ctx2.onEditChange?.({
                    edit: true
                });
            },
            invokeOnPreview (ctx2) {
                ctx2.onEditChange?.({
                    edit: false
                });
            },
            toggleEditing (ctx2, evt, { send: send }) {
                send({
                    type: ctx2.edit ? "CONTROLLED.EDIT" : "CONTROLLED.PREVIEW",
                    previousEvent: evt
                });
            },
            syncInputValue (ctx2) {
                $9cfeac3ec88442fd$var$sync.value(ctx2);
            },
            setValue (ctx2, evt) {
                const value = ctx2.maxLength != null ? evt.value.slice(0, ctx2.maxLength) : evt.value;
                $9cfeac3ec88442fd$var$set.value(ctx2, value);
            },
            setPreviousValue (ctx2) {
                ctx2.previousValue = ctx2.value;
            },
            revertValue (ctx2) {
                $9cfeac3ec88442fd$var$set.value(ctx2, ctx2.previousValue);
            },
            blurInputIfNeeded (ctx2) {
                $9cfeac3ec88442fd$var$dom.getInputEl(ctx2)?.blur();
            }
        }
    });
}
var $9cfeac3ec88442fd$var$sync = {
    value: (ctx)=>{
        const inputEl = $9cfeac3ec88442fd$var$dom.getInputEl(ctx);
        $9cfeac3ec88442fd$var$dom.setValue(inputEl, ctx.value);
    }
};
var $9cfeac3ec88442fd$var$invoke = {
    change (ctx) {
        ctx.onValueChange?.({
            value: ctx.value
        });
        $9cfeac3ec88442fd$var$sync.value(ctx);
    }
};
var $9cfeac3ec88442fd$var$set = {
    value (ctx, value) {
        if ((0, $89352e0ddd72597a$export$248d38f6296296c5)(ctx.value, value)) return;
        ctx.value = value;
        $9cfeac3ec88442fd$var$invoke.change(ctx);
    }
};
var $9cfeac3ec88442fd$export$8128bb6492cf3de7 = (0, $5b359805fda5a40e$export$c94ea207b45fef3a)()([
    "activationMode",
    "autoResize",
    "dir",
    "disabled",
    "finalFocusEl",
    "form",
    "getRootNode",
    "id",
    "ids",
    "invalid",
    "maxLength",
    "name",
    "onEditChange",
    "onFocusOutside",
    "onInteractOutside",
    "onPointerDownOutside",
    "onValueChange",
    "onValueCommit",
    "onValueRevert",
    "placeholder",
    "readOnly",
    "required",
    "selectOnFocus",
    "edit",
    "edit.controlled",
    "submitMode",
    "translations",
    "value"
]);
var $9cfeac3ec88442fd$export$45029c61b0073d87 = (0, $89352e0ddd72597a$export$3ea53b214fbc1986)($9cfeac3ec88442fd$export$8128bb6492cf3de7);



"use client";
const $1ecabe0c7927b138$export$a43048b0d2808e4e = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("field").parts("root", "errorText", "helperText", "input", "label", "select", "textarea", "requiredIndicator");
const $1ecabe0c7927b138$export$6e2410c1d27f06e7 = $1ecabe0c7927b138$export$a43048b0d2808e4e.build();



"use client";
const $ca0938c560125fe3$export$3b2066f768dd72d0 = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("fieldset").parts("root", "errorText", "helperText", "legend");
const $ca0938c560125fe3$export$6e2410c1d27f06e7 = $ca0938c560125fe3$export$3b2066f768dd72d0.build();





// src/cache.ts
function $3efd86e428cfc177$var$i18nCache(Ins) {
    const formatterCache = /* @__PURE__ */ new Map();
    return function create(locale, options) {
        const cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
        if (formatterCache.has(cacheKey)) return formatterCache.get(cacheKey);
        let formatter = new Ins(locale, options);
        formatterCache.set(cacheKey, formatter);
        return formatter;
    };
}
// src/filter.ts
var $3efd86e428cfc177$var$collatorCache = $3efd86e428cfc177$var$i18nCache(Intl.Collator);
function $3efd86e428cfc177$export$3dea766d36a8935f(options) {
    const { locale: locale, ...rest } = options || {};
    const collator = $3efd86e428cfc177$var$collatorCache(locale || "en-US", {
        usage: "search",
        ...rest
    });
    function normalize(string) {
        string = string.normalize("NFC");
        if (collator.resolvedOptions().ignorePunctuation) string = string.replace(/\p{P}/gu, "");
        return string;
    }
    function startsWith(string, substring) {
        if (substring.length === 0) return true;
        string = normalize(string);
        substring = normalize(substring);
        return collator.compare(string.slice(0, substring.length), substring) === 0;
    }
    function endsWith(string, substring) {
        if (substring.length === 0) return true;
        string = normalize(string);
        substring = normalize(substring);
        return collator.compare(string.slice(-substring.length), substring) === 0;
    }
    function contains(string, substring) {
        if (substring.length === 0) return true;
        string = normalize(string);
        substring = normalize(substring);
        let scan = 0;
        let sliceLen = substring.length;
        for(; scan + sliceLen <= string.length; scan++){
            let slice = string.slice(scan, scan + sliceLen);
            if (collator.compare(substring, slice) === 0) return true;
        }
        return false;
    }
    return {
        startsWith: startsWith,
        endsWith: endsWith,
        contains: contains
    };
}
// src/format-number.ts
var $3efd86e428cfc177$var$getNumberFormatter = $3efd86e428cfc177$var$i18nCache(Intl.NumberFormat);
function $3efd86e428cfc177$export$f5dd818bff069720(v, locale, options = {}) {
    const formatter = $3efd86e428cfc177$var$getNumberFormatter(locale, options);
    return formatter.format(v);
}
// src/format-bytes.ts
var $3efd86e428cfc177$var$bitPrefixes = [
    "",
    "kilo",
    "mega",
    "giga",
    "tera"
];
var $3efd86e428cfc177$var$bytePrefixes = [
    "",
    "kilo",
    "mega",
    "giga",
    "tera",
    "peta"
];
var $3efd86e428cfc177$export$e1a3971de07c83b5 = (bytes, locale = "en-US", options = {})=>{
    if (isNaN(bytes)) return "";
    if (bytes === 0) return "0 B";
    const { unit: unit = "byte", unitDisplay: unitDisplay = "short" } = options;
    const prefix = unit === "bit" ? $3efd86e428cfc177$var$bitPrefixes : $3efd86e428cfc177$var$bytePrefixes;
    const index = Math.max(0, Math.min(Math.floor(Math.log10(bytes) / 3), prefix.length - 1));
    const _unit = prefix[index] + unit;
    const _unitDisplay = unitDisplay || "short";
    const v = parseFloat((bytes / Math.pow(1e3, index)).toPrecision(3));
    return $3efd86e428cfc177$export$f5dd818bff069720(v, locale, {
        style: "unit",
        unit: _unit,
        unitDisplay: _unitDisplay
    });
};
// src/format-date.ts
var $3efd86e428cfc177$var$symbols = "\\s|\\.|-|/|\\\\|,|\\$|\\!|\\?|:|;";
function $3efd86e428cfc177$var$createRegEx(sign) {
    return new RegExp("(^|>|" + $3efd86e428cfc177$var$symbols + ")(" + sign + ")($|<|" + $3efd86e428cfc177$var$symbols + ")", "g");
}
var $3efd86e428cfc177$var$FORMATS = [
    "G",
    "GG",
    "GGG",
    "GGGG",
    "GGGGG",
    "y",
    "yo",
    "yy",
    "yyy",
    "yyyy",
    "Y",
    "Yo",
    "YY",
    "YYY",
    "YYYY",
    "Q",
    "Qo",
    "QQ",
    "QQQ",
    "QQQQ",
    "QQQQQ",
    "M",
    "Mo",
    "MM",
    "MMM",
    "MMMM",
    "MMMMM",
    "E",
    "EE",
    "EEE",
    "EEEE",
    "EEEEE",
    "EEEEEE",
    "a",
    "aa",
    "aaa",
    "aaaa",
    "aaaaa",
    "d",
    "do",
    "dd",
    "D",
    "Do",
    "DD",
    "DDD",
    "w",
    "wo",
    "ww",
    "s",
    "so",
    "ss",
    "m",
    "mo",
    "mm",
    "h",
    "ho",
    "hh",
    "H",
    "Ho",
    "HH",
    "z",
    "zz",
    "zzz",
    "zzzz",
    "T"
];
function $3efd86e428cfc177$var$ordinal(num) {
    const n = typeof num === "string" ? parseFloat(num) : num;
    let suffix = "th";
    if (n % 10 === 1 && n % 100 !== 11) suffix = "st";
    else if (n % 10 === 2 && n % 100 !== 12) suffix = "nd";
    else if (n % 10 === 3 && n % 100 !== 13) suffix = "rd";
    return `${n}${suffix}`;
}
function $3efd86e428cfc177$var$pad(num, length) {
    return String(num).padStart(length, "0");
}
function $3efd86e428cfc177$var$zone(str) {
    return str.split(/AM|PM/)[1].trim();
}
function $3efd86e428cfc177$var$getFormat(date, options) {
    const { locale: locale, format: format, timeZone: timeZone } = options;
    switch(format){
        // era
        case "G":
        case "GG":
        case "GGG":
            return date.toLocaleString(locale, {
                era: "short"
            });
        case "GGGG":
            return date.toLocaleString(locale, {
                era: "long"
            });
        case "GGGGG":
            return date.toLocaleString(locale, {
                era: "narrow"
            });
        // year
        case "y":
        case "Y":
            return date.getFullYear();
        case "yo":
        case "Yo":
            return $3efd86e428cfc177$var$ordinal(date.toLocaleString(locale, {
                year: "numeric"
            }));
        case "yy":
        case "YY":
            return date.toLocaleString(locale, {
                year: "2-digit"
            });
        case "yyy":
        case "YYY":
            return date.toLocaleString(locale, {
                year: "numeric"
            }).padStart(3, "0");
        case "yyyy":
        case "YYYY":
            return date.toLocaleString(locale, {
                year: "numeric"
            }).padStart(4, "0");
        // quarter
        case "Q":
        case "QQQQQ":
            return Math.ceil((date.getMonth() + 1) / 3);
        case "Qo":
            return $3efd86e428cfc177$var$ordinal(Math.ceil((date.getMonth() + 1) / 3));
        case "QQ":
            return $3efd86e428cfc177$var$pad(Math.ceil((date.getMonth() + 1) / 3), 2);
        case "QQQ":
            return `Q${Math.ceil((date.getMonth() + 1) / 3)}`;
        case "QQQQ":
            {
                const base = $3efd86e428cfc177$var$ordinal(String(Math.ceil((date.getMonth() + 1) / 3)));
                return `${base} quarter`;
            }
        // month
        case "M":
            return date.getMonth() + 1;
        case "Mo":
            return $3efd86e428cfc177$var$ordinal(date.getMonth() + 1);
        case "MM":
            return date.toLocaleString(locale, {
                month: "2-digit"
            });
        case "MMM":
            return date.toLocaleString(locale, {
                month: "short"
            });
        case "MMMM":
            return date.toLocaleString(locale, {
                month: "long"
            });
        case "MMMMM":
            return date.toLocaleString(locale, {
                month: "narrow"
            });
        // week
        case "w":
            return Math.ceil(date.getDate() / 7);
        case "wo":
            return $3efd86e428cfc177$var$ordinal(Math.ceil(date.getDate() / 7));
        case "ww":
            return $3efd86e428cfc177$var$pad(Math.ceil(date.getDate() / 7), 2);
        // day
        case "d":
        case "D":
            return date.getDate();
        case "do":
        case "Do":
            return $3efd86e428cfc177$var$ordinal(date.getDate());
        case "dd":
        case "DD":
            return date.toLocaleString(locale, {
                day: "2-digit"
            });
        case "DDD":
            return $3efd86e428cfc177$var$pad(date.getDate(), 3);
        // weekday
        case "E":
        case "EE":
        case "EEE":
            return date.toLocaleString(locale, {
                weekday: "short"
            });
        case "EEEE":
            return date.toLocaleString(locale, {
                weekday: "long"
            });
        case "EEEEE":
            return date.toLocaleString(locale, {
                weekday: "narrow"
            });
        case "EEEEEE":
            return date.toLocaleString(locale, {
                weekday: "short"
            }).slice(0, 2);
        // hour
        case "h":
            return date.toLocaleString(locale, {
                hour: "numeric",
                hour12: true
            });
        case "ho":
            return $3efd86e428cfc177$var$ordinal(date.toLocaleString(locale, {
                hour: "2-digit",
                hour12: true
            }));
        case "hh":
            return date.toLocaleString(locale, {
                hour: "2-digit",
                hour12: true
            });
        case "H":
            return date.toLocaleString(locale, {
                hour: "numeric",
                hour12: false
            });
        case "Ho":
            return $3efd86e428cfc177$var$ordinal(+date.toLocaleString(locale, {
                hour: "numeric",
                hour12: false
            }));
        case "HH":
            return date.toLocaleString(locale, {
                hour: "2-digit",
                hour12: false
            });
        // minute
        case "m":
            return date.toLocaleString(locale, {
                minute: "numeric"
            });
        case "mo":
            return $3efd86e428cfc177$var$ordinal(date.toLocaleString(locale, {
                minute: "numeric"
            }));
        case "mm":
            return date.toLocaleString(locale, {
                minute: "2-digit"
            });
        // second
        case "s":
            return date.toLocaleString(locale, {
                second: "numeric"
            });
        case "so":
            return $3efd86e428cfc177$var$ordinal(date.toLocaleString(locale, {
                second: "numeric"
            }));
        case "ss":
            return date.toLocaleString(locale, {
                second: "2-digit"
            });
        // timestamp
        case "T":
            return date.getTime();
        // day period
        case "a":
        case "aa":
        case "aaa":
            return date.toLocaleString(locale, {
                hour: "numeric",
                hour12: true
            }).toLocaleUpperCase();
        case "aaaa":
            return date.toLocaleString(locale, {
                hour: "numeric",
                hour12: true
            }).toLocaleLowerCase();
        case "aaaaa":
            return date.toLocaleString(locale, {
                hour: "numeric",
                hour12: true
            }).charAt(0);
        // TODO:Revise this
        case "z":
        case "zz":
        case "zzz":
            return $3efd86e428cfc177$var$zone(date.toLocaleString(locale, {
                timeZone: timeZone,
                timeZoneName: "shortOffset"
            }));
        case "zzzz":
            return $3efd86e428cfc177$var$zone(date.toLocaleString(locale, {
                timeZone: timeZone,
                timeZoneName: "longOffset"
            }));
        default:
            throw new Error(`Unknown format: ${format}`);
    }
}
function $3efd86e428cfc177$export$3ae94a2503e890a1(date, format, locale, timeZone) {
    let result = format;
    for (const key of $3efd86e428cfc177$var$FORMATS){
        const res = $3efd86e428cfc177$var$getFormat(date, {
            locale: locale,
            format: key,
            timeZone: timeZone
        });
        result = result.replace($3efd86e428cfc177$var$createRegEx(key), "$1" + res + "$3");
    }
    return result;
}
// src/format-list.ts
var $3efd86e428cfc177$var$getListFormatter = $3efd86e428cfc177$var$i18nCache(Intl.ListFormat);
function $3efd86e428cfc177$export$e8b8be48b45905bb(list, locale, options = {}) {
    const formatter = $3efd86e428cfc177$var$getListFormatter(locale, options);
    return formatter.format(list);
}
// src/format-relative-time.ts
var $3efd86e428cfc177$var$getRelativeTimeFormatter = $3efd86e428cfc177$var$i18nCache(Intl.RelativeTimeFormat);
function $3efd86e428cfc177$export$b4ea3b48dcf921f6(value, locale, options = {}) {
    const rtf = $3efd86e428cfc177$var$getRelativeTimeFormatter(locale, options);
    const now = /* @__PURE__ */ new Date();
    const diff = $3efd86e428cfc177$var$getDistance(now, value);
    if (diff.years > 0) return rtf.format(diff.years * diff.sign, "year");
    if (diff.months > 0) return rtf.format(diff.months * diff.sign, "month");
    if (diff.weeks > 0) return rtf.format(diff.weeks * diff.sign, "week");
    if (diff.days > 0) return rtf.format(diff.days * diff.sign, "day");
    if (diff.hours > 0) return rtf.format(diff.hours * diff.sign, "hour");
    if (diff.minutes > 0) return rtf.format(diff.minutes * diff.sign, "minute");
    return rtf.format(diff.seconds * diff.sign, "second");
}
var $3efd86e428cfc177$var$SECOND_TO_MS = 1e3;
var $3efd86e428cfc177$var$MINUTE_TO_MS = 60000;
var $3efd86e428cfc177$var$HOUR_TO_MS = 3600000;
var $3efd86e428cfc177$var$DAY_TO_MS = 86400000;
var $3efd86e428cfc177$var$WEEK_TO_MS = 604800000;
var $3efd86e428cfc177$var$MONTH_TO_MS = 2592000000;
var $3efd86e428cfc177$var$YEAR_TO_MS = 31536000000;
function $3efd86e428cfc177$var$getDistance(startDate, endDate) {
    const endTime = endDate.getTime();
    const startTime = startDate.getTime();
    const distance = Math.abs(endTime - startTime);
    return {
        sign: Math.sign(endTime - startTime),
        days: Math.floor(distance / $3efd86e428cfc177$var$DAY_TO_MS),
        hours: Math.floor(distance % $3efd86e428cfc177$var$DAY_TO_MS / $3efd86e428cfc177$var$HOUR_TO_MS),
        minutes: Math.floor(distance % $3efd86e428cfc177$var$HOUR_TO_MS / $3efd86e428cfc177$var$MINUTE_TO_MS),
        seconds: Math.floor(distance % $3efd86e428cfc177$var$MINUTE_TO_MS / $3efd86e428cfc177$var$SECOND_TO_MS),
        weeks: Math.floor(distance / $3efd86e428cfc177$var$WEEK_TO_MS),
        months: Math.floor(distance / $3efd86e428cfc177$var$MONTH_TO_MS),
        years: Math.floor(distance / $3efd86e428cfc177$var$YEAR_TO_MS)
    };
}
// src/is-rtl.ts
var $3efd86e428cfc177$var$RTL_SCRIPTS = /* @__PURE__ */ new Set([
    "Avst",
    "Arab",
    "Armi",
    "Syrc",
    "Samr",
    "Mand",
    "Thaa",
    "Mend",
    "Nkoo",
    "Adlm",
    "Rohg",
    "Hebr"
]);
var $3efd86e428cfc177$var$RTL_LANGS = /* @__PURE__ */ new Set([
    "ae",
    "ar",
    "arc",
    "bcc",
    "bqi",
    "ckb",
    "dv",
    "fa",
    "glk",
    "he",
    "ku",
    "mzn",
    "nqo",
    "pnb",
    "ps",
    "sd",
    "ug",
    "ur",
    "yi"
]);
function $3efd86e428cfc177$export$702d680b21cbd764(locale) {
    if (Intl.Locale) {
        const script = new Intl.Locale(locale).maximize().script ?? "";
        return $3efd86e428cfc177$var$RTL_SCRIPTS.has(script);
    }
    const lang = locale.split("-")[0];
    return $3efd86e428cfc177$var$RTL_LANGS.has(lang);
}
function $3efd86e428cfc177$export$758bcb760fab3fbe(locale) {
    return $3efd86e428cfc177$export$702d680b21cbd764(locale) ? "rtl" : "ltr";
}
// src/locale.ts
function $3efd86e428cfc177$export$f09106e7c6677ec5() {
    let locale = typeof navigator !== "undefined" && (navigator.language || navigator.userLanguage) || "en-US";
    return {
        locale: locale,
        dir: $3efd86e428cfc177$export$702d680b21cbd764(locale) ? "rtl" : "ltr"
    };
}
function $3efd86e428cfc177$export$10dfadecbd6fa070(options = {}) {
    const { getRootNode: getRootNode, onLocaleChange: onLocaleChange } = options;
    onLocaleChange?.($3efd86e428cfc177$export$f09106e7c6677ec5());
    const handleLocaleChange = ()=>{
        onLocaleChange?.($3efd86e428cfc177$export$f09106e7c6677ec5());
    };
    const win = getRootNode ? (0, $b06ec5ff205338e5$export$38b2d434cce3ea22)(getRootNode()) : window;
    win.addEventListener("languagechange", handleLocaleChange);
    return ()=>{
        win.removeEventListener("languagechange", handleLocaleChange);
    };
}



// src/data-url-to-blob.ts
function $9ce8e8f4ed6d6449$export$24bc7e761c190a9f(uri) {
    const binary = atob(uri.split(",")[1]);
    const mimeString = uri.split(",")[0].split(":")[1].split(";")[0];
    const buffer = new ArrayBuffer(binary.length);
    const intArray = new Uint8Array(buffer);
    for(let i = 0; i < binary.length; i++)intArray[i] = binary.charCodeAt(i);
    return new Blob([
        buffer
    ], {
        type: mimeString
    });
}
// src/download-file.ts
function $9ce8e8f4ed6d6449$export$552b0ed0b7a8f620(win) {
    return Boolean(win.navigator && win.navigator.msSaveOrOpenBlob);
}
function $9ce8e8f4ed6d6449$export$bb3b75778e3e272(options) {
    const { file: file, win: win, type: type, name: name } = options;
    const doc = win.document;
    const obj = typeof file === "string" ? new Blob([
        file
    ], {
        type: type
    }) : file;
    const fileName = typeof file === "string" ? name : file instanceof File ? file.name : void 0;
    if ($9ce8e8f4ed6d6449$export$552b0ed0b7a8f620(win)) {
        win.navigator.msSaveOrOpenBlob(obj, fileName || "file-download");
        return;
    }
    const url = win.URL.createObjectURL(obj);
    const anchor = doc.createElement("a");
    anchor.style.display = "none";
    anchor.href = url;
    anchor.rel = "noopener";
    anchor.download = fileName || "file-download";
    doc.documentElement.appendChild(anchor);
    anchor.click();
    setTimeout(()=>{
        win.URL.revokeObjectURL(url);
        anchor.remove();
    }, 0);
}
// src/get-accept-attr.ts
function $9ce8e8f4ed6d6449$var$isMIMEType(v) {
    return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || /\w+\/[-+.\w]+/g.test(v);
}
function $9ce8e8f4ed6d6449$var$isExt(v) {
    return /^.*\.[\w]+$/.test(v);
}
var $9ce8e8f4ed6d6449$var$isValidMIME = (v)=>$9ce8e8f4ed6d6449$var$isMIMEType(v) || $9ce8e8f4ed6d6449$var$isExt(v);
function $9ce8e8f4ed6d6449$export$da06292471ccb1c4(accept) {
    if (!accept) return;
    if (typeof accept === "string") return accept;
    if (Array.isArray(accept)) return accept.filter($9ce8e8f4ed6d6449$var$isValidMIME).join(",");
    return Object.entries(accept).reduce((a, [mimeType, ext])=>[
            ...a,
            mimeType,
            ...ext
        ], []).filter($9ce8e8f4ed6d6449$var$isValidMIME).join(",");
}
// src/get-file-data-url.ts
var $9ce8e8f4ed6d6449$export$6936424727fcbfbe = async (file)=>{
    const reader = new FileReader();
    return new Promise((resolve, reject)=>{
        reader.onerror = ()=>{
            reader.abort();
            reject(new Error("There was an error reading a file"));
        };
        reader.onloadend = ()=>{
            const { result: result } = reader;
            if (result instanceof ArrayBuffer) reject(new Error("Expected DataURL as string from Blob/File, got ArrayBuffer"));
            else resolve(result || void 0);
        };
        reader.readAsDataURL(file);
    });
};
// src/get-total-file-size.ts
var $9ce8e8f4ed6d6449$export$db70eadc173fae60 = (files)=>{
    return files.reduce((acc, file)=>acc + file.size, 0);
};
// src/is-file-equal.ts
var $9ce8e8f4ed6d6449$export$b4fc77db34d25244 = (file1, file2)=>{
    return file1.name === file2.name && file1.size === file2.size && file1.type === file2.type;
};
// src/is-valid-file-size.ts
var $9ce8e8f4ed6d6449$var$isDefined = (v)=>v !== void 0 && v !== null;
function $9ce8e8f4ed6d6449$export$962def5e52666993(file, minSize, maxSize) {
    if ($9ce8e8f4ed6d6449$var$isDefined(file.size)) {
        if ($9ce8e8f4ed6d6449$var$isDefined(minSize) && $9ce8e8f4ed6d6449$var$isDefined(maxSize)) {
            if (file.size > maxSize) return [
                false,
                "FILE_TOO_LARGE"
            ];
            if (file.size < minSize) return [
                false,
                "FILE_TOO_SMALL"
            ];
        } else if ($9ce8e8f4ed6d6449$var$isDefined(minSize) && file.size < minSize) return [
            false,
            "FILE_TOO_SMALL"
        ];
        else if ($9ce8e8f4ed6d6449$var$isDefined(maxSize) && file.size > maxSize) return [
            false,
            "FILE_TOO_LARGE"
        ];
    }
    return [
        true,
        null
    ];
}
// src/is-valid-file-type.ts
function $9ce8e8f4ed6d6449$var$isFileAccepted(file, accept) {
    if (file && accept) {
        const types = Array.isArray(accept) ? accept : accept.split(",");
        const fileName = file.name || "";
        const mimeType = (file.type || "").toLowerCase();
        const baseMimeType = mimeType.replace(/\/.*$/, "");
        return types.some((type)=>{
            const validType = type.trim().toLowerCase();
            if (validType.charAt(0) === ".") return fileName.toLowerCase().endsWith(validType);
            if (validType.endsWith("/*")) return baseMimeType === validType.replace(/\/.*$/, "");
            return mimeType === validType;
        });
    }
    return true;
}
function $9ce8e8f4ed6d6449$export$43ef8acdad253430(file, accept) {
    const isAcceptable = file.type === "application/x-moz-file" || $9ce8e8f4ed6d6449$var$isFileAccepted(file, accept);
    return [
        isAcceptable,
        isAcceptable ? null : "FILE_INVALID_TYPE"
    ];
}




// src/file-upload.anatomy.ts
var $aefe1177600007b1$export$477202748c7242bf = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("file-upload").parts("root", "dropzone", "item", "itemDeleteTrigger", "itemGroup", "itemName", "itemPreview", "itemPreviewImage", "itemSizeText", "label", "trigger", "clearTrigger");
var $aefe1177600007b1$var$parts = $aefe1177600007b1$export$477202748c7242bf.build();
var $aefe1177600007b1$var$dom = (0, $b06ec5ff205338e5$export$41a9651decfe2bde)({
    getRootId: (ctx)=>ctx.ids?.root ?? `file:${ctx.id}`,
    getDropzoneId: (ctx)=>ctx.ids?.dropzone ?? `file:${ctx.id}:dropzone`,
    getHiddenInputId: (ctx)=>ctx.ids?.hiddenInput ?? `file:${ctx.id}:input`,
    getTriggerId: (ctx)=>ctx.ids?.trigger ?? `file:${ctx.id}:trigger`,
    getLabelId: (ctx)=>ctx.ids?.label ?? `file:${ctx.id}:label`,
    getItemId: (ctx, id)=>ctx.ids?.item?.(id) ?? `file:${ctx.id}:item:${id}`,
    getItemNameId: (ctx, id)=>ctx.ids?.itemName?.(id) ?? `file:${ctx.id}:item-name:${id}`,
    getItemSizeTextId: (ctx, id)=>ctx.ids?.itemSizeText?.(id) ?? `file:${ctx.id}:item-size:${id}`,
    getItemPreviewId: (ctx, id)=>ctx.ids?.itemPreview?.(id) ?? `file:${ctx.id}:item-preview:${id}`,
    getRootEl: (ctx)=>$aefe1177600007b1$var$dom.getById(ctx, $aefe1177600007b1$var$dom.getRootId(ctx)),
    getHiddenInputEl: (ctx)=>$aefe1177600007b1$var$dom.getById(ctx, $aefe1177600007b1$var$dom.getHiddenInputId(ctx)),
    getDropzoneEl: (ctx)=>$aefe1177600007b1$var$dom.getById(ctx, $aefe1177600007b1$var$dom.getDropzoneId(ctx))
});
function $aefe1177600007b1$var$isEventWithFiles(event) {
    const target = (0, $b06ec5ff205338e5$export$e58f029f0fbfdb29)(event);
    if (!event.dataTransfer) return !!target && "files" in target;
    return event.dataTransfer.types.some((type)=>{
        return type === "Files" || type === "application/x-moz-file";
    });
}
function $aefe1177600007b1$var$isFilesWithinRange(ctx, incomingCount) {
    if (!ctx.multiple && incomingCount > 1) return false;
    if (!ctx.multiple && incomingCount + ctx.acceptedFiles.length === 2) return true;
    if (incomingCount + ctx.acceptedFiles.length > ctx.maxFiles) return false;
    return true;
}
function $aefe1177600007b1$var$getFilesFromEvent(ctx, files) {
    const acceptedFiles = [];
    const rejectedFiles = [];
    files.forEach((file)=>{
        const [accepted, acceptError] = (0, $9ce8e8f4ed6d6449$export$43ef8acdad253430)(file, ctx.acceptAttr);
        const [sizeMatch, sizeError] = (0, $9ce8e8f4ed6d6449$export$962def5e52666993)(file, ctx.minFileSize, ctx.maxFileSize);
        const validateErrors = ctx.validate?.(file, {
            acceptedFiles: ctx.acceptedFiles,
            rejectedFiles: ctx.rejectedFiles
        });
        const valid = validateErrors ? validateErrors.length === 0 : true;
        if (accepted && sizeMatch && valid) acceptedFiles.push(file);
        else {
            const errors = [
                acceptError,
                sizeError
            ];
            if (!valid) errors.push(...validateErrors ?? []);
            rejectedFiles.push({
                file: file,
                errors: errors.filter(Boolean)
            });
        }
    });
    if (!$aefe1177600007b1$var$isFilesWithinRange(ctx, acceptedFiles.length)) {
        acceptedFiles.forEach((file)=>{
            rejectedFiles.push({
                file: file,
                errors: [
                    "TOO_MANY_FILES"
                ]
            });
        });
        acceptedFiles.splice(0);
    }
    return {
        acceptedFiles: acceptedFiles,
        rejectedFiles: rejectedFiles
    };
}
// src/file-upload.connect.ts
function $aefe1177600007b1$export$64605811ab45167f(state, send, normalize) {
    const disabled = state.context.disabled;
    const allowDrop = state.context.allowDrop;
    const translations = state.context.translations;
    const dragging = state.matches("dragging");
    const focused = state.matches("focused") && !disabled;
    return {
        dragging: dragging,
        focused: focused,
        disabled: !!disabled,
        openFilePicker () {
            if (disabled) return;
            send("OPEN");
        },
        deleteFile (file) {
            send({
                type: "FILE.DELETE",
                file: file
            });
        },
        acceptedFiles: state.context.acceptedFiles,
        rejectedFiles: state.context.rejectedFiles,
        setFiles (files) {
            const count = files.length;
            send({
                type: "FILES.SET",
                files: files,
                count: count
            });
        },
        clearRejectedFiles () {
            send({
                type: "REJECTED_FILES.CLEAR"
            });
        },
        clearFiles () {
            send({
                type: "FILES.CLEAR"
            });
        },
        getFileSize (file) {
            return (0, $3efd86e428cfc177$export$e1a3971de07c83b5)(file.size, state.context.locale);
        },
        createFileUrl (file, cb) {
            const win = $aefe1177600007b1$var$dom.getWin(state.context);
            const url = win.URL.createObjectURL(file);
            cb(url);
            return ()=>win.URL.revokeObjectURL(url);
        },
        setClipboardFiles (dt) {
            if (disabled) return false;
            const items = Array.from(dt?.items ?? []);
            const files = items.reduce((acc, item)=>{
                if (item.kind !== "file") return acc;
                const file = item.getAsFile();
                if (!file) return acc;
                return [
                    ...acc,
                    file
                ];
            }, []);
            if (!files.length) return false;
            send({
                type: "FILES.SET",
                files: files
            });
            return true;
        },
        getRootProps () {
            return normalize.element({
                ...$aefe1177600007b1$var$parts.root.attrs,
                dir: state.context.dir,
                id: $aefe1177600007b1$var$dom.getRootId(state.context),
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-dragging": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(dragging)
            });
        },
        getDropzoneProps (props2 = {}) {
            return normalize.element({
                ...$aefe1177600007b1$var$parts.dropzone.attrs,
                dir: state.context.dir,
                id: $aefe1177600007b1$var$dom.getDropzoneId(state.context),
                tabIndex: disabled || props2.disableClick ? void 0 : 0,
                role: props2.disableClick ? "application" : "button",
                "aria-label": translations.dropzone,
                "aria-disabled": disabled,
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.invalid),
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-dragging": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(dragging),
                onKeyDown (event) {
                    if (disabled) return;
                    if (event.defaultPrevented) return;
                    if (!(0, $b06ec5ff205338e5$export$7bced8f45c53f2f)(event)) return;
                    if (props2.disableClick) return;
                    if (event.key !== "Enter" && event.key !== " ") return;
                    send({
                        type: "DROPZONE.CLICK",
                        src: "keydown"
                    });
                },
                onClick (event) {
                    if (disabled) return;
                    if (event.defaultPrevented) return;
                    if (props2.disableClick) return;
                    if (!(0, $b06ec5ff205338e5$export$7bced8f45c53f2f)(event)) return;
                    if (event.currentTarget.localName === "label") event.preventDefault();
                    send("DROPZONE.CLICK");
                },
                onDragOver (event) {
                    if (disabled) return;
                    if (!allowDrop) return;
                    event.preventDefault();
                    event.stopPropagation();
                    try {
                        event.dataTransfer.dropEffect = "copy";
                    } catch  {}
                    const hasFiles = $aefe1177600007b1$var$isEventWithFiles(event);
                    if (!hasFiles) return;
                    const count = event.dataTransfer.items.length;
                    send({
                        type: "DROPZONE.DRAG_OVER",
                        count: count
                    });
                },
                onDragLeave (event) {
                    if (disabled) return;
                    if (!allowDrop) return;
                    if ((0, $b06ec5ff205338e5$export$2344b14b097df817)(event.currentTarget, event.relatedTarget)) return;
                    send({
                        type: "DROPZONE.DRAG_LEAVE"
                    });
                },
                onDrop (event) {
                    if (disabled) return;
                    if (allowDrop) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                    const hasFiles = $aefe1177600007b1$var$isEventWithFiles(event);
                    if (disabled || !hasFiles) return;
                    send({
                        type: "DROPZONE.DROP",
                        files: Array.from(event.dataTransfer.files)
                    });
                },
                onFocus () {
                    if (disabled) return;
                    send("DROPZONE.FOCUS");
                },
                onBlur () {
                    if (disabled) return;
                    send("DROPZONE.BLUR");
                }
            });
        },
        getTriggerProps () {
            return normalize.button({
                ...$aefe1177600007b1$var$parts.trigger.attrs,
                dir: state.context.dir,
                id: $aefe1177600007b1$var$dom.getTriggerId(state.context),
                disabled: disabled,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.invalid),
                type: "button",
                onClick (event) {
                    if (disabled) return;
                    if ((0, $b06ec5ff205338e5$export$2344b14b097df817)($aefe1177600007b1$var$dom.getDropzoneEl(state.context), event.currentTarget)) event.stopPropagation();
                    send("OPEN");
                }
            });
        },
        getHiddenInputProps () {
            return normalize.input({
                id: $aefe1177600007b1$var$dom.getHiddenInputId(state.context),
                tabIndex: -1,
                disabled: disabled,
                type: "file",
                required: state.context.required,
                capture: state.context.capture,
                name: state.context.name,
                accept: state.context.acceptAttr,
                webkitdirectory: state.context.directory ? "" : void 0,
                multiple: state.context.multiple || state.context.maxFiles > 1,
                onClick (event) {
                    event.stopPropagation();
                    event.currentTarget.value = "";
                },
                onInput (event) {
                    if (disabled) return;
                    const { files: files } = event.currentTarget;
                    send({
                        type: "FILES.SET",
                        files: files ? Array.from(files) : []
                    });
                },
                style: (0, $b06ec5ff205338e5$export$8fecac46448b5689)
            });
        },
        getItemGroupProps () {
            return normalize.element({
                ...$aefe1177600007b1$var$parts.itemGroup.attrs,
                dir: state.context.dir,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled)
            });
        },
        getItemProps (props2) {
            const { file: file } = props2;
            return normalize.element({
                ...$aefe1177600007b1$var$parts.item.attrs,
                dir: state.context.dir,
                id: $aefe1177600007b1$var$dom.getItemId(state.context, file.name),
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled)
            });
        },
        getItemNameProps (props2) {
            const { file: file } = props2;
            return normalize.element({
                ...$aefe1177600007b1$var$parts.itemName.attrs,
                dir: state.context.dir,
                id: $aefe1177600007b1$var$dom.getItemNameId(state.context, file.name),
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled)
            });
        },
        getItemSizeTextProps (props2) {
            const { file: file } = props2;
            return normalize.element({
                ...$aefe1177600007b1$var$parts.itemSizeText.attrs,
                dir: state.context.dir,
                id: $aefe1177600007b1$var$dom.getItemSizeTextId(state.context, file.name),
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled)
            });
        },
        getItemPreviewProps (props2) {
            const { file: file } = props2;
            return normalize.element({
                ...$aefe1177600007b1$var$parts.itemPreview.attrs,
                dir: state.context.dir,
                id: $aefe1177600007b1$var$dom.getItemPreviewId(state.context, file.name),
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled)
            });
        },
        getItemPreviewImageProps (props2) {
            const { file: file, url: url } = props2;
            const isImage = file.type.startsWith("image/");
            if (!isImage) throw new Error("Preview Image is only supported for image files");
            return normalize.img({
                ...$aefe1177600007b1$var$parts.itemPreviewImage.attrs,
                alt: translations.itemPreview?.(file),
                src: url,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled)
            });
        },
        getItemDeleteTriggerProps (props2) {
            const { file: file } = props2;
            return normalize.button({
                ...$aefe1177600007b1$var$parts.itemDeleteTrigger.attrs,
                dir: state.context.dir,
                type: "button",
                disabled: disabled,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "aria-label": translations.deleteFile?.(file),
                onClick () {
                    if (disabled) return;
                    send({
                        type: "FILE.DELETE",
                        file: file
                    });
                }
            });
        },
        getLabelProps () {
            return normalize.label({
                ...$aefe1177600007b1$var$parts.label.attrs,
                dir: state.context.dir,
                id: $aefe1177600007b1$var$dom.getLabelId(state.context),
                htmlFor: $aefe1177600007b1$var$dom.getHiddenInputId(state.context),
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled)
            });
        },
        getClearTriggerProps () {
            return normalize.button({
                ...$aefe1177600007b1$var$parts.clearTrigger.attrs,
                dir: state.context.dir,
                type: "button",
                disabled: disabled,
                hidden: state.context.acceptedFiles.length === 0,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                onClick (event) {
                    if (event.defaultPrevented) return;
                    if (disabled) return;
                    send({
                        type: "FILES.CLEAR"
                    });
                }
            });
        }
    };
}
function $aefe1177600007b1$export$ea56d40cd27c3480(userContext) {
    const ctx = (0, $89352e0ddd72597a$export$8e16b83750b44988)(userContext);
    return (0, $5c0da97e9c7aa95f$export$aaa7fa18f8e9b2e8)({
        id: "fileupload",
        initial: "idle",
        context: {
            minFileSize: 0,
            maxFileSize: Number.POSITIVE_INFINITY,
            maxFiles: 1,
            allowDrop: true,
            accept: ctx.accept,
            preventDocumentDrop: true,
            ...ctx,
            acceptedFiles: (0, $7bf56e9c8ff12ab3$export$eff4d24c3ff7876e)([]),
            rejectedFiles: (0, $7bf56e9c8ff12ab3$export$eff4d24c3ff7876e)([]),
            translations: {
                dropzone: "dropzone",
                itemPreview: (file)=>`preview of ${file.name}`,
                deleteFile: (file)=>`delete file ${file.name}`,
                ...ctx.translations
            }
        },
        computed: {
            acceptAttr: (ctx2)=>(0, $9ce8e8f4ed6d6449$export$da06292471ccb1c4)(ctx2.accept),
            multiple: (ctx2)=>ctx2.maxFiles > 1
        },
        watch: {
            acceptedFiles: [
                "syncInputElement"
            ]
        },
        on: {
            "FILES.SET": {
                actions: [
                    "setFilesFromEvent"
                ]
            },
            "FILE.DELETE": {
                actions: [
                    "removeFile"
                ]
            },
            "FILES.CLEAR": {
                actions: [
                    "clearFiles"
                ]
            },
            "REJECTED_FILES.CLEAR": {
                actions: [
                    "clearRejectedFiles"
                ]
            }
        },
        activities: [
            "preventDocumentDrop"
        ],
        states: {
            idle: {
                on: {
                    OPEN: {
                        actions: [
                            "openFilePicker"
                        ]
                    },
                    "DROPZONE.CLICK": {
                        actions: [
                            "openFilePicker"
                        ]
                    },
                    "DROPZONE.FOCUS": "focused",
                    "DROPZONE.DRAG_OVER": "dragging"
                }
            },
            focused: {
                on: {
                    "DROPZONE.BLUR": "idle",
                    OPEN: {
                        actions: [
                            "openFilePicker"
                        ]
                    },
                    "DROPZONE.CLICK": {
                        actions: [
                            "openFilePicker"
                        ]
                    },
                    "DROPZONE.DRAG_OVER": "dragging"
                }
            },
            dragging: {
                on: {
                    "DROPZONE.DROP": {
                        target: "idle",
                        actions: [
                            "setFilesFromEvent"
                        ]
                    },
                    "DROPZONE.DRAG_LEAVE": "idle"
                }
            }
        }
    }, {
        activities: {
            preventDocumentDrop (ctx2) {
                if (!ctx2.preventDocumentDrop) return;
                if (!ctx2.allowDrop) return;
                if (ctx2.disabled) return;
                const doc = $aefe1177600007b1$var$dom.getDoc(ctx2);
                const onDragOver = (event)=>{
                    event?.preventDefault();
                };
                const onDrop = (event)=>{
                    if ((0, $b06ec5ff205338e5$export$2344b14b097df817)($aefe1177600007b1$var$dom.getRootEl(ctx2), (0, $b06ec5ff205338e5$export$e58f029f0fbfdb29)(event))) return;
                    event.preventDefault();
                };
                return (0, $89352e0ddd72597a$export$9dd9a52f2dd5b9ce)((0, $b06ec5ff205338e5$export$b1d829ddf82884aa)(doc, "dragover", onDragOver, false), (0, $b06ec5ff205338e5$export$b1d829ddf82884aa)(doc, "drop", onDrop, false));
            }
        },
        actions: {
            syncInputElement (ctx2) {
                queueMicrotask(()=>{
                    const inputEl = $aefe1177600007b1$var$dom.getHiddenInputEl(ctx2);
                    if (!inputEl) return;
                    const win = $aefe1177600007b1$var$dom.getWin(ctx2);
                    const dataTransfer = new win.DataTransfer();
                    ctx2.acceptedFiles.forEach((v)=>{
                        dataTransfer.items.add(v);
                    });
                    inputEl.files = dataTransfer.files;
                    inputEl.dispatchEvent(new win.Event("change", {
                        bubbles: true
                    }));
                });
            },
            openFilePicker (ctx2) {
                (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>{
                    $aefe1177600007b1$var$dom.getHiddenInputEl(ctx2)?.click();
                });
            },
            setFilesFromEvent (ctx2, evt) {
                const result = $aefe1177600007b1$var$getFilesFromEvent(ctx2, evt.files);
                const { acceptedFiles: acceptedFiles, rejectedFiles: rejectedFiles } = result;
                if (ctx2.multiple) {
                    const files = (0, $7bf56e9c8ff12ab3$export$eff4d24c3ff7876e)([
                        ...ctx2.acceptedFiles,
                        ...acceptedFiles
                    ]);
                    $aefe1177600007b1$var$set.files(ctx2, files, rejectedFiles);
                    return;
                }
                if (acceptedFiles.length) {
                    const files = (0, $7bf56e9c8ff12ab3$export$eff4d24c3ff7876e)([
                        acceptedFiles[0]
                    ]);
                    $aefe1177600007b1$var$set.files(ctx2, files, rejectedFiles);
                } else if (rejectedFiles.length) $aefe1177600007b1$var$set.files(ctx2, ctx2.acceptedFiles, rejectedFiles);
            },
            removeFile (ctx2, evt) {
                const files = Array.from(ctx2.acceptedFiles.filter((file)=>file !== evt.file));
                const rejectedFiles = Array.from(ctx2.rejectedFiles.filter((item)=>item.file !== evt.file));
                ctx2.acceptedFiles = (0, $7bf56e9c8ff12ab3$export$eff4d24c3ff7876e)(files);
                ctx2.rejectedFiles = (0, $7bf56e9c8ff12ab3$export$eff4d24c3ff7876e)(rejectedFiles);
                $aefe1177600007b1$var$invoke.change(ctx2);
            },
            clearRejectedFiles (ctx2) {
                ctx2.rejectedFiles = (0, $7bf56e9c8ff12ab3$export$eff4d24c3ff7876e)([]);
                $aefe1177600007b1$var$invoke.change(ctx2);
            },
            clearFiles (ctx2) {
                ctx2.acceptedFiles = (0, $7bf56e9c8ff12ab3$export$eff4d24c3ff7876e)([]);
                ctx2.rejectedFiles = (0, $7bf56e9c8ff12ab3$export$eff4d24c3ff7876e)([]);
                $aefe1177600007b1$var$invoke.change(ctx2);
            }
        },
        compareFns: {
            acceptedFiles: (a, b)=>a.length === b.length && a.every((file, i)=>(0, $9ce8e8f4ed6d6449$export$b4fc77db34d25244)(file, b[i]))
        }
    });
}
var $aefe1177600007b1$var$invoke = {
    change: (ctx)=>{
        ctx.onFileChange?.({
            acceptedFiles: ctx.acceptedFiles,
            rejectedFiles: ctx.rejectedFiles
        });
    },
    accept: (ctx)=>{
        ctx.onFileAccept?.({
            files: ctx.acceptedFiles
        });
    },
    reject: (ctx)=>{
        ctx.onFileReject?.({
            files: ctx.rejectedFiles
        });
    }
};
var $aefe1177600007b1$var$set = {
    files: (ctx, acceptedFiles, rejectedFiles)=>{
        ctx.acceptedFiles = (0, $7bf56e9c8ff12ab3$export$eff4d24c3ff7876e)(acceptedFiles);
        $aefe1177600007b1$var$invoke.accept(ctx);
        if (rejectedFiles) {
            ctx.rejectedFiles = (0, $7bf56e9c8ff12ab3$export$eff4d24c3ff7876e)(rejectedFiles);
            $aefe1177600007b1$var$invoke.reject(ctx);
        }
        $aefe1177600007b1$var$invoke.change(ctx);
    }
};
var $aefe1177600007b1$export$8128bb6492cf3de7 = (0, $5b359805fda5a40e$export$c94ea207b45fef3a)()([
    "accept",
    "allowDrop",
    "capture",
    "dir",
    "directory",
    "disabled",
    "getRootNode",
    "id",
    "ids",
    "locale",
    "maxFiles",
    "maxFileSize",
    "minFileSize",
    "name",
    "invalid",
    "onFileAccept",
    "onFileReject",
    "onFileChange",
    "preventDocumentDrop",
    "required",
    "translations",
    "validate"
]);
var $aefe1177600007b1$export$45029c61b0073d87 = (0, $89352e0ddd72597a$export$3ea53b214fbc1986)($aefe1177600007b1$export$8128bb6492cf3de7);
var $aefe1177600007b1$export$b67876e05d194bf9 = (0, $5b359805fda5a40e$export$c94ea207b45fef3a)()([
    "file"
]);
var $aefe1177600007b1$export$ae9d1ad549773548 = (0, $89352e0ddd72597a$export$3ea53b214fbc1986)($aefe1177600007b1$export$b67876e05d194bf9);








var $599424392786cc34$var$__defProp = Object.defineProperty;
var $599424392786cc34$var$__defNormalProp = (obj, key, value)=>key in obj ? $599424392786cc34$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $599424392786cc34$var$__publicField = (obj, key, value)=>$599424392786cc34$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/affine-transform.ts
var $599424392786cc34$export$a1e14422480dc60 = class _AffineTransform {
    constructor([m00, m01, m02, m10, m11, m12] = [
        0,
        0,
        0,
        0,
        0,
        0
    ]){
        $599424392786cc34$var$__publicField(this, "m00");
        $599424392786cc34$var$__publicField(this, "m01");
        $599424392786cc34$var$__publicField(this, "m02");
        $599424392786cc34$var$__publicField(this, "m10");
        $599424392786cc34$var$__publicField(this, "m11");
        $599424392786cc34$var$__publicField(this, "m12");
        $599424392786cc34$var$__publicField(this, "rotate", (...args)=>{
            return this.prepend(_AffineTransform.rotate(...args));
        });
        $599424392786cc34$var$__publicField(this, "scale", (...args)=>{
            return this.prepend(_AffineTransform.scale(...args));
        });
        $599424392786cc34$var$__publicField(this, "translate", (...args)=>{
            return this.prepend(_AffineTransform.translate(...args));
        });
        this.m00 = m00;
        this.m01 = m01;
        this.m02 = m02;
        this.m10 = m10;
        this.m11 = m11;
        this.m12 = m12;
    }
    applyTo(point) {
        const { x: x, y: y } = point;
        const { m00: m00, m01: m01, m02: m02, m10: m10, m11: m11, m12: m12 } = this;
        return {
            x: m00 * x + m01 * y + m02,
            y: m10 * x + m11 * y + m12
        };
    }
    prepend(other) {
        return new _AffineTransform([
            this.m00 * other.m00 + this.m01 * other.m10,
            // m00
            this.m00 * other.m01 + this.m01 * other.m11,
            // m01
            this.m00 * other.m02 + this.m01 * other.m12 + this.m02,
            // m02
            this.m10 * other.m00 + this.m11 * other.m10,
            // m10
            this.m10 * other.m01 + this.m11 * other.m11,
            // m11
            this.m10 * other.m02 + this.m11 * other.m12 + this.m12
        ]);
    }
    append(other) {
        return new _AffineTransform([
            other.m00 * this.m00 + other.m01 * this.m10,
            // m00
            other.m00 * this.m01 + other.m01 * this.m11,
            // m01
            other.m00 * this.m02 + other.m01 * this.m12 + other.m02,
            // m02
            other.m10 * this.m00 + other.m11 * this.m10,
            // m10
            other.m10 * this.m01 + other.m11 * this.m11,
            // m11
            other.m10 * this.m02 + other.m11 * this.m12 + other.m12
        ]);
    }
    get determinant() {
        return this.m00 * this.m11 - this.m01 * this.m10;
    }
    get isInvertible() {
        const det = this.determinant;
        return isFinite(det) && isFinite(this.m02) && isFinite(this.m12) && det !== 0;
    }
    invert() {
        const det = this.determinant;
        return new _AffineTransform([
            this.m11 / det,
            // m00
            -this.m01 / det,
            // m01
            (this.m01 * this.m12 - this.m11 * this.m02) / det,
            // m02
            -this.m10 / det,
            // m10
            this.m00 / det,
            // m11
            (this.m10 * this.m02 - this.m00 * this.m12) / det
        ]);
    }
    get array() {
        return [
            this.m00,
            this.m01,
            this.m02,
            this.m10,
            this.m11,
            this.m12,
            0,
            0,
            1
        ];
    }
    get float32Array() {
        return new Float32Array(this.array);
    }
    // Static
    static get identity() {
        return new _AffineTransform([
            1,
            0,
            0,
            0,
            1,
            0
        ]);
    }
    static rotate(theta, origin) {
        const rotation = new _AffineTransform([
            Math.cos(theta),
            -Math.sin(theta),
            0,
            Math.sin(theta),
            Math.cos(theta),
            0
        ]);
        if (origin && (origin.x !== 0 || origin.y !== 0)) return _AffineTransform.multiply(_AffineTransform.translate(origin.x, origin.y), rotation, _AffineTransform.translate(-origin.x, -origin.y));
        return rotation;
    }
    static scale(sx, sy = sx, origin = {
        x: 0,
        y: 0
    }) {
        const scale = new _AffineTransform([
            sx,
            0,
            0,
            0,
            sy,
            0
        ]);
        if (origin.x !== 0 || origin.y !== 0) return _AffineTransform.multiply(_AffineTransform.translate(origin.x, origin.y), scale, _AffineTransform.translate(-origin.x, -origin.y));
        return scale;
    }
    static translate(tx, ty) {
        return new _AffineTransform([
            1,
            0,
            tx,
            0,
            1,
            ty
        ]);
    }
    static multiply(...[first, ...rest]) {
        if (!first) return _AffineTransform.identity;
        return rest.reduce((result, item)=>result.prepend(item), first);
    }
    get a() {
        return this.m00;
    }
    get b() {
        return this.m10;
    }
    get c() {
        return this.m01;
    }
    get d() {
        return this.m11;
    }
    get tx() {
        return this.m02;
    }
    get ty() {
        return this.m12;
    }
    get scaleComponents() {
        return {
            x: this.a,
            y: this.d
        };
    }
    get translationComponents() {
        return {
            x: this.tx,
            y: this.ty
        };
    }
    get skewComponents() {
        return {
            x: this.c,
            y: this.b
        };
    }
    toString() {
        return `matrix(${this.a}, ${this.b}, ${this.c}, ${this.d}, ${this.tx}, ${this.ty})`;
    }
};
// src/align.ts
function $599424392786cc34$var$hAlign(a, ref, h) {
    let x = ref.minX;
    if (h === "left-inside") x = ref.minX;
    if (h === "left-outside") x = ref.minX - ref.width;
    if (h === "right-inside") x = ref.maxX - ref.width;
    if (h === "right-outside") x = ref.maxX;
    if (h === "center") x = ref.midX - ref.width / 2;
    return {
        ...a,
        x: x
    };
}
function $599424392786cc34$var$vAlign(a, ref, v) {
    let y = ref.minY;
    if (v === "top-inside") y = ref.minY;
    if (v === "top-outside") y = ref.minY - a.height;
    if (v === "bottom-inside") y = ref.maxY - a.height;
    if (v === "bottom-outside") y = ref.maxY;
    if (v === "center") y = ref.midY - a.height / 2;
    return {
        ...a,
        y: y
    };
}
function $599424392786cc34$export$3ba3da73eda1ad79(a, ref, options) {
    const { h: h, v: v } = options;
    return $599424392786cc34$var$vAlign($599424392786cc34$var$hAlign(a, ref, h), ref, v);
}
// src/angle.ts
function $599424392786cc34$export$4854b0a7681457e7(rect, point, reference = rect.center) {
    const x = point.x - reference.x;
    const y = point.y - reference.y;
    const deg = Math.atan2(x, y) * (180 / Math.PI) + 180;
    return 360 - deg;
}
// src/clamp.ts
var $599424392786cc34$var$clamp = (value, min3, max2)=>Math.min(Math.max(value, min3), max2);
var $599424392786cc34$export$cfccc9653e8c4561 = (position, size, boundaryRect)=>{
    const x = $599424392786cc34$var$clamp(position.x, boundaryRect.x, boundaryRect.x + boundaryRect.width - size.width);
    const y = $599424392786cc34$var$clamp(position.y, boundaryRect.y, boundaryRect.y + boundaryRect.height - size.height);
    return {
        x: x,
        y: y
    };
};
var $599424392786cc34$var$defaultMinSize = {
    width: 0,
    height: 0
};
var $599424392786cc34$var$defaultMaxSize = {
    width: Infinity,
    height: Infinity
};
var $599424392786cc34$export$cc50e07f241866e8 = (size, minSize = $599424392786cc34$var$defaultMinSize, maxSize = $599424392786cc34$var$defaultMaxSize)=>{
    return {
        width: Math.min(Math.max(size.width, minSize.width), maxSize.width),
        height: Math.min(Math.max(size.height, minSize.height), maxSize.height)
    };
};
// src/rect.ts
var $599424392786cc34$export$c139681dc522a264 = (x, y)=>({
        x: x,
        y: y
    });
var $599424392786cc34$export$f5f828077cd06751 = (a, b)=>$599424392786cc34$export$c139681dc522a264(a.x - b.x, a.y - b.y);
var $599424392786cc34$export$bf5bf75051d7b104 = (a, b)=>$599424392786cc34$export$c139681dc522a264(a.x + b.x, a.y + b.y);
function $599424392786cc34$export$aff838a5553f2a92(v) {
    return Reflect.has(v, "x") && Reflect.has(v, "y");
}
function $599424392786cc34$export$bd5271f935fe8c1a(r) {
    const { x: x, y: y, width: width, height: height } = r;
    const midX = x + width / 2;
    const midY = y + height / 2;
    return {
        x: x,
        y: y,
        width: width,
        height: height,
        minX: x,
        minY: y,
        maxX: x + width,
        maxY: y + height,
        midX: midX,
        midY: midY,
        center: $599424392786cc34$export$c139681dc522a264(midX, midY)
    };
}
function $599424392786cc34$export$707a34ba392ff427(v) {
    return Reflect.has(v, "x") && Reflect.has(v, "y") && Reflect.has(v, "width") && Reflect.has(v, "height");
}
function $599424392786cc34$export$34bf3eeb6c129ebd(v) {
    const top = $599424392786cc34$export$c139681dc522a264(v.midX, v.minY);
    const right = $599424392786cc34$export$c139681dc522a264(v.maxX, v.midY);
    const bottom = $599424392786cc34$export$c139681dc522a264(v.midX, v.maxY);
    const left = $599424392786cc34$export$c139681dc522a264(v.minX, v.midY);
    return {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
}
function $599424392786cc34$export$2f7bf41810db260c(v) {
    const top = $599424392786cc34$export$c139681dc522a264(v.minX, v.minY);
    const right = $599424392786cc34$export$c139681dc522a264(v.maxX, v.minY);
    const bottom = $599424392786cc34$export$c139681dc522a264(v.maxX, v.maxY);
    const left = $599424392786cc34$export$c139681dc522a264(v.minX, v.maxY);
    return {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
}
function $599424392786cc34$export$8edcba27febab644(v) {
    const c = $599424392786cc34$export$2f7bf41810db260c(v);
    const top = [
        c.top,
        c.right
    ];
    const right = [
        c.right,
        c.bottom
    ];
    const bottom = [
        c.left,
        c.bottom
    ];
    const left = [
        c.top,
        c.left
    ];
    return {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
}
// src/intersection.ts
function $599424392786cc34$export$7b0a31e10bbff018(a, b) {
    return a.x < b.maxX && a.y < b.maxY && a.maxX > b.x && a.maxY > b.y;
}
function $599424392786cc34$export$bc86dfbf7795668c(a, b) {
    const x = Math.max(a.x, b.x);
    const y = Math.max(a.y, b.y);
    const x2 = Math.min(a.x + a.width, b.x + b.width);
    const y2 = Math.min(a.y + a.height, b.y + b.height);
    return $599424392786cc34$export$bd5271f935fe8c1a({
        x: x,
        y: y,
        width: x2 - x,
        height: y2 - y
    });
}
function $599424392786cc34$export$6c47be6e9afe20f7(a, b) {
    return {
        top: a.minY <= b.minY,
        right: a.maxX >= b.maxX,
        bottom: a.maxY >= b.maxY,
        left: a.minX <= b.minX
    };
}
// src/distance.ts
function $599424392786cc34$export$9f17032d917177de(a, b = {
    x: 0,
    y: 0
}) {
    return Math.sqrt(Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2));
}
function $599424392786cc34$export$41a733e81553f39c(r, p) {
    let x = 0;
    let y = 0;
    if (p.x < r.x) x = r.x - p.x;
    else if (p.x > r.maxX) x = p.x - r.maxX;
    if (p.y < r.y) y = r.y - p.y;
    else if (p.y > r.maxY) y = p.y - r.maxY;
    return {
        x: x,
        y: y,
        value: $599424392786cc34$export$9f17032d917177de({
            x: x,
            y: y
        })
    };
}
function $599424392786cc34$export$8b95d2a528c583a6(a, b) {
    if ($599424392786cc34$export$7b0a31e10bbff018(a, b)) return {
        x: 0,
        y: 0,
        value: 0
    };
    const left = a.x < b.x ? a : b;
    const right = b.x < a.x ? a : b;
    const upper = a.y < b.y ? a : b;
    const lower = b.y < a.y ? a : b;
    let x = left.x === right.x ? 0 : right.x - left.maxX;
    x = Math.max(0, x);
    let y = upper.y === lower.y ? 0 : lower.y - upper.maxY;
    y = Math.max(0, y);
    return {
        x: x,
        y: y,
        value: $599424392786cc34$export$9f17032d917177de({
            x: x,
            y: y
        })
    };
}
function $599424392786cc34$export$45b94a8be59f995a(a, b) {
    return {
        left: b.x - a.x,
        top: b.y - a.y,
        right: a.maxX - b.maxX,
        bottom: a.maxY - b.maxY
    };
}
// src/closest.ts
function $599424392786cc34$export$ff7f7c97cdce86e(...pts) {
    return (a)=>{
        const ds = pts.map((b)=>$599424392786cc34$export$9f17032d917177de(b, a));
        const c = Math.min.apply(Math, ds);
        return pts[ds.indexOf(c)];
    };
}
function $599424392786cc34$export$2d315ea207186a36(ref, r) {
    if (r.maxX <= ref.minX) return "left";
    if (r.minX >= ref.maxX) return "right";
    if (r.maxY <= ref.minY) return "top";
    if (r.minY >= ref.maxY) return "bottom";
    return "left";
}
function $599424392786cc34$export$8ab25e799f3e18a2(ref, p) {
    const { x: x, y: y } = p;
    const dl = x - ref.minX;
    const dr = ref.maxX - x;
    const dt = y - ref.minY;
    const db = ref.maxY - y;
    let closest2 = dl;
    let side = "left";
    if (dr < closest2) {
        closest2 = dr;
        side = "right";
    }
    if (dt < closest2) {
        closest2 = dt;
        side = "top";
    }
    if (db < closest2) side = "bottom";
    return side;
}
// src/constrain.ts
var $599424392786cc34$export$cb449c2d96533c2f = (rect, boundary)=>{
    const left = Math.max(boundary.x, Math.min(rect.x, boundary.x + boundary.width - rect.width));
    const top = Math.max(boundary.y, Math.min(rect.y, boundary.y + boundary.height - rect.height));
    return {
        x: left,
        y: top,
        width: Math.min(rect.width, boundary.width),
        height: Math.min(rect.height, boundary.height)
    };
};
// src/contains.ts
function $599424392786cc34$export$16f54e0edfa804eb(r, p) {
    return r.minX <= p.x && p.x <= r.maxX && r.minY <= p.y && p.y <= r.maxY;
}
function $599424392786cc34$export$6bbbfd8eda6d4f5(a, b) {
    return Object.values($599424392786cc34$export$2f7bf41810db260c(b)).every((c)=>$599424392786cc34$export$16f54e0edfa804eb(a, c));
}
function $599424392786cc34$export$2344b14b097df817(r, v) {
    return $599424392786cc34$export$707a34ba392ff427(v) ? $599424392786cc34$export$6bbbfd8eda6d4f5(r, v) : $599424392786cc34$export$16f54e0edfa804eb(r, v);
}
// src/equality.ts
var $599424392786cc34$export$b8389babd24f0564 = (a, b)=>{
    return a.width === b.width && a.height === b.height;
};
var $599424392786cc34$export$26290b09085a91e = (a, b)=>{
    return a.x === b.x && a.y === b.y;
};
var $599424392786cc34$export$3f206312024f6c1 = (a, b)=>{
    return $599424392786cc34$export$26290b09085a91e(a, b) && $599424392786cc34$export$b8389babd24f0564(a, b);
};
// src/from-element.ts
var $599424392786cc34$var$styleCache = /* @__PURE__ */ new WeakMap();
function $599424392786cc34$var$getCacheComputedStyle(el) {
    if (!$599424392786cc34$var$styleCache.has(el)) {
        const win = el.ownerDocument.defaultView || window;
        $599424392786cc34$var$styleCache.set(el, win.getComputedStyle(el));
    }
    return $599424392786cc34$var$styleCache.get(el);
}
function $599424392786cc34$export$8746289dcd524249(el, opts = {}) {
    return $599424392786cc34$export$bd5271f935fe8c1a($599424392786cc34$var$getClientRect(el, opts));
}
function $599424392786cc34$var$getClientRect(el, opts = {}) {
    const { excludeScrollbar: excludeScrollbar = false, excludeBorders: excludeBorders = false } = opts;
    const { x: x, y: y, width: width, height: height } = el.getBoundingClientRect();
    const r = {
        x: x,
        y: y,
        width: width,
        height: height
    };
    const style = $599424392786cc34$var$getCacheComputedStyle(el);
    const { borderLeftWidth: borderLeftWidth, borderTopWidth: borderTopWidth, borderRightWidth: borderRightWidth, borderBottomWidth: borderBottomWidth } = style;
    const borderXWidth = $599424392786cc34$var$sum(borderLeftWidth, borderRightWidth);
    const borderYWidth = $599424392786cc34$var$sum(borderTopWidth, borderBottomWidth);
    if (excludeBorders) {
        r.width -= borderXWidth;
        r.height -= borderYWidth;
        r.x += $599424392786cc34$var$px(borderLeftWidth);
        r.y += $599424392786cc34$var$px(borderTopWidth);
    }
    if (excludeScrollbar) {
        const scrollbarWidth = el.offsetWidth - el.clientWidth - borderXWidth;
        const scrollbarHeight = el.offsetHeight - el.clientHeight - borderYWidth;
        r.width -= scrollbarWidth;
        r.height -= scrollbarHeight;
    }
    return r;
}
var $599424392786cc34$var$px = (v)=>parseFloat(v.replace("px", ""));
var $599424392786cc34$var$sum = (...vals)=>vals.reduce((sum2, v)=>sum2 + (v ? $599424392786cc34$var$px(v) : 0), 0);
// src/from-points.ts
function $599424392786cc34$export$7739e100c5c01a18(...pts) {
    const xs = pts.map((p)=>p.x);
    const ys = pts.map((p)=>p.y);
    const x = Math.min(...xs);
    const y = Math.min(...ys);
    const width = Math.max(...xs) - x;
    const height = Math.max(...ys) - y;
    return $599424392786cc34$export$bd5271f935fe8c1a({
        x: x,
        y: y,
        width: width,
        height: height
    });
}
// src/union.ts
var { min: $599424392786cc34$var$min, max: $599424392786cc34$var$max } = Math;
function $599424392786cc34$export$971dd5b0dfd021b6(...rs) {
    const pMin = {
        x: $599424392786cc34$var$min(...rs.map((r)=>r.minX)),
        y: $599424392786cc34$var$min(...rs.map((r)=>r.minY))
    };
    const pMax = {
        x: $599424392786cc34$var$max(...rs.map((r)=>r.maxX)),
        y: $599424392786cc34$var$max(...rs.map((r)=>r.maxY))
    };
    return $599424392786cc34$export$7739e100c5c01a18(pMin, pMax);
}
// src/from-range.ts
function $599424392786cc34$export$f01e84010c13cebe(range) {
    let rs = [];
    const rects = Array.from(range.getClientRects());
    if (rects.length) {
        rs = rs.concat(rects.map($599424392786cc34$export$bd5271f935fe8c1a));
        return $599424392786cc34$export$971dd5b0dfd021b6.apply(void 0, rs);
    }
    let start = range.startContainer;
    if (start.nodeType === Node.TEXT_NODE) start = start.parentNode;
    if (start instanceof HTMLElement) {
        const r = $599424392786cc34$export$8746289dcd524249(start);
        rs.push({
            ...r,
            x: r.maxX,
            width: 0
        });
    }
    return $599424392786cc34$export$971dd5b0dfd021b6.apply(void 0, rs);
}
// src/from-rotation.ts
function $599424392786cc34$export$8cca2b44d6a11240(d) {
    return d % 360 * Math.PI / 180;
}
function $599424392786cc34$export$bb628a54ab399bc9(a, d, c) {
    const r = $599424392786cc34$export$8cca2b44d6a11240(d);
    const sin = Math.sin(r);
    const cos = Math.cos(r);
    const x = a.x - c.x;
    const y = a.y - c.y;
    return {
        x: c.x + x * cos - y * sin,
        y: c.y + x * sin + y * cos
    };
}
function $599424392786cc34$export$7461f527307615a4(r, deg) {
    const rr = Object.values($599424392786cc34$export$2f7bf41810db260c(r)).map((p)=>$599424392786cc34$export$bb628a54ab399bc9(p, deg, r.center));
    const xs = rr.map((p)=>p.x);
    const ys = rr.map((p)=>p.y);
    const minX = Math.min(...xs);
    const minY = Math.min(...ys);
    const maxX = Math.max(...xs);
    const maxY = Math.max(...ys);
    return $599424392786cc34$export$bd5271f935fe8c1a({
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    });
}
// src/from-window.ts
function $599424392786cc34$export$930712eeea45f024(win, opts = {}) {
    return $599424392786cc34$export$bd5271f935fe8c1a($599424392786cc34$export$80df067bc590384f(win, opts));
}
function $599424392786cc34$export$80df067bc590384f(win, opts) {
    const { excludeScrollbar: excludeScrollbar = false } = opts;
    const { innerWidth: innerWidth, innerHeight: innerHeight, document: doc, visualViewport: visualViewport } = win;
    const width = visualViewport?.width || innerWidth;
    const height = visualViewport?.height || innerHeight;
    const rect = {
        x: 0,
        y: 0,
        width: width,
        height: height
    };
    if (excludeScrollbar) {
        const scrollbarWidth = innerWidth - doc.documentElement.clientWidth;
        const scrollbarHeight = innerHeight - doc.documentElement.clientHeight;
        rect.width -= scrollbarWidth;
        rect.height -= scrollbarHeight;
    }
    return rect;
}
// src/operations.ts
var $599424392786cc34$export$fe5638536448cd29 = (v)=>"dx" in v || "dy" in v;
function $599424392786cc34$export$7ce2732760c0a276(r, i) {
    const v = $599424392786cc34$export$fe5638536448cd29(i) ? {
        left: i.dx,
        right: i.dx,
        top: i.dy,
        bottom: i.dy
    } : i;
    const { top: top = 0, right: right = 0, bottom: bottom = 0, left: left = 0 } = v;
    return $599424392786cc34$export$bd5271f935fe8c1a({
        x: r.x + left,
        y: r.y + top,
        width: r.width - left - right,
        height: r.height - top - bottom
    });
}
function $599424392786cc34$export$9f77e0932fb78f72(r, v) {
    const value = typeof v === "number" ? {
        dx: -v,
        dy: -v
    } : v;
    return $599424392786cc34$export$7ce2732760c0a276(r, value);
}
function $599424392786cc34$export$8b1f3092f5e28575(r, v) {
    const value = typeof v === "number" ? {
        dx: -v,
        dy: -v
    } : v;
    return $599424392786cc34$export$7ce2732760c0a276(r, value);
}
function $599424392786cc34$export$fba63a578e423eb(r, o) {
    const { x: x = 0, y: y = 0 } = o;
    return $599424392786cc34$export$bd5271f935fe8c1a({
        x: r.x + x,
        y: r.y + y,
        width: r.width,
        height: r.height
    });
}
// src/polygon.ts
function $599424392786cc34$export$a818e5abc94ef05a(rectValue, placement) {
    const rect = $599424392786cc34$export$bd5271f935fe8c1a(rectValue);
    const { top: top, right: right, left: left, bottom: bottom } = $599424392786cc34$export$2f7bf41810db260c(rect);
    const [base] = placement.split("-");
    return ({
        top: [
            left,
            top,
            right,
            bottom
        ],
        right: [
            top,
            right,
            bottom,
            left
        ],
        bottom: [
            top,
            left,
            bottom,
            right
        ],
        left: [
            right,
            top,
            left,
            bottom
        ]
    })[base];
}
function $599424392786cc34$export$f1c31811357415ac(polygon, point) {
    const { x: x, y: y } = point;
    let c = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const xi = polygon[i].x;
        const yi = polygon[i].y;
        const xj = polygon[j].x;
        const yj = polygon[j].y;
        if (yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) c = !c;
    }
    return c;
}
function $599424392786cc34$var$createPolygonElement() {
    const id = "debug-polygon";
    const existingPolygon = document.getElementById(id);
    if (existingPolygon) return existingPolygon;
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    Object.assign(svg.style, {
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        opacity: "0.15",
        position: "fixed",
        pointerEvents: "none",
        fill: "red"
    });
    const polygon = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
    polygon.setAttribute("id", id);
    polygon.setAttribute("points", "0,0 0,0");
    svg.appendChild(polygon);
    document.body.appendChild(svg);
    return polygon;
}
function $599424392786cc34$export$ef95a236463e8239(polygon) {
    const el = $599424392786cc34$var$createPolygonElement();
    const points = polygon.map((point)=>`${point.x},${point.y}`).join(" ");
    el.setAttribute("points", points);
    return ()=>{
        el.remove();
    };
}
// src/compass.ts
var $599424392786cc34$var$compassDirectionMap = {
    n: {
        x: 0.5,
        y: 0
    },
    ne: {
        x: 1,
        y: 0
    },
    e: {
        x: 1,
        y: 0.5
    },
    se: {
        x: 1,
        y: 1
    },
    s: {
        x: 0.5,
        y: 1
    },
    sw: {
        x: 0,
        y: 1
    },
    w: {
        x: 0,
        y: 0.5
    },
    nw: {
        x: 0,
        y: 0
    }
};
var $599424392786cc34$var$oppositeDirectionMap = {
    n: "s",
    ne: "sw",
    e: "w",
    se: "nw",
    s: "n",
    sw: "ne",
    w: "e",
    nw: "se"
};
// src/resize.ts
var { sign: $599424392786cc34$var$sign, abs: $599424392786cc34$var$abs, min: $599424392786cc34$var$min2 } = Math;
function $599424392786cc34$var$getRectExtentPoint(rect, direction) {
    const { minX: minX, minY: minY, maxX: maxX, maxY: maxY, midX: midX, midY: midY } = rect;
    const x = direction.includes("w") ? minX : direction.includes("e") ? maxX : midX;
    const y = direction.includes("n") ? minY : direction.includes("s") ? maxY : midY;
    return {
        x: x,
        y: y
    };
}
function $599424392786cc34$var$getOppositeDirection(direction) {
    return $599424392786cc34$var$oppositeDirectionMap[direction];
}
function $599424392786cc34$export$7395518b474faf76(rect, offset, direction, opts) {
    const { scalingOriginMode: scalingOriginMode, lockAspectRatio: lockAspectRatio } = opts;
    const extent = $599424392786cc34$var$getRectExtentPoint(rect, direction);
    const oppositeDirection = $599424392786cc34$var$getOppositeDirection(direction);
    const oppositeExtent = $599424392786cc34$var$getRectExtentPoint(rect, oppositeDirection);
    if (scalingOriginMode === "center") offset = {
        x: offset.x * 2,
        y: offset.y * 2
    };
    const newExtent = {
        x: extent.x + offset.x,
        y: extent.y + offset.y
    };
    const multiplier = {
        x: $599424392786cc34$var$compassDirectionMap[direction].x * 2 - 1,
        y: $599424392786cc34$var$compassDirectionMap[direction].y * 2 - 1
    };
    const newSize = {
        width: newExtent.x - oppositeExtent.x,
        height: newExtent.y - oppositeExtent.y
    };
    const scaleX = multiplier.x * newSize.width / rect.width;
    const scaleY = multiplier.y * newSize.height / rect.height;
    const largestMagnitude = $599424392786cc34$var$abs(scaleX) > $599424392786cc34$var$abs(scaleY) ? scaleX : scaleY;
    const scale = lockAspectRatio ? {
        x: largestMagnitude,
        y: largestMagnitude
    } : {
        x: extent.x === oppositeExtent.x ? 1 : scaleX,
        y: extent.y === oppositeExtent.y ? 1 : scaleY
    };
    if (extent.y === oppositeExtent.y) scale.y = $599424392786cc34$var$abs(scale.y);
    else if ($599424392786cc34$var$sign(scale.y) !== $599424392786cc34$var$sign(scaleY)) scale.y *= -1;
    if (extent.x === oppositeExtent.x) scale.x = $599424392786cc34$var$abs(scale.x);
    else if ($599424392786cc34$var$sign(scale.x) !== $599424392786cc34$var$sign(scaleX)) scale.x *= -1;
    switch(scalingOriginMode){
        case "extent":
            return $599424392786cc34$var$transformRect(rect, $599424392786cc34$export$a1e14422480dc60.scale(scale.x, scale.y, oppositeExtent), false);
        case "center":
            return $599424392786cc34$var$transformRect(rect, $599424392786cc34$export$a1e14422480dc60.scale(scale.x, scale.y, {
                x: rect.midX,
                y: rect.midY
            }), false);
    }
}
function $599424392786cc34$var$createRectFromPoints(initialPoint, finalPoint, normalized = true) {
    if (normalized) return {
        x: $599424392786cc34$var$min2(finalPoint.x, initialPoint.x),
        y: $599424392786cc34$var$min2(finalPoint.y, initialPoint.y),
        width: $599424392786cc34$var$abs(finalPoint.x - initialPoint.x),
        height: $599424392786cc34$var$abs(finalPoint.y - initialPoint.y)
    };
    return {
        x: initialPoint.x,
        y: initialPoint.y,
        width: finalPoint.x - initialPoint.x,
        height: finalPoint.y - initialPoint.y
    };
}
function $599424392786cc34$var$transformRect(rect, transform, normalized = true) {
    const p1 = transform.applyTo({
        x: rect.minX,
        y: rect.minY
    });
    const p2 = transform.applyTo({
        x: rect.maxX,
        y: rect.maxY
    });
    return $599424392786cc34$var$createRectFromPoints(p1, p2, normalized);
}



// src/menu.anatomy.ts
var $d0d20352325a4202$export$477202748c7242bf = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("menu").parts("arrow", "arrowTip", "content", "contextTrigger", "indicator", "item", "itemGroup", "itemGroupLabel", "itemIndicator", "itemText", "positioner", "separator", "trigger", "triggerItem");
var $d0d20352325a4202$var$parts = $d0d20352325a4202$export$477202748c7242bf.build();
var $d0d20352325a4202$var$dom = (0, $b06ec5ff205338e5$export$41a9651decfe2bde)({
    getTriggerId: (ctx)=>ctx.ids?.trigger ?? `menu:${ctx.id}:trigger`,
    getContextTriggerId: (ctx)=>ctx.ids?.contextTrigger ?? `menu:${ctx.id}:ctx-trigger`,
    getContentId: (ctx)=>ctx.ids?.content ?? `menu:${ctx.id}:content`,
    getArrowId: (ctx)=>ctx.ids?.arrow ?? `menu:${ctx.id}:arrow`,
    getPositionerId: (ctx)=>ctx.ids?.positioner ?? `menu:${ctx.id}:popper`,
    getGroupId: (ctx, id)=>ctx.ids?.group?.(id) ?? `menu:${ctx.id}:group:${id}`,
    getGroupLabelId: (ctx, id)=>ctx.ids?.groupLabel?.(id) ?? `menu:${ctx.id}:group-label:${id}`,
    getContentEl: (ctx)=>$d0d20352325a4202$var$dom.getById(ctx, $d0d20352325a4202$var$dom.getContentId(ctx)),
    getPositionerEl: (ctx)=>$d0d20352325a4202$var$dom.getById(ctx, $d0d20352325a4202$var$dom.getPositionerId(ctx)),
    getTriggerEl: (ctx)=>$d0d20352325a4202$var$dom.getById(ctx, $d0d20352325a4202$var$dom.getTriggerId(ctx)),
    getHighlightedItemEl: (ctx)=>ctx.highlightedValue ? $d0d20352325a4202$var$dom.getById(ctx, ctx.highlightedValue) : null,
    getArrowEl: (ctx)=>$d0d20352325a4202$var$dom.getById(ctx, $d0d20352325a4202$var$dom.getArrowId(ctx)),
    getElements: (ctx)=>{
        const ownerId = CSS.escape($d0d20352325a4202$var$dom.getContentId(ctx));
        const selector = `[role^="menuitem"][data-ownedby=${ownerId}]:not([data-disabled])`;
        return (0, $b06ec5ff205338e5$export$dcd0d083aa86c355)($d0d20352325a4202$var$dom.getContentEl(ctx), selector);
    },
    getFirstEl: (ctx)=>(0, $89352e0ddd72597a$export$43128fadae87b74a)($d0d20352325a4202$var$dom.getElements(ctx)),
    getLastEl: (ctx)=>(0, $89352e0ddd72597a$export$4c7897fafd92b108)($d0d20352325a4202$var$dom.getElements(ctx)),
    getNextEl: (ctx, loop)=>(0, $b06ec5ff205338e5$export$f3d559454b8c0d00)($d0d20352325a4202$var$dom.getElements(ctx), ctx.highlightedValue, loop ?? ctx.loopFocus),
    getPrevEl: (ctx, loop)=>(0, $b06ec5ff205338e5$export$326274ae311c62fd)($d0d20352325a4202$var$dom.getElements(ctx), ctx.highlightedValue, loop ?? ctx.loopFocus),
    getElemByKey: (ctx, key)=>(0, $b06ec5ff205338e5$export$ec2dfd1ac255c804)($d0d20352325a4202$var$dom.getElements(ctx), {
            state: ctx.typeaheadState,
            key: key,
            activeId: ctx.highlightedValue
        }),
    isTargetDisabled: (v)=>{
        return (0, $b06ec5ff205338e5$export$1b3bfaa9684536aa)(v) && (v.dataset.disabled === "" || v.hasAttribute("disabled"));
    },
    isTriggerItem: (el)=>{
        return !!el?.getAttribute("role")?.startsWith("menuitem") && !!el?.hasAttribute("aria-controls");
    },
    getOptionFromItemEl (el) {
        return {
            id: el.id,
            name: el.dataset.name,
            value: el.dataset.value,
            valueText: el.dataset.valueText,
            type: el.dataset.type
        };
    }
});
// src/menu.connect.ts
function $d0d20352325a4202$export$64605811ab45167f(state, send, normalize) {
    const isSubmenu = state.context.isSubmenu;
    const isTypingAhead = state.context.isTypingAhead;
    const composite = state.context.composite;
    const open = state.hasTag("open");
    const popperStyles = (0, $9e811243c3728edf$export$736498a3bfbba398)({
        ...state.context.positioning,
        placement: state.context.anchorPoint ? "bottom" : state.context.currentPlacement
    });
    function getItemState(props2) {
        return {
            disabled: !!props2.disabled,
            highlighted: state.context.highlightedValue === props2.value
        };
    }
    function getOptionItemProps(props2) {
        const valueText = props2.valueText ?? props2.value;
        return {
            ...props2,
            id: props2.value,
            valueText: valueText
        };
    }
    function getOptionItemState(props2) {
        const itemState = getItemState(getOptionItemProps(props2));
        return {
            ...itemState,
            checked: !!props2.checked
        };
    }
    function getItemProps(props2) {
        const { value: id, closeOnSelect: closeOnSelect, valueText: valueText } = props2;
        const itemState = getItemState(props2);
        return normalize.element({
            ...$d0d20352325a4202$var$parts.item.attrs,
            id: id,
            role: "menuitem",
            "aria-disabled": itemState.disabled,
            "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(itemState.disabled),
            "data-ownedby": $d0d20352325a4202$var$dom.getContentId(state.context),
            "data-highlighted": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(itemState.highlighted),
            "data-valuetext": valueText,
            onDragStart (event) {
                const isLink = event.currentTarget.matches("a[href]");
                if (isLink) event.preventDefault();
            },
            onPointerMove (event) {
                if (itemState.disabled) return;
                if (event.pointerType !== "mouse") return;
                const target = event.currentTarget;
                if (itemState.highlighted) return;
                send({
                    type: "ITEM_POINTERMOVE",
                    id: id,
                    target: target,
                    closeOnSelect: closeOnSelect
                });
            },
            onPointerLeave (event) {
                if (itemState.disabled) return;
                if (event.pointerType !== "mouse") return;
                const pointerMoved = state.previousEvent.type.includes("POINTER");
                if (!pointerMoved) return;
                const target = event.currentTarget;
                send({
                    type: "ITEM_POINTERLEAVE",
                    id: id,
                    target: target,
                    closeOnSelect: closeOnSelect
                });
            },
            onPointerDown (event) {
                if (itemState.disabled) return;
                const target = event.currentTarget;
                send({
                    type: "ITEM_POINTERDOWN",
                    target: target,
                    id: id,
                    closeOnSelect: closeOnSelect
                });
            },
            onClick (event) {
                if ((0, $b06ec5ff205338e5$export$e2c2f0d64f6a549a)(event)) return;
                if ((0, $b06ec5ff205338e5$export$ca85c990e080b373)(event)) return;
                if (itemState.disabled) return;
                const target = event.currentTarget;
                send({
                    type: "ITEM_CLICK",
                    target: target,
                    id: id,
                    closeOnSelect: closeOnSelect
                });
            }
        });
    }
    return {
        highlightedValue: state.context.highlightedValue,
        open: open,
        setOpen (nextOpen) {
            if (nextOpen === open) return;
            send(nextOpen ? "OPEN" : "CLOSE");
        },
        setHighlightedValue (value) {
            send({
                type: "HIGHLIGHTED.SET",
                id: value
            });
        },
        setParent (parent) {
            send({
                type: "PARENT.SET",
                value: parent,
                id: parent.state.context.id
            });
        },
        setChild (child) {
            send({
                type: "CHILD.SET",
                value: child,
                id: child.state.context.id
            });
        },
        reposition (options = {}) {
            send({
                type: "POSITIONING.SET",
                options: options
            });
        },
        getContextTriggerProps () {
            return normalize.element({
                ...$d0d20352325a4202$var$parts.contextTrigger.attrs,
                dir: state.context.dir,
                id: $d0d20352325a4202$var$dom.getContextTriggerId(state.context),
                onPointerDown (event) {
                    if (event.pointerType === "mouse") return;
                    const point = (0, $b06ec5ff205338e5$export$a8637644cbd23a7b)(event);
                    send({
                        type: "CONTEXT_MENU_START",
                        point: point
                    });
                },
                onPointerCancel (event) {
                    if (event.pointerType === "mouse") return;
                    send("CONTEXT_MENU_CANCEL");
                },
                onPointerMove (event) {
                    if (event.pointerType === "mouse") return;
                    send("CONTEXT_MENU_CANCEL");
                },
                onPointerUp (event) {
                    if (event.pointerType === "mouse") return;
                    send("CONTEXT_MENU_CANCEL");
                },
                onContextMenu (event) {
                    const point = (0, $b06ec5ff205338e5$export$a8637644cbd23a7b)(event);
                    send({
                        type: "CONTEXT_MENU",
                        point: point
                    });
                    event.preventDefault();
                },
                style: {
                    WebkitTouchCallout: "none",
                    WebkitUserSelect: "none",
                    userSelect: "none"
                }
            });
        },
        getTriggerItemProps (childApi) {
            return (0, $5c0da97e9c7aa95f$export$9d1611c77c2fe928)(getItemProps({
                value: childApi.getTriggerProps().id
            }), childApi.getTriggerProps());
        },
        getTriggerProps () {
            return normalize.button({
                ...isSubmenu ? $d0d20352325a4202$var$parts.triggerItem.attrs : $d0d20352325a4202$var$parts.trigger.attrs,
                "data-placement": state.context.currentPlacement,
                type: "button",
                dir: state.context.dir,
                id: $d0d20352325a4202$var$dom.getTriggerId(state.context),
                "data-uid": state.context.id,
                "aria-haspopup": composite ? "menu" : "dialog",
                "aria-controls": $d0d20352325a4202$var$dom.getContentId(state.context),
                "aria-expanded": open || void 0,
                "data-state": open ? "open" : "closed",
                onPointerMove (event) {
                    if (event.pointerType !== "mouse") return;
                    const disabled = $d0d20352325a4202$var$dom.isTargetDisabled(event.currentTarget);
                    if (disabled || !isSubmenu) return;
                    send({
                        type: "TRIGGER_POINTERMOVE",
                        target: event.currentTarget
                    });
                },
                onPointerLeave (event) {
                    if ($d0d20352325a4202$var$dom.isTargetDisabled(event.currentTarget)) return;
                    if (event.pointerType !== "mouse") return;
                    if (!isSubmenu) return;
                    const point = (0, $b06ec5ff205338e5$export$a8637644cbd23a7b)(event);
                    send({
                        type: "TRIGGER_POINTERLEAVE",
                        target: event.currentTarget,
                        point: point
                    });
                },
                onPointerDown (event) {
                    if ($d0d20352325a4202$var$dom.isTargetDisabled(event.currentTarget)) return;
                    if ((0, $b06ec5ff205338e5$export$6faedb510c176c60)(event)) return;
                    event.preventDefault();
                },
                onClick (event) {
                    if (event.defaultPrevented) return;
                    if ($d0d20352325a4202$var$dom.isTargetDisabled(event.currentTarget)) return;
                    send({
                        type: "TRIGGER_CLICK",
                        target: event.currentTarget
                    });
                },
                onBlur () {
                    send("TRIGGER_BLUR");
                },
                onFocus () {
                    send("TRIGGER_FOCUS");
                },
                onKeyDown (event) {
                    if (event.defaultPrevented) return;
                    const keyMap = {
                        ArrowDown () {
                            send("ARROW_DOWN");
                        },
                        ArrowUp () {
                            send("ARROW_UP");
                        },
                        Enter () {
                            send({
                                type: "ARROW_DOWN",
                                src: "enter"
                            });
                        },
                        Space () {
                            send({
                                type: "ARROW_DOWN",
                                src: "space"
                            });
                        }
                    };
                    const key = (0, $b06ec5ff205338e5$export$f7a7490116b79d4d)(event, state.context);
                    const exec = keyMap[key];
                    if (exec) {
                        event.preventDefault();
                        exec(event);
                    }
                }
            });
        },
        getIndicatorProps () {
            return normalize.element({
                ...$d0d20352325a4202$var$parts.indicator.attrs,
                dir: state.context.dir,
                "data-state": open ? "open" : "closed"
            });
        },
        getPositionerProps () {
            return normalize.element({
                ...$d0d20352325a4202$var$parts.positioner.attrs,
                dir: state.context.dir,
                id: $d0d20352325a4202$var$dom.getPositionerId(state.context),
                style: popperStyles.floating
            });
        },
        getArrowProps () {
            return normalize.element({
                id: $d0d20352325a4202$var$dom.getArrowId(state.context),
                ...$d0d20352325a4202$var$parts.arrow.attrs,
                dir: state.context.dir,
                style: popperStyles.arrow
            });
        },
        getArrowTipProps () {
            return normalize.element({
                ...$d0d20352325a4202$var$parts.arrowTip.attrs,
                dir: state.context.dir,
                style: popperStyles.arrowTip
            });
        },
        getContentProps () {
            return normalize.element({
                ...$d0d20352325a4202$var$parts.content.attrs,
                id: $d0d20352325a4202$var$dom.getContentId(state.context),
                "aria-label": state.context["aria-label"],
                hidden: !open,
                "data-state": open ? "open" : "closed",
                role: composite ? "menu" : "dialog",
                tabIndex: 0,
                dir: state.context.dir,
                "aria-activedescendant": state.context.highlightedValue ?? void 0,
                "aria-labelledby": $d0d20352325a4202$var$dom.getTriggerId(state.context),
                "data-placement": state.context.currentPlacement,
                onPointerEnter (event) {
                    if (event.pointerType !== "mouse") return;
                    send("MENU_POINTERENTER");
                },
                onKeyDown (event) {
                    if (event.defaultPrevented) return;
                    if (!(0, $b06ec5ff205338e5$export$7bced8f45c53f2f)(event)) return;
                    const target = (0, $b06ec5ff205338e5$export$e58f029f0fbfdb29)(event);
                    const sameMenu = target?.closest("[role=menu]") === event.currentTarget || target === event.currentTarget;
                    if (!sameMenu) return;
                    if (event.key === "Tab") {
                        const valid = (0, $b06ec5ff205338e5$export$605ed6bb305230a3)(event);
                        if (!valid) {
                            event.preventDefault();
                            return;
                        }
                    }
                    const item = $d0d20352325a4202$var$dom.getHighlightedItemEl(state.context);
                    const keyMap = {
                        ArrowDown () {
                            send("ARROW_DOWN");
                        },
                        ArrowUp () {
                            send("ARROW_UP");
                        },
                        ArrowLeft () {
                            send("ARROW_LEFT");
                        },
                        ArrowRight () {
                            send("ARROW_RIGHT");
                        },
                        Enter () {
                            send("ENTER");
                            if ((0, $b06ec5ff205338e5$export$1800cc20d529d764)(item)) state.context.navigate({
                                value: state.context.highlightedValue,
                                node: item
                            });
                        },
                        Space (event2) {
                            if (isTypingAhead) send({
                                type: "TYPEAHEAD",
                                key: event2.key
                            });
                            else keyMap.Enter?.(event2);
                        },
                        Home () {
                            send("HOME");
                        },
                        End () {
                            send("END");
                        }
                    };
                    const key = (0, $b06ec5ff205338e5$export$f7a7490116b79d4d)(event, {
                        dir: state.context.dir
                    });
                    const exec = keyMap[key];
                    if (exec) {
                        exec(event);
                        event.stopPropagation();
                        event.preventDefault();
                        return;
                    }
                    if (!state.context.typeahead) return;
                    if (!(0, $b06ec5ff205338e5$export$b3f2c64190cf8c4)(event)) return;
                    if ((0, $b06ec5ff205338e5$export$90788ad2c69b4f50)(event)) return;
                    if ((0, $b06ec5ff205338e5$export$2780cb57de98fa3a)(target)) return;
                    send({
                        type: "TYPEAHEAD",
                        key: event.key
                    });
                    event.preventDefault();
                }
            });
        },
        getSeparatorProps () {
            return normalize.element({
                ...$d0d20352325a4202$var$parts.separator.attrs,
                role: "separator",
                dir: state.context.dir,
                "aria-orientation": "horizontal"
            });
        },
        getItemState: getItemState,
        getItemProps: getItemProps,
        getOptionItemState: getOptionItemState,
        getOptionItemProps (props2) {
            const { type: type, disabled: disabled, onCheckedChange: onCheckedChange, closeOnSelect: closeOnSelect } = props2;
            const option = getOptionItemProps(props2);
            const itemState = getOptionItemState(props2);
            return {
                ...getItemProps(option),
                ...normalize.element({
                    "data-type": type,
                    ...$d0d20352325a4202$var$parts.item.attrs,
                    dir: state.context.dir,
                    "data-value": option.value,
                    role: `menuitem${type}`,
                    "aria-checked": !!itemState.checked,
                    "data-state": itemState.checked ? "checked" : "unchecked",
                    onClick (event) {
                        if (disabled) return;
                        if ((0, $b06ec5ff205338e5$export$e2c2f0d64f6a549a)(event)) return;
                        if ((0, $b06ec5ff205338e5$export$ca85c990e080b373)(event)) return;
                        const target = event.currentTarget;
                        send({
                            type: "ITEM_CLICK",
                            target: target,
                            option: option,
                            closeOnSelect: closeOnSelect
                        });
                        onCheckedChange?.(!itemState.checked);
                    }
                })
            };
        },
        getItemIndicatorProps (props2) {
            const itemState = getOptionItemState(props2);
            return normalize.element({
                ...$d0d20352325a4202$var$parts.itemIndicator.attrs,
                dir: state.context.dir,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(itemState.disabled),
                "data-highlighted": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(itemState.highlighted),
                "data-state": itemState.checked ? "checked" : "unchecked",
                hidden: !itemState.checked
            });
        },
        getItemTextProps (props2) {
            const itemState = getOptionItemState(props2);
            return normalize.element({
                ...$d0d20352325a4202$var$parts.itemText.attrs,
                dir: state.context.dir,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(itemState.disabled),
                "data-highlighted": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(itemState.highlighted),
                "data-state": itemState.checked ? "checked" : "unchecked"
            });
        },
        getItemGroupLabelProps (props2) {
            return normalize.element({
                id: $d0d20352325a4202$var$dom.getGroupLabelId(state.context, props2.htmlFor),
                dir: state.context.dir,
                ...$d0d20352325a4202$var$parts.itemGroupLabel.attrs
            });
        },
        getItemGroupProps (props2) {
            return normalize.element({
                id: $d0d20352325a4202$var$dom.getGroupId(state.context, props2.id),
                ...$d0d20352325a4202$var$parts.itemGroup.attrs,
                dir: state.context.dir,
                "aria-labelledby": $d0d20352325a4202$var$dom.getGroupLabelId(state.context, props2.id),
                role: "group"
            });
        }
    };
}
var { not: $d0d20352325a4202$var$not, and: $d0d20352325a4202$var$and, or: $d0d20352325a4202$var$or } = (0, $5c0da97e9c7aa95f$export$f3249297f3edf7e9);
function $d0d20352325a4202$export$ea56d40cd27c3480(userContext) {
    const ctx = (0, $89352e0ddd72597a$export$8e16b83750b44988)(userContext);
    return (0, $5c0da97e9c7aa95f$export$aaa7fa18f8e9b2e8)({
        id: "menu",
        initial: ctx.open ? "open" : "idle",
        context: {
            highlightedValue: null,
            loopFocus: false,
            anchorPoint: null,
            closeOnSelect: true,
            typeahead: true,
            composite: true,
            navigate (details) {
                (0, $b06ec5ff205338e5$export$e91dc30618113dbe)(details.node);
            },
            ...ctx,
            positioning: {
                placement: "bottom-start",
                gutter: 8,
                ...ctx.positioning
            },
            intentPolygon: null,
            parent: null,
            lastHighlightedValue: null,
            children: (0, $89352e0ddd72597a$export$f2db7d5238e1d23f)((0, $7bf56e9c8ff12ab3$export$eff4d24c3ff7876e)({})),
            suspendPointer: false,
            typeaheadState: (0, $b06ec5ff205338e5$export$ec2dfd1ac255c804).defaultOptions
        },
        computed: {
            isSubmenu: (ctx2)=>ctx2.parent !== null,
            isRtl: (ctx2)=>ctx2.dir === "rtl",
            isTypingAhead: (ctx2)=>ctx2.typeaheadState.keysSoFar !== ""
        },
        watch: {
            isSubmenu: "setSubmenuPlacement",
            anchorPoint: "reposition",
            open: "toggleVisibility"
        },
        on: {
            "PARENT.SET": {
                actions: "setParentMenu"
            },
            "CHILD.SET": {
                actions: "setChildMenu"
            },
            OPEN: [
                {
                    guard: "isOpenControlled",
                    actions: "invokeOnOpen"
                },
                {
                    target: "open",
                    actions: "invokeOnOpen"
                }
            ],
            OPEN_AUTOFOCUS: [
                {
                    guard: "isOpenControlled",
                    actions: [
                        "invokeOnOpen"
                    ]
                },
                {
                    internal: true,
                    target: "open",
                    actions: [
                        "highlightFirstItem",
                        "invokeOnOpen"
                    ]
                }
            ],
            CLOSE: [
                {
                    guard: "isOpenControlled",
                    actions: "invokeOnClose"
                },
                {
                    target: "closed",
                    actions: "invokeOnClose"
                }
            ],
            "HIGHLIGHTED.RESTORE": {
                actions: "restoreHighlightedItem"
            },
            "HIGHLIGHTED.SET": {
                actions: "setHighlightedItem"
            }
        },
        states: {
            idle: {
                tags: [
                    "closed"
                ],
                on: {
                    "CONTROLLED.OPEN": "open",
                    "CONTROLLED.CLOSE": "closed",
                    CONTEXT_MENU_START: {
                        target: "opening:contextmenu",
                        actions: "setAnchorPoint"
                    },
                    CONTEXT_MENU: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "setAnchorPoint",
                                "invokeOnOpen"
                            ]
                        },
                        {
                            target: "open",
                            actions: [
                                "setAnchorPoint",
                                "invokeOnOpen"
                            ]
                        }
                    ],
                    TRIGGER_CLICK: [
                        {
                            guard: "isOpenControlled",
                            actions: "invokeOnOpen"
                        },
                        {
                            target: "open",
                            actions: "invokeOnOpen"
                        }
                    ],
                    TRIGGER_FOCUS: {
                        guard: $d0d20352325a4202$var$not("isSubmenu"),
                        target: "closed"
                    },
                    TRIGGER_POINTERMOVE: {
                        guard: "isSubmenu",
                        target: "opening"
                    }
                }
            },
            "opening:contextmenu": {
                tags: [
                    "closed"
                ],
                after: {
                    LONG_PRESS_DELAY: [
                        {
                            guard: "isOpenControlled",
                            actions: "invokeOnOpen"
                        },
                        {
                            target: "open",
                            actions: "invokeOnOpen"
                        }
                    ]
                },
                on: {
                    "CONTROLLED.OPEN": "open",
                    "CONTROLLED.CLOSE": "closed",
                    CONTEXT_MENU_CANCEL: [
                        {
                            guard: "isOpenControlled",
                            actions: "invokeOnClose"
                        },
                        {
                            target: "closed",
                            actions: "invokeOnClose"
                        }
                    ]
                }
            },
            opening: {
                tags: [
                    "closed"
                ],
                after: {
                    SUBMENU_OPEN_DELAY: [
                        {
                            guard: "isOpenControlled",
                            actions: "invokeOnOpen"
                        },
                        {
                            target: "open",
                            actions: "invokeOnOpen"
                        }
                    ]
                },
                on: {
                    "CONTROLLED.OPEN": "open",
                    "CONTROLLED.CLOSE": "closed",
                    BLUR: [
                        {
                            guard: "isOpenControlled",
                            actions: "invokeOnClose"
                        },
                        {
                            target: "closed",
                            actions: "invokeOnClose"
                        }
                    ],
                    TRIGGER_POINTERLEAVE: [
                        {
                            guard: "isOpenControlled",
                            actions: "invokeOnClose"
                        },
                        {
                            target: "closed",
                            actions: "invokeOnClose"
                        }
                    ]
                }
            },
            closing: {
                tags: [
                    "open"
                ],
                activities: [
                    "trackPointerMove",
                    "trackInteractOutside"
                ],
                after: {
                    SUBMENU_CLOSE_DELAY: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnClose"
                            ]
                        },
                        {
                            target: "closed",
                            actions: [
                                "focusParentMenu",
                                "restoreParentHighlightedItem",
                                "invokeOnClose"
                            ]
                        }
                    ]
                },
                on: {
                    "CONTROLLED.OPEN": "open",
                    "CONTROLLED.CLOSE": {
                        target: "closed",
                        actions: [
                            "focusParentMenu",
                            "restoreParentHighlightedItem"
                        ]
                    },
                    // don't invoke on open here since the menu is still open (we're only keeping it open)
                    MENU_POINTERENTER: {
                        target: "open",
                        actions: "clearIntentPolygon"
                    },
                    POINTER_MOVED_AWAY_FROM_SUBMENU: [
                        {
                            guard: "isOpenControlled",
                            actions: "invokeOnClose"
                        },
                        {
                            target: "closed",
                            actions: [
                                "focusParentMenu",
                                "restoreParentHighlightedItem"
                            ]
                        }
                    ]
                }
            },
            closed: {
                tags: [
                    "closed"
                ],
                entry: [
                    "clearHighlightedItem",
                    "focusTrigger",
                    "resumePointer"
                ],
                on: {
                    "CONTROLLED.OPEN": [
                        {
                            guard: $d0d20352325a4202$var$or("isOpenAutoFocusEvent", "isArrowDownEvent"),
                            target: "open",
                            actions: "highlightFirstItem"
                        },
                        {
                            guard: "isArrowUpEvent",
                            target: "open",
                            actions: "highlightLastItem"
                        },
                        {
                            target: "open"
                        }
                    ],
                    CONTEXT_MENU_START: {
                        target: "opening:contextmenu",
                        actions: "setAnchorPoint"
                    },
                    CONTEXT_MENU: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "setAnchorPoint",
                                "invokeOnOpen"
                            ]
                        },
                        {
                            target: "open",
                            actions: [
                                "setAnchorPoint",
                                "invokeOnOpen"
                            ]
                        }
                    ],
                    TRIGGER_CLICK: [
                        {
                            guard: "isOpenControlled",
                            actions: "invokeOnOpen"
                        },
                        {
                            target: "open",
                            actions: "invokeOnOpen"
                        }
                    ],
                    TRIGGER_POINTERMOVE: {
                        guard: "isTriggerItem",
                        target: "opening"
                    },
                    TRIGGER_BLUR: "idle",
                    ARROW_DOWN: [
                        {
                            guard: "isOpenControlled",
                            actions: "invokeOnOpen"
                        },
                        {
                            target: "open",
                            actions: [
                                "highlightFirstItem",
                                "invokeOnOpen"
                            ]
                        }
                    ],
                    ARROW_UP: [
                        {
                            guard: "isOpenControlled",
                            actions: "invokeOnOpen"
                        },
                        {
                            target: "open",
                            actions: [
                                "highlightLastItem",
                                "invokeOnOpen"
                            ]
                        }
                    ]
                }
            },
            open: {
                tags: [
                    "open"
                ],
                activities: [
                    "trackInteractOutside",
                    "trackPositioning",
                    "scrollToHighlightedItem"
                ],
                entry: [
                    "focusMenu",
                    "resumePointer"
                ],
                on: {
                    "CONTROLLED.CLOSE": [
                        {
                            target: "closed",
                            guard: "isArrowLeftEvent",
                            actions: [
                                "focusParentMenu"
                            ]
                        },
                        {
                            target: "closed"
                        }
                    ],
                    TRIGGER_CLICK: [
                        {
                            guard: $d0d20352325a4202$var$and($d0d20352325a4202$var$not("isTriggerItem"), "isOpenControlled"),
                            actions: "invokeOnClose"
                        },
                        {
                            guard: $d0d20352325a4202$var$not("isTriggerItem"),
                            target: "closed",
                            actions: "invokeOnClose"
                        }
                    ],
                    ARROW_UP: {
                        actions: [
                            "highlightPrevItem",
                            "focusMenu"
                        ]
                    },
                    ARROW_DOWN: {
                        actions: [
                            "highlightNextItem",
                            "focusMenu"
                        ]
                    },
                    ARROW_LEFT: [
                        {
                            guard: $d0d20352325a4202$var$and("isSubmenu", "isOpenControlled"),
                            actions: "invokeOnClose"
                        },
                        {
                            guard: "isSubmenu",
                            target: "closed",
                            actions: [
                                "focusParentMenu",
                                "invokeOnClose"
                            ]
                        }
                    ],
                    HOME: {
                        actions: [
                            "highlightFirstItem",
                            "focusMenu"
                        ]
                    },
                    END: {
                        actions: [
                            "highlightLastItem",
                            "focusMenu"
                        ]
                    },
                    ARROW_RIGHT: {
                        guard: "isTriggerItemHighlighted",
                        actions: "openSubmenu"
                    },
                    ENTER: [
                        {
                            guard: "isTriggerItemHighlighted",
                            actions: "openSubmenu"
                        },
                        {
                            actions: "clickHighlightedItem"
                        }
                    ],
                    ITEM_POINTERMOVE: [
                        {
                            guard: $d0d20352325a4202$var$not("suspendPointer"),
                            actions: [
                                "setHighlightedItem",
                                "focusMenu"
                            ]
                        },
                        {
                            actions: "setLastHighlightedItem"
                        }
                    ],
                    ITEM_POINTERLEAVE: {
                        guard: $d0d20352325a4202$var$and($d0d20352325a4202$var$not("suspendPointer"), $d0d20352325a4202$var$not("isTriggerItem")),
                        actions: "clearHighlightedItem"
                    },
                    ITEM_CLICK: [
                        // == grouped ==
                        {
                            guard: $d0d20352325a4202$var$and($d0d20352325a4202$var$not("isTriggerItemHighlighted"), $d0d20352325a4202$var$not("isHighlightedItemEditable"), "closeOnSelect", "isOpenControlled"),
                            actions: [
                                "invokeOnSelect",
                                "setOptionState",
                                "closeRootMenu",
                                "invokeOnClose"
                            ]
                        },
                        {
                            guard: $d0d20352325a4202$var$and($d0d20352325a4202$var$not("isTriggerItemHighlighted"), $d0d20352325a4202$var$not("isHighlightedItemEditable"), "closeOnSelect"),
                            target: "closed",
                            actions: [
                                "invokeOnSelect",
                                "setOptionState",
                                "closeRootMenu",
                                "invokeOnClose"
                            ]
                        },
                        //
                        {
                            guard: $d0d20352325a4202$var$and($d0d20352325a4202$var$not("isTriggerItemHighlighted"), $d0d20352325a4202$var$not("isHighlightedItemEditable")),
                            actions: [
                                "invokeOnSelect",
                                "setOptionState"
                            ]
                        },
                        {
                            actions: "setHighlightedItem"
                        }
                    ],
                    TRIGGER_POINTERLEAVE: {
                        target: "closing",
                        actions: "setIntentPolygon"
                    },
                    ITEM_POINTERDOWN: {
                        actions: "setHighlightedItem"
                    },
                    TYPEAHEAD: {
                        actions: "highlightMatchedItem"
                    },
                    FOCUS_MENU: {
                        actions: "focusMenu"
                    },
                    "POSITIONING.SET": {
                        actions: "reposition"
                    }
                }
            }
        }
    }, {
        delays: {
            LONG_PRESS_DELAY: 700,
            SUBMENU_OPEN_DELAY: 100,
            SUBMENU_CLOSE_DELAY: 100
        },
        guards: {
            closeOnSelect: (ctx2, evt)=>!!(evt?.closeOnSelect ?? ctx2.closeOnSelect),
            // whether the trigger is also a menu item
            isTriggerItem: (_ctx, evt)=>$d0d20352325a4202$var$dom.isTriggerItem(evt.target),
            // whether the trigger item is the active item
            isTriggerItemHighlighted: (ctx2, evt)=>{
                const target = evt.target ?? $d0d20352325a4202$var$dom.getHighlightedItemEl(ctx2);
                return !!target?.hasAttribute("aria-controls");
            },
            isSubmenu: (ctx2)=>ctx2.isSubmenu,
            suspendPointer: (ctx2)=>ctx2.suspendPointer,
            isHighlightedItemEditable: (ctx2)=>(0, $b06ec5ff205338e5$export$2780cb57de98fa3a)($d0d20352325a4202$var$dom.getHighlightedItemEl(ctx2)),
            isWithinPolygon: (ctx2, evt)=>{
                if (!ctx2.intentPolygon) return false;
                return (0, $599424392786cc34$export$f1c31811357415ac)(ctx2.intentPolygon, evt.point);
            },
            // guard assertions (for controlled mode)
            isOpenControlled: (ctx2)=>!!ctx2["open.controlled"],
            isArrowLeftEvent: (_ctx, evt)=>evt.previousEvent?.type === "ARROW_LEFT",
            isArrowUpEvent: (_ctx, evt)=>evt.previousEvent?.type === "ARROW_UP",
            isArrowDownEvent: (_ctx, evt)=>evt.previousEvent?.type === "ARROW_DOWN",
            isOpenAutoFocusEvent: (_ctx, evt)=>evt.previousEvent?.type === "OPEN_AUTOFOCUS"
        },
        activities: {
            trackPositioning (ctx2) {
                if (ctx2.anchorPoint) return;
                ctx2.currentPlacement = ctx2.positioning.placement;
                const getPositionerEl = ()=>$d0d20352325a4202$var$dom.getPositionerEl(ctx2);
                return (0, $9e811243c3728edf$export$a9fe23cfa43a7b55)($d0d20352325a4202$var$dom.getTriggerEl(ctx2), getPositionerEl, {
                    ...ctx2.positioning,
                    defer: true,
                    onComplete (data) {
                        ctx2.currentPlacement = data.placement;
                    }
                });
            },
            trackInteractOutside (ctx2, _evt, { send: send }) {
                const getContentEl = ()=>$d0d20352325a4202$var$dom.getContentEl(ctx2);
                let restoreFocus = true;
                return (0, $a0385836474f3c11$export$72bda0e502b8ea31)(getContentEl, {
                    defer: true,
                    exclude: [
                        $d0d20352325a4202$var$dom.getTriggerEl(ctx2)
                    ],
                    onInteractOutside: ctx2.onInteractOutside,
                    onFocusOutside: ctx2.onFocusOutside,
                    onEscapeKeyDown (event) {
                        ctx2.onEscapeKeyDown?.(event);
                        if (ctx2.isSubmenu) event.preventDefault();
                        $d0d20352325a4202$var$closeRootMenu(ctx2);
                    },
                    onPointerDownOutside (event) {
                        restoreFocus = !event.detail.focusable;
                        ctx2.onPointerDownOutside?.(event);
                    },
                    onDismiss () {
                        send({
                            type: "CLOSE",
                            src: "interact-outside",
                            restoreFocus: restoreFocus
                        });
                    }
                });
            },
            trackPointerMove (ctx2, _evt, { guards: guards2, send: send }) {
                const { isWithinPolygon: isWithinPolygon } = guards2;
                ctx2.parent.state.context.suspendPointer = true;
                const doc = $d0d20352325a4202$var$dom.getDoc(ctx2);
                return (0, $b06ec5ff205338e5$export$b1d829ddf82884aa)(doc, "pointermove", (e)=>{
                    const point = {
                        x: e.clientX,
                        y: e.clientY
                    };
                    const isMovingToSubmenu = isWithinPolygon(ctx2, {
                        point: point
                    });
                    if (!isMovingToSubmenu) {
                        send("POINTER_MOVED_AWAY_FROM_SUBMENU");
                        ctx2.parent.state.context.suspendPointer = false;
                    }
                });
            },
            scrollToHighlightedItem (ctx2, _evt, { getState: getState }) {
                const exec = ()=>{
                    const state = getState();
                    if (state.event.type.startsWith("ITEM_POINTER")) return;
                    const itemEl = $d0d20352325a4202$var$dom.getHighlightedItemEl(ctx2);
                    const contentEl2 = $d0d20352325a4202$var$dom.getContentEl(ctx2);
                    (0, $b06ec5ff205338e5$export$53a0910f038337bd)(itemEl, {
                        rootEl: contentEl2,
                        block: "nearest"
                    });
                };
                (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>exec());
                const contentEl = ()=>$d0d20352325a4202$var$dom.getContentEl(ctx2);
                return (0, $b06ec5ff205338e5$export$343af0d656c88488)(contentEl, {
                    defer: true,
                    attributes: [
                        "aria-activedescendant"
                    ],
                    callback: exec
                });
            }
        },
        actions: {
            setAnchorPoint (ctx2, evt) {
                ctx2.anchorPoint = evt.point;
            },
            setSubmenuPlacement (ctx2) {
                if (!ctx2.isSubmenu) return;
                ctx2.positioning.placement = ctx2.isRtl ? "left-start" : "right-start";
                ctx2.positioning.gutter = 0;
            },
            reposition (ctx2, evt) {
                const getPositionerEl = ()=>$d0d20352325a4202$var$dom.getPositionerEl(ctx2);
                const getAnchorRect = ctx2.anchorPoint ? ()=>({
                        width: 0,
                        height: 0,
                        ...ctx2.anchorPoint
                    }) : void 0;
                (0, $9e811243c3728edf$export$a9fe23cfa43a7b55)($d0d20352325a4202$var$dom.getTriggerEl(ctx2), getPositionerEl, {
                    ...ctx2.positioning,
                    defer: true,
                    getAnchorRect: getAnchorRect,
                    ...evt.options ?? {},
                    listeners: false,
                    onComplete (data) {
                        ctx2.currentPlacement = data.placement;
                    }
                });
            },
            setOptionState (_ctx, evt) {
                if (!evt.option) return;
                const { checked: checked, onCheckedChange: onCheckedChange, type: type } = evt.option;
                if (type === "radio") onCheckedChange?.(true);
                else if (type === "checkbox") onCheckedChange?.(!checked);
            },
            clickHighlightedItem (ctx2, _evt) {
                const itemEl = $d0d20352325a4202$var$dom.getHighlightedItemEl(ctx2);
                if (!itemEl || itemEl.dataset.disabled) return;
                queueMicrotask(()=>itemEl.click());
            },
            setIntentPolygon (ctx2, evt) {
                const menu = $d0d20352325a4202$var$dom.getContentEl(ctx2);
                const placement = ctx2.currentPlacement;
                if (!menu || !placement) return;
                const rect = menu.getBoundingClientRect();
                const polygon = (0, $599424392786cc34$export$a818e5abc94ef05a)(rect, placement);
                if (!polygon) return;
                const rightSide = (0, $9e811243c3728edf$export$2f5876c005418271)(placement) === "right";
                const bleed = rightSide ? -5 : 5;
                ctx2.intentPolygon = [
                    {
                        ...evt.point,
                        x: evt.point.x + bleed
                    },
                    ...polygon
                ];
            },
            clearIntentPolygon (ctx2) {
                ctx2.intentPolygon = null;
            },
            resumePointer (ctx2) {
                if (!ctx2.parent) return;
                ctx2.parent.state.context.suspendPointer = false;
            },
            setHighlightedItem (ctx2, evt) {
                $d0d20352325a4202$var$set.highlighted(ctx2, evt.id);
            },
            clearHighlightedItem (ctx2) {
                $d0d20352325a4202$var$set.highlighted(ctx2, null);
            },
            focusMenu (ctx2) {
                (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>{
                    const contentEl = $d0d20352325a4202$var$dom.getContentEl(ctx2);
                    const initialFocusEl = (0, $b06ec5ff205338e5$export$af1ff6d51ec218ea)({
                        root: contentEl,
                        enabled: !(0, $b06ec5ff205338e5$export$2344b14b097df817)(contentEl, $d0d20352325a4202$var$dom.getActiveElement(ctx2)),
                        filter (node) {
                            return !node.role?.startsWith("menuitem");
                        }
                    });
                    initialFocusEl?.focus({
                        preventScroll: true
                    });
                });
            },
            highlightFirstItem (ctx2) {
                const fn = !!$d0d20352325a4202$var$dom.getContentEl(ctx2) ? queueMicrotask : (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4);
                fn(()=>{
                    const first2 = $d0d20352325a4202$var$dom.getFirstEl(ctx2);
                    if (!first2) return;
                    $d0d20352325a4202$var$set.highlighted(ctx2, first2.id);
                });
            },
            highlightLastItem (ctx2) {
                const fn = !!$d0d20352325a4202$var$dom.getContentEl(ctx2) ? queueMicrotask : (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4);
                fn(()=>{
                    const last2 = $d0d20352325a4202$var$dom.getLastEl(ctx2);
                    if (!last2) return;
                    $d0d20352325a4202$var$set.highlighted(ctx2, last2.id);
                });
            },
            highlightNextItem (ctx2, evt) {
                const next = $d0d20352325a4202$var$dom.getNextEl(ctx2, evt.loop);
                $d0d20352325a4202$var$set.highlighted(ctx2, next?.id ?? null);
            },
            highlightPrevItem (ctx2, evt) {
                const prev = $d0d20352325a4202$var$dom.getPrevEl(ctx2, evt.loop);
                $d0d20352325a4202$var$set.highlighted(ctx2, prev?.id ?? null);
            },
            invokeOnSelect (ctx2) {
                if (!ctx2.highlightedValue) return;
                ctx2.onSelect?.({
                    value: ctx2.highlightedValue
                });
            },
            focusTrigger (ctx2, evt) {
                if (ctx2.isSubmenu || ctx2.anchorPoint || evt.restoreFocus === false) return;
                queueMicrotask(()=>$d0d20352325a4202$var$dom.getTriggerEl(ctx2)?.focus({
                        preventScroll: true
                    }));
            },
            highlightMatchedItem (ctx2, evt) {
                const node = $d0d20352325a4202$var$dom.getElemByKey(ctx2, evt.key);
                if (!node) return;
                $d0d20352325a4202$var$set.highlighted(ctx2, node.id);
            },
            setParentMenu (ctx2, evt) {
                ctx2.parent = (0, $7bf56e9c8ff12ab3$export$eff4d24c3ff7876e)(evt.value);
            },
            setChildMenu (ctx2, evt) {
                ctx2.children[evt.id] = (0, $7bf56e9c8ff12ab3$export$eff4d24c3ff7876e)(evt.value);
            },
            closeRootMenu (ctx2) {
                $d0d20352325a4202$var$closeRootMenu(ctx2);
            },
            openSubmenu (ctx2) {
                const item = $d0d20352325a4202$var$dom.getHighlightedItemEl(ctx2);
                const id = item?.getAttribute("data-uid");
                const child = id ? ctx2.children[id] : null;
                child?.send("OPEN_AUTOFOCUS");
            },
            focusParentMenu (ctx2) {
                ctx2.parent?.send("FOCUS_MENU");
            },
            setLastHighlightedItem (ctx2, evt) {
                ctx2.lastHighlightedValue = evt.id;
            },
            restoreHighlightedItem (ctx2) {
                if (!ctx2.lastHighlightedValue) return;
                $d0d20352325a4202$var$set.highlighted(ctx2, ctx2.lastHighlightedValue);
                ctx2.lastHighlightedValue = null;
            },
            restoreParentHighlightedItem (ctx2) {
                ctx2.parent?.send("HIGHLIGHTED.RESTORE");
            },
            invokeOnOpen (ctx2) {
                ctx2.onOpenChange?.({
                    open: true
                });
            },
            invokeOnClose (ctx2) {
                ctx2.onOpenChange?.({
                    open: false
                });
            },
            toggleVisibility (ctx2, evt, { send: send }) {
                send({
                    type: ctx2.open ? "CONTROLLED.OPEN" : "CONTROLLED.CLOSE",
                    previousEvent: evt
                });
            }
        }
    });
}
function $d0d20352325a4202$var$closeRootMenu(ctx) {
    let parent = ctx.parent;
    while(parent && parent.state.context.isSubmenu)parent = parent.state.context.parent;
    parent?.send("CLOSE");
}
var $d0d20352325a4202$var$set = {
    highlighted (ctx, value) {
        if ((0, $89352e0ddd72597a$export$248d38f6296296c5)(ctx.highlightedValue, value)) return;
        ctx.highlightedValue = value;
        ctx.onHighlightChange?.({
            highlightedValue: value
        });
    }
};
var $d0d20352325a4202$export$8128bb6492cf3de7 = (0, $5b359805fda5a40e$export$c94ea207b45fef3a)()([
    "anchorPoint",
    "aria-label",
    "closeOnSelect",
    "composite",
    "dir",
    "getRootNode",
    "highlightedValue",
    "id",
    "ids",
    "loopFocus",
    "navigate",
    "onEscapeKeyDown",
    "onFocusOutside",
    "onHighlightChange",
    "onInteractOutside",
    "onOpenChange",
    "onPointerDownOutside",
    "onSelect",
    "open.controlled",
    "open",
    "positioning",
    "typeahead"
]);
var $d0d20352325a4202$export$45029c61b0073d87 = (0, $89352e0ddd72597a$export$3ea53b214fbc1986)($d0d20352325a4202$export$8128bb6492cf3de7);
var $d0d20352325a4202$export$b67876e05d194bf9 = (0, $5b359805fda5a40e$export$c94ea207b45fef3a)()([
    "closeOnSelect",
    "disabled",
    "value",
    "valueText"
]);
var $d0d20352325a4202$export$ae9d1ad549773548 = (0, $89352e0ddd72597a$export$3ea53b214fbc1986)($d0d20352325a4202$export$b67876e05d194bf9);
var $d0d20352325a4202$export$92ed29ce5b278a77 = (0, $5b359805fda5a40e$export$c94ea207b45fef3a)()([
    "htmlFor"
]);
var $d0d20352325a4202$export$fc6bfc0f1bf8dde8 = (0, $89352e0ddd72597a$export$3ea53b214fbc1986)($d0d20352325a4202$export$92ed29ce5b278a77);
var $d0d20352325a4202$export$fbe8b8f4cd1d5ed7 = (0, $5b359805fda5a40e$export$c94ea207b45fef3a)()([
    "id"
]);
var $d0d20352325a4202$export$f4286fe441d028d6 = (0, $89352e0ddd72597a$export$3ea53b214fbc1986)($d0d20352325a4202$export$fbe8b8f4cd1d5ed7);
var $d0d20352325a4202$export$31e8b70014e67238 = (0, $5b359805fda5a40e$export$c94ea207b45fef3a)()([
    "disabled",
    "valueText",
    "closeOnSelect",
    "type",
    "value",
    "checked",
    "onCheckedChange"
]);
var $d0d20352325a4202$export$434a36525fb1ae39 = (0, $89352e0ddd72597a$export$3ea53b214fbc1986)($d0d20352325a4202$export$31e8b70014e67238);












// src/popover.anatomy.ts
var $f552bad70b683f14$export$477202748c7242bf = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("popover").parts("arrow", "arrowTip", "anchor", "trigger", "indicator", "positioner", "content", "title", "description", "closeTrigger");
var $f552bad70b683f14$var$parts = $f552bad70b683f14$export$477202748c7242bf.build();
var $f552bad70b683f14$var$dom = (0, $b06ec5ff205338e5$export$41a9651decfe2bde)({
    getAnchorId: (ctx)=>ctx.ids?.anchor ?? `popover:${ctx.id}:anchor`,
    getTriggerId: (ctx)=>ctx.ids?.trigger ?? `popover:${ctx.id}:trigger`,
    getContentId: (ctx)=>ctx.ids?.content ?? `popover:${ctx.id}:content`,
    getPositionerId: (ctx)=>ctx.ids?.positioner ?? `popover:${ctx.id}:popper`,
    getArrowId: (ctx)=>ctx.ids?.arrow ?? `popover:${ctx.id}:arrow`,
    getTitleId: (ctx)=>ctx.ids?.title ?? `popover:${ctx.id}:title`,
    getDescriptionId: (ctx)=>ctx.ids?.description ?? `popover:${ctx.id}:desc`,
    getCloseTriggerId: (ctx)=>ctx.ids?.closeTrigger ?? `popover:${ctx.id}:close`,
    getAnchorEl: (ctx)=>$f552bad70b683f14$var$dom.getById(ctx, $f552bad70b683f14$var$dom.getAnchorId(ctx)),
    getTriggerEl: (ctx)=>$f552bad70b683f14$var$dom.getById(ctx, $f552bad70b683f14$var$dom.getTriggerId(ctx)),
    getContentEl: (ctx)=>$f552bad70b683f14$var$dom.getById(ctx, $f552bad70b683f14$var$dom.getContentId(ctx)),
    getPositionerEl: (ctx)=>$f552bad70b683f14$var$dom.getById(ctx, $f552bad70b683f14$var$dom.getPositionerId(ctx)),
    getTitleEl: (ctx)=>$f552bad70b683f14$var$dom.getById(ctx, $f552bad70b683f14$var$dom.getTitleId(ctx)),
    getDescriptionEl: (ctx)=>$f552bad70b683f14$var$dom.getById(ctx, $f552bad70b683f14$var$dom.getDescriptionId(ctx)),
    getFocusableEls: (ctx)=>(0, $b06ec5ff205338e5$export$f6768025e418420e)($f552bad70b683f14$var$dom.getContentEl(ctx)),
    getFirstFocusableEl: (ctx)=>$f552bad70b683f14$var$dom.getFocusableEls(ctx)[0]
});
// src/popover.connect.ts
function $f552bad70b683f14$export$64605811ab45167f(state, send, normalize) {
    const open = state.matches("open");
    const currentPlacement = state.context.currentPlacement;
    const portalled = state.context.currentPortalled;
    const rendered = state.context.renderedElements;
    const popperStyles = (0, $9e811243c3728edf$export$736498a3bfbba398)({
        ...state.context.positioning,
        placement: currentPlacement
    });
    return {
        portalled: portalled,
        open: open,
        setOpen (nextOpen) {
            if (nextOpen === open) return;
            send(nextOpen ? "OPEN" : "CLOSE");
        },
        reposition (options = {}) {
            send({
                type: "POSITIONING.SET",
                options: options
            });
        },
        getArrowProps () {
            return normalize.element({
                id: $f552bad70b683f14$var$dom.getArrowId(state.context),
                ...$f552bad70b683f14$var$parts.arrow.attrs,
                dir: state.context.dir,
                style: popperStyles.arrow
            });
        },
        getArrowTipProps () {
            return normalize.element({
                ...$f552bad70b683f14$var$parts.arrowTip.attrs,
                dir: state.context.dir,
                style: popperStyles.arrowTip
            });
        },
        getAnchorProps () {
            return normalize.element({
                ...$f552bad70b683f14$var$parts.anchor.attrs,
                dir: state.context.dir,
                id: $f552bad70b683f14$var$dom.getAnchorId(state.context)
            });
        },
        getTriggerProps () {
            return normalize.button({
                ...$f552bad70b683f14$var$parts.trigger.attrs,
                dir: state.context.dir,
                type: "button",
                "data-placement": currentPlacement,
                id: $f552bad70b683f14$var$dom.getTriggerId(state.context),
                "aria-haspopup": "dialog",
                "aria-expanded": open,
                "data-state": open ? "open" : "closed",
                "aria-controls": $f552bad70b683f14$var$dom.getContentId(state.context),
                onPointerDown (event) {
                    if ((0, $b06ec5ff205338e5$export$95df08bae54cb4df)()) event.currentTarget.focus();
                },
                onClick (event) {
                    if (event.defaultPrevented) return;
                    send("TOGGLE");
                },
                onBlur (event) {
                    send({
                        type: "TRIGGER_BLUR",
                        target: event.relatedTarget
                    });
                }
            });
        },
        getIndicatorProps () {
            return normalize.element({
                ...$f552bad70b683f14$var$parts.indicator.attrs,
                dir: state.context.dir,
                "data-state": open ? "open" : "closed"
            });
        },
        getPositionerProps () {
            return normalize.element({
                id: $f552bad70b683f14$var$dom.getPositionerId(state.context),
                ...$f552bad70b683f14$var$parts.positioner.attrs,
                dir: state.context.dir,
                style: popperStyles.floating
            });
        },
        getContentProps () {
            return normalize.element({
                ...$f552bad70b683f14$var$parts.content.attrs,
                dir: state.context.dir,
                id: $f552bad70b683f14$var$dom.getContentId(state.context),
                tabIndex: -1,
                role: "dialog",
                hidden: !open,
                "data-state": open ? "open" : "closed",
                "data-expanded": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(open),
                "aria-labelledby": rendered.title ? $f552bad70b683f14$var$dom.getTitleId(state.context) : void 0,
                "aria-describedby": rendered.description ? $f552bad70b683f14$var$dom.getDescriptionId(state.context) : void 0,
                "data-placement": currentPlacement
            });
        },
        getTitleProps () {
            return normalize.element({
                ...$f552bad70b683f14$var$parts.title.attrs,
                id: $f552bad70b683f14$var$dom.getTitleId(state.context),
                dir: state.context.dir
            });
        },
        getDescriptionProps () {
            return normalize.element({
                ...$f552bad70b683f14$var$parts.description.attrs,
                id: $f552bad70b683f14$var$dom.getDescriptionId(state.context),
                dir: state.context.dir
            });
        },
        getCloseTriggerProps () {
            return normalize.button({
                ...$f552bad70b683f14$var$parts.closeTrigger.attrs,
                dir: state.context.dir,
                id: $f552bad70b683f14$var$dom.getCloseTriggerId(state.context),
                type: "button",
                "aria-label": "close",
                onClick (event) {
                    if (event.defaultPrevented) return;
                    send("CLOSE");
                }
            });
        }
    };
}
function $f552bad70b683f14$export$ea56d40cd27c3480(userContext) {
    const ctx = (0, $89352e0ddd72597a$export$8e16b83750b44988)(userContext);
    return (0, $5c0da97e9c7aa95f$export$aaa7fa18f8e9b2e8)({
        id: "popover",
        initial: ctx.open ? "open" : "closed",
        context: {
            closeOnInteractOutside: true,
            closeOnEscape: true,
            autoFocus: true,
            modal: false,
            portalled: true,
            positioning: {
                placement: "bottom",
                ...ctx.positioning
            },
            currentPlacement: void 0,
            ...ctx,
            renderedElements: {
                title: true,
                description: true
            }
        },
        computed: {
            currentPortalled: (ctx2)=>!!ctx2.modal || !!ctx2.portalled
        },
        watch: {
            open: [
                "toggleVisibility"
            ]
        },
        entry: [
            "checkRenderedElements"
        ],
        states: {
            closed: {
                on: {
                    "CONTROLLED.OPEN": {
                        target: "open",
                        actions: [
                            "setInitialFocus"
                        ]
                    },
                    TOGGLE: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnOpen"
                            ]
                        },
                        {
                            target: "open",
                            actions: [
                                "invokeOnOpen",
                                "setInitialFocus"
                            ]
                        }
                    ],
                    OPEN: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnOpen"
                            ]
                        },
                        {
                            target: "open",
                            actions: [
                                "invokeOnOpen",
                                "setInitialFocus"
                            ]
                        }
                    ]
                }
            },
            open: {
                activities: [
                    "trapFocus",
                    "preventScroll",
                    "hideContentBelow",
                    "trackPositioning",
                    "trackDismissableElement",
                    "proxyTabFocus"
                ],
                on: {
                    "CONTROLLED.CLOSE": {
                        target: "closed",
                        actions: [
                            "setFinalFocus"
                        ]
                    },
                    CLOSE: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnClose"
                            ]
                        },
                        {
                            target: "closed",
                            actions: [
                                "invokeOnClose",
                                "setFinalFocus"
                            ]
                        }
                    ],
                    TOGGLE: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnClose"
                            ]
                        },
                        {
                            target: "closed",
                            actions: [
                                "invokeOnClose"
                            ]
                        }
                    ],
                    "POSITIONING.SET": {
                        actions: "reposition"
                    }
                }
            }
        }
    }, {
        guards: {
            isOpenControlled: (ctx2)=>!!ctx2["open.controlled"]
        },
        activities: {
            trackPositioning (ctx2) {
                ctx2.currentPlacement = ctx2.positioning.placement;
                const anchorEl = $f552bad70b683f14$var$dom.getAnchorEl(ctx2) ?? $f552bad70b683f14$var$dom.getTriggerEl(ctx2);
                const getPositionerEl = ()=>$f552bad70b683f14$var$dom.getPositionerEl(ctx2);
                return (0, $9e811243c3728edf$export$a9fe23cfa43a7b55)(anchorEl, getPositionerEl, {
                    ...ctx2.positioning,
                    defer: true,
                    onComplete (data) {
                        ctx2.currentPlacement = data.placement;
                    }
                });
            },
            trackDismissableElement (ctx2, _evt, { send: send }) {
                const getContentEl = ()=>$f552bad70b683f14$var$dom.getContentEl(ctx2);
                let restoreFocus = true;
                return (0, $a0385836474f3c11$export$72bda0e502b8ea31)(getContentEl, {
                    pointerBlocking: ctx2.modal,
                    exclude: $f552bad70b683f14$var$dom.getTriggerEl(ctx2),
                    defer: true,
                    onEscapeKeyDown (event) {
                        ctx2.onEscapeKeyDown?.(event);
                        if (ctx2.closeOnEscape) return;
                        event.preventDefault();
                    },
                    onInteractOutside (event) {
                        ctx2.onInteractOutside?.(event);
                        if (event.defaultPrevented) return;
                        restoreFocus = !(event.detail.focusable || event.detail.contextmenu);
                        if (!ctx2.closeOnInteractOutside) event.preventDefault();
                    },
                    onPointerDownOutside: ctx2.onPointerDownOutside,
                    onFocusOutside: ctx2.onFocusOutside,
                    persistentElements: ctx2.persistentElements,
                    onDismiss () {
                        send({
                            type: "CLOSE",
                            src: "interact-outside",
                            restoreFocus: restoreFocus
                        });
                    }
                });
            },
            proxyTabFocus (ctx2) {
                if (ctx2.modal || !ctx2.portalled) return;
                const getContentEl = ()=>$f552bad70b683f14$var$dom.getContentEl(ctx2);
                return (0, $b06ec5ff205338e5$export$c90f8060ab168f84)(getContentEl, {
                    triggerElement: $f552bad70b683f14$var$dom.getTriggerEl(ctx2),
                    defer: true,
                    onFocus (el) {
                        el.focus({
                            preventScroll: true
                        });
                    }
                });
            },
            hideContentBelow (ctx2) {
                if (!ctx2.modal) return;
                const getElements = ()=>[
                        $f552bad70b683f14$var$dom.getContentEl(ctx2),
                        $f552bad70b683f14$var$dom.getTriggerEl(ctx2)
                    ];
                return (0, $ef6836a155f3b375$export$e1bd0c6150f13d96)(getElements, {
                    defer: true
                });
            },
            preventScroll (ctx2) {
                if (!ctx2.modal) return;
                return (0, $c5b78d1d10851f7e$export$253461bf837fc8c7)($f552bad70b683f14$var$dom.getDoc(ctx2));
            },
            trapFocus (ctx2) {
                if (!ctx2.modal) return;
                const contentEl = ()=>$f552bad70b683f14$var$dom.getContentEl(ctx2);
                return (0, $39480da6128c25d0$export$bec45a54c2e66c22)(contentEl, {
                    initialFocus: ()=>(0, $b06ec5ff205338e5$export$af1ff6d51ec218ea)({
                            root: $f552bad70b683f14$var$dom.getContentEl(ctx2),
                            getInitialEl: ctx2.initialFocusEl,
                            enabled: ctx2.autoFocus
                        })
                });
            }
        },
        actions: {
            reposition (ctx2, evt) {
                const anchorEl = $f552bad70b683f14$var$dom.getAnchorEl(ctx2) ?? $f552bad70b683f14$var$dom.getTriggerEl(ctx2);
                const getPositionerEl = ()=>$f552bad70b683f14$var$dom.getPositionerEl(ctx2);
                (0, $9e811243c3728edf$export$a9fe23cfa43a7b55)(anchorEl, getPositionerEl, {
                    ...ctx2.positioning,
                    ...evt.options,
                    defer: true,
                    listeners: false,
                    onComplete (data) {
                        ctx2.currentPlacement = data.placement;
                    }
                });
            },
            checkRenderedElements (ctx2) {
                (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>{
                    Object.assign(ctx2.renderedElements, {
                        title: !!$f552bad70b683f14$var$dom.getTitleEl(ctx2),
                        description: !!$f552bad70b683f14$var$dom.getDescriptionEl(ctx2)
                    });
                });
            },
            setInitialFocus (ctx2) {
                if (ctx2.modal) return;
                (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>{
                    const element = (0, $b06ec5ff205338e5$export$af1ff6d51ec218ea)({
                        root: $f552bad70b683f14$var$dom.getContentEl(ctx2),
                        getInitialEl: ctx2.initialFocusEl,
                        enabled: ctx2.autoFocus
                    });
                    element?.focus({
                        preventScroll: true
                    });
                });
            },
            setFinalFocus (ctx2, evt) {
                const restoreFocus = evt.restoreFocus ?? evt.previousEvent?.restoreFocus;
                if (restoreFocus != null && !restoreFocus) return;
                (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>{
                    const element = $f552bad70b683f14$var$dom.getTriggerEl(ctx2);
                    element?.focus({
                        preventScroll: true
                    });
                });
            },
            invokeOnOpen (ctx2) {
                ctx2.onOpenChange?.({
                    open: true
                });
            },
            invokeOnClose (ctx2) {
                ctx2.onOpenChange?.({
                    open: false
                });
            },
            toggleVisibility (ctx2, evt, { send: send }) {
                send({
                    type: ctx2.open ? "CONTROLLED.OPEN" : "CONTROLLED.CLOSE",
                    previousEvent: evt
                });
            }
        }
    });
}
var $f552bad70b683f14$export$8128bb6492cf3de7 = (0, $5b359805fda5a40e$export$c94ea207b45fef3a)()([
    "autoFocus",
    "closeOnEscape",
    "closeOnInteractOutside",
    "dir",
    "getRootNode",
    "id",
    "ids",
    "initialFocusEl",
    "modal",
    "onEscapeKeyDown",
    "onFocusOutside",
    "onInteractOutside",
    "onOpenChange",
    "onPointerDownOutside",
    "open.controlled",
    "open",
    "persistentElements",
    "portalled",
    "positioning"
]);
var $f552bad70b683f14$export$45029c61b0073d87 = (0, $89352e0ddd72597a$export$3ea53b214fbc1986)($f552bad70b683f14$export$8128bb6492cf3de7);






// src/index.ts
var $be5af54bb9a1f1cc$var$rafId;
var $be5af54bb9a1f1cc$var$observedElements = /* @__PURE__ */ new Map();
var $be5af54bb9a1f1cc$var$getRectFn = (el)=>el.getBoundingClientRect();
function $be5af54bb9a1f1cc$export$160589ea9871c2b4(el, options) {
    const { scope: scope = "rect", getRect: getRect = $be5af54bb9a1f1cc$var$getRectFn, onChange: onChange } = options;
    const loop = $be5af54bb9a1f1cc$var$getLoopFn({
        scope: scope,
        getRect: getRect
    });
    const data = $be5af54bb9a1f1cc$var$observedElements.get(el);
    if (!data) {
        $be5af54bb9a1f1cc$var$observedElements.set(el, {
            rect: {},
            callbacks: [
                onChange
            ]
        });
        if ($be5af54bb9a1f1cc$var$observedElements.size === 1) $be5af54bb9a1f1cc$var$rafId = requestAnimationFrame(loop);
    } else {
        data.callbacks.push(onChange);
        onChange(getRect(el));
    }
    return function unobserve() {
        const data2 = $be5af54bb9a1f1cc$var$observedElements.get(el);
        if (!data2) return;
        const index = data2.callbacks.indexOf(onChange);
        if (index > -1) data2.callbacks.splice(index, 1);
        if (data2.callbacks.length === 0) {
            $be5af54bb9a1f1cc$var$observedElements.delete(el);
            if ($be5af54bb9a1f1cc$var$observedElements.size === 0) cancelAnimationFrame($be5af54bb9a1f1cc$var$rafId);
        }
    };
}
function $be5af54bb9a1f1cc$var$getLoopFn(options) {
    const { scope: scope, getRect: getRect } = options;
    const isEqual = $be5af54bb9a1f1cc$var$getEqualityFn(scope);
    return function loop() {
        const changedRectsData = [];
        $be5af54bb9a1f1cc$var$observedElements.forEach((data, element)=>{
            const newRect = getRect(element);
            if (!isEqual(data.rect, newRect)) {
                data.rect = newRect;
                changedRectsData.push(data);
            }
        });
        changedRectsData.forEach((data)=>{
            data.callbacks.forEach((callback)=>callback(data.rect));
        });
        $be5af54bb9a1f1cc$var$rafId = requestAnimationFrame(loop);
    };
}
var $be5af54bb9a1f1cc$var$isEqualSize = (a, b)=>a.width === b.width && a.height === b.height;
var $be5af54bb9a1f1cc$var$isEqualPosition = (a, b)=>a.top === b.top && a.left === b.left;
var $be5af54bb9a1f1cc$var$isEqualRect = (a, b)=>$be5af54bb9a1f1cc$var$isEqualSize(a, b) && $be5af54bb9a1f1cc$var$isEqualPosition(a, b);
function $be5af54bb9a1f1cc$var$getEqualityFn(scope) {
    if (scope === "size") return $be5af54bb9a1f1cc$var$isEqualSize;
    if (scope === "position") return $be5af54bb9a1f1cc$var$isEqualPosition;
    return $be5af54bb9a1f1cc$var$isEqualRect;
}




// src/radio-group.anatomy.ts
var $51157ee96867283b$export$477202748c7242bf = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("radio-group").parts("root", "label", "item", "itemText", "itemControl", "indicator");
var $51157ee96867283b$var$parts = $51157ee96867283b$export$477202748c7242bf.build();
var $51157ee96867283b$var$dom = (0, $b06ec5ff205338e5$export$41a9651decfe2bde)({
    getRootId: (ctx)=>ctx.ids?.root ?? `radio-group:${ctx.id}`,
    getLabelId: (ctx)=>ctx.ids?.label ?? `radio-group:${ctx.id}:label`,
    getItemId: (ctx, value)=>ctx.ids?.item?.(value) ?? `radio-group:${ctx.id}:radio:${value}`,
    getItemHiddenInputId: (ctx, value)=>ctx.ids?.itemHiddenInput?.(value) ?? `radio-group:${ctx.id}:radio:input:${value}`,
    getItemControlId: (ctx, value)=>ctx.ids?.itemControl?.(value) ?? `radio-group:${ctx.id}:radio:control:${value}`,
    getItemLabelId: (ctx, value)=>ctx.ids?.itemLabel?.(value) ?? `radio-group:${ctx.id}:radio:label:${value}`,
    getIndicatorId: (ctx)=>ctx.ids?.indicator ?? `radio-group:${ctx.id}:indicator`,
    getRootEl: (ctx)=>$51157ee96867283b$var$dom.getById(ctx, $51157ee96867283b$var$dom.getRootId(ctx)),
    getItemHiddenInputEl: (ctx, value)=>$51157ee96867283b$var$dom.getById(ctx, $51157ee96867283b$var$dom.getItemHiddenInputId(ctx, value)),
    getIndicatorEl: (ctx)=>$51157ee96867283b$var$dom.getById(ctx, $51157ee96867283b$var$dom.getIndicatorId(ctx)),
    getFirstEnabledInputEl: (ctx)=>$51157ee96867283b$var$dom.getRootEl(ctx)?.querySelector("input:not(:disabled)"),
    getFirstEnabledAndCheckedInputEl: (ctx)=>$51157ee96867283b$var$dom.getRootEl(ctx)?.querySelector("input:not(:disabled):checked"),
    getInputEls: (ctx)=>{
        const ownerId = CSS.escape($51157ee96867283b$var$dom.getRootId(ctx));
        const selector = `input[type=radio][data-ownedby='${ownerId}']:not([disabled])`;
        return (0, $b06ec5ff205338e5$export$dcd0d083aa86c355)($51157ee96867283b$var$dom.getRootEl(ctx), selector);
    },
    getActiveRadioEl: (ctx)=>{
        if (!ctx.value) return;
        return $51157ee96867283b$var$dom.getById(ctx, $51157ee96867283b$var$dom.getItemId(ctx, ctx.value));
    },
    getOffsetRect: (el)=>({
            left: el?.offsetLeft ?? 0,
            top: el?.offsetTop ?? 0,
            width: el?.offsetWidth ?? 0,
            height: el?.offsetHeight ?? 0
        }),
    getRectById: (ctx, id)=>{
        const radioEl = $51157ee96867283b$var$dom.getById(ctx, $51157ee96867283b$var$dom.getItemId(ctx, id));
        if (!radioEl) return;
        return $51157ee96867283b$var$dom.resolveRect($51157ee96867283b$var$dom.getOffsetRect(radioEl));
    },
    resolveRect: (rect)=>({
            width: `${rect.width}px`,
            height: `${rect.height}px`,
            left: `${rect.left}px`,
            top: `${rect.top}px`
        })
});
// src/radio-group.connect.ts
function $51157ee96867283b$export$64605811ab45167f(state, send, normalize) {
    const groupDisabled = state.context.isDisabled;
    const readOnly = state.context.readOnly;
    function getItemState(props2) {
        return {
            invalid: !!props2.invalid,
            disabled: !!props2.disabled || groupDisabled,
            checked: state.context.value === props2.value,
            focused: state.context.focusedValue === props2.value,
            hovered: state.context.hoveredValue === props2.value,
            active: state.context.activeValue === props2.value
        };
    }
    function getItemDataAttrs(props2) {
        const radioState = getItemState(props2);
        return {
            "data-focus": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(radioState.focused),
            "data-focus-visible": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(radioState.focused && state.context.focusVisible),
            "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(radioState.disabled),
            "data-readonly": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(readOnly),
            "data-state": radioState.checked ? "checked" : "unchecked",
            "data-hover": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(radioState.hovered),
            "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(radioState.invalid),
            "data-orientation": state.context.orientation,
            "data-ssr": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.ssr)
        };
    }
    const focus = ()=>{
        const firstEnabledAndCheckedInput = $51157ee96867283b$var$dom.getFirstEnabledAndCheckedInputEl(state.context);
        if (firstEnabledAndCheckedInput) {
            firstEnabledAndCheckedInput.focus();
            return;
        }
        const firstEnabledInput = $51157ee96867283b$var$dom.getFirstEnabledInputEl(state.context);
        firstEnabledInput?.focus();
    };
    return {
        focus: focus,
        value: state.context.value,
        setValue (value) {
            send({
                type: "SET_VALUE",
                value: value,
                isTrusted: false
            });
        },
        clearValue () {
            send({
                type: "SET_VALUE",
                value: null,
                isTrusted: false
            });
        },
        getRootProps () {
            return normalize.element({
                ...$51157ee96867283b$var$parts.root.attrs,
                role: "radiogroup",
                id: $51157ee96867283b$var$dom.getRootId(state.context),
                "aria-labelledby": $51157ee96867283b$var$dom.getLabelId(state.context),
                "data-orientation": state.context.orientation,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(groupDisabled),
                "aria-orientation": state.context.orientation,
                dir: state.context.dir,
                style: {
                    position: "relative"
                }
            });
        },
        getLabelProps () {
            return normalize.element({
                ...$51157ee96867283b$var$parts.label.attrs,
                dir: state.context.dir,
                "data-orientation": state.context.orientation,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(groupDisabled),
                id: $51157ee96867283b$var$dom.getLabelId(state.context),
                onClick: focus
            });
        },
        getItemState: getItemState,
        getItemProps (props2) {
            const itemState = getItemState(props2);
            return normalize.label({
                ...$51157ee96867283b$var$parts.item.attrs,
                dir: state.context.dir,
                id: $51157ee96867283b$var$dom.getItemId(state.context, props2.value),
                htmlFor: $51157ee96867283b$var$dom.getItemHiddenInputId(state.context, props2.value),
                ...getItemDataAttrs(props2),
                onPointerMove () {
                    if (itemState.disabled) return;
                    if (itemState.hovered) return;
                    send({
                        type: "SET_HOVERED",
                        value: props2.value,
                        hovered: true
                    });
                },
                onPointerLeave () {
                    if (itemState.disabled) return;
                    send({
                        type: "SET_HOVERED",
                        value: null
                    });
                },
                onPointerDown (event) {
                    if (itemState.disabled) return;
                    if (itemState.focused && event.pointerType === "mouse") event.preventDefault();
                    send({
                        type: "SET_ACTIVE",
                        value: props2.value,
                        active: true
                    });
                },
                onPointerUp () {
                    if (itemState.disabled) return;
                    send({
                        type: "SET_ACTIVE",
                        value: null
                    });
                }
            });
        },
        getItemTextProps (props2) {
            return normalize.element({
                ...$51157ee96867283b$var$parts.itemText.attrs,
                dir: state.context.dir,
                id: $51157ee96867283b$var$dom.getItemLabelId(state.context, props2.value),
                ...getItemDataAttrs(props2)
            });
        },
        getItemControlProps (props2) {
            const controlState = getItemState(props2);
            return normalize.element({
                ...$51157ee96867283b$var$parts.itemControl.attrs,
                dir: state.context.dir,
                id: $51157ee96867283b$var$dom.getItemControlId(state.context, props2.value),
                "data-active": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(controlState.active),
                "aria-hidden": true,
                ...getItemDataAttrs(props2)
            });
        },
        getItemHiddenInputProps (props2) {
            const inputState = getItemState(props2);
            return normalize.input({
                "data-ownedby": $51157ee96867283b$var$dom.getRootId(state.context),
                id: $51157ee96867283b$var$dom.getItemHiddenInputId(state.context, props2.value),
                type: "radio",
                name: state.context.name || state.context.id,
                form: state.context.form,
                value: props2.value,
                onClick (event) {
                    if (readOnly) {
                        event.preventDefault();
                        return;
                    }
                    if (event.currentTarget.checked) send({
                        type: "SET_VALUE",
                        value: props2.value,
                        isTrusted: true
                    });
                },
                onBlur () {
                    send({
                        type: "SET_FOCUSED",
                        value: null,
                        focused: false,
                        focusVisible: false
                    });
                },
                onFocus () {
                    const focusVisible = (0, $10f5b85675c7b32e$export$b9b3dfddab17db27)();
                    send({
                        type: "SET_FOCUSED",
                        value: props2.value,
                        focused: true,
                        focusVisible: focusVisible
                    });
                },
                onKeyDown (event) {
                    if (event.defaultPrevented) return;
                    if (event.key === " ") send({
                        type: "SET_ACTIVE",
                        value: props2.value,
                        active: true
                    });
                },
                onKeyUp (event) {
                    if (event.defaultPrevented) return;
                    if (event.key === " ") send({
                        type: "SET_ACTIVE",
                        value: null
                    });
                },
                disabled: inputState.disabled,
                defaultChecked: inputState.checked,
                style: (0, $b06ec5ff205338e5$export$8fecac46448b5689)
            });
        },
        getIndicatorProps () {
            return normalize.element({
                id: $51157ee96867283b$var$dom.getIndicatorId(state.context),
                ...$51157ee96867283b$var$parts.indicator.attrs,
                dir: state.context.dir,
                hidden: state.context.value == null,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(groupDisabled),
                "data-orientation": state.context.orientation,
                style: {
                    "--transition-property": "left, top, width, height",
                    "--left": state.context.indicatorRect?.left,
                    "--top": state.context.indicatorRect?.top,
                    "--width": state.context.indicatorRect?.width,
                    "--height": state.context.indicatorRect?.height,
                    position: "absolute",
                    willChange: "var(--transition-property)",
                    transitionProperty: "var(--transition-property)",
                    transitionDuration: state.context.canIndicatorTransition ? "var(--transition-duration, 150ms)" : "0ms",
                    transitionTimingFunction: "var(--transition-timing-function)",
                    [state.context.orientation === "horizontal" ? "left" : "top"]: state.context.orientation === "horizontal" ? "var(--left)" : "var(--top)"
                }
            });
        }
    };
}
var { not: $51157ee96867283b$var$not } = (0, $5c0da97e9c7aa95f$export$f3249297f3edf7e9);
function $51157ee96867283b$export$ea56d40cd27c3480(userContext) {
    const ctx = (0, $89352e0ddd72597a$export$8e16b83750b44988)(userContext);
    return (0, $5c0da97e9c7aa95f$export$aaa7fa18f8e9b2e8)({
        id: "radio",
        initial: "idle",
        context: {
            value: null,
            activeValue: null,
            focusedValue: null,
            hoveredValue: null,
            disabled: false,
            orientation: "vertical",
            ...ctx,
            indicatorRect: {},
            canIndicatorTransition: false,
            fieldsetDisabled: false,
            focusVisible: false,
            ssr: true
        },
        computed: {
            isDisabled: (ctx2)=>!!ctx2.disabled || ctx2.fieldsetDisabled
        },
        entry: [
            "syncIndicatorRect",
            "syncSsr"
        ],
        exit: [
            "cleanupObserver"
        ],
        activities: [
            "trackFormControlState",
            "trackFocusVisible"
        ],
        watch: {
            value: [
                "setIndicatorTransition",
                "syncIndicatorRect",
                "syncInputElements"
            ]
        },
        on: {
            SET_VALUE: [
                {
                    guard: $51157ee96867283b$var$not("isTrusted"),
                    actions: [
                        "setValue",
                        "dispatchChangeEvent"
                    ]
                },
                {
                    actions: [
                        "setValue"
                    ]
                }
            ],
            SET_HOVERED: {
                actions: "setHovered"
            },
            SET_ACTIVE: {
                actions: "setActive"
            },
            SET_FOCUSED: {
                actions: "setFocused"
            }
        },
        states: {
            idle: {}
        }
    }, {
        guards: {
            isTrusted: (_ctx, evt)=>!!evt.isTrusted
        },
        activities: {
            trackFormControlState (ctx2, _evt, { send: send, initialContext: initialContext }) {
                return (0, $b06ec5ff205338e5$export$a48469c7b6beba26)($51157ee96867283b$var$dom.getRootEl(ctx2), {
                    onFieldsetDisabledChange (disabled) {
                        ctx2.fieldsetDisabled = disabled;
                    },
                    onFormReset () {
                        send({
                            type: "SET_VALUE",
                            value: initialContext.value
                        });
                    }
                });
            },
            trackFocusVisible (ctx2) {
                return (0, $10f5b85675c7b32e$export$920b4983565c6f4d)({
                    root: $51157ee96867283b$var$dom.getRootNode(ctx2)
                });
            }
        },
        actions: {
            setValue (ctx2, evt) {
                $51157ee96867283b$var$set.value(ctx2, evt.value);
            },
            setHovered (ctx2, evt) {
                ctx2.hoveredValue = evt.value;
            },
            setActive (ctx2, evt) {
                ctx2.activeValue = evt.value;
            },
            setFocused (ctx2, evt) {
                ctx2.focusedValue = evt.value;
                ctx2.focusVisible = evt.focusVisible;
            },
            syncInputElements (ctx2) {
                const inputs = $51157ee96867283b$var$dom.getInputEls(ctx2);
                inputs.forEach((input)=>{
                    input.checked = input.value === ctx2.value;
                });
            },
            setIndicatorTransition (ctx2) {
                ctx2.canIndicatorTransition = (0, $89352e0ddd72597a$export$844ec244b1367d54)(ctx2.value);
            },
            cleanupObserver (ctx2) {
                ctx2.indicatorCleanup?.();
            },
            syncSsr (ctx2) {
                ctx2.ssr = false;
            },
            syncIndicatorRect (ctx2) {
                ctx2.indicatorCleanup?.();
                if (!$51157ee96867283b$var$dom.getIndicatorEl(ctx2)) return;
                const value = ctx2.value;
                const radioEl = $51157ee96867283b$var$dom.getActiveRadioEl(ctx2);
                if (value == null || !radioEl) {
                    ctx2.indicatorRect = {};
                    return;
                }
                ctx2.indicatorCleanup = (0, $be5af54bb9a1f1cc$export$160589ea9871c2b4)(radioEl, {
                    getRect (el) {
                        return $51157ee96867283b$var$dom.getOffsetRect(el);
                    },
                    onChange (rect) {
                        ctx2.indicatorRect = $51157ee96867283b$var$dom.resolveRect(rect);
                        (0, $b06ec5ff205338e5$export$bdd553fddd433dcb)(()=>{
                            ctx2.canIndicatorTransition = false;
                        });
                    }
                });
            },
            dispatchChangeEvent (ctx2) {
                const inputEls = $51157ee96867283b$var$dom.getInputEls(ctx2);
                inputEls.forEach((inputEl)=>{
                    const checked = inputEl.value === ctx2.value;
                    if (checked === inputEl.checked) return;
                    (0, $b06ec5ff205338e5$export$ebab7723673c874f)(inputEl, {
                        checked: checked
                    });
                });
            }
        }
    });
}
var $51157ee96867283b$var$invoke = {
    change: (ctx)=>{
        if (ctx.value == null) return;
        ctx.onValueChange?.({
            value: ctx.value
        });
    }
};
var $51157ee96867283b$var$set = {
    value: (ctx, value)=>{
        if ((0, $89352e0ddd72597a$export$248d38f6296296c5)(ctx.value, value)) return;
        ctx.value = value;
        $51157ee96867283b$var$invoke.change(ctx);
    }
};
var $51157ee96867283b$export$8128bb6492cf3de7 = (0, $5b359805fda5a40e$export$c94ea207b45fef3a)()([
    "dir",
    "disabled",
    "form",
    "getRootNode",
    "id",
    "ids",
    "name",
    "onValueChange",
    "orientation",
    "readOnly",
    "value"
]);
var $51157ee96867283b$export$45029c61b0073d87 = (0, $89352e0ddd72597a$export$3ea53b214fbc1986)($51157ee96867283b$export$8128bb6492cf3de7);
var $51157ee96867283b$export$b67876e05d194bf9 = (0, $5b359805fda5a40e$export$c94ea207b45fef3a)()([
    "value",
    "disabled",
    "invalid"
]);
var $51157ee96867283b$export$ae9d1ad549773548 = (0, $89352e0ddd72597a$export$3ea53b214fbc1986)($51157ee96867283b$export$b67876e05d194bf9);







// src/rating-group.anatomy.ts
var $bd0d6b40b15e1618$export$477202748c7242bf = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("rating-group").parts("root", "label", "item", "control");
var $bd0d6b40b15e1618$var$parts = $bd0d6b40b15e1618$export$477202748c7242bf.build();
var $bd0d6b40b15e1618$var$dom = (0, $b06ec5ff205338e5$export$41a9651decfe2bde)({
    getRootId: (ctx)=>ctx.ids?.root ?? `rating:${ctx.id}`,
    getLabelId: (ctx)=>ctx.ids?.label ?? `rating:${ctx.id}:label`,
    getHiddenInputId: (ctx)=>ctx.ids?.hiddenInput ?? `rating:${ctx.id}:input`,
    getControlId: (ctx)=>ctx.ids?.control ?? `rating:${ctx.id}:control`,
    getItemId: (ctx, id)=>ctx.ids?.item?.(id) ?? `rating:${ctx.id}:item:${id}`,
    getRootEl: (ctx)=>$bd0d6b40b15e1618$var$dom.getById(ctx, $bd0d6b40b15e1618$var$dom.getRootId(ctx)),
    getControlEl: (ctx)=>$bd0d6b40b15e1618$var$dom.getById(ctx, $bd0d6b40b15e1618$var$dom.getControlId(ctx)),
    getRadioEl: (ctx, value = ctx.value)=>{
        const selector = `[role=radio][aria-posinset='${Math.ceil(value)}']`;
        return (0, $b06ec5ff205338e5$export$2fa187e846a241c4)($bd0d6b40b15e1618$var$dom.getControlEl(ctx), selector);
    },
    getHiddenInputEl: (ctx)=>$bd0d6b40b15e1618$var$dom.getById(ctx, $bd0d6b40b15e1618$var$dom.getHiddenInputId(ctx)),
    dispatchChangeEvent: (ctx)=>{
        const inputEl = $bd0d6b40b15e1618$var$dom.getHiddenInputEl(ctx);
        if (!inputEl) return;
        (0, $b06ec5ff205338e5$export$71608d92f9cda884)(inputEl, {
            value: ctx.value
        });
    }
});
// src/rating-group.connect.ts
function $bd0d6b40b15e1618$export$64605811ab45167f(state, send, normalize) {
    const interactive = state.context.isInteractive;
    const disabled = state.context.isDisabled;
    const readOnly = state.context.readOnly;
    const value = state.context.value;
    const hoveredValue = state.context.hoveredValue;
    const translations = state.context.translations;
    function getItemState(props2) {
        const value2 = state.context.isHovering ? state.context.hoveredValue : state.context.value;
        const equal = Math.ceil(value2) === props2.index;
        const highlighted = props2.index <= value2 || equal;
        const half = equal && Math.abs(value2 - props2.index) === 0.5;
        return {
            highlighted: highlighted,
            half: half,
            checked: equal || state.context.value === -1 && props2.index === 1
        };
    }
    return {
        hovering: state.context.isHovering,
        value: value,
        hoveredValue: hoveredValue,
        count: state.context.count,
        items: Array.from({
            length: state.context.count
        }).map((_, index)=>index + 1),
        setValue (value2) {
            send({
                type: "SET_VALUE",
                value: value2
            });
        },
        clearValue () {
            send("CLEAR_VALUE");
        },
        getRootProps () {
            return normalize.element({
                ...$bd0d6b40b15e1618$var$parts.root.attrs,
                dir: state.context.dir,
                id: $bd0d6b40b15e1618$var$dom.getRootId(state.context)
            });
        },
        getHiddenInputProps () {
            return normalize.input({
                name: state.context.name,
                form: state.context.form,
                type: "text",
                hidden: true,
                disabled: disabled,
                readOnly: readOnly,
                required: state.context.required,
                id: $bd0d6b40b15e1618$var$dom.getHiddenInputId(state.context),
                defaultValue: state.context.value
            });
        },
        getLabelProps () {
            return normalize.label({
                ...$bd0d6b40b15e1618$var$parts.label.attrs,
                dir: state.context.dir,
                id: $bd0d6b40b15e1618$var$dom.getLabelId(state.context),
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                htmlFor: $bd0d6b40b15e1618$var$dom.getHiddenInputId(state.context),
                onClick (event) {
                    if (event.defaultPrevented) return;
                    if (!interactive) return;
                    event.preventDefault();
                    const radioEl = $bd0d6b40b15e1618$var$dom.getRadioEl(state.context, 1);
                    radioEl?.focus({
                        preventScroll: true
                    });
                }
            });
        },
        getControlProps () {
            return normalize.element({
                id: $bd0d6b40b15e1618$var$dom.getControlId(state.context),
                ...$bd0d6b40b15e1618$var$parts.control.attrs,
                dir: state.context.dir,
                role: "radiogroup",
                "aria-orientation": "horizontal",
                "aria-labelledby": $bd0d6b40b15e1618$var$dom.getLabelId(state.context),
                "aria-readonly": (0, $b06ec5ff205338e5$export$91a6105db3d4be7b)(readOnly),
                "data-readonly": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(readOnly),
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                onPointerMove (event) {
                    if (!interactive) return;
                    if (event.pointerType === "touch") return;
                    send("GROUP_POINTER_OVER");
                },
                onPointerLeave (event) {
                    if (!interactive) return;
                    if (event.pointerType === "touch") return;
                    send("GROUP_POINTER_LEAVE");
                }
            });
        },
        getItemState: getItemState,
        getItemProps (props2) {
            const { index: index } = props2;
            const itemState = getItemState(props2);
            const valueText = translations.ratingValueText(index);
            return normalize.element({
                ...$bd0d6b40b15e1618$var$parts.item.attrs,
                dir: state.context.dir,
                id: $bd0d6b40b15e1618$var$dom.getItemId(state.context, index.toString()),
                role: "radio",
                tabIndex: (()=>{
                    if (readOnly) return itemState.checked ? 0 : void 0;
                    if (disabled) return void 0;
                    return itemState.checked ? 0 : -1;
                })(),
                "aria-roledescription": "rating",
                "aria-label": valueText,
                "aria-disabled": disabled,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-readonly": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(readOnly),
                "aria-setsize": state.context.count,
                "aria-checked": itemState.checked,
                "data-checked": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(itemState.checked),
                "aria-posinset": index,
                "data-highlighted": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(itemState.highlighted),
                "data-half": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(itemState.half),
                onPointerDown (event) {
                    if (!interactive) return;
                    if (!(0, $b06ec5ff205338e5$export$698c4f0ff5e11e52)(event)) return;
                    event.preventDefault();
                },
                onPointerMove (event) {
                    if (!interactive) return;
                    const point = (0, $b06ec5ff205338e5$export$a8637644cbd23a7b)(event);
                    const relativePoint = (0, $b06ec5ff205338e5$export$b5a2724f2c73e602)(point, event.currentTarget);
                    const percentX = relativePoint.getPercentValue({
                        orientation: "horizontal",
                        dir: state.context.dir
                    });
                    const isMidway = percentX < 0.5;
                    send({
                        type: "POINTER_OVER",
                        index: index,
                        isMidway: isMidway
                    });
                },
                onKeyDown (event) {
                    if (event.defaultPrevented) return;
                    if (!interactive) return;
                    const keyMap = {
                        ArrowLeft () {
                            send("ARROW_LEFT");
                        },
                        ArrowRight () {
                            send("ARROW_RIGHT");
                        },
                        ArrowUp () {
                            send("ARROW_LEFT");
                        },
                        ArrowDown () {
                            send("ARROW_RIGHT");
                        },
                        Space () {
                            send({
                                type: "SPACE",
                                value: index
                            });
                        },
                        Home () {
                            send("HOME");
                        },
                        End () {
                            send("END");
                        }
                    };
                    const key = (0, $b06ec5ff205338e5$export$f7a7490116b79d4d)(event, state.context);
                    const exec = keyMap[key];
                    if (exec) {
                        event.preventDefault();
                        exec(event);
                    }
                },
                onClick () {
                    if (!interactive) return;
                    send({
                        type: "CLICK",
                        value: index
                    });
                },
                onFocus () {
                    if (!interactive) return;
                    send("FOCUS");
                },
                onBlur () {
                    if (!interactive) return;
                    send("BLUR");
                }
            });
        }
    };
}
function $bd0d6b40b15e1618$export$ea56d40cd27c3480(userContext) {
    const ctx = (0, $89352e0ddd72597a$export$8e16b83750b44988)(userContext);
    return (0, $5c0da97e9c7aa95f$export$aaa7fa18f8e9b2e8)({
        id: "rating",
        initial: "idle",
        context: {
            name: "rating",
            count: 5,
            dir: "ltr",
            value: -1,
            readOnly: false,
            disabled: false,
            ...ctx,
            hoveredValue: -1,
            fieldsetDisabled: false,
            translations: {
                ratingValueText: (index)=>`${index} stars`,
                ...ctx.translations
            }
        },
        created: [
            "roundValueIfNeeded"
        ],
        watch: {
            allowHalf: [
                "roundValueIfNeeded"
            ]
        },
        computed: {
            isDisabled: (ctx2)=>!!ctx2.disabled || ctx2.fieldsetDisabled,
            isInteractive: (ctx2)=>!(ctx2.isDisabled || ctx2.readOnly),
            isHovering: (ctx2)=>ctx2.hoveredValue > -1
        },
        activities: [
            "trackFormControlState"
        ],
        on: {
            SET_VALUE: {
                actions: [
                    "setValue"
                ]
            },
            CLEAR_VALUE: {
                actions: [
                    "clearValue"
                ]
            }
        },
        states: {
            idle: {
                entry: "clearHoveredValue",
                on: {
                    GROUP_POINTER_OVER: "hover",
                    FOCUS: "focus",
                    CLICK: {
                        actions: [
                            "setValue",
                            "focusActiveRadio"
                        ]
                    }
                }
            },
            focus: {
                on: {
                    POINTER_OVER: {
                        actions: "setHoveredValue"
                    },
                    GROUP_POINTER_LEAVE: {
                        actions: "clearHoveredValue"
                    },
                    BLUR: "idle",
                    SPACE: {
                        guard: "isValueEmpty",
                        actions: [
                            "setValue"
                        ]
                    },
                    CLICK: {
                        actions: [
                            "setValue",
                            "focusActiveRadio"
                        ]
                    },
                    ARROW_LEFT: {
                        actions: [
                            "setPrevValue",
                            "focusActiveRadio"
                        ]
                    },
                    ARROW_RIGHT: {
                        actions: [
                            "setNextValue",
                            "focusActiveRadio"
                        ]
                    },
                    HOME: {
                        actions: [
                            "setValueToMin",
                            "focusActiveRadio"
                        ]
                    },
                    END: {
                        actions: [
                            "setValueToMax",
                            "focusActiveRadio"
                        ]
                    }
                }
            },
            hover: {
                on: {
                    POINTER_OVER: {
                        actions: "setHoveredValue"
                    },
                    GROUP_POINTER_LEAVE: [
                        {
                            guard: "isRadioFocused",
                            target: "focus",
                            actions: "clearHoveredValue"
                        },
                        {
                            target: "idle",
                            actions: "clearHoveredValue"
                        }
                    ],
                    CLICK: {
                        actions: [
                            "setValue",
                            "focusActiveRadio"
                        ]
                    }
                }
            }
        }
    }, {
        guards: {
            isInteractive: (ctx2)=>!(ctx2.disabled || ctx2.readOnly),
            isHoveredValueEmpty: (ctx2)=>ctx2.hoveredValue === -1,
            isValueEmpty: (ctx2)=>ctx2.value <= 0,
            isRadioFocused: (ctx2)=>!!$bd0d6b40b15e1618$var$dom.getControlEl(ctx2)?.contains($bd0d6b40b15e1618$var$dom.getActiveElement(ctx2))
        },
        activities: {
            trackFormControlState (ctx2, _evt, { initialContext: initialContext }) {
                return (0, $b06ec5ff205338e5$export$a48469c7b6beba26)($bd0d6b40b15e1618$var$dom.getHiddenInputEl(ctx2), {
                    onFieldsetDisabledChange (disabled) {
                        ctx2.fieldsetDisabled = disabled;
                    },
                    onFormReset () {
                        $bd0d6b40b15e1618$var$set.value(ctx2, initialContext.value);
                    }
                });
            }
        },
        actions: {
            clearHoveredValue (ctx2) {
                $bd0d6b40b15e1618$var$set.hoveredValue(ctx2, -1);
            },
            focusActiveRadio (ctx2) {
                (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>$bd0d6b40b15e1618$var$dom.getRadioEl(ctx2)?.focus());
            },
            setPrevValue (ctx2) {
                const factor = ctx2.allowHalf ? 0.5 : 1;
                $bd0d6b40b15e1618$var$set.value(ctx2, Math.max(0, ctx2.value - factor));
            },
            setNextValue (ctx2) {
                const factor = ctx2.allowHalf ? 0.5 : 1;
                const value = ctx2.value === -1 ? 0 : ctx2.value;
                $bd0d6b40b15e1618$var$set.value(ctx2, Math.min(ctx2.count, value + factor));
            },
            setValueToMin (ctx2) {
                $bd0d6b40b15e1618$var$set.value(ctx2, 1);
            },
            setValueToMax (ctx2) {
                $bd0d6b40b15e1618$var$set.value(ctx2, ctx2.count);
            },
            setValue (ctx2, evt) {
                const value = ctx2.hoveredValue === -1 ? evt.value : ctx2.hoveredValue;
                $bd0d6b40b15e1618$var$set.value(ctx2, value);
            },
            clearValue (ctx2) {
                $bd0d6b40b15e1618$var$set.value(ctx2, -1);
            },
            setHoveredValue (ctx2, evt) {
                const half = ctx2.allowHalf && evt.isMidway;
                const factor = half ? 0.5 : 0;
                $bd0d6b40b15e1618$var$set.hoveredValue(ctx2, evt.index - factor);
            },
            roundValueIfNeeded (ctx2) {
                if (ctx2.allowHalf) return;
                ctx2.value = Math.round(ctx2.value);
            }
        }
    });
}
var $bd0d6b40b15e1618$var$invoke = {
    change: (ctx)=>{
        ctx.onValueChange?.({
            value: ctx.value
        });
        $bd0d6b40b15e1618$var$dom.dispatchChangeEvent(ctx);
    },
    hoverChange: (ctx)=>{
        ctx.onHoverChange?.({
            hoveredValue: ctx.hoveredValue
        });
    }
};
var $bd0d6b40b15e1618$var$set = {
    value: (ctx, value)=>{
        if ((0, $89352e0ddd72597a$export$248d38f6296296c5)(ctx.value, value)) return;
        ctx.value = value;
        $bd0d6b40b15e1618$var$invoke.change(ctx);
    },
    hoveredValue: (ctx, value)=>{
        if ((0, $89352e0ddd72597a$export$248d38f6296296c5)(ctx.hoveredValue, value)) return;
        ctx.hoveredValue = value;
        $bd0d6b40b15e1618$var$invoke.hoverChange(ctx);
    }
};
var $bd0d6b40b15e1618$export$8128bb6492cf3de7 = (0, $5b359805fda5a40e$export$c94ea207b45fef3a)()([
    "allowHalf",
    "autoFocus",
    "count",
    "dir",
    "disabled",
    "form",
    "getRootNode",
    "id",
    "ids",
    "name",
    "onHoverChange",
    "onValueChange",
    "required",
    "readOnly",
    "translations",
    "value"
]);
var $bd0d6b40b15e1618$export$45029c61b0073d87 = (0, $89352e0ddd72597a$export$3ea53b214fbc1986)($bd0d6b40b15e1618$export$8128bb6492cf3de7);
var $bd0d6b40b15e1618$export$b67876e05d194bf9 = (0, $5b359805fda5a40e$export$c94ea207b45fef3a)()([
    "index"
]);
var $bd0d6b40b15e1618$export$ae9d1ad549773548 = (0, $89352e0ddd72597a$export$3ea53b214fbc1986)($bd0d6b40b15e1618$export$b67876e05d194bf9);




var $20e7a777a34d98f3$var$__defProp = Object.defineProperty;
var $20e7a777a34d98f3$var$__defNormalProp = (obj, key, value)=>key in obj ? $20e7a777a34d98f3$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $20e7a777a34d98f3$var$__publicField = (obj, key, value)=>$20e7a777a34d98f3$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var $20e7a777a34d98f3$var$fallback = {
    itemToValue (item) {
        if (typeof item === "string") return item;
        if ((0, $89352e0ddd72597a$export$a6cdc56e425d0d0a)(item) && (0, $89352e0ddd72597a$export$dd642ef726dcde21)(item, "value")) return item.value;
        return "";
    },
    itemToString (item) {
        if (typeof item === "string") return item;
        if ((0, $89352e0ddd72597a$export$a6cdc56e425d0d0a)(item) && (0, $89352e0ddd72597a$export$dd642ef726dcde21)(item, "label")) return item.label;
        return $20e7a777a34d98f3$var$fallback.itemToValue(item);
    },
    isItemDisabled (item) {
        if ((0, $89352e0ddd72597a$export$a6cdc56e425d0d0a)(item) && (0, $89352e0ddd72597a$export$dd642ef726dcde21)(item, "disabled")) return !!item.disabled;
        return false;
    }
};
var $20e7a777a34d98f3$export$d085fb9e920b5ca7 = class {
    constructor(options){
        this.options = options;
        /**
     * The items in the collection
     */ $20e7a777a34d98f3$var$__publicField(this, "items");
        this.items = [
            ...options.items
        ];
    }
    isEqual(other) {
        return (0, $89352e0ddd72597a$export$248d38f6296296c5)(this.items, other.items);
    }
    /**
   * Function to update the collection items
   */ setItems(items) {
        this.items = Array.from(items);
    }
    /**
   * Returns all the values in the collection
   */ getValues(items = this.items) {
        return Array.from(items).map((item)=>this.getItemValue(item)).filter(Boolean);
    }
    /**
   * Get the item based on its value
   */ find(value) {
        if (value == null) return null;
        const index = this.items.findIndex((item)=>this.getItemValue(item) === value);
        return index != null ? this.items[index] : null;
    }
    /**
   * Get the items based on its values
   */ findMany(values) {
        return Array.from(values).map((value)=>this.find(value)).filter(Boolean);
    }
    /**
   * Get the item based on its index
   */ at(index) {
        return this.items[index] ?? null;
    }
    sortFn(valueA, valueB) {
        const indexA = this.indexOf(valueA);
        const indexB = this.indexOf(valueB);
        return (indexA ?? 0) - (indexB ?? 0);
    }
    /**
   * Sort the values based on their index
   */ sort(values) {
        return [
            ...values
        ].sort(this.sortFn.bind(this));
    }
    /**
   * Convert an item to a value
   */ getItemValue(item) {
        if (item == null) return null;
        return this.options.itemToValue?.(item) ?? $20e7a777a34d98f3$var$fallback.itemToValue(item);
    }
    /**
   * Whether an item is disabled
   */ getItemDisabled(item) {
        if (item == null) return false;
        return this.options.isItemDisabled?.(item) ?? $20e7a777a34d98f3$var$fallback.isItemDisabled(item);
    }
    /**
   * Convert an item to a string
   */ stringifyItem(item) {
        if (item == null) return null;
        return this.options.itemToString?.(item) ?? $20e7a777a34d98f3$var$fallback.itemToString(item);
    }
    /**
   * Convert a value to a string
   */ stringify(value) {
        if (value == null) return null;
        return this.stringifyItem(this.find(value));
    }
    /**
   * Convert an array of items to a string
   */ stringifyItems(items, separator = ", ") {
        return Array.from(items).map((item)=>this.stringifyItem(item)).filter(Boolean).join(separator);
    }
    /**
   * Convert an array of items to a string
   */ stringifyMany(value, separator) {
        return this.stringifyItems(this.findMany(value), separator);
    }
    /**
   * Whether the collection has a value
   */ has(value) {
        return this.indexOf(value) !== -1;
    }
    /**
   * Whether the collection has an item
   */ hasItem(item) {
        if (item == null) return false;
        return this.has(this.getItemValue(item));
    }
    /**
   * Returns the number of items in the collection
   */ get size() {
        return this.items.length;
    }
    /**
   * Returns the first value in the collection
   */ get firstValue() {
        let index = 0;
        while(this.getItemDisabled(this.at(index)))index++;
        return this.getItemValue(this.at(index));
    }
    /**
   * Returns the last value in the collection
   */ get lastValue() {
        let index = this.size - 1;
        while(this.getItemDisabled(this.at(index)))index--;
        return this.getItemValue(this.at(index));
    }
    /**
   * Returns the next value in the collection
   */ getNextValue(value, step = 1, clamp = false) {
        let index = this.indexOf(value);
        if (index === -1) return null;
        index = clamp ? Math.min(index + step, this.size - 1) : index + step;
        while(index <= this.size && this.getItemDisabled(this.at(index)))index++;
        return this.getItemValue(this.at(index));
    }
    /**
   * Returns the previous value in the collection
   */ getPreviousValue(value, step = 1, clamp = false) {
        let index = this.indexOf(value);
        if (index === -1) return null;
        index = clamp ? Math.max(index - step, 0) : index - step;
        while(index >= 0 && this.getItemDisabled(this.at(index)))index--;
        return this.getItemValue(this.at(index));
    }
    /**
   * Get the index of an item based on its key
   */ indexOf(value) {
        if (value == null) return -1;
        return this.items.findIndex((item)=>this.getItemValue(item) === value);
    }
    getByText(text, current) {
        let items = current != null ? $20e7a777a34d98f3$var$wrap(this.items, this.indexOf(current)) : this.items;
        const isSingleKey = text.length === 1;
        if (isSingleKey) items = items.filter((item)=>this.getItemValue(item) !== current);
        return items.find((item)=>$20e7a777a34d98f3$var$match(this.stringifyItem(item), text));
    }
    /**
   * Search for a value based on a query
   */ search(queryString, options) {
        const { state: state, currentValue: currentValue, timeout: timeout = 350 } = options;
        const search = state.keysSoFar + queryString;
        const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]);
        const query = isRepeated ? search[0] : search;
        const item = this.getByText(query, currentValue);
        const value = this.getItemValue(item);
        function cleanup() {
            clearTimeout(state.timer);
            state.timer = -1;
        }
        function update(value2) {
            state.keysSoFar = value2;
            cleanup();
            if (value2 !== "") state.timer = +setTimeout(()=>{
                update("");
                cleanup();
            }, timeout);
        }
        update(search);
        return value;
    }
    *[Symbol.iterator]() {
        yield* this.items;
    }
    insertBefore(value, item) {
        const index = this.indexOf(value);
        if (index === -1) return;
        this.items.splice(index, 0, item);
    }
    insertAfter(value, item) {
        const index = this.indexOf(value);
        if (index === -1) return;
        this.items.splice(index + 1, 0, item);
    }
    reorder(fromIndex, toIndex) {
        if (fromIndex === -1 || toIndex === -1) return;
        if (fromIndex === toIndex) return;
        const [removed] = this.items.splice(fromIndex, 1);
        this.items.splice(toIndex, 0, removed);
    }
    json() {
        return {
            size: this.size,
            first: this.firstValue,
            last: this.lastValue
        };
    }
};
var $20e7a777a34d98f3$var$match = (label, query)=>{
    return !!label?.toLowerCase().startsWith(query.toLowerCase());
};
var $20e7a777a34d98f3$var$wrap = (v, idx)=>{
    return v.map((_, index)=>v[(Math.max(idx, 0) + index) % v.length]);
};
// src/grid-collection.ts
var $20e7a777a34d98f3$export$de3fdf6493c353d = class extends $20e7a777a34d98f3$export$d085fb9e920b5ca7 {
    constructor(options){
        const { columnCount: columnCount } = options;
        super(options);
        $20e7a777a34d98f3$var$__publicField(this, "columnCount");
        this.columnCount = columnCount;
    }
    /**
   * Returns the row data in the grid
   */ getRows() {
        return (0, $89352e0ddd72597a$export$5f7ec48d69707ddd)([
            ...this.items
        ], this.columnCount);
    }
    /**
   * Returns the number of rows in the grid
   */ getRowCount() {
        return this.getRows().length;
    }
    /**
   * Returns the index of the specified row and column in the grid
   */ getCellIndex(row, column) {
        return row * this.columnCount + column;
    }
    /**
   * Returns the item at the specified row and column in the grid
   */ getCell(row, column) {
        return this.at(this.getCellIndex(row, column));
    }
    /**
   * Returns the value of the previous row in the grid, based on the current value
   */ getPreviousRowValue(value, clamp = false) {
        return this.getPreviousValue(value, this.columnCount, clamp);
    }
    /**
   * Returns the value of the next row in the grid, based on the current value
   */ getNextRowValue(value, clamp = false) {
        return this.getNextValue(value, this.columnCount, clamp);
    }
};
// src/tree-visit.ts
function $20e7a777a34d98f3$var$access(node, indexPath, options) {
    for(let i = 0; i < indexPath.length; i++)node = options.getChildren(node, indexPath.slice(i + 1))[indexPath[i]];
    return node;
}
function $20e7a777a34d98f3$var$ancestorIndexPaths(indexPaths) {
    const sortedPaths = $20e7a777a34d98f3$var$sortIndexPaths(indexPaths);
    const result = [];
    const seen = /* @__PURE__ */ new Set();
    for (const indexPath of sortedPaths){
        const key = indexPath.join();
        if (!seen.has(key)) {
            seen.add(key);
            result.push(indexPath);
        }
    }
    return result;
}
function $20e7a777a34d98f3$var$compareIndexPaths(a, b) {
    for(let i = 0; i < Math.min(a.length, b.length); i++){
        if (a[i] < b[i]) return -1;
        if (a[i] > b[i]) return 1;
    }
    return a.length - b.length;
}
function $20e7a777a34d98f3$var$sortIndexPaths(indexPaths) {
    return indexPaths.sort($20e7a777a34d98f3$var$compareIndexPaths);
}
function $20e7a777a34d98f3$var$find(node, options) {
    let found;
    $20e7a777a34d98f3$var$visit(node, {
        ...options,
        onEnter: (child, indexPath)=>{
            if (options.predicate(child, indexPath)) {
                found = child;
                return "stop";
            }
        }
    });
    return found;
}
function $20e7a777a34d98f3$var$findIndexPath(node, options) {
    let found;
    $20e7a777a34d98f3$var$visit(node, {
        onEnter: (child, indexPath)=>{
            if (options.predicate(child, indexPath)) {
                found = [
                    ...indexPath
                ];
                return "stop";
            }
        },
        getChildren: options.getChildren
    });
    return found;
}
function $20e7a777a34d98f3$var$reduce(node, options) {
    let result = options.initialResult;
    $20e7a777a34d98f3$var$visit(node, {
        ...options,
        onEnter: (child, indexPath)=>{
            result = options.nextResult(result, child, indexPath);
        }
    });
    return result;
}
function $20e7a777a34d98f3$var$flatMap(node, options) {
    return $20e7a777a34d98f3$var$reduce(node, {
        ...options,
        initialResult: [],
        nextResult: (result, child, indexPath)=>{
            result.push(...options.transform(child, indexPath));
            return result;
        }
    });
}
function $20e7a777a34d98f3$var$insertOperation(index, nodes) {
    return {
        type: "insert",
        index: index,
        nodes: nodes
    };
}
function $20e7a777a34d98f3$var$removeOperation(indexes) {
    return {
        type: "remove",
        indexes: indexes
    };
}
function $20e7a777a34d98f3$var$replaceOperation() {
    return {
        type: "replace"
    };
}
function $20e7a777a34d98f3$var$splitIndexPath(indexPath) {
    return [
        indexPath.slice(0, -1),
        indexPath[indexPath.length - 1]
    ];
}
function $20e7a777a34d98f3$var$getInsertionOperations(indexPath, nodes, operations = /* @__PURE__ */ new Map()) {
    const [parentIndexPath, index] = $20e7a777a34d98f3$var$splitIndexPath(indexPath);
    for(let i = parentIndexPath.length - 1; i >= 0; i--){
        const parentKey = parentIndexPath.slice(0, i).join();
        switch(operations.get(parentKey)?.type){
            case "remove":
                continue;
        }
        operations.set(parentKey, $20e7a777a34d98f3$var$replaceOperation());
    }
    const operation = operations.get(parentIndexPath.join());
    switch(operation?.type){
        case "remove":
            operations.set(parentIndexPath.join(), {
                type: "removeThenInsert",
                removeIndexes: operation.indexes,
                insertIndex: index,
                insertNodes: nodes
            });
            break;
        default:
            operations.set(parentIndexPath.join(), $20e7a777a34d98f3$var$insertOperation(index, nodes));
    }
    return operations;
}
function $20e7a777a34d98f3$var$getRemovalOperations(indexPaths) {
    const operations = /* @__PURE__ */ new Map();
    const indexesToRemove = /* @__PURE__ */ new Map();
    for (const indexPath of indexPaths){
        const parentKey = indexPath.slice(0, -1).join();
        const value = indexesToRemove.get(parentKey) ?? [];
        value.push(indexPath[indexPath.length - 1]);
        indexesToRemove.set(parentKey, value.sort((a, b)=>a - b));
    }
    for (const indexPath of indexPaths)for(let i = indexPath.length - 2; i >= 0; i--){
        const parentKey = indexPath.slice(0, i).join();
        if (!operations.has(parentKey)) operations.set(parentKey, $20e7a777a34d98f3$var$replaceOperation());
    }
    for (const [parentKey, indexes] of indexesToRemove)operations.set(parentKey, $20e7a777a34d98f3$var$removeOperation(indexes));
    return operations;
}
function $20e7a777a34d98f3$var$getReplaceOperations(indexPath, node) {
    const operations = /* @__PURE__ */ new Map();
    const [parentIndexPath, index] = $20e7a777a34d98f3$var$splitIndexPath(indexPath);
    for(let i = parentIndexPath.length - 1; i >= 0; i--){
        const parentKey = parentIndexPath.slice(0, i).join();
        operations.set(parentKey, $20e7a777a34d98f3$var$replaceOperation());
    }
    operations.set(parentIndexPath.join(), {
        type: "removeThenInsert",
        removeIndexes: [
            index
        ],
        insertIndex: index,
        insertNodes: [
            node
        ]
    });
    return operations;
}
function $20e7a777a34d98f3$var$mutate(node, operations, options) {
    return $20e7a777a34d98f3$var$map(node, {
        ...options,
        getChildren: (node2, indexPath)=>{
            const key = indexPath.join();
            const operation = operations.get(key);
            switch(operation?.type){
                case "replace":
                case "remove":
                case "removeThenInsert":
                case "insert":
                    return options.getChildren(node2, indexPath);
                default:
                    return [];
            }
        },
        transform: (node2, children, indexPath)=>{
            const key = indexPath.join();
            const operation = operations.get(key);
            switch(operation?.type){
                case "remove":
                    return options.create(node2, children.filter((_, index)=>!operation.indexes.includes(index)), indexPath);
                case "removeThenInsert":
                    const updatedChildren = children.filter((_, index)=>!operation.removeIndexes.includes(index));
                    const adjustedIndex = operation.removeIndexes.reduce((index, removedIndex)=>removedIndex < index ? index - 1 : index, operation.insertIndex);
                    return options.create(node2, $20e7a777a34d98f3$var$splice(updatedChildren, adjustedIndex, 0, ...operation.insertNodes), indexPath);
                case "insert":
                    return options.create(node2, $20e7a777a34d98f3$var$splice(children, operation.index, 0, ...operation.nodes), indexPath);
                case "replace":
                    return options.create(node2, children, indexPath);
                default:
                    return node2;
            }
        }
    });
}
function $20e7a777a34d98f3$var$splice(array, start, deleteCount, ...items) {
    return [
        ...array.slice(0, start),
        ...items,
        ...array.slice(start + deleteCount)
    ];
}
function $20e7a777a34d98f3$var$map(node, options) {
    const childrenMap = {};
    $20e7a777a34d98f3$var$visit(node, {
        ...options,
        onLeave: (child, indexPath)=>{
            const keyIndexPath = [
                0,
                ...indexPath
            ];
            const key = keyIndexPath.join();
            const transformed = options.transform(child, childrenMap[key] ?? [], indexPath);
            const parentKey = keyIndexPath.slice(0, -1).join();
            const parentChildren = childrenMap[parentKey] ?? [];
            parentChildren.push(transformed);
            childrenMap[parentKey] = parentChildren;
        }
    });
    return childrenMap[""][0];
}
function $20e7a777a34d98f3$var$insert(node, options) {
    const { nodes: nodes, at: at } = options;
    if (at.length === 0) throw new Error(`Can't insert nodes at the root`);
    const state = $20e7a777a34d98f3$var$getInsertionOperations(at, nodes);
    return $20e7a777a34d98f3$var$mutate(node, state, options);
}
function $20e7a777a34d98f3$var$replace(node, options) {
    if (options.at.length === 0) return options.node;
    const operations = $20e7a777a34d98f3$var$getReplaceOperations(options.at, options.node);
    return $20e7a777a34d98f3$var$mutate(node, operations, options);
}
function $20e7a777a34d98f3$var$remove(node, options) {
    if (options.indexPaths.length === 0) return node;
    for (const indexPath of options.indexPaths){
        if (indexPath.length === 0) throw new Error(`Can't remove the root node`);
    }
    const operations = $20e7a777a34d98f3$var$getRemovalOperations(options.indexPaths);
    return $20e7a777a34d98f3$var$mutate(node, operations, options);
}
function $20e7a777a34d98f3$var$move(node, options) {
    if (options.indexPaths.length === 0) return node;
    for (const indexPath of options.indexPaths){
        if (indexPath.length === 0) throw new Error(`Can't move the root node`);
    }
    if (options.to.length === 0) throw new Error(`Can't move nodes to the root`);
    const _ancestorIndexPaths = $20e7a777a34d98f3$var$ancestorIndexPaths(options.indexPaths);
    const nodesToInsert = _ancestorIndexPaths.map((indexPath)=>$20e7a777a34d98f3$var$access(node, indexPath, options));
    const operations = $20e7a777a34d98f3$var$getInsertionOperations(options.to, nodesToInsert, $20e7a777a34d98f3$var$getRemovalOperations(_ancestorIndexPaths));
    return $20e7a777a34d98f3$var$mutate(node, operations, options);
}
function $20e7a777a34d98f3$var$visit(node, options) {
    const { onEnter: onEnter, onLeave: onLeave, getChildren: getChildren } = options;
    let indexPath = [];
    let stack = [
        {
            node: node
        }
    ];
    const getIndexPath = options.reuseIndexPath ? ()=>indexPath : ()=>indexPath.slice();
    while(stack.length > 0){
        let wrapper = stack[stack.length - 1];
        if (wrapper.state === void 0) {
            const enterResult = onEnter?.(wrapper.node, getIndexPath());
            if (enterResult === "stop") return;
            wrapper.state = enterResult === "skip" ? -1 : 0;
        }
        const children = wrapper.children || getChildren(wrapper.node, getIndexPath());
        wrapper.children || (wrapper.children = children);
        if (wrapper.state !== -1) {
            if (wrapper.state < children.length) {
                let currentIndex = wrapper.state;
                indexPath.push(currentIndex);
                stack.push({
                    node: children[currentIndex]
                });
                wrapper.state = currentIndex + 1;
                continue;
            }
            const leaveResult = onLeave?.(wrapper.node, getIndexPath());
            if (leaveResult === "stop") return;
        }
        indexPath.pop();
        stack.pop();
    }
}
// src/tree-collection.ts
var $20e7a777a34d98f3$export$863faf230ee2118a = class {
    constructor(options){
        this.options = options;
        $20e7a777a34d98f3$var$__publicField(this, "rootNode");
        $20e7a777a34d98f3$var$__publicField(this, "isEqual", (other)=>{
            return (0, $89352e0ddd72597a$export$248d38f6296296c5)(this.rootNode, other.rootNode);
        });
        $20e7a777a34d98f3$var$__publicField(this, "getNodeChildren", (node)=>{
            return this.options.nodeToChildren?.(node) ?? $20e7a777a34d98f3$var$fallback2.nodeToChildren(node) ?? [];
        });
        $20e7a777a34d98f3$var$__publicField(this, "getNodeValue", (node)=>{
            return this.options.nodeToValue?.(node) ?? $20e7a777a34d98f3$var$fallback2.nodeToValue(node);
        });
        $20e7a777a34d98f3$var$__publicField(this, "getNodeDisabled", (node)=>{
            return this.options.isNodeDisabled?.(node) ?? $20e7a777a34d98f3$var$fallback2.isNodeDisabled(node);
        });
        $20e7a777a34d98f3$var$__publicField(this, "stringify", (value)=>{
            const node = this.findNode(value);
            if (!node) return null;
            return this.stringifyNode(node);
        });
        $20e7a777a34d98f3$var$__publicField(this, "stringifyNode", (node)=>{
            return this.options.nodeToString?.(node) ?? $20e7a777a34d98f3$var$fallback2.nodeToString(node);
        });
        $20e7a777a34d98f3$var$__publicField(this, "getFirstNode", (rootNode = this.rootNode)=>{
            let firstChild;
            $20e7a777a34d98f3$var$visit(rootNode, {
                getChildren: this.getNodeChildren,
                onEnter: (node, indexPath)=>{
                    if (!firstChild && indexPath.length > 0 && !this.getNodeDisabled(node)) {
                        firstChild = node;
                        return "stop";
                    }
                }
            });
            return firstChild;
        });
        $20e7a777a34d98f3$var$__publicField(this, "getLastNode", (rootNode = this.rootNode, opts = {})=>{
            let lastChild;
            $20e7a777a34d98f3$var$visit(rootNode, {
                getChildren: this.getNodeChildren,
                onEnter: (node, indexPath)=>{
                    const nodeValue = this.getNodeValue(node);
                    if (opts.skip?.({
                        value: nodeValue,
                        node: node,
                        indexPath: indexPath
                    })) return "skip";
                    if (indexPath.length > 1) return "skip";
                    if (!this.getNodeDisabled(node)) lastChild = node;
                }
            });
            return lastChild;
        });
        $20e7a777a34d98f3$var$__publicField(this, "at", (indexPath)=>{
            return $20e7a777a34d98f3$var$access(this.rootNode, indexPath, {
                getChildren: this.getNodeChildren
            });
        });
        $20e7a777a34d98f3$var$__publicField(this, "findNode", (value, rootNode = this.rootNode)=>{
            return $20e7a777a34d98f3$var$find(rootNode, {
                getChildren: this.getNodeChildren,
                predicate: (node)=>this.getNodeValue(node) === value
            });
        });
        $20e7a777a34d98f3$var$__publicField(this, "sort", (values)=>{
            return values.reduce((acc, value)=>{
                const indexPath = this.getIndexPath(value);
                if (indexPath != null) acc.push({
                    value: value,
                    indexPath: indexPath
                });
                return acc;
            }, []).sort((a, b)=>$20e7a777a34d98f3$var$compareIndexPaths(a.indexPath, b.indexPath)).map(({ value: value })=>value);
        });
        $20e7a777a34d98f3$var$__publicField(this, "getIndexPath", (value)=>{
            return $20e7a777a34d98f3$var$findIndexPath(this.rootNode, {
                getChildren: this.getNodeChildren,
                predicate: (node)=>this.getNodeValue(node) === value
            });
        });
        $20e7a777a34d98f3$var$__publicField(this, "getValue", (indexPath)=>{
            const node = this.at(indexPath);
            return node ? this.getNodeValue(node) : void 0;
        });
        $20e7a777a34d98f3$var$__publicField(this, "getValuePath", (indexPath)=>{
            if (!indexPath) return [];
            const valuePath = [];
            let currentPath = [
                ...indexPath
            ];
            while(currentPath.length > 0){
                const node = this.at(currentPath);
                if (node) valuePath.unshift(this.getNodeValue(node));
                currentPath.pop();
            }
            return valuePath;
        });
        $20e7a777a34d98f3$var$__publicField(this, "getDepth", (value)=>{
            const indexPath = $20e7a777a34d98f3$var$findIndexPath(this.rootNode, {
                getChildren: this.getNodeChildren,
                predicate: (node)=>this.getNodeValue(node) === value
            });
            return indexPath?.length ?? 0;
        });
        $20e7a777a34d98f3$var$__publicField(this, "isRootNode", (node)=>{
            return this.getNodeValue(node) === this.getNodeValue(this.rootNode);
        });
        $20e7a777a34d98f3$var$__publicField(this, "contains", (parentIndexPath, valueIndexPath)=>{
            if (!parentIndexPath || !valueIndexPath) return false;
            return valueIndexPath.slice(0, parentIndexPath.length).every((_, i)=>parentIndexPath[i] === valueIndexPath[i]);
        });
        $20e7a777a34d98f3$var$__publicField(this, "getNextNode", (value, opts = {})=>{
            let found = false;
            let nextNode;
            $20e7a777a34d98f3$var$visit(this.rootNode, {
                getChildren: this.getNodeChildren,
                onEnter: (node, indexPath)=>{
                    if (this.isRootNode(node)) return;
                    const nodeValue = this.getNodeValue(node);
                    if (opts.skip?.({
                        value: nodeValue,
                        node: node,
                        indexPath: indexPath
                    })) {
                        if (nodeValue === value) found = true;
                        return "skip";
                    }
                    if (found && !this.getNodeDisabled(node)) {
                        nextNode = node;
                        return "stop";
                    }
                    if (nodeValue === value) found = true;
                }
            });
            return nextNode;
        });
        $20e7a777a34d98f3$var$__publicField(this, "getPreviousNode", (value, opts = {})=>{
            let previousNode;
            let found = false;
            $20e7a777a34d98f3$var$visit(this.rootNode, {
                getChildren: this.getNodeChildren,
                onEnter: (node, indexPath)=>{
                    if (this.isRootNode(node)) return;
                    const nodeValue = this.getNodeValue(node);
                    if (opts.skip?.({
                        value: nodeValue,
                        node: node,
                        indexPath: indexPath
                    })) return "skip";
                    if (nodeValue === value) {
                        found = true;
                        return "stop";
                    }
                    if (!this.getNodeDisabled(node)) previousNode = node;
                }
            });
            return found ? previousNode : void 0;
        });
        $20e7a777a34d98f3$var$__publicField(this, "getParentNodes", (values)=>{
            const result = [];
            let indexPath = this.getIndexPath(values);
            while(indexPath && indexPath.length > 0){
                indexPath.pop();
                const parentNode = this.at(indexPath);
                if (parentNode && !this.isRootNode(parentNode)) result.unshift(parentNode);
            }
            return result;
        });
        $20e7a777a34d98f3$var$__publicField(this, "getParentIndexPath", (indexPath)=>{
            return indexPath.slice(0, -1);
        });
        $20e7a777a34d98f3$var$__publicField(this, "getParentNode", (valueOrIndexPath)=>{
            const indexPath = typeof valueOrIndexPath === "string" ? this.getIndexPath(valueOrIndexPath) : valueOrIndexPath;
            return indexPath ? this.at(this.getParentIndexPath(indexPath)) : void 0;
        });
        $20e7a777a34d98f3$var$__publicField(this, "visit", (opts)=>{
            const { skip: skip, ...rest } = opts;
            $20e7a777a34d98f3$var$visit(this.rootNode, {
                ...rest,
                getChildren: this.getNodeChildren,
                onEnter: (node, indexPath)=>{
                    if (this.isRootNode(node)) return;
                    if (skip?.({
                        value: this.getNodeValue(node),
                        node: node,
                        indexPath: indexPath
                    })) return "skip";
                    return rest.onEnter?.(node, indexPath);
                }
            });
        });
        $20e7a777a34d98f3$var$__publicField(this, "getPreviousSibling", (indexPath)=>{
            const parentNode = this.getParentNode(indexPath);
            if (!parentNode) return;
            const siblings = this.getNodeChildren(parentNode);
            let idx = siblings.findIndex((sibling)=>this.getValue(indexPath) === this.getNodeValue(sibling));
            while(--idx >= 0){
                const sibling = siblings[idx];
                if (!this.getNodeDisabled(sibling)) return sibling;
            }
            return;
        });
        $20e7a777a34d98f3$var$__publicField(this, "getNextSibling", (indexPath)=>{
            const parentNode = this.getParentNode(indexPath);
            if (!parentNode) return;
            const siblings = this.getNodeChildren(parentNode);
            let idx = siblings.findIndex((sibling)=>this.getValue(indexPath) === this.getNodeValue(sibling));
            while(++idx < siblings.length){
                const sibling = siblings[idx];
                if (!this.getNodeDisabled(sibling)) return sibling;
            }
            return;
        });
        $20e7a777a34d98f3$var$__publicField(this, "getSiblingNodes", (indexPath)=>{
            const parentNode = this.getParentNode(indexPath);
            return parentNode ? this.getNodeChildren(parentNode) : [];
        });
        $20e7a777a34d98f3$var$__publicField(this, "getValues", (rootNode = this.rootNode)=>{
            const values = $20e7a777a34d98f3$var$flatMap(rootNode, {
                getChildren: this.getNodeChildren,
                transform: (node)=>[
                        this.getNodeValue(node)
                    ]
            });
            return values.slice(1);
        });
        $20e7a777a34d98f3$var$__publicField(this, "isSameDepth", (indexPath, depth)=>{
            if (depth == null) return true;
            return indexPath.length === depth;
        });
        $20e7a777a34d98f3$var$__publicField(this, "isBranchNode", (node)=>{
            return this.getNodeChildren(node).length > 0;
        });
        $20e7a777a34d98f3$var$__publicField(this, "getBranchValues", (rootNode = this.rootNode, opts = {})=>{
            let values = [];
            $20e7a777a34d98f3$var$visit(rootNode, {
                getChildren: this.getNodeChildren,
                onEnter: (node, indexPath)=>{
                    const nodeValue = this.getNodeValue(node);
                    if (opts.skip?.({
                        value: nodeValue,
                        node: node,
                        indexPath: indexPath
                    })) return "skip";
                    if (this.getNodeChildren(node).length > 0 && this.isSameDepth(indexPath, opts.depth)) values.push(this.getNodeValue(node));
                }
            });
            return values.slice(1);
        });
        $20e7a777a34d98f3$var$__publicField(this, "flatten", (rootNode = this.rootNode)=>{
            const nodes = $20e7a777a34d98f3$var$flatMap(rootNode, {
                getChildren: this.getNodeChildren,
                transform: (node, indexPath)=>{
                    const children = this.getNodeChildren(node).map((child)=>this.getNodeValue(child));
                    return [
                        (0, $89352e0ddd72597a$export$8e16b83750b44988)({
                            label: this.stringifyNode(node),
                            value: this.getNodeValue(node),
                            indexPath: indexPath,
                            children: children.length > 0 ? children : void 0
                        })
                    ];
                }
            });
            return nodes.slice(1);
        });
        $20e7a777a34d98f3$var$__publicField(this, "_create", (node, children)=>{
            return (0, $89352e0ddd72597a$export$8e16b83750b44988)({
                ...node,
                children: children
            });
        });
        $20e7a777a34d98f3$var$__publicField(this, "_insert", (rootNode, indexPath, nodes)=>{
            return $20e7a777a34d98f3$var$insert(rootNode, {
                at: indexPath,
                nodes: nodes,
                getChildren: this.getNodeChildren,
                create: this._create
            });
        });
        $20e7a777a34d98f3$var$__publicField(this, "_replace", (rootNode, indexPath, node)=>{
            return $20e7a777a34d98f3$var$replace(rootNode, {
                at: indexPath,
                node: node,
                getChildren: this.getNodeChildren,
                create: this._create
            });
        });
        $20e7a777a34d98f3$var$__publicField(this, "_move", (rootNode, indexPaths, to)=>{
            return $20e7a777a34d98f3$var$move(rootNode, {
                indexPaths: indexPaths,
                to: to,
                getChildren: this.getNodeChildren,
                create: this._create
            });
        });
        $20e7a777a34d98f3$var$__publicField(this, "_remove", (rootNode, indexPaths)=>{
            return $20e7a777a34d98f3$var$remove(rootNode, {
                indexPaths: indexPaths,
                getChildren: this.getNodeChildren,
                create: this._create
            });
        });
        $20e7a777a34d98f3$var$__publicField(this, "replace", (indexPath, node)=>{
            return this._replace(this.rootNode, indexPath, node);
        });
        $20e7a777a34d98f3$var$__publicField(this, "remove", (indexPaths)=>{
            return this._remove(this.rootNode, indexPaths);
        });
        $20e7a777a34d98f3$var$__publicField(this, "insertBefore", (indexPath, nodes)=>{
            const parentNode = this.getParentNode(indexPath);
            return parentNode ? this._insert(this.rootNode, indexPath, nodes) : void 0;
        });
        $20e7a777a34d98f3$var$__publicField(this, "insertAfter", (indexPath, nodes)=>{
            const parentNode = this.getParentNode(indexPath);
            if (!parentNode) return;
            const nextIndex = [
                ...indexPath.slice(0, -1),
                indexPath[indexPath.length - 1] + 1
            ];
            return this._insert(this.rootNode, nextIndex, nodes);
        });
        $20e7a777a34d98f3$var$__publicField(this, "move", (fromIndexPaths, toIndexPath)=>{
            return this._move(this.rootNode, fromIndexPaths, toIndexPath);
        });
        $20e7a777a34d98f3$var$__publicField(this, "json", ()=>{
            return this.getValues(this.rootNode);
        });
        this.rootNode = options.rootNode;
    }
};
function $20e7a777a34d98f3$export$2aa087f0a57619e1(nodes) {
    let rootNode = {
        value: "ROOT"
    };
    nodes.map((node)=>{
        const { indexPath: indexPath, label: label, value: value } = node;
        if (!indexPath.length) {
            Object.assign(rootNode, {
                label: label,
                value: value,
                children: []
            });
            return;
        }
        rootNode = $20e7a777a34d98f3$var$insert(rootNode, {
            at: indexPath,
            nodes: [
                (0, $89352e0ddd72597a$export$8e16b83750b44988)({
                    label: label,
                    value: value
                })
            ],
            getChildren: (node2)=>node2.children ?? [],
            create: (node2, children)=>{
                return (0, $89352e0ddd72597a$export$8e16b83750b44988)({
                    ...node2,
                    children: children
                });
            }
        });
    });
    return new $20e7a777a34d98f3$export$863faf230ee2118a({
        rootNode: rootNode
    });
}
function $20e7a777a34d98f3$export$2dce4a9e20b2f1e3(paths) {
    const rootNode = {
        label: "",
        value: "ROOT",
        children: []
    };
    paths.forEach((path)=>{
        const parts = path.split("/");
        let currentNode = rootNode;
        parts.forEach((part)=>{
            let childNode = currentNode.children?.find((child)=>child.label === part);
            if (!childNode) {
                childNode = {
                    value: parts.slice(0, parts.indexOf(part) + 1).join("/"),
                    label: part
                };
                currentNode.children || (currentNode.children = []);
                currentNode.children.push(childNode);
            }
            currentNode = childNode;
        });
    });
    return new $20e7a777a34d98f3$export$863faf230ee2118a({
        rootNode: rootNode
    });
}
var $20e7a777a34d98f3$var$fallback2 = {
    nodeToValue (node) {
        if (typeof node === "string") return node;
        if ((0, $89352e0ddd72597a$export$a6cdc56e425d0d0a)(node) && (0, $89352e0ddd72597a$export$dd642ef726dcde21)(node, "value")) return node.value;
        return "";
    },
    nodeToString (node) {
        if (typeof node === "string") return node;
        if ((0, $89352e0ddd72597a$export$a6cdc56e425d0d0a)(node) && (0, $89352e0ddd72597a$export$dd642ef726dcde21)(node, "label")) return node.label;
        return $20e7a777a34d98f3$var$fallback2.nodeToValue(node);
    },
    isNodeDisabled (node) {
        if ((0, $89352e0ddd72597a$export$a6cdc56e425d0d0a)(node) && (0, $89352e0ddd72597a$export$dd642ef726dcde21)(node, "disabled")) return !!node.disabled;
        return false;
    },
    nodeToChildren (node) {
        return node.children;
    }
};








// src/select.anatomy.ts
var $c7b683267f2db6f5$export$477202748c7242bf = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("select").parts("label", "positioner", "trigger", "indicator", "clearTrigger", "item", "itemText", "itemIndicator", "itemGroup", "itemGroupLabel", "list", "content", "root", "control", "valueText");
var $c7b683267f2db6f5$var$parts = $c7b683267f2db6f5$export$477202748c7242bf.build();
var $c7b683267f2db6f5$export$bf5175b0c24981cd = (options)=>{
    return (0, $7bf56e9c8ff12ab3$export$eff4d24c3ff7876e)(new (0, $20e7a777a34d98f3$export$d085fb9e920b5ca7)(options));
};
$c7b683267f2db6f5$export$bf5175b0c24981cd.empty = ()=>{
    return (0, $7bf56e9c8ff12ab3$export$eff4d24c3ff7876e)(new (0, $20e7a777a34d98f3$export$d085fb9e920b5ca7)({
        items: []
    }));
};
var $c7b683267f2db6f5$var$dom = (0, $b06ec5ff205338e5$export$41a9651decfe2bde)({
    getRootId: (ctx)=>ctx.ids?.root ?? `select:${ctx.id}`,
    getContentId: (ctx)=>ctx.ids?.content ?? `select:${ctx.id}:content`,
    getTriggerId: (ctx)=>ctx.ids?.trigger ?? `select:${ctx.id}:trigger`,
    getClearTriggerId: (ctx)=>ctx.ids?.clearTrigger ?? `select:${ctx.id}:clear-trigger`,
    getLabelId: (ctx)=>ctx.ids?.label ?? `select:${ctx.id}:label`,
    getControlId: (ctx)=>ctx.ids?.control ?? `select:${ctx.id}:control`,
    getItemId: (ctx, id)=>ctx.ids?.item?.(id) ?? `select:${ctx.id}:option:${id}`,
    getHiddenSelectId: (ctx)=>ctx.ids?.hiddenSelect ?? `select:${ctx.id}:select`,
    getPositionerId: (ctx)=>ctx.ids?.positioner ?? `select:${ctx.id}:positioner`,
    getItemGroupId: (ctx, id)=>ctx.ids?.itemGroup?.(id) ?? `select:${ctx.id}:optgroup:${id}`,
    getItemGroupLabelId: (ctx, id)=>ctx.ids?.itemGroupLabel?.(id) ?? `select:${ctx.id}:optgroup-label:${id}`,
    getHiddenSelectEl: (ctx)=>$c7b683267f2db6f5$var$dom.getById(ctx, $c7b683267f2db6f5$var$dom.getHiddenSelectId(ctx)),
    getContentEl: (ctx)=>$c7b683267f2db6f5$var$dom.getById(ctx, $c7b683267f2db6f5$var$dom.getContentId(ctx)),
    getControlEl: (ctx)=>$c7b683267f2db6f5$var$dom.getById(ctx, $c7b683267f2db6f5$var$dom.getControlId(ctx)),
    getTriggerEl: (ctx)=>$c7b683267f2db6f5$var$dom.getById(ctx, $c7b683267f2db6f5$var$dom.getTriggerId(ctx)),
    getClearTriggerEl: (ctx)=>$c7b683267f2db6f5$var$dom.getById(ctx, $c7b683267f2db6f5$var$dom.getClearTriggerId(ctx)),
    getPositionerEl: (ctx)=>$c7b683267f2db6f5$var$dom.getById(ctx, $c7b683267f2db6f5$var$dom.getPositionerId(ctx)),
    getHighlightedOptionEl (ctx) {
        if (!ctx.highlightedValue) return null;
        return $c7b683267f2db6f5$var$dom.getById(ctx, $c7b683267f2db6f5$var$dom.getItemId(ctx, ctx.highlightedValue));
    }
});
// src/select.connect.ts
function $c7b683267f2db6f5$export$64605811ab45167f(state, send, normalize) {
    const disabled = state.context.isDisabled;
    const invalid = state.context.invalid;
    const readOnly = state.context.readOnly;
    const interactive = state.context.isInteractive;
    const composite = state.context.composite;
    const open = state.hasTag("open");
    const focused = state.matches("focused");
    const highlightedValue = state.context.highlightedValue;
    const highlightedItem = state.context.highlightedItem;
    const selectedItems = state.context.selectedItems;
    const isTypingAhead = state.context.isTypingAhead;
    const collection2 = state.context.collection;
    const ariaActiveDescendant = highlightedValue ? $c7b683267f2db6f5$var$dom.getItemId(state.context, highlightedValue) : void 0;
    function getItemState(props2) {
        const _disabled = collection2.getItemDisabled(props2.item);
        const value = collection2.getItemValue(props2.item);
        return {
            value: value,
            disabled: Boolean(disabled || _disabled),
            highlighted: highlightedValue === value,
            selected: state.context.value.includes(value)
        };
    }
    const popperStyles = (0, $9e811243c3728edf$export$736498a3bfbba398)({
        ...state.context.positioning,
        placement: state.context.currentPlacement
    });
    return {
        open: open,
        focused: focused,
        empty: state.context.value.length === 0,
        highlightedItem: highlightedItem,
        highlightedValue: highlightedValue,
        selectedItems: selectedItems,
        hasSelectedItems: state.context.hasSelectedItems,
        value: state.context.value,
        valueAsString: state.context.valueAsString,
        collection: collection2,
        multiple: !!state.context.multiple,
        disabled: !!disabled,
        setCollection (collection3) {
            send({
                type: "COLLECTION.SET",
                value: collection3
            });
        },
        reposition (options = {}) {
            send({
                type: "POSITIONING.SET",
                options: options
            });
        },
        focus () {
            $c7b683267f2db6f5$var$dom.getTriggerEl(state.context)?.focus({
                preventScroll: true
            });
        },
        setOpen (nextOpen) {
            if (nextOpen === open) return;
            send(nextOpen ? "OPEN" : "CLOSE");
        },
        selectValue (value) {
            send({
                type: "ITEM.SELECT",
                value: value
            });
        },
        setValue (value) {
            send({
                type: "VALUE.SET",
                value: value
            });
        },
        selectAll () {
            send({
                type: "VALUE.SET",
                value: collection2.getValues()
            });
        },
        highlightValue (value) {
            send({
                type: "HIGHLIGHTED_VALUE.SET",
                value: value
            });
        },
        clearValue (value) {
            if (value) send({
                type: "ITEM.CLEAR",
                value: value
            });
            else send({
                type: "VALUE.CLEAR"
            });
        },
        getItemState: getItemState,
        getRootProps () {
            return normalize.element({
                ...$c7b683267f2db6f5$var$parts.root.attrs,
                dir: state.context.dir,
                id: $c7b683267f2db6f5$var$dom.getRootId(state.context),
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(invalid),
                "data-readonly": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(readOnly)
            });
        },
        getLabelProps () {
            return normalize.label({
                dir: state.context.dir,
                id: $c7b683267f2db6f5$var$dom.getLabelId(state.context),
                ...$c7b683267f2db6f5$var$parts.label.attrs,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(invalid),
                "data-readonly": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(readOnly),
                htmlFor: $c7b683267f2db6f5$var$dom.getHiddenSelectId(state.context),
                onClick (event) {
                    if (event.defaultPrevented) return;
                    if (disabled) return;
                    $c7b683267f2db6f5$var$dom.getTriggerEl(state.context)?.focus({
                        preventScroll: true
                    });
                }
            });
        },
        getControlProps () {
            return normalize.element({
                ...$c7b683267f2db6f5$var$parts.control.attrs,
                dir: state.context.dir,
                id: $c7b683267f2db6f5$var$dom.getControlId(state.context),
                "data-state": open ? "open" : "closed",
                "data-focus": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(focused),
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(invalid)
            });
        },
        getValueTextProps () {
            return normalize.element({
                ...$c7b683267f2db6f5$var$parts.valueText.attrs,
                dir: state.context.dir,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(invalid),
                "data-focus": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(focused)
            });
        },
        getTriggerProps () {
            return normalize.button({
                id: $c7b683267f2db6f5$var$dom.getTriggerId(state.context),
                disabled: disabled,
                dir: state.context.dir,
                type: "button",
                role: "combobox",
                "aria-controls": $c7b683267f2db6f5$var$dom.getContentId(state.context),
                "aria-expanded": open,
                "aria-haspopup": "listbox",
                "data-state": open ? "open" : "closed",
                "aria-invalid": invalid,
                "aria-labelledby": $c7b683267f2db6f5$var$dom.getLabelId(state.context),
                ...$c7b683267f2db6f5$var$parts.trigger.attrs,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(invalid),
                "data-readonly": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(readOnly),
                "data-placement": state.context.currentPlacement,
                "data-placeholder-shown": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(!state.context.hasSelectedItems),
                onClick (event) {
                    if (!interactive) return;
                    if (event.defaultPrevented) return;
                    send({
                        type: "TRIGGER.CLICK"
                    });
                },
                onFocus () {
                    send("TRIGGER.FOCUS");
                },
                onBlur () {
                    send("TRIGGER.BLUR");
                },
                onKeyDown (event) {
                    if (event.defaultPrevented) return;
                    if (!interactive) return;
                    const keyMap = {
                        ArrowUp () {
                            send({
                                type: "TRIGGER.ARROW_UP"
                            });
                        },
                        ArrowDown (event2) {
                            send({
                                type: event2.altKey ? "OPEN" : "TRIGGER.ARROW_DOWN"
                            });
                        },
                        ArrowLeft () {
                            send({
                                type: "TRIGGER.ARROW_LEFT"
                            });
                        },
                        ArrowRight () {
                            send({
                                type: "TRIGGER.ARROW_RIGHT"
                            });
                        },
                        Home () {
                            send({
                                type: "TRIGGER.HOME"
                            });
                        },
                        End () {
                            send({
                                type: "TRIGGER.END"
                            });
                        },
                        Enter () {
                            send({
                                type: "TRIGGER.ENTER"
                            });
                        },
                        Space (event2) {
                            if (isTypingAhead) send({
                                type: "TRIGGER.TYPEAHEAD",
                                key: event2.key
                            });
                            else send({
                                type: "TRIGGER.ENTER"
                            });
                        }
                    };
                    const exec = keyMap[(0, $b06ec5ff205338e5$export$f7a7490116b79d4d)(event, state.context)];
                    if (exec) {
                        exec(event);
                        event.preventDefault();
                        return;
                    }
                    if ((0, $b06ec5ff205338e5$export$ec2dfd1ac255c804).isValidEvent(event)) {
                        send({
                            type: "TRIGGER.TYPEAHEAD",
                            key: event.key
                        });
                        event.preventDefault();
                    }
                }
            });
        },
        getIndicatorProps () {
            return normalize.element({
                ...$c7b683267f2db6f5$var$parts.indicator.attrs,
                dir: state.context.dir,
                "aria-hidden": true,
                "data-state": open ? "open" : "closed",
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(invalid),
                "data-readonly": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(readOnly)
            });
        },
        getItemProps (props2) {
            const itemState = getItemState(props2);
            return normalize.element({
                id: $c7b683267f2db6f5$var$dom.getItemId(state.context, itemState.value),
                role: "option",
                ...$c7b683267f2db6f5$var$parts.item.attrs,
                dir: state.context.dir,
                "data-value": itemState.value,
                "aria-selected": itemState.selected,
                "data-state": itemState.selected ? "checked" : "unchecked",
                "data-highlighted": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(itemState.highlighted),
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(itemState.disabled),
                "aria-disabled": (0, $b06ec5ff205338e5$export$91a6105db3d4be7b)(itemState.disabled),
                onPointerMove (event) {
                    if (itemState.disabled || event.pointerType !== "mouse") return;
                    if (itemState.value === state.context.highlightedValue) return;
                    send({
                        type: "ITEM.POINTER_MOVE",
                        value: itemState.value
                    });
                },
                onClick (event) {
                    if (event.defaultPrevented) return;
                    if (itemState.disabled) return;
                    send({
                        type: "ITEM.CLICK",
                        src: "pointerup",
                        value: itemState.value
                    });
                },
                onPointerLeave (event) {
                    if (itemState.disabled) return;
                    if (props2.persistFocus) return;
                    if (event.pointerType !== "mouse") return;
                    const pointerMoved = state.previousEvent.type.includes("POINTER");
                    if (!pointerMoved) return;
                    send({
                        type: "ITEM.POINTER_LEAVE"
                    });
                }
            });
        },
        getItemTextProps (props2) {
            const itemState = getItemState(props2);
            return normalize.element({
                ...$c7b683267f2db6f5$var$parts.itemText.attrs,
                "data-state": itemState.selected ? "checked" : "unchecked",
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(itemState.disabled),
                "data-highlighted": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(itemState.highlighted)
            });
        },
        getItemIndicatorProps (props2) {
            const itemState = getItemState(props2);
            return normalize.element({
                "aria-hidden": true,
                ...$c7b683267f2db6f5$var$parts.itemIndicator.attrs,
                "data-state": itemState.selected ? "checked" : "unchecked",
                hidden: !itemState.selected
            });
        },
        getItemGroupLabelProps (props2) {
            const { htmlFor: htmlFor } = props2;
            return normalize.element({
                ...$c7b683267f2db6f5$var$parts.itemGroupLabel.attrs,
                id: $c7b683267f2db6f5$var$dom.getItemGroupLabelId(state.context, htmlFor),
                role: "group",
                dir: state.context.dir
            });
        },
        getItemGroupProps (props2) {
            const { id: id } = props2;
            return normalize.element({
                ...$c7b683267f2db6f5$var$parts.itemGroup.attrs,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                id: $c7b683267f2db6f5$var$dom.getItemGroupId(state.context, id),
                "aria-labelledby": $c7b683267f2db6f5$var$dom.getItemGroupLabelId(state.context, id),
                dir: state.context.dir
            });
        },
        getClearTriggerProps () {
            return normalize.button({
                ...$c7b683267f2db6f5$var$parts.clearTrigger.attrs,
                id: $c7b683267f2db6f5$var$dom.getClearTriggerId(state.context),
                type: "button",
                "aria-label": "Clear value",
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(invalid),
                disabled: disabled,
                hidden: !state.context.hasSelectedItems,
                dir: state.context.dir,
                onClick (event) {
                    if (event.defaultPrevented) return;
                    send("CLEAR.CLICK");
                }
            });
        },
        getHiddenSelectProps () {
            return normalize.select({
                name: state.context.name,
                form: state.context.form,
                disabled: disabled,
                multiple: state.context.multiple,
                required: state.context.required,
                "aria-hidden": true,
                id: $c7b683267f2db6f5$var$dom.getHiddenSelectId(state.context),
                defaultValue: state.context.multiple ? state.context.value : state.context.value[0],
                style: (0, $b06ec5ff205338e5$export$8fecac46448b5689),
                tabIndex: -1,
                // Some browser extensions will focus the hidden select.
                // Let's forward the focus to the trigger.
                onFocus () {
                    $c7b683267f2db6f5$var$dom.getTriggerEl(state.context)?.focus({
                        preventScroll: true
                    });
                },
                "aria-labelledby": $c7b683267f2db6f5$var$dom.getLabelId(state.context)
            });
        },
        getPositionerProps () {
            return normalize.element({
                ...$c7b683267f2db6f5$var$parts.positioner.attrs,
                dir: state.context.dir,
                id: $c7b683267f2db6f5$var$dom.getPositionerId(state.context),
                style: popperStyles.floating
            });
        },
        getContentProps () {
            return normalize.element({
                hidden: !open,
                dir: state.context.dir,
                id: $c7b683267f2db6f5$var$dom.getContentId(state.context),
                role: composite ? "listbox" : "dialog",
                ...$c7b683267f2db6f5$var$parts.content.attrs,
                "data-state": open ? "open" : "closed",
                "data-placement": state.context.currentPlacement,
                "data-activedescendant": ariaActiveDescendant,
                "aria-activedescendant": composite ? ariaActiveDescendant : void 0,
                "aria-multiselectable": state.context.multiple && composite ? true : void 0,
                "aria-labelledby": $c7b683267f2db6f5$var$dom.getLabelId(state.context),
                tabIndex: 0,
                onKeyDown (event) {
                    if (!interactive) return;
                    if (!(0, $b06ec5ff205338e5$export$7bced8f45c53f2f)(event)) return;
                    if (event.key === "Tab") {
                        const valid = (0, $b06ec5ff205338e5$export$605ed6bb305230a3)(event);
                        if (!valid) {
                            event.preventDefault();
                            return;
                        }
                    }
                    const keyMap = {
                        ArrowUp () {
                            send({
                                type: "CONTENT.ARROW_UP"
                            });
                        },
                        ArrowDown () {
                            send({
                                type: "CONTENT.ARROW_DOWN"
                            });
                        },
                        Home () {
                            send({
                                type: "CONTENT.HOME"
                            });
                        },
                        End () {
                            send({
                                type: "CONTENT.END"
                            });
                        },
                        Enter () {
                            send({
                                type: "ITEM.CLICK",
                                src: "keydown.enter"
                            });
                        },
                        Space (event2) {
                            if (isTypingAhead) send({
                                type: "CONTENT.TYPEAHEAD",
                                key: event2.key
                            });
                            else keyMap.Enter?.(event2);
                        }
                    };
                    const exec = keyMap[(0, $b06ec5ff205338e5$export$f7a7490116b79d4d)(event)];
                    if (exec) {
                        exec(event);
                        event.preventDefault();
                        return;
                    }
                    const target = (0, $b06ec5ff205338e5$export$e58f029f0fbfdb29)(event);
                    if ((0, $b06ec5ff205338e5$export$2780cb57de98fa3a)(target)) return;
                    if ((0, $b06ec5ff205338e5$export$ec2dfd1ac255c804).isValidEvent(event)) {
                        send({
                            type: "CONTENT.TYPEAHEAD",
                            key: event.key
                        });
                        event.preventDefault();
                    }
                }
            });
        },
        getListProps () {
            return normalize.element({
                ...$c7b683267f2db6f5$var$parts.list.attrs,
                tabIndex: 0,
                role: !composite ? "listbox" : void 0,
                "aria-labelledby": $c7b683267f2db6f5$var$dom.getTriggerId(state.context),
                "aria-activedescendant": !composite ? ariaActiveDescendant : void 0,
                "aria-multiselectable": !composite && state.context.multiple ? true : void 0
            });
        }
    };
}
var { and: $c7b683267f2db6f5$var$and, not: $c7b683267f2db6f5$var$not, or: $c7b683267f2db6f5$var$or } = (0, $5c0da97e9c7aa95f$export$f3249297f3edf7e9);
function $c7b683267f2db6f5$export$ea56d40cd27c3480(userContext) {
    const ctx = (0, $89352e0ddd72597a$export$8e16b83750b44988)(userContext);
    return (0, $5c0da97e9c7aa95f$export$aaa7fa18f8e9b2e8)({
        id: "select",
        context: {
            value: [],
            highlightedValue: null,
            loopFocus: false,
            closeOnSelect: !ctx.multiple,
            disabled: false,
            readOnly: false,
            composite: true,
            ...ctx,
            highlightedItem: null,
            selectedItems: [],
            valueAsString: "",
            collection: ctx.collection ?? $c7b683267f2db6f5$export$bf5175b0c24981cd.empty(),
            typeahead: (0, $b06ec5ff205338e5$export$ec2dfd1ac255c804).defaultOptions,
            fieldsetDisabled: false,
            positioning: {
                placement: "bottom-start",
                gutter: 8,
                ...ctx.positioning
            }
        },
        computed: {
            hasSelectedItems: (ctx2)=>ctx2.value.length > 0,
            isTypingAhead: (ctx2)=>ctx2.typeahead.keysSoFar !== "",
            isDisabled: (ctx2)=>!!ctx2.disabled || ctx2.fieldsetDisabled,
            isInteractive: (ctx2)=>!(ctx2.isDisabled || ctx2.readOnly)
        },
        initial: ctx.open ? "open" : "idle",
        created: [
            "syncCollection"
        ],
        entry: [
            "syncSelectElement"
        ],
        watch: {
            open: [
                "toggleVisibility"
            ],
            value: [
                "syncSelectedItems",
                "syncSelectElement"
            ],
            highlightedValue: [
                "syncHighlightedItem"
            ],
            collection: [
                "syncCollection"
            ]
        },
        on: {
            "HIGHLIGHTED_VALUE.SET": {
                actions: [
                    "setHighlightedItem"
                ]
            },
            "ITEM.SELECT": {
                actions: [
                    "selectItem"
                ]
            },
            "ITEM.CLEAR": {
                actions: [
                    "clearItem"
                ]
            },
            "VALUE.SET": {
                actions: [
                    "setSelectedItems"
                ]
            },
            "VALUE.CLEAR": {
                actions: [
                    "clearSelectedItems"
                ]
            },
            "CLEAR.CLICK": {
                actions: [
                    "clearSelectedItems",
                    "focusTriggerEl"
                ]
            },
            "COLLECTION.SET": {
                actions: [
                    "setCollection"
                ]
            }
        },
        activities: [
            "trackFormControlState"
        ],
        states: {
            idle: {
                tags: [
                    "closed"
                ],
                on: {
                    "CONTROLLED.OPEN": [
                        {
                            guard: "isTriggerClickEvent",
                            target: "open",
                            actions: [
                                "setInitialFocus",
                                "highlightFirstSelectedItem"
                            ]
                        },
                        {
                            target: "open",
                            actions: [
                                "setInitialFocus"
                            ]
                        }
                    ],
                    "TRIGGER.CLICK": [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnOpen"
                            ]
                        },
                        {
                            target: "open",
                            actions: [
                                "invokeOnOpen",
                                "setInitialFocus",
                                "highlightFirstSelectedItem"
                            ]
                        }
                    ],
                    "TRIGGER.FOCUS": {
                        target: "focused"
                    },
                    OPEN: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnOpen"
                            ]
                        },
                        {
                            target: "open",
                            actions: [
                                "setInitialFocus",
                                "invokeOnOpen"
                            ]
                        }
                    ]
                }
            },
            focused: {
                tags: [
                    "closed"
                ],
                on: {
                    "CONTROLLED.OPEN": [
                        {
                            guard: "isTriggerClickEvent",
                            target: "open",
                            actions: [
                                "setInitialFocus",
                                "highlightFirstSelectedItem"
                            ]
                        },
                        {
                            guard: "isTriggerArrowUpEvent",
                            target: "open",
                            actions: [
                                "setInitialFocus",
                                "highlightComputedLastItem"
                            ]
                        },
                        {
                            guard: $c7b683267f2db6f5$var$or("isTriggerArrowDownEvent", "isTriggerEnterEvent"),
                            target: "open",
                            actions: [
                                "setInitialFocus",
                                "highlightComputedFirstItem"
                            ]
                        },
                        {
                            target: "open",
                            actions: [
                                "setInitialFocus"
                            ]
                        }
                    ],
                    OPEN: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnOpen"
                            ]
                        },
                        {
                            target: "open",
                            actions: [
                                "setInitialFocus",
                                "invokeOnOpen"
                            ]
                        }
                    ],
                    "TRIGGER.BLUR": {
                        target: "idle"
                    },
                    "TRIGGER.CLICK": [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnOpen"
                            ]
                        },
                        {
                            target: "open",
                            actions: [
                                "setInitialFocus",
                                "invokeOnOpen",
                                "highlightFirstSelectedItem"
                            ]
                        }
                    ],
                    "TRIGGER.ENTER": [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnOpen"
                            ]
                        },
                        {
                            target: "open",
                            actions: [
                                "setInitialFocus",
                                "invokeOnOpen",
                                "highlightComputedFirstItem"
                            ]
                        }
                    ],
                    "TRIGGER.ARROW_UP": [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnOpen"
                            ]
                        },
                        {
                            target: "open",
                            actions: [
                                "setInitialFocus",
                                "invokeOnOpen",
                                "highlightComputedLastItem"
                            ]
                        }
                    ],
                    "TRIGGER.ARROW_DOWN": [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnOpen"
                            ]
                        },
                        {
                            target: "open",
                            actions: [
                                "setInitialFocus",
                                "invokeOnOpen",
                                "highlightComputedFirstItem"
                            ]
                        }
                    ],
                    "TRIGGER.ARROW_LEFT": [
                        {
                            guard: $c7b683267f2db6f5$var$and($c7b683267f2db6f5$var$not("multiple"), "hasSelectedItems"),
                            actions: [
                                "selectPreviousItem"
                            ]
                        },
                        {
                            guard: $c7b683267f2db6f5$var$not("multiple"),
                            actions: [
                                "selectLastItem"
                            ]
                        }
                    ],
                    "TRIGGER.ARROW_RIGHT": [
                        {
                            guard: $c7b683267f2db6f5$var$and($c7b683267f2db6f5$var$not("multiple"), "hasSelectedItems"),
                            actions: [
                                "selectNextItem"
                            ]
                        },
                        {
                            guard: $c7b683267f2db6f5$var$not("multiple"),
                            actions: [
                                "selectFirstItem"
                            ]
                        }
                    ],
                    "TRIGGER.HOME": {
                        guard: $c7b683267f2db6f5$var$not("multiple"),
                        actions: [
                            "selectFirstItem"
                        ]
                    },
                    "TRIGGER.END": {
                        guard: $c7b683267f2db6f5$var$not("multiple"),
                        actions: [
                            "selectLastItem"
                        ]
                    },
                    "TRIGGER.TYPEAHEAD": {
                        guard: $c7b683267f2db6f5$var$not("multiple"),
                        actions: [
                            "selectMatchingItem"
                        ]
                    }
                }
            },
            open: {
                tags: [
                    "open"
                ],
                exit: [
                    "scrollContentToTop"
                ],
                activities: [
                    "trackDismissableElement",
                    "computePlacement",
                    "scrollToHighlightedItem"
                ],
                on: {
                    "CONTROLLED.CLOSE": {
                        target: "focused",
                        actions: [
                            "focusTriggerEl",
                            "clearHighlightedItem"
                        ]
                    },
                    CLOSE: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnClose"
                            ]
                        },
                        {
                            target: "focused",
                            actions: [
                                "invokeOnClose",
                                "focusTriggerEl",
                                "clearHighlightedItem"
                            ]
                        }
                    ],
                    "TRIGGER.CLICK": [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnClose"
                            ]
                        },
                        {
                            target: "focused",
                            actions: [
                                "invokeOnClose",
                                "clearHighlightedItem"
                            ]
                        }
                    ],
                    "ITEM.CLICK": [
                        {
                            guard: $c7b683267f2db6f5$var$and("closeOnSelect", "isOpenControlled"),
                            actions: [
                                "selectHighlightedItem",
                                "invokeOnClose"
                            ]
                        },
                        {
                            guard: "closeOnSelect",
                            target: "focused",
                            actions: [
                                "selectHighlightedItem",
                                "invokeOnClose",
                                "focusTriggerEl",
                                "clearHighlightedItem"
                            ]
                        },
                        {
                            actions: [
                                "selectHighlightedItem"
                            ]
                        }
                    ],
                    "CONTENT.HOME": {
                        actions: [
                            "highlightFirstItem"
                        ]
                    },
                    "CONTENT.END": {
                        actions: [
                            "highlightLastItem"
                        ]
                    },
                    "CONTENT.ARROW_DOWN": [
                        {
                            guard: $c7b683267f2db6f5$var$and("hasHighlightedItem", "loop", "isLastItemHighlighted"),
                            actions: [
                                "highlightFirstItem"
                            ]
                        },
                        {
                            guard: "hasHighlightedItem",
                            actions: [
                                "highlightNextItem"
                            ]
                        },
                        {
                            actions: [
                                "highlightFirstItem"
                            ]
                        }
                    ],
                    "CONTENT.ARROW_UP": [
                        {
                            guard: $c7b683267f2db6f5$var$and("hasHighlightedItem", "loop", "isFirstItemHighlighted"),
                            actions: [
                                "highlightLastItem"
                            ]
                        },
                        {
                            guard: "hasHighlightedItem",
                            actions: [
                                "highlightPreviousItem"
                            ]
                        },
                        {
                            actions: [
                                "highlightLastItem"
                            ]
                        }
                    ],
                    "CONTENT.TYPEAHEAD": {
                        actions: [
                            "highlightMatchingItem"
                        ]
                    },
                    "ITEM.POINTER_MOVE": {
                        actions: [
                            "highlightItem"
                        ]
                    },
                    "ITEM.POINTER_LEAVE": {
                        actions: [
                            "clearHighlightedItem"
                        ]
                    },
                    "POSITIONING.SET": {
                        actions: [
                            "reposition"
                        ]
                    }
                }
            }
        }
    }, {
        guards: {
            loop: (ctx2)=>!!ctx2.loopFocus,
            multiple: (ctx2)=>!!ctx2.multiple,
            hasSelectedItems: (ctx2)=>!!ctx2.hasSelectedItems,
            hasHighlightedItem: (ctx2)=>ctx2.highlightedValue != null,
            isFirstItemHighlighted: (ctx2)=>ctx2.highlightedValue === ctx2.collection.firstValue,
            isLastItemHighlighted: (ctx2)=>ctx2.highlightedValue === ctx2.collection.lastValue,
            closeOnSelect: (ctx2, evt)=>!!(evt.closeOnSelect ?? ctx2.closeOnSelect),
            // guard assertions (for controlled mode)
            isOpenControlled: (ctx2)=>!!ctx2["open.controlled"],
            isTriggerClickEvent: (_ctx, evt)=>evt.previousEvent?.type === "TRIGGER.CLICK",
            isTriggerEnterEvent: (_ctx, evt)=>evt.previousEvent?.type === "TRIGGER.ENTER",
            isTriggerArrowUpEvent: (_ctx, evt)=>evt.previousEvent?.type === "TRIGGER.ARROW_UP",
            isTriggerArrowDownEvent: (_ctx, evt)=>evt.previousEvent?.type === "TRIGGER.ARROW_DOWN"
        },
        activities: {
            trackFormControlState (ctx2, _evt, { initialContext: initialContext }) {
                return (0, $b06ec5ff205338e5$export$a48469c7b6beba26)($c7b683267f2db6f5$var$dom.getHiddenSelectEl(ctx2), {
                    onFieldsetDisabledChange (disabled) {
                        ctx2.fieldsetDisabled = disabled;
                    },
                    onFormReset () {
                        $c7b683267f2db6f5$var$set.selectedItems(ctx2, initialContext.value);
                    }
                });
            },
            trackDismissableElement (ctx2, _evt, { send: send }) {
                const contentEl = ()=>$c7b683267f2db6f5$var$dom.getContentEl(ctx2);
                let restoreFocus = true;
                return (0, $a0385836474f3c11$export$72bda0e502b8ea31)(contentEl, {
                    defer: true,
                    exclude: [
                        $c7b683267f2db6f5$var$dom.getTriggerEl(ctx2),
                        $c7b683267f2db6f5$var$dom.getClearTriggerEl(ctx2)
                    ],
                    onFocusOutside: ctx2.onFocusOutside,
                    onPointerDownOutside: ctx2.onPointerDownOutside,
                    onInteractOutside (event) {
                        ctx2.onInteractOutside?.(event);
                        restoreFocus = !(event.detail.focusable || event.detail.contextmenu);
                    },
                    onDismiss () {
                        send({
                            type: "CLOSE",
                            src: "interact-outside",
                            restoreFocus: restoreFocus
                        });
                    }
                });
            },
            computePlacement (ctx2) {
                ctx2.currentPlacement = ctx2.positioning.placement;
                const triggerEl = ()=>$c7b683267f2db6f5$var$dom.getTriggerEl(ctx2);
                const positionerEl = ()=>$c7b683267f2db6f5$var$dom.getPositionerEl(ctx2);
                return (0, $9e811243c3728edf$export$a9fe23cfa43a7b55)(triggerEl, positionerEl, {
                    defer: true,
                    ...ctx2.positioning,
                    onComplete (data) {
                        ctx2.currentPlacement = data.placement;
                    }
                });
            },
            scrollToHighlightedItem (ctx2, _evt, { getState: getState }) {
                const exec = (immediate)=>{
                    if (ctx2.highlightedValue == null) return;
                    const state = getState();
                    if (state.event.type.includes("POINTER")) return;
                    const optionEl = $c7b683267f2db6f5$var$dom.getHighlightedOptionEl(ctx2);
                    const contentEl2 = $c7b683267f2db6f5$var$dom.getContentEl(ctx2);
                    if (ctx2.scrollToIndexFn) {
                        const highlightedIndex = ctx2.collection.indexOf(ctx2.highlightedValue);
                        ctx2.scrollToIndexFn({
                            index: highlightedIndex,
                            immediate: immediate
                        });
                        return;
                    }
                    (0, $b06ec5ff205338e5$export$53a0910f038337bd)(optionEl, {
                        rootEl: contentEl2,
                        block: "nearest"
                    });
                };
                (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>exec(true));
                const contentEl = ()=>$c7b683267f2db6f5$var$dom.getContentEl(ctx2);
                return (0, $b06ec5ff205338e5$export$343af0d656c88488)(contentEl, {
                    defer: true,
                    attributes: [
                        "data-activedescendant"
                    ],
                    callback () {
                        exec(false);
                    }
                });
            }
        },
        actions: {
            reposition (ctx2, evt) {
                const positionerEl = ()=>$c7b683267f2db6f5$var$dom.getPositionerEl(ctx2);
                (0, $9e811243c3728edf$export$a9fe23cfa43a7b55)($c7b683267f2db6f5$var$dom.getTriggerEl(ctx2), positionerEl, {
                    ...ctx2.positioning,
                    ...evt.options,
                    defer: true,
                    listeners: false,
                    onComplete (data) {
                        ctx2.currentPlacement = data.placement;
                    }
                });
            },
            toggleVisibility (ctx2, evt, { send: send }) {
                send({
                    type: ctx2.open ? "CONTROLLED.OPEN" : "CONTROLLED.CLOSE",
                    previousEvent: evt
                });
            },
            highlightPreviousItem (ctx2) {
                if (ctx2.highlightedValue == null) return;
                const value = ctx2.collection.getPreviousValue(ctx2.highlightedValue);
                $c7b683267f2db6f5$var$set.highlightedItem(ctx2, value);
            },
            highlightNextItem (ctx2) {
                if (ctx2.highlightedValue == null) return;
                const value = ctx2.collection.getNextValue(ctx2.highlightedValue);
                $c7b683267f2db6f5$var$set.highlightedItem(ctx2, value);
            },
            highlightFirstItem (ctx2) {
                const value = ctx2.collection.firstValue;
                $c7b683267f2db6f5$var$set.highlightedItem(ctx2, value);
            },
            highlightLastItem (ctx2) {
                const value = ctx2.collection.lastValue;
                $c7b683267f2db6f5$var$set.highlightedItem(ctx2, value);
            },
            setInitialFocus (ctx2) {
                (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>{
                    const element = (0, $b06ec5ff205338e5$export$af1ff6d51ec218ea)({
                        root: $c7b683267f2db6f5$var$dom.getContentEl(ctx2)
                    });
                    element?.focus({
                        preventScroll: true
                    });
                });
            },
            focusTriggerEl (ctx2, evt) {
                const restoreFocus = evt.restoreFocus ?? evt.previousEvent?.restoreFocus;
                if (restoreFocus != null && !restoreFocus) return;
                (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>{
                    const element = $c7b683267f2db6f5$var$dom.getTriggerEl(ctx2);
                    element?.focus({
                        preventScroll: true
                    });
                });
            },
            selectHighlightedItem (ctx2, evt) {
                let value = evt.value ?? ctx2.highlightedValue;
                if (value == null) return;
                const nullable = ctx2.deselectable && !ctx2.multiple && ctx2.value.includes(value);
                value = nullable ? null : value;
                $c7b683267f2db6f5$var$set.selectedItem(ctx2, value, nullable);
            },
            highlightComputedFirstItem (ctx2) {
                const value = ctx2.hasSelectedItems ? ctx2.collection.sort(ctx2.value)[0] : ctx2.collection.firstValue;
                $c7b683267f2db6f5$var$set.highlightedItem(ctx2, value);
            },
            highlightComputedLastItem (ctx2) {
                const value = ctx2.hasSelectedItems ? ctx2.collection.sort(ctx2.value)[0] : ctx2.collection.lastValue;
                $c7b683267f2db6f5$var$set.highlightedItem(ctx2, value);
            },
            highlightFirstSelectedItem (ctx2) {
                if (!ctx2.hasSelectedItems) return;
                const [value] = ctx2.collection.sort(ctx2.value);
                $c7b683267f2db6f5$var$set.highlightedItem(ctx2, value);
            },
            highlightItem (ctx2, evt) {
                $c7b683267f2db6f5$var$set.highlightedItem(ctx2, evt.value);
            },
            highlightMatchingItem (ctx2, evt) {
                const value = ctx2.collection.search(evt.key, {
                    state: ctx2.typeahead,
                    currentValue: ctx2.highlightedValue
                });
                if (value == null) return;
                $c7b683267f2db6f5$var$set.highlightedItem(ctx2, value);
            },
            setHighlightedItem (ctx2, evt) {
                $c7b683267f2db6f5$var$set.highlightedItem(ctx2, evt.value);
            },
            clearHighlightedItem (ctx2) {
                $c7b683267f2db6f5$var$set.highlightedItem(ctx2, null, true);
            },
            selectItem (ctx2, evt) {
                const nullable = ctx2.deselectable && !ctx2.multiple && ctx2.value.includes(evt.value);
                const value = nullable ? null : evt.value;
                $c7b683267f2db6f5$var$set.selectedItem(ctx2, value, nullable);
            },
            clearItem (ctx2, evt) {
                const value = ctx2.value.filter((v)=>v !== evt.value);
                $c7b683267f2db6f5$var$set.selectedItems(ctx2, value);
            },
            setSelectedItems (ctx2, evt) {
                $c7b683267f2db6f5$var$set.selectedItems(ctx2, evt.value);
            },
            clearSelectedItems (ctx2) {
                $c7b683267f2db6f5$var$set.selectedItems(ctx2, []);
            },
            selectPreviousItem (ctx2) {
                const value = ctx2.collection.getPreviousValue(ctx2.value[0]);
                $c7b683267f2db6f5$var$set.selectedItem(ctx2, value);
            },
            selectNextItem (ctx2) {
                const value = ctx2.collection.getNextValue(ctx2.value[0]);
                $c7b683267f2db6f5$var$set.selectedItem(ctx2, value);
            },
            selectFirstItem (ctx2) {
                const value = ctx2.collection.firstValue;
                $c7b683267f2db6f5$var$set.selectedItem(ctx2, value);
            },
            selectLastItem (ctx2) {
                const value = ctx2.collection.lastValue;
                $c7b683267f2db6f5$var$set.selectedItem(ctx2, value);
            },
            selectMatchingItem (ctx2, evt) {
                const value = ctx2.collection.search(evt.key, {
                    state: ctx2.typeahead,
                    currentValue: ctx2.value[0]
                });
                if (value == null) return;
                $c7b683267f2db6f5$var$set.selectedItem(ctx2, value);
            },
            scrollContentToTop (ctx2) {
                if (ctx2.scrollToIndexFn) ctx2.scrollToIndexFn({
                    index: 0,
                    immediate: true
                });
                else $c7b683267f2db6f5$var$dom.getContentEl(ctx2)?.scrollTo(0, 0);
            },
            invokeOnOpen (ctx2) {
                ctx2.onOpenChange?.({
                    open: true
                });
            },
            invokeOnClose (ctx2) {
                ctx2.onOpenChange?.({
                    open: false
                });
            },
            syncSelectElement (ctx2) {
                const selectEl = $c7b683267f2db6f5$var$dom.getHiddenSelectEl(ctx2);
                if (!selectEl) return;
                if (ctx2.value.length === 0 && !ctx2.multiple) {
                    selectEl.selectedIndex = -1;
                    return;
                }
                for (const option of selectEl.options)option.selected = ctx2.value.includes(option.value);
            },
            setCollection (ctx2, evt) {
                ctx2.collection = evt.value;
            },
            syncCollection (ctx2) {
                const selectedItems = ctx2.collection.findMany(ctx2.value);
                const valueAsString = ctx2.collection.stringifyItems(selectedItems);
                ctx2.highlightedItem = ctx2.collection.find(ctx2.highlightedValue);
                ctx2.selectedItems = selectedItems;
                ctx2.valueAsString = valueAsString;
            },
            syncSelectedItems (ctx2) {
                $c7b683267f2db6f5$var$sync.valueChange(ctx2);
            },
            syncHighlightedItem (ctx2) {
                $c7b683267f2db6f5$var$sync.highlightChange(ctx2);
            }
        }
    });
}
function $c7b683267f2db6f5$var$dispatchChangeEvent(ctx) {
    (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>{
        const node = $c7b683267f2db6f5$var$dom.getHiddenSelectEl(ctx);
        if (!node) return;
        const win = $c7b683267f2db6f5$var$dom.getWin(ctx);
        const changeEvent = new win.Event("change", {
            bubbles: true,
            composed: true
        });
        node.dispatchEvent(changeEvent);
    });
}
var $c7b683267f2db6f5$var$sync = {
    valueChange: (ctx)=>{
        const prevSelectedItems = ctx.selectedItems;
        ctx.selectedItems = ctx.value.map((value)=>{
            const foundItem = prevSelectedItems.find((item)=>ctx.collection.getItemValue(item) === value);
            if (foundItem) return foundItem;
            return ctx.collection.find(value);
        });
        ctx.valueAsString = ctx.collection.stringifyItems(ctx.selectedItems);
    },
    highlightChange: (ctx)=>{
        ctx.highlightedItem = ctx.collection.find(ctx.highlightedValue);
    }
};
var $c7b683267f2db6f5$var$invoke = {
    valueChange: (ctx)=>{
        $c7b683267f2db6f5$var$sync.valueChange(ctx);
        ctx.onValueChange?.({
            value: Array.from(ctx.value),
            items: Array.from(ctx.selectedItems)
        });
        $c7b683267f2db6f5$var$dispatchChangeEvent(ctx);
    },
    highlightChange: (ctx)=>{
        $c7b683267f2db6f5$var$sync.highlightChange(ctx);
        ctx.onHighlightChange?.({
            highlightedValue: ctx.highlightedValue,
            highlightedItem: ctx.highlightedItem,
            highlightedIndex: ctx.collection.indexOf(ctx.highlightedValue)
        });
    }
};
var $c7b683267f2db6f5$var$set = {
    selectedItem: (ctx, value, force = false)=>{
        if ((0, $89352e0ddd72597a$export$248d38f6296296c5)(ctx.value, value)) return;
        if (value == null && !force) return;
        if (value == null && force) {
            ctx.value = [];
            $c7b683267f2db6f5$var$invoke.valueChange(ctx);
            return;
        }
        ctx.value = ctx.multiple ? (0, $89352e0ddd72597a$export$daf1e94085156e29)(ctx.value, value) : [
            value
        ];
        $c7b683267f2db6f5$var$invoke.valueChange(ctx);
    },
    selectedItems: (ctx, value)=>{
        if ((0, $89352e0ddd72597a$export$248d38f6296296c5)(ctx.value, value)) return;
        ctx.value = value;
        $c7b683267f2db6f5$var$invoke.valueChange(ctx);
    },
    highlightedItem: (ctx, value, force = false)=>{
        if ((0, $89352e0ddd72597a$export$248d38f6296296c5)(ctx.highlightedValue, value)) return;
        if (value == null && !force) return;
        ctx.highlightedValue = value ?? null;
        $c7b683267f2db6f5$var$invoke.highlightChange(ctx);
    }
};
var $c7b683267f2db6f5$export$8128bb6492cf3de7 = (0, $5b359805fda5a40e$export$c94ea207b45fef3a)()([
    "closeOnSelect",
    "collection",
    "dir",
    "disabled",
    "deselectable",
    "form",
    "getRootNode",
    "highlightedValue",
    "id",
    "ids",
    "invalid",
    "loopFocus",
    "multiple",
    "name",
    "onFocusOutside",
    "onHighlightChange",
    "onInteractOutside",
    "onOpenChange",
    "onPointerDownOutside",
    "onValueChange",
    "open.controlled",
    "open",
    "composite",
    "positioning",
    "required",
    "readOnly",
    "scrollToIndexFn",
    "value"
]);
var $c7b683267f2db6f5$export$45029c61b0073d87 = (0, $89352e0ddd72597a$export$3ea53b214fbc1986)($c7b683267f2db6f5$export$8128bb6492cf3de7);
var $c7b683267f2db6f5$export$b67876e05d194bf9 = (0, $5b359805fda5a40e$export$c94ea207b45fef3a)()([
    "item",
    "persistFocus"
]);
var $c7b683267f2db6f5$export$ae9d1ad549773548 = (0, $89352e0ddd72597a$export$3ea53b214fbc1986)($c7b683267f2db6f5$export$b67876e05d194bf9);
var $c7b683267f2db6f5$export$fbe8b8f4cd1d5ed7 = (0, $5b359805fda5a40e$export$c94ea207b45fef3a)()([
    "id"
]);
var $c7b683267f2db6f5$export$f4286fe441d028d6 = (0, $89352e0ddd72597a$export$3ea53b214fbc1986)($c7b683267f2db6f5$export$fbe8b8f4cd1d5ed7);
var $c7b683267f2db6f5$export$92ed29ce5b278a77 = (0, $5b359805fda5a40e$export$c94ea207b45fef3a)()([
    "htmlFor"
]);
var $c7b683267f2db6f5$export$fc6bfc0f1bf8dde8 = (0, $89352e0ddd72597a$export$3ea53b214fbc1986)($c7b683267f2db6f5$export$92ed29ce5b278a77);






// src/track-size.ts
function $1ba8ee7ba4c5cd14$export$6bfdefed991d4198(element, callback) {
    if (!element) {
        callback(void 0);
        return;
    }
    callback({
        width: element.offsetWidth,
        height: element.offsetHeight
    });
    const win = element.ownerDocument.defaultView ?? window;
    const observer = new win.ResizeObserver((entries)=>{
        if (!Array.isArray(entries) || !entries.length) return;
        const [entry] = entries;
        let width;
        let height;
        if ("borderBoxSize" in entry) {
            const borderSizeEntry = entry["borderBoxSize"];
            const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
            width = borderSize["inlineSize"];
            height = borderSize["blockSize"];
        } else {
            width = element.offsetWidth;
            height = element.offsetHeight;
        }
        callback({
            width: width,
            height: height
        });
    });
    observer.observe(element, {
        box: "border-box"
    });
    return ()=>observer.unobserve(element);
}
// src/track-sizes.ts
function $1ba8ee7ba4c5cd14$export$2887fd71b1bf2cdb(options) {
    const { getNodes: getNodes, observeMutation: observeMutation = true, callback: callback } = options;
    const cleanups = [];
    let firstNode = null;
    function trigger() {
        const elements = getNodes();
        firstNode = elements[0];
        const fns = elements.map((element, index)=>$1ba8ee7ba4c5cd14$export$6bfdefed991d4198(element, (size)=>{
                callback(size, index);
            }));
        cleanups.push(...fns);
    }
    trigger();
    if (observeMutation) {
        const fn = $1ba8ee7ba4c5cd14$var$trackMutation(firstNode, trigger);
        cleanups.push(fn);
    }
    return ()=>{
        cleanups.forEach((cleanup)=>{
            cleanup?.();
        });
    };
}
function $1ba8ee7ba4c5cd14$var$trackMutation(el, cb) {
    if (!el || !el.parentElement) return;
    const win = el.ownerDocument?.defaultView ?? window;
    const observer = new win.MutationObserver(()=>{
        cb();
    });
    observer.observe(el.parentElement, {
        childList: true
    });
    return ()=>{
        observer.disconnect();
    };
}



// src/slider.anatomy.ts
var $45d0679faae7ef05$export$477202748c7242bf = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("slider").parts("root", "label", "thumb", "valueText", "track", "range", "control", "markerGroup", "marker", "draggingIndicator");
var $45d0679faae7ef05$var$parts = $45d0679faae7ef05$export$477202748c7242bf.build();
function $45d0679faae7ef05$var$getBounds(value) {
    const firstValue = value[0];
    const lastThumb = value[value.length - 1];
    return [
        firstValue,
        lastThumb
    ];
}
function $45d0679faae7ef05$var$getRangeOffsets(ctx) {
    const [firstPercent, lastPercent] = $45d0679faae7ef05$var$getBounds(ctx.valuePercent);
    if (ctx.valuePercent.length === 1) {
        if (ctx.origin === "center") {
            const isNegative = ctx.valuePercent[0] < 50;
            const start = isNegative ? `${ctx.valuePercent[0]}%` : "50%";
            const end = isNegative ? "50%" : `${100 - ctx.valuePercent[0]}%`;
            return {
                start: start,
                end: end
            };
        }
        return {
            start: "0%",
            end: `${100 - lastPercent}%`
        };
    }
    return {
        start: `${firstPercent}%`,
        end: `${100 - lastPercent}%`
    };
}
function $45d0679faae7ef05$var$getRangeStyle(ctx) {
    if (ctx.isVertical) return {
        position: "absolute",
        bottom: "var(--slider-range-start)",
        top: "var(--slider-range-end)"
    };
    return {
        position: "absolute",
        [ctx.isRtl ? "right" : "left"]: "var(--slider-range-start)",
        [ctx.isRtl ? "left" : "right"]: "var(--slider-range-end)"
    };
}
function $45d0679faae7ef05$var$getVerticalThumbOffset(ctx) {
    const { height: height = 0 } = ctx.thumbSize ?? {};
    const getValue = (0, $89352e0ddd72597a$export$42961567a0fc6d1e)([
        ctx.min,
        ctx.max
    ], [
        -height / 2,
        height / 2
    ]);
    return parseFloat(getValue(ctx.value).toFixed(2));
}
function $45d0679faae7ef05$var$getHorizontalThumbOffset(ctx) {
    const { width: width = 0 } = ctx.thumbSize ?? {};
    if (ctx.isRtl) {
        const getValue2 = (0, $89352e0ddd72597a$export$42961567a0fc6d1e)([
            ctx.max,
            ctx.min
        ], [
            -width / 2,
            width / 2
        ]);
        return -1 * parseFloat(getValue2(ctx.value).toFixed(2));
    }
    const getValue = (0, $89352e0ddd72597a$export$42961567a0fc6d1e)([
        ctx.min,
        ctx.max
    ], [
        -width / 2,
        width / 2
    ]);
    return parseFloat(getValue(ctx.value).toFixed(2));
}
function $45d0679faae7ef05$var$getOffset(ctx, percent) {
    if (ctx.thumbAlignment === "center") return `${percent}%`;
    const offset = ctx.isVertical ? $45d0679faae7ef05$var$getVerticalThumbOffset(ctx) : $45d0679faae7ef05$var$getHorizontalThumbOffset(ctx);
    return `calc(${percent}% - ${offset}px)`;
}
function $45d0679faae7ef05$var$getThumbOffset(ctx) {
    let percent = (0, $89352e0ddd72597a$export$22574034cd380c24)(ctx.value, ctx.min, ctx.max) * 100;
    return $45d0679faae7ef05$var$getOffset(ctx, percent);
}
function $45d0679faae7ef05$var$getVisibility(ctx) {
    let visibility = "visible";
    if (ctx.thumbAlignment === "contain" && !ctx.hasMeasuredThumbSize) visibility = "hidden";
    return visibility;
}
function $45d0679faae7ef05$var$getThumbStyle(ctx, index) {
    const placementProp = ctx.isVertical ? "bottom" : "insetInlineStart";
    return {
        visibility: $45d0679faae7ef05$var$getVisibility(ctx),
        position: "absolute",
        transform: "var(--slider-thumb-transform)",
        [placementProp]: `var(--slider-thumb-offset-${index})`
    };
}
function $45d0679faae7ef05$var$getControlStyle() {
    return {
        touchAction: "none",
        userSelect: "none",
        WebkitUserSelect: "none",
        position: "relative"
    };
}
function $45d0679faae7ef05$var$getRootStyle(ctx) {
    const range = $45d0679faae7ef05$var$getRangeOffsets(ctx);
    const offsetStyles = ctx.value.reduce((styles, value, index)=>{
        const offset = $45d0679faae7ef05$var$getThumbOffset({
            ...ctx,
            value: value
        });
        return {
            ...styles,
            [`--slider-thumb-offset-${index}`]: offset
        };
    }, {});
    return {
        ...offsetStyles,
        "--slider-thumb-transform": ctx.isVertical ? "translateY(50%)" : ctx.isRtl ? "translateX(50%)" : "translateX(-50%)",
        "--slider-range-start": range.start,
        "--slider-range-end": range.end
    };
}
function $45d0679faae7ef05$var$getMarkerStyle(ctx, value) {
    return {
        // @ts-expect-error
        visibility: $45d0679faae7ef05$var$getVisibility(ctx),
        position: "absolute",
        pointerEvents: "none",
        // @ts-expect-error
        [ctx.isHorizontal ? "insetInlineStart" : "bottom"]: $45d0679faae7ef05$var$getThumbOffset({
            ...ctx,
            value: value
        }),
        translate: "var(--tx) var(--ty)",
        "--tx": ctx.isHorizontal ? ctx.isRtl ? "50%" : "-50%" : "0%",
        "--ty": !ctx.isHorizontal ? "50%" : "0%"
    };
}
function $45d0679faae7ef05$var$getMarkerGroupStyle() {
    return {
        userSelect: "none",
        WebkitUserSelect: "none",
        pointerEvents: "none",
        position: "relative"
    };
}
var $45d0679faae7ef05$var$styleGetterFns = {
    getRootStyle: $45d0679faae7ef05$var$getRootStyle,
    getControlStyle: $45d0679faae7ef05$var$getControlStyle,
    getThumbStyle: $45d0679faae7ef05$var$getThumbStyle,
    getRangeStyle: $45d0679faae7ef05$var$getRangeStyle,
    getMarkerStyle: $45d0679faae7ef05$var$getMarkerStyle,
    getMarkerGroupStyle: $45d0679faae7ef05$var$getMarkerGroupStyle
};
// src/slider.dom.ts
var $45d0679faae7ef05$var$dom = (0, $b06ec5ff205338e5$export$41a9651decfe2bde)({
    ...$45d0679faae7ef05$var$styleGetterFns,
    getRootId: (ctx)=>ctx.ids?.root ?? `slider:${ctx.id}`,
    getThumbId: (ctx, index)=>ctx.ids?.thumb?.(index) ?? `slider:${ctx.id}:thumb:${index}`,
    getHiddenInputId: (ctx, index)=>ctx.ids?.hiddenInput?.(index) ?? `slider:${ctx.id}:input:${index}`,
    getControlId: (ctx)=>ctx.ids?.control ?? `slider:${ctx.id}:control`,
    getTrackId: (ctx)=>ctx.ids?.track ?? `slider:${ctx.id}:track`,
    getRangeId: (ctx)=>ctx.ids?.range ?? `slider:${ctx.id}:range`,
    getLabelId: (ctx)=>ctx.ids?.label ?? `slider:${ctx.id}:label`,
    getValueTextId: (ctx)=>ctx.ids?.valueText ?? `slider:${ctx.id}:value-text`,
    getMarkerId: (ctx, value)=>ctx.ids?.marker?.(value) ?? `slider:${ctx.id}:marker:${value}`,
    getRootEl: (ctx)=>$45d0679faae7ef05$var$dom.getById(ctx, $45d0679faae7ef05$var$dom.getRootId(ctx)),
    getThumbEl: (ctx, index)=>$45d0679faae7ef05$var$dom.getById(ctx, $45d0679faae7ef05$var$dom.getThumbId(ctx, index)),
    getHiddenInputEl: (ctx, index)=>$45d0679faae7ef05$var$dom.getById(ctx, $45d0679faae7ef05$var$dom.getHiddenInputId(ctx, index)),
    getControlEl: (ctx)=>$45d0679faae7ef05$var$dom.getById(ctx, $45d0679faae7ef05$var$dom.getControlId(ctx)),
    getElements: (ctx)=>(0, $b06ec5ff205338e5$export$dcd0d083aa86c355)($45d0679faae7ef05$var$dom.getControlEl(ctx), "[role=slider]"),
    getFirstEl: (ctx)=>$45d0679faae7ef05$var$dom.getElements(ctx)[0],
    getRangeEl: (ctx)=>$45d0679faae7ef05$var$dom.getById(ctx, $45d0679faae7ef05$var$dom.getRangeId(ctx)),
    getValueFromPoint (ctx, point) {
        const controlEl = $45d0679faae7ef05$var$dom.getControlEl(ctx);
        if (!controlEl) return;
        const relativePoint = (0, $b06ec5ff205338e5$export$b5a2724f2c73e602)(point, controlEl);
        const percent = relativePoint.getPercentValue({
            orientation: ctx.orientation,
            dir: ctx.dir,
            inverted: {
                y: true
            }
        });
        return (0, $89352e0ddd72597a$export$476354dbf49bdff6)(percent, ctx.min, ctx.max, ctx.step);
    },
    dispatchChangeEvent (ctx) {
        const valueArray = Array.from(ctx.value);
        valueArray.forEach((value, index)=>{
            const inputEl = $45d0679faae7ef05$var$dom.getHiddenInputEl(ctx, index);
            if (!inputEl) return;
            (0, $b06ec5ff205338e5$export$71608d92f9cda884)(inputEl, {
                value: value
            });
        });
    }
});
function $45d0679faae7ef05$var$normalizeValues(ctx, nextValues) {
    return nextValues.map((value, index, values)=>{
        return $45d0679faae7ef05$var$constrainValue({
            ...ctx,
            value: values
        }, value, index);
    });
}
function $45d0679faae7ef05$var$getRangeAtIndex(ctx, index) {
    return (0, $89352e0ddd72597a$export$bf5bf18fe4d721e6)(ctx.value, ctx.min, ctx.max, ctx.minStepsBetweenThumbs)[index];
}
function $45d0679faae7ef05$var$constrainValue(ctx, value, index) {
    const range = $45d0679faae7ef05$var$getRangeAtIndex(ctx, index);
    const snapValue = (0, $89352e0ddd72597a$export$cb6e0bb50bc19463)(value, ctx.min, ctx.max, ctx.step);
    return (0, $89352e0ddd72597a$export$31ee16100cde6ce2)(snapValue, range.min, range.max);
}
function $45d0679faae7ef05$var$decrement(ctx, index, step) {
    const idx = index ?? ctx.focusedIndex;
    const range = $45d0679faae7ef05$var$getRangeAtIndex(ctx, idx);
    const nextValues = (0, $89352e0ddd72597a$export$afee86354f7f91ab)(idx, {
        ...range,
        step: step ?? ctx.step,
        values: ctx.value
    });
    nextValues[idx] = (0, $89352e0ddd72597a$export$31ee16100cde6ce2)(nextValues[idx], range.min, range.max);
    return nextValues;
}
function $45d0679faae7ef05$var$increment(ctx, index, step) {
    const idx = index ?? ctx.focusedIndex;
    const range = $45d0679faae7ef05$var$getRangeAtIndex(ctx, idx);
    const nextValues = (0, $89352e0ddd72597a$export$883adeea0e999db3)(idx, {
        ...range,
        step: step ?? ctx.step,
        values: ctx.value
    });
    nextValues[idx] = (0, $89352e0ddd72597a$export$31ee16100cde6ce2)(nextValues[idx], range.min, range.max);
    return nextValues;
}
function $45d0679faae7ef05$var$getClosestIndex(ctx, pointValue) {
    return (0, $89352e0ddd72597a$export$70ddabd6efec4c0a)(ctx.value, pointValue);
}
function $45d0679faae7ef05$var$assignArray(current, next) {
    for(let i = 0; i < next.length; i++){
        const value = next[i];
        current[i] = value;
    }
}
// src/slider.connect.ts
function $45d0679faae7ef05$export$64605811ab45167f(state, send, normalize) {
    const ariaLabel = state.context["aria-label"];
    const ariaLabelledBy = state.context["aria-labelledby"];
    const sliderValue = state.context.value;
    const focused = state.matches("focus");
    const dragging = state.matches("dragging");
    const disabled = state.context.isDisabled;
    const invalid = state.context.invalid;
    const interactive = state.context.isInteractive;
    const isHorizontal = state.context.orientation === "horizontal";
    const isVertical = state.context.orientation === "vertical";
    function getValuePercentFn(value) {
        return (0, $89352e0ddd72597a$export$22574034cd380c24)(value, state.context.min, state.context.max);
    }
    function getPercentValueFn(percent) {
        return (0, $89352e0ddd72597a$export$476354dbf49bdff6)(percent, state.context.min, state.context.max, state.context.step);
    }
    return {
        value: state.context.value,
        dragging: dragging,
        focused: focused,
        setValue (value) {
            send({
                type: "SET_VALUE",
                value: value
            });
        },
        getThumbValue (index) {
            return sliderValue[index];
        },
        setThumbValue (index, value) {
            send({
                type: "SET_VALUE",
                index: index,
                value: value
            });
        },
        getValuePercent: getValuePercentFn,
        getPercentValue: getPercentValueFn,
        getThumbPercent (index) {
            return getValuePercentFn(sliderValue[index]);
        },
        setThumbPercent (index, percent) {
            const value = getPercentValueFn(percent);
            send({
                type: "SET_VALUE",
                index: index,
                value: value
            });
        },
        getThumbMin (index) {
            return $45d0679faae7ef05$var$getRangeAtIndex(state.context, index).min;
        },
        getThumbMax (index) {
            return $45d0679faae7ef05$var$getRangeAtIndex(state.context, index).max;
        },
        increment (index) {
            send({
                type: "INCREMENT",
                index: index
            });
        },
        decrement (index) {
            send({
                type: "DECREMENT",
                index: index
            });
        },
        focus () {
            if (!interactive) return;
            send({
                type: "FOCUS",
                index: 0
            });
        },
        getLabelProps () {
            return normalize.label({
                ...$45d0679faae7ef05$var$parts.label.attrs,
                dir: state.context.dir,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-orientation": state.context.orientation,
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(invalid),
                "data-dragging": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(dragging),
                "data-focus": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(focused),
                id: $45d0679faae7ef05$var$dom.getLabelId(state.context),
                htmlFor: $45d0679faae7ef05$var$dom.getHiddenInputId(state.context, 0),
                onClick (event) {
                    if (!interactive) return;
                    event.preventDefault();
                    $45d0679faae7ef05$var$dom.getFirstEl(state.context)?.focus();
                },
                style: {
                    userSelect: "none",
                    WebkitUserSelect: "none"
                }
            });
        },
        getRootProps () {
            return normalize.element({
                ...$45d0679faae7ef05$var$parts.root.attrs,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-orientation": state.context.orientation,
                "data-dragging": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(dragging),
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(invalid),
                "data-focus": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(focused),
                id: $45d0679faae7ef05$var$dom.getRootId(state.context),
                dir: state.context.dir,
                style: $45d0679faae7ef05$var$dom.getRootStyle(state.context)
            });
        },
        getValueTextProps () {
            return normalize.element({
                ...$45d0679faae7ef05$var$parts.valueText.attrs,
                dir: state.context.dir,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-orientation": state.context.orientation,
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(invalid),
                "data-focus": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(focused),
                id: $45d0679faae7ef05$var$dom.getValueTextId(state.context)
            });
        },
        getTrackProps () {
            return normalize.element({
                ...$45d0679faae7ef05$var$parts.track.attrs,
                dir: state.context.dir,
                id: $45d0679faae7ef05$var$dom.getTrackId(state.context),
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(invalid),
                "data-dragging": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(dragging),
                "data-orientation": state.context.orientation,
                "data-focus": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(focused),
                style: {
                    position: "relative"
                }
            });
        },
        getThumbProps (props2) {
            const { index: index = 0, name: name } = props2;
            const value = sliderValue[index];
            const range = $45d0679faae7ef05$var$getRangeAtIndex(state.context, index);
            const valueText = state.context.getAriaValueText?.({
                value: value,
                index: index
            });
            const _ariaLabel = Array.isArray(ariaLabel) ? ariaLabel[index] : ariaLabel;
            const _ariaLabelledBy = Array.isArray(ariaLabelledBy) ? ariaLabelledBy[index] : ariaLabelledBy;
            return normalize.element({
                ...$45d0679faae7ef05$var$parts.thumb.attrs,
                dir: state.context.dir,
                "data-index": index,
                "data-name": name,
                id: $45d0679faae7ef05$var$dom.getThumbId(state.context, index),
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-orientation": state.context.orientation,
                "data-focus": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(focused && state.context.focusedIndex === index),
                "data-dragging": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(dragging && state.context.focusedIndex === index),
                draggable: false,
                "aria-disabled": (0, $b06ec5ff205338e5$export$91a6105db3d4be7b)(disabled),
                "aria-label": _ariaLabel,
                "aria-labelledby": _ariaLabelledBy ?? $45d0679faae7ef05$var$dom.getLabelId(state.context),
                "aria-orientation": state.context.orientation,
                "aria-valuemax": range.max,
                "aria-valuemin": range.min,
                "aria-valuenow": sliderValue[index],
                "aria-valuetext": valueText,
                role: "slider",
                tabIndex: disabled ? void 0 : 0,
                style: $45d0679faae7ef05$var$dom.getThumbStyle(state.context, index),
                onPointerDown (event) {
                    if (!interactive) return;
                    send({
                        type: "THUMB_POINTER_DOWN",
                        index: index
                    });
                    event.stopPropagation();
                },
                onBlur () {
                    if (!interactive) return;
                    send("BLUR");
                },
                onFocus () {
                    if (!interactive) return;
                    send({
                        type: "FOCUS",
                        index: index
                    });
                },
                onKeyDown (event) {
                    if (event.defaultPrevented) return;
                    if (!interactive) return;
                    const step = (0, $b06ec5ff205338e5$export$587b7b5379932dd6)(event) * state.context.step;
                    const keyMap = {
                        ArrowUp () {
                            if (isHorizontal) return;
                            send({
                                type: "ARROW_INC",
                                step: step,
                                src: "ArrowUp"
                            });
                        },
                        ArrowDown () {
                            if (isHorizontal) return;
                            send({
                                type: "ARROW_DEC",
                                step: step,
                                src: "ArrowDown"
                            });
                        },
                        ArrowLeft () {
                            if (isVertical) return;
                            send({
                                type: "ARROW_DEC",
                                step: step,
                                src: "ArrowLeft"
                            });
                        },
                        ArrowRight () {
                            if (isVertical) return;
                            send({
                                type: "ARROW_INC",
                                step: step,
                                src: "ArrowRight"
                            });
                        },
                        PageUp () {
                            send({
                                type: "ARROW_INC",
                                step: step,
                                src: "PageUp"
                            });
                        },
                        PageDown () {
                            send({
                                type: "ARROW_DEC",
                                step: step,
                                src: "PageDown"
                            });
                        },
                        Home () {
                            send("HOME");
                        },
                        End () {
                            send("END");
                        }
                    };
                    const key = (0, $b06ec5ff205338e5$export$f7a7490116b79d4d)(event, state.context);
                    const exec = keyMap[key];
                    if (exec) {
                        exec(event);
                        event.preventDefault();
                        event.stopPropagation();
                    }
                }
            });
        },
        getHiddenInputProps (props2) {
            const { index: index = 0, name: name } = props2;
            return normalize.input({
                name: name ?? (state.context.name ? state.context.name + (state.context.value.length > 1 ? "[]" : "") : void 0),
                form: state.context.form,
                type: "text",
                hidden: true,
                defaultValue: state.context.value[index],
                id: $45d0679faae7ef05$var$dom.getHiddenInputId(state.context, index)
            });
        },
        getRangeProps () {
            return normalize.element({
                id: $45d0679faae7ef05$var$dom.getRangeId(state.context),
                ...$45d0679faae7ef05$var$parts.range.attrs,
                dir: state.context.dir,
                "data-dragging": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(dragging),
                "data-focus": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(focused),
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(invalid),
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-orientation": state.context.orientation,
                style: $45d0679faae7ef05$var$dom.getRangeStyle(state.context)
            });
        },
        getControlProps () {
            return normalize.element({
                ...$45d0679faae7ef05$var$parts.control.attrs,
                dir: state.context.dir,
                id: $45d0679faae7ef05$var$dom.getControlId(state.context),
                "data-dragging": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(dragging),
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-orientation": state.context.orientation,
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(invalid),
                "data-focus": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(focused),
                style: $45d0679faae7ef05$var$dom.getControlStyle(),
                onPointerDown (event) {
                    if (!interactive) return;
                    if (!(0, $b06ec5ff205338e5$export$698c4f0ff5e11e52)(event)) return;
                    if ((0, $b06ec5ff205338e5$export$90788ad2c69b4f50)(event)) return;
                    const point = (0, $b06ec5ff205338e5$export$a8637644cbd23a7b)(event);
                    send({
                        type: "POINTER_DOWN",
                        point: point
                    });
                    event.preventDefault();
                    event.stopPropagation();
                }
            });
        },
        getMarkerGroupProps () {
            return normalize.element({
                ...$45d0679faae7ef05$var$parts.markerGroup.attrs,
                role: "presentation",
                dir: state.context.dir,
                "aria-hidden": true,
                "data-orientation": state.context.orientation,
                style: $45d0679faae7ef05$var$dom.getMarkerGroupStyle()
            });
        },
        getMarkerProps (props2) {
            const style = $45d0679faae7ef05$var$dom.getMarkerStyle(state.context, props2.value);
            let markerState;
            const first = state.context.value[0];
            const last = state.context.value[state.context.value.length - 1];
            if (props2.value < first) markerState = "under-value";
            else if (props2.value > last) markerState = "over-value";
            else markerState = "at-value";
            return normalize.element({
                ...$45d0679faae7ef05$var$parts.marker.attrs,
                id: $45d0679faae7ef05$var$dom.getMarkerId(state.context, props2.value),
                role: "presentation",
                dir: state.context.dir,
                "data-orientation": state.context.orientation,
                "data-value": props2.value,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-state": markerState,
                style: style
            });
        },
        getDraggingIndicatorProps (props2) {
            const { index: index = 0 } = props2;
            const isDragging = index === state.context.focusedIndex && dragging;
            return normalize.element({
                ...$45d0679faae7ef05$var$parts.draggingIndicator.attrs,
                role: "presentation",
                dir: state.context.dir,
                hidden: !isDragging,
                "data-orientation": state.context.orientation,
                "data-state": isDragging ? "open" : "closed",
                style: $45d0679faae7ef05$var$dom.getThumbStyle(state.context, index)
            });
        }
    };
}
var $45d0679faae7ef05$var$isEqualSize = (a, b)=>{
    return a?.width === b?.width && a?.height === b?.height;
};
function $45d0679faae7ef05$export$ea56d40cd27c3480(userContext) {
    const ctx = (0, $89352e0ddd72597a$export$8e16b83750b44988)(userContext);
    return (0, $5c0da97e9c7aa95f$export$aaa7fa18f8e9b2e8)({
        id: "slider",
        initial: "idle",
        context: {
            thumbSize: null,
            thumbAlignment: "contain",
            min: 0,
            max: 100,
            step: 1,
            value: [
                0
            ],
            origin: "start",
            orientation: "horizontal",
            dir: "ltr",
            minStepsBetweenThumbs: 0,
            disabled: false,
            readOnly: false,
            ...ctx,
            focusedIndex: -1,
            fieldsetDisabled: false
        },
        computed: {
            isHorizontal: (ctx2)=>ctx2.orientation === "horizontal",
            isVertical: (ctx2)=>ctx2.orientation === "vertical",
            isRtl: (ctx2)=>ctx2.orientation === "horizontal" && ctx2.dir === "rtl",
            isDisabled: (ctx2)=>!!ctx2.disabled || ctx2.fieldsetDisabled,
            isInteractive: (ctx2)=>!(ctx2.readOnly || ctx2.isDisabled),
            hasMeasuredThumbSize: (ctx2)=>ctx2.thumbSize != null,
            valuePercent (ctx2) {
                return ctx2.value.map((value)=>100 * (0, $89352e0ddd72597a$export$22574034cd380c24)(value, ctx2.min, ctx2.max));
            }
        },
        watch: {
            value: [
                "syncInputElements"
            ]
        },
        entry: [
            "coarseValue"
        ],
        activities: [
            "trackFormControlState",
            "trackThumbsSize"
        ],
        on: {
            SET_VALUE: [
                {
                    guard: "hasIndex",
                    actions: "setValueAtIndex"
                },
                {
                    actions: "setValue"
                }
            ],
            INCREMENT: {
                actions: "incrementThumbAtIndex"
            },
            DECREMENT: {
                actions: "decrementThumbAtIndex"
            }
        },
        states: {
            idle: {
                on: {
                    POINTER_DOWN: {
                        target: "dragging",
                        actions: [
                            "setClosestThumbIndex",
                            "setPointerValue",
                            "focusActiveThumb"
                        ]
                    },
                    FOCUS: {
                        target: "focus",
                        actions: "setFocusedIndex"
                    },
                    THUMB_POINTER_DOWN: {
                        target: "dragging",
                        actions: [
                            "setFocusedIndex",
                            "focusActiveThumb"
                        ]
                    }
                }
            },
            focus: {
                entry: "focusActiveThumb",
                on: {
                    POINTER_DOWN: {
                        target: "dragging",
                        actions: [
                            "setClosestThumbIndex",
                            "setPointerValue",
                            "focusActiveThumb"
                        ]
                    },
                    THUMB_POINTER_DOWN: {
                        target: "dragging",
                        actions: [
                            "setFocusedIndex",
                            "focusActiveThumb"
                        ]
                    },
                    ARROW_DEC: {
                        actions: [
                            "decrementThumbAtIndex",
                            "invokeOnChangeEnd"
                        ]
                    },
                    ARROW_INC: {
                        actions: [
                            "incrementThumbAtIndex",
                            "invokeOnChangeEnd"
                        ]
                    },
                    HOME: {
                        actions: [
                            "setFocusedThumbToMin",
                            "invokeOnChangeEnd"
                        ]
                    },
                    END: {
                        actions: [
                            "setFocusedThumbToMax",
                            "invokeOnChangeEnd"
                        ]
                    },
                    BLUR: {
                        target: "idle",
                        actions: "clearFocusedIndex"
                    }
                }
            },
            dragging: {
                entry: "focusActiveThumb",
                activities: "trackPointerMove",
                on: {
                    POINTER_UP: {
                        target: "focus",
                        actions: "invokeOnChangeEnd"
                    },
                    POINTER_MOVE: {
                        actions: "setPointerValue"
                    }
                }
            }
        }
    }, {
        guards: {
            hasIndex: (_ctx, evt)=>evt.index != null
        },
        activities: {
            trackFormControlState (ctx2, _evt, { initialContext: initialContext }) {
                return (0, $b06ec5ff205338e5$export$a48469c7b6beba26)($45d0679faae7ef05$var$dom.getRootEl(ctx2), {
                    onFieldsetDisabledChange (disabled) {
                        ctx2.fieldsetDisabled = disabled;
                    },
                    onFormReset () {
                        $45d0679faae7ef05$var$set.value(ctx2, initialContext.value);
                    }
                });
            },
            trackPointerMove (ctx2, _evt, { send: send }) {
                return (0, $b06ec5ff205338e5$export$71f75065f080cb5b)($45d0679faae7ef05$var$dom.getDoc(ctx2), {
                    onPointerMove (info) {
                        send({
                            type: "POINTER_MOVE",
                            point: info.point
                        });
                    },
                    onPointerUp () {
                        send("POINTER_UP");
                    }
                });
            },
            trackThumbsSize (ctx2) {
                if (ctx2.thumbAlignment !== "contain" || ctx2.thumbSize) return;
                return (0, $1ba8ee7ba4c5cd14$export$2887fd71b1bf2cdb)({
                    getNodes: ()=>$45d0679faae7ef05$var$dom.getElements(ctx2),
                    observeMutation: true,
                    callback (size) {
                        if (!size || $45d0679faae7ef05$var$isEqualSize(ctx2.thumbSize, size)) return;
                        ctx2.thumbSize = size;
                    }
                });
            }
        },
        actions: {
            syncInputElements (ctx2) {
                ctx2.value.forEach((value, index)=>{
                    const inputEl = $45d0679faae7ef05$var$dom.getHiddenInputEl(ctx2, index);
                    $45d0679faae7ef05$var$dom.setValue(inputEl, value);
                });
            },
            invokeOnChangeEnd (ctx2) {
                $45d0679faae7ef05$var$invoke.valueChangeEnd(ctx2);
            },
            setClosestThumbIndex (ctx2, evt) {
                const pointValue = $45d0679faae7ef05$var$dom.getValueFromPoint(ctx2, evt.point);
                if (pointValue == null) return;
                const focusedIndex = $45d0679faae7ef05$var$getClosestIndex(ctx2, pointValue);
                $45d0679faae7ef05$var$set.focusedIndex(ctx2, focusedIndex);
            },
            setFocusedIndex (ctx2, evt) {
                $45d0679faae7ef05$var$set.focusedIndex(ctx2, evt.index);
            },
            clearFocusedIndex (ctx2) {
                $45d0679faae7ef05$var$set.focusedIndex(ctx2, -1);
            },
            setPointerValue (ctx2, evt) {
                const pointerValue = $45d0679faae7ef05$var$dom.getValueFromPoint(ctx2, evt.point);
                if (pointerValue == null) return;
                const value = $45d0679faae7ef05$var$constrainValue(ctx2, pointerValue, ctx2.focusedIndex);
                $45d0679faae7ef05$var$set.valueAtIndex(ctx2, ctx2.focusedIndex, value);
            },
            focusActiveThumb (ctx2) {
                (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>{
                    const thumbEl = $45d0679faae7ef05$var$dom.getThumbEl(ctx2, ctx2.focusedIndex);
                    thumbEl?.focus({
                        preventScroll: true
                    });
                });
            },
            decrementThumbAtIndex (ctx2, evt) {
                const value = $45d0679faae7ef05$var$decrement(ctx2, evt.index, evt.step);
                $45d0679faae7ef05$var$set.value(ctx2, value);
            },
            incrementThumbAtIndex (ctx2, evt) {
                const value = $45d0679faae7ef05$var$increment(ctx2, evt.index, evt.step);
                $45d0679faae7ef05$var$set.value(ctx2, value);
            },
            setFocusedThumbToMin (ctx2) {
                const { min: min } = $45d0679faae7ef05$var$getRangeAtIndex(ctx2, ctx2.focusedIndex);
                $45d0679faae7ef05$var$set.valueAtIndex(ctx2, ctx2.focusedIndex, min);
            },
            setFocusedThumbToMax (ctx2) {
                const { max: max } = $45d0679faae7ef05$var$getRangeAtIndex(ctx2, ctx2.focusedIndex);
                $45d0679faae7ef05$var$set.valueAtIndex(ctx2, ctx2.focusedIndex, max);
            },
            coarseValue (ctx2) {
                const value = $45d0679faae7ef05$var$normalizeValues(ctx2, ctx2.value);
                $45d0679faae7ef05$var$set.value(ctx2, value);
            },
            setValueAtIndex (ctx2, evt) {
                const value = $45d0679faae7ef05$var$constrainValue(ctx2, evt.value, evt.index);
                $45d0679faae7ef05$var$set.valueAtIndex(ctx2, evt.index, value);
            },
            setValue (ctx2, evt) {
                const value = $45d0679faae7ef05$var$normalizeValues(ctx2, evt.value);
                $45d0679faae7ef05$var$set.value(ctx2, value);
            }
        }
    });
}
var $45d0679faae7ef05$var$invoke = {
    valueChange (ctx) {
        ctx.onValueChange?.({
            value: Array.from(ctx.value)
        });
        $45d0679faae7ef05$var$dom.dispatchChangeEvent(ctx);
    },
    valueChangeEnd (ctx) {
        ctx.onValueChangeEnd?.({
            value: Array.from(ctx.value)
        });
    },
    focusChange (ctx) {
        ctx.onFocusChange?.({
            value: Array.from(ctx.value),
            focusedIndex: ctx.focusedIndex
        });
    }
};
var $45d0679faae7ef05$var$set = {
    valueAtIndex: (ctx, index, value)=>{
        if ((0, $89352e0ddd72597a$export$248d38f6296296c5)(ctx.value[index], value)) return;
        ctx.value[index] = value;
        $45d0679faae7ef05$var$invoke.valueChange(ctx);
    },
    value: (ctx, value)=>{
        if ((0, $89352e0ddd72597a$export$248d38f6296296c5)(ctx.value, value)) return;
        $45d0679faae7ef05$var$assignArray(ctx.value, value);
        $45d0679faae7ef05$var$invoke.valueChange(ctx);
    },
    focusedIndex: (ctx, index)=>{
        if ((0, $89352e0ddd72597a$export$248d38f6296296c5)(ctx.focusedIndex, index)) return;
        ctx.focusedIndex = index;
        $45d0679faae7ef05$var$invoke.focusChange(ctx);
    }
};
var $45d0679faae7ef05$export$8128bb6492cf3de7 = (0, $5b359805fda5a40e$export$c94ea207b45fef3a)()([
    "aria-label",
    "aria-labelledby",
    "dir",
    "disabled",
    "form",
    "getAriaValueText",
    "getRootNode",
    "id",
    "ids",
    "invalid",
    "max",
    "min",
    "minStepsBetweenThumbs",
    "name",
    "onFocusChange",
    "onValueChange",
    "onValueChangeEnd",
    "orientation",
    "origin",
    "readOnly",
    "step",
    "thumbAlignment",
    "thumbAlignment",
    "thumbSize",
    "value"
]);
var $45d0679faae7ef05$export$45029c61b0073d87 = (0, $89352e0ddd72597a$export$3ea53b214fbc1986)($45d0679faae7ef05$export$8128bb6492cf3de7);
var $45d0679faae7ef05$export$40d185912cb53f57 = (0, $5b359805fda5a40e$export$c94ea207b45fef3a)()([
    "index",
    "name"
]);
var $45d0679faae7ef05$export$2e0a74520b077bd6 = (0, $89352e0ddd72597a$export$3ea53b214fbc1986)($45d0679faae7ef05$export$40d185912cb53f57);








// src/switch.anatomy.ts
var $208a3ddd1226e21a$export$477202748c7242bf = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("switch").parts("root", "label", "control", "thumb");
var $208a3ddd1226e21a$var$parts = $208a3ddd1226e21a$export$477202748c7242bf.build();
var $208a3ddd1226e21a$var$dom = (0, $b06ec5ff205338e5$export$41a9651decfe2bde)({
    getRootId: (ctx)=>ctx.ids?.root ?? `switch:${ctx.id}`,
    getLabelId: (ctx)=>ctx.ids?.label ?? `switch:${ctx.id}:label`,
    getThumbId: (ctx)=>ctx.ids?.thumb ?? `switch:${ctx.id}:thumb`,
    getControlId: (ctx)=>ctx.ids?.control ?? `switch:${ctx.id}:control`,
    getHiddenInputId: (ctx)=>ctx.ids?.hiddenInput ?? `switch:${ctx.id}:input`,
    getRootEl: (ctx)=>$208a3ddd1226e21a$var$dom.getById(ctx, $208a3ddd1226e21a$var$dom.getRootId(ctx)),
    getHiddenInputEl: (ctx)=>$208a3ddd1226e21a$var$dom.getById(ctx, $208a3ddd1226e21a$var$dom.getHiddenInputId(ctx))
});
// src/switch.connect.ts
function $208a3ddd1226e21a$export$64605811ab45167f(state, send, normalize) {
    const disabled = state.context.isDisabled;
    const readOnly = state.context.readOnly;
    const checked = state.context.checked;
    const focused = !disabled && state.context.focused;
    const focusVisible = !disabled && state.context.focusVisible;
    const dataAttrs = {
        "data-active": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.active),
        "data-focus": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(focused),
        "data-focus-visible": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(focusVisible),
        "data-readonly": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(readOnly),
        "data-hover": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.hovered),
        "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
        "data-state": state.context.checked ? "checked" : "unchecked",
        "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.invalid)
    };
    return {
        checked: checked,
        disabled: disabled,
        focused: focused,
        setChecked (checked2) {
            send({
                type: "CHECKED.SET",
                checked: checked2,
                isTrusted: false
            });
        },
        toggleChecked () {
            send({
                type: "CHECKED.TOGGLE",
                checked: checked,
                isTrusted: false
            });
        },
        getRootProps () {
            return normalize.label({
                ...$208a3ddd1226e21a$var$parts.root.attrs,
                ...dataAttrs,
                dir: state.context.dir,
                id: $208a3ddd1226e21a$var$dom.getRootId(state.context),
                htmlFor: $208a3ddd1226e21a$var$dom.getHiddenInputId(state.context),
                onPointerMove () {
                    if (disabled) return;
                    send({
                        type: "CONTEXT.SET",
                        context: {
                            hovered: true
                        }
                    });
                },
                onPointerLeave () {
                    if (disabled) return;
                    send({
                        type: "CONTEXT.SET",
                        context: {
                            hovered: false
                        }
                    });
                },
                onClick (event) {
                    if (disabled) return;
                    const target = (0, $b06ec5ff205338e5$export$e58f029f0fbfdb29)(event);
                    if (target === $208a3ddd1226e21a$var$dom.getHiddenInputEl(state.context)) event.stopPropagation();
                }
            });
        },
        getLabelProps () {
            return normalize.element({
                ...$208a3ddd1226e21a$var$parts.label.attrs,
                ...dataAttrs,
                dir: state.context.dir,
                id: $208a3ddd1226e21a$var$dom.getLabelId(state.context)
            });
        },
        getThumbProps () {
            return normalize.element({
                ...$208a3ddd1226e21a$var$parts.thumb.attrs,
                ...dataAttrs,
                dir: state.context.dir,
                id: $208a3ddd1226e21a$var$dom.getThumbId(state.context),
                "aria-hidden": true
            });
        },
        getControlProps () {
            return normalize.element({
                ...$208a3ddd1226e21a$var$parts.control.attrs,
                ...dataAttrs,
                dir: state.context.dir,
                id: $208a3ddd1226e21a$var$dom.getControlId(state.context),
                "aria-hidden": true
            });
        },
        getHiddenInputProps () {
            return normalize.input({
                id: $208a3ddd1226e21a$var$dom.getHiddenInputId(state.context),
                type: "checkbox",
                required: state.context.required,
                defaultChecked: checked,
                disabled: disabled,
                "aria-labelledby": $208a3ddd1226e21a$var$dom.getLabelId(state.context),
                "aria-invalid": state.context.invalid,
                name: state.context.name,
                form: state.context.form,
                value: state.context.value,
                style: (0, $b06ec5ff205338e5$export$8fecac46448b5689),
                onFocus () {
                    const focusVisible2 = (0, $10f5b85675c7b32e$export$b9b3dfddab17db27)();
                    send({
                        type: "CONTEXT.SET",
                        context: {
                            focused: true,
                            focusVisible: focusVisible2
                        }
                    });
                },
                onBlur () {
                    send({
                        type: "CONTEXT.SET",
                        context: {
                            focused: false,
                            focusVisible: false
                        }
                    });
                },
                onClick (event) {
                    if (readOnly) {
                        event.preventDefault();
                        return;
                    }
                    const checked2 = event.currentTarget.checked;
                    send({
                        type: "CHECKED.SET",
                        checked: checked2,
                        isTrusted: true
                    });
                }
            });
        }
    };
}
var { not: $208a3ddd1226e21a$var$not } = (0, $5c0da97e9c7aa95f$export$f3249297f3edf7e9);
function $208a3ddd1226e21a$export$ea56d40cd27c3480(userContext) {
    const ctx = (0, $89352e0ddd72597a$export$8e16b83750b44988)(userContext);
    return (0, $5c0da97e9c7aa95f$export$aaa7fa18f8e9b2e8)({
        id: "switch",
        initial: "ready",
        context: {
            checked: false,
            label: "switch",
            value: "on",
            disabled: false,
            ...ctx,
            fieldsetDisabled: false,
            focusVisible: false
        },
        computed: {
            isDisabled: (ctx2)=>ctx2.disabled || ctx2.fieldsetDisabled
        },
        watch: {
            disabled: "removeFocusIfNeeded",
            checked: "syncInputElement"
        },
        activities: [
            "trackFormControlState",
            "trackPressEvent",
            "trackFocusVisible"
        ],
        on: {
            "CHECKED.TOGGLE": [
                {
                    guard: $208a3ddd1226e21a$var$not("isTrusted"),
                    actions: [
                        "toggleChecked",
                        "dispatchChangeEvent"
                    ]
                },
                {
                    actions: [
                        "toggleChecked"
                    ]
                }
            ],
            "CHECKED.SET": [
                {
                    guard: $208a3ddd1226e21a$var$not("isTrusted"),
                    actions: [
                        "setChecked",
                        "dispatchChangeEvent"
                    ]
                },
                {
                    actions: [
                        "setChecked"
                    ]
                }
            ],
            "CONTEXT.SET": {
                actions: [
                    "setContext"
                ]
            }
        },
        states: {
            ready: {}
        }
    }, {
        guards: {
            isTrusted: (_ctx, evt)=>!!evt.isTrusted
        },
        activities: {
            trackPressEvent (ctx2) {
                if (ctx2.isDisabled) return;
                return (0, $b06ec5ff205338e5$export$9a7215eeb3481da)({
                    pointerNode: $208a3ddd1226e21a$var$dom.getRootEl(ctx2),
                    keyboardNode: $208a3ddd1226e21a$var$dom.getHiddenInputEl(ctx2),
                    isValidKey: (event)=>event.key === " ",
                    onPress: ()=>ctx2.active = false,
                    onPressStart: ()=>ctx2.active = true,
                    onPressEnd: ()=>ctx2.active = false
                });
            },
            trackFocusVisible (ctx2) {
                if (ctx2.isDisabled) return;
                return (0, $10f5b85675c7b32e$export$920b4983565c6f4d)({
                    root: $208a3ddd1226e21a$var$dom.getRootNode(ctx2)
                });
            },
            trackFormControlState (ctx2, _evt, { send: send, initialContext: initialContext }) {
                return (0, $b06ec5ff205338e5$export$a48469c7b6beba26)($208a3ddd1226e21a$var$dom.getHiddenInputEl(ctx2), {
                    onFieldsetDisabledChange (disabled) {
                        ctx2.fieldsetDisabled = disabled;
                    },
                    onFormReset () {
                        send({
                            type: "CHECKED.SET",
                            checked: !!initialContext.checked,
                            src: "form-reset"
                        });
                    }
                });
            }
        },
        actions: {
            setContext (ctx2, evt) {
                Object.assign(ctx2, evt.context);
            },
            syncInputElement (ctx2) {
                const inputEl = $208a3ddd1226e21a$var$dom.getHiddenInputEl(ctx2);
                if (!inputEl) return;
                inputEl.checked = !!ctx2.checked;
            },
            removeFocusIfNeeded (ctx2) {
                if (ctx2.disabled && ctx2.focused) ctx2.focused = false;
            },
            setChecked (ctx2, evt) {
                $208a3ddd1226e21a$var$set.checked(ctx2, evt.checked);
            },
            toggleChecked (ctx2, _evt) {
                $208a3ddd1226e21a$var$set.checked(ctx2, !ctx2.checked);
            },
            dispatchChangeEvent (ctx2) {
                const inputEl = $208a3ddd1226e21a$var$dom.getHiddenInputEl(ctx2);
                (0, $b06ec5ff205338e5$export$ebab7723673c874f)(inputEl, {
                    checked: ctx2.checked
                });
            }
        }
    });
}
var $208a3ddd1226e21a$var$invoke = {
    change: (ctx)=>{
        ctx.onCheckedChange?.({
            checked: ctx.checked
        });
    }
};
var $208a3ddd1226e21a$var$set = {
    checked: (ctx, checked)=>{
        if ((0, $89352e0ddd72597a$export$248d38f6296296c5)(ctx.checked, checked)) return;
        ctx.checked = checked;
        $208a3ddd1226e21a$var$invoke.change(ctx);
    }
};
var $208a3ddd1226e21a$export$8128bb6492cf3de7 = (0, $5b359805fda5a40e$export$c94ea207b45fef3a)()([
    "checked",
    "dir",
    "disabled",
    "form",
    "getRootNode",
    "id",
    "ids",
    "invalid",
    "label",
    "name",
    "onCheckedChange",
    "readOnly",
    "required",
    "value"
]);
var $208a3ddd1226e21a$export$45029c61b0073d87 = (0, $89352e0ddd72597a$export$3ea53b214fbc1986)($208a3ddd1226e21a$export$8128bb6492cf3de7);













"use strict";
const $9b7764ce1529e5da$export$377a77e99e7c73a5 = (0, $ee305cd0ec3a86c0$export$477202748c7242bf).extendWith("itemBody");
const $9b7764ce1529e5da$export$7dd5043f89c4709c = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("action-bar").parts("positioner", "content", "separator", "selectionTrigger", "closeTrigger");
const $9b7764ce1529e5da$export$fc51889fa4de265a = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("alert").parts("title", "description", "root", "indicator", "content");
const $9b7764ce1529e5da$export$2fb03f744a6ecf93 = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("breadcrumb").parts("link", "currentLink", "item", "list", "root", "ellipsis", "separator");
const $9b7764ce1529e5da$export$50ffc6bb83cc6686 = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("blockquote").parts("root", "icon", "content", "caption");
const $9b7764ce1529e5da$export$487a447ffa5755b6 = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("card").parts("root", "header", "body", "footer", "title", "description");
const $9b7764ce1529e5da$export$e4581dd169704619 = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("checkbox-card", [
    "root",
    "control",
    "label",
    "description",
    "addon",
    "indicator",
    "content"
]);
const $9b7764ce1529e5da$export$a5a7982d185494cc = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("data-list").parts("root", "item", "itemLabel", "itemValue");
const $9b7764ce1529e5da$export$c438f40c25a9407b = (0, $836c8b81cf0cf8be$export$477202748c7242bf).extendWith("header", "body", "footer", "backdrop");
const $9b7764ce1529e5da$export$d3f4aaa4b0f2907a = (0, $836c8b81cf0cf8be$export$477202748c7242bf).extendWith("header", "body", "footer", "backdrop");
const $9b7764ce1529e5da$export$2813c9511eeab082 = (0, $9cfeac3ec88442fd$export$477202748c7242bf).extendWith("textarea");
const $9b7764ce1529e5da$export$f18c66b472536888 = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("empty-state", [
    "root",
    "content",
    "indicator",
    "title",
    "description"
]);
const $9b7764ce1529e5da$export$a43048b0d2808e4e = (0, $1ecabe0c7927b138$export$a43048b0d2808e4e).extendWith("requiredIndicator");
const $9b7764ce1529e5da$export$3b2066f768dd72d0 = (0, $ca0938c560125fe3$export$3b2066f768dd72d0).extendWith("content");
const $9b7764ce1529e5da$export$b589745ee24985d = (0, $aefe1177600007b1$export$477202748c7242bf).extendWith("itemContent", "dropzoneContent");
const $9b7764ce1529e5da$export$12b3a655a94374ed = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("list").parts("root", "item", "indicator");
const $9b7764ce1529e5da$export$e251092a5dcb1329 = (0, $d0d20352325a4202$export$477202748c7242bf).extendWith("itemCommand");
const $9b7764ce1529e5da$export$f38e0304163546fd = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("select").parts("root", "field", "indicator");
const $9b7764ce1529e5da$export$afda07d12cd4337d = (0, $f552bad70b683f14$export$477202748c7242bf).extendWith("header", "body", "footer");
const $9b7764ce1529e5da$export$837558ec9d0fab0d = (0, $51157ee96867283b$export$477202748c7242bf).extendWith("itemAddon", "itemIndicator");
const $9b7764ce1529e5da$export$6f8cb2f45f823e4d = $9b7764ce1529e5da$export$837558ec9d0fab0d.extendWith("itemContent", "itemDescription");
const $9b7764ce1529e5da$export$127aba8545f015d6 = (0, $bd0d6b40b15e1618$export$477202748c7242bf).extendWith("itemIndicator");
const $9b7764ce1529e5da$export$17993f0be9538b5a = (0, $c7b683267f2db6f5$export$477202748c7242bf).extendWith("indicatorGroup");
const $9b7764ce1529e5da$export$c21b4b3f8b239f32 = (0, $45d0679faae7ef05$export$477202748c7242bf).extendWith("markerIndicator");
const $9b7764ce1529e5da$export$2cfbad67ae6ee421 = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("stat").parts("root", "label", "helpText", "valueText", "valueUnit", "indicator");
const $9b7764ce1529e5da$export$6b07965b0539a879 = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("status").parts("root", "indicator");
const $9b7764ce1529e5da$export$5c3acf63225011aa = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("steps", [
    "root",
    "list",
    "item",
    "trigger",
    "indicator",
    "separator",
    "content",
    "title",
    "description",
    "nextTrigger",
    "prevTrigger",
    "progress"
]);
const $9b7764ce1529e5da$export$921c1a2d1ce1e86a = (0, $208a3ddd1226e21a$export$477202748c7242bf).extendWith("indicator");
const $9b7764ce1529e5da$export$8b1b9cdd5db9f5fd = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("table").parts("root", "header", "body", "row", "columnHeader", "cell", "footer", "caption");
const $9b7764ce1529e5da$export$c220e6c275daf119 = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("toast").parts("root", "title", "description", "indicator", "closeTrigger", "actionTrigger");
const $9b7764ce1529e5da$export$97383552563be58d = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("tabs").parts("root", "trigger", "list", "content", "contentGroup", "indicator");
const $9b7764ce1529e5da$export$4c2f5f7f2ea94a8e = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("tag").parts("root", "label", "closeTrigger", "startElement", "endElement");
const $9b7764ce1529e5da$export$174cdbdedca11ecf = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("timeline").parts("root", "item", "content", "separator", "indicator", "connector", "title", "description");



"use strict";
const $e8750b399fdcd1d6$export$f4a442eb58b0fd05 = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    className: "chakra-accordion",
    slots: (0, $9b7764ce1529e5da$export$377a77e99e7c73a5).keys(),
    base: {
        root: {
            width: "full",
            "--accordion-radius": "radii.l2"
        },
        item: {
            overflowAnchor: "none"
        },
        itemTrigger: {
            display: "flex",
            alignItems: "center",
            width: "full",
            outline: "0",
            gap: "3",
            fontWeight: "medium",
            borderRadius: "var(--accordion-radius)",
            _focusVisible: {
                outline: "2px solid",
                outlineColor: "colorPalette.focusRing"
            },
            _disabled: {
                layerStyle: "disabled"
            }
        },
        itemBody: {
            pt: "var(--accordion-padding-y)",
            pb: "calc(var(--accordion-padding-y) * 2)"
        },
        itemContent: {
            overflow: "hidden",
            borderRadius: "var(--accordion-radius)",
            _open: {
                animationName: "expand-height, fade-in",
                animationDuration: "moderate"
            },
            _closed: {
                animationName: "collapse-height, fade-out",
                animationDuration: "moderate"
            }
        },
        itemIndicator: {
            transition: "rotate 0.2s",
            transformOrigin: "center",
            color: "fg.subtle",
            _open: {
                rotate: "180deg"
            },
            _icon: {
                width: "1.2em",
                height: "1.2em"
            }
        }
    },
    variants: {
        variant: {
            outline: {
                item: {
                    borderBottomWidth: "1px"
                }
            },
            subtle: {
                itemTrigger: {
                    px: "var(--accordion-padding-x)"
                },
                itemContent: {
                    px: "var(--accordion-padding-x)"
                },
                item: {
                    borderRadius: "var(--accordion-radius)",
                    _open: {
                        bg: "colorPalette.subtle"
                    }
                }
            },
            enclosed: {
                root: {
                    borderWidth: "1px",
                    borderRadius: "var(--accordion-radius)",
                    divideY: "1px",
                    overflow: "hidden"
                },
                itemTrigger: {
                    px: "var(--accordion-padding-x)"
                },
                itemContent: {
                    px: "var(--accordion-padding-x)"
                },
                item: {
                    _open: {
                        bg: "bg.subtle"
                    }
                }
            },
            plain: {}
        },
        size: {
            sm: {
                root: {
                    "--accordion-padding-x": "spacing.3",
                    "--accordion-padding-y": "spacing.2"
                },
                itemTrigger: {
                    textStyle: "sm",
                    py: "var(--accordion-padding-y)"
                }
            },
            md: {
                root: {
                    "--accordion-padding-x": "spacing.4",
                    "--accordion-padding-y": "spacing.2"
                },
                itemTrigger: {
                    textStyle: "md",
                    py: "var(--accordion-padding-y)"
                }
            },
            lg: {
                root: {
                    "--accordion-padding-x": "spacing.4.5",
                    "--accordion-padding-y": "spacing.2.5"
                },
                itemTrigger: {
                    textStyle: "lg",
                    py: "var(--accordion-padding-y)"
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "outline"
    }
});




"use strict";
const $8a86a91c46871bba$export$fa2b273b16ba8691 = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    className: "chakra-action-bar",
    slots: (0, $9b7764ce1529e5da$export$7dd5043f89c4709c).keys(),
    base: {
        positioner: {
            position: "fixed",
            display: "flex",
            justifyContent: "center",
            pointerEvents: "none",
            insetInline: "0",
            top: "unset",
            bottom: "calc(env(safe-area-inset-bottom) + 20px)"
        },
        content: {
            bg: "bg.panel",
            shadow: "md",
            display: "flex",
            alignItems: "center",
            gap: "3",
            borderRadius: "l3",
            py: "2.5",
            px: "3",
            pointerEvents: "auto",
            // Stabilize the position of the action bar when the scrollbar is hidden
            // by using the scrollbar width to offset the position.
            translate: "calc(-1 * var(--scrollbar-width) / 2) 0px",
            _open: {
                animationName: "slide-from-bottom, fade-in",
                animationDuration: "moderate"
            },
            _closed: {
                animationName: "slide-to-bottom, fade-out",
                animationDuration: "faster"
            }
        },
        separator: {
            width: "1px",
            height: "5",
            bg: "border"
        },
        selectionTrigger: {
            display: "inline-flex",
            alignItems: "center",
            gap: "2",
            alignSelf: "stretch",
            textStyle: "sm",
            px: "4",
            py: "1",
            borderRadius: "l2",
            borderWidth: "1px",
            borderStyle: "dashed"
        }
    }
});




"use strict";
const $090963649c47e7b1$export$998588db5c35d89f = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    slots: (0, $9b7764ce1529e5da$export$fc51889fa4de265a).keys(),
    className: "chakra-alert",
    base: {
        root: {
            width: "full",
            display: "flex",
            alignItems: "flex-start",
            position: "relative",
            borderRadius: "l3"
        },
        title: {
            fontWeight: "medium"
        },
        description: {
            display: "inline"
        },
        indicator: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: "0",
            width: "1em",
            height: "1em",
            _icon: {
                boxSize: "full"
            }
        },
        content: {
            display: "flex",
            flex: "1",
            gap: "1"
        }
    },
    variants: {
        status: {
            info: {
                root: {
                    colorPalette: "blue"
                }
            },
            warning: {
                root: {
                    colorPalette: "orange"
                }
            },
            success: {
                root: {
                    colorPalette: "green"
                }
            },
            error: {
                root: {
                    colorPalette: "red"
                }
            },
            neutral: {
                root: {
                    colorPalette: "gray"
                }
            }
        },
        inline: {
            true: {
                content: {
                    display: "inline-flex",
                    flexDirection: "row",
                    alignItems: "center"
                }
            },
            false: {
                content: {
                    display: "flex",
                    flexDirection: "column"
                }
            }
        },
        variant: {
            subtle: {
                root: {
                    bg: "colorPalette.subtle",
                    color: "colorPalette.fg"
                }
            },
            surface: {
                root: {
                    bg: "colorPalette.subtle",
                    color: "colorPalette.fg",
                    shadow: "inset 0 0 0px 1px var(--shadow-color)",
                    shadowColor: "colorPalette.muted"
                },
                indicator: {
                    color: "colorPalette.fg"
                }
            },
            outline: {
                root: {
                    color: "colorPalette.fg",
                    shadow: "inset 0 0 0px 1px var(--shadow-color)",
                    shadowColor: "colorPalette.muted"
                },
                indicator: {
                    color: "colorPalette.fg"
                }
            },
            solid: {
                root: {
                    bg: "colorPalette.solid",
                    color: "colorPalette.contrast"
                },
                indicator: {
                    color: "colorPalette.contrast"
                }
            }
        },
        size: {
            sm: {
                root: {
                    gap: "2",
                    px: "3",
                    py: "3",
                    textStyle: "xs"
                },
                indicator: {
                    textStyle: "lg"
                }
            },
            md: {
                root: {
                    gap: "3",
                    px: "4",
                    py: "4",
                    textStyle: "sm"
                },
                indicator: {
                    textStyle: "xl"
                }
            },
            lg: {
                root: {
                    gap: "3",
                    px: "4",
                    py: "4",
                    textStyle: "md"
                },
                indicator: {
                    textStyle: "2xl"
                }
            }
        }
    },
    defaultVariants: {
        status: "info",
        variant: "subtle",
        size: "md",
        inline: false
    }
});








// src/avatar.anatomy.ts
var $77abc660aa6e1995$export$477202748c7242bf = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("avatar").parts("root", "image", "fallback");
var $77abc660aa6e1995$var$parts = $77abc660aa6e1995$export$477202748c7242bf.build();
var $77abc660aa6e1995$var$dom = (0, $b06ec5ff205338e5$export$41a9651decfe2bde)({
    getRootId: (ctx)=>ctx.ids?.root ?? `avatar:${ctx.id}`,
    getImageId: (ctx)=>ctx.ids?.image ?? `avatar:${ctx.id}:image`,
    getFallbackId: (ctx)=>ctx.ids?.fallback ?? `avatar:${ctx.id}:fallback`,
    getRootEl: (ctx)=>$77abc660aa6e1995$var$dom.getById(ctx, $77abc660aa6e1995$var$dom.getRootId(ctx)),
    getImageEl: (ctx)=>$77abc660aa6e1995$var$dom.getById(ctx, $77abc660aa6e1995$var$dom.getImageId(ctx))
});
// src/avatar.connect.ts
function $77abc660aa6e1995$export$64605811ab45167f(state, send, normalize) {
    const loaded = state.matches("loaded");
    return {
        loaded: loaded,
        setSrc (src) {
            send({
                type: "SRC.SET",
                src: src
            });
        },
        setLoaded () {
            send({
                type: "IMG.LOADED",
                src: "api"
            });
        },
        setError () {
            send({
                type: "IMG.ERROR",
                src: "api"
            });
        },
        getRootProps () {
            return normalize.element({
                ...$77abc660aa6e1995$var$parts.root.attrs,
                dir: state.context.dir,
                id: $77abc660aa6e1995$var$dom.getRootId(state.context)
            });
        },
        getImageProps () {
            return normalize.img({
                ...$77abc660aa6e1995$var$parts.image.attrs,
                hidden: !loaded,
                dir: state.context.dir,
                id: $77abc660aa6e1995$var$dom.getImageId(state.context),
                "data-state": loaded ? "visible" : "hidden",
                onLoad () {
                    send({
                        type: "IMG.LOADED",
                        src: "element"
                    });
                },
                onError () {
                    send({
                        type: "IMG.ERROR",
                        src: "element"
                    });
                }
            });
        },
        getFallbackProps () {
            return normalize.element({
                ...$77abc660aa6e1995$var$parts.fallback.attrs,
                dir: state.context.dir,
                id: $77abc660aa6e1995$var$dom.getFallbackId(state.context),
                hidden: loaded,
                "data-state": loaded ? "hidden" : "visible"
            });
        }
    };
}
function $77abc660aa6e1995$export$ea56d40cd27c3480(userContext) {
    const ctx = (0, $89352e0ddd72597a$export$8e16b83750b44988)(userContext);
    return (0, $5c0da97e9c7aa95f$export$aaa7fa18f8e9b2e8)({
        id: "avatar",
        initial: "loading",
        activities: [
            "trackImageRemoval"
        ],
        context: ctx,
        on: {
            "SRC.CHANGE": {
                target: "loading"
            },
            "IMG.UNMOUNT": {
                target: "error"
            }
        },
        states: {
            loading: {
                activities: [
                    "trackSrcChange"
                ],
                entry: [
                    "checkImageStatus"
                ],
                on: {
                    "IMG.LOADED": {
                        target: "loaded",
                        actions: [
                            "invokeOnLoad"
                        ]
                    },
                    "IMG.ERROR": {
                        target: "error",
                        actions: [
                            "invokeOnError"
                        ]
                    }
                }
            },
            error: {
                activities: [
                    "trackSrcChange"
                ],
                on: {
                    "IMG.LOADED": {
                        target: "loaded",
                        actions: [
                            "invokeOnLoad"
                        ]
                    }
                }
            },
            loaded: {
                activities: [
                    "trackSrcChange"
                ],
                on: {
                    "IMG.ERROR": {
                        target: "error",
                        actions: [
                            "invokeOnError"
                        ]
                    }
                }
            }
        }
    }, {
        activities: {
            trackSrcChange (ctx2, _evt, { send: send }) {
                const imageEl = $77abc660aa6e1995$var$dom.getImageEl(ctx2);
                return (0, $b06ec5ff205338e5$export$343af0d656c88488)(imageEl, {
                    attributes: [
                        "src",
                        "srcset"
                    ],
                    callback () {
                        send({
                            type: "SRC.CHANGE"
                        });
                    }
                });
            },
            trackImageRemoval (ctx2, _evt, { send: send }) {
                const rootEl = $77abc660aa6e1995$var$dom.getRootEl(ctx2);
                return (0, $b06ec5ff205338e5$export$c7ed990b38b19ee7)(rootEl, {
                    callback (records) {
                        const removedNodes = Array.from(records[0].removedNodes);
                        const removed = removedNodes.find((node)=>node.nodeType === Node.ELEMENT_NODE && node.matches("[data-scope=avatar][data-part=image]"));
                        if (removed) send({
                            type: "IMG.UNMOUNT"
                        });
                    }
                });
            }
        },
        actions: {
            invokeOnLoad (ctx2) {
                ctx2.onStatusChange?.({
                    status: "loaded"
                });
            },
            invokeOnError (ctx2) {
                ctx2.onStatusChange?.({
                    status: "error"
                });
            },
            checkImageStatus (ctx2, _evt, { send: send }) {
                const imageEl = $77abc660aa6e1995$var$dom.getImageEl(ctx2);
                if (imageEl?.complete) {
                    const type = $77abc660aa6e1995$var$hasLoaded(imageEl) ? "IMG.LOADED" : "IMG.ERROR";
                    send({
                        type: type,
                        src: "ssr"
                    });
                }
            }
        }
    });
}
function $77abc660aa6e1995$var$hasLoaded(image) {
    return image.complete && image.naturalWidth !== 0 && image.naturalHeight !== 0;
}
var $77abc660aa6e1995$export$8128bb6492cf3de7 = (0, $5b359805fda5a40e$export$c94ea207b45fef3a)()([
    "dir",
    "id",
    "ids",
    "onStatusChange",
    "getRootNode"
]);
var $77abc660aa6e1995$export$45029c61b0073d87 = (0, $89352e0ddd72597a$export$3ea53b214fbc1986)($77abc660aa6e1995$export$8128bb6492cf3de7);


"use strict";
const $45fd1dd2da84c020$export$3abc6b3f791f1dd4 = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    slots: (0, $77abc660aa6e1995$export$477202748c7242bf).keys(),
    className: "chakra-avatar",
    base: {
        root: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "medium",
            position: "relative",
            verticalAlign: "top",
            flexShrink: "0",
            userSelect: "none",
            width: "var(--avatar-size)",
            height: "var(--avatar-size)",
            fontSize: "var(--avatar-font-size)",
            borderRadius: "var(--avatar-radius)",
            "&[data-group-item]": {
                borderWidth: "2px",
                borderColor: "bg"
            }
        },
        image: {
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: "var(--avatar-radius)"
        },
        fallback: {
            lineHeight: "1",
            textTransform: "uppercase",
            fontWeight: "medium",
            fontSize: "var(--avatar-font-size)",
            borderRadius: "var(--avatar-radius)"
        }
    },
    variants: {
        size: {
            full: {
                root: {
                    "--avatar-size": "100%",
                    "--avatar-font-size": "100%"
                }
            },
            "2xs": {
                root: {
                    "--avatar-font-size": "fontSizes.2xs",
                    "--avatar-size": "sizes.6"
                }
            },
            xs: {
                root: {
                    "--avatar-font-size": "fontSizes.xs",
                    "--avatar-size": "sizes.8"
                }
            },
            sm: {
                root: {
                    "--avatar-font-size": "fontSizes.sm",
                    "--avatar-size": "sizes.9"
                }
            },
            md: {
                root: {
                    "--avatar-font-size": "fontSizes.md",
                    "--avatar-size": "sizes.10"
                }
            },
            lg: {
                root: {
                    "--avatar-font-size": "fontSizes.md",
                    "--avatar-size": "sizes.11"
                }
            },
            xl: {
                root: {
                    "--avatar-font-size": "fontSizes.lg",
                    "--avatar-size": "sizes.12"
                }
            },
            "2xl": {
                root: {
                    "--avatar-font-size": "fontSizes.xl",
                    "--avatar-size": "sizes.16"
                }
            }
        },
        variant: {
            solid: {
                root: {
                    bg: "colorPalette.solid",
                    color: "colorPalette.contrast"
                }
            },
            subtle: {
                root: {
                    bg: "colorPalette.muted",
                    color: "colorPalette.fg"
                }
            },
            outline: {
                root: {
                    color: "colorPalette.fg",
                    borderWidth: "1px",
                    borderColor: "colorPalette.muted"
                }
            }
        },
        shape: {
            square: {},
            rounded: {
                root: {
                    "--avatar-radius": "radii.l3"
                }
            },
            full: {
                root: {
                    "--avatar-radius": "radii.full"
                }
            }
        },
        borderless: {
            true: {
                root: {
                    "&[data-group-item]": {
                        borderWidth: "0px"
                    }
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        shape: "full",
        variant: "subtle"
    }
});




"use strict";
const $dd4749d5e77707a5$export$8b1f9367c4597998 = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    className: "chakra-blockquote",
    slots: (0, $9b7764ce1529e5da$export$50ffc6bb83cc6686).keys(),
    base: {
        root: {
            position: "relative",
            display: "flex",
            flexDirection: "column",
            gap: "2"
        },
        caption: {
            textStyle: "sm",
            color: "fg.muted"
        },
        icon: {
            boxSize: "5"
        }
    },
    variants: {
        justify: {
            start: {
                root: {
                    alignItems: "flex-start",
                    textAlign: "start"
                }
            },
            center: {
                root: {
                    alignItems: "center",
                    textAlign: "center"
                }
            },
            end: {
                root: {
                    alignItems: "flex-end",
                    textAlign: "end"
                }
            }
        },
        variant: {
            subtle: {
                root: {
                    paddingX: "5",
                    borderStartWidth: "4px",
                    borderStartColor: "colorPalette.muted"
                },
                icon: {
                    color: "colorPalette.fg"
                }
            },
            solid: {
                root: {
                    paddingX: "5",
                    borderStartWidth: "4px",
                    borderStartColor: "colorPalette.solid"
                },
                icon: {
                    color: "colorPalette.solid"
                }
            },
            plain: {
                root: {
                    paddingX: "5"
                },
                icon: {
                    color: "colorPalette.solid"
                }
            }
        }
    },
    defaultVariants: {
        variant: "subtle",
        justify: "start"
    }
});




"use strict";
const $464bc7fd799ca00e$export$445bd218bcf49ac8 = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    className: "chakra-breadcrumb",
    slots: (0, $9b7764ce1529e5da$export$2fb03f744a6ecf93).keys(),
    base: {
        list: {
            display: "flex",
            alignItems: "center",
            wordBreak: "break-word",
            color: "fg.muted",
            listStyle: "none"
        },
        link: {
            outline: "0",
            textDecoration: "none",
            borderRadius: "l1",
            focusRing: "outside",
            display: "inline-flex",
            alignItems: "center",
            gap: "2"
        },
        item: {
            display: "inline-flex",
            alignItems: "center"
        },
        separator: {
            color: "fg.muted",
            opacity: "0.8",
            _icon: {
                boxSize: "1em"
            },
            _rtl: {
                rotate: "180deg"
            }
        },
        ellipsis: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            _icon: {
                boxSize: "1em"
            }
        }
    },
    variants: {
        variant: {
            underline: {
                link: {
                    color: "colorPalette.fg",
                    textDecoration: "underline",
                    textUnderlineOffset: "0.2em",
                    textDecorationColor: "colorPalette.muted"
                },
                currentLink: {
                    color: "colorPalette.fg"
                }
            },
            plain: {
                link: {
                    color: "fg.muted",
                    _hover: {
                        color: "fg"
                    }
                },
                currentLink: {
                    color: "fg"
                }
            }
        },
        size: {
            sm: {
                list: {
                    gap: "1",
                    textStyle: "xs"
                }
            },
            md: {
                list: {
                    gap: "1.5",
                    textStyle: "sm"
                }
            },
            lg: {
                list: {
                    gap: "2",
                    textStyle: "md"
                }
            }
        }
    },
    defaultVariants: {
        variant: "plain",
        size: "md"
    }
});




"use strict";
const $0e5d0e8a57447c08$export$e4092ce1781694ee = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    className: "chakra-card",
    slots: (0, $9b7764ce1529e5da$export$487a447ffa5755b6).keys(),
    base: {
        root: {
            display: "flex",
            flexDirection: "column",
            position: "relative",
            minWidth: "0",
            wordWrap: "break-word",
            borderRadius: "l3",
            color: "fg",
            textAlign: "start"
        },
        title: {
            fontWeight: "semibold"
        },
        description: {
            color: "fg.muted",
            fontSize: "sm"
        },
        header: {
            paddingInline: "var(--card-padding)",
            paddingTop: "var(--card-padding)",
            display: "flex",
            flexDirection: "column",
            gap: "1.5"
        },
        body: {
            padding: "var(--card-padding)",
            flex: "1",
            display: "flex",
            flexDirection: "column"
        },
        footer: {
            display: "flex",
            alignItems: "center",
            gap: "2",
            paddingInline: "var(--card-padding)",
            paddingBottom: "var(--card-padding)"
        }
    },
    variants: {
        size: {
            sm: {
                root: {
                    "--card-padding": "spacing.4"
                },
                title: {
                    textStyle: "md"
                }
            },
            md: {
                root: {
                    "--card-padding": "spacing.6"
                },
                title: {
                    textStyle: "lg"
                }
            },
            lg: {
                root: {
                    "--card-padding": "spacing.7"
                },
                title: {
                    textStyle: "xl"
                }
            }
        },
        variant: {
            elevated: {
                root: {
                    bg: "bg.panel",
                    boxShadow: "md"
                }
            },
            outline: {
                root: {
                    bg: "bg.panel",
                    borderWidth: "1px",
                    borderColor: "border"
                }
            },
            subtle: {
                root: {
                    bg: "bg.muted"
                }
            }
        }
    },
    defaultVariants: {
        variant: "outline",
        size: "md"
    }
});










// src/checkbox.anatomy.ts
var $040c7e57db6c628c$export$477202748c7242bf = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("checkbox").parts("root", "label", "control", "indicator");
var $040c7e57db6c628c$var$parts = $040c7e57db6c628c$export$477202748c7242bf.build();
var $040c7e57db6c628c$var$dom = (0, $b06ec5ff205338e5$export$41a9651decfe2bde)({
    getRootId: (ctx)=>ctx.ids?.root ?? `checkbox:${ctx.id}`,
    getLabelId: (ctx)=>ctx.ids?.label ?? `checkbox:${ctx.id}:label`,
    getControlId: (ctx)=>ctx.ids?.control ?? `checkbox:${ctx.id}:control`,
    getHiddenInputId: (ctx)=>ctx.ids?.hiddenInput ?? `checkbox:${ctx.id}:input`,
    getRootEl: (ctx)=>$040c7e57db6c628c$var$dom.getById(ctx, $040c7e57db6c628c$var$dom.getRootId(ctx)),
    getHiddenInputEl: (ctx)=>$040c7e57db6c628c$var$dom.getById(ctx, $040c7e57db6c628c$var$dom.getHiddenInputId(ctx))
});
function $040c7e57db6c628c$export$64605811ab45167f(state, send, normalize) {
    const disabled = state.context.isDisabled;
    const readOnly = state.context.readOnly;
    const focused = !disabled && state.context.focused;
    const focusVisible = !disabled && state.context.focusVisible;
    const checked = state.context.isChecked;
    const indeterminate = state.context.isIndeterminate;
    const dataAttrs = {
        "data-active": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.active),
        "data-focus": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(focused),
        "data-focus-visible": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(focusVisible),
        "data-readonly": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(readOnly),
        "data-hover": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.hovered),
        "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
        "data-state": indeterminate ? "indeterminate" : state.context.checked ? "checked" : "unchecked",
        "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.invalid)
    };
    return {
        checked: checked,
        disabled: disabled,
        indeterminate: indeterminate,
        focused: focused,
        checkedState: state.context.checked,
        setChecked (checked2) {
            send({
                type: "CHECKED.SET",
                checked: checked2,
                isTrusted: false
            });
        },
        toggleChecked () {
            send({
                type: "CHECKED.TOGGLE",
                checked: checked,
                isTrusted: false
            });
        },
        getRootProps () {
            return normalize.label({
                ...$040c7e57db6c628c$var$parts.root.attrs,
                ...dataAttrs,
                dir: state.context.dir,
                id: $040c7e57db6c628c$var$dom.getRootId(state.context),
                htmlFor: $040c7e57db6c628c$var$dom.getHiddenInputId(state.context),
                onPointerMove () {
                    if (disabled) return;
                    send({
                        type: "CONTEXT.SET",
                        context: {
                            hovered: true
                        }
                    });
                },
                onPointerLeave () {
                    if (disabled) return;
                    send({
                        type: "CONTEXT.SET",
                        context: {
                            hovered: false
                        }
                    });
                },
                onClick (event) {
                    const target = (0, $b06ec5ff205338e5$export$e58f029f0fbfdb29)(event);
                    if (target === $040c7e57db6c628c$var$dom.getHiddenInputEl(state.context)) event.stopPropagation();
                }
            });
        },
        getLabelProps () {
            return normalize.element({
                ...$040c7e57db6c628c$var$parts.label.attrs,
                ...dataAttrs,
                dir: state.context.dir,
                id: $040c7e57db6c628c$var$dom.getLabelId(state.context)
            });
        },
        getControlProps () {
            return normalize.element({
                ...$040c7e57db6c628c$var$parts.control.attrs,
                ...dataAttrs,
                dir: state.context.dir,
                id: $040c7e57db6c628c$var$dom.getControlId(state.context),
                "aria-hidden": true
            });
        },
        getIndicatorProps () {
            return normalize.element({
                ...$040c7e57db6c628c$var$parts.indicator.attrs,
                ...dataAttrs,
                dir: state.context.dir,
                hidden: !indeterminate && !state.context.checked
            });
        },
        getHiddenInputProps () {
            return normalize.input({
                id: $040c7e57db6c628c$var$dom.getHiddenInputId(state.context),
                type: "checkbox",
                required: state.context.required,
                defaultChecked: checked,
                disabled: disabled,
                "aria-labelledby": $040c7e57db6c628c$var$dom.getLabelId(state.context),
                "aria-invalid": state.context.invalid,
                name: state.context.name,
                form: state.context.form,
                value: state.context.value,
                style: (0, $b06ec5ff205338e5$export$8fecac46448b5689),
                onFocus () {
                    const focusVisible2 = (0, $10f5b85675c7b32e$export$b9b3dfddab17db27)();
                    send({
                        type: "CONTEXT.SET",
                        context: {
                            focused: true,
                            focusVisible: focusVisible2
                        }
                    });
                },
                onBlur () {
                    send({
                        type: "CONTEXT.SET",
                        context: {
                            focused: false,
                            focusVisible: false
                        }
                    });
                },
                onClick (event) {
                    if (readOnly) {
                        event.preventDefault();
                        return;
                    }
                    const checked2 = event.currentTarget.checked;
                    send({
                        type: "CHECKED.SET",
                        checked: checked2,
                        isTrusted: true
                    });
                }
            });
        }
    };
}
var { not: $040c7e57db6c628c$var$not } = (0, $5c0da97e9c7aa95f$export$f3249297f3edf7e9);
function $040c7e57db6c628c$export$ea56d40cd27c3480(userContext) {
    const ctx = (0, $89352e0ddd72597a$export$8e16b83750b44988)(userContext);
    return (0, $5c0da97e9c7aa95f$export$aaa7fa18f8e9b2e8)({
        id: "checkbox",
        initial: "ready",
        context: {
            checked: false,
            value: "on",
            disabled: false,
            ...ctx,
            fieldsetDisabled: false,
            focusVisible: false
        },
        watch: {
            disabled: "removeFocusIfNeeded",
            checked: "syncInputElement"
        },
        activities: [
            "trackFormControlState",
            "trackPressEvent",
            "trackFocusVisible"
        ],
        on: {
            "CHECKED.TOGGLE": [
                {
                    guard: $040c7e57db6c628c$var$not("isTrusted"),
                    actions: [
                        "toggleChecked",
                        "dispatchChangeEvent"
                    ]
                },
                {
                    actions: [
                        "toggleChecked"
                    ]
                }
            ],
            "CHECKED.SET": [
                {
                    guard: $040c7e57db6c628c$var$not("isTrusted"),
                    actions: [
                        "setChecked",
                        "dispatchChangeEvent"
                    ]
                },
                {
                    actions: [
                        "setChecked"
                    ]
                }
            ],
            "CONTEXT.SET": {
                actions: [
                    "setContext"
                ]
            }
        },
        computed: {
            isIndeterminate: (ctx2)=>$040c7e57db6c628c$var$isIndeterminate(ctx2.checked),
            isChecked: (ctx2)=>$040c7e57db6c628c$var$isChecked(ctx2.checked),
            isDisabled: (ctx2)=>!!ctx2.disabled || ctx2.fieldsetDisabled
        },
        states: {
            ready: {}
        }
    }, {
        guards: {
            isTrusted: (_ctx, evt)=>!!evt.isTrusted
        },
        activities: {
            trackPressEvent (ctx2) {
                if (ctx2.isDisabled) return;
                return (0, $b06ec5ff205338e5$export$9a7215eeb3481da)({
                    pointerNode: $040c7e57db6c628c$var$dom.getRootEl(ctx2),
                    keyboardNode: $040c7e57db6c628c$var$dom.getHiddenInputEl(ctx2),
                    isValidKey: (event)=>event.key === " ",
                    onPress: ()=>ctx2.active = false,
                    onPressStart: ()=>ctx2.active = true,
                    onPressEnd: ()=>ctx2.active = false
                });
            },
            trackFocusVisible (ctx2) {
                if (ctx2.isDisabled) return;
                return (0, $10f5b85675c7b32e$export$920b4983565c6f4d)({
                    root: $040c7e57db6c628c$var$dom.getRootNode(ctx2)
                });
            },
            trackFormControlState (ctx2, _evt, { send: send, initialContext: initialContext }) {
                return (0, $b06ec5ff205338e5$export$a48469c7b6beba26)($040c7e57db6c628c$var$dom.getHiddenInputEl(ctx2), {
                    onFieldsetDisabledChange (disabled) {
                        ctx2.fieldsetDisabled = disabled;
                    },
                    onFormReset () {
                        send({
                            type: "CHECKED.SET",
                            checked: !!initialContext.checked
                        });
                    }
                });
            }
        },
        actions: {
            setContext (ctx2, evt) {
                Object.assign(ctx2, evt.context);
            },
            syncInputElement (ctx2) {
                const inputEl = $040c7e57db6c628c$var$dom.getHiddenInputEl(ctx2);
                if (!inputEl) return;
                (0, $b06ec5ff205338e5$export$1b2cb9f366b7b263)(inputEl, ctx2.isChecked);
                inputEl.indeterminate = ctx2.isIndeterminate;
            },
            removeFocusIfNeeded (ctx2) {
                if (ctx2.disabled && ctx2.focused) {
                    ctx2.focused = false;
                    ctx2.focusVisible = false;
                }
            },
            setChecked (ctx2, evt) {
                $040c7e57db6c628c$var$set.checked(ctx2, evt.checked);
            },
            toggleChecked (ctx2) {
                const checked = $040c7e57db6c628c$var$isIndeterminate(ctx2.checked) ? true : !ctx2.checked;
                $040c7e57db6c628c$var$set.checked(ctx2, checked);
            },
            dispatchChangeEvent (ctx2) {
                const inputEl = $040c7e57db6c628c$var$dom.getHiddenInputEl(ctx2);
                (0, $b06ec5ff205338e5$export$ebab7723673c874f)(inputEl, {
                    checked: $040c7e57db6c628c$var$isChecked(ctx2.checked)
                });
            }
        }
    });
}
function $040c7e57db6c628c$var$isIndeterminate(checked) {
    return checked === "indeterminate";
}
function $040c7e57db6c628c$var$isChecked(checked) {
    return $040c7e57db6c628c$var$isIndeterminate(checked) ? false : !!checked;
}
var $040c7e57db6c628c$var$invoke = {
    change: (ctx)=>{
        ctx.onCheckedChange?.({
            checked: ctx.checked
        });
    }
};
var $040c7e57db6c628c$var$set = {
    checked: (ctx, checked)=>{
        if ((0, $89352e0ddd72597a$export$248d38f6296296c5)(ctx.checked, checked)) return;
        ctx.checked = checked;
        $040c7e57db6c628c$var$invoke.change(ctx);
    }
};
var $040c7e57db6c628c$export$8128bb6492cf3de7 = (0, $5b359805fda5a40e$export$c94ea207b45fef3a)()([
    "checked",
    "dir",
    "disabled",
    "form",
    "getRootNode",
    "id",
    "ids",
    "invalid",
    "name",
    "onCheckedChange",
    "readOnly",
    "required",
    "value"
]);
var $040c7e57db6c628c$export$45029c61b0073d87 = (0, $89352e0ddd72597a$export$3ea53b214fbc1986)($040c7e57db6c628c$export$8128bb6492cf3de7);


"use client";
const $b6abc3db36c933ab$export$21946b04497ed6ac = (0, $040c7e57db6c628c$export$477202748c7242bf).extendWith("group");


"use strict";
const $be4db9b9eceaefc4$export$85054d78118eabd7 = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    slots: (0, $b6abc3db36c933ab$export$21946b04497ed6ac).keys(),
    className: "chakra-checkbox",
    base: {
        root: {
            display: "inline-flex",
            gap: "2",
            alignItems: "center",
            verticalAlign: "top",
            position: "relative"
        },
        control: (0, $85d8300c74ba233f$export$ecb1dc0d32e8f247).base,
        label: {
            fontWeight: "medium",
            userSelect: "none",
            _disabled: {
                opacity: "0.5"
            }
        }
    },
    variants: {
        size: {
            xs: {
                root: {
                    gap: "1.5"
                },
                label: {
                    textStyle: "xs"
                },
                control: (0, $85d8300c74ba233f$export$ecb1dc0d32e8f247).variants?.size?.xs
            },
            sm: {
                root: {
                    gap: "2"
                },
                label: {
                    textStyle: "sm"
                },
                control: (0, $85d8300c74ba233f$export$ecb1dc0d32e8f247).variants?.size?.sm
            },
            md: {
                root: {
                    gap: "2.5"
                },
                label: {
                    textStyle: "sm"
                },
                control: (0, $85d8300c74ba233f$export$ecb1dc0d32e8f247).variants?.size?.md
            },
            lg: {
                root: {
                    gap: "3"
                },
                label: {
                    textStyle: "md"
                },
                control: (0, $85d8300c74ba233f$export$ecb1dc0d32e8f247).variants?.size?.lg
            }
        },
        variant: {
            outline: {
                control: (0, $85d8300c74ba233f$export$ecb1dc0d32e8f247).variants?.variant?.outline
            },
            solid: {
                control: (0, $85d8300c74ba233f$export$ecb1dc0d32e8f247).variants?.variant?.solid
            },
            subtle: {
                control: (0, $85d8300c74ba233f$export$ecb1dc0d32e8f247).variants?.variant?.subtle
            }
        }
    },
    defaultVariants: {
        variant: "solid",
        size: "md"
    }
});





"use strict";
const $7eab2d6def0821ca$export$7450efef80368c09 = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    slots: (0, $9b7764ce1529e5da$export$e4581dd169704619).keys(),
    className: "chakra-checkbox-card",
    base: {
        root: {
            display: "flex",
            flexDirection: "column",
            userSelect: "none",
            position: "relative",
            borderRadius: "l2",
            flex: "1",
            focusVisibleRing: "outside",
            _disabled: {
                opacity: "0.8",
                borderColor: "border.subtle"
            },
            _invalid: {
                outline: "2px solid",
                outlineColor: "border.error"
            }
        },
        control: {
            display: "inline-flex",
            flex: "1",
            position: "relative",
            borderRadius: "inherit",
            justifyContent: "var(--checkbox-card-justify)",
            alignItems: "var(--checkbox-card-align)"
        },
        label: {
            fontWeight: "medium",
            display: "flex",
            alignItems: "center",
            gap: "2",
            _disabled: {
                opacity: "0.5"
            }
        },
        description: {
            opacity: "0.64",
            textStyle: "sm"
        },
        addon: {
            _disabled: {
                opacity: "0.5"
            }
        },
        indicator: (0, $85d8300c74ba233f$export$ecb1dc0d32e8f247).base,
        content: {
            display: "flex",
            flexDirection: "column",
            flex: "1",
            gap: "1",
            justifyContent: "var(--checkbox-card-justify)",
            alignItems: "var(--checkbox-card-align)"
        }
    },
    variants: {
        size: {
            sm: {
                root: {
                    textStyle: "sm"
                },
                control: {
                    padding: "3",
                    gap: "1.5"
                },
                addon: {
                    px: "3",
                    py: "1.5",
                    borderTopWidth: "1px"
                },
                indicator: (0, $85d8300c74ba233f$export$ecb1dc0d32e8f247).variants?.size.sm
            },
            md: {
                root: {
                    textStyle: "sm"
                },
                control: {
                    padding: "4",
                    gap: "2.5"
                },
                addon: {
                    px: "4",
                    py: "2",
                    borderTopWidth: "1px"
                },
                indicator: (0, $85d8300c74ba233f$export$ecb1dc0d32e8f247).variants?.size.md
            },
            lg: {
                root: {
                    textStyle: "md"
                },
                control: {
                    padding: "4",
                    gap: "3.5"
                },
                addon: {
                    px: "4",
                    py: "2",
                    borderTopWidth: "1px"
                },
                indicator: (0, $85d8300c74ba233f$export$ecb1dc0d32e8f247).variants?.size.lg
            }
        },
        variant: {
            surface: {
                root: {
                    borderWidth: "1px",
                    borderColor: "border",
                    _checked: {
                        bg: "colorPalette.subtle",
                        color: "colorPalette.fg",
                        borderColor: "colorPalette.muted"
                    },
                    _disabled: {
                        bg: "bg.muted"
                    }
                },
                indicator: (0, $85d8300c74ba233f$export$ecb1dc0d32e8f247).variants?.variant.solid
            },
            subtle: {
                root: {
                    bg: "bg.muted"
                },
                control: {
                    _checked: {
                        bg: "colorPalette.muted",
                        color: "colorPalette.fg"
                    }
                },
                indicator: (0, $85d8300c74ba233f$export$ecb1dc0d32e8f247).variants?.variant.plain
            },
            outline: {
                root: {
                    borderWidth: "1px",
                    borderColor: "border",
                    _checked: {
                        boxShadow: "0 0 0 1px var(--shadow-color)",
                        boxShadowColor: "colorPalette.solid",
                        borderColor: "colorPalette.solid"
                    }
                },
                indicator: (0, $85d8300c74ba233f$export$ecb1dc0d32e8f247).variants?.variant.solid
            },
            solid: {
                root: {
                    borderWidth: "1px",
                    _checked: {
                        bg: "colorPalette.solid",
                        color: "colorPalette.contrast",
                        borderColor: "colorPalette.solid"
                    }
                },
                indicator: (0, $85d8300c74ba233f$export$ecb1dc0d32e8f247).variants?.variant.inverted
            }
        },
        justify: {
            start: {
                root: {
                    "--checkbox-card-justify": "flex-start"
                }
            },
            end: {
                root: {
                    "--checkbox-card-justify": "flex-end"
                }
            },
            center: {
                root: {
                    "--checkbox-card-justify": "center"
                }
            }
        },
        align: {
            start: {
                root: {
                    "--checkbox-card-align": "flex-start"
                },
                content: {
                    textAlign: "start"
                }
            },
            end: {
                root: {
                    "--checkbox-card-align": "flex-end"
                },
                content: {
                    textAlign: "end"
                }
            },
            center: {
                root: {
                    "--checkbox-card-align": "center"
                },
                content: {
                    textAlign: "center"
                }
            }
        },
        orientation: {
            vertical: {
                control: {
                    flexDirection: "column"
                }
            },
            horizontal: {
                control: {
                    flexDirection: "row"
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "outline",
        align: "start",
        orientation: "horizontal"
    }
});








// src/collapsible.anatomy.ts
var $de63f46e9875c00e$export$477202748c7242bf = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("collapsible").parts("root", "trigger", "content");
var $de63f46e9875c00e$var$parts = $de63f46e9875c00e$export$477202748c7242bf.build();
var $de63f46e9875c00e$var$dom = (0, $b06ec5ff205338e5$export$41a9651decfe2bde)({
    getRootId: (ctx)=>ctx.ids?.root ?? `collapsible:${ctx.id}`,
    getContentId: (ctx)=>ctx.ids?.content ?? `collapsible:${ctx.id}:content`,
    getTriggerId: (ctx)=>ctx.ids?.trigger ?? `collapsible:${ctx.id}:trigger`,
    getRootEl: (ctx)=>$de63f46e9875c00e$var$dom.getById(ctx, $de63f46e9875c00e$var$dom.getRootId(ctx)),
    getContentEl: (ctx)=>$de63f46e9875c00e$var$dom.getById(ctx, $de63f46e9875c00e$var$dom.getContentId(ctx)),
    getTriggerEl: (ctx)=>$de63f46e9875c00e$var$dom.getById(ctx, $de63f46e9875c00e$var$dom.getTriggerId(ctx))
});
// src/collapsible.connect.ts
function $de63f46e9875c00e$export$64605811ab45167f(state, send, normalize) {
    const visible = state.matches("open", "closing");
    const open = state.matches("open");
    const height = state.context.height;
    const width = state.context.width;
    const disabled = !!state.context.disabled;
    const skip = !state.context.initial && open;
    return {
        disabled: disabled,
        visible: visible,
        open: open,
        measureSize () {
            send("SIZE.MEASURE");
        },
        setOpen (nextOpen) {
            if (nextOpen === open) return;
            send(nextOpen ? "OPEN" : "CLOSE");
        },
        getRootProps () {
            return normalize.element({
                ...$de63f46e9875c00e$var$parts.root.attrs,
                "data-state": open ? "open" : "closed",
                dir: state.context.dir,
                id: $de63f46e9875c00e$var$dom.getRootId(state.context)
            });
        },
        getContentProps () {
            return normalize.element({
                ...$de63f46e9875c00e$var$parts.content.attrs,
                "data-collapsible": "",
                "data-state": skip ? void 0 : open ? "open" : "closed",
                id: $de63f46e9875c00e$var$dom.getContentId(state.context),
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                hidden: !visible,
                style: {
                    "--height": height != null ? `${height}px` : void 0,
                    "--width": width != null ? `${width}px` : void 0
                }
            });
        },
        getTriggerProps () {
            return normalize.element({
                ...$de63f46e9875c00e$var$parts.trigger.attrs,
                id: $de63f46e9875c00e$var$dom.getTriggerId(state.context),
                dir: state.context.dir,
                type: "button",
                "data-state": open ? "open" : "closed",
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "aria-controls": $de63f46e9875c00e$var$dom.getContentId(state.context),
                "aria-expanded": visible || false,
                onClick (event) {
                    if (event.defaultPrevented) return;
                    if (disabled) return;
                    send({
                        type: open ? "CLOSE" : "OPEN",
                        src: "trigger.click"
                    });
                }
            });
        }
    };
}
function $de63f46e9875c00e$export$ea56d40cd27c3480(userContext) {
    const ctx = (0, $89352e0ddd72597a$export$8e16b83750b44988)(userContext);
    return (0, $5c0da97e9c7aa95f$export$aaa7fa18f8e9b2e8)({
        id: "collapsible",
        initial: ctx.open ? "open" : "closed",
        context: {
            ...ctx,
            height: 0,
            width: 0,
            initial: false,
            stylesRef: null,
            unmountAnimationName: null
        },
        watch: {
            open: [
                "setInitial",
                "computeSize",
                "toggleVisibility"
            ]
        },
        exit: [
            "clearInitial",
            "cleanupNode"
        ],
        states: {
            closed: {
                tags: [
                    "closed"
                ],
                on: {
                    "CONTROLLED.OPEN": "open",
                    OPEN: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnOpen"
                            ]
                        },
                        {
                            target: "open",
                            actions: [
                                "setInitial",
                                "computeSize",
                                "invokeOnOpen"
                            ]
                        }
                    ]
                }
            },
            closing: {
                tags: [
                    "open"
                ],
                activities: [
                    "trackExitAnimation"
                ],
                on: {
                    "CONTROLLED.CLOSE": "closed",
                    "CONTROLLED.OPEN": "open",
                    OPEN: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnOpen"
                            ]
                        },
                        {
                            target: "open",
                            actions: [
                                "setInitial",
                                "invokeOnOpen"
                            ]
                        }
                    ],
                    CLOSE: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnExitComplete"
                            ]
                        },
                        {
                            target: "closed",
                            actions: [
                                "setInitial",
                                "computeSize",
                                "invokeOnExitComplete"
                            ]
                        }
                    ],
                    "ANIMATION.END": {
                        target: "closed",
                        actions: [
                            "invokeOnExitComplete",
                            "clearInitial"
                        ]
                    }
                }
            },
            open: {
                tags: [
                    "open"
                ],
                activities: [
                    "trackEnterAnimation"
                ],
                on: {
                    "CONTROLLED.CLOSE": "closing",
                    CLOSE: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnClose"
                            ]
                        },
                        {
                            target: "closing",
                            actions: [
                                "setInitial",
                                "computeSize",
                                "invokeOnClose"
                            ]
                        }
                    ],
                    "SIZE.MEASURE": {
                        actions: [
                            "measureSize"
                        ]
                    },
                    "ANIMATION.END": {
                        actions: [
                            "clearInitial"
                        ]
                    }
                }
            }
        }
    }, {
        guards: {
            isOpenControlled: (ctx2)=>!!ctx2["open.controlled"]
        },
        activities: {
            trackEnterAnimation (ctx2, _evt, { send: send }) {
                let cleanup;
                const rafCleanup = (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>{
                    const contentEl = $de63f46e9875c00e$var$dom.getContentEl(ctx2);
                    if (!contentEl) return;
                    const animationName = (0, $b06ec5ff205338e5$export$3735103072e4a80)(contentEl).animationName;
                    const hasNoAnimation = !animationName || animationName === "none";
                    if (hasNoAnimation) {
                        send({
                            type: "ANIMATION.END"
                        });
                        return;
                    }
                    const onEnd = (event)=>{
                        const target = (0, $b06ec5ff205338e5$export$e58f029f0fbfdb29)(event);
                        if (target === contentEl) send({
                            type: "ANIMATION.END"
                        });
                    };
                    contentEl.addEventListener("animationend", onEnd);
                    cleanup = ()=>{
                        contentEl.removeEventListener("animationend", onEnd);
                    };
                });
                return ()=>{
                    rafCleanup();
                    cleanup?.();
                };
            },
            trackExitAnimation (ctx2, _evt, { send: send }) {
                let cleanup;
                const rafCleanup = (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>{
                    const contentEl = $de63f46e9875c00e$var$dom.getContentEl(ctx2);
                    if (!contentEl) return;
                    const animationName = (0, $b06ec5ff205338e5$export$3735103072e4a80)(contentEl).animationName;
                    const hasNoAnimation = !animationName || animationName === "none";
                    if (hasNoAnimation) {
                        send({
                            type: "ANIMATION.END"
                        });
                        return;
                    }
                    const onEnd = (event)=>{
                        const win = contentEl.ownerDocument.defaultView || window;
                        const animationName2 = win.getComputedStyle(contentEl).animationName;
                        const target = (0, $b06ec5ff205338e5$export$e58f029f0fbfdb29)(event);
                        if (target === contentEl && animationName2 === ctx2.unmountAnimationName) send({
                            type: "ANIMATION.END"
                        });
                    };
                    contentEl.addEventListener("animationend", onEnd);
                    cleanup = ()=>{
                        contentEl.removeEventListener("animationend", onEnd);
                    };
                });
                return ()=>{
                    rafCleanup();
                    cleanup?.();
                };
            }
        },
        actions: {
            setInitial (ctx2) {
                ctx2.initial = true;
            },
            clearInitial (ctx2) {
                (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>{
                    ctx2.initial = false;
                });
            },
            cleanupNode (ctx2) {
                ctx2.stylesRef = null;
            },
            measureSize (ctx2) {
                const contentEl = $de63f46e9875c00e$var$dom.getContentEl(ctx2);
                if (!contentEl) return;
                const { height: height, width: width } = contentEl.getBoundingClientRect();
                ctx2.height = height;
                ctx2.width = width;
            },
            computeSize (ctx2, evt) {
                ctx2._rafCleanup?.();
                ctx2._rafCleanup = (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>{
                    const contentEl = $de63f46e9875c00e$var$dom.getContentEl(ctx2);
                    if (!contentEl) return;
                    ctx2.stylesRef || (ctx2.stylesRef = (0, $7bf56e9c8ff12ab3$export$eff4d24c3ff7876e)({
                        animationName: contentEl.style.animationName,
                        animationDuration: contentEl.style.animationDuration
                    }));
                    if (evt.type === "CLOSE" || !ctx2.open) {
                        const win = contentEl.ownerDocument.defaultView || window;
                        ctx2.unmountAnimationName = win.getComputedStyle(contentEl).animationName;
                    }
                    const hidden = contentEl.hidden;
                    contentEl.style.animationName = "none";
                    contentEl.style.animationDuration = "0s";
                    contentEl.hidden = false;
                    const rect = contentEl.getBoundingClientRect();
                    ctx2.height = rect.height;
                    ctx2.width = rect.width;
                    if (ctx2.initial) {
                        contentEl.style.animationName = ctx2.stylesRef.animationName;
                        contentEl.style.animationDuration = ctx2.stylesRef.animationDuration;
                    }
                    contentEl.hidden = hidden;
                });
            },
            invokeOnOpen: (ctx2)=>{
                ctx2.onOpenChange?.({
                    open: true
                });
            },
            invokeOnClose: (ctx2)=>{
                ctx2.onOpenChange?.({
                    open: false
                });
            },
            invokeOnExitComplete (ctx2) {
                ctx2.onExitComplete?.();
            },
            toggleVisibility: (ctx2, _evt, { send: send })=>{
                send({
                    type: ctx2.open ? "CONTROLLED.OPEN" : "CONTROLLED.CLOSE"
                });
            }
        }
    });
}
var $de63f46e9875c00e$export$8128bb6492cf3de7 = (0, $5b359805fda5a40e$export$c94ea207b45fef3a)()([
    "dir",
    "disabled",
    "getRootNode",
    "id",
    "ids",
    "onExitComplete",
    "onOpenChange",
    "open.controlled",
    "open"
]);
var $de63f46e9875c00e$export$45029c61b0073d87 = (0, $89352e0ddd72597a$export$3ea53b214fbc1986)($de63f46e9875c00e$export$8128bb6492cf3de7);


"use strict";
const $fbb03d03218a1ba7$export$e9d5652bed1138b = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    slots: (0, $de63f46e9875c00e$export$477202748c7242bf).keys(),
    className: "chakra-collapsible",
    base: {
        content: {
            overflow: "hidden",
            _open: {
                animationName: "expand-height, fade-in",
                animationDuration: "moderate"
            },
            _closed: {
                animationName: "collapse-height, fade-out",
                animationDuration: "moderate"
            }
        }
    }
});







var $a863e86c6a9eaf22$var$__defProp = Object.defineProperty;
var $a863e86c6a9eaf22$var$__defNormalProp = (obj, key, value)=>key in obj ? $a863e86c6a9eaf22$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $a863e86c6a9eaf22$var$__publicField = (obj, key, value)=>$a863e86c6a9eaf22$var$__defNormalProp(obj, key + "", value);
// src/color-format-gradient.ts
var $a863e86c6a9eaf22$var$generateRGB_R = (orientation, dir, zValue)=>{
    const maskImage = `linear-gradient(to ${orientation[Number(!dir)]}, transparent, #000)`;
    const result = {
        areaStyles: {
            backgroundImage: `linear-gradient(to ${orientation[Number(dir)]},rgb(${zValue},0,0),rgb(${zValue},255,0))`
        },
        areaGradientStyles: {
            backgroundImage: `linear-gradient(to ${orientation[Number(dir)]},rgb(${zValue},0,255),rgb(${zValue},255,255))`,
            WebkitMaskImage: maskImage,
            maskImage: maskImage
        }
    };
    return result;
};
var $a863e86c6a9eaf22$var$generateRGB_G = (orientation, dir, zValue)=>{
    const maskImage = `linear-gradient(to ${orientation[Number(!dir)]}, transparent, #000)`;
    const result = {
        areaStyles: {
            backgroundImage: `linear-gradient(to ${orientation[Number(dir)]},rgb(0,${zValue},0),rgb(255,${zValue},0))`
        },
        areaGradientStyles: {
            backgroundImage: `linear-gradient(to ${orientation[Number(dir)]},rgb(0,${zValue},255),rgb(255,${zValue},255))`,
            WebkitMaskImage: maskImage,
            maskImage: maskImage
        }
    };
    return result;
};
var $a863e86c6a9eaf22$var$generateRGB_B = (orientation, dir, zValue)=>{
    const maskImage = `linear-gradient(to ${orientation[Number(!dir)]}, transparent, #000)`;
    const result = {
        areaStyles: {
            backgroundImage: `linear-gradient(to ${orientation[Number(dir)]},rgb(0,0,${zValue}),rgb(255,0,${zValue}))`
        },
        areaGradientStyles: {
            backgroundImage: `linear-gradient(to ${orientation[Number(dir)]},rgb(0,255,${zValue}),rgb(255,255,${zValue}))`,
            WebkitMaskImage: maskImage,
            maskImage: maskImage
        }
    };
    return result;
};
var $a863e86c6a9eaf22$var$generateHSL_H = (orientation, dir, zValue)=>{
    const result = {
        areaStyles: {},
        areaGradientStyles: {
            background: [
                `linear-gradient(to ${orientation[Number(dir)]}, hsla(0,0%,0%,1) 0%, hsla(0,0%,0%,0) 50%, hsla(0,0%,100%,0) 50%, hsla(0,0%,100%,1) 100%)`,
                `linear-gradient(to ${orientation[Number(!dir)]},hsl(0,0%,50%),hsla(0,0%,50%,0))`,
                `hsl(${zValue}, 100%, 50%)`
            ].join(",")
        }
    };
    return result;
};
var $a863e86c6a9eaf22$var$generateHSL_S = (orientation, dir, alphaValue)=>{
    const result = {
        areaStyles: {},
        areaGradientStyles: {
            background: [
                `linear-gradient(to ${orientation[Number(!dir)]}, hsla(0,0%,0%,${alphaValue}) 0%, hsla(0,0%,0%,0) 50%, hsla(0,0%,100%,0) 50%, hsla(0,0%,100%,${alphaValue}) 100%)`,
                `linear-gradient(to ${orientation[Number(dir)]},hsla(0,100%,50%,${alphaValue}),hsla(60,100%,50%,${alphaValue}),hsla(120,100%,50%,${alphaValue}),hsla(180,100%,50%,${alphaValue}),hsla(240,100%,50%,${alphaValue}),hsla(300,100%,50%,${alphaValue}),hsla(359,100%,50%,${alphaValue}))`,
                "hsl(0, 0%, 50%)"
            ].join(",")
        }
    };
    return result;
};
var $a863e86c6a9eaf22$var$generateHSL_L = (orientation, dir, zValue)=>{
    const result = {
        areaStyles: {},
        areaGradientStyles: {
            backgroundImage: [
                `linear-gradient(to ${orientation[Number(!dir)]},hsl(0,0%,${zValue}%),hsla(0,0%,${zValue}%,0))`,
                `linear-gradient(to ${orientation[Number(dir)]},hsl(0,100%,${zValue}%),hsl(60,100%,${zValue}%),hsl(120,100%,${zValue}%),hsl(180,100%,${zValue}%),hsl(240,100%,${zValue}%),hsl(300,100%,${zValue}%),hsl(360,100%,${zValue}%))`
            ].join(",")
        }
    };
    return result;
};
var $a863e86c6a9eaf22$var$generateHSB_H = (orientation, dir, zValue)=>{
    const result = {
        areaStyles: {},
        areaGradientStyles: {
            background: [
                `linear-gradient(to ${orientation[Number(dir)]},hsl(0,0%,0%),hsla(0,0%,0%,0))`,
                `linear-gradient(to ${orientation[Number(!dir)]},hsl(0,0%,100%),hsla(0,0%,100%,0))`,
                `hsl(${zValue}, 100%, 50%)`
            ].join(",")
        }
    };
    return result;
};
var $a863e86c6a9eaf22$var$generateHSB_S = (orientation, dir, alphaValue)=>{
    const result = {
        areaStyles: {},
        areaGradientStyles: {
            background: [
                `linear-gradient(to ${orientation[Number(!dir)]},hsla(0,0%,0%,${alphaValue}),hsla(0,0%,0%,0))`,
                `linear-gradient(to ${orientation[Number(dir)]},hsla(0,100%,50%,${alphaValue}),hsla(60,100%,50%,${alphaValue}),hsla(120,100%,50%,${alphaValue}),hsla(180,100%,50%,${alphaValue}),hsla(240,100%,50%,${alphaValue}),hsla(300,100%,50%,${alphaValue}),hsla(359,100%,50%,${alphaValue}))`,
                `linear-gradient(to ${orientation[Number(!dir)]},hsl(0,0%,0%),hsl(0,0%,100%))`
            ].join(",")
        }
    };
    return result;
};
var $a863e86c6a9eaf22$var$generateHSB_B = (orientation, dir, alphaValue)=>{
    const result = {
        areaStyles: {},
        areaGradientStyles: {
            background: [
                `linear-gradient(to ${orientation[Number(!dir)]},hsla(0,0%,100%,${alphaValue}),hsla(0,0%,100%,0))`,
                `linear-gradient(to ${orientation[Number(dir)]},hsla(0,100%,50%,${alphaValue}),hsla(60,100%,50%,${alphaValue}),hsla(120,100%,50%,${alphaValue}),hsla(180,100%,50%,${alphaValue}),hsla(240,100%,50%,${alphaValue}),hsla(300,100%,50%,${alphaValue}),hsla(359,100%,50%,${alphaValue}))`,
                "#000"
            ].join(",")
        }
    };
    return result;
};
// src/area-gradient.ts
function $a863e86c6a9eaf22$export$71082afb279a4688(color, options) {
    const { xChannel: xChannel, yChannel: yChannel, dir: dirProp = "ltr" } = options;
    const { zChannel: zChannel } = color.getColorAxes({
        xChannel: xChannel,
        yChannel: yChannel
    });
    const zValue = color.getChannelValue(zChannel);
    const { minValue: zMin, maxValue: zMax } = color.getChannelRange(zChannel);
    const orientation = [
        "top",
        dirProp === "rtl" ? "left" : "right"
    ];
    let dir = false;
    let background = {
        areaStyles: {},
        areaGradientStyles: {}
    };
    let alphaValue = (zValue - zMin) / (zMax - zMin);
    let isHSL = color.getFormat() === "hsla";
    switch(zChannel){
        case "red":
            dir = xChannel === "green";
            background = $a863e86c6a9eaf22$var$generateRGB_R(orientation, dir, zValue);
            break;
        case "green":
            dir = xChannel === "red";
            background = $a863e86c6a9eaf22$var$generateRGB_G(orientation, dir, zValue);
            break;
        case "blue":
            dir = xChannel === "red";
            background = $a863e86c6a9eaf22$var$generateRGB_B(orientation, dir, zValue);
            break;
        case "hue":
            dir = xChannel !== "saturation";
            if (isHSL) background = $a863e86c6a9eaf22$var$generateHSL_H(orientation, dir, zValue);
            else background = $a863e86c6a9eaf22$var$generateHSB_H(orientation, dir, zValue);
            break;
        case "saturation":
            dir = xChannel === "hue";
            if (isHSL) background = $a863e86c6a9eaf22$var$generateHSL_S(orientation, dir, alphaValue);
            else background = $a863e86c6a9eaf22$var$generateHSB_S(orientation, dir, alphaValue);
            break;
        case "brightness":
            dir = xChannel === "hue";
            background = $a863e86c6a9eaf22$var$generateHSB_B(orientation, dir, alphaValue);
            break;
        case "lightness":
            dir = xChannel === "hue";
            background = $a863e86c6a9eaf22$var$generateHSL_L(orientation, dir, zValue);
            break;
    }
    return background;
}
var $a863e86c6a9eaf22$var$isEqualObject = (a, b)=>{
    if (Object.keys(a).length !== Object.keys(b).length) return false;
    for(let key in a)if (a[key] !== b[key]) return false;
    return true;
};
var $a863e86c6a9eaf22$export$892596cec99bc70e = class {
    toHexInt() {
        return this.toFormat("rgba").toHexInt();
    }
    getChannelValue(channel) {
        if (channel in this) return this[channel];
        throw new Error("Unsupported color channel: " + channel);
    }
    getChannelValuePercent(channel, valueToCheck) {
        const value = valueToCheck ?? this.getChannelValue(channel);
        const { minValue: minValue, maxValue: maxValue } = this.getChannelRange(channel);
        return (0, $89352e0ddd72597a$export$22574034cd380c24)(value, minValue, maxValue);
    }
    getChannelPercentValue(channel, percentToCheck) {
        const { minValue: minValue, maxValue: maxValue, step: step } = this.getChannelRange(channel);
        const percentValue = (0, $89352e0ddd72597a$export$476354dbf49bdff6)(percentToCheck, minValue, maxValue, step);
        return (0, $89352e0ddd72597a$export$cb6e0bb50bc19463)(percentValue, minValue, maxValue, step);
    }
    withChannelValue(channel, value) {
        const { minValue: minValue, maxValue: maxValue } = this.getChannelRange(channel);
        if (channel in this) {
            let clone = this.clone();
            clone[channel] = (0, $89352e0ddd72597a$export$31ee16100cde6ce2)(value, minValue, maxValue);
            return clone;
        }
        throw new Error("Unsupported color channel: " + channel);
    }
    getColorAxes(xyChannels) {
        let { xChannel: xChannel, yChannel: yChannel } = xyChannels;
        let xCh = xChannel || this.getChannels().find((c)=>c !== yChannel);
        let yCh = yChannel || this.getChannels().find((c)=>c !== xCh);
        let zCh = this.getChannels().find((c)=>c !== xCh && c !== yCh);
        return {
            xChannel: xCh,
            yChannel: yCh,
            zChannel: zCh
        };
    }
    incrementChannel(channel, stepSize) {
        const { minValue: minValue, maxValue: maxValue, step: step } = this.getChannelRange(channel);
        const value = (0, $89352e0ddd72597a$export$cb6e0bb50bc19463)((0, $89352e0ddd72597a$export$31ee16100cde6ce2)(this.getChannelValue(channel) + stepSize, minValue, maxValue), minValue, maxValue, step);
        return this.withChannelValue(channel, value);
    }
    decrementChannel(channel, stepSize) {
        return this.incrementChannel(channel, -stepSize);
    }
    isEqual(color) {
        const isSame = $a863e86c6a9eaf22$var$isEqualObject(this.toJSON(), color.toJSON());
        return isSame && this.getChannelValue("alpha") === color.getChannelValue("alpha");
    }
};
var $a863e86c6a9eaf22$var$_RGBColor = class _RGBColor extends $a863e86c6a9eaf22$export$892596cec99bc70e {
    constructor(red, green, blue, alpha){
        super();
        this.red = red;
        this.green = green;
        this.blue = blue;
        this.alpha = alpha;
    }
    static parse(value) {
        let colors = [];
        if (/^#[\da-f]+$/i.test(value) && [
            4,
            5,
            7,
            9
        ].includes(value.length)) {
            const values = (value.length < 6 ? value.replace(/[^#]/gi, "$&$&") : value).slice(1).split("");
            while(values.length > 0)colors.push(parseInt(values.splice(0, 2).join(""), 16));
            colors[3] = colors[3] !== void 0 ? colors[3] / 255 : void 0;
        }
        const match = value.match(/^rgba?\((.*)\)$/);
        if (match?.[1]) colors = match[1].split(",").map((value2)=>Number(value2.trim())).map((num, i)=>(0, $89352e0ddd72597a$export$31ee16100cde6ce2)(num, 0, i < 3 ? 255 : 1));
        return colors.length < 3 ? void 0 : new _RGBColor(colors[0], colors[1], colors[2], colors[3] ?? 1);
    }
    toString(format) {
        switch(format){
            case "hex":
                return "#" + (this.red.toString(16).padStart(2, "0") + this.green.toString(16).padStart(2, "0") + this.blue.toString(16).padStart(2, "0")).toUpperCase();
            case "hexa":
                return "#" + (this.red.toString(16).padStart(2, "0") + this.green.toString(16).padStart(2, "0") + this.blue.toString(16).padStart(2, "0") + Math.round(this.alpha * 255).toString(16).padStart(2, "0")).toUpperCase();
            case "rgb":
                return `rgb(${this.red}, ${this.green}, ${this.blue})`;
            case "css":
            case "rgba":
                return `rgba(${this.red}, ${this.green}, ${this.blue}, ${this.alpha})`;
            case "hsl":
                return this.toHSL().toString("hsl");
            case "hsb":
                return this.toHSB().toString("hsb");
            default:
                return this.toFormat(format).toString(format);
        }
    }
    toFormat(format) {
        switch(format){
            case "rgba":
                return this;
            case "hsba":
                return this.toHSB();
            case "hsla":
                return this.toHSL();
            default:
                throw new Error("Unsupported color conversion: rgb -> " + format);
        }
    }
    toHexInt() {
        return this.red << 16 | this.green << 8 | this.blue;
    }
    /**
   * Converts an RGB color value to HSB.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#From_RGB.
   * @returns An HSBColor object.
   */ toHSB() {
        const red = this.red / 255;
        const green = this.green / 255;
        const blue = this.blue / 255;
        const min = Math.min(red, green, blue);
        const brightness = Math.max(red, green, blue);
        const chroma = brightness - min;
        const saturation = brightness === 0 ? 0 : chroma / brightness;
        let hue = 0;
        if (chroma !== 0) {
            switch(brightness){
                case red:
                    hue = (green - blue) / chroma + (green < blue ? 6 : 0);
                    break;
                case green:
                    hue = (blue - red) / chroma + 2;
                    break;
                case blue:
                    hue = (red - green) / chroma + 4;
                    break;
            }
            hue /= 6;
        }
        return new $a863e86c6a9eaf22$var$HSBColor((0, $89352e0ddd72597a$export$b6268554fba451f)(hue * 360, 2), (0, $89352e0ddd72597a$export$b6268554fba451f)(saturation * 100, 2), (0, $89352e0ddd72597a$export$b6268554fba451f)(brightness * 100, 2), (0, $89352e0ddd72597a$export$b6268554fba451f)(this.alpha, 2));
    }
    /**
   * Converts an RGB color value to HSL.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#From_RGB.
   * @returns An HSLColor object.
   */ toHSL() {
        const red = this.red / 255;
        const green = this.green / 255;
        const blue = this.blue / 255;
        const min = Math.min(red, green, blue);
        const max = Math.max(red, green, blue);
        const lightness = (max + min) / 2;
        const chroma = max - min;
        let hue = -1;
        let saturation = -1;
        if (chroma === 0) hue = saturation = 0;
        else {
            saturation = chroma / (lightness < 0.5 ? max + min : 2 - max - min);
            switch(max){
                case red:
                    hue = (green - blue) / chroma + (green < blue ? 6 : 0);
                    break;
                case green:
                    hue = (blue - red) / chroma + 2;
                    break;
                case blue:
                    hue = (red - green) / chroma + 4;
                    break;
            }
            hue /= 6;
        }
        return new $a863e86c6a9eaf22$var$HSLColor((0, $89352e0ddd72597a$export$b6268554fba451f)(hue * 360, 2), (0, $89352e0ddd72597a$export$b6268554fba451f)(saturation * 100, 2), (0, $89352e0ddd72597a$export$b6268554fba451f)(lightness * 100, 2), (0, $89352e0ddd72597a$export$b6268554fba451f)(this.alpha, 2));
    }
    clone() {
        return new _RGBColor(this.red, this.green, this.blue, this.alpha);
    }
    getChannelFormatOptions(channel) {
        switch(channel){
            case "red":
            case "green":
            case "blue":
                return {
                    style: "decimal"
                };
            case "alpha":
                return {
                    style: "percent"
                };
            default:
                throw new Error("Unknown color channel: " + channel);
        }
    }
    formatChannelValue(channel, locale) {
        let options = this.getChannelFormatOptions(channel);
        let value = this.getChannelValue(channel);
        return new Intl.NumberFormat(locale, options).format(value);
    }
    getChannelRange(channel) {
        switch(channel){
            case "red":
            case "green":
            case "blue":
                return {
                    minValue: 0,
                    maxValue: 255,
                    step: 1,
                    pageSize: 17
                };
            case "alpha":
                return {
                    minValue: 0,
                    maxValue: 1,
                    step: 0.01,
                    pageSize: 0.1
                };
            default:
                throw new Error("Unknown color channel: " + channel);
        }
    }
    toJSON() {
        return {
            r: this.red,
            g: this.green,
            b: this.blue,
            a: this.alpha
        };
    }
    getFormat() {
        return "rgba";
    }
    getChannels() {
        return _RGBColor.colorChannels;
    }
};
$a863e86c6a9eaf22$var$__publicField($a863e86c6a9eaf22$var$_RGBColor, "colorChannels", [
    "red",
    "green",
    "blue"
]);
var $a863e86c6a9eaf22$var$RGBColor = $a863e86c6a9eaf22$var$_RGBColor;
// src/hsl-color.ts
var $a863e86c6a9eaf22$var$HSL_REGEX = /hsl\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%)\)|hsla\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d(.\d+)?)\)/;
var $a863e86c6a9eaf22$var$_HSLColor = class _HSLColor extends $a863e86c6a9eaf22$export$892596cec99bc70e {
    constructor(hue, saturation, lightness, alpha){
        super();
        this.hue = hue;
        this.saturation = saturation;
        this.lightness = lightness;
        this.alpha = alpha;
    }
    static parse(value) {
        let m;
        if (m = value.match($a863e86c6a9eaf22$var$HSL_REGEX)) {
            const [h, s, l, a] = (m[1] ?? m[2]).split(",").map((n)=>Number(n.trim().replace("%", "")));
            return new _HSLColor((0, $89352e0ddd72597a$export$842a2cf37af977e1)(h, 360), (0, $89352e0ddd72597a$export$31ee16100cde6ce2)(s, 0, 100), (0, $89352e0ddd72597a$export$31ee16100cde6ce2)(l, 0, 100), (0, $89352e0ddd72597a$export$31ee16100cde6ce2)(a ?? 1, 0, 1));
        }
    }
    toString(format) {
        switch(format){
            case "hex":
                return this.toRGB().toString("hex");
            case "hexa":
                return this.toRGB().toString("hexa");
            case "hsl":
                return `hsl(${this.hue}, ${(0, $89352e0ddd72597a$export$b6268554fba451f)(this.saturation, 2)}%, ${(0, $89352e0ddd72597a$export$b6268554fba451f)(this.lightness, 2)}%)`;
            case "css":
            case "hsla":
                return `hsla(${this.hue}, ${(0, $89352e0ddd72597a$export$b6268554fba451f)(this.saturation, 2)}%, ${(0, $89352e0ddd72597a$export$b6268554fba451f)(this.lightness, 2)}%, ${this.alpha})`;
            case "hsb":
                return this.toHSB().toString("hsb");
            case "rgb":
                return this.toRGB().toString("rgb");
            default:
                return this.toFormat(format).toString(format);
        }
    }
    toFormat(format) {
        switch(format){
            case "hsla":
                return this;
            case "hsba":
                return this.toHSB();
            case "rgba":
                return this.toRGB();
            default:
                throw new Error("Unsupported color conversion: hsl -> " + format);
        }
    }
    /**
   * Converts a HSL color to HSB.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSL_to_HSV.
   * @returns An HSBColor object.
   */ toHSB() {
        let saturation = this.saturation / 100;
        let lightness = this.lightness / 100;
        let brightness = lightness + saturation * Math.min(lightness, 1 - lightness);
        saturation = brightness === 0 ? 0 : 2 * (1 - lightness / brightness);
        return new $a863e86c6a9eaf22$var$HSBColor((0, $89352e0ddd72597a$export$b6268554fba451f)(this.hue, 2), (0, $89352e0ddd72597a$export$b6268554fba451f)(saturation * 100, 2), (0, $89352e0ddd72597a$export$b6268554fba451f)(brightness * 100, 2), (0, $89352e0ddd72597a$export$b6268554fba451f)(this.alpha, 2));
    }
    /**
   * Converts a HSL color to RGB.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSL_to_RGB_alternative.
   * @returns An RGBColor object.
   */ toRGB() {
        let hue = this.hue;
        let saturation = this.saturation / 100;
        let lightness = this.lightness / 100;
        let a = saturation * Math.min(lightness, 1 - lightness);
        let fn = (n, k = (n + hue / 30) % 12)=>lightness - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
        return new $a863e86c6a9eaf22$var$RGBColor(Math.round(fn(0) * 255), Math.round(fn(8) * 255), Math.round(fn(4) * 255), (0, $89352e0ddd72597a$export$b6268554fba451f)(this.alpha, 2));
    }
    clone() {
        return new _HSLColor(this.hue, this.saturation, this.lightness, this.alpha);
    }
    getChannelFormatOptions(channel) {
        switch(channel){
            case "hue":
                return {
                    style: "unit",
                    unit: "degree",
                    unitDisplay: "narrow"
                };
            case "saturation":
            case "lightness":
            case "alpha":
                return {
                    style: "percent"
                };
            default:
                throw new Error("Unknown color channel: " + channel);
        }
    }
    formatChannelValue(channel, locale) {
        let options = this.getChannelFormatOptions(channel);
        let value = this.getChannelValue(channel);
        if (channel === "saturation" || channel === "lightness") value /= 100;
        return new Intl.NumberFormat(locale, options).format(value);
    }
    getChannelRange(channel) {
        switch(channel){
            case "hue":
                return {
                    minValue: 0,
                    maxValue: 360,
                    step: 1,
                    pageSize: 15
                };
            case "saturation":
            case "lightness":
                return {
                    minValue: 0,
                    maxValue: 100,
                    step: 1,
                    pageSize: 10
                };
            case "alpha":
                return {
                    minValue: 0,
                    maxValue: 1,
                    step: 0.01,
                    pageSize: 0.1
                };
            default:
                throw new Error("Unknown color channel: " + channel);
        }
    }
    toJSON() {
        return {
            h: this.hue,
            s: this.saturation,
            l: this.lightness,
            a: this.alpha
        };
    }
    getFormat() {
        return "hsla";
    }
    getChannels() {
        return _HSLColor.colorChannels;
    }
};
$a863e86c6a9eaf22$var$__publicField($a863e86c6a9eaf22$var$_HSLColor, "colorChannels", [
    "hue",
    "saturation",
    "lightness"
]);
var $a863e86c6a9eaf22$var$HSLColor = $a863e86c6a9eaf22$var$_HSLColor;
// src/hsb-color.ts
var $a863e86c6a9eaf22$var$HSB_REGEX = /hsb\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%)\)|hsba\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d(.\d+)?)\)/;
var $a863e86c6a9eaf22$var$_HSBColor = class _HSBColor extends $a863e86c6a9eaf22$export$892596cec99bc70e {
    constructor(hue, saturation, brightness, alpha){
        super();
        this.hue = hue;
        this.saturation = saturation;
        this.brightness = brightness;
        this.alpha = alpha;
    }
    static parse(value) {
        let m;
        if (m = value.match($a863e86c6a9eaf22$var$HSB_REGEX)) {
            const [h, s, b, a] = (m[1] ?? m[2]).split(",").map((n)=>Number(n.trim().replace("%", "")));
            return new _HSBColor((0, $89352e0ddd72597a$export$842a2cf37af977e1)(h, 360), (0, $89352e0ddd72597a$export$31ee16100cde6ce2)(s, 0, 100), (0, $89352e0ddd72597a$export$31ee16100cde6ce2)(b, 0, 100), (0, $89352e0ddd72597a$export$31ee16100cde6ce2)(a ?? 1, 0, 1));
        }
    }
    toString(format) {
        switch(format){
            case "css":
                return this.toHSL().toString("css");
            case "hex":
                return this.toRGB().toString("hex");
            case "hexa":
                return this.toRGB().toString("hexa");
            case "hsb":
                return `hsb(${this.hue}, ${(0, $89352e0ddd72597a$export$b6268554fba451f)(this.saturation, 2)}%, ${(0, $89352e0ddd72597a$export$b6268554fba451f)(this.brightness, 2)}%)`;
            case "hsba":
                return `hsba(${this.hue}, ${(0, $89352e0ddd72597a$export$b6268554fba451f)(this.saturation, 2)}%, ${(0, $89352e0ddd72597a$export$b6268554fba451f)(this.brightness, 2)}%, ${this.alpha})`;
            case "hsl":
                return this.toHSL().toString("hsl");
            case "rgb":
                return this.toRGB().toString("rgb");
            default:
                return this.toFormat(format).toString(format);
        }
    }
    toFormat(format) {
        switch(format){
            case "hsba":
                return this;
            case "hsla":
                return this.toHSL();
            case "rgba":
                return this.toRGB();
            default:
                throw new Error("Unsupported color conversion: hsb -> " + format);
        }
    }
    /**
   * Converts a HSB color to HSL.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSV_to_HSL.
   * @returns An HSLColor object.
   */ toHSL() {
        let saturation = this.saturation / 100;
        let brightness = this.brightness / 100;
        let lightness = brightness * (1 - saturation / 2);
        saturation = lightness === 0 || lightness === 1 ? 0 : (brightness - lightness) / Math.min(lightness, 1 - lightness);
        return new $a863e86c6a9eaf22$var$HSLColor((0, $89352e0ddd72597a$export$b6268554fba451f)(this.hue, 2), (0, $89352e0ddd72597a$export$b6268554fba451f)(saturation * 100, 2), (0, $89352e0ddd72597a$export$b6268554fba451f)(lightness * 100, 2), (0, $89352e0ddd72597a$export$b6268554fba451f)(this.alpha, 2));
    }
    /**
   * Converts a HSV color value to RGB.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSV_to_RGB_alternative.
   * @returns An RGBColor object.
   */ toRGB() {
        let hue = this.hue;
        let saturation = this.saturation / 100;
        let brightness = this.brightness / 100;
        let fn = (n, k = (n + hue / 60) % 6)=>brightness - saturation * brightness * Math.max(Math.min(k, 4 - k, 1), 0);
        return new $a863e86c6a9eaf22$var$RGBColor(Math.round(fn(5) * 255), Math.round(fn(3) * 255), Math.round(fn(1) * 255), (0, $89352e0ddd72597a$export$b6268554fba451f)(this.alpha, 2));
    }
    clone() {
        return new _HSBColor(this.hue, this.saturation, this.brightness, this.alpha);
    }
    getChannelFormatOptions(channel) {
        switch(channel){
            case "hue":
                return {
                    style: "unit",
                    unit: "degree",
                    unitDisplay: "narrow"
                };
            case "saturation":
            case "brightness":
            case "alpha":
                return {
                    style: "percent"
                };
            default:
                throw new Error("Unknown color channel: " + channel);
        }
    }
    formatChannelValue(channel, locale) {
        let options = this.getChannelFormatOptions(channel);
        let value = this.getChannelValue(channel);
        if (channel === "saturation" || channel === "brightness") value /= 100;
        return new Intl.NumberFormat(locale, options).format(value);
    }
    getChannelRange(channel) {
        switch(channel){
            case "hue":
                return {
                    minValue: 0,
                    maxValue: 360,
                    step: 1,
                    pageSize: 15
                };
            case "saturation":
            case "brightness":
                return {
                    minValue: 0,
                    maxValue: 100,
                    step: 1,
                    pageSize: 10
                };
            case "alpha":
                return {
                    minValue: 0,
                    maxValue: 1,
                    step: 0.01,
                    pageSize: 0.1
                };
            default:
                throw new Error("Unknown color channel: " + channel);
        }
    }
    toJSON() {
        return {
            h: this.hue,
            s: this.saturation,
            b: this.brightness,
            a: this.alpha
        };
    }
    getFormat() {
        return "hsba";
    }
    getChannels() {
        return _HSBColor.colorChannels;
    }
};
$a863e86c6a9eaf22$var$__publicField($a863e86c6a9eaf22$var$_HSBColor, "colorChannels", [
    "hue",
    "saturation",
    "brightness"
]);
var $a863e86c6a9eaf22$var$HSBColor = $a863e86c6a9eaf22$var$_HSBColor;
// src/native-color.ts
var $a863e86c6a9eaf22$var$nativeColors = "aliceblue:f0f8ff,antiquewhite:faebd7,aqua:00ffff,aquamarine:7fffd4,azure:f0ffff,beige:f5f5dc,bisque:ffe4c4,black:000000,blanchedalmond:ffebcd,blue:0000ff,blueviolet:8a2be2,brown:a52a2a,burlywood:deb887,cadetblue:5f9ea0,chartreuse:7fff00,chocolate:d2691e,coral:ff7f50,cornflowerblue:6495ed,cornsilk:fff8dc,crimson:dc143c,cyan:00ffff,darkblue:00008b,darkcyan:008b8b,darkgoldenrod:b8860b,darkgray:a9a9a9,darkgreen:006400,darkkhaki:bdb76b,darkmagenta:8b008b,darkolivegreen:556b2f,darkorange:ff8c00,darkorchid:9932cc,darkred:8b0000,darksalmon:e9967a,darkseagreen:8fbc8f,darkslateblue:483d8b,darkslategray:2f4f4f,darkturquoise:00ced1,darkviolet:9400d3,deeppink:ff1493,deepskyblue:00bfff,dimgray:696969,dodgerblue:1e90ff,firebrick:b22222,floralwhite:fffaf0,forestgreen:228b22,fuchsia:ff00ff,gainsboro:dcdcdc,ghostwhite:f8f8ff,gold:ffd700,goldenrod:daa520,gray:808080,green:008000,greenyellow:adff2f,honeydew:f0fff0,hotpink:ff69b4,indianred:cd5c5c,indigo:4b0082,ivory:fffff0,khaki:f0e68c,lavender:e6e6fa,lavenderblush:fff0f5,lawngreen:7cfc00,lemonchiffon:fffacd,lightblue:add8e6,lightcoral:f08080,lightcyan:e0ffff,lightgoldenrodyellow:fafad2,lightgrey:d3d3d3,lightgreen:90ee90,lightpink:ffb6c1,lightsalmon:ffa07a,lightseagreen:20b2aa,lightskyblue:87cefa,lightslategray:778899,lightsteelblue:b0c4de,lightyellow:ffffe0,lime:00ff00,limegreen:32cd32,linen:faf0e6,magenta:ff00ff,maroon:800000,mediumaquamarine:66cdaa,mediumblue:0000cd,mediumorchid:ba55d3,mediumpurple:9370d8,mediumseagreen:3cb371,mediumslateblue:7b68ee,mediumspringgreen:00fa9a,mediumturquoise:48d1cc,mediumvioletred:c71585,midnightblue:191970,mintcream:f5fffa,mistyrose:ffe4e1,moccasin:ffe4b5,navajowhite:ffdead,navy:000080,oldlace:fdf5e6,olive:808000,olivedrab:6b8e23,orange:ffa500,orangered:ff4500,orchid:da70d6,palegoldenrod:eee8aa,palegreen:98fb98,paleturquoise:afeeee,palevioletred:d87093,papayawhip:ffefd5,peachpuff:ffdab9,peru:cd853f,pink:ffc0cb,plum:dda0dd,powderblue:b0e0e6,purple:800080,rebeccapurple:663399,red:ff0000,rosybrown:bc8f8f,royalblue:4169e1,saddlebrown:8b4513,salmon:fa8072,sandybrown:f4a460,seagreen:2e8b57,seashell:fff5ee,sienna:a0522d,silver:c0c0c0,skyblue:87ceeb,slateblue:6a5acd,slategray:708090,snow:fffafa,springgreen:00ff7f,steelblue:4682b4,tan:d2b48c,teal:008080,thistle:d8bfd8,tomato:ff6347,turquoise:40e0d0,violet:ee82ee,wheat:f5deb3,white:ffffff,whitesmoke:f5f5f5,yellow:ffff00,yellowgreen:9acd32";
var $a863e86c6a9eaf22$var$makeMap = (str)=>{
    const map = /* @__PURE__ */ new Map();
    const list = str.split(",");
    for(let i = 0; i < list.length; i++){
        const [key, val] = list[i].split(":");
        map.set(key, `#${val}`);
        if (key.includes("gray")) map.set(key.replace("gray", "grey"), `#${val}`);
    }
    return map;
};
var $a863e86c6a9eaf22$var$nativeColorMap = $a863e86c6a9eaf22$var$makeMap($a863e86c6a9eaf22$var$nativeColors);
// src/parse-color.ts
var $a863e86c6a9eaf22$export$6e865ea70d7724f = (value)=>{
    if ($a863e86c6a9eaf22$var$nativeColorMap.has(value)) return $a863e86c6a9eaf22$export$6e865ea70d7724f($a863e86c6a9eaf22$var$nativeColorMap.get(value));
    const result = $a863e86c6a9eaf22$var$RGBColor.parse(value) || $a863e86c6a9eaf22$var$HSBColor.parse(value) || $a863e86c6a9eaf22$var$HSLColor.parse(value);
    if (!result) {
        const error = new Error("Invalid color value: " + value);
        Error.captureStackTrace?.(error, $a863e86c6a9eaf22$export$6e865ea70d7724f);
        throw error;
    }
    return result;
};
var $a863e86c6a9eaf22$export$4cde5df63f53f473 = (v)=>{
    return typeof v === "string" ? $a863e86c6a9eaf22$export$6e865ea70d7724f(v) : v;
};







// src/color-picker.anatomy.ts
var $afb42e444b074e48$export$477202748c7242bf = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("color-picker", [
    "root",
    "label",
    "control",
    "trigger",
    "positioner",
    "content",
    "area",
    "areaThumb",
    "valueText",
    "areaBackground",
    "channelSlider",
    "channelSliderLabel",
    "channelSliderTrack",
    "channelSliderThumb",
    "channelSliderValueText",
    "channelInput",
    "transparencyGrid",
    "swatchGroup",
    "swatchTrigger",
    "swatchIndicator",
    "swatch",
    "eyeDropperTrigger",
    "formatTrigger",
    "formatSelect"
]);
var $afb42e444b074e48$var$parts = $afb42e444b074e48$export$477202748c7242bf.build();
var $afb42e444b074e48$var$dom = (0, $b06ec5ff205338e5$export$41a9651decfe2bde)({
    getRootId: (ctx)=>ctx.ids?.root ?? `color-picker:${ctx.id}`,
    getLabelId: (ctx)=>ctx.ids?.label ?? `color-picker:${ctx.id}:label`,
    getHiddenInputId: (ctx)=>ctx.ids?.hiddenInput ?? `color-picker:${ctx.id}:hidden-input`,
    getControlId: (ctx)=>ctx.ids?.control ?? `color-picker:${ctx.id}:control`,
    getTriggerId: (ctx)=>ctx.ids?.trigger ?? `color-picker:${ctx.id}:trigger`,
    getContentId: (ctx)=>ctx.ids?.content ?? `color-picker:${ctx.id}:content`,
    getPositionerId: (ctx)=>ctx.ids?.positioner ?? `color-picker:${ctx.id}:positioner`,
    getFormatSelectId: (ctx)=>ctx.ids?.formatSelect ?? `color-picker:${ctx.id}:format-select`,
    getAreaId: (ctx)=>ctx.ids?.area ?? `color-picker:${ctx.id}:area`,
    getAreaGradientId: (ctx)=>ctx.ids?.areaGradient ?? `color-picker:${ctx.id}:area-gradient`,
    getAreaThumbId: (ctx)=>ctx.ids?.areaThumb ?? `color-picker:${ctx.id}:area-thumb`,
    getChannelSliderTrackId: (ctx, channel)=>ctx.ids?.channelSliderTrack?.(channel) ?? `color-picker:${ctx.id}:slider-track:${channel}`,
    getChannelSliderThumbId: (ctx, channel)=>ctx.ids?.channelSliderThumb?.(channel) ?? `color-picker:${ctx.id}:slider-thumb:${channel}`,
    getContentEl: (ctx)=>$afb42e444b074e48$var$dom.getById(ctx, $afb42e444b074e48$var$dom.getContentId(ctx)),
    getAreaThumbEl: (ctx)=>$afb42e444b074e48$var$dom.getById(ctx, $afb42e444b074e48$var$dom.getAreaThumbId(ctx)),
    getChannelSliderThumbEl: (ctx, channel)=>$afb42e444b074e48$var$dom.getById(ctx, $afb42e444b074e48$var$dom.getChannelSliderThumbId(ctx, channel)),
    getChannelInputEl: (ctx, channel)=>{
        const selector = `input[data-channel="${channel}"]`;
        return [
            ...(0, $b06ec5ff205338e5$export$dcd0d083aa86c355)($afb42e444b074e48$var$dom.getContentEl(ctx), selector),
            ...(0, $b06ec5ff205338e5$export$dcd0d083aa86c355)($afb42e444b074e48$var$dom.getControlEl(ctx), selector)
        ];
    },
    getFormatSelectEl: (ctx)=>$afb42e444b074e48$var$dom.getById(ctx, $afb42e444b074e48$var$dom.getFormatSelectId(ctx)),
    getHiddenInputEl: (ctx)=>$afb42e444b074e48$var$dom.getById(ctx, $afb42e444b074e48$var$dom.getHiddenInputId(ctx)),
    getAreaEl: (ctx)=>$afb42e444b074e48$var$dom.getById(ctx, $afb42e444b074e48$var$dom.getAreaId(ctx)),
    getAreaValueFromPoint (ctx, point) {
        const areaEl = $afb42e444b074e48$var$dom.getAreaEl(ctx);
        if (!areaEl) return;
        const { percent: percent } = (0, $b06ec5ff205338e5$export$b5a2724f2c73e602)(point, areaEl);
        return percent;
    },
    getControlEl: (ctx)=>$afb42e444b074e48$var$dom.getById(ctx, $afb42e444b074e48$var$dom.getControlId(ctx)),
    getTriggerEl: (ctx)=>$afb42e444b074e48$var$dom.getById(ctx, $afb42e444b074e48$var$dom.getTriggerId(ctx)),
    getPositionerEl: (ctx)=>$afb42e444b074e48$var$dom.getById(ctx, $afb42e444b074e48$var$dom.getPositionerId(ctx)),
    getChannelSliderTrackEl: (ctx, channel)=>{
        return $afb42e444b074e48$var$dom.getById(ctx, $afb42e444b074e48$var$dom.getChannelSliderTrackId(ctx, channel));
    },
    getChannelSliderValueFromPoint (ctx, point, channel) {
        const trackEl = $afb42e444b074e48$var$dom.getChannelSliderTrackEl(ctx, channel);
        if (!trackEl) return;
        const { percent: percent } = (0, $b06ec5ff205338e5$export$b5a2724f2c73e602)(point, trackEl);
        return percent;
    },
    getChannelInputEls: (ctx)=>{
        return [
            ...(0, $b06ec5ff205338e5$export$dcd0d083aa86c355)($afb42e444b074e48$var$dom.getContentEl(ctx), "input[data-channel]"),
            ...(0, $b06ec5ff205338e5$export$dcd0d083aa86c355)($afb42e444b074e48$var$dom.getControlEl(ctx), "input[data-channel]")
        ];
    }
});
function $afb42e444b074e48$var$getChannelDisplayColor(color, channel) {
    switch(channel){
        case "hue":
            return (0, $a863e86c6a9eaf22$export$6e865ea70d7724f)(`hsl(${color.getChannelValue("hue")}, 100%, 50%)`);
        case "lightness":
        case "brightness":
        case "saturation":
        case "red":
        case "green":
        case "blue":
            return color.withChannelValue("alpha", 1);
        case "alpha":
            return color;
        default:
            throw new Error("Unknown color channel: " + channel);
    }
}
function $afb42e444b074e48$var$getChannelValue(color, channel) {
    if (channel == null) return "";
    if (channel === "hex") return color.toString("hex");
    if (channel === "css") return color.toString("css");
    if (channel in color) return color.getChannelValue(channel).toString();
    const isHSL = color.getFormat() === "hsla";
    switch(channel){
        case "hue":
            return isHSL ? color.toFormat("hsla").getChannelValue("hue").toString() : color.toFormat("hsba").getChannelValue("hue").toString();
        case "saturation":
            return isHSL ? color.toFormat("hsla").getChannelValue("saturation").toString() : color.toFormat("hsba").getChannelValue("saturation").toString();
        case "lightness":
            return color.toFormat("hsla").getChannelValue("lightness").toString();
        case "brightness":
            return color.toFormat("hsba").getChannelValue("brightness").toString();
        case "red":
        case "green":
        case "blue":
            return color.toFormat("rgba").getChannelValue(channel).toString();
        default:
            return color.getChannelValue(channel).toString();
    }
}
function $afb42e444b074e48$var$getChannelRange(color, channel) {
    switch(channel){
        case "hex":
            const minColor = (0, $a863e86c6a9eaf22$export$6e865ea70d7724f)("#000000");
            const maxColor = (0, $a863e86c6a9eaf22$export$6e865ea70d7724f)("#FFFFFF");
            return {
                minValue: minColor.toHexInt(),
                maxValue: maxColor.toHexInt(),
                pageSize: 10,
                step: 1
            };
        case "css":
            return void 0;
        case "hue":
        case "saturation":
        case "lightness":
            return color.toFormat("hsla").getChannelRange(channel);
        case "brightness":
            return color.toFormat("hsba").getChannelRange(channel);
        case "red":
        case "green":
        case "blue":
            return color.toFormat("rgba").getChannelRange(channel);
        default:
            return color.getChannelRange(channel);
    }
}
// src/utils/get-slider-background.ts
function $afb42e444b074e48$var$getSliderBackgroundDirection(orientation, dir) {
    if (orientation === "vertical") return "top";
    else if (dir === "ltr") return "right";
    else return "left";
}
var $afb42e444b074e48$var$getSliderBackground = (props)=>{
    const { channel: channel, value: value, dir: dir, orientation: orientation } = props;
    const bgDirection = $afb42e444b074e48$var$getSliderBackgroundDirection(orientation, dir);
    const { minValue: minValue, maxValue: maxValue } = value.getChannelRange(channel);
    switch(channel){
        case "hue":
            return `linear-gradient(to ${bgDirection}, rgb(255, 0, 0) 0%, rgb(255, 255, 0) 17%, rgb(0, 255, 0) 33%, rgb(0, 255, 255) 50%, rgb(0, 0, 255) 67%, rgb(255, 0, 255) 83%, rgb(255, 0, 0) 100%)`;
        case "lightness":
            {
                let start = value.withChannelValue(channel, minValue).toString("css");
                let middle = value.withChannelValue(channel, (maxValue - minValue) / 2).toString("css");
                let end = value.withChannelValue(channel, maxValue).toString("css");
                return `linear-gradient(to ${bgDirection}, ${start}, ${middle}, ${end})`;
            }
        case "saturation":
        case "brightness":
        case "red":
        case "green":
        case "blue":
        case "alpha":
            {
                let start = value.withChannelValue(channel, minValue).toString("css");
                let end = value.withChannelValue(channel, maxValue).toString("css");
                return `linear-gradient(to ${bgDirection}, ${start}, ${end})`;
            }
        default:
            throw new Error("Unknown color channel: " + channel);
    }
};
// src/color-picker.connect.ts
function $afb42e444b074e48$export$64605811ab45167f(state, send, normalize) {
    const value = state.context.value;
    const areaValue = state.context.areaValue;
    const valueAsString = state.context.valueAsString;
    const disabled = state.context.isDisabled;
    const interactive = state.context.isInteractive;
    const dragging = state.hasTag("dragging");
    const open = state.hasTag("open");
    const focused = state.hasTag("focused");
    const getAreaChannels = (props)=>{
        const channels = areaValue.getChannels();
        return {
            xChannel: props.xChannel ?? channels[1],
            yChannel: props.yChannel ?? channels[2]
        };
    };
    const currentPlacement = state.context.currentPlacement;
    const popperStyles = (0, $9e811243c3728edf$export$736498a3bfbba398)({
        ...state.context.positioning,
        placement: currentPlacement
    });
    function getSwatchTriggerState(props) {
        const color = (0, $a863e86c6a9eaf22$export$4cde5df63f53f473)(props.value).toFormat(state.context.format);
        return {
            value: color,
            valueAsString: color.toString("hex"),
            checked: color.isEqual(value),
            disabled: props.disabled || !interactive
        };
    }
    return {
        dragging: dragging,
        open: open,
        valueAsString: valueAsString,
        value: value,
        setOpen (nextOpen) {
            if (nextOpen === open) return;
            send({
                type: nextOpen ? "OPEN" : "CLOSE"
            });
        },
        setValue (value2) {
            send({
                type: "VALUE.SET",
                value: (0, $a863e86c6a9eaf22$export$4cde5df63f53f473)(value2),
                src: "set-color"
            });
        },
        getChannelValue (channel) {
            return $afb42e444b074e48$var$getChannelValue(value, channel);
        },
        getChannelValueText (channel, locale) {
            return value.formatChannelValue(channel, locale);
        },
        setChannelValue (channel, channelValue) {
            const color = value.withChannelValue(channel, channelValue);
            send({
                type: "VALUE.SET",
                value: color,
                src: "set-channel"
            });
        },
        format: state.context.format,
        setFormat (format) {
            const formatValue = value.toFormat(format);
            send({
                type: "VALUE.SET",
                value: formatValue,
                src: "set-format"
            });
        },
        alpha: value.getChannelValue("alpha"),
        setAlpha (alphaValue) {
            const color = value.withChannelValue("alpha", alphaValue);
            send({
                type: "VALUE.SET",
                value: color,
                src: "set-alpha"
            });
        },
        getRootProps () {
            return normalize.element({
                ...$afb42e444b074e48$var$parts.root.attrs,
                dir: state.context.dir,
                id: $afb42e444b074e48$var$dom.getRootId(state.context),
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-readonly": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.readOnly),
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.invalid),
                style: {
                    "--value": value.toString("css")
                }
            });
        },
        getLabelProps () {
            return normalize.element({
                ...$afb42e444b074e48$var$parts.label.attrs,
                dir: state.context.dir,
                id: $afb42e444b074e48$var$dom.getLabelId(state.context),
                htmlFor: $afb42e444b074e48$var$dom.getHiddenInputId(state.context),
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-readonly": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.readOnly),
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.invalid),
                "data-focus": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(focused),
                onClick (event) {
                    event.preventDefault();
                    const inputEl = (0, $b06ec5ff205338e5$export$2fa187e846a241c4)($afb42e444b074e48$var$dom.getControlEl(state.context), "[data-channel=hex]");
                    inputEl?.focus({
                        preventScroll: true
                    });
                }
            });
        },
        getControlProps () {
            return normalize.element({
                ...$afb42e444b074e48$var$parts.control.attrs,
                id: $afb42e444b074e48$var$dom.getControlId(state.context),
                dir: state.context.dir,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-readonly": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.readOnly),
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.invalid),
                "data-state": open ? "open" : "closed",
                "data-focus": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(focused)
            });
        },
        getTriggerProps () {
            return normalize.button({
                ...$afb42e444b074e48$var$parts.trigger.attrs,
                id: $afb42e444b074e48$var$dom.getTriggerId(state.context),
                dir: state.context.dir,
                disabled: disabled,
                "aria-label": `select color. current color is ${valueAsString}`,
                "aria-controls": $afb42e444b074e48$var$dom.getContentId(state.context),
                "aria-labelledby": $afb42e444b074e48$var$dom.getLabelId(state.context),
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-readonly": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.readOnly),
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.invalid),
                "data-placement": currentPlacement,
                "aria-expanded": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(open),
                "data-state": open ? "open" : "closed",
                "data-focus": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(focused),
                type: "button",
                onClick () {
                    if (!interactive) return;
                    send({
                        type: "TRIGGER.CLICK"
                    });
                },
                onBlur () {
                    if (!interactive) return;
                    send({
                        type: "TRIGGER.BLUR"
                    });
                },
                style: {
                    position: "relative"
                }
            });
        },
        getPositionerProps () {
            return normalize.element({
                ...$afb42e444b074e48$var$parts.positioner.attrs,
                id: $afb42e444b074e48$var$dom.getPositionerId(state.context),
                dir: state.context.dir,
                style: popperStyles.floating
            });
        },
        getContentProps () {
            return normalize.element({
                ...$afb42e444b074e48$var$parts.content.attrs,
                id: $afb42e444b074e48$var$dom.getContentId(state.context),
                dir: state.context.dir,
                "data-placement": currentPlacement,
                "data-state": open ? "open" : "closed",
                hidden: !open
            });
        },
        getValueTextProps () {
            return normalize.element({
                ...$afb42e444b074e48$var$parts.valueText.attrs,
                dir: state.context.dir,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-focus": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(focused)
            });
        },
        getAreaProps (props = {}) {
            const { xChannel: xChannel, yChannel: yChannel } = getAreaChannels(props);
            const { areaStyles: areaStyles } = (0, $a863e86c6a9eaf22$export$71082afb279a4688)(areaValue, {
                xChannel: xChannel,
                yChannel: yChannel,
                dir: state.context.dir
            });
            return normalize.element({
                ...$afb42e444b074e48$var$parts.area.attrs,
                id: $afb42e444b074e48$var$dom.getAreaId(state.context),
                role: "group",
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.invalid),
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-readonly": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.readOnly),
                onPointerDown (event) {
                    if (!interactive) return;
                    if (!(0, $b06ec5ff205338e5$export$698c4f0ff5e11e52)(event)) return;
                    if ((0, $b06ec5ff205338e5$export$90788ad2c69b4f50)(event)) return;
                    const point = (0, $b06ec5ff205338e5$export$a8637644cbd23a7b)(event);
                    const channel = {
                        xChannel: xChannel,
                        yChannel: yChannel
                    };
                    send({
                        type: "AREA.POINTER_DOWN",
                        point: point,
                        channel: channel,
                        id: "area"
                    });
                    event.preventDefault();
                },
                style: {
                    position: "relative",
                    touchAction: "none",
                    forcedColorAdjust: "none",
                    ...areaStyles
                }
            });
        },
        getAreaBackgroundProps (props = {}) {
            const { xChannel: xChannel, yChannel: yChannel } = getAreaChannels(props);
            const { areaGradientStyles: areaGradientStyles } = (0, $a863e86c6a9eaf22$export$71082afb279a4688)(areaValue, {
                xChannel: xChannel,
                yChannel: yChannel,
                dir: state.context.dir
            });
            return normalize.element({
                ...$afb42e444b074e48$var$parts.areaBackground.attrs,
                id: $afb42e444b074e48$var$dom.getAreaGradientId(state.context),
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.invalid),
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-readonly": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.readOnly),
                style: {
                    position: "relative",
                    touchAction: "none",
                    forcedColorAdjust: "none",
                    ...areaGradientStyles
                }
            });
        },
        getAreaThumbProps (props = {}) {
            const { xChannel: xChannel, yChannel: yChannel } = getAreaChannels(props);
            const channel = {
                xChannel: xChannel,
                yChannel: yChannel
            };
            const xPercent = areaValue.getChannelValuePercent(xChannel);
            const yPercent = 1 - areaValue.getChannelValuePercent(yChannel);
            const xValue = areaValue.getChannelValue(xChannel);
            const yValue = areaValue.getChannelValue(yChannel);
            const color = areaValue.withChannelValue("alpha", 1).toString("css");
            return normalize.element({
                ...$afb42e444b074e48$var$parts.areaThumb.attrs,
                id: $afb42e444b074e48$var$dom.getAreaThumbId(state.context),
                dir: state.context.dir,
                tabIndex: disabled ? void 0 : 0,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.invalid),
                "data-readonly": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.readOnly),
                role: "slider",
                "aria-valuemin": 0,
                "aria-valuemax": 100,
                "aria-valuenow": xValue,
                "aria-label": `${xChannel} and ${yChannel}`,
                "aria-roledescription": "2d slider",
                "aria-valuetext": `${xChannel} ${xValue}, ${yChannel} ${yValue}`,
                style: {
                    position: "absolute",
                    left: `${xPercent * 100}%`,
                    top: `${yPercent * 100}%`,
                    transform: "translate(-50%, -50%)",
                    touchAction: "none",
                    forcedColorAdjust: "none",
                    "--color": color,
                    background: color
                },
                onFocus () {
                    if (!interactive) return;
                    send({
                        type: "AREA.FOCUS",
                        id: "area",
                        channel: channel
                    });
                },
                onKeyDown (event) {
                    if (event.defaultPrevented) return;
                    if (!interactive) return;
                    const step = (0, $b06ec5ff205338e5$export$587b7b5379932dd6)(event);
                    const keyMap = {
                        ArrowUp () {
                            send({
                                type: "AREA.ARROW_UP",
                                channel: channel,
                                step: step
                            });
                        },
                        ArrowDown () {
                            send({
                                type: "AREA.ARROW_DOWN",
                                channel: channel,
                                step: step
                            });
                        },
                        ArrowLeft () {
                            send({
                                type: "AREA.ARROW_LEFT",
                                channel: channel,
                                step: step
                            });
                        },
                        ArrowRight () {
                            send({
                                type: "AREA.ARROW_RIGHT",
                                channel: channel,
                                step: step
                            });
                        },
                        PageUp () {
                            send({
                                type: "AREA.PAGE_UP",
                                channel: channel,
                                step: step
                            });
                        },
                        PageDown () {
                            send({
                                type: "AREA.PAGE_DOWN",
                                channel: channel,
                                step: step
                            });
                        },
                        Escape (event2) {
                            event2.stopPropagation();
                        }
                    };
                    const exec = keyMap[(0, $b06ec5ff205338e5$export$f7a7490116b79d4d)(event, state.context)];
                    if (exec) {
                        exec(event);
                        event.preventDefault();
                    }
                }
            });
        },
        getTransparencyGridProps (props = {}) {
            const { size: size = "12px" } = props;
            return normalize.element({
                ...$afb42e444b074e48$var$parts.transparencyGrid.attrs,
                style: {
                    "--size": size,
                    width: "100%",
                    height: "100%",
                    position: "absolute",
                    backgroundColor: "#fff",
                    backgroundImage: "conic-gradient(#eeeeee 0 25%, transparent 0 50%, #eeeeee 0 75%, transparent 0)",
                    backgroundSize: "var(--size) var(--size)",
                    inset: "0px",
                    zIndex: "auto",
                    pointerEvents: "none"
                }
            });
        },
        getChannelSliderProps (props) {
            const { orientation: orientation = "horizontal", channel: channel, format: format } = props;
            return normalize.element({
                ...$afb42e444b074e48$var$parts.channelSlider.attrs,
                "data-channel": channel,
                "data-orientation": orientation,
                role: "presentation",
                onPointerDown (event) {
                    if (!interactive) return;
                    if (!(0, $b06ec5ff205338e5$export$698c4f0ff5e11e52)(event)) return;
                    if ((0, $b06ec5ff205338e5$export$90788ad2c69b4f50)(event)) return;
                    const point = (0, $b06ec5ff205338e5$export$a8637644cbd23a7b)(event);
                    send({
                        type: "CHANNEL_SLIDER.POINTER_DOWN",
                        channel: channel,
                        format: format,
                        point: point,
                        id: channel,
                        orientation: orientation
                    });
                    event.preventDefault();
                },
                style: {
                    position: "relative",
                    touchAction: "none"
                }
            });
        },
        getChannelSliderTrackProps (props) {
            const { orientation: orientation = "horizontal", channel: channel, format: format } = props;
            const normalizedValue = format ? value.toFormat(format) : areaValue;
            return normalize.element({
                ...$afb42e444b074e48$var$parts.channelSliderTrack.attrs,
                id: $afb42e444b074e48$var$dom.getChannelSliderTrackId(state.context, channel),
                role: "group",
                "data-channel": channel,
                "data-orientation": orientation,
                style: {
                    position: "relative",
                    forcedColorAdjust: "none",
                    backgroundImage: $afb42e444b074e48$var$getSliderBackground({
                        orientation: orientation,
                        channel: channel,
                        dir: state.context.dir,
                        value: normalizedValue
                    })
                }
            });
        },
        getChannelSliderLabelProps (props) {
            const { channel: channel } = props;
            return normalize.element({
                ...$afb42e444b074e48$var$parts.channelSliderLabel.attrs,
                "data-channel": channel,
                onClick (event) {
                    if (!interactive) return;
                    event.preventDefault();
                    const thumbId = $afb42e444b074e48$var$dom.getChannelSliderThumbId(state.context, channel);
                    $afb42e444b074e48$var$dom.getById(state.context, thumbId)?.focus({
                        preventScroll: true
                    });
                },
                style: {
                    userSelect: "none",
                    WebkitUserSelect: "none"
                }
            });
        },
        getChannelSliderValueTextProps (props) {
            return normalize.element({
                ...$afb42e444b074e48$var$parts.channelSliderValueText.attrs,
                "data-channel": props.channel
            });
        },
        getChannelSliderThumbProps (props) {
            const { orientation: orientation = "horizontal", channel: channel, format: format } = props;
            const normalizedValue = format ? value.toFormat(format) : areaValue;
            const channelRange = normalizedValue.getChannelRange(channel);
            const channelValue = normalizedValue.getChannelValue(channel);
            const offset = (channelValue - channelRange.minValue) / (channelRange.maxValue - channelRange.minValue);
            const placementStyles = orientation === "horizontal" ? {
                left: `${offset * 100}%`,
                top: "50%"
            } : {
                top: `${offset * 100}%`,
                left: "50%"
            };
            return normalize.element({
                ...$afb42e444b074e48$var$parts.channelSliderThumb.attrs,
                id: $afb42e444b074e48$var$dom.getChannelSliderThumbId(state.context, channel),
                role: "slider",
                "aria-label": channel,
                tabIndex: disabled ? void 0 : 0,
                "data-channel": channel,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-orientation": orientation,
                "aria-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "aria-orientation": orientation,
                "aria-valuemax": channelRange.maxValue,
                "aria-valuemin": channelRange.minValue,
                "aria-valuenow": channelValue,
                "aria-valuetext": `${channel} ${channelValue}`,
                style: {
                    forcedColorAdjust: "none",
                    position: "absolute",
                    background: $afb42e444b074e48$var$getChannelDisplayColor(areaValue, channel).toString("css"),
                    ...placementStyles
                },
                onFocus () {
                    if (!interactive) return;
                    send({
                        type: "CHANNEL_SLIDER.FOCUS",
                        channel: channel
                    });
                },
                onKeyDown (event) {
                    if (event.defaultPrevented) return;
                    if (!interactive) return;
                    const step = (0, $b06ec5ff205338e5$export$587b7b5379932dd6)(event) * channelRange.step;
                    const keyMap = {
                        ArrowUp () {
                            send({
                                type: "CHANNEL_SLIDER.ARROW_UP",
                                channel: channel,
                                step: step
                            });
                        },
                        ArrowDown () {
                            send({
                                type: "CHANNEL_SLIDER.ARROW_DOWN",
                                channel: channel,
                                step: step
                            });
                        },
                        ArrowLeft () {
                            send({
                                type: "CHANNEL_SLIDER.ARROW_LEFT",
                                channel: channel,
                                step: step
                            });
                        },
                        ArrowRight () {
                            send({
                                type: "CHANNEL_SLIDER.ARROW_RIGHT",
                                channel: channel,
                                step: step
                            });
                        },
                        PageUp () {
                            send({
                                type: "CHANNEL_SLIDER.PAGE_UP",
                                channel: channel
                            });
                        },
                        PageDown () {
                            send({
                                type: "CHANNEL_SLIDER.PAGE_DOWN",
                                channel: channel
                            });
                        },
                        Home () {
                            send({
                                type: "CHANNEL_SLIDER.HOME",
                                channel: channel
                            });
                        },
                        End () {
                            send({
                                type: "CHANNEL_SLIDER.END",
                                channel: channel
                            });
                        },
                        Escape (event2) {
                            event2.stopPropagation();
                        }
                    };
                    const exec = keyMap[(0, $b06ec5ff205338e5$export$f7a7490116b79d4d)(event, state.context)];
                    if (exec) {
                        exec(event);
                        event.preventDefault();
                    }
                }
            });
        },
        getChannelInputProps (props) {
            const { channel: channel } = props;
            const isTextField = channel === "hex" || channel === "css";
            const channelRange = $afb42e444b074e48$var$getChannelRange(value, channel);
            return normalize.input({
                ...$afb42e444b074e48$var$parts.channelInput.attrs,
                dir: state.context.dir,
                type: isTextField ? "text" : "number",
                "data-channel": channel,
                "aria-label": channel,
                spellCheck: false,
                autoComplete: "off",
                disabled: disabled,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.invalid),
                "data-readonly": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.readOnly),
                readOnly: state.context.readOnly,
                defaultValue: $afb42e444b074e48$var$getChannelValue(value, channel),
                min: channelRange?.minValue,
                max: channelRange?.maxValue,
                step: channelRange?.step,
                onBeforeInput (event) {
                    if (isTextField || !interactive) return;
                    const value2 = event.currentTarget.value;
                    if (value2.match(/[^0-9.]/g)) event.preventDefault();
                },
                onFocus (event) {
                    if (!interactive) return;
                    send({
                        type: "CHANNEL_INPUT.FOCUS",
                        channel: channel
                    });
                    event.currentTarget.select();
                },
                onBlur (event) {
                    if (!interactive) return;
                    const value2 = isTextField ? event.currentTarget.value : event.currentTarget.valueAsNumber;
                    send({
                        type: "CHANNEL_INPUT.BLUR",
                        channel: channel,
                        value: value2,
                        isTextField: isTextField
                    });
                },
                onKeyDown (event) {
                    if (event.defaultPrevented) return;
                    if (!interactive) return;
                    if (event.key === "Enter") {
                        const value2 = isTextField ? event.currentTarget.value : event.currentTarget.valueAsNumber;
                        send({
                            type: "CHANNEL_INPUT.CHANGE",
                            channel: channel,
                            value: value2,
                            isTextField: isTextField
                        });
                        event.preventDefault();
                    }
                },
                style: {
                    appearance: "none",
                    WebkitAppearance: "none",
                    MozAppearance: "textfield"
                }
            });
        },
        getHiddenInputProps () {
            return normalize.input({
                type: "text",
                disabled: disabled,
                name: state.context.name,
                tabIndex: -1,
                readOnly: state.context.readOnly,
                required: state.context.required,
                id: $afb42e444b074e48$var$dom.getHiddenInputId(state.context),
                style: (0, $b06ec5ff205338e5$export$8fecac46448b5689),
                defaultValue: valueAsString
            });
        },
        getEyeDropperTriggerProps () {
            return normalize.button({
                ...$afb42e444b074e48$var$parts.eyeDropperTrigger.attrs,
                type: "button",
                dir: state.context.dir,
                disabled: disabled,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.invalid),
                "data-readonly": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.readOnly),
                "aria-label": "Pick a color from the screen",
                onClick () {
                    if (!interactive) return;
                    send("EYEDROPPER.CLICK");
                }
            });
        },
        getSwatchGroupProps () {
            return normalize.element({
                ...$afb42e444b074e48$var$parts.swatchGroup.attrs,
                role: "group"
            });
        },
        getSwatchTriggerState: getSwatchTriggerState,
        getSwatchTriggerProps (props) {
            const swatchState = getSwatchTriggerState(props);
            return normalize.button({
                ...$afb42e444b074e48$var$parts.swatchTrigger.attrs,
                disabled: swatchState.disabled,
                dir: state.context.dir,
                type: "button",
                "aria-label": `select ${swatchState.valueAsString} as the color`,
                "data-state": swatchState.checked ? "checked" : "unchecked",
                "data-value": swatchState.valueAsString,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(swatchState.disabled),
                onClick () {
                    if (swatchState.disabled) return;
                    send({
                        type: "SWATCH_TRIGGER.CLICK",
                        value: swatchState.value
                    });
                },
                style: {
                    "--color": swatchState.valueAsString,
                    position: "relative"
                }
            });
        },
        getSwatchIndicatorProps (props) {
            const swatchState = getSwatchTriggerState(props);
            return normalize.element({
                ...$afb42e444b074e48$var$parts.swatchIndicator.attrs,
                dir: state.context.dir,
                hidden: !swatchState.checked
            });
        },
        getSwatchProps (props) {
            const { respectAlpha: respectAlpha = true } = props;
            const swatchState = getSwatchTriggerState(props);
            const color = swatchState.value.toString(respectAlpha ? "css" : "hex");
            return normalize.element({
                ...$afb42e444b074e48$var$parts.swatch.attrs,
                dir: state.context.dir,
                "data-state": swatchState.checked ? "checked" : "unchecked",
                "data-value": swatchState.valueAsString,
                style: {
                    "--color": color,
                    position: "relative",
                    background: color
                }
            });
        },
        getFormatTriggerProps () {
            return normalize.button({
                ...$afb42e444b074e48$var$parts.formatTrigger.attrs,
                dir: state.context.dir,
                type: "button",
                "aria-label": `change color format to ${$afb42e444b074e48$var$getNextFormat(state.context.format)}`,
                onClick (event) {
                    if (event.currentTarget.disabled) return;
                    const nextFormat = $afb42e444b074e48$var$getNextFormat(state.context.format);
                    send({
                        type: "FORMAT.SET",
                        format: nextFormat,
                        src: "format-trigger"
                    });
                }
            });
        },
        getFormatSelectProps () {
            return normalize.select({
                ...$afb42e444b074e48$var$parts.formatSelect.attrs,
                "aria-label": "change color format",
                dir: state.context.dir,
                defaultValue: state.context.format,
                disabled: disabled,
                onChange (event) {
                    const format = $afb42e444b074e48$var$assertFormat(event.currentTarget.value);
                    send({
                        type: "FORMAT.SET",
                        format: format,
                        src: "format-select"
                    });
                }
            });
        }
    };
}
var $afb42e444b074e48$var$formats = [
    "hsba",
    "hsla",
    "rgba"
];
var $afb42e444b074e48$var$formatRegex = new RegExp(`^(${$afb42e444b074e48$var$formats.join("|")})$`);
function $afb42e444b074e48$var$getNextFormat(format) {
    const index = $afb42e444b074e48$var$formats.indexOf(format);
    return $afb42e444b074e48$var$formats[index + 1] ?? $afb42e444b074e48$var$formats[0];
}
function $afb42e444b074e48$var$assertFormat(format) {
    if ($afb42e444b074e48$var$formatRegex.test(format)) return format;
    throw new Error(`Unsupported color format: ${format}`);
}
var $afb42e444b074e48$export$98e6a39c04603d36 = (colorString)=>{
    return (0, $a863e86c6a9eaf22$export$6e865ea70d7724f)(colorString);
};
// src/color-picker.machine.ts
var { and: $afb42e444b074e48$var$and } = (0, $5c0da97e9c7aa95f$export$f3249297f3edf7e9);
function $afb42e444b074e48$export$ea56d40cd27c3480(userContext) {
    const ctx = (0, $89352e0ddd72597a$export$8e16b83750b44988)(userContext);
    return (0, $5c0da97e9c7aa95f$export$aaa7fa18f8e9b2e8)({
        id: "color-picker",
        initial: ctx.open ? "open" : "idle",
        context: {
            dir: "ltr",
            value: $afb42e444b074e48$export$98e6a39c04603d36("#000000"),
            format: "rgba",
            disabled: false,
            closeOnSelect: false,
            openAutoFocus: true,
            ...ctx,
            activeId: null,
            activeChannel: null,
            activeOrientation: null,
            fieldsetDisabled: false,
            restoreFocus: true,
            positioning: {
                ...ctx.positioning,
                placement: "bottom"
            }
        },
        computed: {
            isRtl: (ctx2)=>ctx2.dir === "rtl",
            isDisabled: (ctx2)=>!!ctx2.disabled || ctx2.fieldsetDisabled,
            isInteractive: (ctx2)=>!(ctx2.isDisabled || ctx2.readOnly),
            valueAsString: (ctx2)=>ctx2.value.toString(ctx2.format),
            areaValue: (ctx2)=>{
                const format = ctx2.format.startsWith("hsl") ? "hsla" : "hsba";
                return ctx2.value.toFormat(format);
            }
        },
        activities: [
            "trackFormControl"
        ],
        watch: {
            value: [
                "syncInputElements"
            ],
            format: [
                "syncFormatSelectElement"
            ],
            open: [
                "toggleVisibility"
            ]
        },
        on: {
            "VALUE.SET": {
                actions: [
                    "setValue"
                ]
            },
            "FORMAT.SET": {
                actions: [
                    "setFormat"
                ]
            },
            "CHANNEL_INPUT.CHANGE": {
                actions: [
                    "setChannelColorFromInput"
                ]
            },
            "EYEDROPPER.CLICK": {
                actions: [
                    "openEyeDropper"
                ]
            },
            "SWATCH_TRIGGER.CLICK": {
                actions: [
                    "setValue"
                ]
            }
        },
        states: {
            idle: {
                tags: [
                    "closed"
                ],
                on: {
                    "CONTROLLED.OPEN": {
                        target: "open",
                        actions: [
                            "setInitialFocus"
                        ]
                    },
                    OPEN: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnOpen"
                            ]
                        },
                        {
                            target: "open",
                            actions: [
                                "invokeOnOpen",
                                "setInitialFocus"
                            ]
                        }
                    ],
                    "TRIGGER.CLICK": [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnOpen"
                            ]
                        },
                        {
                            target: "open",
                            actions: [
                                "invokeOnOpen",
                                "setInitialFocus"
                            ]
                        }
                    ],
                    "CHANNEL_INPUT.FOCUS": {
                        target: "focused",
                        actions: [
                            "setActiveChannel"
                        ]
                    }
                }
            },
            focused: {
                tags: [
                    "closed",
                    "focused"
                ],
                on: {
                    "CONTROLLED.OPEN": {
                        target: "open",
                        actions: [
                            "setInitialFocus"
                        ]
                    },
                    OPEN: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnOpen"
                            ]
                        },
                        {
                            target: "open",
                            actions: [
                                "invokeOnOpen",
                                "setInitialFocus"
                            ]
                        }
                    ],
                    "TRIGGER.CLICK": [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnOpen"
                            ]
                        },
                        {
                            target: "open",
                            actions: [
                                "invokeOnOpen",
                                "setInitialFocus"
                            ]
                        }
                    ],
                    "CHANNEL_INPUT.FOCUS": {
                        actions: [
                            "setActiveChannel"
                        ]
                    },
                    "CHANNEL_INPUT.BLUR": {
                        target: "idle",
                        actions: [
                            "setChannelColorFromInput"
                        ]
                    },
                    "TRIGGER.BLUR": {
                        target: "idle"
                    }
                }
            },
            open: {
                tags: [
                    "open"
                ],
                activities: [
                    "trackPositioning",
                    "trackDismissableElement"
                ],
                on: {
                    "CONTROLLED.CLOSE": [
                        {
                            guard: "shouldRestoreFocus",
                            target: "focused",
                            actions: [
                                "setReturnFocus"
                            ]
                        },
                        {
                            target: "idle"
                        }
                    ],
                    "TRIGGER.CLICK": [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnClose"
                            ]
                        },
                        {
                            target: "idle",
                            actions: [
                                "invokeOnClose"
                            ]
                        }
                    ],
                    "AREA.POINTER_DOWN": {
                        target: "open:dragging",
                        actions: [
                            "setActiveChannel",
                            "setAreaColorFromPoint",
                            "focusAreaThumb"
                        ]
                    },
                    "AREA.FOCUS": {
                        actions: [
                            "setActiveChannel"
                        ]
                    },
                    "CHANNEL_SLIDER.POINTER_DOWN": {
                        target: "open:dragging",
                        actions: [
                            "setActiveChannel",
                            "setChannelColorFromPoint",
                            "focusChannelThumb"
                        ]
                    },
                    "CHANNEL_SLIDER.FOCUS": {
                        actions: [
                            "setActiveChannel"
                        ]
                    },
                    "AREA.ARROW_LEFT": {
                        actions: [
                            "decrementAreaXChannel"
                        ]
                    },
                    "AREA.ARROW_RIGHT": {
                        actions: [
                            "incrementAreaXChannel"
                        ]
                    },
                    "AREA.ARROW_UP": {
                        actions: [
                            "incrementAreaYChannel"
                        ]
                    },
                    "AREA.ARROW_DOWN": {
                        actions: [
                            "decrementAreaYChannel"
                        ]
                    },
                    "AREA.PAGE_UP": {
                        actions: [
                            "incrementAreaXChannel"
                        ]
                    },
                    "AREA.PAGE_DOWN": {
                        actions: [
                            "decrementAreaXChannel"
                        ]
                    },
                    "CHANNEL_SLIDER.ARROW_LEFT": {
                        actions: [
                            "decrementChannel"
                        ]
                    },
                    "CHANNEL_SLIDER.ARROW_RIGHT": {
                        actions: [
                            "incrementChannel"
                        ]
                    },
                    "CHANNEL_SLIDER.ARROW_UP": {
                        actions: [
                            "incrementChannel"
                        ]
                    },
                    "CHANNEL_SLIDER.ARROW_DOWN": {
                        actions: [
                            "decrementChannel"
                        ]
                    },
                    "CHANNEL_SLIDER.PAGE_UP": {
                        actions: [
                            "incrementChannel"
                        ]
                    },
                    "CHANNEL_SLIDER.PAGE_DOWN": {
                        actions: [
                            "decrementChannel"
                        ]
                    },
                    "CHANNEL_SLIDER.HOME": {
                        actions: [
                            "setChannelToMin"
                        ]
                    },
                    "CHANNEL_SLIDER.END": {
                        actions: [
                            "setChannelToMax"
                        ]
                    },
                    "CHANNEL_INPUT.BLUR": {
                        actions: [
                            "setChannelColorFromInput"
                        ]
                    },
                    INTERACT_OUTSIDE: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnClose"
                            ]
                        },
                        {
                            guard: "shouldRestoreFocus",
                            target: "focused",
                            actions: [
                                "invokeOnClose",
                                "setReturnFocus"
                            ]
                        },
                        {
                            target: "idle",
                            actions: [
                                "invokeOnClose"
                            ]
                        }
                    ],
                    CLOSE: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnClose"
                            ]
                        },
                        {
                            target: "idle",
                            actions: [
                                "invokeOnClose"
                            ]
                        }
                    ],
                    "SWATCH_TRIGGER.CLICK": [
                        {
                            guard: $afb42e444b074e48$var$and("isOpenControlled", "closeOnSelect"),
                            actions: [
                                "setValue",
                                "invokeOnClose"
                            ]
                        },
                        {
                            guard: "closeOnSelect",
                            target: "focused",
                            actions: [
                                "setValue",
                                "invokeOnClose",
                                "setReturnFocus"
                            ]
                        },
                        {
                            actions: [
                                "setValue"
                            ]
                        }
                    ]
                }
            },
            "open:dragging": {
                tags: [
                    "open"
                ],
                exit: [
                    "clearActiveChannel"
                ],
                activities: [
                    "trackPointerMove",
                    "disableTextSelection",
                    "trackPositioning",
                    "trackDismissableElement"
                ],
                on: {
                    "CONTROLLED.CLOSE": [
                        {
                            guard: "shouldRestoreFocus",
                            target: "focused",
                            actions: [
                                "setReturnFocus"
                            ]
                        },
                        {
                            target: "idle"
                        }
                    ],
                    "AREA.POINTER_MOVE": {
                        actions: [
                            "setAreaColorFromPoint",
                            "focusAreaThumb"
                        ]
                    },
                    "AREA.POINTER_UP": {
                        target: "open",
                        actions: [
                            "invokeOnChangeEnd"
                        ]
                    },
                    "CHANNEL_SLIDER.POINTER_MOVE": {
                        actions: [
                            "setChannelColorFromPoint",
                            "focusChannelThumb"
                        ]
                    },
                    "CHANNEL_SLIDER.POINTER_UP": {
                        target: "open",
                        actions: [
                            "invokeOnChangeEnd"
                        ]
                    },
                    INTERACT_OUTSIDE: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnClose"
                            ]
                        },
                        {
                            guard: "shouldRestoreFocus",
                            target: "focused",
                            actions: [
                                "invokeOnClose",
                                "setReturnFocus"
                            ]
                        },
                        {
                            target: "idle",
                            actions: [
                                "invokeOnClose"
                            ]
                        }
                    ],
                    CLOSE: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnClose"
                            ]
                        },
                        {
                            target: "idle",
                            actions: [
                                "invokeOnClose"
                            ]
                        }
                    ]
                }
            }
        }
    }, {
        guards: {
            closeOnSelect: (ctx2)=>!!ctx2.closeOnSelect,
            isOpenControlled: (ctx2)=>!!ctx2["open.controlled"],
            shouldRestoreFocus: (ctx2)=>!!ctx2.restoreFocus
        },
        activities: {
            trackPositioning (ctx2) {
                ctx2.currentPlacement || (ctx2.currentPlacement = ctx2.positioning.placement);
                const anchorEl = $afb42e444b074e48$var$dom.getTriggerEl(ctx2);
                const getPositionerEl = ()=>$afb42e444b074e48$var$dom.getPositionerEl(ctx2);
                return (0, $9e811243c3728edf$export$a9fe23cfa43a7b55)(anchorEl, getPositionerEl, {
                    ...ctx2.positioning,
                    defer: true,
                    onComplete (data) {
                        ctx2.currentPlacement = data.placement;
                    }
                });
            },
            trackDismissableElement (ctx2, _evt, { send: send }) {
                const getContentEl = ()=>$afb42e444b074e48$var$dom.getContentEl(ctx2);
                return (0, $a0385836474f3c11$export$72bda0e502b8ea31)(getContentEl, {
                    exclude: $afb42e444b074e48$var$dom.getTriggerEl(ctx2),
                    defer: true,
                    onInteractOutside (event) {
                        ctx2.onInteractOutside?.(event);
                        if (event.defaultPrevented) return;
                        ctx2.restoreFocus = !(event.detail.focusable || event.detail.contextmenu);
                    },
                    onPointerDownOutside: ctx2.onPointerDownOutside,
                    onFocusOutside: ctx2.onFocusOutside,
                    onDismiss () {
                        send({
                            type: "INTERACT_OUTSIDE"
                        });
                    }
                });
            },
            trackFormControl (ctx2, _evt, { send: send, initialContext: initialContext }) {
                const inputEl = $afb42e444b074e48$var$dom.getHiddenInputEl(ctx2);
                return (0, $b06ec5ff205338e5$export$a48469c7b6beba26)(inputEl, {
                    onFieldsetDisabledChange (disabled) {
                        ctx2.fieldsetDisabled = disabled;
                    },
                    onFormReset () {
                        send({
                            type: "VALUE.SET",
                            value: initialContext.value,
                            src: "form.reset"
                        });
                    }
                });
            },
            trackPointerMove (ctx2, evt, { send: send }) {
                return (0, $b06ec5ff205338e5$export$71f75065f080cb5b)($afb42e444b074e48$var$dom.getDoc(ctx2), {
                    onPointerMove ({ point: point }) {
                        const type = ctx2.activeId === "area" ? "AREA.POINTER_MOVE" : "CHANNEL_SLIDER.POINTER_MOVE";
                        send({
                            type: type,
                            point: point,
                            format: evt.format
                        });
                    },
                    onPointerUp () {
                        const type = ctx2.activeId === "area" ? "AREA.POINTER_UP" : "CHANNEL_SLIDER.POINTER_UP";
                        send({
                            type: type
                        });
                    }
                });
            },
            disableTextSelection (ctx2) {
                return (0, $b06ec5ff205338e5$export$16a4697467175487)({
                    doc: $afb42e444b074e48$var$dom.getDoc(ctx2),
                    target: $afb42e444b074e48$var$dom.getContentEl(ctx2)
                });
            }
        },
        actions: {
            openEyeDropper (ctx2) {
                const isSupported = "EyeDropper" in $afb42e444b074e48$var$dom.getWin(ctx2);
                if (!isSupported) return;
                const win = $afb42e444b074e48$var$dom.getWin(ctx2);
                const picker = new win.EyeDropper();
                picker.open().then(({ sRGBHex: sRGBHex })=>{
                    const format = ctx2.value.getFormat();
                    const color = (0, $a863e86c6a9eaf22$export$6e865ea70d7724f)(sRGBHex).toFormat(format);
                    $afb42e444b074e48$var$set.value(ctx2, color);
                    ctx2.onValueChangeEnd?.({
                        value: ctx2.value,
                        valueAsString: ctx2.valueAsString
                    });
                }).catch(()=>void 0);
            },
            setActiveChannel (ctx2, evt) {
                ctx2.activeId = evt.id;
                if (evt.channel) ctx2.activeChannel = evt.channel;
                if (evt.orientation) ctx2.activeOrientation = evt.orientation;
            },
            clearActiveChannel (ctx2) {
                ctx2.activeChannel = null;
                ctx2.activeId = null;
                ctx2.activeOrientation = null;
            },
            setAreaColorFromPoint (ctx2, evt) {
                const normalizedValue = evt.format ? ctx2.value.toFormat(evt.format) : ctx2.areaValue;
                const { xChannel: xChannel, yChannel: yChannel } = evt.channel || ctx2.activeChannel;
                const percent = $afb42e444b074e48$var$dom.getAreaValueFromPoint(ctx2, evt.point);
                if (!percent) return;
                const xValue = normalizedValue.getChannelPercentValue(xChannel, percent.x);
                const yValue = normalizedValue.getChannelPercentValue(yChannel, 1 - percent.y);
                const color = normalizedValue.withChannelValue(xChannel, xValue).withChannelValue(yChannel, yValue);
                $afb42e444b074e48$var$set.value(ctx2, color);
            },
            setChannelColorFromPoint (ctx2, evt) {
                const channel = evt.channel || ctx2.activeId;
                const normalizedValue = evt.format ? ctx2.value.toFormat(evt.format) : ctx2.areaValue;
                const percent = $afb42e444b074e48$var$dom.getChannelSliderValueFromPoint(ctx2, evt.point, channel);
                if (!percent) return;
                const orientation = ctx2.activeOrientation || "horizontal";
                const channelPercent = orientation === "horizontal" ? percent.x : percent.y;
                const value = normalizedValue.getChannelPercentValue(channel, channelPercent);
                const color = normalizedValue.withChannelValue(channel, value);
                $afb42e444b074e48$var$set.value(ctx2, color);
            },
            setValue (ctx2, evt) {
                $afb42e444b074e48$var$set.value(ctx2, evt.value);
            },
            setFormat (ctx2, evt) {
                $afb42e444b074e48$var$set.format(ctx2, evt.format);
            },
            syncInputElements (ctx2) {
                $afb42e444b074e48$var$sync.inputs(ctx2);
            },
            invokeOnChangeEnd (ctx2) {
                $afb42e444b074e48$var$invoke.changeEnd(ctx2);
            },
            setChannelColorFromInput (ctx2, evt) {
                const { channel: channel, isTextField: isTextField, value: value } = evt;
                const currentAlpha = ctx2.value.getChannelValue("alpha");
                let color;
                if (channel === "alpha") {
                    let valueAsNumber = parseFloat(value);
                    valueAsNumber = Number.isNaN(valueAsNumber) ? currentAlpha : valueAsNumber;
                    color = ctx2.value.withChannelValue("alpha", valueAsNumber);
                } else if (isTextField) color = (0, $89352e0ddd72597a$export$d234c058d1d4e435)(()=>$afb42e444b074e48$export$98e6a39c04603d36(value).withChannelValue("alpha", currentAlpha), ()=>ctx2.value);
                else {
                    const current = ctx2.value.toFormat(ctx2.format);
                    const valueAsNumber = Number.isNaN(value) ? current.getChannelValue(channel) : value;
                    color = current.withChannelValue(channel, valueAsNumber);
                }
                $afb42e444b074e48$var$sync.inputs(ctx2, color);
                $afb42e444b074e48$var$set.value(ctx2, color);
            },
            incrementChannel (ctx2, evt) {
                const color = ctx2.value.incrementChannel(evt.channel, evt.step);
                $afb42e444b074e48$var$set.value(ctx2, color);
            },
            decrementChannel (ctx2, evt) {
                const color = ctx2.value.decrementChannel(evt.channel, evt.step);
                $afb42e444b074e48$var$set.value(ctx2, color);
            },
            incrementAreaXChannel (ctx2, evt) {
                const { xChannel: xChannel } = evt.channel;
                const color = ctx2.areaValue.incrementChannel(xChannel, evt.step);
                $afb42e444b074e48$var$set.value(ctx2, color);
            },
            decrementAreaXChannel (ctx2, evt) {
                const { xChannel: xChannel } = evt.channel;
                const color = ctx2.areaValue.decrementChannel(xChannel, evt.step);
                $afb42e444b074e48$var$set.value(ctx2, color);
            },
            incrementAreaYChannel (ctx2, evt) {
                const { yChannel: yChannel } = evt.channel;
                const color = ctx2.areaValue.incrementChannel(yChannel, evt.step);
                $afb42e444b074e48$var$set.value(ctx2, color);
            },
            decrementAreaYChannel (ctx2, evt) {
                const { yChannel: yChannel } = evt.channel;
                const color = ctx2.areaValue.decrementChannel(yChannel, evt.step);
                $afb42e444b074e48$var$set.value(ctx2, color);
            },
            setChannelToMax (ctx2, evt) {
                const range = ctx2.value.getChannelRange(evt.channel);
                const color = ctx2.value.withChannelValue(evt.channel, range.maxValue);
                $afb42e444b074e48$var$set.value(ctx2, color);
            },
            setChannelToMin (ctx2, evt) {
                const range = ctx2.value.getChannelRange(evt.channel);
                const color = ctx2.value.withChannelValue(evt.channel, range.minValue);
                $afb42e444b074e48$var$set.value(ctx2, color);
            },
            focusAreaThumb (ctx2) {
                (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>{
                    $afb42e444b074e48$var$dom.getAreaThumbEl(ctx2)?.focus({
                        preventScroll: true
                    });
                });
            },
            focusChannelThumb (ctx2, evt) {
                (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>{
                    $afb42e444b074e48$var$dom.getChannelSliderThumbEl(ctx2, evt.channel)?.focus({
                        preventScroll: true
                    });
                });
            },
            setInitialFocus (ctx2) {
                if (!ctx2.openAutoFocus) return;
                (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>{
                    const element = (0, $b06ec5ff205338e5$export$af1ff6d51ec218ea)({
                        root: $afb42e444b074e48$var$dom.getContentEl(ctx2),
                        getInitialEl: ctx2.initialFocusEl
                    });
                    element?.focus({
                        preventScroll: true
                    });
                });
            },
            setReturnFocus (ctx2) {
                (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>{
                    $afb42e444b074e48$var$dom.getTriggerEl(ctx2)?.focus({
                        preventScroll: true
                    });
                });
            },
            syncFormatSelectElement (ctx2) {
                $afb42e444b074e48$var$sync.formatSelect(ctx2);
            },
            invokeOnOpen (ctx2) {
                ctx2.onOpenChange?.({
                    open: true
                });
            },
            invokeOnClose (ctx2) {
                ctx2.onOpenChange?.({
                    open: false
                });
            },
            toggleVisibility (ctx2, evt, { send: send }) {
                send({
                    type: ctx2.open ? "CONTROLLED.OPEN" : "CONTROLLED.CLOSE",
                    previousEvent: evt
                });
            }
        },
        compareFns: {
            value: (a, b)=>a.isEqual(b)
        }
    });
}
var $afb42e444b074e48$var$sync = {
    // sync channel inputs
    inputs (ctx, color) {
        const channelInputs = $afb42e444b074e48$var$dom.getChannelInputEls(ctx);
        (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>{
            channelInputs.forEach((inputEl)=>{
                const channel = inputEl.dataset.channel;
                $afb42e444b074e48$var$dom.setValue(inputEl, $afb42e444b074e48$var$getChannelValue(color || ctx.value, channel));
            });
        });
    },
    // sync format select
    formatSelect (ctx) {
        const selectEl = $afb42e444b074e48$var$dom.getFormatSelectEl(ctx);
        (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>{
            $afb42e444b074e48$var$dom.setValue(selectEl, ctx.format);
        });
    }
};
var $afb42e444b074e48$var$invoke = {
    changeEnd (ctx) {
        const value = ctx.value.toFormat(ctx.format);
        ctx.onValueChangeEnd?.({
            value: value,
            valueAsString: ctx.valueAsString
        });
    },
    change (ctx) {
        const value = ctx.value.toFormat(ctx.format);
        ctx.onValueChange?.({
            value: value,
            valueAsString: ctx.valueAsString
        });
        (0, $b06ec5ff205338e5$export$71608d92f9cda884)($afb42e444b074e48$var$dom.getHiddenInputEl(ctx), {
            value: ctx.valueAsString
        });
    },
    formatChange (ctx) {
        ctx.onFormatChange?.({
            format: ctx.format
        });
    }
};
var $afb42e444b074e48$var$set = {
    value (ctx, color) {
        if (!color || ctx.value.isEqual(color)) return;
        ctx.value = color;
        $afb42e444b074e48$var$invoke.change(ctx);
    },
    format (ctx, format) {
        if (ctx.format === format) return;
        ctx.format = format;
        $afb42e444b074e48$var$invoke.formatChange(ctx);
    }
};


"use client";
const $78dc3196c18951b0$export$5785807b87db4889 = (0, $afb42e444b074e48$export$477202748c7242bf).extendWith("view");


"use strict";
const $fd3111db65af1811$export$e0aacfa04a4a59f3 = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    className: "colorPicker",
    slots: (0, $78dc3196c18951b0$export$5785807b87db4889).keys(),
    base: {
        root: {
            display: "flex",
            flexDirection: "column",
            gap: "1.5"
        },
        label: {
            color: "fg",
            fontWeight: "medium",
            textStyle: "sm"
        },
        valueText: {
            textAlign: "start"
        },
        control: {
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            gap: "2",
            position: "relative"
        },
        swatchTrigger: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        trigger: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "row",
            flexShrink: "0",
            gap: "2",
            textStyle: "sm",
            minH: "var(--input-height)",
            minW: "var(--input-height)",
            px: "1",
            rounded: "l2",
            _disabled: {
                opacity: "0.5"
            },
            "--focus-color": "colors.colorPalette.focusRing",
            "&:focus-visible": {
                borderColor: "var(--focus-color)",
                outline: "1px solid var(--focus-color)"
            },
            "&[data-fit-content]": {
                "--input-height": "unset",
                px: "0",
                border: "0"
            }
        },
        content: {
            display: "flex",
            flexDirection: "column",
            bg: "bg.panel",
            borderRadius: "l3",
            boxShadow: "lg",
            width: "64",
            p: "4",
            gap: "3",
            zIndex: "dropdown",
            _open: {
                animationStyle: "slide-fade-in",
                animationDuration: "fast"
            },
            _closed: {
                animationStyle: "slide-fade-out",
                animationDuration: "faster"
            }
        },
        area: {
            height: "180px",
            borderRadius: "l2",
            overflow: "hidden"
        },
        areaThumb: {
            borderRadius: "full",
            height: "var(--thumb-size)",
            width: "var(--thumb-size)",
            borderWidth: "2px",
            borderColor: "white",
            shadow: "sm",
            focusVisibleRing: "mixed",
            focusRingColor: "white"
        },
        areaBackground: {
            height: "full"
        },
        channelSlider: {
            borderRadius: "l2",
            flex: "1"
        },
        channelSliderTrack: {
            height: "var(--slider-height)",
            borderRadius: "inherit",
            boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.1)"
        },
        swatchGroup: {
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            gap: "2"
        },
        swatch: {
            ...(0, $b905f70517d44150$export$9822f4e3dd6bcc87).base,
            borderRadius: "l1"
        },
        swatchIndicator: {
            color: "white",
            rounded: "full"
        },
        channelSliderThumb: {
            borderRadius: "full",
            height: "var(--thumb-size)",
            width: "var(--thumb-size)",
            borderWidth: "2px",
            borderColor: "white",
            shadow: "sm",
            transform: "translate(-50%, -50%)",
            focusVisibleRing: "outside",
            focusRingOffset: "1px"
        },
        channelInput: {
            ...(0, $074665036d2ed9fc$export$a6445e005c28dca2).base,
            "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button": {
                WebkitAppearance: "none",
                margin: 0
            }
        },
        formatSelect: {
            textStyle: "xs",
            textTransform: "uppercase",
            borderWidth: "1px",
            minH: "6",
            focusRing: "inside",
            rounded: "l2"
        },
        transparencyGrid: {
            borderRadius: "l2"
        },
        view: {
            display: "flex",
            flexDirection: "column",
            gap: "2"
        }
    },
    variants: {
        size: {
            "2xs": {
                channelInput: (0, $074665036d2ed9fc$export$a6445e005c28dca2).variants?.size?.["2xs"],
                swatch: {
                    "--swatch-size": "sizes.4.5"
                },
                trigger: {
                    "--input-height": "sizes.7"
                },
                area: {
                    "--thumb-size": "sizes.3"
                },
                channelSlider: {
                    "--slider-height": "sizes.3",
                    "--thumb-size": "sizes.3"
                }
            },
            xs: {
                channelInput: (0, $074665036d2ed9fc$export$a6445e005c28dca2).variants?.size?.xs,
                swatch: {
                    "--swatch-size": "sizes.5"
                },
                trigger: {
                    "--input-height": "sizes.8"
                },
                area: {
                    "--thumb-size": "sizes.3.5"
                },
                channelSlider: {
                    "--slider-height": "sizes.3.5",
                    "--thumb-size": "sizes.3.5"
                }
            },
            sm: {
                channelInput: (0, $074665036d2ed9fc$export$a6445e005c28dca2).variants?.size?.sm,
                swatch: {
                    "--swatch-size": "sizes.6"
                },
                trigger: {
                    "--input-height": "sizes.9"
                },
                area: {
                    "--thumb-size": "sizes.3.5"
                },
                channelSlider: {
                    "--slider-height": "sizes.3.5",
                    "--thumb-size": "sizes.3.5"
                }
            },
            md: {
                channelInput: (0, $074665036d2ed9fc$export$a6445e005c28dca2).variants?.size?.md,
                swatch: {
                    "--swatch-size": "sizes.7"
                },
                trigger: {
                    "--input-height": "sizes.10"
                },
                area: {
                    "--thumb-size": "sizes.3.5"
                },
                channelSlider: {
                    "--slider-height": "sizes.3.5",
                    "--thumb-size": "sizes.3.5"
                }
            },
            lg: {
                channelInput: (0, $074665036d2ed9fc$export$a6445e005c28dca2).variants?.size?.lg,
                swatch: {
                    "--swatch-size": "sizes.7"
                },
                trigger: {
                    "--input-height": "sizes.11"
                },
                area: {
                    "--thumb-size": "sizes.3.5"
                },
                channelSlider: {
                    "--slider-height": "sizes.3.5",
                    "--thumb-size": "sizes.3.5"
                }
            },
            xl: {
                channelInput: (0, $074665036d2ed9fc$export$a6445e005c28dca2).variants?.size?.xl,
                swatch: {
                    "--swatch-size": "sizes.8"
                },
                trigger: {
                    "--input-height": "sizes.12"
                },
                area: {
                    "--thumb-size": "sizes.3.5"
                },
                channelSlider: {
                    "--slider-height": "sizes.3.5",
                    "--thumb-size": "sizes.3.5"
                }
            },
            "2xl": {
                channelInput: (0, $074665036d2ed9fc$export$a6445e005c28dca2).variants?.size?.["2xl"],
                swatch: {
                    "--swatch-size": "sizes.10"
                },
                trigger: {
                    "--input-height": "sizes.16"
                },
                area: {
                    "--thumb-size": "sizes.3.5"
                },
                channelSlider: {
                    "--slider-height": "sizes.3.5",
                    "--thumb-size": "sizes.3.5"
                }
            }
        },
        variant: {
            outline: {
                channelInput: (0, $074665036d2ed9fc$export$a6445e005c28dca2).variants?.variant?.outline,
                trigger: {
                    borderWidth: "1px"
                }
            },
            subtle: {
                channelInput: (0, $074665036d2ed9fc$export$a6445e005c28dca2).variants?.variant?.subtle,
                trigger: {
                    borderWidth: "1px",
                    borderColor: "transparent",
                    bg: "bg.muted"
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "outline"
    }
});




"use strict";
const $3a08a1b5461b08fc$export$8a8fa4faf7e5d248 = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    slots: (0, $9b7764ce1529e5da$export$a5a7982d185494cc).keys(),
    className: "chakra-data-list",
    base: {
        itemLabel: {
            display: "flex",
            alignItems: "center",
            gap: "1"
        },
        itemValue: {
            display: "flex",
            minWidth: "0",
            flex: "1"
        }
    },
    variants: {
        orientation: {
            horizontal: {
                root: {
                    display: "flex",
                    flexDirection: "column"
                },
                item: {
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "4"
                },
                itemLabel: {
                    minWidth: "120px"
                }
            },
            vertical: {
                root: {
                    display: "flex",
                    flexDirection: "column"
                },
                item: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "1"
                }
            }
        },
        size: {
            sm: {
                root: {
                    gap: "3"
                },
                item: {
                    textStyle: "xs"
                }
            },
            md: {
                root: {
                    gap: "4"
                },
                item: {
                    textStyle: "sm"
                }
            },
            lg: {
                root: {
                    gap: "5"
                },
                item: {
                    textStyle: "md"
                }
            }
        },
        variant: {
            subtle: {
                itemLabel: {
                    color: "fg.muted"
                }
            },
            bold: {
                itemLabel: {
                    fontWeight: "medium"
                },
                itemValue: {
                    color: "fg.muted"
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        orientation: "vertical",
        variant: "subtle"
    }
});




"use strict";
const $65556a547bce7f35$export$ffb2f7e6a3d6561c = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    slots: (0, $9b7764ce1529e5da$export$c438f40c25a9407b).keys(),
    className: "chakra-dialog",
    base: {
        backdrop: {
            bg: "blackAlpha.500",
            pos: "fixed",
            left: 0,
            top: 0,
            w: "100vw",
            h: "100dvh",
            zIndex: "modal",
            _open: {
                animationName: "fade-in",
                animationDuration: "slow"
            },
            _closed: {
                animationName: "fade-out",
                animationDuration: "moderate"
            }
        },
        positioner: {
            display: "flex",
            width: "100vw",
            height: "100dvh",
            position: "fixed",
            left: 0,
            top: 0,
            "--dialog-z-index": "zIndex.modal",
            zIndex: "calc(var(--dialog-z-index) + var(--layer-index, 0))",
            justifyContent: "center",
            overscrollBehaviorY: "none"
        },
        content: {
            display: "flex",
            flexDirection: "column",
            position: "relative",
            width: "100%",
            outline: 0,
            borderRadius: "l3",
            textStyle: "sm",
            my: "var(--dialog-margin, var(--dialog-base-margin))",
            "--dialog-z-index": "zIndex.modal",
            zIndex: "calc(var(--dialog-z-index) + var(--layer-index, 0))",
            bg: "bg.panel",
            boxShadow: "lg",
            _open: {
                animationDuration: "moderate"
            },
            _closed: {
                animationDuration: "faster"
            }
        },
        header: {
            flex: 0,
            px: "6",
            pt: "6",
            pb: "4"
        },
        body: {
            flex: "1",
            px: "6",
            pt: "2",
            pb: "6"
        },
        footer: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: "3",
            px: "6",
            pt: "2",
            pb: "4"
        },
        title: {
            textStyle: "lg",
            fontWeight: "semibold"
        },
        description: {
            color: "fg.muted"
        }
    },
    variants: {
        placement: {
            center: {
                positioner: {
                    alignItems: "center"
                },
                content: {
                    "--dialog-base-margin": "auto",
                    mx: "auto"
                }
            },
            top: {
                positioner: {
                    alignItems: "flex-start"
                },
                content: {
                    "--dialog-base-margin": "spacing.16",
                    mx: "auto"
                }
            },
            bottom: {
                positioner: {
                    alignItems: "flex-end"
                },
                content: {
                    "--dialog-base-margin": "spacing.16",
                    mx: "auto"
                }
            }
        },
        scrollBehavior: {
            inside: {
                positioner: {
                    overflow: "hidden"
                },
                content: {
                    maxH: "calc(100% - 7.5rem)"
                },
                body: {
                    overflow: "auto"
                }
            },
            outside: {
                positioner: {
                    overflow: "auto",
                    pointerEvents: "auto"
                }
            }
        },
        size: {
            xs: {
                content: {
                    maxW: "sm"
                }
            },
            sm: {
                content: {
                    maxW: "md"
                }
            },
            md: {
                content: {
                    maxW: "lg"
                }
            },
            lg: {
                content: {
                    maxW: "2xl"
                }
            },
            xl: {
                content: {
                    maxW: "4xl"
                }
            },
            cover: {
                positioner: {
                    padding: "10"
                },
                content: {
                    width: "100%",
                    height: "100%",
                    "--dialog-margin": "0"
                }
            },
            full: {
                content: {
                    maxW: "100vw",
                    minH: "100vh",
                    "--dialog-margin": "0",
                    borderRadius: "0"
                }
            }
        },
        motionPreset: {
            scale: {
                content: {
                    _open: {
                        animationName: "scale-in, fade-in"
                    },
                    _closed: {
                        animationName: "scale-out, fade-out"
                    }
                }
            },
            "slide-in-bottom": {
                content: {
                    _open: {
                        animationName: "slide-from-bottom, fade-in"
                    },
                    _closed: {
                        animationName: "slide-to-bottom, fade-out"
                    }
                }
            },
            "slide-in-top": {
                content: {
                    _open: {
                        animationName: "slide-from-top, fade-in"
                    },
                    _closed: {
                        animationName: "slide-to-top, fade-out"
                    }
                }
            },
            "slide-in-left": {
                content: {
                    _open: {
                        animationName: "slide-from-left, fade-in"
                    },
                    _closed: {
                        animationName: "slide-to-left, fade-out"
                    }
                }
            },
            "slide-in-right": {
                content: {
                    _open: {
                        animationName: "slide-from-right, fade-in"
                    },
                    _closed: {
                        animationName: "slide-to-right, fade-out"
                    }
                }
            },
            none: {}
        }
    },
    defaultVariants: {
        size: "md",
        scrollBehavior: "outside",
        placement: "top",
        motionPreset: "scale"
    }
});




"use strict";
const $b64ab7162012d2f9$export$da2da8d2e5cdf76b = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    slots: (0, $9b7764ce1529e5da$export$d3f4aaa4b0f2907a).keys(),
    className: "chakra-drawer",
    base: {
        backdrop: {
            bg: "blackAlpha.500",
            pos: "fixed",
            insetInlineStart: 0,
            top: 0,
            w: "100vw",
            h: "100dvh",
            zIndex: "modal",
            _open: {
                animationName: "fade-in",
                animationDuration: "slow"
            },
            _closed: {
                animationName: "fade-out",
                animationDuration: "moderate"
            }
        },
        positioner: {
            display: "flex",
            width: "100vw",
            height: "100dvh",
            position: "fixed",
            insetInlineStart: 0,
            top: 0,
            zIndex: "modal",
            overscrollBehaviorY: "none"
        },
        content: {
            display: "flex",
            flexDirection: "column",
            position: "relative",
            width: "100%",
            outline: 0,
            zIndex: "modal",
            textStyle: "sm",
            maxH: "100dvh",
            color: "inherit",
            bg: "bg.panel",
            boxShadow: "lg",
            _open: {
                animationDuration: "slowest",
                animationTimingFunction: "ease-in-smooth"
            },
            _closed: {
                animationDuration: "slower",
                animationTimingFunction: "ease-in-smooth"
            }
        },
        header: {
            flex: 0,
            px: "6",
            pt: "6",
            pb: "4"
        },
        body: {
            px: "6",
            py: "2",
            flex: "1",
            overflow: "auto"
        },
        footer: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: "3",
            px: "6",
            pt: "2",
            pb: "4"
        },
        title: {
            textStyle: "lg",
            fontWeight: "semibold"
        },
        description: {
            color: "fg.muted"
        }
    },
    variants: {
        size: {
            xs: {
                content: {
                    maxW: "xs"
                }
            },
            sm: {
                content: {
                    maxW: "md"
                }
            },
            md: {
                content: {
                    maxW: "lg"
                }
            },
            lg: {
                content: {
                    maxW: "2xl"
                }
            },
            xl: {
                content: {
                    maxW: "4xl"
                }
            },
            full: {
                content: {
                    maxW: "100vw",
                    h: "100dvh"
                }
            }
        },
        placement: {
            start: {
                positioner: {
                    justifyContent: "flex-start"
                },
                content: {
                    _open: {
                        animationName: {
                            base: "slide-from-left-full, fade-in",
                            _rtl: "slide-from-right-full, fade-in"
                        }
                    },
                    _closed: {
                        animationName: {
                            base: "slide-to-left-full, fade-out",
                            _rtl: "slide-to-right-full, fade-out"
                        }
                    }
                }
            },
            end: {
                positioner: {
                    justifyContent: "flex-end"
                },
                content: {
                    _open: {
                        animationName: {
                            base: "slide-from-right-full, fade-in",
                            _rtl: "slide-from-left-full, fade-in"
                        }
                    },
                    _closed: {
                        animationName: {
                            base: "slide-to-right-full, fade-out",
                            _rtl: "slide-to-right-full, fade-out"
                        }
                    }
                }
            },
            top: {
                positioner: {
                    alignItems: "flex-start"
                },
                content: {
                    maxW: "100%",
                    _open: {
                        animationName: "slide-from-top-full, fade-in"
                    },
                    _closed: {
                        animationName: "slide-to-top-full, fade-out"
                    }
                }
            },
            bottom: {
                positioner: {
                    alignItems: "flex-end"
                },
                content: {
                    maxW: "100%",
                    _open: {
                        animationName: "slide-from-bottom-full, fade-in"
                    },
                    _closed: {
                        animationName: "slide-to-bottom-full, fade-out"
                    }
                }
            }
        },
        contained: {
            true: {
                positioner: {
                    padding: "4"
                },
                content: {
                    borderRadius: "l3"
                }
            }
        }
    },
    defaultVariants: {
        size: "xs",
        placement: "end"
    }
});




"use strict";
const $717ffabf83a36dad$var$sharedStyles = (0, $ee2de6f250f65b79$export$9a6b93c1c4f92839)({
    fontSize: "inherit",
    fontWeight: "inherit",
    textAlign: "inherit",
    bg: "transparent",
    borderRadius: "l2"
});
const $717ffabf83a36dad$export$e1e8b391e6213091 = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    slots: (0, $9b7764ce1529e5da$export$2813c9511eeab082).keys(),
    className: "chakra-editable",
    base: {
        root: {
            display: "inline-flex",
            alignItems: "center",
            position: "relative",
            gap: "1.5",
            width: "full"
        },
        preview: {
            ...$717ffabf83a36dad$var$sharedStyles,
            py: "1",
            px: "1",
            display: "inline-flex",
            alignItems: "center",
            transitionProperty: "common",
            transitionDuration: "normal",
            cursor: "text",
            _hover: {
                bg: "bg.muted"
            },
            _disabled: {
                userSelect: "none"
            }
        },
        input: {
            ...$717ffabf83a36dad$var$sharedStyles,
            outline: "0",
            py: "1",
            px: "1",
            transitionProperty: "common",
            transitionDuration: "normal",
            width: "full",
            focusVisibleRing: "inside",
            focusRingWidth: "2px",
            _placeholder: {
                opacity: 0.6
            }
        },
        control: {
            display: "inline-flex",
            alignItems: "center",
            gap: "1.5"
        }
    },
    variants: {
        size: {
            sm: {
                root: {
                    textStyle: "sm"
                },
                preview: {
                    minH: "8"
                },
                input: {
                    minH: "8"
                }
            },
            md: {
                root: {
                    textStyle: "sm"
                },
                preview: {
                    minH: "9"
                },
                input: {
                    minH: "9"
                }
            },
            lg: {
                root: {
                    textStyle: "md"
                },
                preview: {
                    minH: "10"
                },
                input: {
                    minH: "10"
                }
            }
        }
    },
    defaultVariants: {
        size: "md"
    }
});




"use strict";
const $4dce04b04ece4098$export$93a945b6c6bfa0fe = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    slots: (0, $9b7764ce1529e5da$export$f18c66b472536888).keys(),
    className: "chakra-empty-state",
    base: {
        root: {
            width: "full"
        },
        content: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center"
        },
        indicator: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "fg.subtle",
            _icon: {
                boxSize: "1em"
            }
        },
        title: {
            fontWeight: "semibold"
        },
        description: {
            textStyle: "sm",
            color: "fg.muted"
        }
    },
    variants: {
        size: {
            sm: {
                root: {
                    px: "4",
                    py: "6"
                },
                title: {
                    textStyle: "md"
                },
                content: {
                    gap: "4"
                },
                indicator: {
                    textStyle: "2xl"
                }
            },
            md: {
                root: {
                    px: "8",
                    py: "12"
                },
                title: {
                    textStyle: "lg"
                },
                content: {
                    gap: "6"
                },
                indicator: {
                    textStyle: "4xl"
                }
            },
            lg: {
                root: {
                    px: "12",
                    py: "16"
                },
                title: {
                    textStyle: "xl"
                },
                content: {
                    gap: "8"
                },
                indicator: {
                    textStyle: "6xl"
                }
            }
        }
    },
    defaultVariants: {
        size: "md"
    }
});




"use strict";
const $b89acf6a6aeac59f$export$9044d569b4a94288 = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    className: "chakra-field",
    slots: (0, $9b7764ce1529e5da$export$a43048b0d2808e4e).keys(),
    base: {
        requiredIndicator: {
            color: "fg.error",
            lineHeight: "1"
        },
        root: {
            display: "flex",
            width: "100%",
            position: "relative",
            gap: "1.5"
        },
        label: {
            display: "flex",
            alignItems: "center",
            textAlign: "start",
            textStyle: "sm",
            fontWeight: "medium",
            gap: "1",
            userSelect: "none",
            _disabled: {
                opacity: "0.5"
            }
        },
        errorText: {
            display: "inline-flex",
            alignItems: "center",
            fontWeight: "medium",
            gap: "1",
            color: "fg.error",
            textStyle: "xs"
        },
        helperText: {
            color: "fg.muted",
            textStyle: "xs"
        }
    },
    variants: {
        orientation: {
            vertical: {
                root: {
                    flexDirection: "column",
                    alignItems: "flex-start"
                }
            },
            horizontal: {
                root: {
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between"
                },
                label: {
                    flex: "0 0 var(--field-label-width, 80px)"
                }
            }
        }
    },
    defaultVariants: {
        orientation: "vertical"
    }
});




"use strict";
const $0fe7d45769f81093$export$31b1fb468e8ba73 = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    className: "fieldset",
    slots: (0, $9b7764ce1529e5da$export$3b2066f768dd72d0).keys(),
    base: {
        root: {
            display: "flex",
            flexDirection: "column",
            width: "full"
        },
        content: {
            display: "flex",
            flexDirection: "column",
            width: "full"
        },
        legend: {
            color: "fg",
            fontWeight: "medium",
            _disabled: {
                opacity: "0.5"
            }
        },
        helperText: {
            color: "fg.muted",
            textStyle: "sm"
        },
        errorText: {
            display: "inline-flex",
            alignItems: "center",
            color: "fg.error",
            gap: "2",
            fontWeight: "medium",
            textStyle: "sm"
        }
    },
    variants: {
        size: {
            sm: {
                root: {
                    spaceY: "2"
                },
                content: {
                    gap: "1.5"
                },
                legend: {
                    textStyle: "sm"
                }
            },
            md: {
                root: {
                    spaceY: "4"
                },
                content: {
                    gap: "4"
                },
                legend: {
                    textStyle: "sm"
                }
            },
            lg: {
                root: {
                    spaceY: "6"
                },
                content: {
                    gap: "4"
                },
                legend: {
                    textStyle: "md"
                }
            }
        }
    },
    defaultVariants: {
        size: "md"
    }
});




"use strict";
const $0b9c8f83ec07724b$export$bd84411a7156c13a = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    className: "chakra-file-upload",
    slots: (0, $9b7764ce1529e5da$export$b589745ee24985d).keys(),
    base: {
        root: {
            display: "flex",
            flexDirection: "column",
            gap: "4",
            width: "100%",
            alignItems: "flex-start"
        },
        label: {
            fontWeight: "medium",
            textStyle: "sm"
        },
        dropzone: {
            background: "bg",
            borderRadius: "l3",
            borderWidth: "2px",
            borderStyle: "dashed",
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            gap: "4",
            justifyContent: "center",
            minHeight: "2xs",
            px: "3",
            py: "2",
            transition: "backgrounds",
            focusVisibleRing: "outside",
            _hover: {
                bg: "bg.subtle"
            },
            _dragging: {
                bg: "colorPalette.subtle",
                borderStyle: "solid",
                borderColor: "colorPalette.solid"
            }
        },
        dropzoneContent: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            gap: "1",
            textStyle: "sm"
        },
        item: {
            textStyle: "sm",
            animationName: "fade-in",
            animationDuration: "moderate",
            background: "bg",
            borderRadius: "l2",
            borderWidth: "1px",
            width: "100%",
            display: "flex",
            alignItems: "center",
            gap: "3",
            p: "4"
        },
        itemGroup: {
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "3"
        },
        itemName: {
            color: "fg",
            fontWeight: "medium",
            lineClamp: "1"
        },
        itemContent: {
            display: "flex",
            flexDirection: "column",
            gap: "0.5",
            flex: "1"
        },
        itemSizeText: {
            color: "fg.muted",
            textStyle: "xs"
        },
        itemDeleteTrigger: {
            alignSelf: "flex-start"
        },
        itemPreviewImage: {
            width: "10",
            height: "10",
            objectFit: "scale-down"
        }
    },
    defaultVariants: {}
});










// src/hover-card.anatomy.ts
var $d74ac0efb763aad9$export$477202748c7242bf = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("hoverCard").parts("arrow", "arrowTip", "trigger", "positioner", "content");
var $d74ac0efb763aad9$var$parts = $d74ac0efb763aad9$export$477202748c7242bf.build();
var $d74ac0efb763aad9$var$dom = (0, $b06ec5ff205338e5$export$41a9651decfe2bde)({
    getTriggerId: (ctx)=>ctx.ids?.trigger ?? `hover-card:${ctx.id}:trigger`,
    getContentId: (ctx)=>ctx.ids?.content ?? `hover-card:${ctx.id}:content`,
    getPositionerId: (ctx)=>ctx.ids?.positioner ?? `hover-card:${ctx.id}:popper`,
    getArrowId: (ctx)=>ctx.ids?.arrow ?? `hover-card:${ctx.id}:arrow`,
    getTriggerEl: (ctx)=>$d74ac0efb763aad9$var$dom.getById(ctx, $d74ac0efb763aad9$var$dom.getTriggerId(ctx)),
    getContentEl: (ctx)=>$d74ac0efb763aad9$var$dom.getById(ctx, $d74ac0efb763aad9$var$dom.getContentId(ctx)),
    getPositionerEl: (ctx)=>$d74ac0efb763aad9$var$dom.getById(ctx, $d74ac0efb763aad9$var$dom.getPositionerId(ctx))
});
// src/hover-card.connect.ts
function $d74ac0efb763aad9$export$64605811ab45167f(state, send, normalize) {
    const open = state.hasTag("open");
    const popperStyles = (0, $9e811243c3728edf$export$736498a3bfbba398)({
        ...state.context.positioning,
        placement: state.context.currentPlacement
    });
    return {
        open: open,
        setOpen (nextOpen) {
            if (nextOpen === open) return;
            send(nextOpen ? "OPEN" : "CLOSE");
        },
        reposition (options = {}) {
            send({
                type: "POSITIONING.SET",
                options: options
            });
        },
        getArrowProps () {
            return normalize.element({
                id: $d74ac0efb763aad9$var$dom.getArrowId(state.context),
                ...$d74ac0efb763aad9$var$parts.arrow.attrs,
                dir: state.context.dir,
                style: popperStyles.arrow
            });
        },
        getArrowTipProps () {
            return normalize.element({
                ...$d74ac0efb763aad9$var$parts.arrowTip.attrs,
                dir: state.context.dir,
                style: popperStyles.arrowTip
            });
        },
        getTriggerProps () {
            return normalize.element({
                ...$d74ac0efb763aad9$var$parts.trigger.attrs,
                dir: state.context.dir,
                "data-placement": state.context.currentPlacement,
                id: $d74ac0efb763aad9$var$dom.getTriggerId(state.context),
                "data-state": open ? "open" : "closed",
                onPointerEnter (event) {
                    if (event.pointerType === "touch") return;
                    send({
                        type: "POINTER_ENTER",
                        src: "trigger"
                    });
                },
                onPointerLeave (event) {
                    if (event.pointerType === "touch") return;
                    send({
                        type: "POINTER_LEAVE",
                        src: "trigger"
                    });
                },
                onFocus () {
                    send("TRIGGER_FOCUS");
                },
                onBlur () {
                    send("TRIGGER_BLUR");
                }
            });
        },
        getPositionerProps () {
            return normalize.element({
                id: $d74ac0efb763aad9$var$dom.getPositionerId(state.context),
                ...$d74ac0efb763aad9$var$parts.positioner.attrs,
                dir: state.context.dir,
                style: popperStyles.floating
            });
        },
        getContentProps () {
            return normalize.element({
                ...$d74ac0efb763aad9$var$parts.content.attrs,
                dir: state.context.dir,
                id: $d74ac0efb763aad9$var$dom.getContentId(state.context),
                hidden: !open,
                "data-state": open ? "open" : "closed",
                "data-placement": state.context.currentPlacement,
                onPointerEnter (event) {
                    if (event.pointerType === "touch") return;
                    send({
                        type: "POINTER_ENTER",
                        src: "content"
                    });
                },
                onPointerLeave (event) {
                    if (event.pointerType === "touch") return;
                    send({
                        type: "POINTER_LEAVE",
                        src: "content"
                    });
                }
            });
        }
    };
}
var { not: $d74ac0efb763aad9$var$not, and: $d74ac0efb763aad9$var$and } = (0, $5c0da97e9c7aa95f$export$f3249297f3edf7e9);
function $d74ac0efb763aad9$export$ea56d40cd27c3480(userContext) {
    const ctx = (0, $89352e0ddd72597a$export$8e16b83750b44988)(userContext);
    return (0, $5c0da97e9c7aa95f$export$aaa7fa18f8e9b2e8)({
        id: "hover-card",
        initial: ctx.open ? "open" : "closed",
        context: {
            openDelay: 700,
            closeDelay: 300,
            currentPlacement: void 0,
            ...ctx,
            positioning: {
                placement: "bottom",
                ...ctx.positioning
            }
        },
        watch: {
            open: [
                "toggleVisibility"
            ]
        },
        states: {
            closed: {
                tags: [
                    "closed"
                ],
                entry: [
                    "clearIsPointer"
                ],
                on: {
                    "CONTROLLED.OPEN": "open",
                    POINTER_ENTER: {
                        target: "opening",
                        actions: [
                            "setIsPointer"
                        ]
                    },
                    TRIGGER_FOCUS: "opening",
                    OPEN: "opening"
                }
            },
            opening: {
                tags: [
                    "closed"
                ],
                after: {
                    OPEN_DELAY: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnOpen"
                            ]
                        },
                        {
                            target: "open",
                            actions: [
                                "invokeOnOpen"
                            ]
                        }
                    ]
                },
                on: {
                    "CONTROLLED.OPEN": "open",
                    "CONTROLLED.CLOSE": "closed",
                    POINTER_LEAVE: [
                        {
                            guard: "isOpenControlled",
                            // We trigger toggleVisibility manually since the `ctx.open` has not changed yet (at this point)
                            actions: [
                                "invokeOnClose",
                                "toggleVisibility"
                            ]
                        },
                        {
                            target: "closed",
                            actions: [
                                "invokeOnClose"
                            ]
                        }
                    ],
                    TRIGGER_BLUR: [
                        {
                            guard: $d74ac0efb763aad9$var$and("isOpenControlled", $d74ac0efb763aad9$var$not("isPointer")),
                            // We trigger toggleVisibility manually since the `ctx.open` has not changed yet (at this point)
                            actions: [
                                "invokeOnClose",
                                "toggleVisibility"
                            ]
                        },
                        {
                            guard: $d74ac0efb763aad9$var$not("isPointer"),
                            target: "closed",
                            actions: [
                                "invokeOnClose"
                            ]
                        }
                    ],
                    CLOSE: [
                        {
                            guard: "isOpenControlled",
                            // We trigger toggleVisibility manually since the `ctx.open` has not changed yet (at this point)
                            actions: [
                                "invokeOnClose",
                                "toggleVisibility"
                            ]
                        },
                        {
                            target: "closed",
                            actions: [
                                "invokeOnClose"
                            ]
                        }
                    ]
                }
            },
            open: {
                tags: [
                    "open"
                ],
                activities: [
                    "trackDismissableElement",
                    "trackPositioning"
                ],
                on: {
                    "CONTROLLED.CLOSE": "closed",
                    POINTER_ENTER: {
                        actions: [
                            "setIsPointer"
                        ]
                    },
                    POINTER_LEAVE: "closing",
                    CLOSE: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnClose"
                            ]
                        },
                        {
                            target: "closed",
                            actions: [
                                "invokeOnClose"
                            ]
                        }
                    ],
                    TRIGGER_BLUR: [
                        {
                            guard: $d74ac0efb763aad9$var$and("isOpenControlled", $d74ac0efb763aad9$var$not("isPointer")),
                            actions: [
                                "invokeOnClose"
                            ]
                        },
                        {
                            guard: $d74ac0efb763aad9$var$not("isPointer"),
                            target: "closed",
                            actions: [
                                "invokeOnClose"
                            ]
                        }
                    ],
                    "POSITIONING.SET": {
                        actions: "reposition"
                    }
                }
            },
            closing: {
                tags: [
                    "open"
                ],
                activities: [
                    "trackPositioning"
                ],
                after: {
                    CLOSE_DELAY: [
                        {
                            guard: "isOpenControlled",
                            actions: [
                                "invokeOnClose"
                            ]
                        },
                        {
                            target: "closed",
                            actions: [
                                "invokeOnClose"
                            ]
                        }
                    ]
                },
                on: {
                    "CONTROLLED.CLOSE": "closed",
                    "CONTROLLED.OPEN": "open",
                    POINTER_ENTER: {
                        target: "open",
                        // no need to invokeOnOpen here because it's still open (but about to close)
                        actions: [
                            "setIsPointer"
                        ]
                    }
                }
            }
        }
    }, {
        delays: {
            OPEN_DELAY: (ctx2)=>ctx2.openDelay,
            CLOSE_DELAY: (ctx2)=>ctx2.closeDelay
        },
        guards: {
            isPointer: (ctx2)=>!!ctx2.isPointer,
            isOpenControlled: (ctx2)=>!!ctx2["open.controlled"]
        },
        activities: {
            trackPositioning (ctx2) {
                ctx2.currentPlacement || (ctx2.currentPlacement = ctx2.positioning.placement);
                const getPositionerEl = ()=>$d74ac0efb763aad9$var$dom.getPositionerEl(ctx2);
                return (0, $9e811243c3728edf$export$a9fe23cfa43a7b55)($d74ac0efb763aad9$var$dom.getTriggerEl(ctx2), getPositionerEl, {
                    ...ctx2.positioning,
                    defer: true,
                    onComplete (data) {
                        ctx2.currentPlacement = data.placement;
                    }
                });
            },
            trackDismissableElement (ctx2, _evt, { send: send }) {
                const getContentEl = ()=>$d74ac0efb763aad9$var$dom.getContentEl(ctx2);
                return (0, $a0385836474f3c11$export$72bda0e502b8ea31)(getContentEl, {
                    defer: true,
                    exclude: [
                        $d74ac0efb763aad9$var$dom.getTriggerEl(ctx2)
                    ],
                    onDismiss () {
                        send({
                            type: "CLOSE",
                            src: "interact-outside"
                        });
                    },
                    onFocusOutside (event) {
                        event.preventDefault();
                    }
                });
            }
        },
        actions: {
            invokeOnClose (ctx2) {
                ctx2.onOpenChange?.({
                    open: false
                });
            },
            invokeOnOpen (ctx2) {
                ctx2.onOpenChange?.({
                    open: true
                });
            },
            setIsPointer (ctx2) {
                ctx2.isPointer = true;
            },
            clearIsPointer (ctx2) {
                ctx2.isPointer = false;
            },
            reposition (ctx2, evt) {
                const getPositionerEl = ()=>$d74ac0efb763aad9$var$dom.getPositionerEl(ctx2);
                (0, $9e811243c3728edf$export$a9fe23cfa43a7b55)($d74ac0efb763aad9$var$dom.getTriggerEl(ctx2), getPositionerEl, {
                    ...ctx2.positioning,
                    ...evt.options,
                    defer: true,
                    listeners: false,
                    onComplete (data) {
                        ctx2.currentPlacement = data.placement;
                    }
                });
            },
            toggleVisibility (ctx2, evt, { send: send }) {
                queueMicrotask(()=>{
                    send({
                        type: ctx2.open ? "CONTROLLED.OPEN" : "CONTROLLED.CLOSE",
                        previousEvent: evt
                    });
                });
            }
        }
    });
}
var $d74ac0efb763aad9$export$8128bb6492cf3de7 = (0, $5b359805fda5a40e$export$c94ea207b45fef3a)()([
    "closeDelay",
    "dir",
    "getRootNode",
    "id",
    "ids",
    "onOpenChange",
    "open.controlled",
    "open",
    "openDelay",
    "positioning"
]);
var $d74ac0efb763aad9$export$45029c61b0073d87 = (0, $89352e0ddd72597a$export$3ea53b214fbc1986)($d74ac0efb763aad9$export$8128bb6492cf3de7);


"use strict";
const $fd067fafc3133b2a$export$2d0f90af978875ab = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    className: "chakra-hover-card",
    slots: (0, $d74ac0efb763aad9$export$477202748c7242bf).keys(),
    base: {
        content: {
            position: "relative",
            display: "flex",
            flexDirection: "column",
            textStyle: "sm",
            "--hovercard-bg": "colors.bg.panel",
            bg: "var(--hovercard-bg)",
            boxShadow: "lg",
            maxWidth: "80",
            borderRadius: "l3",
            zIndex: "popover",
            transformOrigin: "var(--transform-origin)",
            outline: "0",
            _open: {
                animationStyle: "slide-fade-in",
                animationDuration: "fast"
            },
            _closed: {
                animationStyle: "slide-fade-out",
                animationDuration: "faster"
            }
        },
        arrow: {
            "--arrow-size": "sizes.3",
            "--arrow-background": "var(--hovercard-bg)"
        },
        arrowTip: {
            borderTopWidth: "0.5px",
            borderInlineStartWidth: "0.5px"
        }
    },
    variants: {
        size: {
            xs: {
                content: {
                    padding: "3"
                }
            },
            sm: {
                content: {
                    padding: "4"
                }
            },
            md: {
                content: {
                    padding: "5"
                }
            },
            lg: {
                content: {
                    padding: "6"
                }
            }
        }
    },
    defaultVariants: {
        size: "md"
    }
});




"use strict";
const $c8ea3ccfe33f36d3$export$d6effa609ff73c80 = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    className: "chakra-list",
    slots: (0, $9b7764ce1529e5da$export$12b3a655a94374ed).keys(),
    base: {
        root: {
            display: "flex",
            flexDirection: "column",
            gap: "var(--list-gap)",
            "& :where(ul, ol)": {
                marginTop: "var(--list-gap)"
            }
        },
        item: {
            whiteSpace: "normal",
            display: "list-item"
        },
        indicator: {
            marginEnd: "2",
            minHeight: "1lh",
            flexShrink: 0,
            display: "inline-block",
            verticalAlign: "middle"
        }
    },
    variants: {
        variant: {
            marker: {
                root: {
                    listStyle: "revert"
                },
                item: {
                    _marker: {
                        color: "fg.subtle"
                    }
                }
            },
            plain: {
                item: {
                    alignItems: "flex-start",
                    display: "inline-flex"
                }
            }
        },
        align: {
            center: {
                item: {
                    alignItems: "center"
                }
            },
            start: {
                item: {
                    alignItems: "flex-start"
                }
            },
            end: {
                item: {
                    alignItems: "flex-end"
                }
            }
        }
    },
    defaultVariants: {
        variant: "marker"
    }
});




"use strict";
const $ee5da4f93aebd01b$export$51b7bcd215c1d4ed = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    className: "chakra-menu",
    slots: (0, $9b7764ce1529e5da$export$e251092a5dcb1329).keys(),
    base: {
        content: {
            outline: 0,
            bg: "bg.panel",
            boxShadow: "lg",
            color: "fg",
            maxHeight: "var(--available-height)",
            "--menu-z-index": "zIndex.dropdown",
            zIndex: "calc(var(--menu-z-index) + var(--layer-index, 0))",
            borderRadius: "l2",
            overflow: "hidden",
            overflowY: "auto",
            _open: {
                animationStyle: "slide-fade-in",
                animationDuration: "fast"
            },
            _closed: {
                animationStyle: "slide-fade-out",
                animationDuration: "faster"
            }
        },
        item: {
            textDecoration: "none",
            color: "fg",
            userSelect: "none",
            borderRadius: "l1",
            width: "100%",
            display: "flex",
            cursor: "menuitem",
            alignItems: "center",
            textAlign: "start",
            position: "relative",
            flex: "0 0 auto",
            outline: 0,
            _disabled: {
                layerStyle: "disabled"
            }
        },
        itemText: {
            flex: "1"
        },
        itemGroupLabel: {
            px: "2",
            py: "1.5",
            fontWeight: "semibold",
            textStyle: "sm"
        },
        indicator: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: "0"
        },
        itemCommand: {
            opacity: "0.6",
            textStyle: "xs",
            ms: "auto",
            ps: "4",
            letterSpacing: "widest"
        },
        separator: {
            height: "1px",
            bg: "bg.muted",
            my: "1",
            mx: "-1"
        }
    },
    variants: {
        variant: {
            subtle: {
                item: {
                    _highlighted: {
                        bg: "bg.emphasized/60"
                    }
                }
            },
            solid: {
                item: {
                    _highlighted: {
                        bg: "colorPalette.solid",
                        color: "colorPalette.contrast"
                    }
                }
            }
        },
        size: {
            sm: {
                content: {
                    minW: "8rem",
                    padding: "1"
                },
                item: {
                    gap: "1",
                    textStyle: "xs",
                    py: "1",
                    px: "1.5"
                }
            },
            md: {
                content: {
                    minW: "8rem",
                    padding: "1.5"
                },
                item: {
                    gap: "2",
                    textStyle: "sm",
                    py: "1.5",
                    px: "2"
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "subtle"
    }
});






"use strict";
const $9563cc14b192a234$export$a17a1e7a6654f699 = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    className: "chakra-select",
    slots: (0, $9b7764ce1529e5da$export$17993f0be9538b5a).keys(),
    base: {
        root: {
            display: "flex",
            flexDirection: "column",
            gap: "1.5",
            width: "full"
        },
        trigger: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "full",
            minH: "var(--select-trigger-height)",
            px: "var(--select-trigger-padding-x)",
            borderRadius: "l2",
            userSelect: "none",
            textAlign: "start",
            focusVisibleRing: "inside",
            _placeholderShown: {
                color: "fg.muted/80"
            },
            _disabled: {
                layerStyle: "disabled"
            },
            _invalid: {
                borderColor: "border.error"
            }
        },
        indicatorGroup: {
            display: "flex",
            alignItems: "center",
            gap: "1",
            pos: "absolute",
            right: "0",
            top: "0",
            bottom: "0",
            px: "var(--select-trigger-padding-x)",
            pointerEvents: "none"
        },
        indicator: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: {
                base: "fg.muted",
                _disabled: "fg.subtle",
                _invalid: "fg.error"
            }
        },
        content: {
            background: "bg.panel",
            display: "flex",
            flexDirection: "column",
            zIndex: "dropdown",
            borderRadius: "l2",
            outline: 0,
            maxH: "96",
            overflowY: "auto",
            boxShadow: "md",
            _open: {
                animationStyle: "slide-fade-in",
                animationDuration: "fast"
            },
            _closed: {
                animationStyle: "slide-fade-out",
                animationDuration: "fastest"
            }
        },
        item: {
            position: "relative",
            userSelect: "none",
            display: "flex",
            alignItems: "center",
            gap: "2",
            cursor: "option",
            justifyContent: "space-between",
            flex: "1",
            textAlign: "start",
            borderRadius: "l1",
            _highlighted: {
                bg: "bg.emphasized/60"
            },
            _disabled: {
                pointerEvents: "none",
                opacity: "0.5"
            },
            _icon: {
                width: "4",
                height: "4"
            }
        },
        control: {
            pos: "relative"
        },
        itemText: {
            flex: "1"
        },
        itemGroup: {
            _first: {
                mt: "0"
            }
        },
        itemGroupLabel: {
            py: "1",
            fontWeight: "medium"
        },
        label: {
            fontWeight: "medium",
            userSelect: "none",
            textStyle: "sm",
            _disabled: {
                layerStyle: "disabled"
            }
        },
        valueText: {
            lineClamp: "1",
            maxW: "80%"
        }
    },
    variants: {
        variant: {
            outline: {
                trigger: {
                    bg: "transparent",
                    borderWidth: "1px",
                    borderColor: "border",
                    _expanded: {
                        borderColor: "border.emphasized"
                    }
                }
            },
            subtle: {
                trigger: {
                    borderWidth: "1px",
                    borderColor: "transparent",
                    bg: "bg.muted"
                }
            }
        },
        size: {
            xs: {
                root: {
                    "--select-trigger-height": "sizes.8",
                    "--select-trigger-padding-x": "spacing.2"
                },
                content: {
                    p: "1",
                    gap: "1",
                    textStyle: "xs"
                },
                trigger: {
                    textStyle: "xs",
                    gap: "1"
                },
                item: {
                    py: "1",
                    px: "2"
                },
                itemGroupLabel: {
                    py: "1",
                    px: "2"
                },
                indicator: {
                    _icon: {
                        width: "3.5",
                        height: "3.5"
                    }
                }
            },
            sm: {
                root: {
                    "--select-trigger-height": "sizes.9",
                    "--select-trigger-padding-x": "spacing.2.5"
                },
                content: {
                    p: "1",
                    textStyle: "sm"
                },
                trigger: {
                    textStyle: "sm",
                    gap: "1"
                },
                indicator: {
                    _icon: {
                        width: "4",
                        height: "4"
                    }
                },
                item: {
                    py: "1",
                    px: "1.5"
                },
                itemGroup: {
                    mt: "1"
                },
                itemGroupLabel: {
                    py: "1",
                    px: "1.5"
                }
            },
            md: {
                root: {
                    "--select-trigger-height": "sizes.10",
                    "--select-trigger-padding-x": "spacing.3"
                },
                content: {
                    p: "1",
                    textStyle: "sm"
                },
                itemGroup: {
                    mt: "1.5"
                },
                item: {
                    py: "1.5",
                    px: "2"
                },
                itemIndicator: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                },
                itemGroupLabel: {
                    py: "1.5",
                    px: "2"
                },
                trigger: {
                    textStyle: "sm",
                    gap: "2"
                },
                indicator: {
                    _icon: {
                        width: "4",
                        height: "4"
                    }
                }
            },
            lg: {
                root: {
                    "--select-trigger-height": "sizes.12",
                    "--select-trigger-padding-x": "spacing.4"
                },
                content: {
                    p: "1.5",
                    textStyle: "md"
                },
                itemGroup: {
                    mt: "2"
                },
                item: {
                    py: "2",
                    px: "3"
                },
                itemGroupLabel: {
                    py: "2",
                    px: "3"
                },
                trigger: {
                    textStyle: "md",
                    py: "3",
                    gap: "2"
                },
                indicator: {
                    _icon: {
                        width: "5",
                        height: "5"
                    }
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "outline"
    }
});


"use strict";
const $84885f741037b150$export$bd566e82fcc568be = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    className: "chakra-native-select",
    slots: (0, $9b7764ce1529e5da$export$f38e0304163546fd).keys(),
    base: {
        root: {
            height: "fit-content",
            display: "flex",
            width: "100%",
            position: "relative"
        },
        field: {
            width: "100%",
            minWidth: "0",
            outline: "0",
            appearance: "none",
            borderRadius: "l2",
            "--error-color": "colors.border.error",
            _disabled: {
                layerStyle: "disabled"
            },
            _invalid: {
                focusRingColor: "var(--error-color)",
                borderColor: "var(--error-color)"
            },
            focusVisibleRing: "inside",
            lineHeight: "normal",
            "& > option, & > optgroup": {
                bg: "bg"
            }
        },
        indicator: {
            position: "absolute",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none",
            top: "50%",
            transform: "translateY(-50%)",
            height: "100%",
            color: "fg.muted",
            _disabled: {
                opacity: "0.5"
            },
            _invalid: {
                color: "fg.error"
            },
            _icon: {
                width: "1em",
                height: "1em"
            }
        }
    },
    variants: {
        variant: {
            outline: {
                field: (0, $9563cc14b192a234$export$a17a1e7a6654f699).variants?.variant.outline.trigger
            },
            subtle: {
                field: (0, $9563cc14b192a234$export$a17a1e7a6654f699).variants?.variant.subtle.trigger
            },
            plain: {
                field: {
                    bg: "transparent",
                    color: "fg",
                    focusRingWidth: "2px"
                }
            }
        },
        size: {
            xs: {
                field: {
                    textStyle: "xs",
                    ps: "2",
                    pe: "6",
                    height: "6"
                },
                indicator: {
                    textStyle: "sm",
                    insetEnd: "1.5"
                }
            },
            sm: {
                field: {
                    textStyle: "sm",
                    ps: "2.5",
                    pe: "8",
                    height: "8"
                },
                indicator: {
                    textStyle: "md",
                    insetEnd: "2"
                }
            },
            md: {
                field: {
                    textStyle: "sm",
                    ps: "3",
                    pe: "8",
                    height: "10"
                },
                indicator: {
                    textStyle: "lg",
                    insetEnd: "2"
                }
            },
            lg: {
                field: {
                    textStyle: "md",
                    ps: "4",
                    pe: "8",
                    height: "11"
                },
                indicator: {
                    textStyle: "xl",
                    insetEnd: "3"
                }
            },
            xl: {
                field: {
                    textStyle: "md",
                    ps: "4.5",
                    pe: "10",
                    height: "12"
                },
                indicator: {
                    textStyle: "xl",
                    insetEnd: "3"
                }
            }
        }
    },
    defaultVariants: (0, $9563cc14b192a234$export$a17a1e7a6654f699).defaultVariants
});



"use strict";
function $f262c6389d8a528e$export$592ef47eabb05614(obj, f) {
    const result = {};
    for(const key in obj){
        const kv = f(key, obj[key]);
        result[kv[0]] = kv[1];
    }
    return result;
}







/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$formatterCache = new Map();
let $14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$supportsSignDisplay = false;
try {
    $14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$supportsSignDisplay = new Intl.NumberFormat("de-DE", {
        signDisplay: "exceptZero"
    }).resolvedOptions().signDisplay === "exceptZero";
// eslint-disable-next-line no-empty
} catch  {}
let $14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$supportsUnit = false;
try {
    $14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$supportsUnit = new Intl.NumberFormat("de-DE", {
        style: "unit",
        unit: "degree"
    }).resolvedOptions().style === "unit";
// eslint-disable-next-line no-empty
} catch  {}
// Polyfill for units since Safari doesn't support them yet. See https://bugs.webkit.org/show_bug.cgi?id=215438.
// Currently only polyfilling the unit degree in narrow format for ColorSlider in our supported locales.
// Values were determined by switching to each locale manually in Chrome.
const $14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$UNITS = {
    degree: {
        narrow: {
            default: "\xb0",
            "ja-JP": " \u5EA6",
            "zh-TW": "\u5EA6",
            "sl-SI": " \xb0"
        }
    }
};
class $14359adf615d4bd8$export$cc77c4ff7e8673c5 {
    /** Formats a number value as a string, according to the locale and options provided to the constructor. */ format(value) {
        let res = "";
        if (!$14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$supportsSignDisplay && this.options.signDisplay != null) res = $14359adf615d4bd8$export$711b50b3c525e0f2(this.numberFormatter, this.options.signDisplay, value);
        else res = this.numberFormatter.format(value);
        if (this.options.style === "unit" && !$14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$supportsUnit) {
            var _UNITS_unit;
            let { unit: unit, unitDisplay: unitDisplay = "short", locale: locale } = this.resolvedOptions();
            if (!unit) return res;
            let values = (_UNITS_unit = $14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$UNITS[unit]) === null || _UNITS_unit === void 0 ? void 0 : _UNITS_unit[unitDisplay];
            res += values[locale] || values.default;
        }
        return res;
    }
    /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */ formatToParts(value) {
        // TODO: implement signDisplay for formatToParts
        return this.numberFormatter.formatToParts(value);
    }
    /** Formats a number range as a string. */ formatRange(start, end) {
        if (typeof this.numberFormatter.formatRange === "function") return this.numberFormatter.formatRange(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        // Very basic fallback for old browsers.
        return `${this.format(start)} \u{2013} ${this.format(end)}`;
    }
    /** Formats a number range as an array of parts. */ formatRangeToParts(start, end) {
        if (typeof this.numberFormatter.formatRangeToParts === "function") return this.numberFormatter.formatRangeToParts(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        let startParts = this.numberFormatter.formatToParts(start);
        let endParts = this.numberFormatter.formatToParts(end);
        return [
            ...startParts.map((p)=>({
                    ...p,
                    source: "startRange"
                })),
            {
                type: "literal",
                value: " \u2013 ",
                source: "shared"
            },
            ...endParts.map((p)=>({
                    ...p,
                    source: "endRange"
                }))
        ];
    }
    /** Returns the resolved formatting options based on the values passed to the constructor. */ resolvedOptions() {
        let options = this.numberFormatter.resolvedOptions();
        if (!$14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$supportsSignDisplay && this.options.signDisplay != null) options = {
            ...options,
            signDisplay: this.options.signDisplay
        };
        if (!$14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$supportsUnit && this.options.style === "unit") options = {
            ...options,
            style: "unit",
            unit: this.options.unit,
            unitDisplay: this.options.unitDisplay
        };
        return options;
    }
    constructor(locale, options = {}){
        this.numberFormatter = $14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$getCachedNumberFormatter(locale, options);
        this.options = options;
    }
}
function $14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$getCachedNumberFormatter(locale, options = {}) {
    let { numberingSystem: numberingSystem } = options;
    if (numberingSystem && locale.includes("-nu-")) {
        if (!locale.includes("-u-")) locale += "-u-";
        locale += `-nu-${numberingSystem}`;
    }
    if (options.style === "unit" && !$14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$supportsUnit) {
        var _UNITS_unit;
        let { unit: unit, unitDisplay: unitDisplay = "short" } = options;
        if (!unit) throw new Error('unit option must be provided with style: "unit"');
        if (!((_UNITS_unit = $14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$UNITS[unit]) === null || _UNITS_unit === void 0 ? void 0 : _UNITS_unit[unitDisplay])) throw new Error(`Unsupported unit ${unit} with unitDisplay = ${unitDisplay}`);
        options = {
            ...options,
            style: "decimal"
        };
    }
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    if ($14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$formatterCache.has(cacheKey)) return $14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$formatterCache.get(cacheKey);
    let numberFormatter = new Intl.NumberFormat(locale, options);
    $14359adf615d4bd8$var$$488c6ddbf4ef74c2$var$formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
function $14359adf615d4bd8$export$711b50b3c525e0f2(numberFormat, signDisplay, num) {
    if (signDisplay === "auto") return numberFormat.format(num);
    else if (signDisplay === "never") return numberFormat.format(Math.abs(num));
    else {
        let needsPositiveSign = false;
        if (signDisplay === "always") needsPositiveSign = num > 0 || Object.is(num, 0);
        else if (signDisplay === "exceptZero") {
            if (Object.is(num, -0) || Object.is(num, 0)) num = Math.abs(num);
            else needsPositiveSign = num > 0;
        }
        if (needsPositiveSign) {
            let negative = numberFormat.format(-num);
            let noSign = numberFormat.format(num);
            // ignore RTL/LTR marker character
            let minus = negative.replace(noSign, "").replace(/\u200e|\u061C/, "");
            if ([
                ...minus
            ].length !== 1) console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case");
            let positive = negative.replace(noSign, "!!!").replace(minus, "+").replace("!!!", noSign);
            return positive;
        } else return numberFormat.format(num);
    }
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $f764810b880bba05$var$$6c7bd7858deea686$var$CURRENCY_SIGN_REGEX = new RegExp("^.*\\(.*\\).*$");
const $f764810b880bba05$var$$6c7bd7858deea686$var$NUMBERING_SYSTEMS = [
    "latn",
    "arab",
    "hanidec",
    "deva",
    "beng"
];
class $f764810b880bba05$export$cd11ab140839f11d {
    /**
   * Parses the given string to a number. Returns NaN if a valid number could not be parsed.
   */ parse(value) {
        return $f764810b880bba05$var$$6c7bd7858deea686$var$getNumberParserImpl(this.locale, this.options, value).parse(value);
    }
    /**
   * Returns whether the given string could potentially be a valid number. This should be used to
   * validate user input as the user types. If a `minValue` or `maxValue` is provided, the validity
   * of the minus/plus sign characters can be checked.
   */ isValidPartialNumber(value, minValue, maxValue) {
        return $f764810b880bba05$var$$6c7bd7858deea686$var$getNumberParserImpl(this.locale, this.options, value).isValidPartialNumber(value, minValue, maxValue);
    }
    /**
   * Returns a numbering system for which the given string is valid in the current locale.
   * If no numbering system could be detected, the default numbering system for the current
   * locale is returned.
   */ getNumberingSystem(value) {
        return $f764810b880bba05$var$$6c7bd7858deea686$var$getNumberParserImpl(this.locale, this.options, value).options.numberingSystem;
    }
    constructor(locale, options = {}){
        this.locale = locale;
        this.options = options;
    }
}
const $f764810b880bba05$var$$6c7bd7858deea686$var$numberParserCache = new Map();
function $f764810b880bba05$var$$6c7bd7858deea686$var$getNumberParserImpl(locale, options, value) {
    // First try the default numbering system for the provided locale
    let defaultParser = $f764810b880bba05$var$$6c7bd7858deea686$var$getCachedNumberParser(locale, options);
    // If that doesn't match, and the locale doesn't include a hard coded numbering system,
    // try each of the other supported numbering systems until we find one that matches.
    if (!locale.includes("-nu-") && !defaultParser.isValidPartialNumber(value)) {
        for (let numberingSystem of $f764810b880bba05$var$$6c7bd7858deea686$var$NUMBERING_SYSTEMS)if (numberingSystem !== defaultParser.options.numberingSystem) {
            let parser = $f764810b880bba05$var$$6c7bd7858deea686$var$getCachedNumberParser(locale + (locale.includes("-u-") ? "-nu-" : "-u-nu-") + numberingSystem, options);
            if (parser.isValidPartialNumber(value)) return parser;
        }
    }
    return defaultParser;
}
function $f764810b880bba05$var$$6c7bd7858deea686$var$getCachedNumberParser(locale, options) {
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    let parser = $f764810b880bba05$var$$6c7bd7858deea686$var$numberParserCache.get(cacheKey);
    if (!parser) {
        parser = new $f764810b880bba05$var$$6c7bd7858deea686$var$NumberParserImpl(locale, options);
        $f764810b880bba05$var$$6c7bd7858deea686$var$numberParserCache.set(cacheKey, parser);
    }
    return parser;
}
// The actual number parser implementation. Instances of this class are cached
// based on the locale, options, and detected numbering system.
class $f764810b880bba05$var$$6c7bd7858deea686$var$NumberParserImpl {
    parse(value) {
        // to parse the number, we need to remove anything that isn't actually part of the number, for example we want '-10.40' not '-10.40 USD'
        let fullySanitizedValue = this.sanitize(value);
        if (this.symbols.group) fullySanitizedValue = $f764810b880bba05$var$$6c7bd7858deea686$var$replaceAll(fullySanitizedValue, this.symbols.group, "");
        if (this.symbols.decimal) fullySanitizedValue = fullySanitizedValue.replace(this.symbols.decimal, ".");
        if (this.symbols.minusSign) fullySanitizedValue = fullySanitizedValue.replace(this.symbols.minusSign, "-");
        fullySanitizedValue = fullySanitizedValue.replace(this.symbols.numeral, this.symbols.index);
        if (this.options.style === "percent") {
            // javascript is bad at dividing by 100 and maintaining the same significant figures, so perform it on the string before parsing
            let isNegative = fullySanitizedValue.indexOf("-");
            fullySanitizedValue = fullySanitizedValue.replace("-", "");
            let index = fullySanitizedValue.indexOf(".");
            if (index === -1) index = fullySanitizedValue.length;
            fullySanitizedValue = fullySanitizedValue.replace(".", "");
            if (index - 2 === 0) fullySanitizedValue = `0.${fullySanitizedValue}`;
            else if (index - 2 === -1) fullySanitizedValue = `0.0${fullySanitizedValue}`;
            else if (index - 2 === -2) fullySanitizedValue = "0.00";
            else fullySanitizedValue = `${fullySanitizedValue.slice(0, index - 2)}.${fullySanitizedValue.slice(index - 2)}`;
            if (isNegative > -1) fullySanitizedValue = `-${fullySanitizedValue}`;
        }
        let newValue = fullySanitizedValue ? +fullySanitizedValue : NaN;
        if (isNaN(newValue)) return NaN;
        if (this.options.style === "percent") {
            var _this_options_minimumFractionDigits, _this_options_maximumFractionDigits;
            // extra step for rounding percents to what our formatter would output
            let options = {
                ...this.options,
                style: "decimal",
                minimumFractionDigits: Math.min(((_this_options_minimumFractionDigits = this.options.minimumFractionDigits) !== null && _this_options_minimumFractionDigits !== void 0 ? _this_options_minimumFractionDigits : 0) + 2, 20),
                maximumFractionDigits: Math.min(((_this_options_maximumFractionDigits = this.options.maximumFractionDigits) !== null && _this_options_maximumFractionDigits !== void 0 ? _this_options_maximumFractionDigits : 0) + 2, 20)
            };
            return new $f764810b880bba05$export$cd11ab140839f11d(this.locale, options).parse(new (0, $14359adf615d4bd8$export$cc77c4ff7e8673c5)(this.locale, options).format(newValue));
        }
        // accounting will always be stripped to a positive number, so if it's accounting and has a () around everything, then we need to make it negative again
        if (this.options.currencySign === "accounting" && $f764810b880bba05$var$$6c7bd7858deea686$var$CURRENCY_SIGN_REGEX.test(value)) newValue = -1 * newValue;
        return newValue;
    }
    sanitize(value) {
        // Remove literals and whitespace, which are allowed anywhere in the string
        value = value.replace(this.symbols.literals, "");
        // Replace the ASCII minus sign with the minus sign used in the current locale
        // so that both are allowed in case the user's keyboard doesn't have the locale's minus sign.
        if (this.symbols.minusSign) value = value.replace("-", this.symbols.minusSign);
        // In arab numeral system, their decimal character is 1643, but most keyboards don't type that
        // instead they use the , (44) character or apparently the (1548) character.
        if (this.options.numberingSystem === "arab") {
            if (this.symbols.decimal) {
                value = value.replace(",", this.symbols.decimal);
                value = value.replace(String.fromCharCode(1548), this.symbols.decimal);
            }
            if (this.symbols.group) value = $f764810b880bba05$var$$6c7bd7858deea686$var$replaceAll(value, ".", this.symbols.group);
        }
        // fr-FR group character is char code 8239, but that's not a key on the french keyboard,
        // so allow 'period' as a group char and replace it with a space
        if (this.options.locale === "fr-FR") value = $f764810b880bba05$var$$6c7bd7858deea686$var$replaceAll(value, ".", String.fromCharCode(8239));
        return value;
    }
    isValidPartialNumber(value, minValue = -Infinity, maxValue = Infinity) {
        value = this.sanitize(value);
        // Remove minus or plus sign, which must be at the start of the string.
        if (this.symbols.minusSign && value.startsWith(this.symbols.minusSign) && minValue < 0) value = value.slice(this.symbols.minusSign.length);
        else if (this.symbols.plusSign && value.startsWith(this.symbols.plusSign) && maxValue > 0) value = value.slice(this.symbols.plusSign.length);
        // Numbers cannot start with a group separator
        if (this.symbols.group && value.startsWith(this.symbols.group)) return false;
        // Numbers that can't have any decimal values fail if a decimal character is typed
        if (this.symbols.decimal && value.indexOf(this.symbols.decimal) > -1 && this.options.maximumFractionDigits === 0) return false;
        // Remove numerals, groups, and decimals
        if (this.symbols.group) value = $f764810b880bba05$var$$6c7bd7858deea686$var$replaceAll(value, this.symbols.group, "");
        value = value.replace(this.symbols.numeral, "");
        if (this.symbols.decimal) value = value.replace(this.symbols.decimal, "");
        // The number is valid if there are no remaining characters
        return value.length === 0;
    }
    constructor(locale, options = {}){
        this.locale = locale;
        this.formatter = new Intl.NumberFormat(locale, options);
        this.options = this.formatter.resolvedOptions();
        this.symbols = $f764810b880bba05$var$$6c7bd7858deea686$var$getSymbols(locale, this.formatter, this.options, options);
        var _this_options_minimumFractionDigits, _this_options_maximumFractionDigits;
        if (this.options.style === "percent" && (((_this_options_minimumFractionDigits = this.options.minimumFractionDigits) !== null && _this_options_minimumFractionDigits !== void 0 ? _this_options_minimumFractionDigits : 0) > 18 || ((_this_options_maximumFractionDigits = this.options.maximumFractionDigits) !== null && _this_options_maximumFractionDigits !== void 0 ? _this_options_maximumFractionDigits : 0) > 18)) console.warn("NumberParser cannot handle percentages with greater than 18 decimal places, please reduce the number in your options.");
    }
}
const $f764810b880bba05$var$$6c7bd7858deea686$var$nonLiteralParts = new Set([
    "decimal",
    "fraction",
    "integer",
    "minusSign",
    "plusSign",
    "group"
]);
// This list is derived from https://www.unicode.org/cldr/charts/43/supplemental/language_plural_rules.html#comparison and includes
// all unique numbers which we need to check in order to determine all the plural forms for a given locale.
// See: https://github.com/adobe/react-spectrum/pull/5134/files#r1337037855 for used script
const $f764810b880bba05$var$$6c7bd7858deea686$var$pluralNumbers = [
    0,
    4,
    2,
    1,
    11,
    20,
    3,
    7,
    100,
    21,
    0.1,
    1.1
];
function $f764810b880bba05$var$$6c7bd7858deea686$var$getSymbols(locale, formatter, intlOptions, originalOptions) {
    var _allParts_find, _posAllParts_find, _decimalParts_find, _allParts_find1;
    // formatter needs access to all decimal places in order to generate the correct literal strings for the plural set
    let symbolFormatter = new Intl.NumberFormat(locale, {
        ...intlOptions,
        // Resets so we get the full range of symbols
        minimumSignificantDigits: 1,
        maximumSignificantDigits: 21,
        roundingIncrement: 1,
        roundingPriority: "auto",
        roundingMode: "halfExpand"
    });
    // Note: some locale's don't add a group symbol until there is a ten thousands place
    let allParts = symbolFormatter.formatToParts(-10000.111);
    let posAllParts = symbolFormatter.formatToParts(10000.111);
    let pluralParts = $f764810b880bba05$var$$6c7bd7858deea686$var$pluralNumbers.map((n)=>symbolFormatter.formatToParts(n));
    var _allParts_find_value;
    let minusSign = (_allParts_find_value = (_allParts_find = allParts.find((p)=>p.type === "minusSign")) === null || _allParts_find === void 0 ? void 0 : _allParts_find.value) !== null && _allParts_find_value !== void 0 ? _allParts_find_value : "-";
    let plusSign = (_posAllParts_find = posAllParts.find((p)=>p.type === "plusSign")) === null || _posAllParts_find === void 0 ? void 0 : _posAllParts_find.value;
    // Safari does not support the signDisplay option, but our number parser polyfills it.
    // If no plus sign was returned, but the original options contained signDisplay, default to the '+' character.
    if (!plusSign && ((originalOptions === null || originalOptions === void 0 ? void 0 : originalOptions.signDisplay) === "exceptZero" || (originalOptions === null || originalOptions === void 0 ? void 0 : originalOptions.signDisplay) === "always")) plusSign = "+";
    // If maximumSignificantDigits is 1 (the minimum) then we won't get decimal characters out of the above formatters
    // Percent also defaults to 0 fractionDigits, so we need to make a new one that isn't percent to get an accurate decimal
    let decimalParts = new Intl.NumberFormat(locale, {
        ...intlOptions,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).formatToParts(0.001);
    let decimal = (_decimalParts_find = decimalParts.find((p)=>p.type === "decimal")) === null || _decimalParts_find === void 0 ? void 0 : _decimalParts_find.value;
    let group = (_allParts_find1 = allParts.find((p)=>p.type === "group")) === null || _allParts_find1 === void 0 ? void 0 : _allParts_find1.value;
    // this set is also for a regex, it's all literals that might be in the string we want to eventually parse that
    // don't contribute to the numerical value
    let allPartsLiterals = allParts.filter((p)=>!$f764810b880bba05$var$$6c7bd7858deea686$var$nonLiteralParts.has(p.type)).map((p)=>$f764810b880bba05$var$$6c7bd7858deea686$var$escapeRegex(p.value));
    let pluralPartsLiterals = pluralParts.flatMap((p)=>p.filter((p)=>!$f764810b880bba05$var$$6c7bd7858deea686$var$nonLiteralParts.has(p.type)).map((p)=>$f764810b880bba05$var$$6c7bd7858deea686$var$escapeRegex(p.value)));
    let sortedLiterals = [
        ...new Set([
            ...allPartsLiterals,
            ...pluralPartsLiterals
        ])
    ].sort((a, b)=>b.length - a.length);
    let literals = sortedLiterals.length === 0 ? new RegExp("[\\p{White_Space}]", "gu") : new RegExp(`${sortedLiterals.join("|")}|[\\p{White_Space}]`, "gu");
    // These are for replacing non-latn characters with the latn equivalent
    let numerals = [
        ...new Intl.NumberFormat(intlOptions.locale, {
            useGrouping: false
        }).format(9876543210)
    ].reverse();
    let indexes = new Map(numerals.map((d, i)=>[
            d,
            i
        ]));
    let numeral = new RegExp(`[${numerals.join("")}]`, "g");
    let index = (d)=>String(indexes.get(d));
    return {
        minusSign: minusSign,
        plusSign: plusSign,
        decimal: decimal,
        group: group,
        literals: literals,
        numeral: numeral,
        index: index
    };
}
function $f764810b880bba05$var$$6c7bd7858deea686$var$replaceAll(str, find, replace) {
    if (str.replaceAll) return str.replaceAll(find, replace);
    return str.split(find).join(replace);
}
function $f764810b880bba05$var$$6c7bd7858deea686$var$escapeRegex(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}


// src/number-input.anatomy.ts
var $c654b4eb021ac767$export$477202748c7242bf = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("numberInput").parts("root", "label", "input", "control", "valueText", "incrementTrigger", "decrementTrigger", "scrubber");
var $c654b4eb021ac767$var$parts = $c654b4eb021ac767$export$477202748c7242bf.build();
var $c654b4eb021ac767$var$dom = (0, $b06ec5ff205338e5$export$41a9651decfe2bde)({
    getRootId: (ctx)=>ctx.ids?.root ?? `number-input:${ctx.id}`,
    getInputId: (ctx)=>ctx.ids?.input ?? `number-input:${ctx.id}:input`,
    getIncrementTriggerId: (ctx)=>ctx.ids?.incrementTrigger ?? `number-input:${ctx.id}:inc`,
    getDecrementTriggerId: (ctx)=>ctx.ids?.decrementTrigger ?? `number-input:${ctx.id}:dec`,
    getScrubberId: (ctx)=>ctx.ids?.scrubber ?? `number-input:${ctx.id}:scrubber`,
    getCursorId: (ctx)=>`number-input:${ctx.id}:cursor`,
    getLabelId: (ctx)=>ctx.ids?.label ?? `number-input:${ctx.id}:label`,
    getInputEl: (ctx)=>$c654b4eb021ac767$var$dom.getById(ctx, $c654b4eb021ac767$var$dom.getInputId(ctx)),
    getIncrementTriggerEl: (ctx)=>$c654b4eb021ac767$var$dom.getById(ctx, $c654b4eb021ac767$var$dom.getIncrementTriggerId(ctx)),
    getDecrementTriggerEl: (ctx)=>$c654b4eb021ac767$var$dom.getById(ctx, $c654b4eb021ac767$var$dom.getDecrementTriggerId(ctx)),
    getScrubberEl: (ctx)=>$c654b4eb021ac767$var$dom.getById(ctx, $c654b4eb021ac767$var$dom.getScrubberId(ctx)),
    getCursorEl: (ctx)=>$c654b4eb021ac767$var$dom.getDoc(ctx).getElementById($c654b4eb021ac767$var$dom.getCursorId(ctx)),
    getPressedTriggerEl: (ctx, hint = ctx.hint)=>{
        let btnEl = null;
        if (hint === "increment") btnEl = $c654b4eb021ac767$var$dom.getIncrementTriggerEl(ctx);
        if (hint === "decrement") btnEl = $c654b4eb021ac767$var$dom.getDecrementTriggerEl(ctx);
        return btnEl;
    },
    setupVirtualCursor (ctx) {
        if ((0, $b06ec5ff205338e5$export$95df08bae54cb4df)()) return;
        $c654b4eb021ac767$var$dom.createVirtualCursor(ctx);
        return ()=>{
            $c654b4eb021ac767$var$dom.getCursorEl(ctx)?.remove();
        };
    },
    preventTextSelection (ctx) {
        const doc = $c654b4eb021ac767$var$dom.getDoc(ctx);
        const html = doc.documentElement;
        const body = doc.body;
        body.style.pointerEvents = "none";
        html.style.userSelect = "none";
        html.style.cursor = "ew-resize";
        return ()=>{
            body.style.pointerEvents = "";
            html.style.userSelect = "";
            html.style.cursor = "";
            if (!html.style.length) html.removeAttribute("style");
            if (!body.style.length) body.removeAttribute("style");
        };
    },
    getMousemoveValue (ctx, event) {
        const win = $c654b4eb021ac767$var$dom.getWin(ctx);
        const x = (0, $89352e0ddd72597a$export$db558e705f7d32d7)(event.movementX, win.devicePixelRatio);
        const y = (0, $89352e0ddd72597a$export$db558e705f7d32d7)(event.movementY, win.devicePixelRatio);
        let hint = x > 0 ? "increment" : x < 0 ? "decrement" : null;
        if (ctx.isRtl && hint === "increment") hint = "decrement";
        if (ctx.isRtl && hint === "decrement") hint = "increment";
        const point = {
            x: ctx.scrubberCursorPoint.x + x,
            y: ctx.scrubberCursorPoint.y + y
        };
        const width = win.innerWidth;
        const half = (0, $89352e0ddd72597a$export$db558e705f7d32d7)(7.5, win.devicePixelRatio);
        point.x = (0, $89352e0ddd72597a$export$4997ffc0176396a6)(point.x + half, width) - half;
        return {
            hint: hint,
            point: point
        };
    },
    createVirtualCursor (ctx) {
        const doc = $c654b4eb021ac767$var$dom.getDoc(ctx);
        const el = doc.createElement("div");
        el.className = "scrubber--cursor";
        el.id = $c654b4eb021ac767$var$dom.getCursorId(ctx);
        Object.assign(el.style, {
            width: "15px",
            height: "15px",
            position: "fixed",
            pointerEvents: "none",
            left: "0px",
            top: "0px",
            zIndex: (0, $b06ec5ff205338e5$export$e2f9a725ee199e81),
            transform: ctx.scrubberCursorPoint ? `translate3d(${ctx.scrubberCursorPoint.x}px, ${ctx.scrubberCursorPoint.y}px, 0px)` : void 0,
            willChange: "transform"
        });
        el.innerHTML = `
        <svg width="46" height="15" style="left: -15.5px; position: absolute; top: 0; filter: drop-shadow(rgba(0, 0, 0, 0.4) 0px 1px 1.1px);">
          <g transform="translate(2 3)">
            <path fill-rule="evenodd" d="M 15 4.5L 15 2L 11.5 5.5L 15 9L 15 6.5L 31 6.5L 31 9L 34.5 5.5L 31 2L 31 4.5Z" style="stroke-width: 2px; stroke: white;"></path>
            <path fill-rule="evenodd" d="M 15 4.5L 15 2L 11.5 5.5L 15 9L 15 6.5L 31 6.5L 31 9L 34.5 5.5L 31 2L 31 4.5Z"></path>
          </g>
        </svg>`;
        doc.body.appendChild(el);
    }
});
// src/number-input.connect.ts
function $c654b4eb021ac767$export$64605811ab45167f(state, send, normalize) {
    const focused = state.hasTag("focus");
    const disabled = state.context.isDisabled;
    const readOnly = state.context.readOnly;
    const empty = state.context.isValueEmpty;
    const invalid = state.context.isOutOfRange || !!state.context.invalid;
    const isIncrementDisabled = disabled || !state.context.canIncrement || readOnly;
    const isDecrementDisabled = disabled || !state.context.canDecrement || readOnly;
    const translations = state.context.translations;
    return {
        focused: focused,
        invalid: invalid,
        empty: empty,
        value: state.context.formattedValue,
        valueAsNumber: state.context.valueAsNumber,
        setValue (value) {
            send({
                type: "VALUE.SET",
                value: value
            });
        },
        clearValue () {
            send("VALUE.CLEAR");
        },
        increment () {
            send("VALUE.INCREMENT");
        },
        decrement () {
            send("VALUE.DECREMENT");
        },
        setToMax () {
            send({
                type: "VALUE.SET",
                value: state.context.max
            });
        },
        setToMin () {
            send({
                type: "VALUE.SET",
                value: state.context.min
            });
        },
        focus () {
            $c654b4eb021ac767$var$dom.getInputEl(state.context)?.focus();
        },
        getRootProps () {
            return normalize.element({
                id: $c654b4eb021ac767$var$dom.getRootId(state.context),
                ...$c654b4eb021ac767$var$parts.root.attrs,
                dir: state.context.dir,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-focus": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(focused),
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(invalid)
            });
        },
        getLabelProps () {
            return normalize.label({
                ...$c654b4eb021ac767$var$parts.label.attrs,
                dir: state.context.dir,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-focus": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(focused),
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(invalid),
                id: $c654b4eb021ac767$var$dom.getLabelId(state.context),
                htmlFor: $c654b4eb021ac767$var$dom.getInputId(state.context)
            });
        },
        getControlProps () {
            return normalize.element({
                ...$c654b4eb021ac767$var$parts.control.attrs,
                dir: state.context.dir,
                role: "group",
                "aria-disabled": disabled,
                "data-focus": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(focused),
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(invalid),
                "aria-invalid": (0, $b06ec5ff205338e5$export$91a6105db3d4be7b)(state.context.invalid)
            });
        },
        getValueTextProps () {
            return normalize.element({
                ...$c654b4eb021ac767$var$parts.valueText.attrs,
                dir: state.context.dir,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(invalid),
                "data-focus": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(focused)
            });
        },
        getInputProps () {
            return normalize.input({
                ...$c654b4eb021ac767$var$parts.input.attrs,
                dir: state.context.dir,
                name: state.context.name,
                form: state.context.form,
                id: $c654b4eb021ac767$var$dom.getInputId(state.context),
                role: "spinbutton",
                defaultValue: state.context.formattedValue,
                pattern: state.context.pattern,
                inputMode: state.context.inputMode,
                "aria-invalid": (0, $b06ec5ff205338e5$export$91a6105db3d4be7b)(invalid),
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(invalid),
                disabled: disabled,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                readOnly: state.context.readOnly,
                required: state.context.required,
                autoComplete: "off",
                autoCorrect: "off",
                spellCheck: "false",
                type: "text",
                "aria-roledescription": "numberfield",
                "aria-valuemin": state.context.min,
                "aria-valuemax": state.context.max,
                "aria-valuenow": Number.isNaN(state.context.valueAsNumber) ? void 0 : state.context.valueAsNumber,
                "aria-valuetext": state.context.valueText,
                onFocus () {
                    send("INPUT.FOCUS");
                },
                onBlur () {
                    send("INPUT.BLUR");
                },
                onInput (event) {
                    send({
                        type: "INPUT.CHANGE",
                        target: event.currentTarget,
                        hint: "set"
                    });
                },
                onBeforeInput (event) {
                    try {
                        const { selectionStart: selectionStart, selectionEnd: selectionEnd, value: value } = event.currentTarget;
                        const nextValue = value.slice(0, selectionStart) + (event.data ?? "") + value.slice(selectionEnd);
                        const isValid = state.context.parser.isValidPartialNumber(nextValue);
                        if (!isValid) event.preventDefault();
                    } catch  {}
                },
                onKeyDown (event) {
                    if (event.defaultPrevented) return;
                    if (readOnly) return;
                    if ((0, $b06ec5ff205338e5$export$49e72d3db4288c1)(event)) return;
                    const step = (0, $b06ec5ff205338e5$export$587b7b5379932dd6)(event) * state.context.step;
                    const keyMap = {
                        ArrowUp () {
                            send({
                                type: "INPUT.ARROW_UP",
                                step: step
                            });
                            event.preventDefault();
                        },
                        ArrowDown () {
                            send({
                                type: "INPUT.ARROW_DOWN",
                                step: step
                            });
                            event.preventDefault();
                        },
                        Home () {
                            if ((0, $b06ec5ff205338e5$export$90788ad2c69b4f50)(event)) return;
                            send("INPUT.HOME");
                            event.preventDefault();
                        },
                        End () {
                            if ((0, $b06ec5ff205338e5$export$90788ad2c69b4f50)(event)) return;
                            send("INPUT.END");
                            event.preventDefault();
                        },
                        Enter () {
                            send("INPUT.ENTER");
                        }
                    };
                    const exec = keyMap[event.key];
                    exec?.(event);
                }
            });
        },
        getDecrementTriggerProps () {
            return normalize.button({
                ...$c654b4eb021ac767$var$parts.decrementTrigger.attrs,
                dir: state.context.dir,
                id: $c654b4eb021ac767$var$dom.getDecrementTriggerId(state.context),
                disabled: isDecrementDisabled,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(isDecrementDisabled),
                "aria-label": translations.decrementLabel,
                type: "button",
                tabIndex: -1,
                "aria-controls": $c654b4eb021ac767$var$dom.getInputId(state.context),
                onPointerDown (event) {
                    if (isDecrementDisabled || !(0, $b06ec5ff205338e5$export$698c4f0ff5e11e52)(event)) return;
                    send({
                        type: "TRIGGER.PRESS_DOWN",
                        hint: "decrement",
                        pointerType: event.pointerType
                    });
                    if (event.pointerType === "mouse") event.preventDefault();
                    if (event.pointerType === "touch") event.currentTarget?.focus({
                        preventScroll: true
                    });
                },
                onPointerUp (event) {
                    send({
                        type: "TRIGGER.PRESS_UP",
                        hint: "decrement",
                        pointerType: event.pointerType
                    });
                },
                onPointerLeave () {
                    if (isDecrementDisabled) return;
                    send({
                        type: "TRIGGER.PRESS_UP",
                        hint: "decrement"
                    });
                }
            });
        },
        getIncrementTriggerProps () {
            return normalize.button({
                ...$c654b4eb021ac767$var$parts.incrementTrigger.attrs,
                dir: state.context.dir,
                id: $c654b4eb021ac767$var$dom.getIncrementTriggerId(state.context),
                disabled: isIncrementDisabled,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(isIncrementDisabled),
                "aria-label": translations.incrementLabel,
                type: "button",
                tabIndex: -1,
                "aria-controls": $c654b4eb021ac767$var$dom.getInputId(state.context),
                onPointerDown (event) {
                    if (isIncrementDisabled || !(0, $b06ec5ff205338e5$export$698c4f0ff5e11e52)(event)) return;
                    send({
                        type: "TRIGGER.PRESS_DOWN",
                        hint: "increment",
                        pointerType: event.pointerType
                    });
                    if (event.pointerType === "mouse") event.preventDefault();
                    if (event.pointerType === "touch") event.currentTarget?.focus({
                        preventScroll: true
                    });
                },
                onPointerUp (event) {
                    send({
                        type: "TRIGGER.PRESS_UP",
                        hint: "increment",
                        pointerType: event.pointerType
                    });
                },
                onPointerLeave (event) {
                    send({
                        type: "TRIGGER.PRESS_UP",
                        hint: "increment",
                        pointerType: event.pointerType
                    });
                }
            });
        },
        getScrubberProps () {
            return normalize.element({
                ...$c654b4eb021ac767$var$parts.scrubber.attrs,
                dir: state.context.dir,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(disabled),
                id: $c654b4eb021ac767$var$dom.getScrubberId(state.context),
                role: "presentation",
                onMouseDown (event) {
                    if (disabled) return;
                    const point = (0, $b06ec5ff205338e5$export$a8637644cbd23a7b)(event);
                    const win = (0, $b06ec5ff205338e5$export$38b2d434cce3ea22)(event.currentTarget);
                    const dpr = win.devicePixelRatio;
                    point.x = point.x - (0, $89352e0ddd72597a$export$db558e705f7d32d7)(7.5, dpr);
                    point.y = point.y - (0, $89352e0ddd72597a$export$db558e705f7d32d7)(7.5, dpr);
                    send({
                        type: "SCRUBBER.PRESS_DOWN",
                        point: point
                    });
                    event.preventDefault();
                },
                style: {
                    cursor: disabled ? void 0 : "ew-resize"
                }
            });
        }
    };
}
// src/cursor.ts
function $c654b4eb021ac767$var$recordCursor(inputEl) {
    if (inputEl.ownerDocument.activeElement !== inputEl) return;
    try {
        const { selectionStart: start, selectionEnd: end, value: value } = inputEl;
        const beforeTxt = value.substring(0, start);
        const afterTxt = value.substring(end);
        return {
            start: start,
            end: end,
            value: value,
            beforeTxt: beforeTxt,
            afterTxt: afterTxt
        };
    } catch  {}
}
function $c654b4eb021ac767$var$restoreCursor(inputEl, selection) {
    if (inputEl.ownerDocument.activeElement !== inputEl) return;
    if (!selection) {
        inputEl.setSelectionRange(inputEl.value.length, inputEl.value.length);
        return;
    }
    try {
        const { value: value } = inputEl;
        const { beforeTxt: beforeTxt = "", afterTxt: afterTxt = "", start: start } = selection;
        let startPos = value.length;
        if (value.endsWith(afterTxt)) startPos = value.length - afterTxt.length;
        else if (value.startsWith(beforeTxt)) startPos = beforeTxt.length;
        else if (start != null) {
            const beforeLastChar = beforeTxt[start - 1];
            const newIndex = value.indexOf(beforeLastChar, start - 1);
            if (newIndex !== -1) startPos = newIndex + 1;
        }
        inputEl.setSelectionRange(startPos, startPos);
    } catch  {}
}
var $c654b4eb021ac767$var$createFormatter = (locale, options = {})=>{
    return (0, $7bf56e9c8ff12ab3$export$eff4d24c3ff7876e)(new Intl.NumberFormat(locale, options));
};
var $c654b4eb021ac767$var$createParser = (locale, options = {})=>{
    return (0, $7bf56e9c8ff12ab3$export$eff4d24c3ff7876e)(new (0, $f764810b880bba05$export$cd11ab140839f11d)(locale, options));
};
var $c654b4eb021ac767$var$parseValue = (ctx, value)=>{
    if (!ctx.formatOptions) return parseFloat(value);
    return ctx.parser.parse(String(value));
};
var $c654b4eb021ac767$var$formatValue = (ctx, value)=>{
    if (Number.isNaN(value)) return "";
    if (!ctx.formatOptions) return value.toString();
    return ctx.formatter.format(value);
};
// src/number-input.machine.ts
var { not: $c654b4eb021ac767$var$not, and: $c654b4eb021ac767$var$and } = (0, $5c0da97e9c7aa95f$export$f3249297f3edf7e9);
function $c654b4eb021ac767$export$ea56d40cd27c3480(userContext) {
    const ctx = (0, $89352e0ddd72597a$export$8e16b83750b44988)(userContext);
    return (0, $5c0da97e9c7aa95f$export$aaa7fa18f8e9b2e8)({
        id: "number-input",
        initial: "idle",
        context: {
            dir: "ltr",
            locale: "en-US",
            focusInputOnChange: true,
            clampValueOnBlur: true,
            allowOverflow: false,
            inputMode: "decimal",
            pattern: "[0-9]*(.[0-9]+)?",
            value: "",
            step: 1,
            min: Number.MIN_SAFE_INTEGER,
            max: Number.MAX_SAFE_INTEGER,
            invalid: false,
            spinOnPress: true,
            disabled: false,
            readOnly: false,
            ...ctx,
            hint: null,
            scrubberCursorPoint: null,
            fieldsetDisabled: false,
            formatter: $c654b4eb021ac767$var$createFormatter(ctx.locale || "en-US", ctx.formatOptions),
            parser: $c654b4eb021ac767$var$createParser(ctx.locale || "en-US", ctx.formatOptions),
            translations: {
                incrementLabel: "increment value",
                decrementLabel: "decrease value",
                ...ctx.translations
            }
        },
        computed: {
            isRtl: (ctx2)=>ctx2.dir === "rtl",
            valueAsNumber: (ctx2)=>$c654b4eb021ac767$var$parseValue(ctx2, ctx2.value),
            formattedValue: (ctx2)=>$c654b4eb021ac767$var$formatValue(ctx2, ctx2.valueAsNumber),
            isAtMin: (ctx2)=>(0, $89352e0ddd72597a$export$f34fe80559da9f6e)(ctx2.valueAsNumber, ctx2.min),
            isAtMax: (ctx2)=>(0, $89352e0ddd72597a$export$e280c4b0ba1fba46)(ctx2.valueAsNumber, ctx2.max),
            isOutOfRange: (ctx2)=>!(0, $89352e0ddd72597a$export$7c4e06fee2f75722)(ctx2.valueAsNumber, ctx2.min, ctx2.max),
            isValueEmpty: (ctx2)=>ctx2.value === "",
            isDisabled: (ctx2)=>!!ctx2.disabled || ctx2.fieldsetDisabled,
            canIncrement: (ctx2)=>ctx2.allowOverflow || !ctx2.isAtMax,
            canDecrement: (ctx2)=>ctx2.allowOverflow || !ctx2.isAtMin,
            valueText: (ctx2)=>ctx2.translations.valueText?.(ctx2.value)
        },
        watch: {
            formatOptions: [
                "setFormatterAndParser",
                "syncInputElement"
            ],
            locale: [
                "setFormatterAndParser",
                "syncInputElement"
            ],
            value: [
                "syncInputElement"
            ],
            isOutOfRange: [
                "invokeOnInvalid"
            ],
            scrubberCursorPoint: [
                "setVirtualCursorPosition"
            ]
        },
        activities: [
            "trackFormControl"
        ],
        on: {
            "VALUE.SET": {
                actions: [
                    "setRawValue",
                    "setHintToSet"
                ]
            },
            "VALUE.CLEAR": {
                actions: [
                    "clearValue"
                ]
            },
            "VALUE.INCREMENT": {
                actions: [
                    "increment"
                ]
            },
            "VALUE.DECREMENT": {
                actions: [
                    "decrement"
                ]
            }
        },
        states: {
            idle: {
                on: {
                    "TRIGGER.PRESS_DOWN": [
                        {
                            guard: "isTouchPointer",
                            target: "before:spin",
                            actions: [
                                "setHint"
                            ]
                        },
                        {
                            target: "before:spin",
                            actions: [
                                "focusInput",
                                "invokeOnFocus",
                                "setHint"
                            ]
                        }
                    ],
                    "SCRUBBER.PRESS_DOWN": {
                        target: "scrubbing",
                        actions: [
                            "focusInput",
                            "invokeOnFocus",
                            "setHint",
                            "setCursorPoint"
                        ]
                    },
                    "INPUT.FOCUS": {
                        target: "focused",
                        actions: [
                            "focusInput",
                            "invokeOnFocus"
                        ]
                    }
                }
            },
            focused: {
                tags: "focus",
                activities: "attachWheelListener",
                on: {
                    "TRIGGER.PRESS_DOWN": [
                        {
                            guard: "isTouchPointer",
                            target: "before:spin",
                            actions: [
                                "setHint"
                            ]
                        },
                        {
                            target: "before:spin",
                            actions: [
                                "focusInput",
                                "setHint"
                            ]
                        }
                    ],
                    "SCRUBBER.PRESS_DOWN": {
                        target: "scrubbing",
                        actions: [
                            "focusInput",
                            "setHint",
                            "setCursorPoint"
                        ]
                    },
                    "INPUT.ARROW_UP": {
                        actions: "increment"
                    },
                    "INPUT.ARROW_DOWN": {
                        actions: "decrement"
                    },
                    "INPUT.HOME": {
                        actions: "decrementToMin"
                    },
                    "INPUT.END": {
                        actions: "incrementToMax"
                    },
                    "INPUT.CHANGE": {
                        actions: [
                            "setValue",
                            "setHint"
                        ]
                    },
                    "INPUT.BLUR": [
                        {
                            guard: $c654b4eb021ac767$var$and("clampValueOnBlur", $c654b4eb021ac767$var$not("isInRange")),
                            target: "idle",
                            actions: [
                                "setClampedValue",
                                "clearHint",
                                "invokeOnBlur"
                            ]
                        },
                        {
                            target: "idle",
                            actions: [
                                "setFormattedValue",
                                "clearHint",
                                "invokeOnBlur"
                            ]
                        }
                    ],
                    "INPUT.ENTER": {
                        actions: [
                            "setFormattedValue",
                            "clearHint",
                            "invokeOnBlur"
                        ]
                    }
                }
            },
            "before:spin": {
                tags: "focus",
                activities: "trackButtonDisabled",
                entry: (0, $5c0da97e9c7aa95f$export$7877a478dd30fd3d)([
                    {
                        guard: "isIncrementHint",
                        actions: "increment"
                    },
                    {
                        guard: "isDecrementHint",
                        actions: "decrement"
                    }
                ]),
                after: {
                    CHANGE_DELAY: {
                        target: "spinning",
                        guard: $c654b4eb021ac767$var$and("isInRange", "spinOnPress")
                    }
                },
                on: {
                    "TRIGGER.PRESS_UP": [
                        {
                            guard: "isTouchPointer",
                            target: "focused",
                            actions: "clearHint"
                        },
                        {
                            target: "focused",
                            actions: [
                                "focusInput",
                                "clearHint"
                            ]
                        }
                    ]
                }
            },
            spinning: {
                tags: "focus",
                activities: "trackButtonDisabled",
                every: [
                    {
                        delay: "CHANGE_INTERVAL",
                        guard: $c654b4eb021ac767$var$and($c654b4eb021ac767$var$not("isAtMin"), "isIncrementHint"),
                        actions: "increment"
                    },
                    {
                        delay: "CHANGE_INTERVAL",
                        guard: $c654b4eb021ac767$var$and($c654b4eb021ac767$var$not("isAtMax"), "isDecrementHint"),
                        actions: "decrement"
                    }
                ],
                on: {
                    "TRIGGER.PRESS_UP": {
                        target: "focused",
                        actions: [
                            "focusInput",
                            "clearHint"
                        ]
                    }
                }
            },
            scrubbing: {
                tags: "focus",
                activities: [
                    "activatePointerLock",
                    "trackMousemove",
                    "setupVirtualCursor",
                    "preventTextSelection"
                ],
                on: {
                    "SCRUBBER.POINTER_UP": {
                        target: "focused",
                        actions: [
                            "focusInput",
                            "clearCursorPoint"
                        ]
                    },
                    "SCRUBBER.POINTER_MOVE": [
                        {
                            guard: "isIncrementHint",
                            actions: [
                                "increment",
                                "setCursorPoint"
                            ]
                        },
                        {
                            guard: "isDecrementHint",
                            actions: [
                                "decrement",
                                "setCursorPoint"
                            ]
                        }
                    ]
                }
            }
        }
    }, {
        delays: {
            CHANGE_INTERVAL: 50,
            CHANGE_DELAY: 300
        },
        guards: {
            clampValueOnBlur: (ctx2)=>ctx2.clampValueOnBlur,
            isAtMin: (ctx2)=>ctx2.isAtMin,
            spinOnPress: (ctx2)=>!!ctx2.spinOnPress,
            isAtMax: (ctx2)=>ctx2.isAtMax,
            isInRange: (ctx2)=>!ctx2.isOutOfRange,
            isDecrementHint: (ctx2, evt)=>(evt.hint ?? ctx2.hint) === "decrement",
            isIncrementHint: (ctx2, evt)=>(evt.hint ?? ctx2.hint) === "increment",
            isTouchPointer: (_ctx, evt)=>evt.pointerType === "touch"
        },
        activities: {
            trackFormControl (ctx2, _evt, { initialContext: initialContext }) {
                const inputEl = $c654b4eb021ac767$var$dom.getInputEl(ctx2);
                return (0, $b06ec5ff205338e5$export$a48469c7b6beba26)(inputEl, {
                    onFieldsetDisabledChange (disabled) {
                        ctx2.fieldsetDisabled = disabled;
                    },
                    onFormReset () {
                        $c654b4eb021ac767$var$set.value(ctx2, initialContext.value);
                    }
                });
            },
            setupVirtualCursor (ctx2) {
                return $c654b4eb021ac767$var$dom.setupVirtualCursor(ctx2);
            },
            preventTextSelection (ctx2) {
                return $c654b4eb021ac767$var$dom.preventTextSelection(ctx2);
            },
            trackButtonDisabled (ctx2, _evt, { send: send }) {
                const btn = $c654b4eb021ac767$var$dom.getPressedTriggerEl(ctx2, ctx2.hint);
                return (0, $b06ec5ff205338e5$export$343af0d656c88488)(btn, {
                    attributes: [
                        "disabled"
                    ],
                    callback () {
                        send({
                            type: "TRIGGER.PRESS_UP",
                            src: "attr"
                        });
                    }
                });
            },
            attachWheelListener (ctx2, _evt, { send: send }) {
                const inputEl = $c654b4eb021ac767$var$dom.getInputEl(ctx2);
                if (!inputEl || !$c654b4eb021ac767$var$dom.isActiveElement(ctx2, inputEl) || !ctx2.allowMouseWheel) return;
                function onWheel(event) {
                    event.preventDefault();
                    const dir = Math.sign(event.deltaY) * -1;
                    if (dir === 1) send("VALUE.INCREMENT");
                    else if (dir === -1) send("VALUE.DECREMENT");
                }
                return (0, $b06ec5ff205338e5$export$b1d829ddf82884aa)(inputEl, "wheel", onWheel, {
                    passive: false
                });
            },
            activatePointerLock (ctx2) {
                if ((0, $b06ec5ff205338e5$export$95df08bae54cb4df)()) return;
                return (0, $b06ec5ff205338e5$export$1f5d6fe16dcd7702)($c654b4eb021ac767$var$dom.getDoc(ctx2));
            },
            trackMousemove (ctx2, _evt, { send: send }) {
                const doc = $c654b4eb021ac767$var$dom.getDoc(ctx2);
                function onMousemove(event) {
                    if (!ctx2.scrubberCursorPoint) return;
                    const value = $c654b4eb021ac767$var$dom.getMousemoveValue(ctx2, event);
                    if (!value.hint) return;
                    send({
                        type: "SCRUBBER.POINTER_MOVE",
                        hint: value.hint,
                        point: value.point
                    });
                }
                function onMouseup() {
                    send("SCRUBBER.POINTER_UP");
                }
                return (0, $89352e0ddd72597a$export$9dd9a52f2dd5b9ce)((0, $b06ec5ff205338e5$export$b1d829ddf82884aa)(doc, "mousemove", onMousemove, false), (0, $b06ec5ff205338e5$export$b1d829ddf82884aa)(doc, "mouseup", onMouseup, false));
            }
        },
        actions: {
            focusInput (ctx2) {
                if (!ctx2.focusInputOnChange) return;
                const inputEl = $c654b4eb021ac767$var$dom.getInputEl(ctx2);
                if ($c654b4eb021ac767$var$dom.isActiveElement(ctx2, inputEl)) return;
                (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>inputEl?.focus({
                        preventScroll: true
                    }));
            },
            increment (ctx2, evt) {
                const nextValue = (0, $89352e0ddd72597a$export$d3f405d8a429a91)(ctx2.valueAsNumber, evt.step ?? ctx2.step);
                const value = $c654b4eb021ac767$var$formatValue(ctx2, (0, $89352e0ddd72597a$export$31ee16100cde6ce2)(nextValue, ctx2.min, ctx2.max));
                $c654b4eb021ac767$var$set.value(ctx2, value);
            },
            decrement (ctx2, evt) {
                const nextValue = (0, $89352e0ddd72597a$export$5b2c46821c67093d)(ctx2.valueAsNumber, evt.step ?? ctx2.step);
                const value = $c654b4eb021ac767$var$formatValue(ctx2, (0, $89352e0ddd72597a$export$31ee16100cde6ce2)(nextValue, ctx2.min, ctx2.max));
                $c654b4eb021ac767$var$set.value(ctx2, value);
            },
            setClampedValue (ctx2) {
                const nextValue = (0, $89352e0ddd72597a$export$31ee16100cde6ce2)(ctx2.valueAsNumber, ctx2.min, ctx2.max);
                $c654b4eb021ac767$var$set.value(ctx2, $c654b4eb021ac767$var$formatValue(ctx2, nextValue));
            },
            setRawValue (ctx2, evt) {
                const parsedValue = $c654b4eb021ac767$var$parseValue(ctx2, evt.value);
                const value = $c654b4eb021ac767$var$formatValue(ctx2, (0, $89352e0ddd72597a$export$31ee16100cde6ce2)(parsedValue, ctx2.min, ctx2.max));
                $c654b4eb021ac767$var$set.value(ctx2, value);
            },
            setValue (ctx2, evt) {
                const value = evt.target?.value ?? evt.value;
                $c654b4eb021ac767$var$set.value(ctx2, value);
            },
            clearValue (ctx2) {
                $c654b4eb021ac767$var$set.value(ctx2, "");
            },
            incrementToMax (ctx2) {
                const value = $c654b4eb021ac767$var$formatValue(ctx2, ctx2.max);
                $c654b4eb021ac767$var$set.value(ctx2, value);
            },
            decrementToMin (ctx2) {
                const value = $c654b4eb021ac767$var$formatValue(ctx2, ctx2.min);
                $c654b4eb021ac767$var$set.value(ctx2, value);
            },
            setHint (ctx2, evt) {
                ctx2.hint = evt.hint;
            },
            clearHint (ctx2) {
                ctx2.hint = null;
            },
            setHintToSet (ctx2) {
                ctx2.hint = "set";
            },
            invokeOnFocus (ctx2) {
                ctx2.onFocusChange?.({
                    focused: true,
                    value: ctx2.formattedValue,
                    valueAsNumber: ctx2.valueAsNumber
                });
            },
            invokeOnBlur (ctx2) {
                ctx2.onFocusChange?.({
                    focused: false,
                    value: ctx2.formattedValue,
                    valueAsNumber: ctx2.valueAsNumber
                });
            },
            invokeOnInvalid (ctx2) {
                if (!ctx2.isOutOfRange) return;
                const reason = ctx2.valueAsNumber > ctx2.max ? "rangeOverflow" : "rangeUnderflow";
                ctx2.onValueInvalid?.({
                    reason: reason,
                    value: ctx2.formattedValue,
                    valueAsNumber: ctx2.valueAsNumber
                });
            },
            syncInputElement (ctx2, evt) {
                const value = evt.type.endsWith("CHANGE") ? ctx2.value : ctx2.formattedValue;
                $c654b4eb021ac767$var$sync.input(ctx2, value);
            },
            setFormattedValue (ctx2) {
                $c654b4eb021ac767$var$set.value(ctx2, ctx2.formattedValue);
            },
            setCursorPoint (ctx2, evt) {
                ctx2.scrubberCursorPoint = evt.point;
            },
            clearCursorPoint (ctx2) {
                ctx2.scrubberCursorPoint = null;
            },
            setVirtualCursorPosition (ctx2) {
                const cursorEl = $c654b4eb021ac767$var$dom.getCursorEl(ctx2);
                if (!cursorEl || !ctx2.scrubberCursorPoint) return;
                const { x: x, y: y } = ctx2.scrubberCursorPoint;
                cursorEl.style.transform = `translate3d(${x}px, ${y}px, 0px)`;
            },
            setFormatterAndParser (ctx2) {
                if (!ctx2.locale) return;
                ctx2.formatter = $c654b4eb021ac767$var$createFormatter(ctx2.locale, ctx2.formatOptions);
                ctx2.parser = $c654b4eb021ac767$var$createParser(ctx2.locale, ctx2.formatOptions);
            }
        },
        compareFns: {
            formatOptions: (a, b)=>(0, $89352e0ddd72597a$export$248d38f6296296c5)(a, b),
            scrubberCursorPoint: (a, b)=>(0, $89352e0ddd72597a$export$248d38f6296296c5)(a, b)
        }
    });
}
var $c654b4eb021ac767$var$sync = {
    input (ctx, value) {
        const inputEl = $c654b4eb021ac767$var$dom.getInputEl(ctx);
        if (!inputEl) return;
        const sel = $c654b4eb021ac767$var$recordCursor(inputEl);
        (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>{
            (0, $b06ec5ff205338e5$export$c2c7fef809f2f8ef)(inputEl, value);
            $c654b4eb021ac767$var$restoreCursor(inputEl, sel);
        });
    }
};
var $c654b4eb021ac767$var$invoke = {
    onChange: (ctx)=>{
        ctx.onValueChange?.({
            value: ctx.value,
            valueAsNumber: ctx.valueAsNumber
        });
    }
};
var $c654b4eb021ac767$var$set = {
    value: (ctx, value)=>{
        if ((0, $89352e0ddd72597a$export$248d38f6296296c5)(ctx.value, value)) return;
        ctx.value = value;
        $c654b4eb021ac767$var$invoke.onChange(ctx);
    }
};


"use strict";
const $c5bf017c697a33c4$var$triggerStyle = (0, $ee2de6f250f65b79$export$9a6b93c1c4f92839)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: "1",
    userSelect: "none",
    cursor: "button",
    lineHeight: "1",
    color: "fg.muted",
    "--stepper-base-radius": "radii.l1",
    "--stepper-radius": "calc(var(--stepper-base-radius) + 1px)",
    _icon: {
        boxSize: "1em"
    },
    _disabled: {
        opacity: "0.5"
    },
    _hover: {
        bg: "bg.muted"
    },
    _active: {
        bg: "bg.emphasized"
    }
});
const $c5bf017c697a33c4$export$a4772ecb6b3bbf82 = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    className: "chakra-number-input",
    slots: (0, $c654b4eb021ac767$export$477202748c7242bf).keys(),
    base: {
        root: {
            position: "relative",
            zIndex: "0",
            isolation: "isolate"
        },
        input: {
            ...(0, $074665036d2ed9fc$export$a6445e005c28dca2).base,
            verticalAlign: "top",
            pe: "calc(var(--stepper-width) + 0.5rem)"
        },
        control: {
            display: "flex",
            flexDirection: "column",
            position: "absolute",
            top: "0",
            insetEnd: "0px",
            margin: "1px",
            width: "var(--stepper-width)",
            height: "calc(100% - 2px)",
            zIndex: "1",
            borderStartWidth: "1px",
            divideY: "1px"
        },
        incrementTrigger: {
            ...$c5bf017c697a33c4$var$triggerStyle,
            borderTopEndRadius: "var(--stepper-radius)"
        },
        decrementTrigger: {
            ...$c5bf017c697a33c4$var$triggerStyle,
            borderBottomEndRadius: "var(--stepper-radius)"
        },
        valueText: {
            fontWeight: "medium",
            fontFeatureSettings: "pnum",
            fontVariantNumeric: "proportional-nums"
        }
    },
    variants: {
        size: {
            xs: {
                input: (0, $074665036d2ed9fc$export$a6445e005c28dca2).variants.size.xs,
                control: {
                    fontSize: "2xs",
                    "--stepper-width": "sizes.4"
                }
            },
            sm: {
                input: (0, $074665036d2ed9fc$export$a6445e005c28dca2).variants.size.sm,
                control: {
                    fontSize: "xs",
                    "--stepper-width": "sizes.5"
                }
            },
            md: {
                input: (0, $074665036d2ed9fc$export$a6445e005c28dca2).variants.size.md,
                control: {
                    fontSize: "sm",
                    "--stepper-width": "sizes.6"
                }
            },
            lg: {
                input: (0, $074665036d2ed9fc$export$a6445e005c28dca2).variants.size.lg,
                control: {
                    fontSize: "sm",
                    "--stepper-width": "sizes.6"
                }
            }
        },
        variant: (0, $f262c6389d8a528e$export$592ef47eabb05614)((0, $074665036d2ed9fc$export$a6445e005c28dca2).variants.variant, (key, variantStyles)=>[
                key,
                {
                    input: variantStyles
                }
            ])
    },
    defaultVariants: {
        size: "md",
        variant: "outline"
    }
});









// src/pin-input.anatomy.ts
var $1cbdd08a17cb94aa$export$477202748c7242bf = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("pinInput").parts("root", "label", "input", "control");
var $1cbdd08a17cb94aa$var$parts = $1cbdd08a17cb94aa$export$477202748c7242bf.build();
var $1cbdd08a17cb94aa$var$dom = (0, $b06ec5ff205338e5$export$41a9651decfe2bde)({
    getRootId: (ctx)=>ctx.ids?.root ?? `pin-input:${ctx.id}`,
    getInputId: (ctx, id)=>ctx.ids?.input?.(id) ?? `pin-input:${ctx.id}:${id}`,
    getHiddenInputId: (ctx)=>ctx.ids?.hiddenInput ?? `pin-input:${ctx.id}:hidden`,
    getLabelId: (ctx)=>ctx.ids?.label ?? `pin-input:${ctx.id}:label`,
    getControlId: (ctx)=>ctx.ids?.control ?? `pin-input:${ctx.id}:control`,
    getRootEl: (ctx)=>$1cbdd08a17cb94aa$var$dom.getById(ctx, $1cbdd08a17cb94aa$var$dom.getRootId(ctx)),
    getInputEls: (ctx)=>{
        const ownerId = CSS.escape($1cbdd08a17cb94aa$var$dom.getRootId(ctx));
        const selector = `input[data-ownedby=${ownerId}]`;
        return (0, $b06ec5ff205338e5$export$dcd0d083aa86c355)($1cbdd08a17cb94aa$var$dom.getRootEl(ctx), selector);
    },
    getInputEl: (ctx, id)=>$1cbdd08a17cb94aa$var$dom.getById(ctx, $1cbdd08a17cb94aa$var$dom.getInputId(ctx, id)),
    getFocusedInputEl: (ctx)=>$1cbdd08a17cb94aa$var$dom.getInputEls(ctx)[ctx.focusedIndex],
    getFirstInputEl: (ctx)=>$1cbdd08a17cb94aa$var$dom.getInputEls(ctx)[0],
    getHiddenInputEl: (ctx)=>$1cbdd08a17cb94aa$var$dom.getById(ctx, $1cbdd08a17cb94aa$var$dom.getHiddenInputId(ctx))
});
// src/pin-input.utils.ts
var $1cbdd08a17cb94aa$var$REGEX = {
    numeric: /^[0-9]+$/,
    alphabetic: /^[A-Za-z]+$/,
    alphanumeric: /^[a-zA-Z0-9]+$/i
};
function $1cbdd08a17cb94aa$var$isValidType(ctx, value) {
    if (!ctx.type) return true;
    return !!$1cbdd08a17cb94aa$var$REGEX[ctx.type]?.test(value);
}
function $1cbdd08a17cb94aa$var$isValidValue(ctx, value) {
    if (!ctx.pattern) return $1cbdd08a17cb94aa$var$isValidType(ctx, value);
    const regex = new RegExp(ctx.pattern, "g");
    return regex.test(value);
}
// src/pin-input.connect.ts
function $1cbdd08a17cb94aa$export$64605811ab45167f(state, send, normalize) {
    const complete = state.context.isValueComplete;
    const invalid = state.context.invalid;
    const focusedIndex = state.context.focusedIndex;
    const translations = state.context.translations;
    function focus() {
        $1cbdd08a17cb94aa$var$dom.getFirstInputEl(state.context)?.focus();
    }
    return {
        focus: focus,
        value: state.context.value,
        valueAsString: state.context.valueAsString,
        complete: complete,
        setValue (value) {
            if (!Array.isArray(value)) (0, $89352e0ddd72597a$export$f5708dca728d7177)("[pin-input/setValue] value must be an array");
            send({
                type: "VALUE.SET",
                value: value
            });
        },
        clearValue () {
            send({
                type: "VALUE.CLEAR"
            });
        },
        setValueAtIndex (index, value) {
            send({
                type: "VALUE.SET",
                value: value,
                index: index
            });
        },
        getRootProps () {
            return normalize.element({
                dir: state.context.dir,
                ...$1cbdd08a17cb94aa$var$parts.root.attrs,
                id: $1cbdd08a17cb94aa$var$dom.getRootId(state.context),
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(invalid),
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.disabled),
                "data-complete": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(complete),
                "data-readonly": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.readOnly)
            });
        },
        getLabelProps () {
            return normalize.label({
                ...$1cbdd08a17cb94aa$var$parts.label.attrs,
                dir: state.context.dir,
                htmlFor: $1cbdd08a17cb94aa$var$dom.getHiddenInputId(state.context),
                id: $1cbdd08a17cb94aa$var$dom.getLabelId(state.context),
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(invalid),
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.disabled),
                "data-complete": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(complete),
                "data-readonly": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.readOnly),
                onClick (event) {
                    event.preventDefault();
                    focus();
                }
            });
        },
        getHiddenInputProps () {
            return normalize.input({
                "aria-hidden": true,
                type: "text",
                tabIndex: -1,
                id: $1cbdd08a17cb94aa$var$dom.getHiddenInputId(state.context),
                readOnly: state.context.readOnly,
                disabled: state.context.disabled,
                required: state.context.required,
                name: state.context.name,
                form: state.context.form,
                style: (0, $b06ec5ff205338e5$export$8fecac46448b5689),
                maxLength: state.context.valueLength,
                defaultValue: state.context.valueAsString
            });
        },
        getControlProps () {
            return normalize.element({
                ...$1cbdd08a17cb94aa$var$parts.control.attrs,
                dir: state.context.dir,
                id: $1cbdd08a17cb94aa$var$dom.getControlId(state.context)
            });
        },
        getInputProps (props) {
            const { index: index } = props;
            const inputType = state.context.type === "numeric" ? "tel" : "text";
            return normalize.input({
                ...$1cbdd08a17cb94aa$var$parts.input.attrs,
                dir: state.context.dir,
                disabled: state.context.disabled,
                "data-disabled": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(state.context.disabled),
                "data-complete": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(complete),
                id: $1cbdd08a17cb94aa$var$dom.getInputId(state.context, index.toString()),
                "data-ownedby": $1cbdd08a17cb94aa$var$dom.getRootId(state.context),
                "aria-label": translations.inputLabel(index, state.context.valueLength),
                inputMode: state.context.otp || state.context.type === "numeric" ? "numeric" : "text",
                "aria-invalid": (0, $b06ec5ff205338e5$export$91a6105db3d4be7b)(invalid),
                "data-invalid": (0, $b06ec5ff205338e5$export$5cc3b7b83e34ade7)(invalid),
                type: state.context.mask ? "password" : inputType,
                defaultValue: state.context.value[index] || "",
                readOnly: state.context.readOnly,
                autoCapitalize: "none",
                autoComplete: state.context.otp ? "one-time-code" : "off",
                placeholder: focusedIndex === index ? "" : state.context.placeholder,
                onBeforeInput (event) {
                    try {
                        const value = (0, $b06ec5ff205338e5$export$28ed887a50e27461)(event);
                        const isValid = $1cbdd08a17cb94aa$var$isValidValue(state.context, value);
                        if (!isValid) {
                            send({
                                type: "VALUE.INVALID",
                                value: value
                            });
                            event.preventDefault();
                        }
                        if (value.length > 2) event.currentTarget.setSelectionRange(0, 1, "forward");
                    } catch  {}
                },
                onChange (event) {
                    const evt = (0, $b06ec5ff205338e5$export$4abe0e945399ac1d)(event);
                    const { value: value } = event.currentTarget;
                    if (evt.inputType === "insertFromPaste" || value.length > 2) {
                        send({
                            type: "INPUT.PASTE",
                            value: value
                        });
                        event.currentTarget.value = value[0];
                        event.preventDefault();
                        return;
                    }
                    if (evt.inputType === "deleteContentBackward") {
                        send("INPUT.BACKSPACE");
                        return;
                    }
                    send({
                        type: "INPUT.CHANGE",
                        value: value,
                        index: index
                    });
                },
                onKeyDown (event) {
                    if (event.defaultPrevented) return;
                    if ((0, $b06ec5ff205338e5$export$49e72d3db4288c1)(event)) return;
                    if ((0, $b06ec5ff205338e5$export$90788ad2c69b4f50)(event)) return;
                    const keyMap = {
                        Backspace () {
                            send("INPUT.BACKSPACE");
                        },
                        Delete () {
                            send("INPUT.DELETE");
                        },
                        ArrowLeft () {
                            send("INPUT.ARROW_LEFT");
                        },
                        ArrowRight () {
                            send("INPUT.ARROW_RIGHT");
                        },
                        Enter () {
                            send("INPUT.ENTER");
                        }
                    };
                    const exec = keyMap[(0, $b06ec5ff205338e5$export$f7a7490116b79d4d)(event, state.context)];
                    if (exec) {
                        exec(event);
                        event.preventDefault();
                    }
                },
                onFocus () {
                    send({
                        type: "INPUT.FOCUS",
                        index: index
                    });
                },
                onBlur () {
                    send({
                        type: "INPUT.BLUR",
                        index: index
                    });
                }
            });
        }
    };
}
function $1cbdd08a17cb94aa$export$ea56d40cd27c3480(userContext) {
    const ctx = (0, $89352e0ddd72597a$export$8e16b83750b44988)(userContext);
    return (0, $5c0da97e9c7aa95f$export$aaa7fa18f8e9b2e8)({
        id: "pin-input",
        initial: "idle",
        context: {
            value: [],
            placeholder: "\u25CB",
            otp: false,
            type: "numeric",
            ...ctx,
            focusedIndex: -1,
            translations: {
                inputLabel: (index, length)=>`pin code ${index + 1} of ${length}`,
                ...ctx.translations
            }
        },
        computed: {
            valueLength: (ctx2)=>ctx2.value.length,
            filledValueLength: (ctx2)=>ctx2.value.filter((v)=>v?.trim() !== "").length,
            isValueComplete: (ctx2)=>ctx2.valueLength === ctx2.filledValueLength,
            valueAsString: (ctx2)=>ctx2.value.join(""),
            focusedValue: (ctx2)=>ctx2.value[ctx2.focusedIndex] || ""
        },
        entry: (0, $5c0da97e9c7aa95f$export$7877a478dd30fd3d)([
            {
                guard: "autoFocus",
                actions: [
                    "setupValue",
                    "setFocusIndexToFirst"
                ]
            },
            {
                actions: [
                    "setupValue"
                ]
            }
        ]),
        watch: {
            focusedIndex: [
                "focusInput",
                "selectInputIfNeeded"
            ],
            value: [
                "syncInputElements"
            ],
            isValueComplete: [
                "invokeOnComplete",
                "blurFocusedInputIfNeeded"
            ]
        },
        on: {
            "VALUE.SET": [
                {
                    guard: "hasIndex",
                    actions: [
                        "setValueAtIndex"
                    ]
                },
                {
                    actions: [
                        "setValue"
                    ]
                }
            ],
            "VALUE.CLEAR": {
                actions: [
                    "clearValue",
                    "setFocusIndexToFirst"
                ]
            }
        },
        states: {
            idle: {
                on: {
                    "INPUT.FOCUS": {
                        target: "focused",
                        actions: "setFocusedIndex"
                    }
                }
            },
            focused: {
                on: {
                    "INPUT.CHANGE": [
                        {
                            guard: "isFinalValue",
                            actions: [
                                "setFocusedValue",
                                "syncInputValue"
                            ]
                        },
                        {
                            actions: [
                                "setFocusedValue",
                                "setNextFocusedIndex",
                                "syncInputValue"
                            ]
                        }
                    ],
                    "INPUT.PASTE": {
                        actions: [
                            "setPastedValue",
                            "setLastValueFocusIndex"
                        ]
                    },
                    "INPUT.BLUR": {
                        target: "idle",
                        actions: "clearFocusedIndex"
                    },
                    "INPUT.DELETE": {
                        guard: "hasValue",
                        actions: "clearFocusedValue"
                    },
                    "INPUT.ARROW_LEFT": {
                        actions: "setPrevFocusedIndex"
                    },
                    "INPUT.ARROW_RIGHT": {
                        actions: "setNextFocusedIndex"
                    },
                    "INPUT.BACKSPACE": [
                        {
                            guard: "hasValue",
                            actions: [
                                "clearFocusedValue"
                            ]
                        },
                        {
                            actions: [
                                "setPrevFocusedIndex",
                                "clearFocusedValue"
                            ]
                        }
                    ],
                    "INPUT.ENTER": {
                        guard: "isValueComplete",
                        actions: "requestFormSubmit"
                    },
                    "VALUE.INVALID": {
                        actions: "invokeOnInvalid"
                    }
                }
            }
        }
    }, {
        guards: {
            autoFocus: (ctx2)=>!!ctx2.autoFocus,
            isValueEmpty: (_ctx, evt)=>evt.value === "",
            hasValue: (ctx2)=>ctx2.value[ctx2.focusedIndex] !== "",
            isValueComplete: (ctx2)=>ctx2.isValueComplete,
            isFinalValue: (ctx2)=>ctx2.filledValueLength + 1 === ctx2.valueLength && ctx2.value.findIndex((v)=>v.trim() === "") === ctx2.focusedIndex,
            hasIndex: (_ctx, evt)=>evt.index !== void 0,
            isDisabled: (ctx2)=>!!ctx2.disabled
        },
        actions: {
            setupValue (ctx2) {
                if (ctx2.value.length) return;
                const inputEls = $1cbdd08a17cb94aa$var$dom.getInputEls(ctx2);
                const emptyValues = Array.from({
                    length: inputEls.length
                }).fill("");
                $1cbdd08a17cb94aa$var$assignValue(ctx2, emptyValues);
            },
            focusInput (ctx2) {
                if (ctx2.focusedIndex === -1) return;
                $1cbdd08a17cb94aa$var$dom.getFocusedInputEl(ctx2)?.focus({
                    preventScroll: true
                });
            },
            selectInputIfNeeded (ctx2) {
                if (!ctx2.selectOnFocus || ctx2.focusedIndex === -1) return;
                (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>{
                    $1cbdd08a17cb94aa$var$dom.getFocusedInputEl(ctx2)?.select();
                });
            },
            invokeOnComplete (ctx2) {
                if (!ctx2.isValueComplete) return;
                ctx2.onValueComplete?.({
                    value: Array.from(ctx2.value),
                    valueAsString: ctx2.valueAsString
                });
            },
            invokeOnInvalid (ctx2, evt) {
                ctx2.onValueInvalid?.({
                    value: evt.value,
                    index: ctx2.focusedIndex
                });
            },
            clearFocusedIndex (ctx2) {
                ctx2.focusedIndex = -1;
            },
            setFocusedIndex (ctx2, evt) {
                ctx2.focusedIndex = evt.index;
            },
            setValue (ctx2, evt) {
                $1cbdd08a17cb94aa$var$set.value(ctx2, evt.value);
            },
            setFocusedValue (ctx2, evt) {
                const nextValue = $1cbdd08a17cb94aa$var$getNextValue(ctx2.focusedValue, evt.value);
                $1cbdd08a17cb94aa$var$set.valueAtIndex(ctx2, ctx2.focusedIndex, nextValue);
            },
            revertInputValue (ctx2) {
                const inputEl = $1cbdd08a17cb94aa$var$dom.getFocusedInputEl(ctx2);
                $1cbdd08a17cb94aa$var$dom.setValue(inputEl, ctx2.focusedValue);
            },
            syncInputValue (ctx2, evt) {
                const inputEl = $1cbdd08a17cb94aa$var$dom.getInputEl(ctx2, evt.index.toString());
                $1cbdd08a17cb94aa$var$dom.setValue(inputEl, ctx2.value[evt.index]);
            },
            syncInputElements (ctx2) {
                const inputEls = $1cbdd08a17cb94aa$var$dom.getInputEls(ctx2);
                inputEls.forEach((inputEl, index)=>{
                    $1cbdd08a17cb94aa$var$dom.setValue(inputEl, ctx2.value[index]);
                });
            },
            setPastedValue (ctx2, evt) {
                (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>{
                    const startIndex = Math.min(ctx2.focusedIndex, ctx2.filledValueLength);
                    const left = startIndex > 0 ? ctx2.valueAsString.substring(0, ctx2.focusedIndex) : "";
                    const right = evt.value.substring(0, ctx2.valueLength - startIndex);
                    const value = left + right;
                    $1cbdd08a17cb94aa$var$set.value(ctx2, value.split(""));
                });
            },
            setValueAtIndex (ctx2, evt) {
                const nextValue = $1cbdd08a17cb94aa$var$getNextValue(ctx2.focusedValue, evt.value);
                $1cbdd08a17cb94aa$var$set.valueAtIndex(ctx2, evt.index, nextValue);
            },
            clearValue (ctx2) {
                const nextValue = Array.from({
                    length: ctx2.valueLength
                }).fill("");
                $1cbdd08a17cb94aa$var$set.value(ctx2, nextValue);
            },
            clearFocusedValue (ctx2) {
                $1cbdd08a17cb94aa$var$set.valueAtIndex(ctx2, ctx2.focusedIndex, "");
            },
            setFocusIndexToFirst (ctx2) {
                ctx2.focusedIndex = 0;
            },
            setNextFocusedIndex (ctx2) {
                ctx2.focusedIndex = Math.min(ctx2.focusedIndex + 1, ctx2.valueLength - 1);
            },
            setPrevFocusedIndex (ctx2) {
                ctx2.focusedIndex = Math.max(ctx2.focusedIndex - 1, 0);
            },
            setLastValueFocusIndex (ctx2) {
                (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>{
                    ctx2.focusedIndex = Math.min(ctx2.filledValueLength, ctx2.valueLength - 1);
                });
            },
            blurFocusedInputIfNeeded (ctx2) {
                if (!ctx2.blurOnComplete) return;
                (0, $b06ec5ff205338e5$export$27f233d61a9e2fa4)(()=>{
                    $1cbdd08a17cb94aa$var$dom.getFocusedInputEl(ctx2)?.blur();
                });
            },
            requestFormSubmit (ctx2) {
                if (!ctx2.name || !ctx2.isValueComplete) return;
                const inputEl = $1cbdd08a17cb94aa$var$dom.getHiddenInputEl(ctx2);
                inputEl?.form?.requestSubmit();
            }
        }
    });
}
function $1cbdd08a17cb94aa$var$assignValue(ctx, value) {
    const arr = Array.isArray(value) ? value : value.split("").filter(Boolean);
    arr.forEach((value2, index)=>{
        ctx.value[index] = value2;
    });
}
function $1cbdd08a17cb94aa$var$getNextValue(current, next) {
    let nextValue = next;
    if (current[0] === next[0]) nextValue = next[1];
    else if (current[0] === next[1]) nextValue = next[0];
    return nextValue.split("")[nextValue.length - 1];
}
var $1cbdd08a17cb94aa$var$invoke = {
    change (ctx) {
        ctx.onValueChange?.({
            value: Array.from(ctx.value),
            valueAsString: ctx.valueAsString
        });
        const inputEl = $1cbdd08a17cb94aa$var$dom.getHiddenInputEl(ctx);
        (0, $b06ec5ff205338e5$export$71608d92f9cda884)(inputEl, {
            value: ctx.valueAsString
        });
    }
};
var $1cbdd08a17cb94aa$var$set = {
    value (ctx, value) {
        if ((0, $89352e0ddd72597a$export$248d38f6296296c5)(ctx.value, value)) return;
        $1cbdd08a17cb94aa$var$assignValue(ctx, value);
        $1cbdd08a17cb94aa$var$invoke.change(ctx);
    },
    valueAtIndex (ctx, index, value) {
        if ((0, $89352e0ddd72597a$export$248d38f6296296c5)(ctx.value[index], value)) return;
        ctx.value[index] = value;
        $1cbdd08a17cb94aa$var$invoke.change(ctx);
    }
};


"use strict";
const { variants: $88ded7672394e2b0$var$variants, defaultVariants: $88ded7672394e2b0$var$defaultVariants } = (0, $074665036d2ed9fc$export$a6445e005c28dca2);
const $88ded7672394e2b0$export$6ac4344d3861b231 = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    className: "chakra-pin-input",
    slots: (0, $1cbdd08a17cb94aa$export$477202748c7242bf).keys(),
    base: {
        input: {
            ...(0, $074665036d2ed9fc$export$a6445e005c28dca2).base,
            textAlign: "center",
            width: "var(--input-height)"
        }
    },
    variants: {
        size: (0, $f262c6389d8a528e$export$592ef47eabb05614)($88ded7672394e2b0$var$variants.size, (key, value)=>[
                key,
                {
                    input: value
                }
            ]),
        variant: (0, $f262c6389d8a528e$export$592ef47eabb05614)($88ded7672394e2b0$var$variants.variant, (key, value)=>[
                key,
                {
                    input: value
                }
            ])
    },
    defaultVariants: $88ded7672394e2b0$var$defaultVariants
});




"use strict";
const $c2c1d50c86fe32ba$export$d45077169de7cc48 = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    className: "chakra-popover",
    slots: (0, $9b7764ce1529e5da$export$afda07d12cd4337d).keys(),
    base: {
        content: {
            position: "relative",
            display: "flex",
            flexDirection: "column",
            textStyle: "sm",
            "--popover-bg": "colors.bg.panel",
            bg: "var(--popover-bg)",
            boxShadow: "lg",
            "--popover-size": "sizes.xs",
            "--popover-mobile-size": "calc(100dvw - 1rem)",
            width: {
                base: "min(var(--popover-mobile-size), var(--popover-size))",
                sm: "var(--popover-size)"
            },
            borderRadius: "l3",
            "--popover-z-index": "zIndex.popover",
            zIndex: "calc(var(--popover-z-index) + var(--layer-index, 0))",
            outline: "0",
            transformOrigin: "var(--transform-origin)",
            maxHeight: "var(--available-height)",
            _open: {
                animationStyle: "scale-fade-in",
                animationDuration: "fast"
            },
            _closed: {
                animationStyle: "scale-fade-out",
                animationDuration: "faster"
            }
        },
        header: {
            paddingInline: "var(--popover-padding)",
            paddingTop: "var(--popover-padding)"
        },
        body: {
            padding: "var(--popover-padding)",
            flex: "1"
        },
        footer: {
            display: "flex",
            alignItems: "center",
            paddingInline: "var(--popover-padding)",
            paddingBottom: "var(--popover-padding)"
        },
        arrow: {
            "--arrow-size": "sizes.3",
            "--arrow-background": "var(--popover-bg)"
        },
        arrowTip: {
            borderTopWidth: "1px",
            borderInlineStartWidth: "1px"
        }
    },
    variants: {
        size: {
            xs: {
                content: {
                    "--popover-padding": "spacing.3"
                }
            },
            sm: {
                content: {
                    "--popover-padding": "spacing.4"
                }
            },
            md: {
                content: {
                    "--popover-padding": "spacing.5"
                }
            },
            lg: {
                content: {
                    "--popover-padding": "spacing.6"
                }
            }
        }
    },
    defaultVariants: {
        size: "md"
    }
});








// src/progress.anatomy.ts
var $abee42452e65a540$export$477202748c7242bf = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("progress").parts("root", "label", "track", "range", "valueText", "view", "circle", "circleTrack", "circleRange");
var $abee42452e65a540$var$parts = $abee42452e65a540$export$477202748c7242bf.build();
var $abee42452e65a540$var$dom = (0, $b06ec5ff205338e5$export$41a9651decfe2bde)({
    getRootId: (ctx)=>ctx.ids?.root ?? `progress-${ctx.id}`,
    getTrackId: (ctx)=>ctx.ids?.track ?? `progress-${ctx.id}-track`,
    getLabelId: (ctx)=>ctx.ids?.label ?? `progress-${ctx.id}-label`,
    getCircleId: (ctx)=>ctx.ids?.circle ?? `progress-${ctx.id}-circle`
});
// src/progress.connect.ts
function $abee42452e65a540$export$64605811ab45167f(state, send, normalize) {
    const percent = state.context.percent;
    const percentAsString = state.context.isIndeterminate ? "" : `${percent}%`;
    const max = state.context.max;
    const min = state.context.min;
    const orientation = state.context.orientation;
    const translations = state.context.translations;
    const indeterminate = state.context.isIndeterminate;
    const value = state.context.value;
    const valueAsString = translations.value({
        value: value,
        max: max,
        percent: percent,
        min: min
    });
    const progressState = $abee42452e65a540$var$getProgressState(value, max);
    const progressbarProps = {
        role: "progressbar",
        "aria-label": valueAsString,
        "data-max": max,
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": value ?? void 0,
        "data-orientation": orientation,
        "data-state": progressState
    };
    const circleProps = $abee42452e65a540$var$getCircleProps(state.context);
    return {
        value: value,
        valueAsString: valueAsString,
        min: min,
        max: max,
        percent: percent,
        percentAsString: percentAsString,
        indeterminate: indeterminate,
        setValue (value2) {
            send({
                type: "VALUE.SET",
                value: value2
            });
        },
        setToMax () {
            send({
                type: "VALUE.SET",
                value: max
            });
        },
        setToMin () {
            send({
                type: "VALUE.SET",
                value: min
            });
        },
        getRootProps () {
            return normalize.element({
                dir: state.context.dir,
                ...$abee42452e65a540$var$parts.root.attrs,
                id: $abee42452e65a540$var$dom.getRootId(state.context),
                "data-max": max,
                "data-value": value ?? void 0,
                "data-state": progressState,
                "data-orientation": orientation,
                style: {
                    "--percent": indeterminate ? void 0 : percent
                }
            });
        },
        getLabelProps () {
            return normalize.element({
                dir: state.context.dir,
                id: $abee42452e65a540$var$dom.getLabelId(state.context),
                ...$abee42452e65a540$var$parts.label.attrs,
                "data-orientation": orientation
            });
        },
        getValueTextProps () {
            return normalize.element({
                dir: state.context.dir,
                "aria-live": "polite",
                ...$abee42452e65a540$var$parts.valueText.attrs
            });
        },
        getTrackProps () {
            return normalize.element({
                dir: state.context.dir,
                id: $abee42452e65a540$var$dom.getTrackId(state.context),
                ...$abee42452e65a540$var$parts.track.attrs,
                ...progressbarProps
            });
        },
        getRangeProps () {
            return normalize.element({
                dir: state.context.dir,
                ...$abee42452e65a540$var$parts.range.attrs,
                "data-orientation": orientation,
                "data-state": progressState,
                style: {
                    [state.context.isHorizontal ? "width" : "height"]: indeterminate ? void 0 : `${percent}%`
                }
            });
        },
        getCircleProps () {
            return normalize.element({
                dir: state.context.dir,
                id: $abee42452e65a540$var$dom.getCircleId(state.context),
                ...$abee42452e65a540$var$parts.circle.attrs,
                ...progressbarProps,
                ...circleProps.root
            });
        },
        getCircleTrackProps () {
            return normalize.element({
                dir: state.context.dir,
                "data-orientation": orientation,
                ...$abee42452e65a540$var$parts.circleTrack.attrs,
                ...circleProps.track
            });
        },
        getCircleRangeProps () {
            return normalize.element({
                dir: state.context.dir,
                ...$abee42452e65a540$var$parts.circleRange.attrs,
                ...circleProps.range,
                "data-state": progressState
            });
        },
        getViewProps (props2) {
            return normalize.element({
                dir: state.context.dir,
                ...$abee42452e65a540$var$parts.view.attrs,
                "data-state": props2.state,
                hidden: props2.state !== progressState
            });
        }
    };
}
function $abee42452e65a540$var$getProgressState(value, maxValue) {
    return value == null ? "indeterminate" : value === maxValue ? "complete" : "loading";
}
function $abee42452e65a540$var$getCircleProps(ctx) {
    const circleProps = {
        style: {
            "--radius": "calc(var(--size) / 2 - var(--thickness) / 2)",
            cx: "calc(var(--size) / 2)",
            cy: "calc(var(--size) / 2)",
            r: "var(--radius)",
            fill: "transparent",
            strokeWidth: "var(--thickness)"
        }
    };
    return {
        root: {
            style: {
                width: "var(--size)",
                height: "var(--size)"
            }
        },
        track: circleProps,
        range: {
            opacity: ctx.value === 0 ? 0 : void 0,
            style: {
                ...circleProps.style,
                "--percent": ctx.percent,
                "--circumference": `calc(2 * 3.14159 * var(--radius))`,
                "--offset": `calc(var(--circumference) * (100 - var(--percent)) / 100)`,
                strokeDashoffset: `calc(var(--circumference) * ((100 - var(--percent)) / 100))`,
                strokeDasharray: ctx.isIndeterminate ? void 0 : `var(--circumference)`,
                transformOrigin: "center",
                transform: "rotate(-90deg)"
            }
        }
    };
}
function $abee42452e65a540$var$midValue(min, max) {
    return min + (max - min) / 2;
}
function $abee42452e65a540$export$ea56d40cd27c3480(userContext) {
    const ctx = (0, $89352e0ddd72597a$export$8e16b83750b44988)(userContext);
    return (0, $5c0da97e9c7aa95f$export$aaa7fa18f8e9b2e8)({
        id: "progress",
        initial: "idle",
        context: {
            max: ctx.max ?? 100,
            min: ctx.min ?? 0,
            value: $abee42452e65a540$var$midValue(ctx.min ?? 0, ctx.max ?? 100),
            orientation: "horizontal",
            translations: {
                value: ({ percent: percent })=>percent === -1 ? "loading..." : `${percent} percent`,
                ...ctx.translations
            },
            ...ctx
        },
        created: [
            "validateContext"
        ],
        computed: {
            isIndeterminate: (ctx2)=>ctx2.value === null,
            percent (ctx2) {
                if (!(0, $89352e0ddd72597a$export$7e4aa119212bc614)(ctx2.value)) return -1;
                return Math.round((ctx2.value - ctx2.min) / (ctx2.max - ctx2.min) * 100);
            },
            isAtMax: (ctx2)=>ctx2.value === ctx2.max,
            isHorizontal: (ctx2)=>ctx2.orientation === "horizontal",
            isRtl: (ctx2)=>ctx2.dir === "rtl"
        },
        states: {
            idle: {
                on: {
                    "VALUE.SET": {
                        actions: [
                            "setValue"
                        ]
                    }
                }
            }
        }
    }, {
        actions: {
            setValue: (ctx2, evt)=>{
                $abee42452e65a540$var$set.value(ctx2, evt.value);
            },
            validateContext: (ctx2)=>{
                if (ctx2.value == null) return;
                if (!$abee42452e65a540$var$isValidNumber(ctx2.max)) throw new Error(`[progress] The max value passed \`${ctx2.max}\` is not a valid number`);
                if (!$abee42452e65a540$var$isValidMax(ctx2.value, ctx2.max)) throw new Error(`[progress] The value passed \`${ctx2.value}\` exceeds the max value \`${ctx2.max}\``);
                if (!$abee42452e65a540$var$isValidMin(ctx2.value, ctx2.min)) throw new Error(`[progress] The value passed \`${ctx2.value}\` exceeds the min value \`${ctx2.min}\``);
            }
        }
    });
}
function $abee42452e65a540$var$isValidNumber(max) {
    return (0, $89352e0ddd72597a$export$7e4aa119212bc614)(max) && !isNaN(max);
}
function $abee42452e65a540$var$isValidMax(value, max) {
    return $abee42452e65a540$var$isValidNumber(value) && value <= max;
}
function $abee42452e65a540$var$isValidMin(value, min) {
    return $abee42452e65a540$var$isValidNumber(value) && value >= min;
}
var $abee42452e65a540$var$set = {
    value (ctx, value) {
        if ((0, $89352e0ddd72597a$export$248d38f6296296c5)(ctx.value, value)) return;
        ctx.value = value === null ? null : Math.max(0, Math.min(value, ctx.max));
        ctx.onValueChange?.({
            value: value
        });
    }
};
var $abee42452e65a540$export$8128bb6492cf3de7 = (0, $5b359805fda5a40e$export$c94ea207b45fef3a)()([
    "dir",
    "getRootNode",
    "id",
    "ids",
    "max",
    "min",
    "orientation",
    "translations",
    "value",
    "onValueChange"
]);
var $abee42452e65a540$export$45029c61b0073d87 = (0, $89352e0ddd72597a$export$3ea53b214fbc1986)($abee42452e65a540$export$8128bb6492cf3de7);


"use strict";
const $91e24d4280588615$export$9f977c65a046b227 = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    slots: (0, $abee42452e65a540$export$477202748c7242bf).keys(),
    className: "chakra-progress",
    base: {
        root: {
            textStyle: "sm",
            position: "relative"
        },
        track: {
            overflow: "hidden",
            position: "relative"
        },
        range: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transitionProperty: "width, height",
            transitionDuration: "slow",
            height: "100%",
            bgColor: "var(--track-color)",
            _indeterminate: {
                "--animate-from-x": "-40%",
                "--animate-to-x": "100%",
                position: "absolute",
                willChange: "left",
                minWidth: "50%",
                animation: "position 1s ease infinite normal none running",
                backgroundImage: `linear-gradient(to right, transparent 0%, var(--track-color) 50%, transparent 100%)`
            }
        },
        label: {
            display: "inline-flex",
            fontWeight: "medium",
            alignItems: "center",
            gap: "1"
        },
        valueText: {
            textStyle: "xs",
            lineHeight: "1",
            fontWeight: "medium"
        }
    },
    variants: {
        variant: {
            outline: {
                track: {
                    shadow: "inset",
                    bgColor: "bg.muted"
                },
                range: {
                    bgColor: "colorPalette.solid"
                }
            },
            subtle: {
                track: {
                    bgColor: "colorPalette.muted"
                },
                range: {
                    bgColor: "colorPalette.solid/72"
                }
            }
        },
        shape: {
            square: {},
            rounded: {
                track: {
                    borderRadius: "l1"
                }
            },
            full: {
                track: {
                    borderRadius: "full"
                }
            }
        },
        striped: {
            true: {
                range: {
                    backgroundImage: `linear-gradient(45deg, var(--stripe-color) 25%, transparent 25%, transparent 50%, var(--stripe-color) 50%, var(--stripe-color) 75%, transparent 75%, transparent)`,
                    backgroundSize: `var(--stripe-size) var(--stripe-size)`,
                    "--stripe-size": "1rem",
                    "--stripe-color": {
                        _light: "rgba(255, 255, 255, 0.3)",
                        _dark: "rgba(0, 0, 0, 0.3)"
                    }
                }
            }
        },
        animated: {
            true: {
                range: {
                    "--animate-from": "var(--stripe-size)",
                    animation: "bg-position 1s linear infinite"
                }
            }
        },
        size: {
            xs: {
                track: {
                    h: "1.5"
                }
            },
            sm: {
                track: {
                    h: "2"
                }
            },
            md: {
                track: {
                    h: "2.5"
                }
            },
            lg: {
                track: {
                    h: "3"
                }
            },
            xl: {
                track: {
                    h: "4"
                }
            }
        }
    },
    defaultVariants: {
        variant: "outline",
        size: "md",
        shape: "rounded"
    }
});




"use strict";
const $bc4d98668d3dadba$export$bf55419709f49d86 = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    className: "chakra-progress-circle",
    slots: (0, $abee42452e65a540$export$477202748c7242bf).keys(),
    base: {
        root: {
            display: "inline-flex",
            textStyle: "sm",
            position: "relative"
        },
        circle: {
            _indeterminate: {
                animation: "spin 2s linear infinite"
            }
        },
        circleTrack: {
            "--track-color": "colors.colorPalette.muted",
            stroke: "var(--track-color)"
        },
        circleRange: {
            stroke: "colorPalette.solid",
            transitionProperty: "stroke-dasharray",
            transitionDuration: "0.6s",
            _indeterminate: {
                animation: "circular-progress 1.5s linear infinite"
            }
        },
        label: {
            display: "inline-flex"
        },
        valueText: {
            lineHeight: "1",
            fontWeight: "medium",
            letterSpacing: "tight",
            fontVariantNumeric: "tabular-nums"
        }
    },
    variants: {
        size: {
            xs: {
                circle: {
                    "--size": "24px",
                    "--thickness": "4px"
                },
                valueText: {
                    textStyle: "2xs"
                }
            },
            sm: {
                circle: {
                    "--size": "32px",
                    "--thickness": "5px"
                },
                valueText: {
                    textStyle: "2xs"
                }
            },
            md: {
                circle: {
                    "--size": "40px",
                    "--thickness": "6px"
                },
                valueText: {
                    textStyle: "xs"
                }
            },
            lg: {
                circle: {
                    "--size": "48px",
                    "--thickness": "7px"
                },
                valueText: {
                    textStyle: "sm"
                }
            },
            xl: {
                circle: {
                    "--size": "64px",
                    "--thickness": "8px"
                },
                valueText: {
                    textStyle: "sm"
                }
            }
        }
    },
    defaultVariants: {
        size: "md"
    }
});








// This is required only for performance.
// https://github.com/dai-shi/proxy-memoize/issues/68
const $40205517a527439f$var$targetCache = new WeakMap();
// constants from proxy-compare
const $40205517a527439f$var$HAS_KEY_PROPERTY = "h";
const $40205517a527439f$var$ALL_OWN_KEYS_PROPERTY = "w";
const $40205517a527439f$var$HAS_OWN_KEY_PROPERTY = "o";
const $40205517a527439f$var$KEYS_PROPERTY = "k";
const $40205517a527439f$var$trackMemoUntrackedObjSet = new WeakSet();
const $40205517a527439f$var$isObject = (x)=>typeof x === "object" && x !== null;
const $40205517a527439f$var$untrack = (x, seen)=>{
    if (!$40205517a527439f$var$isObject(x)) return x;
    const untrackedObj = (0, $2364deb6cb3c9389$export$80d2cee7ee556e99)(x);
    if (untrackedObj) {
        (0, $2364deb6cb3c9389$export$badc26589cf7bb38)(x);
        $40205517a527439f$var$trackMemoUntrackedObjSet.add(untrackedObj);
        return untrackedObj;
    }
    if (!seen.has(x)) {
        seen.add(x);
        Object.entries(x).forEach(([k, v])=>{
            const vv = $40205517a527439f$var$untrack(v, seen);
            if (!Object.is(vv, v)) x[k] = vv;
        });
    }
    return x;
};
const $40205517a527439f$var$touchAffected = (dst, src, affected)=>{
    var _a, _b, _c;
    if (!$40205517a527439f$var$isObject(dst) || !$40205517a527439f$var$isObject(src)) return;
    const untrackedObj = (0, $2364deb6cb3c9389$export$80d2cee7ee556e99)(src);
    const used = affected.get(untrackedObj || src);
    if (!used) {
        if ($40205517a527439f$var$trackMemoUntrackedObjSet.has(untrackedObj)) (0, $2364deb6cb3c9389$export$badc26589cf7bb38)(dst);
        return;
    }
    (_a = used[$40205517a527439f$var$HAS_KEY_PROPERTY]) === null || _a === void 0 || _a.forEach((key)=>{
        Reflect.has(dst, key);
    });
    if (used[$40205517a527439f$var$ALL_OWN_KEYS_PROPERTY] === true) Reflect.ownKeys(dst);
    (_b = used[$40205517a527439f$var$HAS_OWN_KEY_PROPERTY]) === null || _b === void 0 || _b.forEach((key)=>{
        Reflect.getOwnPropertyDescriptor(dst, key);
    });
    (_c = used[$40205517a527439f$var$KEYS_PROPERTY]) === null || _c === void 0 || _c.forEach((key)=>{
        $40205517a527439f$var$touchAffected(dst[key], src[key], affected);
    });
};
const $40205517a527439f$var$isOriginalEqual = (x, y)=>{
    for(let xx = x; xx; x = xx, xx = (0, $2364deb6cb3c9389$export$80d2cee7ee556e99)(xx));
    for(let yy = y; yy; y = yy, yy = (0, $2364deb6cb3c9389$export$80d2cee7ee556e99)(yy));
    return Object.is(x, y);
};
// properties
const $40205517a527439f$var$OBJ_PROPERTY = "o";
const $40205517a527439f$var$RESULT_PROPERTY = "r";
const $40205517a527439f$var$AFFECTED_PROPERTY = "a";
function $40205517a527439f$export$fc10aeed3a532e2a(fn, options) {
    var _a;
    let memoListHead = 0;
    const size = (_a = options === null || options === void 0 ? void 0 : options.size) !== null && _a !== void 0 ? _a : 1;
    const memoList = [];
    const resultCache = (options === null || options === void 0 ? void 0 : options.noWeakMap) ? null : new WeakMap();
    const memoizedFn = (obj)=>{
        const cache = resultCache === null || resultCache === void 0 ? void 0 : resultCache.get(obj);
        if (cache) return cache;
        for(let i = 0; i < size; i += 1){
            const memo = memoList[(memoListHead + i) % size];
            if (!memo) break;
            const { [$40205517a527439f$var$OBJ_PROPERTY]: memoObj, [$40205517a527439f$var$AFFECTED_PROPERTY]: memoAffected, [$40205517a527439f$var$RESULT_PROPERTY]: memoResult } = memo;
            if (!(0, $2364deb6cb3c9389$export$3a85b3f4caf02b6f)(memoObj, obj, memoAffected, new WeakMap(), $40205517a527439f$var$isOriginalEqual)) {
                $40205517a527439f$var$touchAffected(obj, memoObj, memoAffected);
                resultCache === null || resultCache === void 0 || resultCache.set(obj, memoResult);
                return memoResult;
            }
        }
        const affected = new WeakMap();
        const proxy = (0, $2364deb6cb3c9389$export$7865d0c7f908de6b)(obj, affected, undefined, $40205517a527439f$var$targetCache);
        const result = $40205517a527439f$var$untrack(fn(proxy), new WeakSet());
        $40205517a527439f$var$touchAffected(obj, obj, affected);
        const entry = {
            [$40205517a527439f$var$OBJ_PROPERTY]: obj,
            [$40205517a527439f$var$RESULT_PROPERTY]: result,
            [$40205517a527439f$var$AFFECTED_PROPERTY]: affected
        };
        memoListHead = (memoListHead - 1 + size) % size;
        memoList[memoListHead] = entry;
        resultCache === null || resultCache === void 0 || resultCache.set(obj, result);
        return result;
    };
    return memoizedFn;
}


var $b20a401b1fb69c6f$export$d6c5ba88ccff797 = /* @__PURE__ */ ((QrCodeDataType2)=>{
    QrCodeDataType2[QrCodeDataType2["Border"] = -1] = "Border";
    QrCodeDataType2[QrCodeDataType2["Data"] = 0] = "Data";
    QrCodeDataType2[QrCodeDataType2["Function"] = 1] = "Function";
    QrCodeDataType2[QrCodeDataType2["Position"] = 2] = "Position";
    QrCodeDataType2[QrCodeDataType2["Timing"] = 3] = "Timing";
    QrCodeDataType2[QrCodeDataType2["Alignment"] = 4] = "Alignment";
    return QrCodeDataType2;
})($b20a401b1fb69c6f$export$d6c5ba88ccff797 || {});
var $b20a401b1fb69c6f$var$__defProp = Object.defineProperty;
var $b20a401b1fb69c6f$var$__defNormalProp = (obj, key, value)=>key in obj ? $b20a401b1fb69c6f$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $b20a401b1fb69c6f$var$__publicField = (obj, key, value)=>{
    $b20a401b1fb69c6f$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $b20a401b1fb69c6f$var$LOW = [
    0,
    1
];
const $b20a401b1fb69c6f$var$MEDIUM = [
    1,
    0
];
const $b20a401b1fb69c6f$var$QUARTILE = [
    2,
    3
];
const $b20a401b1fb69c6f$var$HIGH = [
    3,
    2
];
const $b20a401b1fb69c6f$var$EccMap = {
    L: $b20a401b1fb69c6f$var$LOW,
    M: $b20a401b1fb69c6f$var$MEDIUM,
    Q: $b20a401b1fb69c6f$var$QUARTILE,
    H: $b20a401b1fb69c6f$var$HIGH
};
const $b20a401b1fb69c6f$var$NUMERIC_REGEX = /^[0-9]*$/;
const $b20a401b1fb69c6f$var$ALPHANUMERIC_REGEX = /^[A-Z0-9 $%*+.\/:-]*$/;
const $b20a401b1fb69c6f$var$ALPHANUMERIC_CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:";
const $b20a401b1fb69c6f$var$MIN_VERSION = 1;
const $b20a401b1fb69c6f$var$MAX_VERSION = 40;
const $b20a401b1fb69c6f$var$PENALTY_N1 = 3;
const $b20a401b1fb69c6f$var$PENALTY_N2 = 3;
const $b20a401b1fb69c6f$var$PENALTY_N3 = 40;
const $b20a401b1fb69c6f$var$PENALTY_N4 = 10;
const $b20a401b1fb69c6f$var$ECC_CODEWORDS_PER_BLOCK = [
    // Version: (note that index 0 is for padding, and is set to an illegal value)
    // 0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
    [
        -1,
        7,
        10,
        15,
        20,
        26,
        18,
        20,
        24,
        30,
        18,
        20,
        24,
        26,
        30,
        22,
        24,
        28,
        30,
        28,
        28,
        28,
        28,
        30,
        30,
        26,
        28,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30
    ],
    // Low
    [
        -1,
        10,
        16,
        26,
        18,
        24,
        16,
        18,
        22,
        22,
        26,
        30,
        22,
        22,
        24,
        24,
        28,
        28,
        26,
        26,
        26,
        26,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28,
        28
    ],
    // Medium
    [
        -1,
        13,
        22,
        18,
        26,
        18,
        24,
        18,
        22,
        20,
        24,
        28,
        26,
        24,
        20,
        30,
        24,
        28,
        28,
        26,
        30,
        28,
        30,
        30,
        30,
        30,
        28,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30
    ],
    // Quartile
    [
        -1,
        17,
        28,
        22,
        16,
        22,
        28,
        26,
        26,
        24,
        28,
        24,
        28,
        22,
        24,
        24,
        30,
        28,
        28,
        26,
        28,
        30,
        24,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        30
    ]
];
const $b20a401b1fb69c6f$var$NUM_ERROR_CORRECTION_BLOCKS = [
    // Version: (note that index 0 is for padding, and is set to an illegal value)
    // 0, 1, 2, 3, 4, 5, 6, 7, 8, 9,10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
    [
        -1,
        1,
        1,
        1,
        1,
        1,
        2,
        2,
        2,
        2,
        4,
        4,
        4,
        4,
        4,
        6,
        6,
        6,
        6,
        7,
        8,
        8,
        9,
        9,
        10,
        12,
        12,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        19,
        20,
        21,
        22,
        24,
        25
    ],
    // Low
    [
        -1,
        1,
        1,
        1,
        2,
        2,
        4,
        4,
        4,
        5,
        5,
        5,
        8,
        9,
        9,
        10,
        10,
        11,
        13,
        14,
        16,
        17,
        17,
        18,
        20,
        21,
        23,
        25,
        26,
        28,
        29,
        31,
        33,
        35,
        37,
        38,
        40,
        43,
        45,
        47,
        49
    ],
    // Medium
    [
        -1,
        1,
        1,
        2,
        2,
        4,
        4,
        6,
        6,
        8,
        8,
        8,
        10,
        12,
        16,
        12,
        17,
        16,
        18,
        21,
        20,
        23,
        23,
        25,
        27,
        29,
        34,
        34,
        35,
        38,
        40,
        43,
        45,
        48,
        51,
        53,
        56,
        59,
        62,
        65,
        68
    ],
    // Quartile
    [
        -1,
        1,
        1,
        2,
        4,
        4,
        4,
        5,
        6,
        8,
        8,
        11,
        11,
        16,
        16,
        18,
        16,
        19,
        21,
        25,
        25,
        25,
        34,
        30,
        32,
        35,
        37,
        40,
        42,
        45,
        48,
        51,
        54,
        57,
        60,
        63,
        66,
        70,
        74,
        77,
        81
    ]
];
class $b20a401b1fb69c6f$var$QrCode {
    /* -- Constructor (low level) and fields -- */ // Creates a new QR Code with the given version number,
    // error correction level, data codeword bytes, and mask number.
    // This is a low-level API that most users should not use directly.
    // A mid-level API is the encodeSegments() function.
    constructor(version, ecc, dataCodewords, msk){
        this.version = version;
        this.ecc = ecc;
        /* -- Fields -- */ // The width and height of this QR Code, measured in modules, between
        // 21 and 177 (inclusive). This is equal to version * 4 + 17.
        $b20a401b1fb69c6f$var$__publicField(this, "size");
        // The index of the mask pattern used in this QR Code, which is between 0 and 7 (inclusive).
        // Even if a QR Code is created with automatic masking requested (mask = -1),
        // the resulting object still has a mask value between 0 and 7.
        $b20a401b1fb69c6f$var$__publicField(this, "mask");
        // The modules of this QR Code (false = light, true = dark).
        // Immutable after constructor finishes. Accessed through getModule().
        $b20a401b1fb69c6f$var$__publicField(this, "modules", []);
        $b20a401b1fb69c6f$var$__publicField(this, "types", []);
        if (version < $b20a401b1fb69c6f$var$MIN_VERSION || version > $b20a401b1fb69c6f$var$MAX_VERSION) throw new RangeError("Version value out of range");
        if (msk < -1 || msk > 7) throw new RangeError("Mask value out of range");
        this.size = version * 4 + 17;
        const row = Array.from({
            length: this.size
        }, ()=>false);
        for(let i = 0; i < this.size; i++){
            this.modules.push(row.slice());
            this.types.push(row.map(()=>0));
        }
        this.drawFunctionPatterns();
        const allCodewords = this.addEccAndInterleave(dataCodewords);
        this.drawCodewords(allCodewords);
        if (msk === -1) {
            let minPenalty = 1e9;
            for(let i = 0; i < 8; i++){
                this.applyMask(i);
                this.drawFormatBits(i);
                const penalty = this.getPenaltyScore();
                if (penalty < minPenalty) {
                    msk = i;
                    minPenalty = penalty;
                }
                this.applyMask(i);
            }
        }
        this.mask = msk;
        this.applyMask(msk);
        this.drawFormatBits(msk);
    }
    /* -- Accessor methods -- */ // Returns the color of the module (pixel) at the given coordinates, which is false
    // for light or true for dark. The top left corner has the coordinates (x=0, y=0).
    // If the given coordinates are out of bounds, then false (light) is returned.
    getModule(x, y) {
        return x >= 0 && x < this.size && y >= 0 && y < this.size && this.modules[y][x];
    }
    /* -- Private helper methods for constructor: Drawing function modules -- */ // Reads this object's version field, and draws and marks all function modules.
    drawFunctionPatterns() {
        for(let i = 0; i < this.size; i++){
            this.setFunctionModule(6, i, i % 2 === 0, $b20a401b1fb69c6f$export$d6c5ba88ccff797.Timing);
            this.setFunctionModule(i, 6, i % 2 === 0, $b20a401b1fb69c6f$export$d6c5ba88ccff797.Timing);
        }
        this.drawFinderPattern(3, 3);
        this.drawFinderPattern(this.size - 4, 3);
        this.drawFinderPattern(3, this.size - 4);
        const alignPatPos = this.getAlignmentPatternPositions();
        const numAlign = alignPatPos.length;
        for(let i = 0; i < numAlign; i++){
            for(let j = 0; j < numAlign; j++)if (!(i === 0 && j === 0 || i === 0 && j === numAlign - 1 || i === numAlign - 1 && j === 0)) this.drawAlignmentPattern(alignPatPos[i], alignPatPos[j]);
        }
        this.drawFormatBits(0);
        this.drawVersion();
    }
    // Draws two copies of the format bits (with its own error correction code)
    // based on the given mask and this object's error correction level field.
    drawFormatBits(mask) {
        const data = this.ecc[1] << 3 | mask;
        let rem = data;
        for(let i = 0; i < 10; i++)rem = rem << 1 ^ (rem >>> 9) * 1335;
        const bits = (data << 10 | rem) ^ 21522;
        for(let i = 0; i <= 5; i++)this.setFunctionModule(8, i, $b20a401b1fb69c6f$var$getBit(bits, i));
        this.setFunctionModule(8, 7, $b20a401b1fb69c6f$var$getBit(bits, 6));
        this.setFunctionModule(8, 8, $b20a401b1fb69c6f$var$getBit(bits, 7));
        this.setFunctionModule(7, 8, $b20a401b1fb69c6f$var$getBit(bits, 8));
        for(let i = 9; i < 15; i++)this.setFunctionModule(14 - i, 8, $b20a401b1fb69c6f$var$getBit(bits, i));
        for(let i = 0; i < 8; i++)this.setFunctionModule(this.size - 1 - i, 8, $b20a401b1fb69c6f$var$getBit(bits, i));
        for(let i = 8; i < 15; i++)this.setFunctionModule(8, this.size - 15 + i, $b20a401b1fb69c6f$var$getBit(bits, i));
        this.setFunctionModule(8, this.size - 8, true);
    }
    // Draws two copies of the version bits (with its own error correction code),
    // based on this object's version field, iff 7 <= version <= 40.
    drawVersion() {
        if (this.version < 7) return;
        let rem = this.version;
        for(let i = 0; i < 12; i++)rem = rem << 1 ^ (rem >>> 11) * 7973;
        const bits = this.version << 12 | rem;
        for(let i = 0; i < 18; i++){
            const color = $b20a401b1fb69c6f$var$getBit(bits, i);
            const a = this.size - 11 + i % 3;
            const b = Math.floor(i / 3);
            this.setFunctionModule(a, b, color);
            this.setFunctionModule(b, a, color);
        }
    }
    // Draws a 9*9 finder pattern including the border separator,
    // with the center module at (x, y). Modules can be out of bounds.
    drawFinderPattern(x, y) {
        for(let dy = -4; dy <= 4; dy++)for(let dx = -4; dx <= 4; dx++){
            const dist = Math.max(Math.abs(dx), Math.abs(dy));
            const xx = x + dx;
            const yy = y + dy;
            if (xx >= 0 && xx < this.size && yy >= 0 && yy < this.size) this.setFunctionModule(xx, yy, dist !== 2 && dist !== 4, $b20a401b1fb69c6f$export$d6c5ba88ccff797.Position);
        }
    }
    // Draws a 5*5 alignment pattern, with the center module
    // at (x, y). All modules must be in bounds.
    drawAlignmentPattern(x, y) {
        for(let dy = -2; dy <= 2; dy++)for(let dx = -2; dx <= 2; dx++)this.setFunctionModule(x + dx, y + dy, Math.max(Math.abs(dx), Math.abs(dy)) !== 1, $b20a401b1fb69c6f$export$d6c5ba88ccff797.Alignment);
    }
    // Sets the color of a module and marks it as a function module.
    // Only used by the constructor. Coordinates must be in bounds.
    setFunctionModule(x, y, isDark, type = $b20a401b1fb69c6f$export$d6c5ba88ccff797.Function) {
        this.modules[y][x] = isDark;
        this.types[y][x] = type;
    }
    /* -- Private helper methods for constructor: Codewords and masking -- */ // Returns a new byte string representing the given data with the appropriate error correction
    // codewords appended to it, based on this object's version and error correction level.
    addEccAndInterleave(data) {
        const ver = this.version;
        const ecl = this.ecc;
        if (data.length !== $b20a401b1fb69c6f$var$getNumDataCodewords(ver, ecl)) throw new RangeError("Invalid argument");
        const numBlocks = $b20a401b1fb69c6f$var$NUM_ERROR_CORRECTION_BLOCKS[ecl[0]][ver];
        const blockEccLen = $b20a401b1fb69c6f$var$ECC_CODEWORDS_PER_BLOCK[ecl[0]][ver];
        const rawCodewords = Math.floor($b20a401b1fb69c6f$var$getNumRawDataModules(ver) / 8);
        const numShortBlocks = numBlocks - rawCodewords % numBlocks;
        const shortBlockLen = Math.floor(rawCodewords / numBlocks);
        const blocks = [];
        const rsDiv = $b20a401b1fb69c6f$var$reedSolomonComputeDivisor(blockEccLen);
        for(let i = 0, k = 0; i < numBlocks; i++){
            const dat = data.slice(k, k + shortBlockLen - blockEccLen + (i < numShortBlocks ? 0 : 1));
            k += dat.length;
            const ecc = $b20a401b1fb69c6f$var$reedSolomonComputeRemainder(dat, rsDiv);
            if (i < numShortBlocks) dat.push(0);
            blocks.push(dat.concat(ecc));
        }
        const result = [];
        for(let i = 0; i < blocks[0].length; i++)blocks.forEach((block, j)=>{
            if (i !== shortBlockLen - blockEccLen || j >= numShortBlocks) result.push(block[i]);
        });
        return result;
    }
    // Draws the given sequence of 8-bit codewords (data and error correction) onto the entire
    // data area of this QR Code. Function modules need to be marked off before this is called.
    drawCodewords(data) {
        if (data.length !== Math.floor($b20a401b1fb69c6f$var$getNumRawDataModules(this.version) / 8)) throw new RangeError("Invalid argument");
        let i = 0;
        for(let right = this.size - 1; right >= 1; right -= 2){
            if (right === 6) right = 5;
            for(let vert = 0; vert < this.size; vert++)for(let j = 0; j < 2; j++){
                const x = right - j;
                const upward = (right + 1 & 2) === 0;
                const y = upward ? this.size - 1 - vert : vert;
                if (!this.types[y][x] && i < data.length * 8) {
                    this.modules[y][x] = $b20a401b1fb69c6f$var$getBit(data[i >>> 3], 7 - (i & 7));
                    i++;
                }
            }
        }
    }
    // XORs the codeword modules in this QR Code with the given mask pattern.
    // The function modules must be marked and the codeword bits must be drawn
    // before masking. Due to the arithmetic of XOR, calling applyMask() with
    // the same mask value a second time will undo the mask. A final well-formed
    // QR Code needs exactly one (not zero, two, etc.) mask applied.
    applyMask(mask) {
        if (mask < 0 || mask > 7) throw new RangeError("Mask value out of range");
        for(let y = 0; y < this.size; y++)for(let x = 0; x < this.size; x++){
            let invert;
            switch(mask){
                case 0:
                    invert = (x + y) % 2 === 0;
                    break;
                case 1:
                    invert = y % 2 === 0;
                    break;
                case 2:
                    invert = x % 3 === 0;
                    break;
                case 3:
                    invert = (x + y) % 3 === 0;
                    break;
                case 4:
                    invert = (Math.floor(x / 3) + Math.floor(y / 2)) % 2 === 0;
                    break;
                case 5:
                    invert = x * y % 2 + x * y % 3 === 0;
                    break;
                case 6:
                    invert = (x * y % 2 + x * y % 3) % 2 === 0;
                    break;
                case 7:
                    invert = ((x + y) % 2 + x * y % 3) % 2 === 0;
                    break;
                default:
                    throw new Error("Unreachable");
            }
            if (!this.types[y][x] && invert) this.modules[y][x] = !this.modules[y][x];
        }
    }
    // Calculates and returns the penalty score based on state of this QR Code's current modules.
    // This is used by the automatic mask choice algorithm to find the mask pattern that yields the lowest score.
    getPenaltyScore() {
        let result = 0;
        for(let y = 0; y < this.size; y++){
            let runColor = false;
            let runX = 0;
            const runHistory = [
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ];
            for(let x = 0; x < this.size; x++)if (this.modules[y][x] === runColor) {
                runX++;
                if (runX === 5) result += $b20a401b1fb69c6f$var$PENALTY_N1;
                else if (runX > 5) result++;
            } else {
                this.finderPenaltyAddHistory(runX, runHistory);
                if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * $b20a401b1fb69c6f$var$PENALTY_N3;
                runColor = this.modules[y][x];
                runX = 1;
            }
            result += this.finderPenaltyTerminateAndCount(runColor, runX, runHistory) * $b20a401b1fb69c6f$var$PENALTY_N3;
        }
        for(let x = 0; x < this.size; x++){
            let runColor = false;
            let runY = 0;
            const runHistory = [
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ];
            for(let y = 0; y < this.size; y++)if (this.modules[y][x] === runColor) {
                runY++;
                if (runY === 5) result += $b20a401b1fb69c6f$var$PENALTY_N1;
                else if (runY > 5) result++;
            } else {
                this.finderPenaltyAddHistory(runY, runHistory);
                if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * $b20a401b1fb69c6f$var$PENALTY_N3;
                runColor = this.modules[y][x];
                runY = 1;
            }
            result += this.finderPenaltyTerminateAndCount(runColor, runY, runHistory) * $b20a401b1fb69c6f$var$PENALTY_N3;
        }
        for(let y = 0; y < this.size - 1; y++)for(let x = 0; x < this.size - 1; x++){
            const color = this.modules[y][x];
            if (color === this.modules[y][x + 1] && color === this.modules[y + 1][x] && color === this.modules[y + 1][x + 1]) result += $b20a401b1fb69c6f$var$PENALTY_N2;
        }
        let dark = 0;
        for (const row of this.modules)dark = row.reduce((sum, color)=>sum + (color ? 1 : 0), dark);
        const total = this.size * this.size;
        const k = Math.ceil(Math.abs(dark * 20 - total * 10) / total) - 1;
        result += k * $b20a401b1fb69c6f$var$PENALTY_N4;
        return result;
    }
    /* -- Private helper functions -- */ // Returns an ascending list of positions of alignment patterns for this version number.
    // Each position is in the range [0,177), and are used on both the x and y axes.
    // This could be implemented as lookup table of 40 variable-length lists of integers.
    getAlignmentPatternPositions() {
        if (this.version === 1) return [];
        else {
            const numAlign = Math.floor(this.version / 7) + 2;
            const step = this.version === 32 ? 26 : Math.ceil((this.version * 4 + 4) / (numAlign * 2 - 2)) * 2;
            const result = [
                6
            ];
            for(let pos = this.size - 7; result.length < numAlign; pos -= step)result.splice(1, 0, pos);
            return result;
        }
    }
    // Can only be called immediately after a light run is added, and
    // returns either 0, 1, or 2. A helper function for getPenaltyScore().
    finderPenaltyCountPatterns(runHistory) {
        const n = runHistory[1];
        const core = n > 0 && runHistory[2] === n && runHistory[3] === n * 3 && runHistory[4] === n && runHistory[5] === n;
        return (core && runHistory[0] >= n * 4 && runHistory[6] >= n ? 1 : 0) + (core && runHistory[6] >= n * 4 && runHistory[0] >= n ? 1 : 0);
    }
    // Must be called at the end of a line (row or column) of modules. A helper function for getPenaltyScore().
    finderPenaltyTerminateAndCount(currentRunColor, currentRunLength, runHistory) {
        if (currentRunColor) {
            this.finderPenaltyAddHistory(currentRunLength, runHistory);
            currentRunLength = 0;
        }
        currentRunLength += this.size;
        this.finderPenaltyAddHistory(currentRunLength, runHistory);
        return this.finderPenaltyCountPatterns(runHistory);
    }
    // Pushes the given value to the front and drops the last value. A helper function for getPenaltyScore().
    finderPenaltyAddHistory(currentRunLength, runHistory) {
        if (runHistory[0] === 0) currentRunLength += this.size;
        runHistory.pop();
        runHistory.unshift(currentRunLength);
    }
}
function $b20a401b1fb69c6f$var$appendBits(val, len, bb) {
    if (len < 0 || len > 31 || val >>> len !== 0) throw new RangeError("Value out of range");
    for(let i = len - 1; i >= 0; i--)bb.push(val >>> i & 1);
}
function $b20a401b1fb69c6f$var$getBit(x, i) {
    return (x >>> i & 1) !== 0;
}
class $b20a401b1fb69c6f$var$QrSegment {
    // Creates a new QR Code segment with the given attributes and data.
    // The character count (numChars) must agree with the mode and the bit buffer length,
    // but the constraint isn't checked. The given bit buffer is cloned and stored.
    constructor(mode, numChars, bitData){
        this.mode = mode;
        this.numChars = numChars;
        this.bitData = bitData;
        if (numChars < 0) throw new RangeError("Invalid argument");
        this.bitData = bitData.slice();
    }
    /* -- Methods -- */ // Returns a new copy of the data bits of this segment.
    getData() {
        return this.bitData.slice();
    }
}
const $b20a401b1fb69c6f$var$MODE_NUMERIC = [
    1,
    10,
    12,
    14
];
const $b20a401b1fb69c6f$var$MODE_ALPHANUMERIC = [
    2,
    9,
    11,
    13
];
const $b20a401b1fb69c6f$var$MODE_BYTE = [
    4,
    8,
    16,
    16
];
function $b20a401b1fb69c6f$var$numCharCountBits(mode, ver) {
    return mode[Math.floor((ver + 7) / 17) + 1];
}
function $b20a401b1fb69c6f$var$makeBytes(data) {
    const bb = [];
    for (const b of data)$b20a401b1fb69c6f$var$appendBits(b, 8, bb);
    return new $b20a401b1fb69c6f$var$QrSegment($b20a401b1fb69c6f$var$MODE_BYTE, data.length, bb);
}
function $b20a401b1fb69c6f$var$makeNumeric(digits) {
    if (!$b20a401b1fb69c6f$var$isNumeric(digits)) throw new RangeError("String contains non-numeric characters");
    const bb = [];
    for(let i = 0; i < digits.length;){
        const n = Math.min(digits.length - i, 3);
        $b20a401b1fb69c6f$var$appendBits(Number.parseInt(digits.substring(i, i + n), 10), n * 3 + 1, bb);
        i += n;
    }
    return new $b20a401b1fb69c6f$var$QrSegment($b20a401b1fb69c6f$var$MODE_NUMERIC, digits.length, bb);
}
function $b20a401b1fb69c6f$var$makeAlphanumeric(text) {
    if (!$b20a401b1fb69c6f$var$isAlphanumeric(text)) throw new RangeError("String contains unencodable characters in alphanumeric mode");
    const bb = [];
    let i;
    for(i = 0; i + 2 <= text.length; i += 2){
        let temp = $b20a401b1fb69c6f$var$ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)) * 45;
        temp += $b20a401b1fb69c6f$var$ALPHANUMERIC_CHARSET.indexOf(text.charAt(i + 1));
        $b20a401b1fb69c6f$var$appendBits(temp, 11, bb);
    }
    if (i < text.length) $b20a401b1fb69c6f$var$appendBits($b20a401b1fb69c6f$var$ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)), 6, bb);
    return new $b20a401b1fb69c6f$var$QrSegment($b20a401b1fb69c6f$var$MODE_ALPHANUMERIC, text.length, bb);
}
function $b20a401b1fb69c6f$var$makeSegments(text) {
    if (text === "") return [];
    else if ($b20a401b1fb69c6f$var$isNumeric(text)) return [
        $b20a401b1fb69c6f$var$makeNumeric(text)
    ];
    else if ($b20a401b1fb69c6f$var$isAlphanumeric(text)) return [
        $b20a401b1fb69c6f$var$makeAlphanumeric(text)
    ];
    else return [
        $b20a401b1fb69c6f$var$makeBytes($b20a401b1fb69c6f$var$toUtf8ByteArray(text))
    ];
}
function $b20a401b1fb69c6f$var$isNumeric(text) {
    return $b20a401b1fb69c6f$var$NUMERIC_REGEX.test(text);
}
function $b20a401b1fb69c6f$var$isAlphanumeric(text) {
    return $b20a401b1fb69c6f$var$ALPHANUMERIC_REGEX.test(text);
}
function $b20a401b1fb69c6f$var$getTotalBits(segs, version) {
    let result = 0;
    for (const seg of segs){
        const ccbits = $b20a401b1fb69c6f$var$numCharCountBits(seg.mode, version);
        if (seg.numChars >= 1 << ccbits) return Number.POSITIVE_INFINITY;
        result += 4 + ccbits + seg.bitData.length;
    }
    return result;
}
function $b20a401b1fb69c6f$var$toUtf8ByteArray(str) {
    str = encodeURI(str);
    const result = [];
    for(let i = 0; i < str.length; i++)if (str.charAt(i) !== "%") result.push(str.charCodeAt(i));
    else {
        result.push(Number.parseInt(str.substring(i + 1, i + 3), 16));
        i += 2;
    }
    return result;
}
function $b20a401b1fb69c6f$var$getNumRawDataModules(ver) {
    if (ver < $b20a401b1fb69c6f$var$MIN_VERSION || ver > $b20a401b1fb69c6f$var$MAX_VERSION) throw new RangeError("Version number out of range");
    let result = (16 * ver + 128) * ver + 64;
    if (ver >= 2) {
        const numAlign = Math.floor(ver / 7) + 2;
        result -= (25 * numAlign - 10) * numAlign - 55;
        if (ver >= 7) result -= 36;
    }
    return result;
}
function $b20a401b1fb69c6f$var$getNumDataCodewords(ver, ecl) {
    return Math.floor($b20a401b1fb69c6f$var$getNumRawDataModules(ver) / 8) - $b20a401b1fb69c6f$var$ECC_CODEWORDS_PER_BLOCK[ecl[0]][ver] * $b20a401b1fb69c6f$var$NUM_ERROR_CORRECTION_BLOCKS[ecl[0]][ver];
}
function $b20a401b1fb69c6f$var$reedSolomonComputeDivisor(degree) {
    if (degree < 1 || degree > 255) throw new RangeError("Degree out of range");
    const result = [];
    for(let i = 0; i < degree - 1; i++)result.push(0);
    result.push(1);
    let root = 1;
    for(let i = 0; i < degree; i++){
        for(let j = 0; j < result.length; j++){
            result[j] = $b20a401b1fb69c6f$var$reedSolomonMultiply(result[j], root);
            if (j + 1 < result.length) result[j] ^= result[j + 1];
        }
        root = $b20a401b1fb69c6f$var$reedSolomonMultiply(root, 2);
    }
    return result;
}
function $b20a401b1fb69c6f$var$reedSolomonComputeRemainder(data, divisor) {
    const result = divisor.map((_)=>0);
    for (const b of data){
        const factor = b ^ result.shift();
        result.push(0);
        divisor.forEach((coef, i)=>result[i] ^= $b20a401b1fb69c6f$var$reedSolomonMultiply(coef, factor));
    }
    return result;
}
function $b20a401b1fb69c6f$var$reedSolomonMultiply(x, y) {
    if (x >>> 8 !== 0 || y >>> 8 !== 0) throw new RangeError("Byte out of range");
    let z = 0;
    for(let i = 7; i >= 0; i--){
        z = z << 1 ^ (z >>> 7) * 285;
        z ^= (y >>> i & 1) * x;
    }
    return z;
}
function $b20a401b1fb69c6f$var$encodeSegments(segs, ecl, minVersion = 1, maxVersion = 40, mask = -1, boostEcl = true) {
    if (!($b20a401b1fb69c6f$var$MIN_VERSION <= minVersion && minVersion <= maxVersion && maxVersion <= $b20a401b1fb69c6f$var$MAX_VERSION) || mask < -1 || mask > 7) throw new RangeError("Invalid value");
    let version;
    let dataUsedBits;
    for(version = minVersion;; version++){
        const dataCapacityBits2 = $b20a401b1fb69c6f$var$getNumDataCodewords(version, ecl) * 8;
        const usedBits = $b20a401b1fb69c6f$var$getTotalBits(segs, version);
        if (usedBits <= dataCapacityBits2) {
            dataUsedBits = usedBits;
            break;
        }
        if (version >= maxVersion) throw new RangeError("Data too long");
    }
    for (const newEcl of [
        $b20a401b1fb69c6f$var$MEDIUM,
        $b20a401b1fb69c6f$var$QUARTILE,
        $b20a401b1fb69c6f$var$HIGH
    ])if (boostEcl && dataUsedBits <= $b20a401b1fb69c6f$var$getNumDataCodewords(version, newEcl) * 8) ecl = newEcl;
    const bb = [];
    for (const seg of segs){
        $b20a401b1fb69c6f$var$appendBits(seg.mode[0], 4, bb);
        $b20a401b1fb69c6f$var$appendBits(seg.numChars, $b20a401b1fb69c6f$var$numCharCountBits(seg.mode, version), bb);
        for (const b of seg.getData())bb.push(b);
    }
    const dataCapacityBits = $b20a401b1fb69c6f$var$getNumDataCodewords(version, ecl) * 8;
    $b20a401b1fb69c6f$var$appendBits(0, Math.min(4, dataCapacityBits - bb.length), bb);
    $b20a401b1fb69c6f$var$appendBits(0, (8 - bb.length % 8) % 8, bb);
    for(let padByte = 236; bb.length < dataCapacityBits; padByte ^= 253)$b20a401b1fb69c6f$var$appendBits(padByte, 8, bb);
    const dataCodewords = Array.from({
        length: Math.ceil(bb.length / 8)
    }, ()=>0);
    bb.forEach((b, i)=>dataCodewords[i >>> 3] |= b << 7 - (i & 7));
    return new $b20a401b1fb69c6f$var$QrCode(version, ecl, dataCodewords, mask);
}
function $b20a401b1fb69c6f$export$c564cdbbe6da493(data, options) {
    const { ecc: ecc = "L", boostEcc: boostEcc = false, minVersion: minVersion = 1, maxVersion: maxVersion = 40, maskPattern: maskPattern = -1, border: border = 1 } = options || {};
    const segment = typeof data === "string" ? $b20a401b1fb69c6f$var$makeSegments(data) : Array.isArray(data) ? [
        $b20a401b1fb69c6f$var$makeBytes(data)
    ] : void 0;
    if (!segment) throw new Error(`uqr only supports encoding string and binary data, but got: ${typeof data}`);
    const qr = $b20a401b1fb69c6f$var$encodeSegments(segment, $b20a401b1fb69c6f$var$EccMap[ecc], minVersion, maxVersion, maskPattern, boostEcc);
    const result = $b20a401b1fb69c6f$var$addBorder({
        version: qr.version,
        maskPattern: qr.mask,
        size: qr.size,
        data: qr.modules,
        types: qr.types
    }, border);
    if (options?.invert) result.data = result.data.map((row)=>row.map((mod)=>!mod));
    options?.onEncoded?.(result);
    return result;
}
function $b20a401b1fb69c6f$var$addBorder(input, border = 1) {
    if (!border) return input;
    const { size: size } = input;
    const newSize = size + border * 2;
    input.size = newSize;
    input.data.forEach((row)=>{
        for(let i = 0; i < border; i++){
            row.unshift(false);
            row.push(false);
        }
    });
    for(let i = 0; i < border; i++){
        input.data.unshift(Array.from({
            length: newSize
        }, (_)=>false));
        input.data.push(Array.from({
            length: newSize
        }, (_)=>false));
    }
    const b = $b20a401b1fb69c6f$export$d6c5ba88ccff797.Border;
    input.types.forEach((row)=>{
        for(let i = 0; i < border; i++){
            row.unshift(b);
            row.push(b);
        }
    });
    for(let i = 0; i < border; i++){
        input.types.unshift(Array.from({
            length: newSize
        }, (_)=>b));
        input.types.push(Array.from({
            length: newSize
        }, (_)=>b));
    }
    return input;
}
function $b20a401b1fb69c6f$var$getDataAt(data, x, y, defaults = false) {
    if (x < 0 || y < 0 || x >= data.length || y >= data.length) return defaults;
    return data[y][x];
}
function $b20a401b1fb69c6f$export$4ffff0904aa9166b(data, options = {}) {
    const { whiteChar: whiteChar = "\u2588", blackChar: blackChar = "\u2591" } = options;
    const result = $b20a401b1fb69c6f$export$c564cdbbe6da493(data, options);
    return result.data.map((row)=>{
        return row.map((mod)=>mod ? blackChar : whiteChar).join("");
    }).join("\n");
}
function $b20a401b1fb69c6f$export$2b305132f1e28d07(data, options = {}) {
    return $b20a401b1fb69c6f$export$4ffff0904aa9166b(data, {
        ...options,
        blackChar: "\x1b[40m\u3000\x1b[0m",
        whiteChar: "\x1b[47m\u3000\x1b[0m"
    });
}
function $b20a401b1fb69c6f$export$96fb6a042c547e20(data, options = {}) {
    const platte = {
        WHITE_ALL: "\u2588",
        WHITE_BLACK: "\u2580",
        BLACK_WHITE: "\u2584",
        BLACK_ALL: " "
    };
    const result = $b20a401b1fb69c6f$export$c564cdbbe6da493(data, options);
    const WHITE = false;
    const BLACK = true;
    const at = (x, y)=>$b20a401b1fb69c6f$var$getDataAt(result.data, x, y, true);
    const lines = [];
    let line = "";
    for(let row = 0; row < result.size; row += 2){
        for(let col = 0; col < result.size; col++){
            if (at(col, row) === WHITE && at(col, row + 1) === WHITE) line += platte.WHITE_ALL;
            else if (at(col, row) === WHITE && at(col, row + 1) === BLACK) line += platte.WHITE_BLACK;
            else if (at(col, row) === BLACK && at(col, row + 1) === WHITE) line += platte.BLACK_WHITE;
            else line += platte.BLACK_ALL;
        }
        lines.push(line);
        line = "";
    }
    return lines.join("\n");
}
function $b20a401b1fb69c6f$export$c5f8399d19a7394b(data, options = {}) {
    const result = $b20a401b1fb69c6f$export$c564cdbbe6da493(data, options);
    const { pixelSize: pixelSize = 10, whiteColor: whiteColor = "white", blackColor: blackColor = "black" } = options;
    const height = result.size * pixelSize;
    const width = result.size * pixelSize;
    let svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${height}">`;
    const pathes = [];
    for(let row = 0; row < result.size; row++)for(let col = 0; col < result.size; col++){
        const x = col * pixelSize;
        const y = row * pixelSize;
        if (result.data[row][col]) pathes.push(`M${x},${y}h${pixelSize}v${pixelSize}h-${pixelSize}z`);
    }
    svg += `<rect fill="${whiteColor}" width="${width}" height="${height}"/>`;
    svg += `<path fill="${blackColor}" d="${pathes.join("")}"/>`;
    svg += "</svg>";
    return svg;
}



// src/qr-code.anatomy.ts
var $6782f4151ec5f72a$export$477202748c7242bf = (0, $26df824f906b3a5c$export$197e6e8d4b33fd6c)("qr-code").parts("root", "frame", "pattern", "overlay", "downloadTrigger");
var $6782f4151ec5f72a$var$parts = $6782f4151ec5f72a$export$477202748c7242bf.build();
var $6782f4151ec5f72a$var$dom = (0, $b06ec5ff205338e5$export$41a9651decfe2bde)({
    getRootId: (ctx)=>ctx.ids?.root ?? `qrcode:${ctx.id}:root`,
    getFrameId: (ctx)=>ctx.ids?.frame ?? `qrcode:${ctx.id}:frame`,
    getFrameEl: (ctx)=>$6782f4151ec5f72a$var$dom.getById(ctx, $6782f4151ec5f72a$var$dom.getFrameId(ctx))
});
// src/qr-code.connect.ts
function $6782f4151ec5f72a$export$64605811ab45167f(state, send, normalize) {
    const encoded = state.context.encoded;
    const pixelSize = state.context.pixelSize;
    const height = encoded.size * pixelSize;
    const width = encoded.size * pixelSize;
    const paths = [];
    for(let row = 0; row < encoded.size; row++)for(let col = 0; col < encoded.size; col++){
        const x = col * pixelSize;
        const y = row * pixelSize;
        if (encoded.data[row][col]) paths.push(`M${x},${y}h${pixelSize}v${pixelSize}h-${pixelSize}z`);
    }
    return {
        value: state.context.value,
        setValue (value) {
            send({
                type: "VALUE.SET",
                value: value
            });
        },
        getDataUrl (type, quality) {
            const svgEl = $6782f4151ec5f72a$var$dom.getFrameEl(state.context);
            return (0, $b06ec5ff205338e5$export$4631f9310db9e583)(svgEl, {
                type: type,
                quality: quality
            });
        },
        getRootProps () {
            return normalize.element({
                id: $6782f4151ec5f72a$var$dom.getRootId(state.context),
                ...$6782f4151ec5f72a$var$parts.root.attrs,
                style: {
                    "--qrcode-pixel-size": `${pixelSize}px`,
                    "--qrcode-width": `${width}px`,
                    "--qrcode-height": `${height}px`,
                    position: "relative"
                }
            });
        },
        getFrameProps () {
            return normalize.svg({
                id: $6782f4151ec5f72a$var$dom.getFrameId(state.context),
                ...$6782f4151ec5f72a$var$parts.frame.attrs,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: `0 0 ${width} ${height}`
            });
        },
        getPatternProps () {
            return normalize.path({
                d: paths.join(""),
                ...$6782f4151ec5f72a$var$parts.pattern.attrs
            });
        },
        getOverlayProps () {
            return normalize.element({
                ...$6782f4151ec5f72a$var$parts.overlay.attrs,
                style: {
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    translate: "-50% -50%"
                }
            });
        },
        getDownloadTriggerProps (props2) {
            return normalize.button({
                type: "button",
                ...$6782f4151ec5f72a$var$parts.downloadTrigger.attrs,
                onClick (event) {
                    if (event.defaultPrevented) return;
                    send({
                        type: "DOWNLOAD_TRIGGER.CLICK",
                        ...props2
                    });
                }
            });
        }
    };
}
function $6782f4151ec5f72a$export$ea56d40cd27c3480(userContext) {
    const ctx = (0, $89352e0ddd72597a$export$8e16b83750b44988)(userContext);
    return (0, $5c0da97e9c7aa95f$export$aaa7fa18f8e9b2e8)({
        id: "qr-code",
        initial: "idle",
        context: {
            value: "",
            ...ctx,
            pixelSize: 10
        },
        computed: {
            encoded: (0, $40205517a527439f$export$fc10aeed3a532e2a)((ctx2)=>(0, $b20a401b1fb69c6f$export$c564cdbbe6da493)(ctx2.value, ctx2.encoding))
        },
        on: {
            "VALUE.SET": {
                actions: [
                    "setValue"
                ]
            },
            "DOWNLOAD_TRIGGER.CLICK": {
                actions: [
                    "downloadQrCode"
                ]
            }
        }
    }, {
        actions: {
            setValue (ctx2, evt) {
                $6782f4151ec5f72a$var$set.value(ctx2, evt.value);
            },
            downloadQrCode (ctx2, evt) {
                const { mimeType: mimeType, quality: quality, fileName: fileName } = evt;
                const svgEl = $6782f4151ec5f72a$var$dom.getFrameEl(ctx2);
                const doc = $6782f4151ec5f72a$var$dom.getDoc(ctx2);
                (0, $b06ec5ff205338e5$export$4631f9310db9e583)(svgEl, {
                    type: mimeType,
                    quality: quality
                }).then((dataUri)=>{
                    const a = doc.createElement("a");
                    a.href = dataUri;
                    a.rel = "noopener";
                    a.download = fileName;
                    a.click();
                    setTimeout(()=>{
                        a.remove();
                    }, 0);
                });
            }
        }
    });
}
var $6782f4151ec5f72a$var$set = {
    value (ctx, value) {
        if ((0, $89352e0ddd72597a$export$248d38f6296296c5)(ctx.value, value)) return;
        ctx.value = value;
        ctx.onValueChange?.({
            value: value
        });
    }
};
var $6782f4151ec5f72a$export$8128bb6492cf3de7 = (0, $5b359805fda5a40e$export$c94ea207b45fef3a)()([
    "ids",
    "value",
    "id",
    "encoding",
    "dir",
    "getRootNode",
    "onValueChange"
]);
var $6782f4151ec5f72a$export$45029c61b0073d87 = (0, $89352e0ddd72597a$export$3ea53b214fbc1986)($6782f4151ec5f72a$export$8128bb6492cf3de7);


"use strict";
const $e9ef641b90330e09$export$8ac26324cd542d34 = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    slots: (0, $6782f4151ec5f72a$export$477202748c7242bf).keys(),
    className: "chakra-qr-code",
    base: {
        root: {
            position: "relative",
            width: "fit-content",
            "--qr-code-overlay-size": "calc(var(--qr-code-size) / 3)"
        },
        frame: {
            width: "var(--qr-code-size)",
            height: "var(--qr-code-size)",
            fill: "currentColor"
        },
        overlay: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "var(--qr-code-overlay-size)",
            height: "var(--qr-code-overlay-size)",
            padding: "1",
            bg: "bg",
            rounded: "l1"
        }
    },
    variants: {
        size: {
            "2xs": {
                root: {
                    "--qr-code-size": "40px"
                }
            },
            xs: {
                root: {
                    "--qr-code-size": "64px"
                }
            },
            sm: {
                root: {
                    "--qr-code-size": "80px"
                }
            },
            md: {
                root: {
                    "--qr-code-size": "120px"
                }
            },
            lg: {
                root: {
                    "--qr-code-size": "160px"
                }
            },
            xl: {
                root: {
                    "--qr-code-size": "200px"
                }
            },
            "2xl": {
                root: {
                    "--qr-code-size": "240px"
                }
            },
            full: {
                root: {
                    "--qr-code-size": "100%"
                }
            }
        }
    },
    defaultVariants: {
        size: "md"
    }
});





"use strict";
const $42e3e9f4c9c6016b$export$ba1bd7ba2c203b42 = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    className: "chakra-radio-card",
    slots: (0, $9b7764ce1529e5da$export$6f8cb2f45f823e4d).keys(),
    base: {
        root: {
            display: "flex",
            flexDirection: "column",
            gap: "1.5",
            isolation: "isolate"
        },
        item: {
            flex: "1",
            display: "flex",
            flexDirection: "column",
            userSelect: "none",
            position: "relative",
            borderRadius: "l2",
            _focus: {
                bg: "colorPalette.muted/20"
            },
            _disabled: {
                opacity: "0.8",
                borderColor: "border.disabled"
            },
            _checked: {
                zIndex: "1"
            }
        },
        label: {
            display: "inline-flex",
            fontWeight: "medium",
            textStyle: "sm",
            _disabled: {
                opacity: "0.5"
            }
        },
        itemText: {
            fontWeight: "medium"
        },
        itemDescription: {
            opacity: "0.64",
            textStyle: "sm"
        },
        itemControl: {
            display: "inline-flex",
            flex: "1",
            pos: "relative",
            rounded: "inherit",
            justifyContent: "var(--radio-card-justify)",
            alignItems: "var(--radio-card-align)",
            _disabled: {
                bg: "bg.muted"
            }
        },
        itemIndicator: (0, $4eca34b97189bf98$export$f073ddc07274fbb0).base,
        itemAddon: {
            roundedBottom: "inherit",
            _disabled: {
                color: "fg.muted"
            }
        },
        itemContent: {
            display: "flex",
            flexDirection: "column",
            flex: "1",
            gap: "1",
            justifyContent: "var(--radio-card-justify)",
            alignItems: "var(--radio-card-align)"
        }
    },
    variants: {
        size: {
            sm: {
                item: {
                    textStyle: "sm"
                },
                itemControl: {
                    padding: "3",
                    gap: "1.5"
                },
                itemAddon: {
                    px: "3",
                    py: "1.5",
                    borderTopWidth: "1px"
                },
                itemIndicator: (0, $4eca34b97189bf98$export$f073ddc07274fbb0).variants?.size.sm
            },
            md: {
                item: {
                    textStyle: "sm"
                },
                itemControl: {
                    padding: "4",
                    gap: "2.5"
                },
                itemAddon: {
                    px: "4",
                    py: "2",
                    borderTopWidth: "1px"
                },
                itemIndicator: (0, $4eca34b97189bf98$export$f073ddc07274fbb0).variants?.size.md
            },
            lg: {
                item: {
                    textStyle: "md"
                },
                itemControl: {
                    padding: "4",
                    gap: "3.5"
                },
                itemAddon: {
                    px: "4",
                    py: "2",
                    borderTopWidth: "1px"
                },
                itemIndicator: (0, $4eca34b97189bf98$export$f073ddc07274fbb0).variants?.size.lg
            }
        },
        variant: {
            surface: {
                item: {
                    borderWidth: "1px",
                    _checked: {
                        bg: "colorPalette.subtle",
                        color: "colorPalette.fg",
                        borderColor: "colorPalette.muted"
                    }
                },
                itemIndicator: (0, $4eca34b97189bf98$export$f073ddc07274fbb0).variants?.variant.solid
            },
            subtle: {
                item: {
                    bg: "bg.muted"
                },
                itemControl: {
                    _checked: {
                        bg: "colorPalette.muted",
                        color: "colorPalette.fg"
                    }
                },
                itemIndicator: (0, $4eca34b97189bf98$export$f073ddc07274fbb0).variants?.variant.outline
            },
            outline: {
                item: {
                    borderWidth: "1px",
                    _checked: {
                        boxShadow: "0 0 0 1px var(--shadow-color)",
                        boxShadowColor: "colorPalette.solid",
                        borderColor: "colorPalette.solid"
                    }
                },
                itemIndicator: (0, $4eca34b97189bf98$export$f073ddc07274fbb0).variants?.variant.solid
            },
            solid: {
                item: {
                    borderWidth: "1px",
                    _checked: {
                        bg: "colorPalette.solid",
                        color: "colorPalette.contrast",
                        borderColor: "colorPalette.solid"
                    }
                },
                itemIndicator: (0, $4eca34b97189bf98$export$f073ddc07274fbb0).variants?.variant.inverted
            }
        },
        justify: {
            start: {
                item: {
                    "--radio-card-justify": "flex-start"
                }
            },
            end: {
                item: {
                    "--radio-card-justify": "flex-end"
                }
            },
            center: {
                item: {
                    "--radio-card-justify": "center"
                }
            }
        },
        align: {
            start: {
                item: {
                    "--radio-card-align": "flex-start"
                },
                itemControl: {
                    textAlign: "start"
                }
            },
            end: {
                item: {
                    "--radio-card-align": "flex-end"
                },
                itemControl: {
                    textAlign: "end"
                }
            },
            center: {
                item: {
                    "--radio-card-align": "center"
                },
                itemControl: {
                    textAlign: "center"
                }
            }
        },
        orientation: {
            vertical: {
                itemControl: {
                    flexDirection: "column"
                }
            },
            horizontal: {
                itemControl: {
                    flexDirection: "row"
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "outline",
        align: "start",
        orientation: "horizontal"
    }
});





"use strict";
const $80b278dc05e14427$export$f22f9c9e9c78d451 = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    className: "chakra-radio-group",
    slots: (0, $9b7764ce1529e5da$export$837558ec9d0fab0d).keys(),
    base: {
        item: {
            display: "inline-flex",
            alignItems: "center",
            position: "relative",
            fontWeight: "medium",
            _disabled: {
                cursor: "disabled"
            }
        },
        itemControl: (0, $4eca34b97189bf98$export$f073ddc07274fbb0).base,
        label: {
            userSelect: "none",
            textStyle: "sm",
            _disabled: {
                opacity: "0.5"
            }
        }
    },
    variants: {
        variant: {
            outline: {
                itemControl: (0, $4eca34b97189bf98$export$f073ddc07274fbb0).variants?.variant?.outline
            },
            subtle: {
                itemControl: (0, $4eca34b97189bf98$export$f073ddc07274fbb0).variants?.variant?.subtle
            },
            solid: {
                itemControl: (0, $4eca34b97189bf98$export$f073ddc07274fbb0).variants?.variant?.solid
            }
        },
        size: {
            xs: {
                item: {
                    textStyle: "xs",
                    gap: "1.5"
                },
                itemControl: (0, $4eca34b97189bf98$export$f073ddc07274fbb0).variants?.size?.xs
            },
            sm: {
                item: {
                    textStyle: "sm",
                    gap: "2"
                },
                itemControl: (0, $4eca34b97189bf98$export$f073ddc07274fbb0).variants?.size?.sm
            },
            md: {
                item: {
                    textStyle: "sm",
                    gap: "2.5"
                },
                itemControl: (0, $4eca34b97189bf98$export$f073ddc07274fbb0).variants?.size?.md
            },
            lg: {
                item: {
                    textStyle: "md",
                    gap: "3"
                },
                itemControl: (0, $4eca34b97189bf98$export$f073ddc07274fbb0).variants?.size?.lg
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "solid"
    }
});




"use strict";
const $08e6bd453f1b48cf$export$bd71218a24c0f454 = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    className: "chakra-rating-group",
    slots: (0, $9b7764ce1529e5da$export$127aba8545f015d6).keys(),
    base: {
        root: {
            display: "inline-flex"
        },
        control: {
            display: "inline-flex",
            alignItems: "center"
        },
        item: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            userSelect: "none"
        },
        itemIndicator: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "1em",
            height: "1em",
            position: "relative",
            _icon: {
                stroke: "currentColor",
                width: "100%",
                height: "100%",
                display: "inline-block",
                flexShrink: 0,
                position: "absolute",
                left: 0,
                top: 0
            },
            "& [data-bg]": {
                color: "bg.emphasized"
            },
            "& [data-fg]": {
                color: "transparent"
            },
            "&[data-highlighted]:not([data-half])": {
                "& [data-fg]": {
                    color: "colorPalette.solid"
                }
            },
            "&[data-half]": {
                "& [data-fg]": {
                    color: "colorPalette.solid",
                    clipPath: "inset(0 50% 0 0)"
                }
            }
        }
    },
    variants: {
        size: {
            xs: {
                item: {
                    textStyle: "sm"
                }
            },
            sm: {
                item: {
                    textStyle: "md"
                }
            },
            md: {
                item: {
                    textStyle: "xl"
                }
            },
            lg: {
                item: {
                    textStyle: "2xl"
                }
            }
        }
    },
    defaultVariants: {
        size: "md"
    }
});




"use client";
const $9c6976ebc64ce7e7$export$bdb66e13d4208038 = (0, $51157ee96867283b$export$477202748c7242bf).rename("segment-group");
const $9c6976ebc64ce7e7$export$6e2410c1d27f06e7 = $9c6976ebc64ce7e7$export$bdb66e13d4208038.build();


"use strict";
const $85e19c13bff93e48$export$7b9ca3573b9e7a3e = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    className: "chakra-segment-group",
    slots: (0, $9c6976ebc64ce7e7$export$bdb66e13d4208038).keys(),
    base: {
        root: {
            "--segment-radius": "radii.l2",
            borderRadius: "l2",
            display: "inline-flex",
            boxShadow: "inset",
            minW: "max-content",
            textAlign: "center",
            position: "relative",
            isolation: "isolate",
            bg: "bg.muted"
        },
        item: {
            display: "flex",
            alignItems: "center",
            userSelect: "none",
            fontSize: "sm",
            position: "relative",
            color: "fg",
            borderRadius: "var(--segment-radius)",
            _disabled: {
                opacity: "0.5"
            },
            "&:has(input:focus-visible)": {
                focusRing: "outside"
            },
            _before: {
                content: '""',
                position: "absolute",
                insetInlineStart: 0,
                insetBlock: "1.5",
                bg: "border",
                width: "1px",
                transition: "opacity 0.2s"
            },
            "& + &[data-state=checked], &[data-state=checked] + &, &:first-of-type": {
                _before: {
                    opacity: "0"
                }
            },
            "&[data-state=checked][data-ssr]": {
                shadow: "sm",
                bg: "bg",
                borderRadius: "var(--segment-radius)"
            }
        },
        indicator: {
            shadow: "sm",
            pos: "absolute",
            bg: {
                _light: "bg",
                _dark: "bg.emphasized"
            },
            width: "var(--width)",
            height: "var(--height)",
            top: "var(--top)",
            left: "var(--left)",
            zIndex: -1,
            borderRadius: "var(--segment-radius)"
        }
    },
    variants: {
        size: {
            xs: {
                root: {
                    height: "6"
                },
                item: {
                    textStyle: "xs",
                    px: "3",
                    gap: "1"
                }
            },
            sm: {
                root: {
                    height: "8"
                },
                item: {
                    textStyle: "sm",
                    px: "4",
                    gap: "2"
                }
            },
            md: {
                root: {
                    height: "10"
                },
                item: {
                    textStyle: "sm",
                    px: "4",
                    gap: "2"
                }
            },
            lg: {
                root: {
                    height: "10"
                },
                item: {
                    textStyle: "md",
                    px: "5",
                    gap: "3"
                }
            }
        }
    },
    defaultVariants: {
        size: "md"
    }
});





"use strict";
const $2ee578431620f840$export$d46f05a25a44100c = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    className: "chakra-slider",
    slots: (0, $9b7764ce1529e5da$export$c21b4b3f8b239f32).keys(),
    base: {
        root: {
            display: "flex",
            flexDirection: "column",
            gap: "1",
            textStyle: "sm",
            position: "relative",
            isolation: "isolate",
            touchAction: "none"
        },
        label: {
            fontWeight: "medium",
            textStyle: "sm"
        },
        control: {
            display: "inline-flex",
            alignItems: "center",
            position: "relative"
        },
        track: {
            overflow: "hidden",
            borderRadius: "full",
            flex: "1"
        },
        range: {
            width: "inherit",
            height: "inherit",
            _disabled: {
                bg: "border.emphasized!"
            }
        },
        markerGroup: {
            position: "absolute!",
            zIndex: "1"
        },
        marker: {
            "--marker-bg": {
                base: "white",
                _underValue: "colors.bg"
            },
            display: "flex",
            alignItems: "center",
            gap: "calc(var(--slider-thumb-size) / 2)",
            color: "fg.muted",
            textStyle: "xs"
        },
        markerIndicator: {
            width: "var(--slider-marker-size)",
            height: "var(--slider-marker-size)",
            borderRadius: "full",
            bg: "var(--marker-bg)"
        },
        thumb: {
            width: "var(--slider-thumb-size)",
            height: "var(--slider-thumb-size)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            outline: 0,
            zIndex: "2",
            borderRadius: "full",
            _focusVisible: {
                ring: "2px",
                ringColor: "colorPalette.focusRing",
                ringOffset: "2px",
                ringOffsetColor: "bg"
            }
        }
    },
    variants: {
        size: {
            sm: {
                root: {
                    "--slider-thumb-size": "sizes.4",
                    "--slider-track-size": "sizes.1.5",
                    "--slider-marker-center": "6px",
                    "--slider-marker-size": "sizes.1",
                    "--slider-marker-inset": "3px"
                }
            },
            md: {
                root: {
                    "--slider-thumb-size": "sizes.5",
                    "--slider-track-size": "sizes.2",
                    "--slider-marker-center": "8px",
                    "--slider-marker-size": "sizes.1",
                    "--slider-marker-inset": "4px"
                }
            },
            lg: {
                root: {
                    "--slider-thumb-size": "sizes.6",
                    "--slider-track-size": "sizes.2.5",
                    "--slider-marker-center": "9px",
                    "--slider-marker-size": "sizes.1.5",
                    "--slider-marker-inset": "5px"
                }
            }
        },
        variant: {
            outline: {
                track: {
                    shadow: "inset",
                    bg: "bg.emphasized/72"
                },
                range: {
                    bg: "colorPalette.solid"
                },
                thumb: {
                    borderWidth: "2px",
                    borderColor: "colorPalette.solid",
                    bg: "bg",
                    _disabled: {
                        bg: "border.emphasized",
                        borderColor: "border.emphasized"
                    }
                }
            },
            solid: {
                track: {
                    bg: "colorPalette.subtle",
                    _disabled: {
                        bg: "bg.muted"
                    }
                },
                range: {
                    bg: "colorPalette.solid"
                },
                thumb: {
                    bg: "colorPalette.solid",
                    _disabled: {
                        bg: "border.emphasized"
                    }
                }
            }
        },
        orientation: {
            vertical: {
                root: {
                    display: "inline-flex"
                },
                control: {
                    flexDirection: "column",
                    height: "100%",
                    minWidth: "var(--slider-thumb-size)",
                    "&[data-has-mark-label]": {
                        marginEnd: "4"
                    }
                },
                track: {
                    width: "var(--slider-track-size)"
                },
                thumb: {
                    left: "50%",
                    translate: "-50% 0"
                },
                markerGroup: {
                    insetStart: "var(--slider-marker-center)",
                    insetBlock: "var(--slider-marker-inset)"
                },
                marker: {
                    flexDirection: "row"
                }
            },
            horizontal: {
                control: {
                    flexDirection: "row",
                    width: "100%",
                    minHeight: "var(--slider-thumb-size)",
                    "&[data-has-mark-label]": {
                        marginBottom: "4"
                    }
                },
                track: {
                    height: "var(--slider-track-size)"
                },
                thumb: {
                    top: "50%",
                    translate: "0 -50%"
                },
                markerGroup: {
                    top: "var(--slider-marker-center)",
                    insetInline: "var(--slider-marker-inset)"
                },
                marker: {
                    flexDirection: "column"
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "outline",
        orientation: "horizontal"
    }
});




"use strict";
const $e13de866dd30e0ea$export$49c5be1bec04cd74 = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    className: "chakra-stat",
    slots: (0, $9b7764ce1529e5da$export$2cfbad67ae6ee421).keys(),
    base: {
        root: {
            display: "flex",
            flexDirection: "column",
            gap: "1",
            position: "relative",
            flex: "1"
        },
        label: {
            display: "inline-flex",
            gap: "1.5",
            alignItems: "center",
            color: "fg.muted",
            textStyle: "sm"
        },
        helpText: {
            color: "fg.muted",
            textStyle: "xs"
        },
        valueUnit: {
            color: "fg.muted",
            textStyle: "xs",
            fontWeight: "initial",
            letterSpacing: "initial"
        },
        valueText: {
            verticalAlign: "baseline",
            fontWeight: "semibold",
            letterSpacing: "tight",
            fontFeatureSettings: "pnum",
            fontVariantNumeric: "proportional-nums",
            display: "inline-flex",
            gap: "1"
        },
        indicator: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            marginEnd: 1,
            "& :where(svg)": {
                w: "1em",
                h: "1em"
            },
            "&[data-type=up]": {
                color: "fg.success"
            },
            "&[data-type=down]": {
                color: "fg.error"
            }
        }
    },
    variants: {
        size: {
            sm: {
                valueText: {
                    textStyle: "xl"
                }
            },
            md: {
                valueText: {
                    textStyle: "2xl"
                }
            },
            lg: {
                valueText: {
                    textStyle: "3xl"
                }
            }
        }
    },
    defaultVariants: {
        size: "md"
    }
});




"use strict";
const $5f021ed746d1cdcc$export$62ef19b4b5830661 = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    className: "chakra-status",
    slots: (0, $9b7764ce1529e5da$export$6b07965b0539a879).keys(),
    base: {
        root: {
            display: "inline-flex",
            alignItems: "center",
            gap: "2"
        },
        indicator: {
            width: "0.64em",
            height: "0.64em",
            flexShrink: 0,
            borderRadius: "full",
            forcedColorAdjust: "none",
            bg: "colorPalette.solid"
        }
    },
    variants: {
        size: {
            sm: {
                root: {
                    textStyle: "xs"
                }
            },
            md: {
                root: {
                    textStyle: "sm"
                }
            },
            lg: {
                root: {
                    textStyle: "md"
                }
            }
        }
    },
    defaultVariants: {
        size: "md"
    }
});




"use strict";
const $093d91af25a7b2ad$export$830e54a433c6be33 = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    className: "chakra-steps",
    slots: (0, $9b7764ce1529e5da$export$5c3acf63225011aa).keys(),
    base: {
        root: {
            display: "flex",
            width: "full"
        },
        list: {
            display: "flex",
            justifyContent: "space-between",
            "--steps-gutter": "spacing.3",
            "--steps-thickness": "2px"
        },
        title: {
            fontWeight: "medium",
            color: "fg"
        },
        description: {
            color: "fg.muted"
        },
        separator: {
            bg: "border",
            flex: "1"
        },
        indicator: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexShrink: "0",
            borderRadius: "full",
            fontWeight: "medium",
            width: "var(--steps-size)",
            height: "var(--steps-size)",
            _icon: {
                flexShrink: "0",
                width: "var(--steps-icon-size)",
                height: "var(--steps-icon-size)"
            }
        },
        item: {
            position: "relative",
            display: "flex",
            flex: "1 0 0",
            "&:last-of-type": {
                flex: "initial",
                "& [data-part=separator]": {
                    display: "none"
                }
            }
        },
        trigger: {
            display: "flex",
            alignItems: "center",
            gap: "3",
            textAlign: "start",
            focusVisibleRing: "outside",
            borderRadius: "l2"
        },
        content: {
            focusVisibleRing: "outside"
        }
    },
    variants: {
        orientation: {
            vertical: {
                root: {
                    flexDirection: "row",
                    height: "100%"
                },
                list: {
                    flexDirection: "column",
                    alignItems: "flex-start"
                },
                separator: {
                    position: "absolute",
                    width: "var(--steps-thickness)",
                    height: "100%",
                    maxHeight: "calc(100% - var(--steps-size) - var(--steps-gutter) * 2)",
                    top: "calc(var(--steps-size) + var(--steps-gutter))",
                    insetStart: "calc(var(--steps-size) / 2 - 1px)"
                },
                item: {
                    alignItems: "flex-start"
                }
            },
            horizontal: {
                root: {
                    flexDirection: "column",
                    width: "100%"
                },
                list: {
                    flexDirection: "row",
                    alignItems: "center"
                },
                separator: {
                    width: "100%",
                    height: "var(--steps-thickness)",
                    marginX: "var(--steps-gutter)"
                },
                item: {
                    alignItems: "center"
                }
            }
        },
        variant: {
            solid: {
                indicator: {
                    _incomplete: {
                        borderWidth: "var(--steps-thickness)"
                    },
                    _current: {
                        bg: "colorPalette.muted",
                        borderWidth: "var(--steps-thickness)",
                        borderColor: "colorPalette.solid",
                        color: "colorPalette.fg"
                    },
                    _complete: {
                        bg: "colorPalette.solid",
                        borderColor: "colorPalette.solid",
                        color: "colorPalette.contrast"
                    }
                },
                separator: {
                    _complete: {
                        bg: "colorPalette.solid"
                    }
                }
            },
            subtle: {
                indicator: {
                    _incomplete: {
                        bg: "bg.muted"
                    },
                    _current: {
                        bg: "colorPalette.muted",
                        color: "colorPalette.fg"
                    },
                    _complete: {
                        bg: "colorPalette.emphasized",
                        color: "colorPalette.fg"
                    }
                },
                separator: {
                    _complete: {
                        bg: "colorPalette.emphasized"
                    }
                }
            }
        },
        size: {
            xs: {
                root: {
                    gap: "2.5"
                },
                list: {
                    "--steps-size": "sizes.6",
                    "--steps-icon-size": "sizes.3.5",
                    textStyle: "xs"
                },
                title: {
                    textStyle: "sm"
                }
            },
            sm: {
                root: {
                    gap: "3"
                },
                list: {
                    "--steps-size": "sizes.8",
                    "--steps-icon-size": "sizes.4",
                    textStyle: "xs"
                },
                title: {
                    textStyle: "sm"
                }
            },
            md: {
                root: {
                    gap: "4"
                },
                list: {
                    "--steps-size": "sizes.10",
                    "--steps-icon-size": "sizes.4",
                    textStyle: "sm"
                },
                title: {
                    textStyle: "sm"
                }
            },
            lg: {
                root: {
                    gap: "6"
                },
                list: {
                    "--steps-size": "sizes.11",
                    "--steps-icon-size": "sizes.5",
                    textStyle: "md"
                },
                title: {
                    textStyle: "md"
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "solid",
        orientation: "horizontal"
    }
});




"use strict";
const $bbf720331f42c134$export$daa01504810a732d = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    slots: (0, $9b7764ce1529e5da$export$921c1a2d1ce1e86a).keys(),
    className: "chakra-switch",
    base: {
        root: {
            display: "inline-flex",
            gap: "2.5",
            alignItems: "center",
            position: "relative",
            verticalAlign: "middle",
            "--switch-diff": "calc(var(--switch-width) - var(--switch-height))",
            "--switch-x": {
                base: "var(--switch-diff)",
                _rtl: "calc(var(--switch-diff) * -1)"
            }
        },
        label: {
            lineHeight: "1",
            userSelect: "none",
            fontSize: "sm",
            fontWeight: "medium",
            _disabled: {
                opacity: "0.5"
            }
        },
        indicator: {
            position: "absolute",
            height: "var(--switch-height)",
            width: "var(--switch-height)",
            fontSize: "var(--switch-indicator-font-size)",
            fontWeight: "medium",
            flexShrink: 0,
            userSelect: "none",
            display: "grid",
            placeContent: "center",
            transition: "inset-inline-start 0.12s ease",
            insetInlineStart: "calc(var(--switch-x) - 2px)",
            _checked: {
                insetInlineStart: "2px"
            }
        },
        control: {
            display: "inline-flex",
            gap: "0.5rem",
            flexShrink: 0,
            justifyContent: "flex-start",
            cursor: "switch",
            borderRadius: "full",
            position: "relative",
            width: "var(--switch-width)",
            height: "var(--switch-height)",
            _disabled: {
                opacity: "0.5",
                cursor: "not-allowed"
            },
            _invalid: {
                outline: "2px solid",
                outlineColor: "border.error",
                outlineOffset: "2px"
            }
        },
        thumb: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            transitionProperty: "translate",
            transitionDuration: "fast",
            borderRadius: "inherit",
            _checked: {
                translate: "var(--switch-x) 0"
            }
        }
    },
    variants: {
        variant: {
            solid: {
                control: {
                    borderRadius: "full",
                    bg: "bg.emphasized",
                    focusVisibleRing: "outside",
                    _checked: {
                        bg: "colorPalette.solid"
                    }
                },
                thumb: {
                    bg: "white",
                    width: "var(--switch-height)",
                    height: "var(--switch-height)",
                    scale: "0.8",
                    boxShadow: "sm",
                    _checked: {
                        bg: "colorPalette.contrast"
                    }
                }
            },
            raised: {
                control: {
                    borderRadius: "full",
                    height: "calc(var(--switch-height) / 2)",
                    bg: "bg.muted",
                    boxShadow: "inset",
                    _checked: {
                        bg: "colorPalette.solid/60"
                    }
                },
                thumb: {
                    width: "var(--switch-height)",
                    height: "var(--switch-height)",
                    position: "relative",
                    top: "calc(var(--switch-height) * -0.25)",
                    bg: "white",
                    boxShadow: "xs",
                    focusVisibleRing: "outside",
                    _checked: {
                        bg: "colorPalette.solid"
                    }
                }
            }
        },
        size: {
            xs: {
                root: {
                    "--switch-width": "sizes.6",
                    "--switch-height": "sizes.3",
                    "--switch-indicator-font-size": "fontSizes.xs"
                }
            },
            sm: {
                root: {
                    "--switch-width": "sizes.8",
                    "--switch-height": "sizes.4",
                    "--switch-indicator-font-size": "fontSizes.xs"
                }
            },
            md: {
                root: {
                    "--switch-width": "sizes.10",
                    "--switch-height": "sizes.5",
                    "--switch-indicator-font-size": "fontSizes.sm"
                }
            },
            lg: {
                root: {
                    "--switch-width": "sizes.12",
                    "--switch-height": "sizes.6",
                    "--switch-indicator-font-size": "fontSizes.md"
                }
            }
        }
    },
    defaultVariants: {
        variant: "solid",
        size: "md"
    }
});




"use strict";
const $8713989e43c14595$export$5281e08caf496f42 = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    className: "chakra-table",
    slots: (0, $9b7764ce1529e5da$export$8b1b9cdd5db9f5fd).keys(),
    base: {
        root: {
            fontVariantNumeric: "lining-nums tabular-nums",
            borderCollapse: "collapse",
            width: "full",
            textAlign: "start",
            verticalAlign: "top"
        },
        row: {
            _selected: {
                bg: "colorPalette.subtle"
            }
        },
        cell: {
            textAlign: "start",
            alignItems: "center"
        },
        columnHeader: {
            fontWeight: "medium",
            textAlign: "start",
            color: "fg"
        },
        caption: {
            fontWeight: "medium",
            textStyle: "xs"
        },
        footer: {
            fontWeight: "medium"
        }
    },
    variants: {
        interactive: {
            true: {
                body: {
                    "& tr": {
                        _hover: {
                            bg: "colorPalette.subtle"
                        }
                    }
                }
            }
        },
        stickyHeader: {
            true: {
                header: {
                    "& :where(tr)": {
                        top: "var(--table-sticky-offset, 0)",
                        position: "sticky",
                        zIndex: 1
                    }
                }
            }
        },
        striped: {
            true: {
                row: {
                    "&:nth-of-type(odd) td": {
                        bg: "bg.muted"
                    }
                }
            }
        },
        showColumnBorder: {
            true: {
                columnHeader: {
                    "&:not(:last-of-type)": {
                        borderInlineEndWidth: "1px"
                    }
                },
                cell: {
                    "&:not(:last-of-type)": {
                        borderInlineEndWidth: "1px"
                    }
                }
            }
        },
        variant: {
            line: {
                columnHeader: {
                    borderBottomWidth: "1px"
                },
                cell: {
                    borderBottomWidth: "1px"
                },
                row: {
                    bg: "bg"
                }
            },
            outline: {
                root: {
                    boxShadow: "0 0 0 1px {colors.border}",
                    overflow: "hidden"
                },
                columnHeader: {
                    borderBottomWidth: "1px"
                },
                header: {
                    bg: "bg.muted"
                },
                row: {
                    "&:not(:last-of-type)": {
                        borderBottomWidth: "1px"
                    }
                },
                footer: {
                    borderTopWidth: "1px"
                }
            }
        },
        size: {
            sm: {
                root: {
                    textStyle: "sm"
                },
                columnHeader: {
                    px: "2",
                    py: "2"
                },
                cell: {
                    px: "2",
                    py: "2"
                }
            },
            md: {
                root: {
                    textStyle: "sm"
                },
                columnHeader: {
                    px: "3",
                    py: "3"
                },
                cell: {
                    px: "3",
                    py: "3"
                }
            },
            lg: {
                root: {
                    textStyle: "md"
                },
                columnHeader: {
                    px: "4",
                    py: "3"
                },
                cell: {
                    px: "4",
                    py: "3"
                }
            }
        }
    },
    defaultVariants: {
        variant: "line",
        size: "md"
    }
});




"use strict";
const $eb8c80750cfbc560$export$e5eae33afdf5ce13 = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    slots: (0, $9b7764ce1529e5da$export$97383552563be58d).keys(),
    className: "chakra-tabs",
    base: {
        root: {
            "--tabs-trigger-radius": "radii.l2",
            position: "relative",
            _horizontal: {
                display: "block"
            },
            _vertical: {
                display: "flex"
            }
        },
        list: {
            display: "inline-flex",
            position: "relative",
            isolation: "isolate",
            "--tabs-indicator-shadow": "shadows.xs",
            "--tabs-indicator-bg": "colors.bg",
            minH: "var(--tabs-height)",
            _horizontal: {
                flexDirection: "row"
            },
            _vertical: {
                flexDirection: "column"
            }
        },
        trigger: {
            outline: "0",
            minW: "var(--tabs-height)",
            height: "var(--tabs-height)",
            display: "flex",
            alignItems: "center",
            fontWeight: "medium",
            position: "relative",
            cursor: "button",
            gap: "2",
            _focusVisible: {
                zIndex: 1,
                outline: "2px solid",
                outlineColor: "colorPalette.focusRing"
            },
            _disabled: {
                cursor: "not-allowed",
                opacity: 0.5
            }
        },
        content: {
            focusVisibleRing: "inside",
            _horizontal: {
                width: "100%",
                pt: "var(--tabs-content-padding)"
            },
            _vertical: {
                height: "100%",
                ps: "var(--tabs-content-padding)"
            }
        },
        indicator: {
            width: "var(--width)",
            height: "var(--height)",
            borderRadius: "var(--tabs-indicator-radius)",
            bg: "var(--tabs-indicator-bg)",
            shadow: "var(--tabs-indicator-shadow)",
            zIndex: -1
        }
    },
    variants: {
        fitted: {
            true: {
                list: {
                    display: "flex"
                },
                trigger: {
                    flex: 1,
                    textAlign: "center",
                    justifyContent: "center"
                }
            }
        },
        justify: {
            start: {
                list: {
                    justifyContent: "flex-start"
                }
            },
            center: {
                list: {
                    justifyContent: "center"
                }
            },
            end: {
                list: {
                    justifyContent: "flex-end"
                }
            }
        },
        size: {
            sm: {
                root: {
                    "--tabs-height": "sizes.9",
                    "--tabs-content-padding": "spacing.3"
                },
                trigger: {
                    py: "1",
                    px: "3",
                    textStyle: "sm"
                }
            },
            md: {
                root: {
                    "--tabs-height": "sizes.10",
                    "--tabs-content-padding": "spacing.4"
                },
                trigger: {
                    py: "2",
                    px: "4",
                    textStyle: "sm"
                }
            },
            lg: {
                root: {
                    "--tabs-height": "sizes.11",
                    "--tabs-content-padding": "spacing.4.5"
                },
                trigger: {
                    py: "2",
                    px: "4.5",
                    textStyle: "md"
                }
            }
        },
        variant: {
            line: {
                list: {
                    display: "flex",
                    borderColor: "border",
                    _horizontal: {
                        borderBottomWidth: "1px"
                    },
                    _vertical: {
                        borderEndWidth: "1px"
                    }
                },
                trigger: {
                    color: "fg.muted",
                    _disabled: {
                        _active: {
                            bg: "initial"
                        }
                    },
                    _selected: {
                        color: "fg",
                        _horizontal: {
                            layerStyle: "indicator.bottom",
                            "--indicator-offset-y": "-1px",
                            "--indicator-color": "colors.colorPalette.solid"
                        },
                        _vertical: {
                            layerStyle: "indicator.end",
                            "--indicator-offset-x": "-1px"
                        }
                    }
                }
            },
            subtle: {
                trigger: {
                    borderRadius: "var(--tabs-trigger-radius)",
                    color: "fg.muted",
                    _selected: {
                        bg: "colorPalette.subtle",
                        color: "colorPalette.fg"
                    }
                }
            },
            enclosed: {
                list: {
                    bg: "bg.muted",
                    padding: "1",
                    borderRadius: "l3",
                    minH: "calc(var(--tabs-height) - 4px)"
                },
                trigger: {
                    justifyContent: "center",
                    color: "fg.muted",
                    borderRadius: "var(--tabs-trigger-radius)",
                    _selected: {
                        bg: "bg",
                        color: "colorPalette.fg",
                        shadow: "xs"
                    }
                }
            },
            outline: {
                list: {
                    "--line-thickness": "1px",
                    "--line-offset": "calc(var(--line-thickness) * -1)",
                    borderColor: "border",
                    display: "flex",
                    _horizontal: {
                        _before: {
                            content: '""',
                            position: "absolute",
                            bottom: "0px",
                            width: "100%",
                            borderBottomWidth: "var(--line-thickness)",
                            borderBottomColor: "border"
                        }
                    },
                    _vertical: {
                        _before: {
                            content: '""',
                            position: "absolute",
                            insetInline: "var(--line-offset)",
                            height: "calc(100% - calc(var(--line-thickness) * 2))",
                            borderEndWidth: "var(--line-thickness)",
                            borderEndColor: "border"
                        }
                    }
                },
                trigger: {
                    color: "fg.muted",
                    borderWidth: "1px",
                    borderColor: "transparent",
                    _selected: {
                        bg: "currentBg",
                        color: "colorPalette.fg"
                    },
                    _horizontal: {
                        borderTopRadius: "var(--tabs-trigger-radius)",
                        marginBottom: "var(--line-offset)",
                        marginEnd: {
                            _notLast: "var(--line-offset)"
                        },
                        _selected: {
                            borderColor: "border",
                            borderBottomColor: "transparent"
                        }
                    },
                    _vertical: {
                        borderStartRadius: "var(--tabs-trigger-radius)",
                        marginEnd: "var(--line-offset)",
                        marginBottom: {
                            _notLast: "var(--line-offset)"
                        },
                        _selected: {
                            borderColor: "border",
                            borderEndColor: "transparent"
                        }
                    }
                }
            },
            plain: {
                trigger: {
                    color: "fg.muted",
                    _selected: {
                        color: "colorPalette.fg"
                    },
                    borderRadius: "var(--tabs-trigger-radius)",
                    "&[data-selected][data-ssr]": {
                        bg: "var(--tabs-indicator-bg)",
                        shadow: "var(--tabs-indicator-shadow)",
                        borderRadius: "var(--tabs-indicator-radius)"
                    }
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "line"
    }
});





"use strict";
const $3782c51f24378bd0$var$badgeVariant = (0, $bbc9778f5da0d591$export$251a0a63b19d28c5).variants?.variant;
const $3782c51f24378bd0$export$393c38caed566ad7 = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    slots: (0, $9b7764ce1529e5da$export$4c2f5f7f2ea94a8e).keys(),
    className: "chakra-tag",
    base: {
        root: {
            display: "inline-flex",
            alignItems: "center",
            verticalAlign: "top",
            maxWidth: "100%",
            userSelect: "none",
            borderRadius: "l2",
            focusVisibleRing: "outside"
        },
        label: {
            lineClamp: "1"
        },
        closeTrigger: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            outline: "0",
            borderRadius: "l1",
            color: "currentColor",
            focusVisibleRing: "inside",
            focusRingWidth: "2px"
        },
        startElement: {
            flexShrink: 0,
            boxSize: "var(--tag-element-size)",
            ms: "var(--tag-element-offset)",
            "&:has([data-scope=avatar])": {
                boxSize: "var(--tag-avatar-size)",
                ms: "calc(var(--tag-element-offset) * 1.5)"
            },
            _icon: {
                boxSize: "100%"
            }
        },
        endElement: {
            flexShrink: 0,
            boxSize: "var(--tag-element-size)",
            me: "var(--tag-element-offset)",
            _icon: {
                boxSize: "100%"
            },
            "&:has(button)": {
                ms: "calc(var(--tag-element-offset) * -1)"
            }
        }
    },
    variants: {
        size: {
            sm: {
                root: {
                    px: "1.5",
                    minH: "4.5",
                    gap: "1",
                    "--tag-avatar-size": "spacing.3",
                    "--tag-element-size": "spacing.3",
                    "--tag-element-offset": "-2px"
                },
                label: {
                    textStyle: "xs"
                }
            },
            md: {
                root: {
                    px: "1.5",
                    minH: "5",
                    gap: "1",
                    "--tag-avatar-size": "spacing.3.5",
                    "--tag-element-size": "spacing.3.5",
                    "--tag-element-offset": "-2px"
                },
                label: {
                    textStyle: "xs"
                }
            },
            lg: {
                root: {
                    px: "2",
                    minH: "6",
                    gap: "1.5",
                    "--tag-avatar-size": "spacing.4.5",
                    "--tag-element-size": "spacing.4",
                    "--tag-element-offset": "-3px"
                },
                label: {
                    textStyle: "sm"
                }
            },
            xl: {
                root: {
                    px: "2.5",
                    minH: "8",
                    gap: "1.5",
                    "--tag-avatar-size": "spacing.6",
                    "--tag-element-size": "spacing.4.5",
                    "--tag-element-offset": "-4px"
                },
                label: {
                    textStyle: "sm"
                }
            }
        },
        variant: {
            subtle: {
                root: $3782c51f24378bd0$var$badgeVariant?.subtle
            },
            solid: {
                root: $3782c51f24378bd0$var$badgeVariant?.solid
            },
            outline: {
                root: $3782c51f24378bd0$var$badgeVariant?.outline
            },
            surface: {
                root: $3782c51f24378bd0$var$badgeVariant?.surface
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "surface"
    }
});




"use strict";
const $ac3f2bebd39cab17$export$f0ba3c1ebe09d322 = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    slots: (0, $9b7764ce1529e5da$export$174cdbdedca11ecf).keys(),
    className: "chakra-timeline",
    base: {
        root: {
            display: "flex",
            flexDirection: "column",
            width: "full",
            "--timeline-thickness": "1px",
            "--timeline-gutter": "4px"
        },
        item: {
            display: "flex",
            position: "relative",
            alignItems: "flex-start",
            flexShrink: 0,
            gap: "4",
            _last: {
                "& :where(.chakra-timeline__separator)": {
                    display: "none"
                }
            }
        },
        separator: {
            position: "absolute",
            borderStartWidth: "var(--timeline-thickness)",
            ms: "calc(-1 * var(--timeline-thickness) / 2)",
            insetInlineStart: "calc(var(--timeline-indicator-size) / 2)",
            insetBlock: "0",
            borderColor: "border"
        },
        indicator: {
            outline: "2px solid {colors.bg}",
            position: "relative",
            flexShrink: "0",
            boxSize: "var(--timeline-indicator-size)",
            fontSize: "var(--timeline-font-size)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "full",
            fontWeight: "medium"
        },
        connector: {
            alignSelf: "stretch",
            position: "relative"
        },
        content: {
            pb: "6",
            display: "flex",
            flexDirection: "column",
            width: "full",
            gap: "2"
        },
        title: {
            display: "flex",
            fontWeight: "medium",
            flexWrap: "wrap",
            gap: "1.5",
            alignItems: "center",
            mt: "var(--timeline-margin)"
        },
        description: {
            color: "fg.muted",
            textStyle: "xs"
        }
    },
    variants: {
        variant: {
            subtle: {
                indicator: {
                    bg: "colorPalette.muted"
                }
            },
            solid: {
                indicator: {
                    bg: "colorPalette.solid",
                    color: "colorPalette.contrast"
                }
            },
            outline: {
                indicator: {
                    bg: "currentBg",
                    borderWidth: "1px",
                    borderColor: "colorPalette.muted"
                }
            },
            plain: {}
        },
        size: {
            sm: {
                root: {
                    "--timeline-indicator-size": "sizes.4",
                    "--timeline-font-size": "fontSizes.2xs"
                },
                title: {
                    textStyle: "xs"
                }
            },
            md: {
                root: {
                    "--timeline-indicator-size": "sizes.5",
                    "--timeline-font-size": "fontSizes.xs"
                },
                title: {
                    textStyle: "sm"
                }
            },
            lg: {
                root: {
                    "--timeline-indicator-size": "sizes.6",
                    "--timeline-font-size": "fontSizes.xs"
                },
                title: {
                    mt: "0.5",
                    textStyle: "sm"
                }
            },
            xl: {
                root: {
                    "--timeline-indicator-size": "sizes.8",
                    "--timeline-font-size": "fontSizes.sm"
                },
                title: {
                    mt: "1.5",
                    textStyle: "sm"
                }
            }
        }
    },
    defaultVariants: {
        size: "md",
        variant: "solid"
    }
});




"use strict";
const $37f45b1c97571345$export$a32d889916d34b1f = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    slots: (0, $9b7764ce1529e5da$export$c220e6c275daf119).keys(),
    className: "chakra-toast",
    base: {
        root: {
            width: "full",
            display: "flex",
            alignItems: "flex-start",
            position: "relative",
            gap: "3",
            py: "4",
            ps: "4",
            pe: "6",
            borderRadius: "l2",
            translate: "var(--x) var(--y)",
            scale: "var(--scale)",
            zIndex: "var(--z-index)",
            height: "var(--height)",
            opacity: "var(--opacity)",
            willChange: "translate, opacity, scale",
            transition: "translate 400ms, scale 400ms, opacity 400ms, height 400ms, box-shadow 200ms",
            transitionTimingFunction: "cubic-bezier(0.21, 1.02, 0.73, 1)",
            _closed: {
                transition: "translate 400ms, scale 400ms, opacity 200ms",
                transitionTimingFunction: "cubic-bezier(0.06, 0.71, 0.55, 1)"
            },
            bg: "bg.panel",
            color: "fg",
            boxShadow: "xl",
            "--toast-trigger-bg": "colors.bg.muted",
            "&[data-type=warning]": {
                bg: "orange.solid",
                color: "orange.contrast",
                "--toast-trigger-bg": "{white/10}",
                "--toast-border-color": "{white/40}"
            },
            "&[data-type=success]": {
                bg: "green.solid",
                color: "green.contrast",
                "--toast-trigger-bg": "{white/10}",
                "--toast-border-color": "{white/40}"
            },
            "&[data-type=error]": {
                bg: "red.solid",
                color: "red.contrast",
                "--toast-trigger-bg": "{white/10}",
                "--toast-border-color": "{white/40}"
            }
        },
        title: {
            fontWeight: "medium",
            textStyle: "sm",
            marginEnd: "2"
        },
        description: {
            display: "inline",
            textStyle: "sm",
            opacity: "0.8"
        },
        indicator: {
            flexShrink: "0",
            boxSize: "5"
        },
        actionTrigger: {
            textStyle: "sm",
            fontWeight: "medium",
            height: "8",
            px: "3",
            borderRadius: "l2",
            alignSelf: "center",
            borderWidth: "1px",
            borderColor: "var(--toast-border-color, inherit)",
            transition: "background 200ms",
            _hover: {
                bg: "var(--toast-trigger-bg)"
            }
        },
        closeTrigger: {
            position: "absolute",
            top: "1",
            insetEnd: "1",
            padding: "1",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            color: "{currentColor/60}",
            borderRadius: "l2",
            textStyle: "md",
            transition: "background 200ms",
            _icon: {
                boxSize: "1em"
            }
        }
    }
});




"use strict";
const $0435cccc61f4310a$export$a5b861b2913e76b1 = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    slots: (0, $aa59da5a8c9775bf$export$477202748c7242bf).keys(),
    className: "chakra-tooltip",
    base: {
        content: {
            "--tooltip-bg": "colors.bg.inverted",
            bg: "var(--tooltip-bg)",
            color: "fg.inverted",
            px: "2.5",
            py: "1",
            borderRadius: "l2",
            fontWeight: "medium",
            textStyle: "xs",
            boxShadow: "md",
            maxW: "xs",
            zIndex: "tooltip",
            transformOrigin: "var(--transform-origin)",
            _open: {
                animationStyle: "scale-fade-in",
                animationDuration: "fast"
            },
            _closed: {
                animationStyle: "scale-fade-out",
                animationDuration: "fast"
            }
        },
        arrow: {
            "--arrow-size": "sizes.2",
            "--arrow-background": "var(--tooltip-bg)"
        },
        arrowTip: {
            borderTopWidth: "1px",
            borderInlineStartWidth: "1px",
            borderColor: "var(--tooltip-bg)"
        }
    }
});


"use strict";
const $5ddea6fbf9393ed0$export$5a51f768ceeb5eb3 = {
    accordion: (0, $e8750b399fdcd1d6$export$f4a442eb58b0fd05),
    actionBar: (0, $8a86a91c46871bba$export$fa2b273b16ba8691),
    alert: (0, $090963649c47e7b1$export$998588db5c35d89f),
    avatar: (0, $45fd1dd2da84c020$export$3abc6b3f791f1dd4),
    blockquote: (0, $dd4749d5e77707a5$export$8b1f9367c4597998),
    breadcrumb: (0, $464bc7fd799ca00e$export$445bd218bcf49ac8),
    card: (0, $0e5d0e8a57447c08$export$e4092ce1781694ee),
    checkbox: (0, $be4db9b9eceaefc4$export$85054d78118eabd7),
    checkboxCard: (0, $7eab2d6def0821ca$export$7450efef80368c09),
    collapsible: (0, $fbb03d03218a1ba7$export$e9d5652bed1138b),
    dataList: (0, $3a08a1b5461b08fc$export$8a8fa4faf7e5d248),
    dialog: (0, $65556a547bce7f35$export$ffb2f7e6a3d6561c),
    drawer: (0, $b64ab7162012d2f9$export$da2da8d2e5cdf76b),
    editable: (0, $717ffabf83a36dad$export$e1e8b391e6213091),
    emptyState: (0, $4dce04b04ece4098$export$93a945b6c6bfa0fe),
    field: (0, $b89acf6a6aeac59f$export$9044d569b4a94288),
    fieldset: (0, $0fe7d45769f81093$export$31b1fb468e8ba73),
    fileUpload: (0, $0b9c8f83ec07724b$export$bd84411a7156c13a),
    hoverCard: (0, $fd067fafc3133b2a$export$2d0f90af978875ab),
    list: (0, $c8ea3ccfe33f36d3$export$d6effa609ff73c80),
    menu: (0, $ee5da4f93aebd01b$export$51b7bcd215c1d4ed),
    nativeSelect: (0, $84885f741037b150$export$bd566e82fcc568be),
    numberInput: (0, $c5bf017c697a33c4$export$a4772ecb6b3bbf82),
    pinInput: (0, $88ded7672394e2b0$export$6ac4344d3861b231),
    popover: (0, $c2c1d50c86fe32ba$export$d45077169de7cc48),
    progress: (0, $91e24d4280588615$export$9f977c65a046b227),
    progressCircle: (0, $bc4d98668d3dadba$export$bf55419709f49d86),
    radioCard: (0, $42e3e9f4c9c6016b$export$ba1bd7ba2c203b42),
    radioGroup: (0, $80b278dc05e14427$export$f22f9c9e9c78d451),
    ratingGroup: (0, $08e6bd453f1b48cf$export$bd71218a24c0f454),
    segmentGroup: (0, $85e19c13bff93e48$export$7b9ca3573b9e7a3e),
    select: (0, $9563cc14b192a234$export$a17a1e7a6654f699),
    slider: (0, $2ee578431620f840$export$d46f05a25a44100c),
    stat: (0, $e13de866dd30e0ea$export$49c5be1bec04cd74),
    steps: (0, $093d91af25a7b2ad$export$830e54a433c6be33),
    switch: (0, $bbf720331f42c134$export$daa01504810a732d),
    table: (0, $8713989e43c14595$export$5281e08caf496f42),
    tabs: (0, $eb8c80750cfbc560$export$e5eae33afdf5ce13),
    tag: (0, $3782c51f24378bd0$export$393c38caed566ad7),
    toast: (0, $37f45b1c97571345$export$a32d889916d34b1f),
    tooltip: (0, $0435cccc61f4310a$export$a5b861b2913e76b1),
    status: (0, $5f021ed746d1cdcc$export$62ef19b4b5830661),
    timeline: (0, $ac3f2bebd39cab17$export$f0ba3c1ebe09d322),
    colorPicker: (0, $fd3111db65af1811$export$e0aacfa04a4a59f3),
    qrCode: (0, $e9ef641b90330e09$export$8ac26324cd542d34)
};



"use strict";
const $e6f48c027c842acd$export$6a54c24d15b0f6ba = (0, $ee2de6f250f65b79$export$4e5d103345f1ef38)({
    "2xs": {
        value: {
            fontSize: "2xs",
            lineHeight: "0.75rem"
        }
    },
    xs: {
        value: {
            fontSize: "xs",
            lineHeight: "1rem"
        }
    },
    sm: {
        value: {
            fontSize: "sm",
            lineHeight: "1.25rem"
        }
    },
    md: {
        value: {
            fontSize: "md",
            lineHeight: "1.5rem"
        }
    },
    lg: {
        value: {
            fontSize: "lg",
            lineHeight: "1.75rem"
        }
    },
    xl: {
        value: {
            fontSize: "xl",
            lineHeight: "1.875rem"
        }
    },
    "2xl": {
        value: {
            fontSize: "2xl",
            lineHeight: "2rem"
        }
    },
    "3xl": {
        value: {
            fontSize: "3xl",
            lineHeight: "2.375rem"
        }
    },
    "4xl": {
        value: {
            fontSize: "4xl",
            lineHeight: "2.75rem",
            letterSpacing: "-0.025em"
        }
    },
    "5xl": {
        value: {
            fontSize: "5xl",
            lineHeight: "3.75rem",
            letterSpacing: "-0.025em"
        }
    },
    "6xl": {
        value: {
            fontSize: "6xl",
            lineHeight: "4.5rem",
            letterSpacing: "-0.025em"
        }
    },
    "7xl": {
        value: {
            fontSize: "7xl",
            lineHeight: "5.75rem",
            letterSpacing: "-0.025em"
        }
    },
    none: {
        value: {}
    }
});



"use strict";
const $43eed95b8269eddb$export$7f9953c70dacfd7f = (0, $ee2de6f250f65b79$export$8e135e7aaa7aabf6).animations({
    spin: {
        value: "spin 1s linear infinite"
    },
    ping: {
        value: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite"
    },
    pulse: {
        value: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite"
    },
    bounce: {
        value: "bounce 1s infinite"
    }
});



"use strict";
const $5786f907b7c2301a$export$d81ee2a7bf2dffaa = (0, $ee2de6f250f65b79$export$8e135e7aaa7aabf6).aspectRatios({
    square: {
        value: "1 / 1"
    },
    landscape: {
        value: "4 / 3"
    },
    portrait: {
        value: "3 / 4"
    },
    wide: {
        value: "16 / 9"
    },
    ultrawide: {
        value: "18 / 5"
    },
    golden: {
        value: "1.618 / 1"
    }
});



"use strict";
const $a8404cf802427cdc$export$a86789f140d190e2 = (0, $ee2de6f250f65b79$export$8e135e7aaa7aabf6).blurs({
    none: {
        value: " "
    },
    sm: {
        value: "4px"
    },
    md: {
        value: "8px"
    },
    lg: {
        value: "12px"
    },
    xl: {
        value: "16px"
    },
    "2xl": {
        value: "24px"
    },
    "3xl": {
        value: "40px"
    },
    "4xl": {
        value: "64px"
    }
});



"use strict";
const $34e128a01e88b03b$export$5a5da632d18030b0 = (0, $ee2de6f250f65b79$export$8e135e7aaa7aabf6).borders({
    xs: {
        value: "0.5px solid"
    },
    sm: {
        value: "1px solid"
    },
    md: {
        value: "2px solid"
    },
    lg: {
        value: "4px solid"
    },
    xl: {
        value: "8px solid"
    }
});



"use strict";
const $20970d7ce8b3b5ae$export$8f45430ccf837300 = (0, $ee2de6f250f65b79$export$8e135e7aaa7aabf6).colors({
    transparent: {
        value: "transparent"
    },
    current: {
        value: "currentColor"
    },
    black: {
        value: "#09090B"
    },
    white: {
        value: "#FFFFFF"
    },
    whiteAlpha: {
        50: {
            value: "rgba(255, 255, 255, 0.04)"
        },
        100: {
            value: "rgba(255, 255, 255, 0.06)"
        },
        200: {
            value: "rgba(255, 255, 255, 0.08)"
        },
        300: {
            value: "rgba(255, 255, 255, 0.16)"
        },
        400: {
            value: "rgba(255, 255, 255, 0.24)"
        },
        500: {
            value: "rgba(255, 255, 255, 0.36)"
        },
        600: {
            value: "rgba(255, 255, 255, 0.48)"
        },
        700: {
            value: "rgba(255, 255, 255, 0.64)"
        },
        800: {
            value: "rgba(255, 255, 255, 0.80)"
        },
        900: {
            value: "rgba(255, 255, 255, 0.92)"
        },
        950: {
            value: "rgba(255, 255, 255, 0.95)"
        }
    },
    blackAlpha: {
        50: {
            value: "rgba(0, 0, 0, 0.04)"
        },
        100: {
            value: "rgba(0, 0, 0, 0.06)"
        },
        200: {
            value: "rgba(0, 0, 0, 0.08)"
        },
        300: {
            value: "rgba(0, 0, 0, 0.16)"
        },
        400: {
            value: "rgba(0, 0, 0, 0.24)"
        },
        500: {
            value: "rgba(0, 0, 0, 0.36)"
        },
        600: {
            value: "rgba(0, 0, 0, 0.48)"
        },
        700: {
            value: "rgba(0, 0, 0, 0.64)"
        },
        800: {
            value: "rgba(0, 0, 0, 0.80)"
        },
        900: {
            value: "rgba(0, 0, 0, 0.92)"
        },
        950: {
            value: "rgba(0, 0, 0, 0.95)"
        }
    },
    gray: {
        50: {
            value: "#fafafa"
        },
        100: {
            value: "#f4f4f5"
        },
        200: {
            value: "#e4e4e7"
        },
        300: {
            value: "#d4d4d8"
        },
        400: {
            value: "#a1a1aa"
        },
        500: {
            value: "#71717a"
        },
        600: {
            value: "#52525b"
        },
        700: {
            value: "#3f3f46"
        },
        800: {
            value: "#27272a"
        },
        900: {
            value: "#18181b"
        },
        950: {
            value: "#111111"
        }
    },
    red: {
        50: {
            value: "#fef2f2"
        },
        100: {
            value: "#fee2e2"
        },
        200: {
            value: "#fecaca"
        },
        300: {
            value: "#fca5a5"
        },
        400: {
            value: "#f87171"
        },
        500: {
            value: "#ef4444"
        },
        600: {
            value: "#dc2626"
        },
        700: {
            value: "#991919"
        },
        800: {
            value: "#511111"
        },
        900: {
            value: "#300c0c"
        },
        950: {
            value: "#1f0808"
        }
    },
    orange: {
        50: {
            value: "#fff7ed"
        },
        100: {
            value: "#ffedd5"
        },
        200: {
            value: "#fed7aa"
        },
        300: {
            value: "#fdba74"
        },
        400: {
            value: "#fb923c"
        },
        500: {
            value: "#f97316"
        },
        600: {
            value: "#ea580c"
        },
        700: {
            value: "#92310a"
        },
        800: {
            value: "#6c2710"
        },
        900: {
            value: "#3b1106"
        },
        950: {
            value: "#220a04"
        }
    },
    yellow: {
        50: {
            value: "#fefce8"
        },
        100: {
            value: "#fef9c3"
        },
        200: {
            value: "#fef08a"
        },
        300: {
            value: "#fde047"
        },
        400: {
            value: "#facc15"
        },
        500: {
            value: "#eab308"
        },
        600: {
            value: "#ca8a04"
        },
        700: {
            value: "#845209"
        },
        800: {
            value: "#713f12"
        },
        900: {
            value: "#422006"
        },
        950: {
            value: "#281304"
        }
    },
    green: {
        50: {
            value: "#f0fdf4"
        },
        100: {
            value: "#dcfce7"
        },
        200: {
            value: "#bbf7d0"
        },
        300: {
            value: "#86efac"
        },
        400: {
            value: "#4ade80"
        },
        500: {
            value: "#22c55e"
        },
        600: {
            value: "#16a34a"
        },
        700: {
            value: "#116932"
        },
        800: {
            value: "#124a28"
        },
        900: {
            value: "#042713"
        },
        950: {
            value: "#03190c"
        }
    },
    teal: {
        50: {
            value: "#f0fdfa"
        },
        100: {
            value: "#ccfbf1"
        },
        200: {
            value: "#99f6e4"
        },
        300: {
            value: "#5eead4"
        },
        400: {
            value: "#2dd4bf"
        },
        500: {
            value: "#14b8a6"
        },
        600: {
            value: "#0d9488"
        },
        700: {
            value: "#0c5d56"
        },
        800: {
            value: "#114240"
        },
        900: {
            value: "#032726"
        },
        950: {
            value: "#021716"
        }
    },
    blue: {
        50: {
            value: "#eff6ff"
        },
        100: {
            value: "#dbeafe"
        },
        200: {
            value: "#bfdbfe"
        },
        300: {
            value: "#a3cfff"
        },
        400: {
            value: "#60a5fa"
        },
        500: {
            value: "#3b82f6"
        },
        600: {
            value: "#2563eb"
        },
        700: {
            value: "#173da6"
        },
        800: {
            value: "#1a3478"
        },
        900: {
            value: "#14204a"
        },
        950: {
            value: "#0c142e"
        }
    },
    cyan: {
        50: {
            value: "#ecfeff"
        },
        100: {
            value: "#cffafe"
        },
        200: {
            value: "#a5f3fc"
        },
        300: {
            value: "#67e8f9"
        },
        400: {
            value: "#22d3ee"
        },
        500: {
            value: "#06b6d4"
        },
        600: {
            value: "#0891b2"
        },
        700: {
            value: "#0c5c72"
        },
        800: {
            value: "#134152"
        },
        900: {
            value: "#072a38"
        },
        950: {
            value: "#051b24"
        }
    },
    purple: {
        50: {
            value: "#faf5ff"
        },
        100: {
            value: "#f3e8ff"
        },
        200: {
            value: "#e9d5ff"
        },
        300: {
            value: "#d8b4fe"
        },
        400: {
            value: "#c084fc"
        },
        500: {
            value: "#a855f7"
        },
        600: {
            value: "#9333ea"
        },
        700: {
            value: "#641ba3"
        },
        800: {
            value: "#4a1772"
        },
        900: {
            value: "#2f0553"
        },
        950: {
            value: "#1a032e"
        }
    },
    pink: {
        50: {
            value: "#fdf2f8"
        },
        100: {
            value: "#fce7f3"
        },
        200: {
            value: "#fbcfe8"
        },
        300: {
            value: "#f9a8d4"
        },
        400: {
            value: "#f472b6"
        },
        500: {
            value: "#ec4899"
        },
        600: {
            value: "#db2777"
        },
        700: {
            value: "#a41752"
        },
        800: {
            value: "#6d0e34"
        },
        900: {
            value: "#45061f"
        },
        950: {
            value: "#2c0514"
        }
    }
});



"use strict";
const $3938b38524575205$export$58734539bbfa41a2 = (0, $ee2de6f250f65b79$export$8e135e7aaa7aabf6).cursor({
    button: {
        value: "pointer"
    },
    checkbox: {
        value: "default"
    },
    disabled: {
        value: "not-allowed"
    },
    menuitem: {
        value: "default"
    },
    option: {
        value: "default"
    },
    radio: {
        value: "default"
    },
    slider: {
        value: "default"
    },
    switch: {
        value: "pointer"
    }
});



"use strict";
const $ff4f24702db97103$export$38b928a7167ce124 = (0, $ee2de6f250f65b79$export$8e135e7aaa7aabf6).durations({
    fastest: {
        value: "50ms"
    },
    faster: {
        value: "100ms"
    },
    fast: {
        value: "150ms"
    },
    moderate: {
        value: "200ms"
    },
    slow: {
        value: "300ms"
    },
    slower: {
        value: "400ms"
    },
    slowest: {
        value: "500ms"
    }
});



"use strict";
const $5ea74a4429ed57e2$export$15a0bf1b4bbacad8 = (0, $ee2de6f250f65b79$export$8e135e7aaa7aabf6).easings({
    "ease-in": {
        value: "cubic-bezier(0.42, 0, 1, 1)"
    },
    "ease-out": {
        value: "cubic-bezier(0, 0, 0.58, 1)"
    },
    "ease-in-out": {
        value: "cubic-bezier(0.42, 0, 0.58, 1)"
    },
    "ease-in-smooth": {
        value: "cubic-bezier(0.32, 0.72, 0, 1)"
    }
});



"use strict";
const $7d51cd6dba13870e$export$67baea80019ff381 = (0, $ee2de6f250f65b79$export$8e135e7aaa7aabf6).fontSizes({
    "2xs": {
        value: "0.625rem"
    },
    xs: {
        value: "0.75rem"
    },
    sm: {
        value: "0.875rem"
    },
    md: {
        value: "1rem"
    },
    lg: {
        value: "1.125rem"
    },
    xl: {
        value: "1.25rem"
    },
    "2xl": {
        value: "1.5rem"
    },
    "3xl": {
        value: "1.875rem"
    },
    "4xl": {
        value: "2.25rem"
    },
    "5xl": {
        value: "3rem"
    },
    "6xl": {
        value: "3.75rem"
    },
    "7xl": {
        value: "4.5rem"
    },
    "8xl": {
        value: "6rem"
    },
    "9xl": {
        value: "8rem"
    }
});



"use strict";
const $da9f39112e17d3b5$export$59230918eb9bd861 = (0, $ee2de6f250f65b79$export$8e135e7aaa7aabf6).fontWeights({
    thin: {
        value: "100"
    },
    extralight: {
        value: "200"
    },
    light: {
        value: "300"
    },
    normal: {
        value: "400"
    },
    medium: {
        value: "500"
    },
    semibold: {
        value: "600"
    },
    bold: {
        value: "700"
    },
    extrabold: {
        value: "800"
    },
    black: {
        value: "900"
    }
});



"use strict";
const $e3cae4aec89a06c6$var$fallback = `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`;
const $e3cae4aec89a06c6$export$f45fbea8fe20ca8a = (0, $ee2de6f250f65b79$export$8e135e7aaa7aabf6).fonts({
    heading: {
        value: `Inter, ${$e3cae4aec89a06c6$var$fallback}`
    },
    body: {
        value: `Inter, ${$e3cae4aec89a06c6$var$fallback}`
    },
    mono: {
        value: `SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace`
    }
});



"use strict";
const $6d4caaed20451dcc$export$d25ddfdf17c3ad3e = (0, $ee2de6f250f65b79$export$900dac1a2cda17d7)({
    spin: {
        "0%": {
            transform: "rotate(0deg)"
        },
        "100%": {
            transform: "rotate(360deg)"
        }
    },
    pulse: {
        "50%": {
            opacity: "0.5"
        }
    },
    ping: {
        "75%, 100%": {
            transform: "scale(2)",
            opacity: "0"
        }
    },
    bounce: {
        "0%, 100%": {
            transform: "translateY(-25%)",
            animationTimingFunction: "cubic-bezier(0.8,0,1,1)"
        },
        "50%": {
            transform: "none",
            animationTimingFunction: "cubic-bezier(0,0,0.2,1)"
        }
    },
    "bg-position": {
        from: {
            backgroundPosition: "var(--animate-from, 1rem) 0"
        },
        to: {
            backgroundPosition: "var(--animate-to, 0) 0"
        }
    },
    position: {
        from: {
            insetInlineStart: "var(--animate-from-x)",
            insetBlockStart: "var(--animate-from-y)"
        },
        to: {
            insetInlineStart: "var(--animate-to-x)",
            insetBlockStart: "var(--animate-to-y)"
        }
    },
    "circular-progress": {
        "0%": {
            strokeDasharray: "1, 400",
            strokeDashoffset: "0"
        },
        "50%": {
            strokeDasharray: "400, 400",
            strokeDashoffset: "-100%"
        },
        "100%": {
            strokeDasharray: "400, 400",
            strokeDashoffset: "-260%"
        }
    },
    // collapse
    "expand-height": {
        from: {
            height: "0"
        },
        to: {
            height: "var(--height)"
        }
    },
    "collapse-height": {
        from: {
            height: "var(--height)"
        },
        to: {
            height: "0"
        }
    },
    "expand-width": {
        from: {
            width: "0"
        },
        to: {
            width: "var(--width)"
        }
    },
    "collapse-width": {
        from: {
            height: "var(--width)"
        },
        to: {
            height: "0"
        }
    },
    // fade
    "fade-in": {
        from: {
            opacity: 0
        },
        to: {
            opacity: 1
        }
    },
    "fade-out": {
        from: {
            opacity: 1
        },
        to: {
            opacity: 0
        }
    },
    // slide from (full)
    "slide-from-left-full": {
        from: {
            translate: "-100% 0"
        },
        to: {
            translate: "0 0"
        }
    },
    "slide-from-right-full": {
        from: {
            translate: "100% 0"
        },
        to: {
            translate: "0 0"
        }
    },
    "slide-from-top-full": {
        from: {
            translate: "0 -100%"
        },
        to: {
            translate: "0 0"
        }
    },
    "slide-from-bottom-full": {
        from: {
            translate: "0 100%"
        },
        to: {
            translate: "0 0"
        }
    },
    // slide to (full)
    "slide-to-left-full": {
        from: {
            translate: "0 0"
        },
        to: {
            translate: "-100% 0"
        }
    },
    "slide-to-right-full": {
        from: {
            translate: "0 0"
        },
        to: {
            translate: "100% 0"
        }
    },
    "slide-to-top-full": {
        from: {
            translate: "0 0"
        },
        to: {
            translate: "0 -100%"
        }
    },
    "slide-to-bottom-full": {
        from: {
            translate: "0 0"
        },
        to: {
            translate: "0 100%"
        }
    },
    // slide from
    "slide-from-top": {
        "0%": {
            translate: "0 -0.5rem"
        },
        to: {
            translate: "0"
        }
    },
    "slide-from-bottom": {
        "0%": {
            translate: "0 0.5rem"
        },
        to: {
            translate: "0"
        }
    },
    "slide-from-left": {
        "0%": {
            translate: "-0.5rem 0"
        },
        to: {
            translate: "0"
        }
    },
    "slide-from-right": {
        "0%": {
            translate: "0.5rem 0"
        },
        to: {
            translate: "0"
        }
    },
    // slide to
    "slide-to-top": {
        "0%": {
            translate: "0"
        },
        to: {
            translate: "0 -0.5rem"
        }
    },
    "slide-to-bottom": {
        "0%": {
            translate: "0"
        },
        to: {
            translate: "0 0.5rem"
        }
    },
    "slide-to-left": {
        "0%": {
            translate: "0"
        },
        to: {
            translate: "-0.5rem 0"
        }
    },
    "slide-to-right": {
        "0%": {
            translate: "0"
        },
        to: {
            translate: "0.5rem 0"
        }
    },
    // scale
    "scale-in": {
        from: {
            scale: "0.95"
        },
        to: {
            scale: "1"
        }
    },
    "scale-out": {
        from: {
            scale: "1"
        },
        to: {
            scale: "0.95"
        }
    }
});



"use strict";
const $f899d2b25955c778$export$b74e30ebb52682da = (0, $ee2de6f250f65b79$export$8e135e7aaa7aabf6).letterSpacings({
    tighter: {
        value: "-0.05em"
    },
    tight: {
        value: "-0.025em"
    },
    wide: {
        value: "0.025em"
    },
    wider: {
        value: "0.05em"
    },
    widest: {
        value: "0.1em"
    }
});



"use strict";
const $3a40b19f0fbc37c7$export$e646ed6b629bf51e = (0, $ee2de6f250f65b79$export$8e135e7aaa7aabf6).lineHeights({
    shorter: {
        value: 1.25
    },
    short: {
        value: 1.375
    },
    moderate: {
        value: 1.5
    },
    tall: {
        value: 1.625
    },
    taller: {
        value: 2
    }
});



"use strict";
const $24814f80cd8e6b71$export$18f838d5aba6962a = (0, $ee2de6f250f65b79$export$8e135e7aaa7aabf6).radii({
    none: {
        value: "0"
    },
    "2xs": {
        value: "0.0625rem"
    },
    xs: {
        value: "0.125rem"
    },
    sm: {
        value: "0.25rem"
    },
    md: {
        value: "0.375rem"
    },
    lg: {
        value: "0.5rem"
    },
    xl: {
        value: "0.75rem"
    },
    "2xl": {
        value: "1rem"
    },
    "3xl": {
        value: "1.5rem"
    },
    "4xl": {
        value: "2rem"
    },
    full: {
        value: "9999px"
    }
});




"use strict";
const $3bd125e5a0dc7181$export$5458b64234d1333c = (0, $ee2de6f250f65b79$export$8e135e7aaa7aabf6).spacing({
    0.5: {
        value: "0.125rem"
    },
    1: {
        value: "0.25rem"
    },
    1.5: {
        value: "0.375rem"
    },
    2: {
        value: "0.5rem"
    },
    2.5: {
        value: "0.625rem"
    },
    3: {
        value: "0.75rem"
    },
    3.5: {
        value: "0.875rem"
    },
    4: {
        value: "1rem"
    },
    4.5: {
        value: "1.125rem"
    },
    5: {
        value: "1.25rem"
    },
    6: {
        value: "1.5rem"
    },
    7: {
        value: "1.75rem"
    },
    8: {
        value: "2rem"
    },
    9: {
        value: "2.25rem"
    },
    10: {
        value: "2.5rem"
    },
    11: {
        value: "2.75rem"
    },
    12: {
        value: "3rem"
    },
    14: {
        value: "3.5rem"
    },
    16: {
        value: "4rem"
    },
    20: {
        value: "5rem"
    },
    24: {
        value: "6rem"
    },
    28: {
        value: "7rem"
    },
    32: {
        value: "8rem"
    },
    36: {
        value: "9rem"
    },
    40: {
        value: "10rem"
    },
    44: {
        value: "11rem"
    },
    48: {
        value: "12rem"
    },
    52: {
        value: "13rem"
    },
    56: {
        value: "14rem"
    },
    60: {
        value: "15rem"
    },
    64: {
        value: "16rem"
    },
    72: {
        value: "18rem"
    },
    80: {
        value: "20rem"
    },
    96: {
        value: "24rem"
    }
});


"use strict";
const $da4f6aac6ef8d153$var$largeSizes = (0, $ee2de6f250f65b79$export$8e135e7aaa7aabf6).sizes({
    "3xs": {
        value: "14rem"
    },
    "2xs": {
        value: "16rem"
    },
    xs: {
        value: "20rem"
    },
    sm: {
        value: "24rem"
    },
    md: {
        value: "28rem"
    },
    lg: {
        value: "32rem"
    },
    xl: {
        value: "36rem"
    },
    "2xl": {
        value: "42rem"
    },
    "3xl": {
        value: "48rem"
    },
    "4xl": {
        value: "56rem"
    },
    "5xl": {
        value: "64rem"
    },
    "6xl": {
        value: "72rem"
    },
    "7xl": {
        value: "80rem"
    },
    "8xl": {
        value: "90rem"
    }
});
const $da4f6aac6ef8d153$var$namedSizes = (0, $ee2de6f250f65b79$export$8e135e7aaa7aabf6).sizes({
    max: {
        value: "max-content"
    },
    min: {
        value: "min-content"
    },
    fit: {
        value: "fit-content"
    },
    prose: {
        value: "60ch"
    },
    full: {
        value: "100%"
    },
    dvh: {
        value: "100dvh"
    },
    svh: {
        value: "100svh"
    },
    lvh: {
        value: "100lvh"
    },
    dvw: {
        value: "100dvw"
    },
    svw: {
        value: "100svw"
    },
    lvw: {
        value: "100lvw"
    },
    vw: {
        value: "100vw"
    },
    vh: {
        value: "100vh"
    }
});
const $da4f6aac6ef8d153$var$fractionalSizes = (0, $ee2de6f250f65b79$export$8e135e7aaa7aabf6).sizes({
    "1/2": {
        value: "50%"
    },
    "1/3": {
        value: "33.333333%"
    },
    "2/3": {
        value: "66.666667%"
    },
    "1/4": {
        value: "25%"
    },
    "3/4": {
        value: "75%"
    },
    "1/5": {
        value: "20%"
    },
    "2/5": {
        value: "40%"
    },
    "3/5": {
        value: "60%"
    },
    "4/5": {
        value: "80%"
    },
    "1/6": {
        value: "16.666667%"
    },
    "2/6": {
        value: "33.333333%"
    },
    "3/6": {
        value: "50%"
    },
    "4/6": {
        value: "66.666667%"
    },
    "5/6": {
        value: "83.333333%"
    },
    "1/12": {
        value: "8.333333%"
    },
    "2/12": {
        value: "16.666667%"
    },
    "3/12": {
        value: "25%"
    },
    "4/12": {
        value: "33.333333%"
    },
    "5/12": {
        value: "41.666667%"
    },
    "6/12": {
        value: "50%"
    },
    "7/12": {
        value: "58.333333%"
    },
    "8/12": {
        value: "66.666667%"
    },
    "9/12": {
        value: "75%"
    },
    "10/12": {
        value: "83.333333%"
    },
    "11/12": {
        value: "91.666667%"
    }
});
const $da4f6aac6ef8d153$export$c647cb0ee6e282fe = (0, $ee2de6f250f65b79$export$8e135e7aaa7aabf6).sizes({
    ...$da4f6aac6ef8d153$var$largeSizes,
    ...(0, $3bd125e5a0dc7181$export$5458b64234d1333c),
    ...$da4f6aac6ef8d153$var$fractionalSizes,
    ...$da4f6aac6ef8d153$var$namedSizes
});




"use strict";
const $9a93eaf342287de0$export$a01878c2d95345c0 = (0, $ee2de6f250f65b79$export$8e135e7aaa7aabf6).zIndex({
    hide: {
        value: -1
    },
    base: {
        value: 0
    },
    docked: {
        value: 10
    },
    dropdown: {
        value: 1e3
    },
    sticky: {
        value: 1100
    },
    banner: {
        value: 1200
    },
    overlay: {
        value: 1300
    },
    modal: {
        value: 1400
    },
    popover: {
        value: 1500
    },
    skipNav: {
        value: 1600
    },
    toast: {
        value: 1700
    },
    tooltip: {
        value: 1800
    },
    max: {
        value: 2147483647
    }
});


"use strict";
const $0f0c5468a603a423$export$a9c3b64d72246606 = (0, $ee2de6f250f65b79$export$9e20b617fd74b180)({
    preflight: true,
    cssVarsPrefix: "chakra",
    cssVarsRoot: ":where(html, .chakra-theme)",
    globalCss: $ee532e93ddb721f3$export$db53682eef82cc11,
    theme: {
        breakpoints: $b948e4674d6fb783$export$d07517a676ce386f,
        keyframes: $6d4caaed20451dcc$export$d25ddfdf17c3ad3e,
        tokens: {
            aspectRatios: $5786f907b7c2301a$export$d81ee2a7bf2dffaa,
            animations: $43eed95b8269eddb$export$7f9953c70dacfd7f,
            blurs: $a8404cf802427cdc$export$a86789f140d190e2,
            borders: $34e128a01e88b03b$export$5a5da632d18030b0,
            colors: $20970d7ce8b3b5ae$export$8f45430ccf837300,
            durations: $ff4f24702db97103$export$38b928a7167ce124,
            easings: $5ea74a4429ed57e2$export$15a0bf1b4bbacad8,
            fonts: $e3cae4aec89a06c6$export$f45fbea8fe20ca8a,
            fontSizes: $7d51cd6dba13870e$export$67baea80019ff381,
            fontWeights: $da9f39112e17d3b5$export$59230918eb9bd861,
            letterSpacings: $f899d2b25955c778$export$b74e30ebb52682da,
            lineHeights: $3a40b19f0fbc37c7$export$e646ed6b629bf51e,
            radii: $24814f80cd8e6b71$export$18f838d5aba6962a,
            spacing: $3bd125e5a0dc7181$export$5458b64234d1333c,
            sizes: $da4f6aac6ef8d153$export$c647cb0ee6e282fe,
            zIndex: (0, $9a93eaf342287de0$export$a01878c2d95345c0),
            cursor: $3938b38524575205$export$58734539bbfa41a2
        },
        semanticTokens: {
            colors: (0, $de3e683eef03515f$export$bba894c3986a1bd6),
            shadows: (0, $6a303010962bcba7$export$be8678bc2461c05b),
            radii: (0, $43209b4391cfe2b2$export$9a35918a914a3cfd)
        },
        recipes: $47ee297e29ad652e$export$fa74c78a0037e9df,
        slotRecipes: $5ddea6fbf9393ed0$export$5a51f768ceeb5eb3,
        textStyles: $e6f48c027c842acd$export$6a54c24d15b0f6ba,
        layerStyles: $905267d7480630f1$export$c5ce54c56ca9d603,
        animationStyles: $8710b90ad96b7ca6$export$af3299cdb043c88c
    }
});


"use strict";
const $59f0754614c69ed2$export$f84bd70098573c5c = (0, $ee2de6f250f65b79$export$5d86b86a654a7039)((0, $0de2139040a29c93$export$68b8fa3a393a40ba), (0, $0f0c5468a603a423$export$a9c3b64d72246606));
const $59f0754614c69ed2$export$696a1c03ebc75055 = (0, $a858f572f00a56ce$export$b06ab6dfae3e7e3)($59f0754614c69ed2$export$f84bd70098573c5c);



const $25d38ac7d80d0bc6$var$tooltipRecipe = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    slots: (0, $aa59da5a8c9775bf$export$477202748c7242bf).keys(),
    base: {
        content: {
            "--tooltip-bg": "colors.base"
        }
    }
});
const $25d38ac7d80d0bc6$var$listRecipe = (0, $ee2de6f250f65b79$export$c28efc68fea5b4d6)({
    slots: (0, $9b7764ce1529e5da$export$12b3a655a94374ed).keys(),
    variants: {
        variant: {
            marker: {
                item: {
                    _marker: {
                        color: "white"
                    }
                }
            }
        }
    }
});
const $25d38ac7d80d0bc6$var$linkRecipe = (0, $ee2de6f250f65b79$export$9ab6f981e4119117)({
    variants: {
        variant: {
            plain: {
                color: "white"
            }
        }
    }
});
const $25d38ac7d80d0bc6$var$config = (0, $ee2de6f250f65b79$export$9e20b617fd74b180)({
    globalCss: {
        "html, body": {
            backgroundColor: "primary"
        },
        a: {
            colorPalette: "red"
        }
    },
    theme: {
        recipes: {
            link: $25d38ac7d80d0bc6$var$linkRecipe
        },
        slotRecipes: {
            tooltip: $25d38ac7d80d0bc6$var$tooltipRecipe,
            list: $25d38ac7d80d0bc6$var$listRecipe
        },
        keyframes: {
            mainBg: {
                "0%": {
                    backgroundPosition: "-44vw top"
                },
                "100%": {
                    backgroundPosition: "-48vw top"
                }
            }
        },
        tokens: {
            animations: {
                mainBg: {
                    value: "mainBg 4s ease 0s 1 normal forwards"
                }
            },
            colors: {
                base: {
                    value: "#201D1D"
                },
                primary: {
                    value: "#F1584A"
                },
                secondary: {
                    value: "#F1826A"
                }
            },
            fonts: {
                heading: {
                    value: `"Pier Sans", "Helvetica Neue", Helvetica, Arial, sans-serif`
                },
                body: {
                    value: `"Pier Sans", "Helvetica Neue", Helvetica, Arial, sans-serif`
                }
            }
        }
    }
});
var $25d38ac7d80d0bc6$export$2e2bcd8739ae039 = (0, $a858f572f00a56ce$export$b06ab6dfae3e7e3)((0, $59f0754614c69ed2$export$f84bd70098573c5c), $25d38ac7d80d0bc6$var$config);



var $acw62 = parcelRequire("acw62");

function $a1ac1d77c18d2946$export$20f257fc407da7a3() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $63d46a01db878c10$export$98f03c5d19621d70), {
        styles: `
        // Bold Italic

        @font-face {
          font-family: "Pier Sans";
          src: url(data:application/font-woff;charset=utf-8;base64,d09GRgABAAAAAE7MABMAAAAAijwAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABGRlRNAAABqAAAABwAAAAcdMdeBEdERUYAAAHEAAAAHQAAAB4AJwC6R1BPUwAAAeQAAABxAAAAhK3+wAlHU1VCAAACWAAAACAAAAAgRHZMdU9TLzIAAAJ4AAAATgAAAGBxuZMTY21hcAAAAsgAAAHIAAACYmE3IcJjdnQgAAAEkAAAAEQAAABEFe8ahGZwZ20AAATUAAABsQAAAmVTtC+nZ2FzcAAABogAAAAIAAAACAAAABBnbHlmAAAGkAAAQGgAAHX8gCFxA2hlYWQAAEb4AAAAMQAAADYLq+Y5aGhlYQAARywAAAAfAAAAJBD7BXZobXR4AABHTAAAAgwAAALQDkVcR2xvY2EAAElYAAABXAAAAWrWJLlCbWF4cAAASrQAAAAgAAAAIAHRAaVuYW1lAABK1AAAAcIAAAScU+KgHnBvc3QAAEyYAAABfAAAAjhIyZl6cHJlcAAAThQAAACwAAABFiiZ8rd3ZWJmAABOxAAAAAYAAAAGnRlVnwAAAAEAAAAA0aD+SAAAAADRYRIkAAAAANHFTZd42mNgZGBg4AFiMSBmYmAEws1AzALmMQAAC08A4gAAAHjaJYsxC4JgFEXPlwrS7Nz00RQIgnwi0SRNTuLcVFPg0C+S6H/ebja8+3jnvEsA9hw4EYbrOFOSmyDxM+H5eC1m/C+73bZLz2X7LKjcjjR0dketJN1tk2Yyot5mHybdzKJq56TWWbhTk+g5fwFL1RRqAAAAAAEAAAAKABwAHgABREZMVAAIAAQAAAAA//8AAAAAAAB42mNgZklm2sPAysDCasxyloGBYRaEZgLhOCBm4GBlAVHMQDkQhgM/fz9XBkYGBdU/rN/+fmNg4OBhUgMKM4LkGN8xvQNSCgxMAEsTDMYAAHjaY2BgYGaAYBkGRiDJwBgD5DGC+SyMDkDah8GBgZWBh6GaoZZhAcNihqUMKxhWM6xl2MiwhWEHw26GQwxHGM4zXGG4znCH4RHDE4b3DF8YvjH8YfjPWMF0TIFLQURBUkFWQUlBTUFfIV5hjeqf//+BpiqgmbYBaNp2oGkHgKYdZ7jEcI3hJsMDoGnPGT4BTfsJNY1BQUBBQkEG1bT/j/8/+n/g/77/e//v/r/z/47/2/5v+b/p/4b/a/6v/r/y//L/y/4v/b/o/8L/8//P/T/n/6z/M/4r/L38YNaDqQ8mPZjwoOdB54PGB0EP2G5th4QA9QAjGwPcSEYmIMGErgAY9CysbOwcnFzcPLx8/AKCQsIiomLiEpJS0jKycvIKikrKKqpq6hqaWto6unr6BoZGxiamZuYWllbWNrZ29g6OTs4urm7uHp5e3j6+fv4BgUHBIaFh4RGRUdExsXEM8QwM+QwFRQw1jc1NLa0MDG0d7Z1dPd29fQwT+idOYpgyeeo0hjSGRIZ1YNdkJIPIdAaGJEyvpGSvT8gBMVasXLN21WoGhukzGDaBZTKBOK84t6SwrLyitKqaobK+oY5hJlgqC4gBuyCj+QAAA/QGAAEQAMEA5QD6AP8BHwErAS8BSAEvATcBOwFBAUgBTwFYAV4A5wELATIBPQDcAT8BWwFWASUBKAEjAO4ARAUReNpdUbtOW0EQ3Q0PA4HE2CA52hSzmZDGe6EFCcTVjWJkO4XlCGk3cpGLcQEfQIFEDdqvGaChpEibBiEXSHxCPiESM2uIojQ7O7NzzpkzS8qRqnfpa89T5ySQwt0GzTb9Tki1swD3pOvrjYy0gwdabGb0ynX7/gsGm9GUO2oA5T1vKQ8ZTTuBWrSn/tH8Cob7/B/zOxi0NNP01DoJ6SEE5ptxS4PvGc26yw/6gtXhYjAwpJim4i4/plL+tzTnasuwtZHRvIMzEfnJNEBTa20Emv7UIdXzcRRLkMumsTaYmLL+JBPBhcl0VVO1zPjawV2ys+hggyrNgQfYw1Z5DB4ODyYU0rckyiwNEfZiq8QIEZMcCjnl3Mn+pED5SBLGvElKO+OGtQbGkdfAoDZPs/88m01tbx3C+FkcwXe/GUs6+MiG2hgRYjtiKYAJREJGVfmGGs+9LAbkUvvPQJSA5fGPf50ItO7YRDyXtXUOMVYIen7b3PLLirtWuc6LQndvqmqo0inN+17OvscDnh4Lw0FjwZvP+/5Kgfo8LK40aA4EQ3o3ev+iteqIq7wXPrIn07+xWgAAAAABAAH//wAPeNrlvQl4VOXZMPw855w5s2SWM3vWSWYmmWwkk8yETIaQBQhbWEQ2FZFdZNG6Sy2lFqkiIKKogGvVUmsV9ZyZSJFamxYtbxdfX+sr1uJSP6ttKqWptQoxOfz3/ZwzyQSCy9de//t91wdXzpw5czLn3rfnvp8QjnQQwq0wzCM8MZJahZLo2JRRKPlrTBENb45N8RycEoXHywa8nDKKwf6xKYrX486gsyzoDHZwJWop3aOuMszre6JDeInAV5IfnjrGXyYSkkMcZApJ2ThSLZujCm/pobIUlW1HFLu7J+2w20zVitXaI1ujisPaozhptWKzOl2KmU8mZYdTNiSJYuOdLtmarKtPtNJ4zGe003Ao4qZBetC5buLkaU7n1ydNnLaccnSx+pst4y5c2D7+wgvpJOHqz7YThIVK/HrhI0OK2EgBKSQyicr2eJdoISahWvbEqFwYVYpoNamrp4mI/gjRmKDBYe+otDPqcm+Zde48t62OU0/Q6h21Tve2mXPmua31nPoJv74vOWva6tXTmut49f2+sTOmrV41PdEA54wevYQY3zJ0AgTFQPMUXKuW/XGZiyrevHhc4U09irswFpPFqOIMwAUjXMhxxJDglup0u9FsrpZtAGtJVAkyWOPusDuYgB93kI/DD/w3xvHoDvM0ngj3PvfcZBq+LD2FFjxH23/65+fhQLnJ6u5LP52sfne/+tP9H+yna9+97ANaTYv30QBtVH+FP+r/2qe+q75Gq9XXuM59ACdPNp4yiQnxBGkkk8hcGidUnheV40e6YlYiAQljkpJLq7vy2DtlPq2WG/MPthb33ku81RZBjtfKebVyXFJinpNyHtzrOXmw1d/7Dfg0By6nTfFcd3XazI5+PMIXpvNjefA2yI4hdqzHI97fwO5sZ8dxmfsns3vm4jEFN5RsLdkaFu1OV1I2JWVzUm5PyuOSsj+Zgq/Bq5OT8tykHErKwaScnyTtksnsz83LD4bqY/GG9nGT59ae9o+2W+EWvOGMj+X2fKqANriURBMIba5TaZsDr3mu1LQZ5ySTSWCWuyzA+QPU764VyiOJxkQr10bjRp/fECmPlPMBgx9lLG6nDhpO1FKaCIh+twiXRHcj3N0YL4ff20iLzZLIFa9qXpmYuXBs1ChKRZPHytumNB9v/ccu9VjI3LRgQazlvMZkidHq8zVxneoDLcebt77HOTkqWIxuU75hypRKv1W8a16dzWYyWqjJb6kQqP2PefUSVzfFRfe4ixuSc+onTvnahTMvrbQc/6Tuj29Ptc2tVnc5c8urkp2jGpbNm3XZXfkf/8V9J7+Ny3E6zFaDnafFeYlgdW7/O6FJ7ooyp8PvNft5YqDuU6pxKdgAEAzQu0oymowhqXKUfFtcqeF7UgJaBXtcyed7uuIl5YKtWonDqcfCTj082IrGqJLQdLOVY6oo6LrPi754DGgTCYdE2ljK7AIHn5VlX2/O2/mr1Q//MFKh/uXhh554iu+ibf2zHsupqKyYasmpKq+YQn8bobkPwR15O3+z5ruP0Yk5lRWVU3NyquAOYfPKpy5+6/77j77Z7xFJHxE2V7e0VFePH9f/wn1vHr2ffThqXHsNXCVMT645ddzwhiiRKODZQVpJqgRxrYynRsErYpYyAcLKBMRrYlSZBHgp8RKnKxUIloKcyBOcXby7sKml1A+2zt2K1khDTDTaBaMfLhjsnBHEKFhutJvCtRzDNRHhyu2Uij6GdUi8N5heHymspP5Hvr+vMnwFdeSFYgWPmssFGnHlzWny31uiLmuxWh2lxbHouHGzqnb9bh5dXLhy2eUba5+ubZhJEzmB9uYcS3F7krPcfHzG/PUPv/rqw7dcQe2evCLrgHtmTqKh9eaW0Ee1C0Sj2Wl1WW1mA731xO7LHmibQu1TSq/k5laOGVNZ0dRECKVWfj3vZra3Ai2vbnapbI/K5EiX2U3MYDMcYPXNBIy8mDzDClPr7Wh3z5l9HrOz/xy0sxnbSsk16i7hJnE/8cAbF/XbTQHBbyTUv5f71nTPqEXzLr1gfqPDUVWVLHAcVidwj3F30vV/twZmzLvlzl/+/ld33jJ3ZqHtn/QG/K5Tj6m7+Gfhu9xgr1t5FwACqpcgPEfPL5m8+5s3lxU4HJVVTYX2F+nPvr934MZrPfEd36fWXZf98s5b5s0osv1dvXng0oG16ibAvY3fw283HCIuEiayKypb4go19MgmMOPuDPpGQN+jO594ecKf8BvjxrDPbyw3lidoW+OSyjecEx7sXDJ6WYXhVe+4vZ1Cx2vjVi9durbttUbLmpWrLm0njAafkEPCXP4l8Lc7kM6KKQecCDX2KJwBnAih6ESIBZyIOZaiBN9RHt4JAAu4XptutDWzbJEttbJQK1skxew9KQuSwsOLRUpzFh7MrVlKG8wCmFsTHvF6Dl7nf8TxgsFktuRkGUbAq4AGNfcErumTNiqMp55xVGxX+8apH46nh8FtC2q/qqr9VAD6v3KqjB6hi76KvBiHyUt0R73XfcvMOfPdzhpw00f7ms6dtnbN9FZ48wHQ6Rh9SJjOPQLa6md0QhLBD5WFqGJgfAB4+WPj+OLx9CHKqSr8zvxTxzlKFxAz2LCUCXS5i7cQJ0JlQagUgxt8NYBkAJDAkzOLDxCxSCUUWePe+sj5bs+te+c+2rlmTefMNWuQXxIhBk5Eq+HTogGIqUh1FhhxsHESn0aDhcYHY4i7wb48BvbFCTHE7SRlR6viNWtmVCk092SiA8bKC/5+K7LSLhNJpt2Ky3dSLu4+2Drz7xcxDudKcl63YrGclE3dabPFBH4TjkN+k7SbCQVmunLzirOc4AgX0f0xsjWSeCxAjX7eTsFI11LdEruZKTYeuGEs3fL+rjfOD3MbI6+o/2v3rt+dRxcXrFq+4qmC9flrVizfl89xtO89Wr/l47s5Vdz98ZYtH3937bZta+lf1t6yZQ3oE5CefwloZiDz9AjKEIcQFV6FuMLxPTIFaRY1luT0KEadEkW9OxnKjBCyQZKFbl6hAoNc4xnHM54FKYRT8Bg65ncdXLG6SeilElIe+XUtPHafmEtKSQNJlSLlQ/BAU1RxId3LokoErXmoFISSQtDhTFlygmjTXS4IPzBaa0wQpETEWNbKJxr9AR58vt1oDPLXTnhzCSd1eNrm/vCb6rvO+lnrJj62N79lzYqSKdWO1vbLp22fcI+Xvt1BpW+OpedQ6dwrbcfHl527ZlXFIpFagzObbnm6dcOKb0xfN/pap9qLsLpATg4DnfJILUn5EVYepMSOUmJD35MfVQoQWt4P0JKkbHMqVEqizynTfGctLQ+i1lKfy8iYGXHR9ukr1z6b7yhYNFH9iL6mXjmBf1bl1q0oj/xOff3+re9Qbv3KbasmXj2Np29T18CJqeqn9+85ue1ulNtNQLttAI8FtPpbJGVGzpniKQ4A6rLkmDnw9YIVzJUFKGqMMV03HwEL1oOKzlhY2Hu7JsxmSbZ1G2QTMjFtNAmaObKYbWCOrHjkiWyrpV2C0WK1DRohJcfC+AIYQljPx/kw2CKImjeN5nfRlqPrO76xWH120f6TF9AbXucf79+h9qob6Q1UoksZ7+8/1WuYCfAHSA1JFaKuYjqjSODQJRuaUinHDKpbHFVKkKxSITzMgulKmc/vQ6dcHjEyG2hs9DcGOJ2k99OyxLJl/1lY0LHoW9PUvsN8okN1N7R2Ln/kqkAw8nv1zZ1bf9N3YItkvf3Ky7dY7BP4MrX35RKRjt/y6u13f3abltuQuwC2WoANI6yIbhM8emhF5aKoEkCQBA9EGZwxP8m43JhwgXHRACkZ1FOmpgfDV75Dr6Qr1O23He4sRT1Vf/vmeXRZ/sVLlz2TX7hq2dIUZ7l1B7XTl9Skec9nd+75dNu2E7vXPvDA2sseeABoBaCIHUxH83W7hgqK2omqiTqp2TYQLpFXBxZ2CA99Vj2oaDy5EWQ3CTbOQ0rIKBInKRdilAvya8TvqTL3dJUGXEYQmVJUvJqoUosIlgZAja0cQ89VNhQ3+fgzcaRZ54+1U7G0uIIWfe+hJysC8/aPi/wWsp/fHp0Ppmn1imVPFTADRV2WWCg402KOBUMzORM1/GDxNd/74E+PXLnsB+pnGgVWb9u6BowV5ylvbi6PjBmDeacTyPCE6IIMuICESCoH5T4vqghICz3nVPJyAHCbGwGnrbS0BAyoaATu6MFdBuTRkd/SYlp7dH6kbM3APvUh+rXt/9FJFxVesnRZurDwkuVLU/wne07ceuvJ3XdtHiijL5rv7d956f33XQY/mpyMBx92M/8ixAd+ktR0UPdisjfa5dD9WS7zsi43+lwlD1yaC8xjmjf7HRCTktMS8Kzz+e5bz5k93+3ZNmfWvKfc286Zo59nPB63f9qla6fPWHspg8V+qox7GmCxgYUaRWR/tMupPz+fPd+jhUVgoxQPPD9lynNqaZR/mKfPBsC+M+Z1b8Fk3DmKUz+9MAuGoxgvQgTQBh98wPcMAkLJ4VO/Fh4VDqPMgl3gzZQ/XMnvnzXwDt00i37yKFetPqe+qP5C/QnALJMuYT2/ktVJ8jORA/PWGDyAHzAzyU6AmlP4kcfzgXEDM9v44vYujCKorMcSzfDMIngm+DK/m0ZKy93U2DyLC45R+ybM4vZWjqYT6Jja1xtpx8Brj4IMNZ96w7BarAX5wR95FDgaS48cilI5GlXqmM+JAInsuS6m25TliyydtPNAGmMQsoZWLtEIJggTSj6LZrS5+fAPDj+/botXsLhWX7G3rjjkVQ8VTmifeGB+YbwlfuGaKa22Q451Eyd1OrDEMlUI9+z4ut12wSUvllVMuX3FHfHg/PO/sWdM623zmteOGy0az51yaf/V7RcuGDd+4ULk86PqDcZewybSSeaTE0SeFFXGCT2oATOBdDMlubrkiJMZq2oPWtHqMghI50IEA5+OBlMhAGHPi8r0SFeLVlo4X/MGLS//bYXmDaKSHO9WpNyTsr374Ni3jo3GmkLaIdnd1Qdb3v3bD1mJISql66JxrCCwYwyPKbiSVSOoT8qxZAp+Lyv+2W+POaRoXX0m9DntPYt6lHGTwNR3QK7vlCck5WqX7E/KM51yZVIJzoVPSoEjjWCMXKOA6gEBsjgge7kIB+CIC02UPxHkPajorULCxQVDjGngNQyxhB/uq+WyjVWXPTzqrzRBr3rqhjf3Xp8Ug+6WVRvkpcu+a96watfvZkfK/puGd41e5bTR0t8IhQXB1nh52Gaa1acemv38qz/aHfabaxK76aQLxh66+5P173XdyrWULFq25umS4gtWL3vmB3+5QaFTjt3Wds0jhz/YcM4Pfn738jWzkrspt2cP5e6Oh+v7X7ImxsQWzL2iLkAn0stq1+zp2XbRfT/s/A+jb/Oycdc9ylV9U3nqhm89LaOOn3oRbN9mUCwjZP+j9GiNj7Mgt0s0EQoGXEQ7aIsqdpRiatKdZphq1Szw0yLXzP/z1T71odED/+yml9Pm+rIfYSxMy9U3uAT98Vj118xnXA7Puh+e5SVBeNb9JOXFp5G44gPZwicqo/ierlDQi08N8cxtyIVHFIezR3ZIshHFsALOK0DonD3oUPS48S4tbqyVR9VC9Kj4/CflUZJC4cUnpYO+UVicwiP/DKG+YGjUoGgojgpAJycJ2hlkJ/Iop2xMMs8HTPd5Peib/D6/hwUDfBBZPLqhPFIOjhE0thFOw8HL6QbuqssfDki20PVtXjOVggfVUzf9iVaPX++zSIWt6n920PqScVajaAuqr4nkisWxxtjobddPWlJVM6b1pnc3UemGBeWhqtJ2nkqmufFAzFOFdu/9U8fFj8DHlpOJJBVG/1qYqU04kDoVUZk7oviAFJVggn0cYFAOqBSG4aQEq7IpzlqMwa0JUQOPGxndkGgkIM+C31ALpsXOGUWvxx/gUHT9WLKp5T6geQlaTR/43VM09zz1w7LUtcsP3XtVnqsgf+53Zi3/zda9u9W9T9741gMrON6fu+zS39PVL239zlurr5p/27PLZ06dOX7csqYLvvnGpi0zt7+AtmU9xBmPsbiniCwmKUnnuDPD8SJEJBCVc48oFkCkWOdpoHdPhqdFjKdOYGYR4ymfJtRZNBgyFjnBMZssSZ1pEK97gFsiEYx8EA1qQy1XHlwPHFq1cv/W1Q0CzWtQ/6Be+9JbtPgbPQ8XS9EZX5+qviuSphXbH19mtZ134SvqQ/9JIaa8490N0267YXETZbHlFsAjwerkqzUtUcwZFCBO6DJoqmJAbLLy9MLeOzJoCAwNs5/l6Siaw9NzFE3MyrMzcsCHz/zfQjcI9RMGfLO55R0DDy7lHRC8Qfi7X/2rugGziQyMowFGM1mia7I5PjKIWj5szmH5cHYZWE++zCxuzwYvjdCNBBoCFp0wkHs+t2TCwEMPMqgeUHsHNmkwvXbquDEBMlxNLtLyMVZYHCbIXSXBchNAVoKQjRqU6RpdppVqkkSpxpStLCmXOOFqMqk4gmyxAVK4L5Tt0gSL6hPMUL/O5TXSGvrA609R/3nqR8U/vWbFoXuuRPme851Z99Omyep9Hdxz76gHgp8ObHzrgeUcn5u3dK0m5q8vvD5LzH//AHX1X3/TbibpiOsKoP9eJiMP6TG1Ecs7Gg9SnEGE8y4Lj2zATBjTKDOr6yAzcnJ65ByQDMCag1NOUkxwaoRTo4SlBkUEbmXkKti7F7l1sLW89znGthwpzedwkGWZpLRgMmChHo943YLX+TQvmC2n8c/Nkkd+Bd1Ap9zPNdxHp6ib1AP3D7wERnpgC7euj3DrBrZouG0AAz6e1UHahnsJmYtjNQRR4AFYfhAFBDpbl3k6+Gh44AZ8GCuYUPITyCXeZ3kb+IRcFA8jpmz45c445mty0RHFAIbfICkSfLkTvrxk8Mt3azGGhBmn7JRkV7dsk9J2mwREcOAxBedZQYQjSdIOl83OooXBM7Y4YCjCIkMuWEzJCVk3ip1kxEtFej4WBJGCGMAA2Sm1CyHIv0Hsnud9dIrvjoqOuso8n9lACZ16ing6rrjtFx/8YIHHSb99zvlzWu7xFtdVJkp8gumzE7Pu2Lp87LjLOtsn5DDa7gX32wv4O8hm3bbkOHSpUTgQGrYSB/R15KAfHKSvUydBSe/DmjAE2UkO3JPmHcD0tB2PKThmoc8DUjygTNmRoQ0ZkEu2wXVK2IkmHo0kEaQ+4g9SI78X+DX5jvncOffRN/oXzaNrp4PVWff6NpCT/S30wcsH1t02sPvb3PPbBl4CfJYQIlzJcsupOj68biuZsIgYKyIGcIkVOIm5erAIVNL7oG6HFN5xkpf5IYEFmJYAHJ3qYW4TWL/PpIzd20iIqQeeZyO3aM9LG00WW6lfF1AxrpclFRsQ0DaoWFlVix1Dts8Od8jW7gw1LVjDMHcbQAtlsZsnitmKYkNFfNViCJMNy4mWZIaAvEZASph+0XAO3QhgL6FurvM3dJn6HfXAOwPzD3/4DqDQyxtoTh/hN/bfgD+AyyMgC5czG36tTjvRnJEFwYCyMGi7wUorApYzs8x4qPcH2aiAHTd1I1G/y64KkswDKgYdFd7EUOHF4YadItyUfwSAXkjlPiD4JvVhdfZJkfTb+Y8A2t5+ieWH3WDbC8C255PRZBZJ+RDakoxhr9VWhdCaF4DqFkhKOcAKoRyuEykFGKzkJ+VysOYmXEFGW06U2hIgpUMrDwwa9ACnBWKclaIBLwvwoIIcxmGja3kw9BQN/c8zZn3j2w9cbOLyKn+hnlSffxgs+Ao6iY6et+mcFS9AGOOkDfO+M2tT31NB55Bhn3nrC9fl5i1Zu1c9+l/XgzV/o3PTsuT8HQeXT5/MC52bljbd+ZdN0yYLDOdtYOMrgT8usFZX65bQpfMnAL7M6WZe1onYFzNOuYBTLoll6RjhZAxXuPeJLIfrkuRAd9rpCoDWuvEIDtfpDgxGOQG3HnYDf5AeOkUEY5B3a0FpI0ai2yDOWbvwwctLwwbqKn9DPXKP+s6iR2jh8oPFVhqoW66+JxLavGbKlPmSc/LMB9RP76XqJm57+lv11R1NCxC/z06tM54PPC0gY8givSpZmuFpA2LVzHgaAJ4GJOakbYDVWHgNIE8LknKNM+XxmzDutLkUpxv1otQPfHV74VIDBKVOWzJ5mstGdDhcaC0Xg8hjj+66E+Vl/sYhVoNPH+AgPq2hD/7uCE20lORN+n35Fap65371sxvfBlZP8eedu3nejYt3U2HzvBBye9OsFS/cc1WeNMTul55ZvHbRSvXD15sffOGtlcDvP/D8pLYJF4+Nv3PolfWbpk8SGNPR03cynq8DnhcAz50Qw96ka6XNmdFKiGC7JBfjuqQHs8B18FHgjHDBneUqmbi2pve/s7gO3qqoOy05i4DrLjwC1yVXJrZVcjG0tdqBakYns88uSW+wQCmgfp8RZcDI0jBdCiIoBesw2r3/D6P8IANv7vov9em0emzlPlp48TMBkILYxUwKdn57wvQJnd9VB6aoefQRdRGX2ru+rnJ8bLZmU6dD7sGBHJxDlpLUDKLFkKlSRLgGsZzFMrMYSEFMM6iTAcsJE2Mx5Vx4EysEyOkMTD2caVeNc0wpJNyTXUppBUpDjeB0QbgbKK+YqC2hlgVovBSX8IzltQZIrkAwQDRaqR7N8bguIXoCRn9AREnxinppdjoNeH/8NWqsMlCzIzcvVFxR7KkYN7OlrdbtMplsod9Qfutj1LNAPeZtnPW1ljlb3QaLLd8fLqgs8FRNPKetvbbUZKLWsv9W//j4Tz+l9j9eeI/h+57SkoI8r9sh5RhtueFwXbykuDRYKXCjam9+8aJ7b3m7ovOc6IwZrlBRvt/tsktmoz2vtKx+9PjSknJRGFW389cX3UEodYHM5LG8upOkRH0NhMkL4XsUwRiLYTVKFrUlEPNp3k+EbHdwCUQwZowzVqzQNlNXh3CoQ+1Qf6H+iCaxKqv2fiYJvcC3F4Fvz8HzqsiPSSrCVp54rSabMhUWxdGBVDMFtjt70kY7Z6rGAr5sl5RC4FsRwDJKh2Xt33+vRVbM82lu8GDLB3/7MYOwENelICMDsyXnSen8vEKQ4QI8puA8K94oSJJnRHNBIC9fL9AMe8fiDxPcqHgjIC2FTgjxCTMNWCADdNG6G8EWoM3n2QUxVMv/glJBdHxAJ79vMHGU8kJRbMHYOVvObfObPqBT33dUTTp/w12H3nzya9OC9HqPpzrSNIa/v3+FvzrisPk8JZPqg62zr5gYxGtjrvz211ZNHTVq6qqv4To4ZCfinUA/E8YuuIaYIsg0ylyvmak2dfcoFo1I3deeuCijzybwt1SSuW4icxBdcabBJTeIAlgwFabldNGVNfT7l9FF/Q0vgT+d28k9ncYYmILamfcyv3K+VkuXrXH26BQVLIxtbu3hrh5ch2YP7+irzDzcddrDXZnKF3EBbUU7qzkG3S4adzfmU4SFF4kxTGfT82d/RkM/XzL29VQnXdC/5OeXTFZvWtoNsG2kD9O3+zddTNfSmm+D199w7cCeh9jaO/ZIuVi8FdE9oEVbJQIZx1ALAyuicLhiJ1jxyWEzBkJaNMlTifuTKtOL36Iv028MVHup2Kw+9lc1yOfBdQ891t8fHTi4mbMPfIR0KYJnLWT8WEhSRsLCOUYXyD8YQ4xHWGakM6Q10ntgUGpN3ahIhm6iYOpK2ZEJnGhky0xAHTzhNNpgzAPHIrqln6uHw4O71B/dDQHundxl/YsGHuEWMbv4oJ7jmUmF7gmM+ioOBrkYnWEsBrEV5g1UZGUJN0uzIHx9cCLf19/XIWyZ1G/ihQk0j38dVPdP/ZXaemCeul9YaOxkNkM2RrFOAtk6Fq8pP1i8Hp6tZ+oKBrtWV7Cz8ohgGAro4OF8mMaBuqVc8cTfqZe8Pkndb7pL/dvJ29S/MVtP10Bat4zldhNJiicsTNdoTLXcjodw3dGTphwP5oLYe1hZ3T6Y4XVfeWJTdobHVo3W0NaD6k+0JXGQmfXqfv55htsc1tlnjCNSMhdj368hKsZGRJKrlcVaTIiN/pPAUEjMAEmOF41DSPLuOFsTvmnSa/Se1ydxJQNvqvupU7yKOj+9lOG4S5gtPGV4j4gkyJ7Px7uoheTgYoYxig5MD94NwDCU1mC5ke6iq6jnfvXPM/cIs+kd6uU7dmi4vK6qwlxW0cwnKYoyQIw97CSrLwA8Ml/ZLrSMV1W2pAAw/FqYzW8ynIDfKyEyH0UALEK1nj13cW5iF6r136ZlgM2v6bh16nHDyp3qAhaHrDn1kXCtIJAwqcfsgHUtFcSVKgMkyxSgsIg9XXy0RIJIhDeAwMSicuiIEgF+RSRFBPOe6+hR4vAaCbE8TxadPxLMVqmwqKQWHXQuhm9EqcIgvCiUTCoWraETs2FbrpYClzZTFmuCRy7HNQoMQ1jFjQ8m7DRcMrqhTIT3WAxvg3BdXFdBwy8/KFBf4Dtzqn+26h/fOP+Wc/JyOWpS1Fectd/pUH9Ox1CaW9i44Gtmf6plMa18+JDTEc4NFZZtvOiistbKqlqjWFEx0DIlUvd6ddRgCEruc6oWTEd6rDrVK3xmeJm4STnoomaJ3PGUg61EAlFEJErQoFVKMeW0srpKEUbiNlY0ZXKW13uj1gFJaw0y6RYUrvCkQXZD3lTQeytLqN2QULsxoXbhMQXH4Qk1aoZLqycQ3uUedGyYWKccuRGMhYucihjE6CeYOxTKs2UeLZYnuORgdGu1WFZjZlGP17OKXk2jW4Lfa3xzRbsnqd719ujr7VKnoXRa/eJ0sbUwumT50wU5hpcH3grH71r8rcmz31XfiIU66M6GuaOf+Hpd9bj4/AOXRcqtYF/2Ab1eBlMVIM16ncUtgu3SRSdTaHHYerT1cTcC6kvKFqdixNBdwD4e1vBWGi/RimwAIOYiflwFCQL8kUTD86W/pt6dlKxX+6yXtC15AkJOWli3+KG5e/9bPbXzv6t8lJ64s3fzwZ9Nar5nXW15S910urH74M1fb5vchjzdfarXsBd46gH7OltbJ9eWlguAoUYENYIMrWQxjN/WI/sl1tNjtfYoVfCaA5lG2mhzleBCqFIAHJIdScUYySz1R8ox58AVHcxyE9oCG0YYvoRO91oO8HrcRd1N9MI3E1ukrbRe3a6+LJXeOvrOX1GblRbWLl4uF1qoITw9vvjp483jJ3S+R8tjIS7YV98Rit1Mb6yrbmuYT/dfFonYbQ1zG58AvFJA+w+A9sWkklyidScoXlFHqRwUt8RRiKvlJbiaVsWwc9pYChFGrAC7angNQ0bQ5TDmFiJ6co5TseehSHmxkyGP9WHnJpXyEmem3q8jixLmoEGGJiv1I9q1lAYzcnbAQL1JuvTDY2s6vNJAVKSVTbNm3Fp/3wUf7P3GgWX0IrqdllXNP/frtKIkNGHa+7Rs56KNk2d35PqaqprbWg8uWDZzK33SbBoTipwDcvYYIULU8C7JJTt0rcyNp3hAVPaA1ReBZzFcTzKhzOWxqCYX8MsfnhizhihDNzZAubtBL6U0JVjRzJXSnlw39iDjkQffDvpGu6jB7fEPLuvkEubX9Zb0HFYlZirnDifibGnabwS87byDxo1h/rHnrmi70tL84QuzJjeH5wbqiwttZktve+9zXF9f9NhvR/dW5oebK4PRvgERZbRF5QxtYIeLSRyr2haiSWXKDyim3MjQekMP9nQIiGFDVHYcUUKgVaOBgyEHxgVFyDWhSGvrsTixFSniko1JuR5Y6gBd86Pm6ZkRMIyJaXkkI7qJoNa7BZLr1Vk6KLkt1Bia1nzJU6Hw7fE7flnmcjXRy99KrLO7aPSfZS+o79+7QaFX5BTULFr2TH4OFcPTY4tS6is/n9F5aHO4/uZ1zTd3/oFWgQHpr777k51r+NuiVeMaznv20rKI3QEWZR/GKSuBv6+CjvrJy3qd22rzY53bgLh7UD9Zg4LitzL9tGn6measOEVA4SKNojFOS+yCGSKJvNNtsZYg+zGkPdj6w4/6NJGwSbK9W7ZKcg5+lub9aJR9eEzBcbhRfgaMco7dp2cd6cw5M8wSlio8SdmqDS5g94LW/oV1T90iQzCo5dMhI78SbfCd099/paW4aIf6yg4XteSedyixA8xu1w1rGs+bd83A89z4CTVhX8NbA8+jjCyBwzuGfeDrvRjRD1bMKYuuZCmqGHHEwpdxTGkefCIEElYWXPGgD36dJAW9WwaDK4UDeU4Z3R6tzwJXYN2DLgSEBNvUG5b002h/juPq8R2leYLj2onjQ7mU/7jfavC3za8OVDjd7QvoqOIKF1v/na5u4YMAp4uUknaSykH4ADiDqQf7pHwW1jQn5xxhBjaCjMwBCHzFYYRAMUiaCOc4WdcW7/ahNLZyWuaGApoNXQgT+66JFa78BilcU2k9RqPHxry8e844Lua4pmNCGKBlL+ph6ioxWqzFE2P84/3zj7/qFDcMgl5TXOkCGVxFiGEDyKADOyy19TismaMzGyyXW4fK5dahcvlpIubQREx39Z9fOEc/r60bnFY8xxVkgehmF4WoDHvy/Cx95dGB1++ny+iLA/KYk0FV/lAcLywB0SlX1ZWr1c5mesBQw6sbWH4xH8JKzvAxyE3LoNSAumSvsliHVlmsQ6sshb23nb7KMp+uB991k+HjPiv77nWQS60DH1RBTmjf3eVyFwUqsFDOQiWKvchlYLryY8zDwsMq4GEVEjanKUVwWiQpbuw2Ann1udwgrw47c7vZgpqpPVdgsRmvbmNXA5JczAoGhXDxsY/+wS66JdnDip/Obrg/XV7BA9nhmNXf8Qzv9BQWl2e6O2j2W40DgQpm7FmEVQa20+3CYRKfEwdGlDLCIgAIdeEi0xgjE8lWmshS8wZNzbNO14ES5Y17ZPoLU5sP3/Bqawmo/cs7nJbceYcSt6sv3+60+M97MbGD/3hhQ+OWxHRxdeMFc5kNGF8T9qMNgLPajDVA2kN+L/wUaJ9LtmcqiLlxje6QZSleQ7YvBCeH3RaKDejstNmBzhb7kIM8jc65SGfwhkg6OGaRDjIlIFmK4otGKnsuI5Vic2aasgcJgsXEDAHKgQCzkQATH5r0amsxLbxdfQVQzj3/502A8tLG5KDJG4dIUt3m3Qsxzp8BRzcpw9kp1uOYn4kww+gLI1HZdUTxQWDjk7AmqpjBLeK6QLEPm6MEzaqE8wE6VybUxD4MoxYgo/0oYy7PP1jzDon7WMR556sQWkpJdeMf3rluFh1nDdQtWbovkEMDdcuWPMFCzs1fb5/SOvEd9fW7L97cPrmmoq12Or3nOnitm34Ps4V9apmBA/g9EKOdp/UqDOYRyCRIJcA4s/AM+OQBPnm0bCLHpoVnRR4IPqkoVbDgMxeNozspB3GFWha1hSGeavT2ZUX9vFvz8kNRP8b9Ir2C1rmr1o/b+euIyzVG/f6b9ZvzNh92zW7W4/4x66MxrxVgfnlKeXTzupYJ4zvfU4/GgwPv8s3t0zD2b2+YP6Nt8uzammKtLx3urQH8vIDfYr1js1APq+WcuFIO+NmjmfAz15Ythww/FB/FVYiVfWfa6AiWMzwLXZqKlTtRC41aoK0X97VoBfJpPeI8M1651+Btope93bTO5tYC7c0lDzd97QcX0hjguHiZUmjhDKXT6xcrtCJQPGnGu7SyPjypr54rDsZnbqPRuqr2hnk/urS0DMKTeRBpE8038CcYH6/RbagnriEJTLSjpnkzHFR8IyuVhymV24NKBcdhSuXWlMo92F1mJyy7wCq9OcvG+PzGWkFEY7IKdMkX2T6mcWzhMmeBy2v2C91jtvMfL6hPWNzvmXJEjtI/DhxG2BeADiGPWolMUmPZ+p+xJxVEDarADsa2qNKugXw8+HN9csCFUZFSW3xSrus++NGNP7uCJa0uKe1wYYfdX7f//AC7Uiulo7V1gBEchzBKwV3Z9tZld9RG6zLF2ux3GrbiWM3nVzhTtKwRU9ug1kHXRrEYEPfh3BxO49Qa4YTX6EC1dTrspteiARwBW3CieHHMbImEqu0mzusvLSw2FlU3VdYU5VupyXvlrRsbLj04/pP8VXXeqqhRjM5duSxSJplMeXf95pq1P3n8cONkgVK7lOfMdVvNBpGzOPz+4uCoaHNw3qZJ4cUXvNgw1RIJ5JbllpQHg7X+wqLwxbs6lwON/3Sql99v8JMCpLEHaewAK4WhmcIZwAUWiDj8k6IFw8ZvCrFJSSYxJQdscdFp6zl8rV3O7zYoQuFJO1suzpfSXP4IUzhwvQCv40pyPhBYH8bJL8ga01Bycll4ShSHBxUOGxIKnLKT9cVjzIc5i57MJYyiZhcT7j+1XzmZRif/ra13tovy1vFjz21ZNe0/2oPFsyGNoWH1rT61q7PKYWlq6IuviJ8//3o6XfNNkJsagvzH4JteIax6ItvjKTeLqQwaXVIQurMidN5gvGpg8arfDhE+hIt2Vlmx6rYi46me/IdFk1AqyaQb7hgWEUAYLwGlWEw/NGkqSekcyQpCCscssUwTPkdiItkFZ3ZpyP0bqGZmOdQ+2YqmiCjU7MQmT21KSPSysDTBmoAycejLd9DoHU6I4+cfSuyEgFl9xdf4xBTw9DTFjR94XvPj3Ph+68I4uLsL5gKdeiDmFIBOJhLMrA1QvehtjmIFmijEpBeU3eBKXVhn76FjJrSeqKeJgYW/4D8eeH4x3T29X4vH3idEPA7f5yBVOt1NcfaVCq93fWDQCl/qwKkAg0VbNQ26KVaUaZi3c8bw+7SpjCbfCdNm2jiw6XBH6YaLq/8DnvMqVzPwChftt9KeMYcfnszqlp/o8A+v2yMKxrPU7bEi3orLBVi/ttB/vEFbV1Y9XEkXqgU96ovrVJUz0WPqhzXPjVJFVaQFOOhHTz2kugxT4DmFmB1bqb5aKhdAQoyzAEVR2XpEsYEWBfT68Vv/vEmTEy2zYxJBQM8w0M6xZwyPUKAZHqtToV4Ej0+g38RWgASvkZvwdkM4tORu//iS8JTZkXITv4c2z235awUdqy75pHX+qnnLljfOUzf1FYUbrx8/1S7yq1VxIV02dmC3uvOi6zedMzGANhhitfMBfjPO5ZhZjT8TxfBiVo3faGbLCIrAO7XSWByH0YNGcPELklxQXd7Gc8mBo/Sh1h7O2feHgQ+0Wji1qO8a9hjLSBPtJMhkB1IlGZXrj8ixmFKW0yOXxpQxug5Fe49q6UoMTIylWwlbTsre7oNtJf+8WqNZTJJHdwtKqR0sD06OFfXezRQpJqXNMQuYnLCU9oW9WDFhx1w8yqVSuqS0WPs0yK6H8KiEvSb8LIyfDfuuOH6XErOY4Gx01mfphsEPGvCDFDxU01v0LfClmDsFcaZbzoWoPJmCx7K5NckbNFt8/tziklC4NBZvGH3mKLc965YzbmDKX1bPGm7Y2mjMB6LApKHRwGOvgF00BqgIviYgxHlWnTS28uUQhVg6hakFY0a5i9tavM03ynRS55jVSyfaDAEJHEUyFHJKbsllFxxlyTmJzq5fJmY6OBoqkVyuC7jLaSnlRJc99yd/rL5z9TZRfd1TNaPBc0PLVZPmt/sbb71mRtPE2XWjC/Ms6mvjJ15yN1f60JYtdr8b9WKb+q7gAb4nyHFtMgH53hSVnUeUpN4yv/CvLw8uXwGz630n5Wj3wZYP//ayJgROEAJvtxICISjphpvSJqMFm/3wKDultMuJrHSzowePcgj4GyqBk3opXVcfBQbBr2SlteZkCi4jr+B38QKYUk8yBb/DuOSweI0mkHO3pyQYGmqrz+IRu+Esn+sLoLw71ipCUJCo5XCoDuI+dymO1fH+AN8Y5yPII2MCV/Wv7UycNzFeWZjvzCm+8DxfHs/7HSWiLTBjcXMnnb5qhpXxwRpqzJ8iTF28tLi4rdXLtd2w4M/qu7TaklfYUH/u5MT1z830t8+bckX7N/wNM6o8tFLctnJX6Xe3bLXbXRBqqW9Stz/3uferubsvmTgeZz3ALu4SCyAqbiOpStT3cpxwi8olccUEMXEgJudGFbeZVWYxEAbVLwe5E5JKrkmrkbudshcNABO/cCKO8y8JNkDI6owQ+kBQGLRjv06zc/q45msCx5vedQdzV8wbs3X9xMIn7/lLbFVO6fTA96bS+U3qPrHUEy73c74JUzdPb91QeVT59rLvnts0M2il5g3qVEMo8KD62lHrxFBT1Mea4Ch5FXL7uEiIj0zQ+urZmj8Y+C5CvUZbtSzFFQK4uGJdgoFdsMYVAQN+CG3Ag+cyrAx6HcydCOJ/bVUUAMf/YGJfTdDlJvWBJmpS9+IyaZRuGSigJKF+30QXJNRHx6vPjqPWo+GjfAFbNn0fTtWPqZVw9C1hg/Azwz4CAQFQGVsf3HHcZYRtluHTZkEdrMMTq/mSg9W/2NQnqDfWl7xJWXLJdqbq+swu7iIwdEqPOa68ZYrDcV3HhA6603G1fj4Jy17z29oXXDBOf2V7jVTz1xvshhSxkjxcEbREZX8cB61M2niTPniJ44iSNq6D+0Doz8x+Q9scNdTy+Pao23PLObPn048ctdS0b0fU5cHZZiHaXEdz+0fPnrF6zfQx9XDaeO70NauHzTeT0weZGXxF/KP8s6yX2A9+VBvO8wo9GGg4BFZgxZqpRozBSaFE9ihaS/HRDTfcXFzy5g0bbvqHLVxaNs1mLSsrnSq88i1F+daGp57+ZmxaZ7xhxgyWG94EPu9aYTbA4yB79AqFPjlldUBMbDD2KKI5FksJBoyKBTvb5yRlEPCdwQjvcFxei1iyG3Nle61sqsX+Epv3pGySFCO82KW0aDeCTbKBj7KZcCYUj3jdgdf5H4lgU6w2yD2GjajHtamtwTH1m9r5QNvA1WcMqwMVuemUUFHtO0XUPioyv8uLwkrDJNEKOIaINuFCTl+BNQ2uwJqpH36DTjmhviqspI/eoX6o1ef+/TPmp+5QC+hSsh50N0ogNVV4ZLA/M+KHi8K5+ogfWxwAufSySAgjoEGGG8upH9wdE4TLrzbn+spEg88X8i6g0Ss7ohUO/w8WX6xuvNYR8PmKitupdXM8sKZt4SaUNRe/XvhY1wVt3x3b4L477tigOgzf8WHYtjuUum7P7LpjjaonaM3QpjvRrD13ktHBLXdGxyFY5LX5I+MJNn8kfe4EkjOquM4+geQucwfPnEKaScevU/962iyS8D5bUNeefdzY968/G0TlzGf/hcnOac/mX6WP7lSPsRla9vyfGd9nz3d/7vM9UcV79ufzWr/CmSAU0lXUe7/6p5m7zwRjsJ9BYHC8ZNzI4PCTMFlzVkjkYFT2QoIMdtsBglHKNohyOViDK8poAOx2Gcqqzel6RjBQi+RljQVOOZyUA5DEFARZhe8sdBxm1wet2pl4NWiW/tqOCRPB0l/TMUF7M/l0Rq893fJz5B21gM1UhUgSO7yK0VPW40HUx+4hIFMiqIBjorLniNKMZI80AbiAQbEzVRqN6Z2tlrokKyujv3RFzpg9wY61zFAVdY+sp8cdxSPOWtGG4bNWD10F+hxBfQ4P6fOjiy+m249tHjaANWvXjYPjVwMHzlR2TptjAn3D/b6+cJIpy5z/+yaZsLXlzGkm9V7W7JI91GTUGl90mE3W/0GY0RmMAPMxOpmp+BDM4qCrGKT1+wC364vhdkczfX3/VriZZTgT9IE36GrsbWKmIQv8uUN2gdfh3wjw+0Bf9n4+BnJJFJf38y1aSBlmSb7TwVoYMJQrAtNQ+q8jqDhx1zmHB9fInbgxWJGry2jJyS/RBt+HCdrI5mQEPuad1Z5kkebYmWEk8BjnoiYZT7B582WE9fRilybk8FRSeH2YS4wNNrXpw1AC4s4x3BFpjnW1cWlCOX4wt2X9aJBj4JovxF/aii9OwYACbaBT6Ab1wGW6f6ODPWIAj7AGfBrCc95Z4PnfAYYBIQwBkQCN0IGop1M+RS2Yq7k2DYZJIPc8hFdLAYackWCw/msESRlw5jMDTbkm5zpAL2XJ9pBA8wyu6SDPPLGT/MysVdYcG3YtQFbksmitiAUjDLXJAg4hmx09aQerf3pBqgtHmHPTVoPtSYUi3UQriKsZJ4tx0CU/qXg5va6rr9TyI4uqPiY383Pc3ZliyZODp45DwnaCrWPV4D44TrYSB3rLnFwZmpvaqOw7gpsQKVH4CfrAXzvF/LKqUZoeZRxagM/M3VBXZu5GH7pBO/4rqXho6kYqHhq6eZcbHLlxcZmRG3opE9eM15p56wvHbtZnbuif79ZnbmbdfSMbuBF0kR7Ep0/HZ/SXxGc/w6e65ksjhEb+qyHE5bMY78shxOv6kcHnfYZP3VnwqR/EJzYMn1G1XwEfphRfkUdlGDPeh02vXxotTcMEHa+NDK8GyPIXjYAZNqW2xJUa0LEE6Fg7QxMb96LgKqISw3gc/FThgrAzvwGDragzJdaUaStN6dq2RMuXl9ERKwVfkSIrHFfptQSmfvr55C9JnjP0k5Iusofv59GvEndC20sO95Hr+vOtx7f8eftfbju27T06+8Czzx848PyzBw7u3492/RDOdYBOh0gErBWLWxW73nmeMnh9bHWmnK3OmJ24fJUWzGigDNqcoBeHqcHqVui2auXfX9CsrpDZbMs0NNxhl71sjNYnyf5usNlpjqJD5vGIA8YiGzA2sgFjl5R2u1i1EY8puHNYy0wK7sIzMZmC2/DMkyTtFl70+ClnNGm9snop8Ud4lTMOXdOWd8yY9hYD873OVCBcphl9V0SbDuGGD4ZwaJR+Kdr00RCD6axzIdxKFm/S5Lev1EdDprdNHnEsRLwv41s1HvQxHpj/X+VBOhAujWBS53NpszpnYwWa0y/Hihc0K/rFrDBs0bPnDC/eB15UUuvZeFH1hbyo/r+SFyk7678DbnQFSsvKK3V2RD6fHcwbfCmO0D9lnMDuL8eVoRhL48tG4EsNaaJTR+YMjqA1xtkOSXUxtvR1FjZh73OFg7Wg6RxLx31e+LwWLtZGlTiEX2P+L1ansFOuScoVLiWA02+1TrkJmOpS6hrhXdyJ+x0BW2Ofa/BG9HBfTu/iw+LKq/XzyV/GJgbPTIZ4Un7qI+FqwwlSQCKkiownqXyMr71xpdjQk7JTbR21iy/Nt2cmVKqjOG5IlOJ8tlyvGHmtk8aub+rBxk1YS5Q2bMJnxky07ZbYhAlW/q5lUya2lnHjB4dM6nmzrI+YbKTrhURCHzDZoNn9yocPJTv0GZM5C6NsvoTWV0RwtkSwoMXX8HlLtOr4zBiOTwWK81dHCpgtl39p1MCEfgXUTrByxOeixlsG6xMafgcN7zH8ar4Uv0Dlov8qv/Rq5VfASxgKST8PN+6TQTskMNx+a9jHcIuRFpzb/gLs5Lqo3BxXqsAojQaj1BqVy48oNWBnaiQ2NNUEtqYNXmvKna52s2CxG3zF4ao6tL2gqi1JucmVdnkbm1lP3L8k0FkZYJZOfwWCzXdclUkSh4esnysaPx5hnYzcoxawmaFcEiWT9JVF3MFncGwIZaIQ66V1UaUeZaOwVhtGgXAtv6wC3ZTFpRjRvgnOkQaIsDMHp4fOWiU9Y6IosHhJZpxozoWnlUYnRMu10ujQkNF19+CAUe9AwZn1UJ5cf6pXeBNslo8UkSBJ6P1gNrFHG2YoABHxWzwGEBE/IhmKok8iis0DSDrZ7Iakbx5H4jEXDtkMTdhE3EHGa7RQe4qL2YDNq2OcA3W+y2fN2K5P13xGt4tz55/79Rxml3750yvep2Xqmx90zLtOG6zhElOmncM9qcWgDF6DADZJg7cjC95i5l+/NNCgBvAu8MXAgw36QuCfZpbnLMDTJ7Nsjkbv9xj8pWfSOwSgBzTQA0LWhr1fkt6aaeE1yM8K9bOD9aE3dPjPhFzwaMZEDQMGYE80uPcxuCtInFz/+ZKCnc71cSUIxqQ6xmaAAkeUMBiTsMQ2a4P4hY0DhQNOV5fBYwsWoB2pdKak3DiqTK0rbc4bVc9syVeSNX7EeOALGegaOcc9mzguGrEWijMvuwxaLfQSrfbIa82C+uSwNtxCrUMVSL3tNrv6V6hV/wpPr/7xWvVPpqyOxuGoLqv+uVlBdAlr4buBFZj4j+lVmZwNYOKfZ2u+RtwVzcC22/33AoYlPgBMBwYLoxowYVYX5T++ShN/DZY9IPtYF71Eq4ueDQzr/zZ9tKHTrOqoO1Md1aB6a3BNkP94UcZh8gw2hc0r2UkeuePMiSUrdkjg0JLsZEvCQwO1shlrooKDNQuY4YXge96aqZF6QNYLRhpm0mukwFFWIVXMSEgjG2PMSyoeDitALv/gqFPOyLEuG3fqGll+M2NPZ8aq17DZ4RNsb9siEtB2/VWcmT4/v8h2csEZBZKZQ8Atf0k4NGzDXzTtmfmDOaVs+uAYvSSwBGcPAkuXLnkiRsdfB+Emmz/ovfMd9XVa9fZ199xz3bp77uE+1dahERaDHWRUg6U6C5YCLuNpswFSCgS2e9LnAgZi+LmAHWHSOSJg9NOMwc7Q6T2ADXd6ztApN0OnAIIVjCqhEeiUGaPPguoMiJYOSqP6YRZww8DimzQxHXhUhw/jO4TrFMgr0qyM1JELRuAgLkLVxpUikNmKGCup5h9RSkBASyQ2ylYNgonV1RII1rpyBKc/jEY44pTrcI9YpbJW+5swZ6fxyIHa55K97myh2YgS8tiIdnYjygvIrgu8UTdJWQkb39DmVcTBjm2ztm2IP3v03Yyj72BecnV19PRe9jkN2vom7hZsys1czcGeHZPNjH2ENvPwBm2TLdOgbcqx1Q6fghcld5ItgqSsHp8WFMrepP5nHMRh3dkRLOI9t5NG7whEzzuUuIOZLT82Z2+gB7UVBNaife2qTH/2q8L3MvZ+o65LSJvfjEAbD9tS5f88AimixMiTtro9PhRDjT6KR+tuH5FOWGEbmU6cVSupnU4n/nsZX6TJ0HtApzxy6ItkKH8kEhX8z8lQ2urx52lEUry+5FnESLc/Z5GkpB4EzthzJpV2DPlFjU44HwtxHxDlcymFS4aROE7NyiXaCKU+LOFmjjDXkU1ApEkYPWUALoNlh+hwcJTy/xeaulHspKIkG50QcfuPtNXrY4FowClXJJUwlhpLgmz7Cgsutp9FXUd0y2ch+46zLKacodFzz1jXPDVFdQm9wAstAn+KpGxo6O0uIHwhmy04W9SdtocDQH+bvYftY20/PQwfPoTA9n+U7ZLs6CaK1YFDCHjUZk1xr0cLZLVKGKjb5fUBebTIXY5j1J5yjnKxDiehcOhvdviyhhX404cVRqbeARxhKGwZnaz2mYTdI8wwcNLIxTs221DVdt6MKsl45nCD0TBCLKTtsWTcSEzEDR7+vjP2WZKdUbkwrliBrL4Y2yZE23QpbRaNQFY7yK8oYfeKkucY2uDwS+3EZGbbJIFaK3bR6UpzOVYnktPjhMxUznMpfvyLL2du01Rwlhbg4Zs3ZS/c3TnUEJy9p5Nw2xkE+bfuFfQFfb7/ls9Nx7I+v9e48v6sz2kZfz1fzXo7K7DLebDF2cbaSwXt7zThjKegDTGS05qdaRL7m/ft0PubsxuaSfbfDbOe9negbNl/B8p+1r8bNuzPhkWz/moYaw/9H+/T/p/sjaXkFDeee5R/is0hQc6qdxp/iYZjOthwTF3urY/Mc7u3PDKf68OnzFi7lsX1808dNzzB+pjdYE9DWi+z4iyIx/XvV6w+3KNwMAcaamIuG+FsqLGZ9ox0mml3nnnaK5PhA6eOG1eKEsTxi0gqxDb74XtS5sz24ISGzLZq2acNMOTGugw8u+CJKwY20YBz5ThFDokRbmxVnNTUM5BUHAZtoyuzk22b6U7EcTjDRYLYqRkJhgSjPtzgyzRrlpSWH2haI6wYfdm1HKGJJ2ne+eqxqepnT6h/Pp/rHD3wOMfNbFK9c/7w9Q8W7t2j7n1SHVD/q4I+drT8KA3R1Vu/89bRVx6HN49fcfEbm7a89zrihwT/hP8EK+6ZvyFGyWDXOc/+ior+ojef1zuDTvyVfgv5/wAk9ZUaeNpjYGRgYADi2LYg4Xh+m68M8hwMIHDxqO90GP3f4x8T5xIOHgYmBg4gBgIAK8ELGQAAAHjaY2BkYODg+XsLSL787/H3H+cSBqAICtgCAKc9B4IAeNpVkl9I01EUx7/n3nPvRoywFVIjoYeaDz715INI9OchQR8yWBARImMMEYJYamgPS8YQGSJlUozon+UiYgyJCAOpSWAg/cUHEelhiDTBPWhUD7czNfh54cOBew/33O+Hq8o4A1nquRATxpDTnVTjm8a6OYmkL0b7TQkJBQqoChI65CbVCJ3gy9iklPvMLSirICI6hRr+iTH1hfy8hms8giDfwiDnkJX92/wYlt/hJi/QPlrDKRXGXr2MD3JPXmoTR6nJ9w1PTcbNmkZcsWGUbAT9Jo4hE8KQ/Y3v5geiagA3uIK3dhxPeA4d/gNI2ik8ss8wYyYw7AvjrxlFr2lBK89R0Cxi1oSo3t9M7Sbv1s0g1ZkN3FfdOKTbqEt1u34G3eGMW5D6kdvQxUuI8yW84AmMy/sL+igmeR7NnEdM1aJDRV0rv0JcHUbE14lezqCdC7jH8+4Pr2BMW8T1DC7q81iRvgKHsWprUeKDbpN73ANmOSvSHl10w1Xn3IcmcxxfZf6S/kQNW07TVMdAiqGtzIzQtBvVDyVP1Y8H8bRsTosjD1VHXsTNGy/ie0q8vPfCjajfxTnc5TSu84CQ3kaFJLsHLiKxi1EkveiKO1v1veXXAv6AZN2p6qWgAbqwAwlZ+YhXpUfy/8fmpH8VZfpFx9QRCuhFaqh6UHE42yhestv32B681hvAP7Seuz942mNgYNCBwiKGLYxCTHpMy5gNmJOYO5jXMT9h8WCpYJnEsoflGmsY6xTWV2xGbJPYHrBrsHuwr2P/wmHFUccxhWMHxwVOPS4driSuX9wx3Ad4hHhieC7xOvDm8b7jC+Pr4/vC78V/RMBEYJ+gheANIRGhLUIfhN2Ea4SPCH8S0RNJEFkgckzkkSiTaJeYkliJ2APxMPFjEm4SNyR1JDskv0gpST2QDpLeJKMkM03mi+wyOT25Q3Kv5JXkw+S3yT9TeKS4TnGdkoBSgtIKpRdKP5QNlBcpH1F+p6KnkqOySuWVqp7qEjUVtTq1W+pW6mc0RDTCNBZpimnWaT7TCtJ6ps2gfUinQzdEL0hvl76W/gwDG4M1hiyGKYYHjIKM5hg9MjYwXmH8zsTGpMOUzXSKmYbZHvMmCz2LbRZ3cMA3Fn8seYBQxtLHssZyj+UvKw2rPDC8Z/UPALbKdYwAAQAAALQAVwAFAAAAAAACAAEAAgAWAAABAAFKAAAAAHjaxVLdSgJBGD3r2I8hXXgRIV3sRUQJrT9RkUZQiVBQBEJBV/mb1qalqxD4BF103QP4AD1GP08QRA/RE3RmHLeVRLyLYXbOnDlzvrMzAyCELwgY/gCADnsPG+Q7Gvswh0eNBY7R1diPCL41nkDNWNB4EkvGg8ZTqBjPGk9j0TevcYB4W+MZdHwXGgex4/vUOISICGv8gjmR1vgVMXGu8RtmRb/WO4LiqYc/BMKii33UcYt7NFDFJSpwYGIZBaxwTCCGONaJ8lSYOEKO6xUqS2hxnubYxBXZBopka5xZ5Hdhs5kez6aaSXWJY5vfIpUnyqnBtSw95O49prG5ZuKAu3LEVWYZrDusapI7/rqZrl/S8zejdIN1T5WuSVynzuR+i122FF2yLpNitjr3FZSuTT6ueAubrJrCDR2v6SU1ZbLSPc8Vi2lk31Ke/Vz9VKtuKm+m0emrap5jd6jJkSup6g3WN6kqj32L46jG0fzn+5IrDqsnEWXLk7XoUSIXVafyW6s4pNL47+SMujzPVt6+495+RuUzcUh/W7Ex9WI2mCeBNfWNeU5BZijTU6od5d6iQ4t1M65zFndkquTl39o/hWK3PwAAeNp90MdOlGEYBeDno/de7L3XmYGh2BCBsfdeowYElAiCo0GNJca40o2J96DGjTXRpQt7iyWuvAYvwTL/2nfz5JzFWbyy/P8eEbJCtmw5cuXJV6BQkWIlSpUpV6FSlWo1atWpN8ZY44w3wUSTTDbFVNNMN8NMs8w2x1zzzLfAQossFhOX0KBRUpNmLVotsdQyy63QZqV2q3To1CVltTXWWme9DTbaZLMtttpmux122mW3PfbaZ78DDjrkcMhxzW033Qm5rrrlhhd+uuu+1146qttbPV5546N33vvgi08+6/XLd1990+e4ficMGHTKkGEj0k4746xzRp13wSUXXXbFM8/9CHkhPxSEwlAUikNJKA1loTxUhMpQFao98NATT/989rHr7oWaUBvqQn1e78DoUF88QyI/fbI/FmuPRXb+NRGLxSLjkYnIhsjGyGRkU2RzZEtka2R7xni0G48XHevvTQ/3dB8Z6ctUiVTGZCqnKz08+C8kUx2/AfGXa8J42j3NvQrCMBQF4KSxaWvsf1ehukkGdXB3sEUoiIhIAz6Hqy6Oujv5CrdO4svVq8Zs5zvcy3nS9gz0Qipw13VD6VU1JZf1ACJVQbbBcFJ94HJfE2B5AUwuwMmLB5tb8guOcKYaNoIPNToIO9VwPz87DQ/hTjS6CG/0AwWhN0Jsxc2SDSsPyAAZrgx9ZLA07CH9sWGUFy8iji0xTYwH0d0wQcZbwxSZzP5UkMk3xs5PMQABVZ+dGAAA) format('woff');
          font-weight: 700;
          font-style: italic;
        }

        // Bold
        @font-face {
          font-family: "Pier Sans";
          src: url(data:application/font-woff;charset=utf-8;base64,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) format('woff');
          font-weight: 400;
          font-style: normal;
        }

        // Regular Italic
        @font-face {
          font-family: "Pier Sans";
          src: url(data:application/font-woff;charset=utf-8;base64,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) format('woff');
          font-weight: normal;
          font-style: italic;
        }

        // Regular
        @font-face {
          font-family: "Pier Sans";
          src: url(data:application/font-woff;charset=utf-8;base64,d09GRgABAAAAAETsABMAAAAAehQAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABGRlRNAAABqAAAABwAAAAcdCKoTkdERUYAAAHEAAAAHQAAAB4AJwC7R1BPUwAAAeQAAABxAAAAhK3+wAlHU1VCAAACWAAAACAAAAAgRHZMdU9TLzIAAAJ4AAAATAAAAGBswJALY21hcAAAAsQAAAHCAAACWtnWG9pjdnQgAAAEiAAAADYAAAA2E7UMi2ZwZ20AAATAAAABsQAAAmVTtC+nZ2FzcAAABnQAAAAIAAAACAAAABBnbHlmAAAGfAAANrUAAGYc4ANwemhlYWQAAD00AAAAMgAAADYLOOXkaGhlYQAAPWgAAAAgAAAAJBB2B2ZobXR4AAA9iAAAAeQAAALUG9tDyWxvY2EAAD9sAAABWwAAAWxXC3EebWF4cAAAQMgAAAAgAAAAIAHSAcduYW1lAABA6AAAAasAAAQcQjmRtnBvc3QAAEKUAAABfQAAAjqa9khGcHJlcAAARBQAAADOAAABXD68h7F3ZWJmAABE5AAAAAYAAAAGnRFVnwAAAAEAAAAA0W2IUQAAAADQ79JsAAAAANHFTZB42mNgZGBg4AFiMSBmYmAEwi1AzALmMQAAC1oA4wAAAHjaJYsxC4JgFEXPlwrS7Nz00RQIgnwi0SRNTuLcVFPg0C+S6H/ebja8+3jnvEsA9hw4EYbrOFOSmyDxM+H5eC1m/C+73bZLz2X7LKjcjjR0dketJN1tk2Yyot5mHybdzKJq56TWWbhTk+g5fwFL1RRqAAAAAAEAAAAKABwAHgABREZMVAAIAAQAAAAA//8AAAAAAAB42mNgZilgnMDAysDCasxyloGBYRaEZgLhOCBmYGVlAFHMQBKE4cDP388VSCmo/mH99vcbAwP7D6ZIIJ8RJMf4jukdSI6BCQBVEA28eNpjYGBgZoBgGQZGIMnAGALkMYL5LIwWQNqLwYGBlYGLoZqhlmEBw2KGpQwrGFYzrGXYyLCFYQfDboZDDEcYzjNcYbjOcJfhEcMThvcMXxi+Mfxl+M9YocClIKIgqSCroKSgpqCvEK+wRvXP//9AMxXQzNoANGs70KwDQLOOM1xiuMZwk+EB0KznDJ+AZv0Em8WgIKAgoSCDatb/x/8f/T/wf9//vf93/9/5f8f/bf+3/N/0f8P/Nf9X/1/5f/n/Zf+X/l/8f9H/Bf/n/Z/7f/b/Wf+VHsx+MO3B5AcTH/Q+6HrQ9CD4AfutHRC/UwswsjHADWRkAhJM6AqAQc7CysbOwcnFzcPLxy8gKCQsIiomLiEpJS0jKyevoKikrKKqpq6hqaWto6unb2BoZGxiamZuYWllbWNrZ+/g6OTs4urm7uHp5e3j6+cfEBgUHBIaFh4RGRUdExvHEM/AkM9QUMRQ09jS3NrGwNDe2dHV3dvT188wccKkyQxTp0ybzpDGkMiwHuyajGQQmc7AkITplZTsDQk5IMbKVWvXrV7DwDBzFsNmsEwmEOcV55YUlpVXlFZVM1TWN9RBNWUBMQAay6AkAAAAAAP0BgAAvADnAKwArgCvALQAvQC/AKsA0wDmAKgAtQDSANMA1QDcAOMA5ADlAKYAsgBEBREAAHjaXVG7TltBEN0NDwOBxNggOdoUs5mQxnuhBQnE1Y1iZDuF5QhpN3KRi3EBH0CBRA3arxmgoaRImwYhF0h8Qj4hEjNriKI0Ozuzc86ZM0vKkap36WvPU+ckkMLdBs02/U5ItbMA96Tr642MtIMHWmxm9Mp1+/4LBpvRlDtqAOU9bykPGU07gVq0p/7R/AqG+/wf8zsYtDTT9NQ6CekhBOabcUuD7xnNussP+oLV4WIwMKSYpuIuP6ZS/rc052rLsLWR0byDMxH5yTRAU2ttBJr+1CHV83EUS5DLprE2mJiy/iQTwYXJdFVTtcz42sFdsrPoYIMqzYEH2MNWeQweDg8mFNK3JMosDRH2YqvECBGTHAo55dzJ/qRA+UgSxrxJSjvjhrUGxpHXwKA2T7P/PJtNbW8dwvhZHMF3vxlLOvjIhtoYEWI7YimACURCRlX5hhrPvSwG5FL7z0CUgOXxj3+dCLTu2EQ8l7V1DjFWCHp+29zyy4q7VrnOi0J3b6pqqNIpzftezr7HA54eC8NBY8Gbz/v+SoH6PCyuNGgOBEN6N3r/orXqiKu8Fz6yJ9O/sVoAAAAAAQAB//8AD3ja1X0LfFTVnf859965M5N53nkmmbwmj5m8yCQzSYYQEh6JCOEhhIcICogYEUR8ISJaRWRBKcTgC6laatF2bf723kms2E27ur7XUmtTsGq17aLdna61iqyrkFz+v9+5dyYTCEg/+9ndz0pm5t47yT2/3+/83ud7roQj7YRwqwwLCU+MpEahJDIxYRRy/hJVRMPvJiZ4Dg6JwuNlA15OGMXcoYkJitdjUlAqC0rBdq5ILaV71dWGhSd+1C4cInBLcujUO/QNkcB9HWQKScCVKtkWUYxCksrOiMwfUThrsm8SL9irZBJTsmxJmUYViVYpHC+5FKOtqYkoxCi5ZK6pts4d40v4+sZY1Of1iCXFoUND3sGs9khdW1tdbZtITt6uvhVpm1obbUN2yGb+J7zT8AyxkVzSQWQSke2xfqNAzEKV7IlSORCRhSMyifZn2YgPrmU5cWDZHu33swtKHpCRJcDYtEnxS/DpaCJARLyGNuhEGPlgPDRysnlWScX8CS0Lc16gdTNndja3LMh+kf/Jn93tlc2dnc21pWryz5UX42FdiZrU5EOI+JmhhQRIIdCYyCUgH28sYaCkSjHbYjFFyEoqjoJoFOSeVdU32WA0V8mWaD+huUZblSLlwa8Q+BW3PwocFUWUIK1CGhuC7hJ4xXj28gbZq8SNr7KgO3iIhtcM0vxNhzfRDZvhLax2r6X56r4N72xQd254ZyMN0hvWqjvppDdp4Zt0hvocvt5U//im+iKdhC+4TnBWu9QvhfeNWaSGtJKZZBtJVCMHFUC3OSlPiiaqGdXVVeaqhBfn3hVTAvBNUzThDeA3Xre5isqzInLVkYTgGh+NRvsr/cQhVCU8gUlwJlc6lTaYhjJPUs6OKrPhsK0SZqKwSS6T5BxQjgBM0HOEGrJzCsfPLPWDlkyiBdQvhcLwrzHeKsQbYl64YAyFJZ8f/xVQ0WinRm9JQ6jUJfoLDH7Jzhsp/C4NhWuEcNfe6Ds3/H3rE9F8e3neJUtWzyjeuvP4sgev+Z3Z3duxrdYoGfLq/v2JrfvUv7xsspt8obzmYDinftJ4iS5OxB1cFp9VWjJlXE1y7+KbLFxOff7sv7voRx0N8yNFVu6EKt111YOPNqhO3hCr6LhduuCBKTfukYa+NN8t1C8r95UUeHKsdvoGb8uLBk9+kL+teG4Vnzcuv1BygriJgbScUsWNYE9m4iZ+EiTjyOMkUYQy98SUMj4Jpso0SHHBsQ21yMQn+wNVRTbQlgAPVlcTkekRxeJIyhan4gR5inAoOpUcOCyGw2KnUg6HBY6kEoFPp0VyJUy8p6mpSRYl2d+kFOeA/L1NcrmUCBT5mtBAq8okV19OfkE2yF9x2eCEGETKJsPlRONwgrVyHl8s2lgfKil20xgtTV/n2fUG/EJs+UXPnl/8Yk+Pe0X7BStWXND2La7h8PAh6jzt8uWCRIsPHVI/fJPu37FixY6VJw6K5AR5kxa/+ab64SG67ILLL7+gfcUKwnS05dQnhh+KLlJMqkkj2UISAZBXAvS3SgllJRMmkJjSgA4pHpHJEaUEHJKhhJiqlBprUi5xKjEQg8XK5OWBQ68zqYyHzxoDOCi+EuQSkxKmkIQSsrjkiibZIymuPJRLKACiymuSG6RnicGSU1nLROKub8xwGiL8A93zs89g2E5Larg4E0mc2qkrLbSWezZ0vvXAg4fmls0d56Jd42xv+8Zb8iin/v6aS97+wX2f7Ro8ePfK77SrkTnLehc2T5w/f2IzPbHnqxlX3v3Qq688fNdVsQqPQV1/8azSm6/NrVD/uPmiyXTH5w/s6A83cqbK/dw9d1669K4lIC+KfpPuY34zil5Td5lUtqN4ZCHlL/UPxYFekjAveYZ3HHGIo90gG+eA+ih3THwKNNlNqOxhwjd7kopXc2FO6rfznNcD9mkkB+hflwdaNy6+oLRx9tTZIWm5KnFPcE/TJU95Gvf2qb978pYP9+9ZOrfQ+kN6Gd6bwL3nZN7bdESR0vf2tooN9VwNF44TyUmlENyysfSCxRtbA8voZ6pzwFo4d+me/R/e8iQt7dvb6HlKfXL44uHF6hOE0d3FJ7kKkI9EwiyqZMX6qYUEIIKYwAe7IgqhTDhZIBy37o5j4bg/7jfGvCV+Y9gYjndtbF4zsXntxI0bJ65tnrimWdi1+eqW1atbrt7c1XrVVa1dOM5Bsovv4buIhXSycYwxhRqSsiGaIBR9J8kCr0oJHlIe3agVaDkic1HFbE/CPCXMWfidGUJGIsuMh1nEXKXYUhFCgsjtDUol0kHq76U+9c+99ID2qSapX+O185SfXk/tmi5kRfr5EV3IYrFT1HRBHNEFMQt0wYK6EE/rQQloBUw9KsI0UIktuh78Oelu18Y5SAf4Hm41WKsfeUVG8UVlIaIYUgR7D3Lv0oHeXtTRU5/QR2kWyKaBJMxgykgZho2MYyYQcuQ0EjX24xlZxOb5E1sWLmidOP92JKtlwQJCT30CwflLlrf4IGtBf0HBTWSQUwI+zMO8E3oeFsu7Tn0ibAM/4yB5ZDpJWNHBuMHBCOhgctDB5DMdd4IvcTpRFRWTK6kUMJ8CXlbgrcyb5rjhRDSb4ATYlhpJEfHHpBKRlBTXUHANRY0NEvOW3i6eRmk/reM5jld/9X73Z7vfPkhNzz1397bn6DEu9wNaob7zwfCfPlR/u+3T7+zo79/BZe1QlB2ow0BwRMSIUk0SQoo/hWCEEDEvUngPUM6j1gioNca01pRIXfSNo4b2gRPE0M7smBDhRjEXcoBJmqyUah44jCh5yHMENUUpBUZrgdFSUA5lXA2yWa35DNkpJTzeUsZsrAGCMAdxuKE+XMOVhMAlhlv5eKO/QPCnfKVoDHoPPPHDixddU9rSOL5gWcyx/MIri98y5tRePH7nPnf5olmXlV5ZVTV9xZcdzdyCgeu+1zn/xsj829pvvDBcYxbi7XePK7pg5eVll4rU4CtuG3fnPy6/dtWKOz++sGYAefHAHHpALtmg7wkf8sILEEhRNlYzcJMTkcUjigu4yQWBKFYeYx11uPTEQ49kVZQGG4LU5/J6wJ8XhzyHVt57389f2vkE3aCG+dnqXfteuP/kg9uSby5e+eQDO16mQz8f/rJF/fenH/hi+y2aLnWCTO8AOrLA8hZrGp7ggIp+YjFztipZiOFcyWKUmaL5iGyNKibIkfhowsRM3SSC1ZtNzAHg/DmQXIsuck6SbahbDTQmgUuCKYUEvpP7+fHNm4+qc2iC7n2Sf2lowYC6mu4dAKukZOWpD4VxQE8RmUgSThSHGxIMtxPv73ag8wlGZMcRxeNNJjwOvOpxwajFMOUeB0y5jTahRwAJ+X2N8UZIzTAFK2EOCKaXuuBUCNfQlU/P3LH1Vx7P41vWXSJIwpvcseFjN9y4+3dXe7yyOtS99tk377jB7X5o+47fuR0TOAvHHR9QXyiV3H3qsfv3vH+lx3FDyhY/BVskxAm5fydJOHAmPYKWHvUbcxw8pEOsCAmwdEhyJWXJqfi0SM8Sfx8k/M/ygtHuMMDkglV6wCoJtTBFdTnjYP/gQgooTnFRyM3Msj5UJHZ10B8eV//iqew+tmvX5+ofjk1Dk3xeHfopvYqGtnDH1Bxhz9CDD3y+fTvdtj2R2H7vq6/qvhbm/ACzyVzd5yC1UAgxm9QtMMY0q5M7PmwVOod+yMwQvFQn6O314Ht8MEOVZCdJeJDj3FR6UwGsl2I2WIg8VzE35HdBnuPHPKcYHJLfybgG39RncebBxTBcDEeYOKoxNWTZDqSBclh61p2TW1BoArFgwmMD4RTmwrdOAt+WSoqNh88Kl2IxNJ2R7ejySvkxFNhIitO5fePct+7f83bnxu27UXK7Dz9HTQcPql891wvZzELIauhX930884rtj7zz273bruz4uOf+Y9u3H7t/e1/f9h19fdwVdy299M6l2vyDLLeJHpj/PDKLJCyYIdsjqAJybkQRdGeMM29lM+8HFo26M8ZS71lwfRa7lc18Ls48JUZ95ltpEXJhpCUUo4c7I33t2v05LTq2e7q66HPqLPd2fzHt+a13PY/umL+Blh/bsePYAz1bh+30X4X76X33vvzyveCN07GDbucfh3jmJ02jIprsjfQ79HiWzTIwayrqyq7UEWbvp0U1KeO4a8HElgXzWycuSH2mIh33q+b585tb5y/QaPDrNOSQZiKbI+k4mhuRfUcUYoXqzKWNLKaOlABIzOUDCfFmfxMzcnfGyO5RKUCaDm4+q40xF+CdOgnDz0yYzypjLSuAGA+KvUrYRETItBJgF0CIMaKY9EBEvWbq3cwlh/+Ny6ZDW+jQYfVhdd9h4OMg5SCX+Ir1MnJT2QSL3JhQmCKKOZ1QUC2pGA5DYsH19tIOSC7IGWOT0WPHGsy0AcfOhrGTh2kXvfqwKmzR5/EdoVb0QiycQOYB1Wh8leCox0eUKCpdMzM9LCxqnFhfyTlRpcHGatuJWFNoDlppiMAn6l5lFAOMK7tGqxzAdUI01MpYn9HO4Y/oLwnFIUpC4GzEmjdcDDEycw66rFdd+fAlUzrarps1J0fKc0yprQlWxqQa/jA/2dNYOcUZyiszOSzWiqkb7u+MW/amGirC3Mc2XV/hNQrZFYuXfuuqVRO66iryK9rCV972dHf19FCjI1TQEhw/ZVbDQuPV01YPSenWC8jhCnWV8RbD3WQVuYl8nyTq0Bv5IWLU+TE21FWZq/qK6vzgZlaLSfmySP98LYG+IaKEcZI2sMRtJusEyDOdSinI5krw0Vc6lXVwWA35bbVTaYI828V+R7kZrq67UnL9JK8oXFE5tR19U7WkXLwYXFGTK+Gvm8BSK/98kOvFTcrqIvjMb5JvkJTSEs1LxRvjo6SL8oXYXcO1UPZJwfBjUX9DTPIUcLEopiVhLlwjQBjT0hLRK+p/GY1r9VwVZU2IcKhMq+caMa2h6Cfap6y//p5d+zbvvOWqe6749owJDntl1cCNMzdODjbeN737i127vui+9+7DvK0kUD2nNuQQwvbA+w2br7511gq/d/umLUuWT5jAT5pw7Y2PfKevZe74KU1tnRctFF9/7gf33jVlBhd6fsui+8rHjSvvWbjleY5873sP3HLTrFk54NUqmxfd+qNtP3z92Rd/WT97Zr5QFb9/iJaf3HP5hKHXPRWzIuMmzq52/kChk1+ouSDsM3JQfrVdePmVW++994H777n+5qltvGQPri91e/nZF9677fHeJ77z3soFC9dcvXD+Fe9pfgybFJvAVo2QuVRrliPzMZZc9osmQiHsiphHWSKKFTMSaoKJyIIJqIN4WsIHeXeQ5zbu5DZ+uW/4wMO/p4f+hOk17VHXc3O4ZVo9fwh8O+bmNtYBuULPOe2gXSyHDfLJ/mw/GyobQ2cxMzk7ayDJdqfiwnrVm5Tzi45IisGbVErggsEFdBhRQ+yMIDlbglM56JINmJdKwXT0IiVlQebvwyUQiWOYq4ZKgoe4Fd95b8Nl16jHf6Zupbcv/7s7l2bhgThh3sKJ6laRfLz/hxsm/3LTS+onA09tuOGAYUDYNLdzo1ZPnvrE0Mv6EzGSKEBefMCLgeWcyEAJY0ACSktZzgnOtt9EzLkBvZvgaiyNRQW/EVXLjgUzqicFDRRKiktDXNfmX9Oi/U/T0NUPTv3jlpve6ll40c7fbJ6zb0/4odXq+0/vV//w6808+T4t+9WtN294aHnXFQfe27DucO+a0NIpD954861v0zKYV8jxDe+DzDE2TNAlbk1JPAepzGVUWkHMVk3GRii3A0hwjhU7uWKTJkif4HM5OVEwohjjTJBAePAAt+ghKr16002vqn99SN1F13f9w4X75nZM/2mX2iMSeusv1Y/V19WPDt1KBxbOe+azm450zruY1chE+IDR1aFTZU5RJYAeGDSVM2Ql9WJQMXu10piVzWaLGd95s14m68WhVhdrr4O8OvQn7p7hjfwUkQyoTf84rA7o4/azPtzkjPpw1JgolKwxxhwZzXLaaAf5oaF/w7FwpKKB4cWpGvwTcQ3oRxn40kQ+jhVk6Syvl5YWGDQnNyjY9JkIsUEdvqTscCr5EGMguORBNZefh+Pn58DIYZiffAd29oQg9q3yJKb8uUG45CAFrJUlKUaT5hpdI/ol6voFHi6ItWCDrmSdv6Zdv+mlodUPXfzmXd9Td8y59zeb//Pb2wLqJu66o6vVowe+q/7h7dt48h5d88uNNz10+ar96uc/QC17/IFXB4YOvLL2WqZojN9u0LUKNqd6PSkbNQ8iG2L9WTyTbhafnlELSJeLYncOwjPImSleaiJxcQJqZ3jv/ogbPHp0GIqY4WXcEycI98TwMr33AG+Pslo/eFqtj7fnwe7wZUjf8eBHesmv9SGElaxenKLn3Dw2YT0oaR7qroSV3SqH3YqCcVAnTrti97EKEo7BNtweLW+KOYPRVkMDDOGx88U1/Oaj1B2/OF7uttCPC2asf+a9H183s5B+rL4UCE2KzgjlCYGTH8/59rYVEyas2PZtjR5cT6hjsqs9TXZCLC0wDwqMiUihBNN6s2abMYkGzTRIjdKho3yMzhm2csfVl4a/83uQWTs3MLxtaDN3/B+GX9PmSNiU6h+QFN+a3MSU3BI803jekO4fsAnxdn/EiyDCgQGNZvAtxp1wLzuZpt/LZImlZ5zKjrQDB+9txq4JTDB2rs12JN6AgR35SAhZNq2NIDVTM22mMO+QpEsHCr/gLudWfBE8OixvGZZFcvJS4cAJImw5eQe+UnIzDDF7nqrLTcyQm27GYFFmp8JjjwsowGnkzUABZ0xRoPAm3ctRib0doi5+wlH1L0NvwKhNwmsw6msnm8CftoBNL2K9oiB6LlvKoJnXL9DDFpQnTi/rFWFzHlujGKpynJASGqw2gRUnBVCc9FGTmejddggGRbqHLSqF4sQlQDDgGuprOIgNLbdBKKBQwLx9221vq39Q/wl8/+qdlD628e3uzvndb3/ydvd87lI6HWLBpk2/Ut9XD6rvv30rWOYbj6l/fXrVk+9tuOndJ1etevJdFuvBbgxVTNfcpD3TC7rBIWVZR+xUa+1aIM21RtOrDnozVnFjdBANutwKKJJuDOZQiA5OCKwHuUX3f93T8/X96n30mrt/+tO71QcgHDysDqm/VIcepuoarvMDOv4Dtt53apeIcdQLFfAlJOFCmQZSMg3xWuELMvWBJvmcrDeR5dOrWyxgnC4DOr4sqGAdOKMByAkUuxMuhaQ+SmxZIyIGf4jNHc7oN4bFYDEKmnnFcNwPEY0rxUC8efPbEHe/i8K+4pLDOwdlNQmx9u3Vc3b+5rbXb/63nb9bc+8pwiSfKfIDD6jHrvloy0fbUOrXHu69+tITWz773q8eo86/v0KXO8ZiP8jdRQLYG2Laao9pbAK//ZKbGHBtEPOsPCZ6F3Dsjsourc7F5Mcexcig+JFFB1tkdeMCp61JDkgsH4tJDVJDLFjAIZdgRdqMsFznwFF6/YNf9zz7IO0YUgfVR+j6bQefv1vtoT//GffGAN19Ym+v+sUkNYf+XJ3Kbf7nfY/8gqTyHOFdmJ/ldA5JXEa0cJmoRrJjODsrInLxEaUFqGthvlxZBIeRqHI5uPXG3J9+ets/3UC8VVl2OdspSy8oU/iv5Y4X4KTPlS25q/rc7N3D3r3s3cfe/fguT3H2TZ3SAadt7P0C9j6NvV/I3qez9xn4noDfLLq36N4SERxMk9zWJF/QJE9rki9skqc3yTOaEnBL/MLXhOtg7ibZ0yS7mshkCbJlyeX2+PzZU6ZeMG36jI6a0/+j5/NL8uRcqrQUw9TQMtA+k5SwV8dQNRe55FqYqpgguZ4ltDhSe0l6wTNWqi1fmvEn1IDlTKswkhbyrEDx+As49mPGOsULFYsRErHi0q69DZ/dTk5Nw8VL0S0VuyOeFm+HxdlZNrt8aihWVGTxU2N58MY1tzX5nqKhdQ9O+fhbptxpLW0ej0AtrmVzrjAabQbXvIqOqinlseJii9FkpFxeXP39Pz2p/ja5d9lm/ge4kukqzM5xeLM8Rh9vyLbkSoWB8oqGgsltTteiGZOWVecK2zc9uPxWzp7dWBaKZFlKCqMX5udzPM8Zsq057oK8isp4gVQciDqkjil37eX+TtMr+E/Yx2qOCVqfIN3LlvkoFvzYsjVAAmQQ2RI6JGAJ0YCHInZGtW6A1KCthQj71FJsbg+cGDDoaxPdkJ+vgPuWYGcG8y/MuLTg4IbgUJoKdzKvJb5ecG1l2BVBBENevhbbMagXGNLh3VBcY+j+SHAVNM+9be9tF03Id/FHbWUTVtyeONJ3+8oJITu3hH9qaElufMmchS3h8uZFc5Y2BPDKhGvvWNc1o6pqRte6O9Zr9EHaYWgA+kTMXxj/DGYBETzVs1CImEZQmLHQ8hynj9NHv4B4CHHpIWHNCV2Ophb4eyv4T7Z6IZti7FYKL8bgZraIYmc3A4+d4AxZLNZKeEN2TzMtOUavpVs30K10/RfDH25QN6mbNsD9XxGa8QWxL37yDRinBehdz+JGSPdeMA6XivbWiJaZcBhPhSwWF8wsL2E/LZx/OEktdBftoebhJOdV/1O9Ub2eU3lu+EVu0pA6zHEtwy8RbQ3H8CKMY8JcyDhKLuaIbDyiiJDWZWEs0vAlGUATnuVBoA4e6qGH6TvUO7wdsr7hGHdoaOXw49zKVM5QwXr05am8JZWS83xGjcub0JKN2gIHtm9jXhr0HuKvGXqA/3ztUA+/PiksHUiefDKVD6n7uXXGFaDPDax7BZUEdq8oz7pX2Bgx2hiIBZI4UOvUGR9NNbYgxSqRYt4D9I0//Undb3ph4KuDA6evafEpeWSsafGoGYe5hndG8lui7qdvMFpaCWoTM6oIOm5Gi/EIDIs9SCRAdCoUrICCvTlTRBlT3TYvZOFQMAQ//pi+ocYPGKcP/OdkuL8s9PJzme6OI1qXgAjEyrhB7UVmeRsxClWaHmOSxSryAI25S8JG+f0/vy/v3y/00gVq7yuvMJpPnVA/FcRT+7S1RCCWGJL4ymDUCLYuCtaTx7t6CaXNQi/Xz+RSrNPAMxr0CqCfsxELEKD9KY27S2jzawnZsK9L7dXWak59yr8kmEg+2M1VJOFHySLEQCkyJBNOhuQRoSwsCzixLDSkG/AV1qRcoYVksSQaVXx6q72CaJHYLyWszgDrWxkQSJDdJJslxWrTirJWLhZsqIeKzBjGxhQEahAwW22KY7OphQaL0eN3Tr727tm08JUL76zq6Xj9+tXfXxYZjD4x80e/OSz9ZNvtqnr5+FpasXTHnLL2h6e1bO28dMLl65uHW9a3tyS2bF85aW+kfKoVedzC1hcI5KuFZJWe62FTXfEaNFeYEJHRgJhEFBKrP62synD6WRmajQks8BeEz2woPPtEizfAElgvcmvHvEPBJU9ZdMm8Xo0gX8RJgKWwl4fYRdONdqO4ZTD2gxnv0SL1D+91PDZx3LjyXZfcffC5bZfsKscK70DlePU36kT1SH31LPrVmoVz572+95HX5s5djDoNuTf/liCCdrToNZsDmBD0idK77IoVqMWuuuKADBvCO8g+Af4Bw7DgkkVtDrAjaGRLsdjhi/tFbBS27P78vq927un87rbnDt69f96enV/d9/lu+tUDx3Y8cvf61x7Z+/p1Wx/Zfkxf5wO5tutyXUMSWShXO1s4BpKMKFce6crX5YoVgYtVBOC3ZBEs3sVqkmx7Eshm0s3C8oC3u/OZdN3aYrycL4HtAOm8RrrLSWJRnx9LY6Yz/GkNyk5a9F7Hk/WHD098dOZ7M3+y9ZLu8Lhx4e5Ltv6E+ujLtHp8JXfpCTKrup6z7n2986KFa1Yvvmjea1pdIzQw2RbgupsvJV3GRR6YQbbZh2tv2chQIWPI7MbOXMLMMA1mE0TkIhS7GdsTxOUGgSt52awtrtFd5Pbl06CngEeK/Yz6oAYeot5/pb3TTUMfhSfPW1g+o6eyp/lnjx2bxDU/eevGJ6mL/oKWqwuqG2c1Xjqpxjtj4ta5y7hrN27vJvp6+IDoIblkKUnksByCaqAq8ByyL4rBz2TU1gtzGMYi24o5dSI7B8nO9pmr5KxoIicbz3IwrchDJmxUE79JS6rdDbGGehAzaI0XKDbaOeCEpR1dm13Viw9dEKssDxbVR1zUpH41yE/v7bpz5YU9BQfcNn/jJYu7eocO8tM1vekYfktoAp+TB/X3LWTE3RhpSmUqxSQS7UF/M44JOh8ozney1MQEVmkC14MLf+CuY0oNNoSQWCf6nWd5mxQoqmQaFPDg0h7ovVJpwziWDVpklDK1CFvizPGE48xEtYb56SrVgSr16MTBXce6r3uto6fqWxfe9XzsyY73Zj93NxotM+DnaDZqV8O4OSeHHji557J5W1svfH/fsoo4qtm8uahmc+e+pveIhPFgNz5yoZ5D2LR6PWFC5l3ItZ/ZsY/5ISz4IHlRbGDV2az/AryagD0Xup8Rh8PmxmeEGdEQFlL3oO/A0kCu3HUzHbxmy64d4Fzmtq0VueXrjg0f5GKP7vx/u4f/qM0JKtJGw7uQ1zhIvZZBMQgeZBuIImCAVyuCZphvFDWYqwPLXzN/5sIZkNPdHqlrb4vWtlkGDV2R9rbaura2E2/yx4esON6pd9QV9OcwngtsbRphjCPqgjMmoexTfIJmYRCi3VElC0bMiaJlKVmQ5CSsvjwWWDin5txAQQkIwYherJVqOSo1AiFhmkFUBarnjOpBIbfw4l9eUE9Je5226POB2xa8div/ylDzFR3LonsKxX+tbWPLSKm5WsnyvejonhTzuemulGukKyWM3ZXqPkz30ulqBf0P9TN1C6SQQz30CvXm4Ydocpm6IdU7pKvEMMTyvNS6nd7GcyXZa6SN131YDH/9LvwN/KX4OvisEFmt53GePOw/UV2bZEdMKTag/KgcZjcLaToVcrL14jw4y9PwPB5QL4aeDDH1wr5qFhSJDDmsFDOusnSuvEzZivyn6xwvlcRTyrdh0LdvSSCbWhcU/Ghlbra86gY6uOrOz/2HuVV3fPtb/PED7WtE7t2V1xq55dd8ger4+D3qp8MHTVzV4/f86D5NL9laplAC/I22FfpfsxVvim7viK1sHvR9H2zlx1fdPLhuy67tQN8oS+ntRoq0mLce6LFClJihrc0rzlQE9uoRGPwVjC/b9LUELRhr2FI+y6L1vhhq6oyF+Uw4BoayXZ/Tos93I6Dg82mIJ3huG/iZVfpyPAII6La9r2N6gPGra/hLYTHQhvF4JclIcWhGigNJ+elZjn0ky3GNmeVYRmc5VBOkmwkyneVIp2c5XYMTH+t4jxarH77X8VSsqqp8NzhJcJi7y6uGvzSoc8c1aGlOvGL4aYG7arGW58ybt5jJGXhp13kBzR5JK2hGWiFnRdKZhfVvyizsozMLo+u0mFAinS2zmPnoxMOHY0/OZL5/N/p+ZEvLLOpr5p7guEUjLv/qhfMgs9D1mHtfwBX5plS3MT0rVlQbl7ZQpk2Jm62VocaaQdxSujWrCVxvi1BUWvd9Sy8eP87anLPg5kb++H3TLi180ujoOnC1GtDsZwnkiwtg3On0ApKYxnrdpmSiGIctN8GwMyJy7hGl1pGUa7W+1WRHUunQmlZfrHxxqta0cjtl5wtKg+lruemFn35W8aKqXfY6FbfTxL7KZl8dq33xLvjKAn/QJ7md7ir2vRdOvHAy6mtX5tdu9vVn+178I37d58FTucHZF29oclf1jcf3BBxn9LXGNyXgDnCU8KAlNZHJWe6GOBx5vOObMltWY15mTaraXA1QZpISfHE55saTXUpZCCMLPw2+IggT76O5ocm4IF/sksvSMDlsV0VojRiu4Vm/CrtVPpZMY7MKW1UUsfoGBvwDd0SLQ0vuWdgz80bJwHGUM0gF3jpfq2XKnFVT3VJJ9kUzF1Q41rww7Z7OBw3u6vLyLLtou2yRTawrXzRuYtjm8pe/tpVb/bNt91wbLbfle8xmm0ey2A12zuGPzIhFatvbq6cWufnZ0+9dS032PHd2juQqDXl4arHk5lbESxpiTY1L187T6wfufkOM5ODas5utPRs1DyEbtHzRGE3hcgWzBp/J1nC5Vm0hMDuFy5WdkEEyvF425oxsudTuBsFJTTKRIBljOaMO1PX4/BievRiVayBGt2wexDyxekZRsLwydsGbS6rckDLi/oxe9Yat1wZt7gMFPdOvv5vu1vT4mlOfCh7+uBYHcMVBI17U3ZucFUvFAd7JmlkQi2VzVLE6tThg44EwNy51iMyZ6V0tBn/SKwmWMYTW/Rrc/45f/zqdOfVy04cPYarEFQ5Z9aCQ7t3xh4GmjN4VPVvvStL6TIepn/oG1cVb+OPDLdxLmAyxHpjohPvYsXeFng64YbdSBFOMrSHhqgPczI69K6NVw9bGAjQe8wfwrhZsfXw2GHg4f/Cvg+odW4a+1u6/fsGC4R4chesevj7db+MHYKzR/St6zv4VjATvMIqHXq0+fOzov3yu7qNdn//LUXqCnlCfoZ2qqIrw/gyhp14a/j2fhPsHYKSEHe8rxbCTjx177NLE0TJahXhjnHXeCG8XSopbJtkirqLWxnGRQo8vS92CUvIcPkWejsy4eP6q8Rer+QctuYLZ09x25cz6pmz+3uHV3N7h76lrr3ukZ2GU6DUQ3wLjmtP9LGMqKvMGtpjNVqwV3oh1gDjSz8J2VhcdUgXuHZWj6ovc9t5nh9f1ar2st/hXjE2kmawgck1EqRaScnNEMcCHK6JImKNOjMj1R2RLVAm5WCEYqkd7CI0D65CiSgsoXqie7fghSnM1zF6ovgEdjUHCTUAuV8KSnavNZjwcbYz54q1cmIF5DN6Q1vT2gZFTfwGPTgVMKO5FHQWf01jDhUPGA4JADdzO1qICjjr8l22nxh/PqHJkUXtuQ1gQwg25dpplr57xY++x7Zf5HRxvzs9u3cntXbOaF5vz185fvG/Bnsu2i4f5aVWdzd+OruhauqRUEMqWXNq1Ivrt5jmRafzhLZftWbCvbtnsqd5mXuupHeKDxjhpJWuJ3BpRCAijNqJUCixvz0eZTGI9a192NKrEMZ8oiUYTYpy1rFtBLnlRZTLIJQ6W0We1lzaygFyLS6CiKY7CqZQUqx3X9V0JX4mGrfb64hrcopWLR+PgQXiMyQjEbSjVVgMKOBBO1Bcz+ktCRjvvZ3jrKgrisGvioALVBeKonPFjKm5f5reDQAqyJ93LGaggmHa2ZheYec7uX7b9mGcZP23cXCaSS5eUCULpkqVMJPMrQSTwpz1z9tdeNrvNN1HkVq/hm71TZy+r2z+nZ9mWlC4KLoYpbyeJMOpiKY95l1yY3myRH0UVsmkYcwSXg3WXgqJUNUHKCBpqwJU7mwSpN8P6Aacu3A3WqMUYivhjBGxhK5CByoP1kNLCTxe1mMVFvnUll81eVOF+ZOfNHZc6YisKiwsM3lkBE12lPm7ILr6CWz20qKp6XMsUC1eyNWD9JW3fPq6t2Geg4qWJmLkmXNVQseXg1PjWumkrdw/UXjNt0qKbxqNtE2LYy+rWWzU/lepJ9zslO7GBv4UjjT9LtN/jZdcMsX6Pds0YZS7afkR2QankhSI+mrDZUS9sFjOmbQm7Dc/sTjPucdTctj3V3faO6m4Dx16t+QAmjP9a0r3uAdqs3kevU+/7SN1Bb4FXm977lrfu3Kr+kRbCh1bzHhWO8fms5vWTCGJGce8ZFLuyI6rVvFozTbSxPWZWlsIndbRqZrlblnF8NFX20s7UUbr8rdM/GdaS7+eJoZfYwFN2ENkSkXNi+gYV8Bz62me/SQOsClFseEAe0e9LYWfZCqhJ6ygrPrsW3BgU0B1jUC+NsMyzrsCLbR3BCtzJQjcHXmjXj4X2ykrqSbraKxBim3F82t4WkrmJhcmvhT/KTWe1sZ/MIRo83WshkoBdg34HO9KF2G/V4JAavKpf1ICPrCpK9xAUL4LtRaIDr9MijWfusXvkmnWP7Ltm7b6rlk+avHzZlEnLhc+u/+7jN6x//LvXdqxf3zHruutIan2f74F4gHt3l+sRger1Q79BIEZQTUsMO9qQJSQEtqIm2DHhcTIVhSLCZs9UUV5rkukqCgkPonUkHVPLwLgjW5IQlJvaltTby9X1Ur+a7FX/TH0oU5oj9HI9o3r25Bw9e7ffSHMSr76O6wRdn5L//v1DJK6G6R2kinjJOLQKxW4BW/BFZOlIauJY21/STdNuZsVUbR1uEtOVLRxP4eKN8d72uRdefvXMOQ1LnAFfYaEv4Nz70qS5hrUzZ69r3uArqy/z6fudXf9b+51j57PfmWdrlbuMXxEjSN5+JkLUOoIQTWVs1Konm7EUQjTuxg8Pt/Hb3M3/sW/4wN4HXu1TbqeHPk5BRY09V6m9J59O4UVHxswaa0zTGGOmUKnpMYMWVKKMMX8P47UnXnsjE55Kv6ILrvrLaWPaoV49Y0zHyJgQw1ipSh0s7R8ZU1/iGs3qJm3BqyODW/EALn69/LLOsKCPvRPGdkOcKU4hZEdG96RGl6WIXBRTLLgrIsqApqYjit3GgFaon/k2hjlV7GwFEzd/+CVEPeS7FM7LQE+4NuLLFFRmC3P0aQYXvejX2+tq22LARzx1kp6+nEhbG1472cUt49bpJzqGRG1mWNk42aSvxSNWNoaBNAWYlUsjSgWa2/gUbhY3eFSDywxqlteECHJQ7/6C0lBdDAvToNRn9Rm0vkYF5hAh7Gv0BcM1uGM3jbjNyT0H4hYh34KDnmm84cZ4DZeJwm396K4UCvfmXyx/qEs9+sPmCy9fM3N2I1p3URFY9xqua/eJZ68egeUuXZOC5V689sHrN/ATDfD7107c4C+rD/knczd6tr9JJa0HLfSD3mEP+hsRsc7zQMRKZyBicQW0ewQVO/SnVxNyGhrLTO9/iA4wyAw6hh9l1qjTgUbBTHEULS5ckzo3Le7zoAV3gZsxb7A2nUETs9lM8ezXLHYUZWiumm/SaNvJ4n8JWXdu6mRvRA7GFAeYayCaAp6ck1Ts4OlJF6K/MB0ssDF0yumEnyUXy+TkrdTGEJaX6c/cSM17jr77oy61C4Q924KbZtT24RSRFHZBj8yI49RKZIO29oFePSaVHHq1T67/6COmR19fKpKx7yOwqJy6jwgxSyHaDkNEfTaAZhw6epTpQ4YewH34dXAfEeIA3seSCS9AKfFID4KeSRpg4EaS3k/+Tvnu/nFHj6bmjhGW2ovAi2z+HJCFXpJa9eHYqg/koywXdmvJqPWI4vAk+0SH1VSlEBuWM5gY9znZBR/MCyak1tTah+LDXM6dM+bS0KinoDD/CIJ/+mhz6jDtQ7/ORreaPmXP7Dj1iXgHyAGxp2W4O24M9GloLPRpWEefPovo0+LSvx1/ipPcdR4Y1HdBCc4Lhyrko7v5X+UJ3dD58MQ5QR/Piym+NqWzo/kqPwtfFWPxVTmKr7K/nS/dAM5rujQDOW/mmPsTdN72M97GkSZy2xjcIVQmHlPKwIrqwIomZLKKAN5yMKNyJ1u+rofD+hEBNOO3xZIrYSsQsCVSIyFMs96VsOYb2NLn3zbLZ/GP5yMeajrTcZ6frJ7Hapc5Ve1Ty4GeIgN8Gd8EPmcyq3rNrOoFJyYbonrNInNRLHyNbKcmliyszmUgNKLwlnRn0h3XnkuBD6V46rXXNr/8ymZ4f+Vl2vDKy5tfhp9XNiGqCmrBU58Y7gE9LCFh3AF+JgqyfCwUZIWOguzLyy8NoQqODYTEjOLgucCQdNNrCfm8EJGG67T847+XXjD5c9P7L1Bsnhe9wtaR+DRCc+XYNFeNRXN1Bs3hc9HMzPncZPt1Qz5fykfyGI32nUB7hDSTrjOpRwxKU0wJgyHHoqzpO8IKlhiVYL2VTvaMiEY4bBxhEDvAlZCUK1n5EBQba+HIkndWUO3ZDPXcjE8bw0LPSwhfnZ72EE7DncI8mogVuwujkae2NPLUriNP+zhzlrbR/Ez4aYBC0ZkBQbWBXmXCUIWpTH14DYMISUk++NIqsiwThVhqSCYKEW0xAkWsGIEiVkdkP9AT1vCHCb8P00g/LkaNw6q0wo+pVTYI3owPAPhm8CHL41IARPGs6MNXoGg4qCMQrzsLAFE40aX2Dm1AGOIyMorHMPDYdTrSsmI0j2Vn8FgyJo+KD1iUK0H8ZX8rr2mgpYjz9I1Iy+vegQzgXGDLZXxc609l8lpKakbzGj5zPqtHeI1ovFaeyWttitcgPnzlb+U11Y345qm9Ryt4Vn3T7Fo1zG5qggWNZ8O7wHMFiZFJ5LuZXFePwtLWpRhGQE5LTAmCW4mDW5kckQuOKKXgQEp1YG3kDEH0TfDhxnOWLkSUCZB2T8EH0xSAJQassWrsB9RLitOM3Q6XEm/BkFn3N5tBZr6ellmmczqr/H6SanoXpiXYku6In0WWr+pt8ZOfaHr0ebpNjvtH1Wb+qCCCHn0rA++KD+pLg17lQEQpsmjqo2Ffsc1cQqtwJzX2TFB5SqyS6zmz4PAG8suZmLIxpSJKUUDbTO+REtkFVZhrOc4fMDtmxwSXYUJc5y7E0fZ07kfIy/fm9Wz560RsgmptEtYEXeN01vsGjo/G1nZnjW6OuF3N/lIaSD8LTsC9En6o1ooRrZ1GqOakwbZFoGF5Gkw1T9T2X+sw1bxRMFUMW2bKgNmj4apFPq2HmoML5rlnh62yRua5oKtLIO155hzwVcMz4CGHn2EY1kzeCoC35Rm8FaV5Ox2CW3IWCG7pGRBcnacinq3FfgMUF/3hueG4zBeeFZJLjzJHOJqnsrPMVwnwVKjxVCim6zzkqXAUT+GzzVdJ5nxln503t96QPdeUXfd+Erzfd+84x6wJL2ieT5s4QeMR/J6fZX6N5J7TcdPlwGCpxmAp2GowItfHlAC4vJooe2ihzm1pJrd92WZqYt0e7AFVAet1Nu25hQW4ZzUQBLOskvocPr6c5R6Z8igvPTfcelSPlwkj07GdRTDptTy3LppJaac2pmrfqruw4TKQEvdYxrofKDuXxdZ+jKAT+qbjszSXjKOaS91gT8HBQbZ14+QC/ni6P8iZRu5nSN3vm5tM3YODfa++wR8/qIVt7V58hO1nyRqh7XwbTd1a5GwcHExtaNGJZH1C7g0dW5zRZ6Jn6zNZ/xv6TGk48uODhWcszGq45PRp6plU69l+Mr+2UzWN9MxJgX81uGfeWHDPfB3u+SzCPbNzTwd8KjlC2rmODfzESR8T/Im7d8YGgPJmbU/P/wjt2eegneWTY9H+FbrNMWnnAiO5Y4p2N3jNLp12P9BuT9OeN7L/wgO0e7S+CdKOEHEP1XYg5UjPIQcOye7GeG/E7QFEyfOPcGIX2G+exkkqWRwbhdvwO+Yi948JxhWadOc4KwXKZWtajCfQfyvzkhGyeQzcMDrGcZpjDIMl1GbOjN75lgtGVZup+arDb7OBK4uDb2IPMcONvZWuRJZTYL2i80Ianw3PMOZE5rdpFjSVzkv7wbHn9fAZ0Af0M6f+IMRhjvEpwEt0NJ8T3/ApyyNwPg19wVtHwfl0LDU6IWyJ2aSE18ce3aVQ3OEhInDIK7FlvTEAfqzC62YA70HEex/+5BDakw7x6+1OQfyc7wl/6NLWgv7rtCL0MOHxIpWyFUk7jVbPWWhla0SZtNJNaEBjEMsfG/HhaXpzyeVnpzdwFnrzRsm2z+tjDkC2ag/0Oi+ydfsZRflWzWrORjvb/shrtBveBtoLoUZel0m9Tjg+964ipvjBSkqirDbWuOjz8PgswFzbafz0haw2uF4E14siSgiiBxbNRQj8FTP5OYuynG1dKZO1ZzVbiLTRzvTRWPp04PR2KKdhJWGu8PnpQZLIxxlKQyb1x6Er+Xb2GOazQSdRSb4JPklvBr05N4ZSPKTlrBpNMAcBEoY69qI0hlMui8h1MXwEo1wFkq+PyHlHlGJb+pHbNSDbBnwYRR7zRPgsE7lcAt+D3WuX4pFYhB6bh7PJ+Zv4+oczsVbn5tJ4xxg9aV7vee0iJuIhReSa0V0vBOYXxBSrgFUGe1Ko1gLrc4hGEz7nPokQGQekKF52IQCCwOa+ETNVqwvCDMKaZK5JCYhwJbugacxmGX8WGWQ20NLIA41fDXaQ0U97Xl8nq0uvl50Lv/Vf+s50MOM7Exn5rovvp9sYrq0O+/uZz1xO49n0D/bAZVPmMurZ4GqjIGrkf/A53/9XcHr/F/BTlHRzq6nMb4c6oCbjCZ3nAVjLdBDd+BjOBS0TF3An8OatCxaynHfzqU8MZQwThznWAg0Xp3iDsZh+f8URiEZHI+RKMwbUEZ6pR4RqeIP+Ao2KsjNgc2VnOU7D6ejLKTrpK6dD7FpO+0TZbDz1iVgmuqCG3qVjhov4ZMKCK4kuPtlPaNhiq5JzY/1EA9PmRftFA7vmj/WL2jVvlC2zwDwbo0q2NwkXEtns/2GRnWeukn3RhJCdeia2bIiy1ZdsrAy5SuaUiuAQAdeKCz2V3dGk7eAIhUsaYo0Zz1EjCDhm4GO230t7WB8Jb7zdza2+xvtbuvA1hAo9NOlf7hpU3yrkNg/fYZS4q4f/uV19FDFD+OC+L9TbL6GvbF3QvPVV2tp/84aHLr1a/eDdrZc0br3zsYvXPnjjzeTUe+k9Fl/yX8IMhzP2TaWQklpZmqpONcBknRSU8E+Gssj/B3eDnJUAAAB42mNgZGBgAOLPbx50x/PbfGWQ52AAgYtHfSfA6P+H/57n2MH+A8jlYGACiQIAowsPUAAAeNpjYGRgYP/xdzkDA2fB/8P/Z3LsYACKoICtALaMB+542lWSMUgcQRSG/515M2uaFHIEcqSwEHsLkRCukEsK00VCEAuLU5YgV5giRtg0IQQrWYKIWoasJhERC4stRETFImSbQ7AQCUeQFDkLC0FFsvnnFmGz8PFmd9689/5/R7XwGHzUKgnIPFJdQ+hvITUDCOwmKuYUFQWE6hyxLjMnQiCjSLwPGJJBJOoe95pZS/4gUA3unSGWCCWZ4/4kau67fOZ6lxwh8M5y9E+Erk47jiPwDzFmZgGzhNT2sPcLxKaKxJSR2CsMmSYi9RaJnCO0C0jlO6KOKmLOmNovnHMZid+D0HzkuQn2XGKtY0RmEKWOCtdrzHmftcwFUlVH7GZmhAAbguxa4D2SJ+0530kXKvKb6xlqv2KtEzyVA/Yvk1p2JFOMDxD5fXgtO5z/kLnbzOMZdYxQ72JE32WNBHV9AthulHSTnnRme/oHte/Ty/3cc5lGYHqzPc7xSwes4TxlX74nnOm+89fbQr8ep7ZPKBVxPplhaiygO/kPiTxkbNCbU3pZgH6v2AF6WsD5Is+ooUhfrr+IWqfuNfZokDqitu4i9Ps/qNfh6usbwL8EbqP6Cnh/yfMcZIyLjK/oCT24xX4D7kzyvvHuuHuo+W/dHVUvEdkqvVnM69gpvNEXwD8mqbxLeNpjYGDQgcIshj2MMoxXmPKY2ZitmDOYpzGfYuFhcWCJYOlgWcTyg1WOtYX1BJsAWwbbIbYH7BnsBziYOLw40jg6OJZwanCpcIVx7eMW4I7hnsF9jseNp45nDs8TXgleO94G3h18UnxJfNf4jQTiBPoE7gkyCZoJZgnOEjwm+EmIR8hGKE2oTmiesIBwmfAeERWRBpEbohGii0RviemJpYjVib0TNxNvEX8lESTRJzlN8pOUjVSC1DSpY9JM0jrS22Q8gHCLrIxslOw62T1yXHIRchVyK+QeyZvI58mvkH+mEKLwRFFDMU9xj5KWkp9SkdIcpW/KCcpnVKxUrqkKqGaoHlJTUFum9kA9SP2EhpPGO80SzUdaPlr7tMO067SXaF/Q0dLp0HmmG6B7Q09Pr03viX6M/jIDBYM+HHCOwSqDHUB4zOCXoZ5hk+EVIyajJDB8Z8wHAHgJapEAAAEAAAC1AHUABQAAAAAAAgABAAIAFgAAAQABTgAAAAB42sVSy0rDQBQ9SeqjRYq6EHEVREQXpmnFihYEUbsQ1GJBd0LTpi9jq2ksCP0GVy79IB8bcecf+AF+gGemk1ZrF91JmJkz55577uTOAJjBOwxokSiADkcXa5jlrot1xHGvsIE0HhWOYLGXO4YGvhQex7TmKDyBC81XeBJL2pvCUeJQH0NHn1d4Cjv6g8JPmNND/2fY+qfCL4gbof4VMWO5iz8MLBg29tDENe7go4YKqghgYgVFrHJNwUYSG0QOFSaOUGC8SqWLW+73ubZQJ+ujRLbBnUV+Fx4/84dnS+6E2uXa5lyiMiedfMby9BDZp9xX6O1JT5saW34ZHOOE44AozApz1gay/rqaA4ozGW9R12Tc/FUnx6yQyfDsTZ6+KHVt8knJW9hkbzK4otslvYSmTNajo8OIxZ6JsSU9B8877Hw1ORc4AkYK7I4r3X36m/Qvj9z9UVSjaP7zXYhIwOrbSPBzyFr0cMklZFf6tUpDKp2Tc9gxcWdB786ysqqJQ/kKBGvLe06zSgrrnJNc+/8mnMv0FeqAXr56Ldmebx43jNYYEX/gfQMInaMiAHjafdDFbpRhGAXg56u7C+6uM9NOBS9tB3fXAGlpCw0tLQMpECSEsIINCfcAhA2awJIFbkGW3AAsuARk/jXv5sk5i7N4Zfn/PSJkhWzZcuTKk69AoSLFSpQqU65CpSrVatSqU2+U0cYYa5zxJphoksmmmGqa6WaYaZbZ5phrnvkWWCgmLqFBo6QmzVq0WmSxJZZaZrkV2qzUrkOnlFVWW2OtddbbYKNNNttiq22222GnXXbbY6999jvgoEMhx1W33HA75Lripuue++6Oe1554Ygub3R76bUP3nrnvc8++qTHL9988VWvH47pc1y/AScNGjIs7ZTTzjhrxDnnXXTBJZf99NSzkBfyQ0EoDEWhOJSE0lAWykNFqAxVodp9Dzz2xMM/373mbqgJtaEu1Of19I8M9sYzJPLTJ/pisbZYZMdfE7FYLDIemYhsiGyMTEY2RTZHtkS2RrZljEe78XjR0b6e9FB31+Hh3kyVSGVMpnI600MD/0Iy1f4bU8lswgAAAHjaRc29DsFQFMDxe28/FEXRMoio7+GOYjCJRGvoIqY2kXgHg9liZPIaklOTeDlOuY7t/s7955wHf52An1kE1jpOOb8kaWjKuAtOEoG7wccxaYMptzEDzQ9Ak0vQ/eCutYT8wEDoHQXTD57MEFOmnMts8t3PFsa5q0IeYS0UClmZF/1fWcTPwuoLDra6XMKpPRcy1cIDsows9YgVZHlGdJCVMbGaXXDEhNGkhkH1RqwjayOii6wPiR7SHRAb2TZP7P/bmhg0KEjAlW8R6V3sAAAAAVWfnRAAAA==) format('woff');
          font-weight: normal;
          font-style: normal;
        }
      `
    });
}


const $6c4c39ac0675f8e7$var$container = document.getElementById("app");
const $6c4c39ac0675f8e7$var$root = (0, $7e96a608cb33bf79$exports.createRoot)($6c4c39ac0675f8e7$var$container);
function $6c4c39ac0675f8e7$var$Root() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $67ef757553aa7733$export$80dbe0482bcbd25a), {
        value: (0, $25d38ac7d80d0bc6$export$2e2bcd8739ae039)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a1ac1d77c18d2946$export$20f257fc407da7a3), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $385655437d631473$export$86fbec116b87613f), null));
}
$6c4c39ac0675f8e7$var$root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6c4c39ac0675f8e7$var$Root, null));


//# sourceMappingURL=index.978342ab.js.map
